(function(){"use strict";try{if(typeof document<"u"){var e=document.createElement("style");e.appendChild(document.createTextNode("._unmatchedHeader_qcj19_1{opacity:.55}")),document.head.appendChild(e)}}catch(t){console.error("vite-plugin-css-injected-by-js",t)}})();
import { isRunningLocalPartnerApi as cI, getPartnerDevApiHeaders as dI, WidgetContextProvider as uI, makeExecuteQuery as mI, makeUseLazyQuery as pI, makeUseQuery as fI, makeUseMutation as hI, IntegrationModal as yI, useWidgetSettingsMutations as pr, useWidgetSettingsQuery as fr, useRenderConditions as hr, PartnerSettingsWrapper as yr, handleWidgetSubmit as gr, MisconfigurationBanner as vr, validateApiHostName as Ul, mapLabels as ar, PartnerHookFormSecretText as Er, WidgetSettingsFormFooter as kr, useTracking as jn, useWidgetContext as fn, hasDownstreamApiForbiddenError as Ml, hasDownstreamApiAuthorizationError as Bl, DisplayErrors as $n, settingsToFormValues as Jo, useCopyWithDelay as Qt, defaultDateFormat as It, displayAttributeValue as qi, OAuthSettings as bi, useData as Iy, isDownstreamApiNotFoundError as gI, isDownstreamApiAuthorizationError as xw, isDownstreamApiPermissionError as vI, capitalizeFirstCharacter as Sw, humanizeKey as kI, hasDownstreamApiTooManyRequestsError as bI, hasDownstreamApiPermissionError as Nw, PartnerHookFormBasicAuth as _I, hasDownstreamApiNotFoundError as Fa, getCountryNameFromCountryCode as xI, parseBoolean as SI, parseString as NI } from "lib-integrations-partner-support";
export * from "lib-integrations-partner-support";
import He, { useMemo as Zn, useContext as ql, createContext as $y, useState as me, useEffect as Xe, useRef as Tr, useCallback as pt, useReducer as jI, useLayoutEffect as wI, isValidElement as jw, Fragment as CI, createElement as FI } from "react";
import { FlexBox as b, Switch as Vo, FieldLabel as ww, FieldWrapper as qe, InputText as ur, InputSelectionList as hi, FormGrid as et, FormField as Z, Text as F, Spinner as sn, Icon as fe, Tooltip as Ge, List as Je, Badge as Pn, Button as Qn, IconButton as Xt, Tag as Jn, NavigationButton as Et, Select as Rr, CollapseCard as Sr, Box as ct, Modal as ht, ModalHead as yt, ModalBody as gt, ModalFoot as vt, Textarea as Gh, TagsInput as Hl, Image as Ia, Banner as Ey, FieldSwitch as Cw, SelectionList as mt, Divider as Wl, FieldText as Kr, FieldTextarea as II, CopyToClipboardButton as $I, getSelectionListContext as EI, Avatar as Ty, Timestamp as TI, Attachment as RI, EmptyState as zo, Table as st, Checkbox as dv, TextWithHighlight as Fw, ErrorBoundaryContext as Iw } from "@dixa/lib-shared-habla";
import ut from "classnames";
import { ApolloLink as Ry, Observable as $w, ApolloClient as DI, InMemoryCache as OI, createHttpLink as PI, ApolloProvider as AI, useApolloClient as LI, ApolloConsumer as VI, NetworkStatus as ir, isApolloError as Ew, gql as Kl, ApolloError as Tw } from "@apollo/client";
import zI from "cross-fetch";
import { config as Uo } from "lib-shared-backend-config";
import Wn from "moment";
import "moment-timezone";
import { __rest as UI, __assign as xc } from "tslib";
function Dy(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var ps = { exports: {} }, Ma = {};
var uv;
function MI() {
  if (uv) return Ma;
  uv = 1;
  var e = He, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (v = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return Ma.Fragment = r, Ma.jsx = s, Ma.jsxs = s, Ma;
}
var Ba = {};
var mv;
function BI() {
  return mv || (mv = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = He, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), d = /* @__PURE__ */ Symbol.for("react.forward_ref"), m = /* @__PURE__ */ Symbol.for("react.suspense"), u = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), v = /* @__PURE__ */ Symbol.for("react.offscreen"), w = Symbol.iterator, N = "@@iterator";
    function j(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = w && t[w] || t[N];
      return typeof c == "function" ? c : null;
    }
    var _ = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          p[y - 1] = arguments[y];
        O("error", t, p);
      }
    }
    function O(t, c, p) {
      {
        var y = _.ReactDebugCurrentFrame, C = y.getStackAddendum();
        C !== "" && (c += "%s", p = p.concat([C]));
        var T = p.map(function(S) {
          return String(S);
        });
        T.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, T);
      }
    }
    var R = !1, $ = !1, I = !1, L = !1, G = !1, Q;
    Q = /* @__PURE__ */ Symbol.for("react.module.reference");
    function ne(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || G || t === a || t === m || t === u || L || t === v || R || $ || I || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Q || t.getModuleId !== void 0));
    }
    function q(t, c, p) {
      var y = t.displayName;
      if (y)
        return y;
      var C = c.displayName || c.name || "";
      return C !== "" ? p + "(" + C + ")" : p;
    }
    function Y(t) {
      return t.displayName || "Context";
    }
    function P(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return Y(c) + ".Consumer";
          case s:
            var p = t;
            return Y(p._context) + ".Provider";
          case d:
            return q(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : P(t.type) || "Memo";
          case h: {
            var C = t, T = C._payload, S = C._init;
            try {
              return P(S(T));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var B = Object.assign, ie = 0, je, pe, le, ge, V, be, Oe;
    function H() {
    }
    H.__reactDisabledLog = !0;
    function Ye() {
      {
        if (ie === 0) {
          je = console.log, pe = console.info, le = console.warn, ge = console.error, V = console.group, be = console.groupCollapsed, Oe = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: H,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ie++;
      }
    }
    function ln() {
      {
        if (ie--, ie === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: B({}, t, {
              value: je
            }),
            info: B({}, t, {
              value: pe
            }),
            warn: B({}, t, {
              value: le
            }),
            error: B({}, t, {
              value: ge
            }),
            group: B({}, t, {
              value: V
            }),
            groupCollapsed: B({}, t, {
              value: be
            }),
            groupEnd: B({}, t, {
              value: Oe
            })
          });
        }
        ie < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Ie = _.ReactCurrentDispatcher, Ue;
    function De(t, c, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (C) {
            var y = C.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Be = !1, Ae;
    {
      var Qe = typeof WeakMap == "function" ? WeakMap : Map;
      Ae = new Qe();
    }
    function Ee(t, c) {
      if (!t || Be)
        return "";
      {
        var p = Ae.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Be = !0;
      var C = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var T;
      T = Ie.current, Ie.current = null, Ye();
      try {
        if (c) {
          var S = function() {
            throw Error();
          };
          if (Object.defineProperty(S.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(S, []);
            } catch (re) {
              y = re;
            }
            Reflect.construct(t, [], S);
          } else {
            try {
              S.call();
            } catch (re) {
              y = re;
            }
            t.call(S.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (re) {
            y = re;
          }
          t();
        }
      } catch (re) {
        if (re && y && typeof re.stack == "string") {
          for (var x = re.stack.split(`
`), ee = y.stack.split(`
`), A = x.length - 1, M = ee.length - 1; A >= 1 && M >= 0 && x[A] !== ee[M]; )
            M--;
          for (; A >= 1 && M >= 0; A--, M--)
            if (x[A] !== ee[M]) {
              if (A !== 1 || M !== 1)
                do
                  if (A--, M--, M < 0 || x[A] !== ee[M]) {
                    var ue = `
` + x[A].replace(" at new ", " at ");
                    return t.displayName && ue.includes("<anonymous>") && (ue = ue.replace("<anonymous>", t.displayName)), typeof t == "function" && Ae.set(t, ue), ue;
                  }
                while (A >= 1 && M >= 0);
              break;
            }
        }
      } finally {
        Be = !1, Ie.current = T, ln(), Error.prepareStackTrace = C;
      }
      var ze = t ? t.displayName || t.name : "", Te = ze ? De(ze) : "";
      return typeof t == "function" && Ae.set(t, Te), Te;
    }
    function Me(t, c, p) {
      return Ee(t, !1);
    }
    function en(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function se(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ee(t, en(t));
      if (typeof t == "string")
        return De(t);
      switch (t) {
        case m:
          return De("Suspense");
        case u:
          return De("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Me(t.render);
          case f:
            return se(t.type, c, p);
          case h: {
            var y = t, C = y._payload, T = y._init;
            try {
              return se(T(C), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var ce = Object.prototype.hasOwnProperty, Se = {}, Ve = _.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, p = se(t.type, t._source, c ? c.type : null);
        Ve.setExtraStackFrame(p);
      } else
        Ve.setExtraStackFrame(null);
    }
    function kn(t, c, p, y, C) {
      {
        var T = Function.call.bind(ce);
        for (var S in t)
          if (T(t, S)) {
            var x = void 0;
            try {
              if (typeof t[S] != "function") {
                var ee = Error((y || "React class") + ": " + p + " type `" + S + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[S] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ee.name = "Invariant Violation", ee;
              }
              x = t[S](c, S, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (A) {
              x = A;
            }
            x && !(x instanceof Error) && (Pe(C), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, S, typeof x), Pe(null)), x instanceof Error && !(x.message in Se) && (Se[x.message] = !0, Pe(C), g("Failed %s type: %s", p, x.message), Pe(null));
          }
      }
    }
    var X = Array.isArray;
    function E(t) {
      return X(t);
    }
    function z(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function ae(t) {
      try {
        return de(t), !1;
      } catch {
        return !0;
      }
    }
    function de(t) {
      return "" + t;
    }
    function U(t) {
      if (ae(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", z(t)), de(t);
    }
    var J = _.ReactCurrentOwner, ve = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, we, Re;
    function rn(t) {
      if (ce.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function bn(t) {
      if (ce.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function an(t, c) {
      typeof t.ref == "string" && J.current;
    }
    function hn(t, c) {
      {
        var p = function() {
          we || (we = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function En(t, c) {
      {
        var p = function() {
          Re || (Re = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var _n = function(t, c, p, y, C, T, S) {
      var x = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: S,
        // Record the component responsible for creating this element.
        _owner: T
      };
      return x._store = {}, Object.defineProperty(x._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(x, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(x, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: C
      }), Object.freeze && (Object.freeze(x.props), Object.freeze(x)), x;
    };
    function Fn(t, c, p, y, C) {
      {
        var T, S = {}, x = null, ee = null;
        p !== void 0 && (U(p), x = "" + p), bn(c) && (U(c.key), x = "" + c.key), rn(c) && (ee = c.ref, an(c, C));
        for (T in c)
          ce.call(c, T) && !ve.hasOwnProperty(T) && (S[T] = c[T]);
        if (t && t.defaultProps) {
          var A = t.defaultProps;
          for (T in A)
            S[T] === void 0 && (S[T] = A[T]);
        }
        if (x || ee) {
          var M = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          x && hn(S, M), ee && En(S, M);
        }
        return _n(t, x, ee, C, y, J.current, S);
      }
    }
    var Ze = _.ReactCurrentOwner, gn = _.ReactDebugCurrentFrame;
    function Le(t) {
      if (t) {
        var c = t._owner, p = se(t.type, t._source, c ? c.type : null);
        gn.setExtraStackFrame(p);
      } else
        gn.setExtraStackFrame(null);
    }
    var dn;
    dn = !1;
    function un(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function Nn() {
      {
        if (Ze.current) {
          var t = P(Ze.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Bn(t) {
      return "";
    }
    var Sn = {};
    function An(t) {
      {
        var c = Nn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function vn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = An(c);
        if (Sn[p])
          return;
        Sn[p] = !0;
        var y = "";
        t && t._owner && t._owner !== Ze.current && (y = " It was passed a child from " + P(t._owner.type) + "."), Le(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Le(null);
      }
    }
    function xn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (E(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            un(y) && vn(y, c);
          }
        else if (un(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var C = j(t);
          if (typeof C == "function" && C !== t.entries)
            for (var T = C.call(t), S; !(S = T.next()).done; )
              un(S.value) && vn(S.value, c);
        }
      }
    }
    function Ln(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var y = P(c);
          kn(p, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !dn) {
          dn = !0;
          var C = P(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", C || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var y = c[p];
          if (y !== "children" && y !== "key") {
            Le(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Le(null);
            break;
          }
        }
        t.ref !== null && (Le(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Le(null));
      }
    }
    var Cn = {};
    function wn(t, c, p, y, C, T) {
      {
        var S = ne(t);
        if (!S) {
          var x = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (x += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ee = Bn();
          ee ? x += ee : x += Nn();
          var A;
          t === null ? A = "null" : E(t) ? A = "array" : t !== void 0 && t.$$typeof === n ? (A = "<" + (P(t.type) || "Unknown") + " />", x = " Did you accidentally export a JSX literal instead of a component?") : A = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", A, x);
        }
        var M = Fn(t, c, p, C, T);
        if (M == null)
          return M;
        if (S) {
          var ue = c.children;
          if (ue !== void 0)
            if (y)
              if (E(ue)) {
                for (var ze = 0; ze < ue.length; ze++)
                  xn(ue[ze], t);
                Object.freeze && Object.freeze(ue);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              xn(ue, t);
        }
        if (ce.call(c, "key")) {
          var Te = P(t), re = Object.keys(c).filter(function(Gn) {
            return Gn !== "key";
          }), mn = re.length > 0 ? "{key: someKey, " + re.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Cn[Te + mn]) {
            var Dn = re.length > 0 ? "{" + re.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, mn, Te, Dn, Te), Cn[Te + mn] = !0;
          }
        }
        return t === i ? Vn(M) : Ln(M), M;
      }
    }
    function zn(t, c, p) {
      return wn(t, c, p, !0);
    }
    function qn(t, c, p) {
      return wn(t, c, p, !1);
    }
    var Un = qn, Kn = zn;
    Ba.Fragment = i, Ba.jsx = Un, Ba.jsxs = Kn;
  })()), Ba;
}
var pv;
function qI() {
  return pv || (pv = 1, process.env.NODE_ENV === "production" ? ps.exports = MI() : ps.exports = BI()), ps.exports;
}
var Xn = qI();
function Rw(e, n) {
  return function() {
    return e.apply(n, arguments);
  };
}
const { toString: HI } = Object.prototype, { getPrototypeOf: _a } = Object, { iterator: Qo, toStringTag: Dw } = Symbol, pl = (({ hasOwnProperty: e }) => (n, r) => e.call(n, r))(Object.prototype), Mo = (e, n) => {
  let r = e;
  const i = [];
  for (; r != null && r !== Object.prototype; ) {
    if (i.indexOf(r) !== -1)
      return !1;
    if (i.push(r), pl(r, n))
      return !0;
    r = _a(r);
  }
  return !1;
}, WI = (e, n) => e != null && Mo(e, n) ? e[n] : void 0, Oy = /* @__PURE__ */ ((e) => (n) => {
  const r = HI.call(n);
  return e[r] || (e[r] = r.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), Dr = (e) => (e = e.toLowerCase(), (n) => Oy(n) === e), Gl = (e) => (n) => typeof n === e, { isArray: Hi } = Array, xa = Gl("undefined");
function $a(e) {
  return e !== null && !xa(e) && e.constructor !== null && !xa(e.constructor) && tr(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const Ow = Dr("ArrayBuffer");
function KI(e) {
  let n;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? n = ArrayBuffer.isView(e) : n = e && e.buffer && Ow(e.buffer), n;
}
const GI = Gl("string"), tr = Gl("function"), Pw = Gl("number"), Ea = (e) => e !== null && typeof e == "object", YI = (e) => e === !0 || e === !1, Qs = (e) => {
  if (!Ea(e))
    return !1;
  const n = _a(e);
  return (n === null || n === Object.prototype || _a(n) === null) && // Treat any genuine (non-Object.prototype-polluted) Symbol.toStringTag or
  // Symbol.iterator as evidence the value is a tagged/iterable type rather
  // than a plain object, while ignoring keys injected onto Object.prototype.
  !Mo(e, Dw) && !Mo(e, Qo);
}, JI = (e) => {
  if (!Ea(e) || $a(e))
    return !1;
  try {
    return Object.keys(e).length === 0 && Object.getPrototypeOf(e) === Object.prototype;
  } catch {
    return !1;
  }
}, QI = Dr("Date"), XI = Dr("File"), ZI = (e) => !!(e && typeof e.uri < "u"), e$ = (e) => e && typeof e.getParts < "u", n$ = Dr("Blob"), t$ = Dr("FileList"), r$ = (e) => Ea(e) && tr(e.pipe);
function i$() {
  return typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : {};
}
const fv = i$(), hv = typeof fv.FormData < "u" ? fv.FormData : void 0, a$ = (e) => {
  if (!e) return !1;
  if (hv && e instanceof hv) return !0;
  const n = _a(e);
  if (!n || n === Object.prototype || !tr(e.append)) return !1;
  const r = Oy(e);
  return r === "formdata" || // detect form-data instance
  r === "object" && tr(e.toString) && e.toString() === "[object FormData]";
}, o$ = Dr("URLSearchParams"), [s$, l$, c$, d$] = [
  "ReadableStream",
  "Request",
  "Response",
  "Headers"
].map(Dr), u$ = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function Xo(e, n, { allOwnKeys: r = !1 } = {}) {
  if (e === null || typeof e > "u")
    return;
  let i, a;
  if (typeof e != "object" && (e = [e]), Hi(e))
    for (i = 0, a = e.length; i < a; i++)
      n.call(null, e[i], i, e);
  else {
    if ($a(e))
      return;
    const o = r ? Object.getOwnPropertyNames(e) : Object.keys(e), s = o.length;
    let l;
    for (i = 0; i < s; i++)
      l = o[i], n.call(null, e[l], l, e);
  }
}
function Aw(e, n) {
  if ($a(e))
    return null;
  n = n.toLowerCase();
  const r = Object.keys(e);
  let i = r.length, a;
  for (; i-- > 0; )
    if (a = r[i], n === a.toLowerCase())
      return a;
  return null;
}
const Ai = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, Lw = (e) => !xa(e) && e !== Ai;
function Yh(...e) {
  const { caseless: n, skipUndefined: r } = Lw(this) && this || {}, i = {}, a = (o, s) => {
    if (s === "__proto__" || s === "constructor" || s === "prototype")
      return;
    const l = n && typeof s == "string" && Aw(i, s) || s, d = pl(i, l) ? i[l] : void 0;
    Qs(d) && Qs(o) ? i[l] = Yh(d, o) : Qs(o) ? i[l] = Yh({}, o) : Hi(o) ? i[l] = o.slice() : (!r || !xa(o)) && (i[l] = o);
  };
  for (let o = 0, s = e.length; o < s; o++) {
    const l = e[o];
    if (!l || $a(l) || (Xo(l, a), typeof l != "object" || Hi(l)))
      continue;
    const d = Object.getOwnPropertySymbols(l);
    for (let m = 0; m < d.length; m++) {
      const u = d[m];
      S$.call(l, u) && a(l[u], u);
    }
  }
  return i;
}
const m$ = (e, n, r, { allOwnKeys: i } = {}) => (Xo(
  n,
  (a, o) => {
    r && tr(a) ? Object.defineProperty(e, o, {
      // Null-proto descriptor so a polluted Object.prototype.get cannot
      // hijack defineProperty's accessor-vs-data resolution.
      __proto__: null,
      value: Rw(a, r),
      writable: !0,
      enumerable: !0,
      configurable: !0
    }) : Object.defineProperty(e, o, {
      __proto__: null,
      value: a,
      writable: !0,
      enumerable: !0,
      configurable: !0
    });
  },
  { allOwnKeys: i }
), e), p$ = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), f$ = (e, n, r, i) => {
  e.prototype = Object.create(n.prototype, i), Object.defineProperty(e.prototype, "constructor", {
    __proto__: null,
    value: e,
    writable: !0,
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(e, "super", {
    __proto__: null,
    value: n.prototype
  }), r && Object.assign(e.prototype, r);
}, h$ = (e, n, r, i) => {
  let a, o, s;
  const l = {};
  if (n = n || {}, e == null) return n;
  do {
    for (a = Object.getOwnPropertyNames(e), o = a.length; o-- > 0; )
      s = a[o], (!i || i(s, e, n)) && !l[s] && (n[s] = e[s], l[s] = !0);
    e = r !== !1 && _a(e);
  } while (e && (!r || r(e, n)) && e !== Object.prototype);
  return n;
}, y$ = (e, n, r) => {
  e = String(e), (r === void 0 || r > e.length) && (r = e.length), r -= n.length;
  const i = e.indexOf(n, r);
  return i !== -1 && i === r;
}, g$ = (e) => {
  if (!e) return null;
  if (Hi(e)) return e;
  let n = e.length;
  if (!Pw(n)) return null;
  const r = new Array(n);
  for (; n-- > 0; )
    r[n] = e[n];
  return r;
}, v$ = /* @__PURE__ */ ((e) => (n) => e && n instanceof e)(typeof Uint8Array < "u" && _a(Uint8Array)), k$ = (e, n) => {
  const i = (e && e[Qo]).call(e);
  let a;
  for (; (a = i.next()) && !a.done; ) {
    const o = a.value;
    n.call(e, o[0], o[1]);
  }
}, b$ = (e, n) => {
  let r;
  const i = [];
  for (; (r = e.exec(n)) !== null; )
    i.push(r);
  return i;
}, _$ = Dr("HTMLFormElement"), x$ = (e) => e.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function(r, i, a) {
  return i.toUpperCase() + a;
}), { propertyIsEnumerable: S$ } = Object.prototype, N$ = Dr("RegExp"), Vw = (e, n) => {
  const r = Object.getOwnPropertyDescriptors(e), i = {};
  Xo(r, (a, o) => {
    let s;
    (s = n(a, o, e)) !== !1 && (i[o] = s || a);
  }), Object.defineProperties(e, i);
}, j$ = (e) => {
  Vw(e, (n, r) => {
    if (tr(e) && ["arguments", "caller", "callee"].includes(r))
      return !1;
    const i = e[r];
    if (tr(i)) {
      if (n.enumerable = !1, "writable" in n) {
        n.writable = !1;
        return;
      }
      n.set || (n.set = () => {
        throw Error("Can not rewrite read-only method '" + r + "'");
      });
    }
  });
}, w$ = (e, n) => {
  const r = {}, i = (a) => {
    a.forEach((o) => {
      r[o] = !0;
    });
  };
  return Hi(e) ? i(e) : i(String(e).split(n)), r;
}, C$ = () => {
}, F$ = (e, n) => e != null && Number.isFinite(e = +e) ? e : n;
function I$(e) {
  return !!(e && tr(e.append) && e[Dw] === "FormData" && e[Qo]);
}
const $$ = (e) => {
  const n = /* @__PURE__ */ new WeakSet(), r = (i) => {
    if (Ea(i)) {
      if (n.has(i))
        return;
      if ($a(i))
        return i;
      if (!("toJSON" in i)) {
        n.add(i);
        const a = Hi(i) ? [] : {};
        return Xo(i, (o, s) => {
          const l = r(o);
          !xa(l) && (a[s] = l);
        }), n.delete(i), a;
      }
    }
    return i;
  };
  return r(e);
}, E$ = Dr("AsyncFunction"), T$ = (e) => e && (Ea(e) || tr(e)) && tr(e.then) && tr(e.catch), zw = ((e, n) => e ? setImmediate : n ? ((r, i) => (Ai.addEventListener(
  "message",
  ({ source: a, data: o }) => {
    a === Ai && o === r && i.length && i.shift()();
  },
  !1
), (a) => {
  i.push(a), Ai.postMessage(r, "*");
}))(`axios@${Math.random()}`, []) : (r) => setTimeout(r))(typeof setImmediate == "function", tr(Ai.postMessage)), R$ = typeof queueMicrotask < "u" ? queueMicrotask.bind(Ai) : typeof process < "u" && process.nextTick || zw, Uw = (e) => e != null && tr(e[Qo]), D$ = (e) => e != null && Mo(e, Qo) && Uw(e), ye = {
  isArray: Hi,
  isArrayBuffer: Ow,
  isBuffer: $a,
  isFormData: a$,
  isArrayBufferView: KI,
  isString: GI,
  isNumber: Pw,
  isBoolean: YI,
  isObject: Ea,
  isPlainObject: Qs,
  isEmptyObject: JI,
  isReadableStream: s$,
  isRequest: l$,
  isResponse: c$,
  isHeaders: d$,
  isUndefined: xa,
  isDate: QI,
  isFile: XI,
  isReactNativeBlob: ZI,
  isReactNative: e$,
  isBlob: n$,
  isRegExp: N$,
  isFunction: tr,
  isStream: r$,
  isURLSearchParams: o$,
  isTypedArray: v$,
  isFileList: t$,
  forEach: Xo,
  merge: Yh,
  extend: m$,
  trim: u$,
  stripBOM: p$,
  inherits: f$,
  toFlatObject: h$,
  kindOf: Oy,
  kindOfTest: Dr,
  endsWith: y$,
  toArray: g$,
  forEachEntry: k$,
  matchAll: b$,
  isHTMLForm: _$,
  hasOwnProperty: pl,
  hasOwnProp: pl,
  // an alias to avoid ESLint no-prototype-builtins detection
  hasOwnInPrototypeChain: Mo,
  getSafeProp: WI,
  reduceDescriptors: Vw,
  freezeMethods: j$,
  toObjectSet: w$,
  toCamelCase: x$,
  noop: C$,
  toFiniteNumber: F$,
  findKey: Aw,
  global: Ai,
  isContextDefined: Lw,
  isSpecCompliantForm: I$,
  toJSONObject: $$,
  isAsyncFn: E$,
  isThenable: T$,
  setImmediate: zw,
  asap: R$,
  isIterable: Uw,
  isSafeIterable: D$
}, O$ = ye.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), P$ = (e) => {
  const n = {};
  let r, i, a;
  return e && e.split(`
`).forEach(function(s) {
    a = s.indexOf(":"), r = s.substring(0, a).trim().toLowerCase(), i = s.substring(a + 1).trim(), !(!r || n[r] && O$[r]) && (r === "set-cookie" ? n[r] ? n[r].push(i) : n[r] = [i] : n[r] = n[r] ? n[r] + ", " + i : i);
  }), n;
};
function A$(e) {
  let n = 0, r = e.length;
  for (; n < r; ) {
    const i = e.charCodeAt(n);
    if (i !== 9 && i !== 32)
      break;
    n += 1;
  }
  for (; r > n; ) {
    const i = e.charCodeAt(r - 1);
    if (i !== 9 && i !== 32)
      break;
    r -= 1;
  }
  return n === 0 && r === e.length ? e : e.slice(n, r);
}
const L$ = new RegExp("[\\u0000-\\u0008\\u000a-\\u001f\\u007f]+", "g"), V$ = new RegExp("[^\\u0009\\u0020-\\u007e\\u0080-\\u00ff]+", "g");
function Py(e, n) {
  return ye.isArray(e) ? e.map((r) => Py(r, n)) : A$(String(e).replace(n, ""));
}
const z$ = (e) => Py(e, L$), U$ = (e) => Py(e, V$);
function Mw(e) {
  const n = /* @__PURE__ */ Object.create(null);
  return ye.forEach(e.toJSON(), (r, i) => {
    n[i] = U$(r);
  }), n;
}
const yv = /* @__PURE__ */ Symbol("internals");
function qa(e) {
  return e && String(e).trim().toLowerCase();
}
function Xs(e) {
  return e === !1 || e == null ? e : ye.isArray(e) ? e.map(Xs) : z$(String(e));
}
function M$(e) {
  const n = /* @__PURE__ */ Object.create(null), r = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let i;
  for (; i = r.exec(e); )
    n[i[1]] = i[2];
  return n;
}
const B$ = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function Sc(e, n, r, i, a) {
  if (ye.isFunction(i))
    return i.call(this, n, r);
  if (a && (n = r), !!ye.isString(n)) {
    if (ye.isString(i))
      return n.indexOf(i) !== -1;
    if (ye.isRegExp(i))
      return i.test(n);
  }
}
function q$(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (n, r, i) => r.toUpperCase() + i);
}
function H$(e, n) {
  const r = ye.toCamelCase(" " + n);
  ["get", "set", "has"].forEach((i) => {
    Object.defineProperty(e, i + r, {
      // Null-proto descriptor so a polluted Object.prototype.get cannot turn
      // this data descriptor into an accessor descriptor on the way in.
      __proto__: null,
      value: function(a, o, s) {
        return this[i].call(this, n, a, o, s);
      },
      configurable: !0
    });
  });
}
let Mt = class {
  constructor(n) {
    n && this.set(n);
  }
  set(n, r, i) {
    const a = this;
    function o(l, d, m) {
      const u = qa(d);
      if (!u)
        return;
      const f = ye.findKey(a, u);
      (!f || a[f] === void 0 || m === !0 || m === void 0 && a[f] !== !1) && (a[f || d] = Xs(l));
    }
    const s = (l, d) => ye.forEach(l, (m, u) => o(m, u, d));
    if (ye.isPlainObject(n) || n instanceof this.constructor)
      s(n, r);
    else if (ye.isString(n) && (n = n.trim()) && !B$(n))
      s(P$(n), r);
    else if (ye.isObject(n) && ye.isSafeIterable(n)) {
      let l = /* @__PURE__ */ Object.create(null), d, m;
      for (const u of n) {
        if (!ye.isArray(u))
          throw new TypeError("Object iterator must return a key-value pair");
        m = u[0], ye.hasOwnProp(l, m) ? (d = l[m], l[m] = ye.isArray(d) ? [...d, u[1]] : [d, u[1]]) : l[m] = u[1];
      }
      s(l, r);
    } else
      n != null && o(r, n, i);
    return this;
  }
  get(n, r) {
    if (n = qa(n), n) {
      const i = ye.findKey(this, n);
      if (i) {
        const a = this[i];
        if (!r)
          return a;
        if (r === !0)
          return M$(a);
        if (ye.isFunction(r))
          return r.call(this, a, i);
        if (ye.isRegExp(r))
          return r.exec(a);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(n, r) {
    if (n = qa(n), n) {
      const i = ye.findKey(this, n);
      return !!(i && this[i] !== void 0 && (!r || Sc(this, this[i], i, r)));
    }
    return !1;
  }
  delete(n, r) {
    const i = this;
    let a = !1;
    function o(s) {
      if (s = qa(s), s) {
        const l = ye.findKey(i, s);
        l && (!r || Sc(i, i[l], l, r)) && (delete i[l], a = !0);
      }
    }
    return ye.isArray(n) ? n.forEach(o) : o(n), a;
  }
  clear(n) {
    const r = Object.keys(this);
    let i = r.length, a = !1;
    for (; i--; ) {
      const o = r[i];
      (!n || Sc(this, this[o], o, n, !0)) && (delete this[o], a = !0);
    }
    return a;
  }
  normalize(n) {
    const r = this, i = {};
    return ye.forEach(this, (a, o) => {
      const s = ye.findKey(i, o);
      if (s) {
        r[s] = Xs(a), delete r[o];
        return;
      }
      const l = n ? q$(o) : String(o).trim();
      l !== o && delete r[o], r[l] = Xs(a), i[l] = !0;
    }), this;
  }
  concat(...n) {
    return this.constructor.concat(this, ...n);
  }
  toJSON(n) {
    const r = /* @__PURE__ */ Object.create(null);
    return ye.forEach(this, (i, a) => {
      i != null && i !== !1 && (r[a] = n && ye.isArray(i) ? i.join(", ") : i);
    }), r;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([n, r]) => n + ": " + r).join(`
`);
  }
  getSetCookie() {
    return this.get("set-cookie") || [];
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(n) {
    return n instanceof this ? n : new this(n);
  }
  static concat(n, ...r) {
    const i = new this(n);
    return r.forEach((a) => i.set(a)), i;
  }
  static accessor(n) {
    const i = (this[yv] = this[yv] = {
      accessors: {}
    }).accessors, a = this.prototype;
    function o(s) {
      const l = qa(s);
      i[l] || (H$(a, s), i[l] = !0);
    }
    return ye.isArray(n) ? n.forEach(o) : o(n), this;
  }
};
Mt.accessor([
  "Content-Type",
  "Content-Length",
  "Accept",
  "Accept-Encoding",
  "User-Agent",
  "Authorization"
]);
ye.reduceDescriptors(Mt.prototype, ({ value: e }, n) => {
  let r = n[0].toUpperCase() + n.slice(1);
  return {
    get: () => e,
    set(i) {
      this[r] = i;
    }
  };
});
ye.freezeMethods(Mt);
const W$ = "[REDACTED ****]";
function K$(e) {
  if (ye.hasOwnProp(e, "toJSON"))
    return !0;
  let n = Object.getPrototypeOf(e);
  for (; n && n !== Object.prototype; ) {
    if (ye.hasOwnProp(n, "toJSON"))
      return !0;
    n = Object.getPrototypeOf(n);
  }
  return !1;
}
function G$(e, n) {
  const r = new Set(n.map((o) => String(o).toLowerCase())), i = [], a = (o) => {
    if (o === null || typeof o != "object" || ye.isBuffer(o)) return o;
    if (i.indexOf(o) !== -1) return;
    o instanceof Mt && (o = o.toJSON()), i.push(o);
    let s;
    if (ye.isArray(o))
      s = [], o.forEach((l, d) => {
        const m = a(l);
        ye.isUndefined(m) || (s[d] = m);
      });
    else {
      if (!ye.isPlainObject(o) && K$(o))
        return i.pop(), o;
      s = /* @__PURE__ */ Object.create(null);
      for (const [l, d] of Object.entries(o)) {
        const m = r.has(l.toLowerCase()) ? W$ : a(d);
        ye.isUndefined(m) || (s[l] = m);
      }
    }
    return i.pop(), s;
  };
  return a(e);
}
let on = class Bw extends Error {
  static from(n, r, i, a, o, s) {
    const l = new Bw(n.message, r || n.code, i, a, o);
    return l.cause = n, l.name = n.name, n.status != null && l.status == null && (l.status = n.status), s && Object.assign(l, s), l;
  }
  /**
   * Create an Error with the specified message, config, error code, request and response.
   *
   * @param {string} message The error message.
   * @param {string} [code] The error code (for example, 'ECONNABORTED').
   * @param {Object} [config] The config.
   * @param {Object} [request] The request.
   * @param {Object} [response] The response.
   *
   * @returns {Error} The created error.
   */
  constructor(n, r, i, a, o) {
    super(n), Object.defineProperty(this, "message", {
      // Null-proto descriptor so a polluted Object.prototype.get cannot turn
      // this data descriptor into an accessor descriptor on the way in.
      __proto__: null,
      value: n,
      enumerable: !0,
      writable: !0,
      configurable: !0
    }), this.name = "AxiosError", this.isAxiosError = !0, r && (this.code = r), i && (this.config = i), a && (this.request = a), o && (this.response = o, this.status = o.status);
  }
  toJSON() {
    const n = this.config, r = n && ye.hasOwnProp(n, "redact") ? n.redact : void 0, i = ye.isArray(r) && r.length > 0 ? G$(n, r) : ye.toJSONObject(n);
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: i,
      code: this.code,
      status: this.status
    };
  }
};
on.ERR_BAD_OPTION_VALUE = "ERR_BAD_OPTION_VALUE";
on.ERR_BAD_OPTION = "ERR_BAD_OPTION";
on.ECONNABORTED = "ECONNABORTED";
on.ETIMEDOUT = "ETIMEDOUT";
on.ECONNREFUSED = "ECONNREFUSED";
on.ERR_NETWORK = "ERR_NETWORK";
on.ERR_FR_TOO_MANY_REDIRECTS = "ERR_FR_TOO_MANY_REDIRECTS";
on.ERR_DEPRECATED = "ERR_DEPRECATED";
on.ERR_BAD_RESPONSE = "ERR_BAD_RESPONSE";
on.ERR_BAD_REQUEST = "ERR_BAD_REQUEST";
on.ERR_CANCELED = "ERR_CANCELED";
on.ERR_NOT_SUPPORT = "ERR_NOT_SUPPORT";
on.ERR_INVALID_URL = "ERR_INVALID_URL";
on.ERR_FORM_DATA_DEPTH_EXCEEDED = "ERR_FORM_DATA_DEPTH_EXCEEDED";
const Y$ = null, qw = 100;
function Jh(e) {
  return ye.isPlainObject(e) || ye.isArray(e);
}
function Hw(e) {
  return ye.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function Nc(e, n, r) {
  return e ? e.concat(n).map(function(a, o) {
    return a = Hw(a), !r && o ? "[" + a + "]" : a;
  }).join(r ? "." : "") : n;
}
function J$(e) {
  return ye.isArray(e) && !e.some(Jh);
}
const Q$ = ye.toFlatObject(ye, {}, null, function(n) {
  return /^is[A-Z]/.test(n);
});
function Yl(e, n, r) {
  if (!ye.isObject(e))
    throw new TypeError("target must be an object");
  n = n || new FormData(), r = ye.toFlatObject(
    r,
    {
      metaTokens: !0,
      dots: !1,
      indexes: !1
    },
    !1,
    function(g, O) {
      return !ye.isUndefined(O[g]);
    }
  );
  const i = r.metaTokens, a = r.visitor || w, o = r.dots, s = r.indexes, l = r.Blob || typeof Blob < "u" && Blob, d = r.maxDepth === void 0 ? qw : r.maxDepth, m = l && ye.isSpecCompliantForm(n), u = [];
  if (!ye.isFunction(a))
    throw new TypeError("visitor must be a function");
  function f(_) {
    if (_ === null) return "";
    if (ye.isDate(_))
      return _.toISOString();
    if (ye.isBoolean(_))
      return _.toString();
    if (!m && ye.isBlob(_))
      throw new on("Blob is not supported. Use a Buffer instead.");
    return ye.isArrayBuffer(_) || ye.isTypedArray(_) ? m && typeof Blob == "function" ? new Blob([_]) : Buffer.from(_) : _;
  }
  function h(_) {
    if (_ > d)
      throw new on(
        "Object is too deeply nested (" + _ + " levels). Max depth: " + d,
        on.ERR_FORM_DATA_DEPTH_EXCEEDED
      );
  }
  function v(_, g) {
    if (d === 1 / 0)
      return JSON.stringify(_);
    const O = [];
    return JSON.stringify(_, function($, I) {
      if (!ye.isObject(I))
        return I;
      for (; O.length && O[O.length - 1] !== this; )
        O.pop();
      return O.push(I), h(g + O.length - 1), I;
    });
  }
  function w(_, g, O) {
    let R = _;
    if (ye.isReactNative(n) && ye.isReactNativeBlob(_))
      return n.append(Nc(O, g, o), f(_)), !1;
    if (_ && !O && typeof _ == "object") {
      if (ye.endsWith(g, "{}"))
        g = i ? g : g.slice(0, -2), _ = v(_, 1);
      else if (ye.isArray(_) && J$(_) || (ye.isFileList(_) || ye.endsWith(g, "[]")) && (R = ye.toArray(_)))
        return g = Hw(g), R.forEach(function(I, L) {
          !(ye.isUndefined(I) || I === null) && n.append(
            // eslint-disable-next-line no-nested-ternary
            s === !0 ? Nc([g], L, o) : s === null ? g : g + "[]",
            f(I)
          );
        }), !1;
    }
    return Jh(_) ? !0 : (n.append(Nc(O, g, o), f(_)), !1);
  }
  const N = Object.assign(Q$, {
    defaultVisitor: w,
    convertValue: f,
    isVisitable: Jh
  });
  function j(_, g, O = 0) {
    if (!ye.isUndefined(_)) {
      if (h(O), u.indexOf(_) !== -1)
        throw new Error("Circular reference detected in " + g.join("."));
      u.push(_), ye.forEach(_, function($, I) {
        (!(ye.isUndefined($) || $ === null) && a.call(n, $, ye.isString(I) ? I.trim() : I, g, N)) === !0 && j($, g ? g.concat(I) : [I], O + 1);
      }), u.pop();
    }
  }
  if (!ye.isObject(e))
    throw new TypeError("data must be an object");
  return j(e), n;
}
function gv(e) {
  const n = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20/g, function(i) {
    return n[i];
  });
}
function Ay(e, n) {
  this._pairs = [], e && Yl(e, this, n);
}
const Ww = Ay.prototype;
Ww.append = function(n, r) {
  this._pairs.push([n, r]);
};
Ww.toString = function(n) {
  const r = n ? function(i) {
    return n.call(this, i, gv);
  } : gv;
  return this._pairs.map(function(a) {
    return r(a[0]) + "=" + r(a[1]);
  }, "").join("&");
};
function X$(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+");
}
function Kw(e, n, r) {
  if (!n)
    return e;
  const i = ye.isFunction(r) ? {
    serialize: r
  } : r, a = ye.getSafeProp(i, "encode") || X$, o = ye.getSafeProp(i, "serialize");
  let s;
  if (o ? s = o(n, i) : s = ye.isURLSearchParams(n) ? n.toString() : new Ay(n, i).toString(a), s) {
    const l = e.indexOf("#");
    l !== -1 && (e = e.slice(0, l)), e += (e.indexOf("?") === -1 ? "?" : "&") + s;
  }
  return e;
}
class vv {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   * @param {Object} options The options for the interceptor, synchronous and runWhen
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(n, r, i) {
    return this.handlers.push({
      fulfilled: n,
      rejected: r,
      synchronous: i ? i.synchronous : !1,
      runWhen: i ? i.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {void}
   */
  eject(n) {
    this.handlers[n] && (this.handlers[n] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(n) {
    ye.forEach(this.handlers, function(i) {
      i !== null && n(i);
    });
  }
}
const Ly = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1,
  legacyInterceptorReqResOrdering: !0,
  advertiseZstdAcceptEncoding: !1,
  validateStatusUndefinedResolves: !0
}, Z$ = typeof URLSearchParams < "u" ? URLSearchParams : Ay, eE = typeof FormData < "u" ? FormData : null, nE = typeof Blob < "u" ? Blob : null, tE = {
  isBrowser: !0,
  classes: {
    URLSearchParams: Z$,
    FormData: eE,
    Blob: nE
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, Vy = typeof window < "u" && typeof document < "u", Qh = typeof navigator == "object" && navigator || void 0, rE = Vy && (!Qh || ["ReactNative", "NativeScript", "NS"].indexOf(Qh.product) < 0), iE = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", aE = Vy && window.location.href || "http://localhost", oE = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: Vy,
  hasStandardBrowserEnv: rE,
  hasStandardBrowserWebWorkerEnv: iE,
  navigator: Qh,
  origin: aE
}, Symbol.toStringTag, { value: "Module" })), At = {
  ...oE,
  ...tE
};
function sE(e, n) {
  return Yl(e, new At.classes.URLSearchParams(), {
    visitor: function(r, i, a, o) {
      return At.isNode && ye.isBuffer(r) ? (this.append(i, r.toString("base64")), !1) : o.defaultVisitor.apply(this, arguments);
    },
    ...n
  });
}
const kv = qw;
function Gw(e) {
  if (e > kv)
    throw new on(
      "FormData field is too deeply nested (" + e + " levels). Max depth: " + kv,
      on.ERR_FORM_DATA_DEPTH_EXCEEDED
    );
}
function lE(e) {
  const n = [], r = /\w+|\[(\w*)]/g;
  let i;
  for (; (i = r.exec(e)) !== null; )
    Gw(n.length), n.push(i[0] === "[]" ? "" : i[1] || i[0]);
  return n;
}
function cE(e) {
  const n = {}, r = Object.keys(e);
  let i;
  const a = r.length;
  let o;
  for (i = 0; i < a; i++)
    o = r[i], n[o] = e[o];
  return n;
}
function Yw(e) {
  function n(r, i, a, o) {
    Gw(o);
    let s = r[o++];
    if (s === "__proto__") return !0;
    const l = Number.isFinite(+s), d = o >= r.length;
    return s = !s && ye.isArray(a) ? a.length : s, d ? (ye.hasOwnProp(a, s) ? a[s] = ye.isArray(a[s]) ? a[s].concat(i) : [a[s], i] : a[s] = i, !l) : ((!ye.hasOwnProp(a, s) || !ye.isObject(a[s])) && (a[s] = []), n(r, i, a[s], o) && ye.isArray(a[s]) && (a[s] = cE(a[s])), !l);
  }
  if (ye.isFormData(e) && ye.isFunction(e.entries)) {
    const r = {};
    return ye.forEachEntry(e, (i, a) => {
      n(lE(i), a, r, 0);
    }), r;
  }
  return null;
}
const ea = (e, n) => e != null && ye.hasOwnProp(e, n) ? e[n] : void 0;
function dE(e, n, r) {
  if (ye.isString(e))
    try {
      return (n || JSON.parse)(e), ye.trim(e);
    } catch (i) {
      if (i.name !== "SyntaxError")
        throw i;
    }
  return (r || JSON.stringify)(e);
}
const Zo = {
  transitional: Ly,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [
    function(n, r) {
      const i = r.getContentType() || "", a = i.indexOf("application/json") > -1, o = ye.isObject(n);
      if (o && ye.isHTMLForm(n) && (n = new FormData(n)), ye.isFormData(n))
        return a ? JSON.stringify(Yw(n)) : n;
      if (ye.isArrayBuffer(n) || ye.isBuffer(n) || ye.isStream(n) || ye.isFile(n) || ye.isBlob(n) || ye.isReadableStream(n))
        return n;
      if (ye.isArrayBufferView(n))
        return n.buffer;
      if (ye.isURLSearchParams(n))
        return r.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), n.toString();
      let l;
      if (o) {
        const d = ea(this, "formSerializer");
        if (i.indexOf("application/x-www-form-urlencoded") > -1)
          return sE(n, d).toString();
        if ((l = ye.isFileList(n)) || i.indexOf("multipart/form-data") > -1) {
          const m = ea(this, "env"), u = m && m.FormData;
          return Yl(
            l ? { "files[]": n } : n,
            u && new u(),
            d
          );
        }
      }
      return o || a ? (r.setContentType("application/json", !1), dE(n)) : n;
    }
  ],
  transformResponse: [
    function(n) {
      const r = ea(this, "transitional") || Zo.transitional, i = r && r.forcedJSONParsing, a = ea(this, "responseType"), o = a === "json";
      if (ye.isResponse(n) || ye.isReadableStream(n))
        return n;
      if (n && ye.isString(n) && (i && !a || o)) {
        const l = !(r && r.silentJSONParsing) && o;
        try {
          return JSON.parse(n, ea(this, "parseReviver"));
        } catch (d) {
          if (l)
            throw d.name === "SyntaxError" ? on.from(d, on.ERR_BAD_RESPONSE, this, null, ea(this, "response")) : d;
        }
      }
      return n;
    }
  ],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: At.classes.FormData,
    Blob: At.classes.Blob
  },
  validateStatus: function(n) {
    return n >= 200 && n < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
ye.forEach(["delete", "get", "head", "post", "put", "patch", "query"], (e) => {
  Zo.headers[e] = {};
});
function jc(e, n) {
  const r = this || Zo, i = n || r, a = Mt.from(i.headers);
  let o = i.data;
  return ye.forEach(e, function(l) {
    o = l.call(r, o, a.normalize(), n ? n.status : void 0);
  }), a.normalize(), o;
}
function Jw(e) {
  return !!(e && e.__CANCEL__);
}
let es = class extends on {
  /**
   * A `CanceledError` is an object that is thrown when an operation is canceled.
   *
   * @param {string=} message The message.
   * @param {Object=} config The config.
   * @param {Object=} request The request.
   *
   * @returns {CanceledError} The created error.
   */
  constructor(n, r, i) {
    super(n ?? "canceled", on.ERR_CANCELED, r, i), this.name = "CanceledError", this.__CANCEL__ = !0;
  }
};
function Qw(e, n, r) {
  const i = r.config.validateStatus;
  !r.status || !i || i(r.status) ? e(r) : n(new on(
    "Request failed with status code " + r.status,
    r.status >= 400 && r.status < 500 ? on.ERR_BAD_REQUEST : on.ERR_BAD_RESPONSE,
    r.config,
    r.request,
    r
  ));
}
function uE(e) {
  const n = /^([-+\w]{1,25}):(?:\/\/)?/.exec(e);
  return n && n[1] || "";
}
function mE(e, n) {
  e = e || 10;
  const r = new Array(e), i = new Array(e);
  let a = 0, o = 0, s;
  return n = n !== void 0 ? n : 1e3, function(d) {
    const m = Date.now(), u = i[o];
    s || (s = m), r[a] = d, i[a] = m;
    let f = o, h = 0;
    for (; f !== a; )
      h += r[f++], f = f % e;
    if (a = (a + 1) % e, a === o && (o = (o + 1) % e), m - s < n)
      return;
    const v = u && m - u;
    return v ? Math.round(h * 1e3 / v) : void 0;
  };
}
function pE(e, n) {
  let r = 0, i = 1e3 / n, a, o;
  const s = (m, u = Date.now()) => {
    r = u, a = null, o && (clearTimeout(o), o = null), e(...m);
  };
  return [(...m) => {
    const u = Date.now(), f = u - r;
    f >= i ? s(m, u) : (a = m, o || (o = setTimeout(() => {
      o = null, s(a);
    }, i - f)));
  }, () => a && s(a)];
}
const fl = (e, n, r = 3) => {
  let i = 0;
  const a = mE(50, 250);
  return pE((o) => {
    if (!o || typeof o.loaded != "number")
      return;
    const s = o.loaded, l = o.lengthComputable ? o.total : void 0, d = l != null ? Math.min(s, l) : s, m = Math.max(0, d - i), u = a(m);
    i = Math.max(i, d);
    const f = {
      loaded: d,
      total: l,
      progress: l ? d / l : void 0,
      bytes: m,
      rate: u || void 0,
      estimated: u && l ? (l - d) / u : void 0,
      event: o,
      lengthComputable: l != null,
      [n ? "download" : "upload"]: !0
    };
    e(f);
  }, r);
}, bv = (e, n) => {
  const r = e != null;
  return [
    (i) => n[0]({
      lengthComputable: r,
      total: e,
      loaded: i
    }),
    n[1]
  ];
}, _v = (e) => (...n) => ye.asap(() => e(...n)), fE = At.hasStandardBrowserEnv ? /* @__PURE__ */ ((e, n) => (r) => (r = new URL(r, At.origin), e.protocol === r.protocol && e.host === r.host && (n || e.port === r.port)))(
  new URL(At.origin),
  At.navigator && /(msie|trident)/i.test(At.navigator.userAgent)
) : () => !0, hE = At.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(e, n, r, i, a, o, s) {
      if (typeof document > "u") return;
      const l = [`${e}=${encodeURIComponent(n)}`];
      ye.isNumber(r) && l.push(`expires=${new Date(r).toUTCString()}`), ye.isString(i) && l.push(`path=${i}`), ye.isString(a) && l.push(`domain=${a}`), o === !0 && l.push("secure"), ye.isString(s) && l.push(`SameSite=${s}`), document.cookie = l.join("; ");
    },
    read(e) {
      if (typeof document > "u") return null;
      const n = document.cookie.split(";");
      for (let r = 0; r < n.length; r++) {
        const i = n[r].replace(/^\s+/, ""), a = i.indexOf("=");
        if (a !== -1 && i.slice(0, a) === e)
          return decodeURIComponent(i.slice(a + 1));
      }
      return null;
    },
    remove(e) {
      this.write(e, "", Date.now() - 864e5, "/");
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function yE(e) {
  return typeof e != "string" ? !1 : /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function gE(e, n) {
  return n ? e.replace(/\/?\/$/, "") + "/" + n.replace(/^\/+/, "") : e;
}
const vE = /^https?:(?!\/\/)/i, kE = /[\t\n\r]/g;
function bE(e) {
  let n = 0;
  for (; n < e.length && e.charCodeAt(n) <= 32; )
    n++;
  return e.slice(n);
}
function _E(e) {
  return bE(e).replace(kE, "");
}
function xv(e, n) {
  if (typeof e == "string" && vE.test(_E(e)))
    throw new on(
      'Invalid URL: missing "//" after protocol',
      on.ERR_INVALID_URL,
      n
    );
}
function Xw(e, n, r, i) {
  xv(n, i);
  let a = !yE(n);
  return e && (a || r === !1) ? (xv(e, i), gE(e, n)) : n;
}
const Sv = (e) => e instanceof Mt ? { ...e } : e;
function Wi(e, n) {
  n = n || {};
  const r = /* @__PURE__ */ Object.create(null);
  Object.defineProperty(r, "hasOwnProperty", {
    // Null-proto descriptor so a polluted Object.prototype.get cannot turn
    // this data descriptor into an accessor descriptor on the way in.
    __proto__: null,
    value: Object.prototype.hasOwnProperty,
    enumerable: !1,
    writable: !0,
    configurable: !0
  });
  function i(u, f, h, v) {
    return ye.isPlainObject(u) && ye.isPlainObject(f) ? ye.merge.call({ caseless: v }, u, f) : ye.isPlainObject(f) ? ye.merge({}, f) : ye.isArray(f) ? f.slice() : f;
  }
  function a(u, f, h, v) {
    if (ye.isUndefined(f)) {
      if (!ye.isUndefined(u))
        return i(void 0, u, h, v);
    } else return i(u, f, h, v);
  }
  function o(u, f) {
    if (!ye.isUndefined(f))
      return i(void 0, f);
  }
  function s(u, f) {
    if (ye.isUndefined(f)) {
      if (!ye.isUndefined(u))
        return i(void 0, u);
    } else return i(void 0, f);
  }
  function l(u) {
    const f = ye.hasOwnProp(n, "transitional") ? n.transitional : void 0;
    if (!ye.isUndefined(f))
      if (ye.isPlainObject(f)) {
        if (ye.hasOwnProp(f, u))
          return f[u];
      } else
        return;
    const h = ye.hasOwnProp(e, "transitional") ? e.transitional : void 0;
    if (ye.isPlainObject(h) && ye.hasOwnProp(h, u))
      return h[u];
  }
  function d(u, f, h) {
    if (ye.hasOwnProp(n, h))
      return i(u, f);
    if (ye.hasOwnProp(e, h))
      return i(void 0, u);
  }
  const m = {
    url: o,
    method: o,
    data: o,
    baseURL: s,
    transformRequest: s,
    transformResponse: s,
    paramsSerializer: s,
    timeout: s,
    timeoutMessage: s,
    withCredentials: s,
    withXSRFToken: s,
    adapter: s,
    responseType: s,
    xsrfCookieName: s,
    xsrfHeaderName: s,
    onUploadProgress: s,
    onDownloadProgress: s,
    decompress: s,
    maxContentLength: s,
    maxBodyLength: s,
    beforeRedirect: s,
    transport: s,
    httpAgent: s,
    httpsAgent: s,
    cancelToken: s,
    socketPath: s,
    allowedSocketPaths: s,
    responseEncoding: s,
    validateStatus: d,
    headers: (u, f, h) => a(Sv(u), Sv(f), h, !0)
  };
  return ye.forEach(Object.keys({ ...e, ...n }), function(f) {
    if (f === "__proto__" || f === "constructor" || f === "prototype") return;
    const h = ye.hasOwnProp(m, f) ? m[f] : a, v = ye.hasOwnProp(e, f) ? e[f] : void 0, w = ye.hasOwnProp(n, f) ? n[f] : void 0, N = h(v, w, f);
    ye.isUndefined(N) && h !== d || (r[f] = N);
  }), ye.hasOwnProp(n, "validateStatus") && ye.isUndefined(n.validateStatus) && l("validateStatusUndefinedResolves") === !1 && (ye.hasOwnProp(e, "validateStatus") ? r.validateStatus = i(void 0, e.validateStatus) : delete r.validateStatus), r;
}
const xE = ["content-type", "content-length"];
function SE(e, n, r) {
  if (r !== "content-only") {
    e.set(n);
    return;
  }
  Object.entries(n).forEach(([i, a]) => {
    xE.includes(i.toLowerCase()) && e.set(i, a);
  });
}
const NE = (e) => encodeURIComponent(e).replace(
  /%([0-9A-F]{2})/gi,
  (n, r) => String.fromCharCode(parseInt(r, 16))
);
function Zw(e) {
  const n = Wi({}, e), r = (h) => ye.hasOwnProp(n, h) ? n[h] : void 0, i = r("data");
  let a = r("withXSRFToken");
  const o = r("xsrfHeaderName"), s = r("xsrfCookieName");
  let l = r("headers");
  const d = r("auth"), m = r("baseURL"), u = r("allowAbsoluteUrls"), f = r("url");
  if (n.headers = l = Mt.from(l), n.url = Kw(
    Xw(m, f, u, n),
    r("params"),
    r("paramsSerializer")
  ), d) {
    const h = ye.getSafeProp(d, "username") || "", v = ye.getSafeProp(d, "password") || "";
    l.set(
      "Authorization",
      "Basic " + btoa(h + ":" + (v ? NE(v) : ""))
    );
  }
  if (ye.isFormData(i) && (At.hasStandardBrowserEnv || At.hasStandardBrowserWebWorkerEnv || ye.isReactNative(i) ? l.setContentType(void 0) : ye.isFunction(i.getHeaders) && SE(l, i.getHeaders(), r("formDataHeaderPolicy"))), At.hasStandardBrowserEnv && (ye.isFunction(a) && (a = a(n)), a === !0 || a == null && fE(n.url))) {
    const v = o && s && hE.read(s);
    v && l.set(o, v);
  }
  return n;
}
const jE = typeof XMLHttpRequest < "u", wE = jE && function(e) {
  return new Promise(function(r, i) {
    const a = Zw(e);
    let o = a.data;
    const s = Mt.from(a.headers).normalize();
    let { responseType: l, onUploadProgress: d, onDownloadProgress: m } = a, u, f, h, v, w;
    function N() {
      v && v(), w && w(), a.cancelToken && a.cancelToken.unsubscribe(u), a.signal && a.signal.removeEventListener("abort", u);
    }
    let j = new XMLHttpRequest();
    j.open(a.method.toUpperCase(), a.url, !0), j.timeout = a.timeout;
    function _() {
      if (!j)
        return;
      const O = Mt.from(
        "getAllResponseHeaders" in j && j.getAllResponseHeaders()
      ), $ = {
        data: !l || l === "text" || l === "json" ? j.responseText : j.response,
        status: j.status,
        statusText: j.statusText,
        headers: O,
        config: e,
        request: j
      };
      Qw(
        function(L) {
          r(L), N();
        },
        function(L) {
          i(L), N();
        },
        $
      ), j = null;
    }
    "onloadend" in j ? j.onloadend = _ : j.onreadystatechange = function() {
      !j || j.readyState !== 4 || j.status === 0 && !(j.responseURL && j.responseURL.startsWith("file:")) || setTimeout(_);
    }, j.onabort = function() {
      j && (i(new on("Request aborted", on.ECONNABORTED, e, j)), N(), j = null);
    }, j.onerror = function(R) {
      const $ = R && R.message ? R.message : "Network Error", I = new on($, on.ERR_NETWORK, e, j);
      I.event = R || null, i(I), N(), j = null;
    }, j.ontimeout = function() {
      let R = a.timeout ? "timeout of " + a.timeout + "ms exceeded" : "timeout exceeded";
      const $ = a.transitional || Ly;
      a.timeoutErrorMessage && (R = a.timeoutErrorMessage), i(
        new on(
          R,
          $.clarifyTimeoutError ? on.ETIMEDOUT : on.ECONNABORTED,
          e,
          j
        )
      ), N(), j = null;
    }, o === void 0 && s.setContentType(null), "setRequestHeader" in j && ye.forEach(Mw(s), function(R, $) {
      j.setRequestHeader($, R);
    }), ye.isUndefined(a.withCredentials) || (j.withCredentials = !!a.withCredentials), l && l !== "json" && (j.responseType = a.responseType), m && ([h, w] = fl(m, !0), j.addEventListener("progress", h)), d && j.upload && ([f, v] = fl(d), j.upload.addEventListener("progress", f), j.upload.addEventListener("loadend", v)), (a.cancelToken || a.signal) && (u = (O) => {
      j && (i(!O || O.type ? new es(null, e, j) : O), j.abort(), N(), j = null);
    }, a.cancelToken && a.cancelToken.subscribe(u), a.signal && (a.signal.aborted ? u() : a.signal.addEventListener("abort", u)));
    const g = uE(a.url);
    if (g && !At.protocols.includes(g)) {
      i(
        new on(
          "Unsupported protocol " + g + ":",
          on.ERR_BAD_REQUEST,
          e
        )
      );
      return;
    }
    j.send(o || null);
  });
}, CE = (e, n) => {
  if (e = e ? e.filter(Boolean) : [], !n && !e.length)
    return;
  const r = new AbortController();
  let i = !1;
  const a = function(d) {
    if (!i) {
      i = !0, s();
      const m = d instanceof Error ? d : this.reason;
      r.abort(
        m instanceof on ? m : new es(m instanceof Error ? m.message : m)
      );
    }
  };
  let o = n && setTimeout(() => {
    o = null, a(new on(`timeout of ${n}ms exceeded`, on.ETIMEDOUT));
  }, n);
  const s = () => {
    e && (o && clearTimeout(o), o = null, e.forEach((d) => {
      d.unsubscribe ? d.unsubscribe(a) : d.removeEventListener("abort", a);
    }), e = null);
  };
  e.forEach((d) => d.addEventListener("abort", a));
  const { signal: l } = r;
  return l.unsubscribe = () => ye.asap(s), l;
}, FE = function* (e, n) {
  let r = e.byteLength;
  if (r < n) {
    yield e;
    return;
  }
  let i = 0, a;
  for (; i < r; )
    a = i + n, yield e.slice(i, a), i = a;
}, IE = async function* (e, n) {
  for await (const r of $E(e))
    yield* FE(r, n);
}, $E = async function* (e) {
  if (e[Symbol.asyncIterator]) {
    yield* e;
    return;
  }
  const n = e.getReader();
  try {
    for (; ; ) {
      const { done: r, value: i } = await n.read();
      if (r)
        break;
      yield i;
    }
  } finally {
    await n.cancel();
  }
}, Nv = (e, n, r, i) => {
  const a = IE(e, n);
  let o = 0, s, l = (d) => {
    s || (s = !0, i && i(d));
  };
  return new ReadableStream(
    {
      async pull(d) {
        try {
          const { done: m, value: u } = await a.next();
          if (m) {
            l(), d.close();
            return;
          }
          let f = u.byteLength;
          if (r) {
            let h = o += f;
            r(h);
          }
          d.enqueue(new Uint8Array(u));
        } catch (m) {
          throw l(m), m;
        }
      },
      cancel(d) {
        return l(d), a.return();
      }
    },
    {
      highWaterMark: 2
    }
  );
}, hl = (e) => e >= 48 && e <= 57 || e >= 65 && e <= 70 || e >= 97 && e <= 102, EE = (e, n, r) => n + 2 < r && hl(e.charCodeAt(n + 1)) && hl(e.charCodeAt(n + 2));
function TE(e) {
  if (!e || typeof e != "string" || !e.startsWith("data:")) return 0;
  const n = e.indexOf(",");
  if (n < 0) return 0;
  const r = e.slice(5, n), i = e.slice(n + 1);
  if (/;base64/i.test(r)) {
    let s = i.length;
    const l = i.length;
    for (let v = 0; v < l; v++)
      if (i.charCodeAt(v) === 37 && v + 2 < l) {
        const w = i.charCodeAt(v + 1), N = i.charCodeAt(v + 2);
        hl(w) && hl(N) && (s -= 2, v += 2);
      }
    let d = 0, m = l - 1;
    const u = (v) => v >= 2 && i.charCodeAt(v - 2) === 37 && // '%'
    i.charCodeAt(v - 1) === 51 && // '3'
    (i.charCodeAt(v) === 68 || i.charCodeAt(v) === 100);
    m >= 0 && (i.charCodeAt(m) === 61 ? (d++, m--) : u(m) && (d++, m -= 3)), d === 1 && m >= 0 && (i.charCodeAt(m) === 61 || u(m)) && d++;
    const h = Math.floor(s / 4) * 3 - (d || 0);
    return h > 0 ? h : 0;
  }
  let o = 0;
  for (let s = 0, l = i.length; s < l; s++) {
    const d = i.charCodeAt(s);
    if (d === 37 && EE(i, s, l))
      o += 1, s += 2;
    else if (d < 128)
      o += 1;
    else if (d < 2048)
      o += 2;
    else if (d >= 55296 && d <= 56319 && s + 1 < l) {
      const m = i.charCodeAt(s + 1);
      m >= 56320 && m <= 57343 ? (o += 4, s++) : o += 3;
    } else
      o += 3;
  }
  return o;
}
const zy = "1.18.0", jv = 64 * 1024, { isFunction: fs } = ye, RE = (e) => encodeURIComponent(e).replace(
  /%([0-9A-F]{2})/gi,
  (n, r) => String.fromCharCode(parseInt(r, 16))
), wv = (e) => {
  if (!ye.isString(e))
    return e;
  try {
    return decodeURIComponent(e);
  } catch {
    return e;
  }
}, Cv = (e, ...n) => {
  try {
    return !!e(...n);
  } catch {
    return !1;
  }
}, DE = (e) => {
  const n = e.indexOf("://");
  let r = e;
  return n !== -1 && (r = r.slice(n + 3)), r.includes("@") || r.includes(":");
}, OE = (e) => {
  const n = ye.global !== void 0 && ye.global !== null ? ye.global : globalThis, { ReadableStream: r, TextEncoder: i } = n;
  e = ye.merge.call(
    {
      skipUndefined: !0
    },
    {
      Request: n.Request,
      Response: n.Response
    },
    e
  );
  const { fetch: a, Request: o, Response: s } = e, l = a ? fs(a) : typeof fetch == "function", d = fs(o), m = fs(s);
  if (!l)
    return !1;
  const u = l && fs(r), f = l && (typeof i == "function" ? /* @__PURE__ */ ((_) => (g) => _.encode(g))(new i()) : async (_) => new Uint8Array(await new o(_).arrayBuffer())), h = d && u && Cv(() => {
    let _ = !1;
    const g = new o(At.origin, {
      body: new r(),
      method: "POST",
      get duplex() {
        return _ = !0, "half";
      }
    }), O = g.headers.has("Content-Type");
    return g.body != null && g.body.cancel(), _ && !O;
  }), v = m && u && Cv(() => ye.isReadableStream(new s("").body)), w = {
    stream: v && ((_) => _.body)
  };
  l && ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((_) => {
    !w[_] && (w[_] = (g, O) => {
      let R = g && g[_];
      if (R)
        return R.call(g);
      throw new on(
        `Response type '${_}' is not supported`,
        on.ERR_NOT_SUPPORT,
        O
      );
    });
  });
  const N = async (_) => {
    if (_ == null)
      return 0;
    if (ye.isBlob(_))
      return _.size;
    if (ye.isSpecCompliantForm(_))
      return (await new o(At.origin, {
        method: "POST",
        body: _
      }).arrayBuffer()).byteLength;
    if (ye.isArrayBufferView(_) || ye.isArrayBuffer(_))
      return _.byteLength;
    if (ye.isURLSearchParams(_) && (_ = _ + ""), ye.isString(_))
      return (await f(_)).byteLength;
  }, j = async (_, g) => {
    const O = ye.toFiniteNumber(_.getContentLength());
    return O ?? N(g);
  };
  return async (_) => {
    let {
      url: g,
      method: O,
      data: R,
      signal: $,
      cancelToken: I,
      timeout: L,
      onDownloadProgress: G,
      onUploadProgress: Q,
      responseType: ne,
      headers: q,
      withCredentials: Y = "same-origin",
      fetchOptions: P,
      maxContentLength: B,
      maxBodyLength: ie
    } = Zw(_);
    const je = ye.isNumber(B) && B > -1, pe = ye.isNumber(ie) && ie > -1, le = (Ie) => ye.hasOwnProp(_, Ie) ? _[Ie] : void 0;
    let ge = a || fetch;
    ne = ne ? (ne + "").toLowerCase() : "text";
    let V = CE(
      [$, I && I.toAbortSignal()],
      L
    ), be = null;
    const Oe = V && V.unsubscribe && (() => {
      V.unsubscribe();
    });
    let H, Ye = null;
    const ln = () => new on(
      "Request body larger than maxBodyLength limit",
      on.ERR_BAD_REQUEST,
      _,
      be
    );
    try {
      let Ie;
      const Ue = le("auth");
      if (Ue) {
        const ce = ye.getSafeProp(Ue, "username") || "", Se = ye.getSafeProp(Ue, "password") || "";
        Ie = {
          username: ce,
          password: Se
        };
      }
      if (DE(g)) {
        const ce = new URL(g, At.origin);
        if (!Ie && (ce.username || ce.password)) {
          const Se = wv(ce.username), Ve = wv(ce.password);
          Ie = {
            username: Se,
            password: Ve
          };
        }
        (ce.username || ce.password) && (ce.username = "", ce.password = "", g = ce.href);
      }
      if (Ie && (q.delete("authorization"), q.set(
        "Authorization",
        "Basic " + btoa(RE((Ie.username || "") + ":" + (Ie.password || "")))
      )), je && typeof g == "string" && g.startsWith("data:") && TE(g) > B)
        throw new on(
          "maxContentLength size of " + B + " exceeded",
          on.ERR_BAD_RESPONSE,
          _,
          be
        );
      if (pe && O !== "get" && O !== "head") {
        const ce = await N(R);
        if (typeof ce == "number" && isFinite(ce) && (H = ce, ce > ie))
          throw ln();
      }
      const De = pe && (ye.isReadableStream(R) || ye.isStream(R)), Be = (ce, Se, Ve) => Nv(
        ce,
        jv,
        (Pe) => {
          if (pe && Pe > ie)
            throw Ye = ln();
          Se && Se(Pe);
        },
        Ve
      );
      if (h && O !== "get" && O !== "head" && (Q || De)) {
        if (H = H ?? await j(q, R), H !== 0 || De) {
          let ce = new o(g, {
            method: "POST",
            body: R,
            duplex: "half"
          }), Se;
          if (ye.isFormData(R) && (Se = ce.headers.get("content-type")) && q.setContentType(Se), ce.body) {
            const [Ve, Pe] = Q && bv(
              H,
              fl(_v(Q))
            ) || [];
            R = Be(ce.body, Ve, Pe);
          }
        }
      } else if (De && !d && u && O !== "get" && O !== "head")
        R = Be(R);
      else if (De && d && !h && O !== "get" && O !== "head")
        throw new on(
          "Stream request bodies are not supported by the current fetch implementation",
          on.ERR_NOT_SUPPORT,
          _,
          be
        );
      ye.isString(Y) || (Y = Y ? "include" : "omit");
      const Ae = d && "credentials" in o.prototype;
      if (ye.isFormData(R)) {
        const ce = q.getContentType();
        ce && /^multipart\/form-data/i.test(ce) && !/boundary=/i.test(ce) && q.delete("content-type");
      }
      q.set("User-Agent", "axios/" + zy, !1);
      const Qe = {
        ...P,
        signal: V,
        method: O.toUpperCase(),
        headers: Mw(q.normalize()),
        body: R,
        duplex: "half",
        credentials: Ae ? Y : void 0
      };
      be = d && new o(g, Qe);
      let Ee = await (d ? ge(be, P) : ge(g, Qe));
      const Me = Mt.from(Ee.headers);
      if (je) {
        const ce = ye.toFiniteNumber(Me.getContentLength());
        if (ce != null && ce > B)
          throw new on(
            "maxContentLength size of " + B + " exceeded",
            on.ERR_BAD_RESPONSE,
            _,
            be
          );
      }
      const en = v && (ne === "stream" || ne === "response");
      if (v && Ee.body && (G || je || en && Oe)) {
        const ce = {};
        ["status", "statusText", "headers"].forEach((E) => {
          ce[E] = Ee[E];
        });
        const Se = ye.toFiniteNumber(Me.getContentLength()), [Ve, Pe] = G && bv(
          Se,
          fl(_v(G), !0)
        ) || [];
        let kn = 0;
        const X = (E) => {
          if (je && (kn = E, kn > B))
            throw new on(
              "maxContentLength size of " + B + " exceeded",
              on.ERR_BAD_RESPONSE,
              _,
              be
            );
          Ve && Ve(E);
        };
        Ee = new s(
          Nv(Ee.body, jv, X, () => {
            Pe && Pe(), Oe && Oe();
          }),
          ce
        );
      }
      ne = ne || "text";
      let se = await w[ye.findKey(w, ne) || "text"](
        Ee,
        _
      );
      if (je && !v && !en) {
        let ce;
        if (se != null && (typeof se.byteLength == "number" ? ce = se.byteLength : typeof se.size == "number" ? ce = se.size : typeof se == "string" && (ce = typeof i == "function" ? new i().encode(se).byteLength : se.length)), typeof ce == "number" && ce > B)
          throw new on(
            "maxContentLength size of " + B + " exceeded",
            on.ERR_BAD_RESPONSE,
            _,
            be
          );
      }
      return !en && Oe && Oe(), await new Promise((ce, Se) => {
        Qw(ce, Se, {
          data: se,
          headers: Mt.from(Ee.headers),
          status: Ee.status,
          statusText: Ee.statusText,
          config: _,
          request: be
        });
      });
    } catch (Ie) {
      if (Oe && Oe(), V && V.aborted && V.reason instanceof on) {
        const Ue = V.reason;
        throw Ue.config = _, be && (Ue.request = be), Ie !== Ue && (Ue.cause = Ie), Ue;
      }
      throw Ye ? (be && !Ye.request && (Ye.request = be), Ye) : Ie instanceof on ? (be && !Ie.request && (Ie.request = be), Ie) : Ie && Ie.name === "TypeError" && /Load failed|fetch/i.test(Ie.message) ? Object.assign(
        new on(
          "Network Error",
          on.ERR_NETWORK,
          _,
          be,
          Ie && Ie.response
        ),
        {
          cause: Ie.cause || Ie
        }
      ) : on.from(Ie, Ie && Ie.code, _, be, Ie && Ie.response);
    }
  };
}, PE = /* @__PURE__ */ new Map(), eC = (e) => {
  let n = e && e.env || {};
  const { fetch: r, Request: i, Response: a } = n, o = [i, a, r];
  let s = o.length, l = s, d, m, u = PE;
  for (; l--; )
    d = o[l], m = u.get(d), m === void 0 && u.set(d, m = l ? /* @__PURE__ */ new Map() : OE(n)), u = m;
  return m;
};
eC();
const Uy = {
  http: Y$,
  xhr: wE,
  fetch: {
    get: eC
  }
};
ye.forEach(Uy, (e, n) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { __proto__: null, value: n });
    } catch {
    }
    Object.defineProperty(e, "adapterName", { __proto__: null, value: n });
  }
});
const Fv = (e) => `- ${e}`, AE = (e) => ye.isFunction(e) || e === null || e === !1;
function LE(e, n) {
  e = ye.isArray(e) ? e : [e];
  const { length: r } = e;
  let i, a;
  const o = {};
  for (let s = 0; s < r; s++) {
    i = e[s];
    let l;
    if (a = i, !AE(i) && (a = Uy[(l = String(i)).toLowerCase()], a === void 0))
      throw new on(`Unknown adapter '${l}'`);
    if (a && (ye.isFunction(a) || (a = a.get(n))))
      break;
    o[l || "#" + s] = a;
  }
  if (!a) {
    const s = Object.entries(o).map(
      ([d, m]) => `adapter ${d} ` + (m === !1 ? "is not supported by the environment" : "is not available in the build")
    );
    let l = r ? s.length > 1 ? `since :
` + s.map(Fv).join(`
`) : " " + Fv(s[0]) : "as no adapter specified";
    throw new on(
      "There is no suitable adapter to dispatch the request " + l,
      "ERR_NOT_SUPPORT"
    );
  }
  return a;
}
const nC = {
  /**
   * Resolve an adapter from a list of adapter names or functions.
   * @type {Function}
   */
  getAdapter: LE,
  /**
   * Exposes all known adapters
   * @type {Object<string, Function|Object>}
   */
  adapters: Uy
};
function wc(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new es(null, e);
}
function Iv(e) {
  return wc(e), e.headers = Mt.from(e.headers), e.data = jc.call(e, e.transformRequest), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), nC.getAdapter(e.adapter || Zo.adapter, e)(e).then(
    function(i) {
      wc(e), e.response = i;
      try {
        i.data = jc.call(e, e.transformResponse, i);
      } finally {
        delete e.response;
      }
      return i.headers = Mt.from(i.headers), i;
    },
    function(i) {
      if (!Jw(i) && (wc(e), i && i.response)) {
        e.response = i.response;
        try {
          i.response.data = jc.call(
            e,
            e.transformResponse,
            i.response
          );
        } finally {
          delete e.response;
        }
        i.response.headers = Mt.from(i.response.headers);
      }
      return Promise.reject(i);
    }
  );
}
const Jl = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, n) => {
  Jl[e] = function(i) {
    return typeof i === e || "a" + (n < 1 ? "n " : " ") + e;
  };
});
const $v = {};
Jl.transitional = function(n, r, i) {
  function a(o, s) {
    return "[Axios v" + zy + "] Transitional option '" + o + "'" + s + (i ? ". " + i : "");
  }
  return (o, s, l) => {
    if (n === !1)
      throw new on(
        a(s, " has been removed" + (r ? " in " + r : "")),
        on.ERR_DEPRECATED
      );
    return r && !$v[s] && ($v[s] = !0, console.warn(
      a(
        s,
        " has been deprecated since v" + r + " and will be removed in the near future"
      )
    )), n ? n(o, s, l) : !0;
  };
};
Jl.spelling = function(n) {
  return (r, i) => (console.warn(`${i} is likely a misspelling of ${n}`), !0);
};
function VE(e, n, r) {
  if (typeof e != "object")
    throw new on("options must be an object", on.ERR_BAD_OPTION_VALUE);
  const i = Object.keys(e);
  let a = i.length;
  for (; a-- > 0; ) {
    const o = i[a], s = Object.prototype.hasOwnProperty.call(n, o) ? n[o] : void 0;
    if (s) {
      const l = e[o], d = l === void 0 || s(l, o, e);
      if (d !== !0)
        throw new on(
          "option " + o + " must be " + d,
          on.ERR_BAD_OPTION_VALUE
        );
      continue;
    }
    if (r !== !0)
      throw new on("Unknown option " + o, on.ERR_BAD_OPTION);
  }
}
const Zs = {
  assertOptions: VE,
  validators: Jl
}, Ut = Zs.validators;
let zi = class {
  constructor(n) {
    this.defaults = n || {}, this.interceptors = {
      request: new vv(),
      response: new vv()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(n, r) {
    try {
      return await this._request(n, r);
    } catch (i) {
      if (i instanceof Error) {
        let a = {};
        Error.captureStackTrace ? Error.captureStackTrace(a) : a = new Error();
        const o = (() => {
          if (!a.stack)
            return "";
          const s = a.stack.indexOf(`
`);
          return s === -1 ? "" : a.stack.slice(s + 1);
        })();
        try {
          if (!i.stack)
            i.stack = o;
          else if (o) {
            const s = o.indexOf(`
`), l = s === -1 ? -1 : o.indexOf(`
`, s + 1), d = l === -1 ? "" : o.slice(l + 1);
            String(i.stack).endsWith(d) || (i.stack += `
` + o);
          }
        } catch {
        }
      }
      throw i;
    }
  }
  _request(n, r) {
    typeof n == "string" ? (r = r || {}, r.url = n) : r = n || {}, r = Wi(this.defaults, r);
    const { transitional: i, paramsSerializer: a, headers: o } = r;
    i !== void 0 && Zs.assertOptions(
      i,
      {
        silentJSONParsing: Ut.transitional(Ut.boolean),
        forcedJSONParsing: Ut.transitional(Ut.boolean),
        clarifyTimeoutError: Ut.transitional(Ut.boolean),
        legacyInterceptorReqResOrdering: Ut.transitional(Ut.boolean),
        advertiseZstdAcceptEncoding: Ut.transitional(Ut.boolean),
        validateStatusUndefinedResolves: Ut.transitional(Ut.boolean)
      },
      !1
    ), a != null && (ye.isFunction(a) ? r.paramsSerializer = {
      serialize: a
    } : Zs.assertOptions(
      a,
      {
        encode: Ut.function,
        serialize: Ut.function
      },
      !0
    )), r.allowAbsoluteUrls !== void 0 || (this.defaults.allowAbsoluteUrls !== void 0 ? r.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls : r.allowAbsoluteUrls = !0), Zs.assertOptions(
      r,
      {
        baseUrl: Ut.spelling("baseURL"),
        withXsrfToken: Ut.spelling("withXSRFToken")
      },
      !0
    ), r.method = (r.method || this.defaults.method || "get").toLowerCase();
    let s = o && ye.merge(o.common, o[r.method]);
    o && ye.forEach(["delete", "get", "head", "post", "put", "patch", "query", "common"], (w) => {
      delete o[w];
    }), r.headers = Mt.concat(s, o);
    const l = [];
    let d = !0;
    this.interceptors.request.forEach(function(N) {
      if (typeof N.runWhen == "function" && N.runWhen(r) === !1)
        return;
      d = d && N.synchronous;
      const j = r.transitional || Ly;
      j && j.legacyInterceptorReqResOrdering ? l.unshift(N.fulfilled, N.rejected) : l.push(N.fulfilled, N.rejected);
    });
    const m = [];
    this.interceptors.response.forEach(function(N) {
      m.push(N.fulfilled, N.rejected);
    });
    let u, f = 0, h;
    if (!d) {
      const w = [Iv.bind(this), void 0];
      for (w.unshift(...l), w.push(...m), h = w.length, u = Promise.resolve(r); f < h; )
        u = u.then(w[f++], w[f++]);
      return u;
    }
    h = l.length;
    let v = r;
    for (; f < h; ) {
      const w = l[f++], N = l[f++];
      try {
        v = w(v);
      } catch (j) {
        N.call(this, j);
        break;
      }
    }
    try {
      u = Iv.call(this, v);
    } catch (w) {
      return Promise.reject(w);
    }
    for (f = 0, h = m.length; f < h; )
      u = u.then(m[f++], m[f++]);
    return u;
  }
  getUri(n) {
    n = Wi(this.defaults, n);
    const r = Xw(n.baseURL, n.url, n.allowAbsoluteUrls, n);
    return Kw(r, n.params, n.paramsSerializer);
  }
};
ye.forEach(["delete", "get", "head", "options"], function(n) {
  zi.prototype[n] = function(r, i) {
    return this.request(
      Wi(i || {}, {
        method: n,
        url: r,
        data: i && ye.hasOwnProp(i, "data") ? i.data : void 0
      })
    );
  };
});
ye.forEach(["post", "put", "patch", "query"], function(n) {
  function r(i) {
    return function(o, s, l) {
      return this.request(
        Wi(l || {}, {
          method: n,
          headers: i ? {
            "Content-Type": "multipart/form-data"
          } : {},
          url: o,
          data: s
        })
      );
    };
  }
  zi.prototype[n] = r(), n !== "query" && (zi.prototype[n + "Form"] = r(!0));
});
let zE = class tC {
  constructor(n) {
    if (typeof n != "function")
      throw new TypeError("executor must be a function.");
    let r;
    this.promise = new Promise(function(o) {
      r = o;
    });
    const i = this;
    this.promise.then((a) => {
      if (!i._listeners) return;
      let o = i._listeners.length;
      for (; o-- > 0; )
        i._listeners[o](a);
      i._listeners = null;
    }), this.promise.then = (a) => {
      let o;
      const s = new Promise((l) => {
        i.subscribe(l), o = l;
      }).then(a);
      return s.cancel = function() {
        i.unsubscribe(o);
      }, s;
    }, n(function(o, s, l) {
      i.reason || (i.reason = new es(o, s, l), r(i.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(n) {
    if (this.reason) {
      n(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(n) : this._listeners = [n];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(n) {
    if (!this._listeners)
      return;
    const r = this._listeners.indexOf(n);
    r !== -1 && this._listeners.splice(r, 1);
  }
  toAbortSignal() {
    const n = new AbortController(), r = (i) => {
      n.abort(i);
    };
    return this.subscribe(r), n.signal.unsubscribe = () => this.unsubscribe(r), n.signal;
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let n;
    return {
      token: new tC(function(a) {
        n = a;
      }),
      cancel: n
    };
  }
};
function UE(e) {
  return function(r) {
    return e.apply(null, r);
  };
}
function ME(e) {
  return ye.isObject(e) && e.isAxiosError === !0;
}
const Xh = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511,
  WebServerIsDown: 521,
  ConnectionTimedOut: 522,
  OriginIsUnreachable: 523,
  TimeoutOccurred: 524,
  SslHandshakeFailed: 525,
  InvalidSslCertificate: 526
};
Object.entries(Xh).forEach(([e, n]) => {
  Xh[n] = e;
});
function rC(e) {
  const n = new zi(e), r = Rw(zi.prototype.request, n);
  return ye.extend(r, zi.prototype, n, { allOwnKeys: !0 }), ye.extend(r, n, null, { allOwnKeys: !0 }), r.create = function(a) {
    return rC(Wi(e, a));
  }, r;
}
const St = rC(Zo);
St.Axios = zi;
St.CanceledError = es;
St.CancelToken = zE;
St.isCancel = Jw;
St.VERSION = zy;
St.toFormData = Yl;
St.AxiosError = on;
St.Cancel = St.CanceledError;
St.all = function(n) {
  return Promise.all(n);
};
St.spread = UE;
St.isAxiosError = ME;
St.mergeConfig = Wi;
St.AxiosHeaders = Mt;
St.formToJSON = (e) => Yw(ye.isHTMLForm(e) ? new FormData(e) : e);
St.getAdapter = nC.getAdapter;
St.HttpStatusCode = Xh;
St.default = St;
const {
  Axios: dY,
  AxiosError: uY,
  CanceledError: mY,
  isCancel: pY,
  CancelToken: fY,
  VERSION: hY,
  all: yY,
  Cancel: gY,
  isAxiosError: BE,
  spread: vY,
  toFormData: kY,
  AxiosHeaders: bY,
  HttpStatusCode: _Y,
  formToJSON: xY,
  getAdapter: SY,
  mergeConfig: NY,
  create: jY
} = St;
class qE {
  /** Checks whether the app is running as an electron application. */
  isElectron() {
    return window.electron ? !!window.electron : !!process?.versions?.electron || /electron/i.test(navigator.userAgent);
  }
  /**
   * Gets the electron version.
   *
   * version 0.0.0 represents a unsupported version
   */
  async getVersion() {
    return window.electron ? (await window.electron.getVersion()).split("-")[0] : "0.0.0";
  }
  /** Checks if the running Electron build is a standalone (non auto-updating windows version) */
  async isStandaloneBuild() {
    return window.electron?.isStandaloneBuild ? await window.electron.isStandaloneBuild() : null;
  }
  /** Checks if the running Electron build is installed from an windows MSI installer */
  async isMsiBuild() {
    return window.electron?.isMsiBuild ? await window.electron.isMsiBuild() : null;
  }
}
const Ev = new qE();
function HE(e, n) {
  return Tv(e), Tv(n), e.localeCompare(n, void 0, {
    numeric: !0
  });
}
function Tv(e) {
  if (e.split(".").length !== 3)
    throw Error(`The version '${e}' must be in the format 'x.x.x'.`);
}
const WE = Object.prototype.toString;
function KE(e, n) {
  return WE.call(e) === `[object ${n}]`;
}
function GE(e) {
  return KE(e, "Object");
}
function YE(e) {
  return !!(e && e.then && typeof e.then == "function");
}
const $o = "8.36.0", si = globalThis;
function My(e, n, r) {
  const i = r || si, a = i.__SENTRY__ = i.__SENTRY__ || {}, o = a[$o] = a[$o] || {};
  return o[e] || (o[e] = n());
}
const iC = typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__, JE = "Sentry Logger ", Rv = [
  "debug",
  "info",
  "warn",
  "error",
  "log",
  "assert",
  "trace"
], Dv = {};
function aC(e) {
  if (!("console" in si))
    return e();
  const n = si.console, r = {}, i = Object.keys(Dv);
  i.forEach((a) => {
    const o = Dv[a];
    r[a] = n[a], n[a] = o;
  });
  try {
    return e();
  } finally {
    i.forEach((a) => {
      n[a] = r[a];
    });
  }
}
function QE() {
  let e = !1;
  const n = {
    enable: () => {
      e = !0;
    },
    disable: () => {
      e = !1;
    },
    isEnabled: () => e
  };
  return iC ? Rv.forEach((r) => {
    n[r] = (...i) => {
      e && aC(() => {
        si.console[r](`${JE}[${r}]:`, ...i);
      });
    };
  }) : Rv.forEach((r) => {
    n[r] = () => {
    };
  }), n;
}
const el = My("logger", QE);
function XE(e, n, r) {
  try {
    Object.defineProperty(e, n, {
      // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
      value: r,
      writable: !0,
      configurable: !0
    });
  } catch {
    iC && el.log(`Failed to add non-enumerable property "${n}" to object`, e);
  }
}
const oC = 1e3;
function By() {
  return Date.now() / oC;
}
function ZE() {
  const { performance: e } = si;
  if (!e || !e.now)
    return By;
  const n = Date.now() - e.now(), r = e.timeOrigin == null ? n : e.timeOrigin;
  return () => (r + e.now()) / oC;
}
const eT = ZE();
(() => {
  const { performance: e } = si;
  if (!e || !e.now)
    return;
  const n = 3600 * 1e3, r = e.now(), i = Date.now(), a = e.timeOrigin ? Math.abs(e.timeOrigin + r - i) : n, o = a < n, s = e.timing && e.timing.navigationStart, d = typeof s == "number" ? Math.abs(s + r - i) : n, m = d < n;
  return o || m ? a <= d ? e.timeOrigin : s : i;
})();
function ha() {
  const e = si, n = e.crypto || e.msCrypto;
  let r = () => Math.random() * 16;
  try {
    if (n && n.randomUUID)
      return n.randomUUID().replace(/-/g, "");
    n && n.getRandomValues && (r = () => {
      const i = new Uint8Array(1);
      return n.getRandomValues(i), i[0];
    });
  } catch {
  }
  return ("10000000100040008000" + 1e11).replace(
    /[018]/g,
    (i) => (
      // eslint-disable-next-line no-bitwise
      (i ^ (r() & 15) >> i / 4).toString(16)
    )
  );
}
function Ov() {
  return {
    traceId: ha(),
    spanId: ha().substring(16)
  };
}
function qy() {
  return Hy(si), si;
}
function Hy(e) {
  const n = e.__SENTRY__ = e.__SENTRY__ || {};
  return n.version = n.version || $o, n[$o] = n[$o] || {};
}
function nT(e, n = {}) {
  if (n.user && (!e.ipAddress && n.user.ip_address && (e.ipAddress = n.user.ip_address), !e.did && !n.did && (e.did = n.user.id || n.user.email || n.user.username)), e.timestamp = n.timestamp || eT(), n.abnormal_mechanism && (e.abnormal_mechanism = n.abnormal_mechanism), n.ignoreDuration && (e.ignoreDuration = n.ignoreDuration), n.sid && (e.sid = n.sid.length === 32 ? n.sid : ha()), n.init !== void 0 && (e.init = n.init), !e.did && n.did && (e.did = `${n.did}`), typeof n.started == "number" && (e.started = n.started), e.ignoreDuration)
    e.duration = void 0;
  else if (typeof n.duration == "number")
    e.duration = n.duration;
  else {
    const r = e.timestamp - e.started;
    e.duration = r >= 0 ? r : 0;
  }
  n.release && (e.release = n.release), n.environment && (e.environment = n.environment), !e.ipAddress && n.ipAddress && (e.ipAddress = n.ipAddress), !e.userAgent && n.userAgent && (e.userAgent = n.userAgent), typeof n.errors == "number" && (e.errors = n.errors), n.status && (e.status = n.status);
}
const Zh = "_sentrySpan";
function Pv(e, n) {
  n ? XE(e, Zh, n) : delete e[Zh];
}
function Av(e) {
  return e[Zh];
}
const tT = 100;
class Wy {
  /** Flag if notifying is happening. */
  /** Callback for client to receive scope changes. */
  /** Callback list that will be called during event processing. */
  /** Array of breadcrumbs. */
  /** User */
  /** Tags */
  /** Extra */
  /** Contexts */
  /** Attachments */
  /** Propagation Context for distributed tracing */
  /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */
  /** Fingerprint */
  /** Severity */
  /**
   * Transaction Name
   *
   * IMPORTANT: The transaction name on the scope has nothing to do with root spans/transaction objects.
   * It's purpose is to assign a transaction to the scope that's added to non-transaction events.
   */
  /** Session */
  /** Request Mode Session Status */
  /** The client on this scope */
  /** Contains the last event id of a captured event.  */
  // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
  constructor() {
    this._notifyingListeners = !1, this._scopeListeners = [], this._eventProcessors = [], this._breadcrumbs = [], this._attachments = [], this._user = {}, this._tags = {}, this._extra = {}, this._contexts = {}, this._sdkProcessingMetadata = {}, this._propagationContext = Ov();
  }
  /**
   * @inheritDoc
   */
  clone() {
    const n = new Wy();
    return n._breadcrumbs = [...this._breadcrumbs], n._tags = { ...this._tags }, n._extra = { ...this._extra }, n._contexts = { ...this._contexts }, n._user = this._user, n._level = this._level, n._session = this._session, n._transactionName = this._transactionName, n._fingerprint = this._fingerprint, n._eventProcessors = [...this._eventProcessors], n._requestSession = this._requestSession, n._attachments = [...this._attachments], n._sdkProcessingMetadata = { ...this._sdkProcessingMetadata }, n._propagationContext = { ...this._propagationContext }, n._client = this._client, n._lastEventId = this._lastEventId, Pv(n, Av(this)), n;
  }
  /**
   * @inheritDoc
   */
  setClient(n) {
    this._client = n;
  }
  /**
   * @inheritDoc
   */
  setLastEventId(n) {
    this._lastEventId = n;
  }
  /**
   * @inheritDoc
   */
  getClient() {
    return this._client;
  }
  /**
   * @inheritDoc
   */
  lastEventId() {
    return this._lastEventId;
  }
  /**
   * @inheritDoc
   */
  addScopeListener(n) {
    this._scopeListeners.push(n);
  }
  /**
   * @inheritDoc
   */
  addEventProcessor(n) {
    return this._eventProcessors.push(n), this;
  }
  /**
   * @inheritDoc
   */
  setUser(n) {
    return this._user = n || {
      email: void 0,
      id: void 0,
      ip_address: void 0,
      username: void 0
    }, this._session && nT(this._session, { user: n }), this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getUser() {
    return this._user;
  }
  /**
   * @inheritDoc
   */
  getRequestSession() {
    return this._requestSession;
  }
  /**
   * @inheritDoc
   */
  setRequestSession(n) {
    return this._requestSession = n, this;
  }
  /**
   * @inheritDoc
   */
  setTags(n) {
    return this._tags = {
      ...this._tags,
      ...n
    }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setTag(n, r) {
    return this._tags = { ...this._tags, [n]: r }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setExtras(n) {
    return this._extra = {
      ...this._extra,
      ...n
    }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setExtra(n, r) {
    return this._extra = { ...this._extra, [n]: r }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setFingerprint(n) {
    return this._fingerprint = n, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setLevel(n) {
    return this._level = n, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setTransactionName(n) {
    return this._transactionName = n, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setContext(n, r) {
    return r === null ? delete this._contexts[n] : this._contexts[n] = r, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setSession(n) {
    return n ? this._session = n : delete this._session, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getSession() {
    return this._session;
  }
  /**
   * @inheritDoc
   */
  update(n) {
    if (!n)
      return this;
    const r = typeof n == "function" ? n(this) : n, [i, a] = r instanceof Sa ? [r.getScopeData(), r.getRequestSession()] : GE(r) ? [n, n.requestSession] : [], { tags: o, extra: s, user: l, contexts: d, level: m, fingerprint: u = [], propagationContext: f } = i || {};
    return this._tags = { ...this._tags, ...o }, this._extra = { ...this._extra, ...s }, this._contexts = { ...this._contexts, ...d }, l && Object.keys(l).length && (this._user = l), m && (this._level = m), u.length && (this._fingerprint = u), f && (this._propagationContext = f), a && (this._requestSession = a), this;
  }
  /**
   * @inheritDoc
   */
  clear() {
    return this._breadcrumbs = [], this._tags = {}, this._extra = {}, this._user = {}, this._contexts = {}, this._level = void 0, this._transactionName = void 0, this._fingerprint = void 0, this._requestSession = void 0, this._session = void 0, Pv(this, void 0), this._attachments = [], this._propagationContext = Ov(), this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  addBreadcrumb(n, r) {
    const i = typeof r == "number" ? r : tT;
    if (i <= 0)
      return this;
    const a = {
      timestamp: By(),
      ...n
    }, o = this._breadcrumbs;
    return o.push(a), this._breadcrumbs = o.length > i ? o.slice(-i) : o, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getLastBreadcrumb() {
    return this._breadcrumbs[this._breadcrumbs.length - 1];
  }
  /**
   * @inheritDoc
   */
  clearBreadcrumbs() {
    return this._breadcrumbs = [], this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  addAttachment(n) {
    return this._attachments.push(n), this;
  }
  /**
   * @inheritDoc
   */
  clearAttachments() {
    return this._attachments = [], this;
  }
  /** @inheritDoc */
  getScopeData() {
    return {
      breadcrumbs: this._breadcrumbs,
      attachments: this._attachments,
      contexts: this._contexts,
      tags: this._tags,
      extra: this._extra,
      user: this._user,
      level: this._level,
      fingerprint: this._fingerprint || [],
      eventProcessors: this._eventProcessors,
      propagationContext: this._propagationContext,
      sdkProcessingMetadata: this._sdkProcessingMetadata,
      transactionName: this._transactionName,
      span: Av(this)
    };
  }
  /**
   * @inheritDoc
   */
  setSDKProcessingMetadata(n) {
    return this._sdkProcessingMetadata = { ...this._sdkProcessingMetadata, ...n }, this;
  }
  /**
   * @inheritDoc
   */
  setPropagationContext(n) {
    return this._propagationContext = n, this;
  }
  /**
   * @inheritDoc
   */
  getPropagationContext() {
    return this._propagationContext;
  }
  /**
   * @inheritDoc
   */
  captureException(n, r) {
    const i = r && r.event_id ? r.event_id : ha();
    if (!this._client)
      return el.warn("No client configured on scope - will not capture exception!"), i;
    const a = new Error("Sentry syntheticException");
    return this._client.captureException(
      n,
      {
        originalException: n,
        syntheticException: a,
        ...r,
        event_id: i
      },
      this
    ), i;
  }
  /**
   * @inheritDoc
   */
  captureMessage(n, r, i) {
    const a = i && i.event_id ? i.event_id : ha();
    if (!this._client)
      return el.warn("No client configured on scope - will not capture message!"), a;
    const o = new Error(n);
    return this._client.captureMessage(
      n,
      r,
      {
        originalException: n,
        syntheticException: o,
        ...i,
        event_id: a
      },
      this
    ), a;
  }
  /**
   * @inheritDoc
   */
  captureEvent(n, r) {
    const i = r && r.event_id ? r.event_id : ha();
    return this._client ? (this._client.captureEvent(n, { ...r, event_id: i }, this), i) : (el.warn("No client configured on scope - will not capture event!"), i);
  }
  /**
   * This will be called on every set call.
   */
  _notifyScopeListeners() {
    this._notifyingListeners || (this._notifyingListeners = !0, this._scopeListeners.forEach((n) => {
      n(this);
    }), this._notifyingListeners = !1);
  }
}
const Sa = Wy;
function rT() {
  return My("defaultCurrentScope", () => new Sa());
}
function iT() {
  return My("defaultIsolationScope", () => new Sa());
}
class aT {
  constructor(n, r) {
    let i;
    n ? i = n : i = new Sa();
    let a;
    r ? a = r : a = new Sa(), this._stack = [{ scope: i }], this._isolationScope = a;
  }
  /**
   * Fork a scope for the stack.
   */
  withScope(n) {
    const r = this._pushScope();
    let i;
    try {
      i = n(r);
    } catch (a) {
      throw this._popScope(), a;
    }
    return YE(i) ? i.then(
      (a) => (this._popScope(), a),
      (a) => {
        throw this._popScope(), a;
      }
    ) : (this._popScope(), i);
  }
  /**
   * Get the client of the stack.
   */
  getClient() {
    return this.getStackTop().client;
  }
  /**
   * Returns the scope of the top stack.
   */
  getScope() {
    return this.getStackTop().scope;
  }
  /**
   * Get the isolation scope for the stack.
   */
  getIsolationScope() {
    return this._isolationScope;
  }
  /**
   * Returns the topmost scope layer in the order domain > local > process.
   */
  getStackTop() {
    return this._stack[this._stack.length - 1];
  }
  /**
   * Push a scope to the stack.
   */
  _pushScope() {
    const n = this.getScope().clone();
    return this._stack.push({
      client: this.getClient(),
      scope: n
    }), n;
  }
  /**
   * Pop a scope from the stack.
   */
  _popScope() {
    return this._stack.length <= 1 ? !1 : !!this._stack.pop();
  }
}
function Na() {
  const e = qy(), n = Hy(e);
  return n.stack = n.stack || new aT(rT(), iT());
}
function oT(e) {
  return Na().withScope(e);
}
function sT(e, n) {
  const r = Na();
  return r.withScope(() => (r.getStackTop().scope = e, n(e)));
}
function Lv(e) {
  return Na().withScope(() => e(Na().getIsolationScope()));
}
function lT() {
  return {
    withIsolationScope: Lv,
    withScope: oT,
    withSetScope: sT,
    withSetIsolationScope: (e, n) => Lv(n),
    getCurrentScope: () => Na().getScope(),
    getIsolationScope: () => Na().getIsolationScope()
  };
}
function sC(e) {
  const n = Hy(e);
  return n.acs ? n.acs : lT();
}
function Ky() {
  const e = qy();
  return sC(e).getCurrentScope();
}
function lC() {
  const e = qy();
  return sC(e).getIsolationScope();
}
function cT() {
  return Ky().getClient();
}
function dT(e) {
  if (e)
    return uT(e) ? { captureContext: e } : pT(e) ? {
      captureContext: e
    } : e;
}
function uT(e) {
  return e instanceof Sa || typeof e == "function";
}
const mT = [
  "user",
  "level",
  "extra",
  "contexts",
  "tags",
  "fingerprint",
  "requestSession",
  "propagationContext"
];
function pT(e) {
  return Object.keys(e).some((n) => mT.includes(n));
}
function Vv(e, n) {
  return Ky().captureException(e, dT(n));
}
function fT(e, n) {
  const r = typeof n == "string" ? n : void 0, i = typeof n != "string" ? { captureContext: n } : void 0;
  return Ky().captureMessage(e, r, i);
}
function hT(e, n) {
  lC().setContext(e, n);
}
const yT = 100;
function Di(e, n) {
  const r = cT(), i = lC();
  if (!r) return;
  const { beforeBreadcrumb: a = null, maxBreadcrumbs: o = yT } = r.getOptions();
  if (o <= 0) return;
  const l = { timestamp: By(), ...e }, d = a ? aC(() => a(l, n)) : l;
  d !== null && (r.emit && r.emit("beforeAddBreadcrumb", d, n), i.addBreadcrumb(d, o));
}
var Bo;
(function(e) {
  e.Unknown = "unknown", e.Core = "core", e.Routing = "routing-and-presence", e.Insights = "insights", e.Ecosystem = "ecosystem", e.Partners = "partners", e.Channels = "channels", e.Messaging = "messaging", e.Platform = "platform", e.AI = "ai", e.Conversations = "conversations", e.Automation = "automation";
})(Bo || (Bo = {}));
function ya(e) {
  const n = e.split(".")[1];
  if (!n)
    throw Error("Invalid token");
  const r = n.replace(/-/g, "+").replace(/_/g, "/");
  try {
    return JSON.parse(Buffer.from(r, "base64").toString());
  } catch (i) {
    throw Error(`Failed to parse the JSON Web Token with the following error: ${i}`);
  }
}
const gT = Uo.backendDomain ? {
  "backend-domain": Uo.backendDomain
} : void 0;
function nl() {
  const e = new URLSearchParams({
    noToken: "true",
    ...gT
  }).toString();
  document.location.href = `${Uo.url.logIn}?${e}`;
}
const Cc = "authData", Fc = 30, vT = 600, Ic = 5;
class kT {
  authData = null;
  /** The (server) time when the access token expires, in seconds. */
  accessTokenExpiresAt = 0;
  /**
   * The difference between client- and server-time, in seconds. Negative if
   * client is ahead of server, positive if server is ahead of client
   */
  clientServerTimeDiff = 0;
  /**
   * Returns an estimated server time (unix epoch in seconds) by adding the
   * client-server time difference to the current client time.
   *
   * The time-diff is stored whenever a new access token is saved.
   *
   * @returns {number} The estimated server time in seconds.
   */
  estimatedServerTime() {
    const n = Date.now() / 1e3;
    return this.clientServerTimeDiff >= Ic || this.clientServerTimeDiff <= -Ic ? Math.ceil(n + this.clientServerTimeDiff) : Math.ceil(n);
  }
  /**
   * Sets the auth data in localStorage.
   *
   * @param authData The auth data.
   */
  setAuthData(n) {
    this.authData = n;
    const i = Math.ceil(Date.now() / 1e3) + vT, a = ya(n.access_token).exp;
    if (this.clientServerTimeDiff = a - i, process.env.NODE_ENV !== "test" && Math.abs(this.clientServerTimeDiff) > Ic) {
      const o = this.clientServerTimeDiff > 0 ? "behind" : "ahead";
      console.info(`Client time is ${o} by significant amount. (${Math.abs(this.clientServerTimeDiff)}s)`);
    }
    this.accessTokenExpiresAt = a, localStorage.setItem(Cc, JSON.stringify(n));
  }
  /** Gets the auth data from memory or localStorage. */
  getAuthData() {
    if (this.authData)
      return this.authData;
    const n = localStorage.getItem(Cc), r = n ? JSON.parse(n) : null;
    return this.validateAuthDataComplete(r) && (this.authData = r), r;
  }
  /** Removes the auth data from localStorage. */
  removeAuthData() {
    this.authData = null, localStorage.removeItem(Cc);
  }
  getAccessToken() {
    return this.authData?.access_token || null;
  }
  getRefreshToken() {
    return this.authData?.refresh_token || null;
  }
  /**
   * Validates that the auth data is complete - i.e not fragmented.
   *
   * @param authData The auth data.
   */
  validateAuthDataComplete(n) {
    return n ? [
      "access_token",
      "refresh_token",
      "expires_in"
    ].every((i) => typeof n[i] < "u") : !1;
  }
  isAccessTokenExpired() {
    if (!this.getAccessToken())
      return !0;
    const r = this.accessTokenExpiresAt - Fc;
    return this.estimatedServerTime() >= r;
  }
  isRefreshTokenExpired(n) {
    if (!n)
      return !0;
    const r = ya(n), i = r.exp - Fc;
    return !r || this.estimatedServerTime() >= i;
  }
  accessTokenExpiresInMs() {
    return (this.accessTokenExpiresAt - Fc - this.estimatedServerTime()) * 1e3;
  }
}
const Tt = new kT();
async function bT(e) {
  const n = window.location.origin.replace(/^https?:\/\//, ""), r = ["localhost:8080", "uptrends-monitor"];
  if (!(!e.response || r.some((i) => n.includes(i)))) {
    try {
      const i = e.response.config.headers.Authorization ?? "", a = i ? i.toString()?.split("Basic ")[1] : "", o = a ? atob(a).split("token:")[1] : "", s = o ? ya(o).exp : "None", l = await Ql.getAuthData({ localStorageOnly: !0 }), d = Math.floor(Date.now() / 1e3), m = l?.access_token, u = l?.refresh_token, f = m ? ya(m).exp : "None", h = u ? ya(u).exp : "None", v = typeof s == "number" ? d - s : "Unknown", w = typeof f == "number" ? d - f : "Unknown", N = typeof h == "number" ? d - h : "Unknown", j = e.response.headers["x-dixa-rid"];
      hT("Expires", {
        currentTimestamp: d,
        accessTokenFromHeader: s,
        accessTokenFromHeaderDiff: v,
        accessTokenFromLocalStorage: f,
        accessTokenFromLocalStorageDiff: w,
        refreshTokenFromLocalStorage: h,
        refreshTokenFromLocalStorageDiff: N,
        xDixaRid: j,
        navigatorOnline: navigator.onLine
      });
    } catch (i) {
      console.error("Error adding Sentry error context", i);
    }
    fT("401 unauthorized interceptor", {
      level: "debug",
      tags: {
        team: Bo.Platform,
        domain: n
      }
    });
  }
}
const $c = /* @__PURE__ */ new Map(), _T = 3;
function xT(e) {
  e.interceptors.response.use((n) => ($c.delete(n.config.url), n), (n) => {
    if (n.response) {
      const { status: r } = n.response;
      switch (r) {
        case ey.Unauthorized:
          if (!Ql.isRefreshTokenExpired() && n.config) {
            Di({
              category: "errorInterceptor",
              message: "Access token expired after request",
              level: "debug"
            });
            const i = $c.get(n.config.url) ?? 0;
            if (console.log(`Retrying request (${i + 1}): ${n.config.url}`), i <= _T)
              return $c.set(n.config.url, i + 1), e(n.config);
          }
          bT(n), console.error("401 unauthorized interceptor"), nl();
          break;
      }
    }
    return Promise.reject(n);
  });
}
const cC = St.create();
xT(cC);
const Zr = console.log;
async function zv(e) {
  return new Promise((n) => setTimeout(n, e * 1e3));
}
class ST extends Error {
  constructor(n, r) {
    super(n, r);
  }
}
function NT(e = 0) {
  return Math.min(Math.round((Math.random() + 1) * Math.pow(1.5, e)), 30);
}
const jT = 5;
class wT {
  authDataPromise = null;
  retryCount = 0;
  async init(n) {
    const r = await this.refresh(n);
    if (r)
      Tt.setAuthData(r);
    else {
      const i = Tt.isRefreshTokenExpired(n) ? "expired" : "unknown";
      throw new ST("Failed to init refresh token", {
        cause: i
      });
    }
  }
  getDebugInfo() {
    const n = Tt.getAccessToken();
    if (!n)
      return {};
    const r = ya(n), { exp: i } = r;
    return {
      expire: i ? new Date(i * 1e3).toISOString() : null,
      now: (/* @__PURE__ */ new Date()).toISOString()
    };
  }
  /**
   * Gets auth data from LocalStorage, or fetches new auth data if the current
   * token is expired or is about to expire.
   */
  async getAuthData({ localStorageOnly: n = !1 } = {}) {
    if (n)
      return Tt.getAuthData();
    if (this.authDataPromise)
      return await this.authDataPromise;
    const r = Tt.getAuthData();
    return r ? Tt.isAccessTokenExpired() ? (Di({
      category: "refreshToken",
      // Cannot include "token" in the message, as it will be redacted
      message: "expired or about to expire",
      level: "debug",
      data: this.getDebugInfo()
    }), this.authDataPromise = this.refresh(r.refresh_token).then((i) => (i && Tt.setAuthData(i), this.authDataPromise = null, i)), await this.authDataPromise) : r : null;
  }
  removeAuthData() {
    return Tt.removeAuthData();
  }
  validateAuthDataComplete(n) {
    return Tt.validateAuthDataComplete(n);
  }
  isAccessTokenExpired() {
    return Tt.isAccessTokenExpired();
  }
  isRefreshTokenExpired() {
    const n = Tt.getAuthData();
    return n ? Tt.isRefreshTokenExpired(n.refresh_token) : !0;
  }
  /** Checks whether refresh token is supported. */
  async isSupported() {
    if (!Ev.isElectron())
      return !0;
    const n = await Ev.getVersion();
    return HE(n, "3.7.0") === 1;
  }
  /**
   * Gets refreshed tokens from the API
   *
   * @param refreshToken The refresh token.
   * @param retriesLeft The number of retries left.
   */
  async refresh(n, r = jT) {
    try {
      return await cC.post(`${Uo.url.rest}/v2/login/refresh`, {
        refreshToken: n
      }).then((i) => (this.retryCount = 0, i.data.data));
    } catch (i) {
      return await this.handleRefreshError(i, n, r);
    }
  }
  async waitUntilOnline() {
    const n = navigator.onLine === !1;
    for (n && (Zr("AUTH", "Network connection offline - waiting..."), Di({
      category: "refreshToken",
      message: "Network connection offline - waiting...",
      level: "debug"
    })); navigator.onLine === !1; )
      await zv(5);
    n && (Zr("AUTH", "Network connection restored"), Di({
      category: "refreshToken",
      message: "Network connection restored",
      level: "debug"
    }));
  }
  async retryRefresh(n, r) {
    await this.waitUntilOnline(), this.retryCount++;
    const i = NT(this.retryCount);
    return Zr("AUTH", `Retrying in ${i} seconds`), await zv(i), await this.refresh(n, r);
  }
  async handleRefreshError(n, r, i) {
    if (Tt.isRefreshTokenExpired(r))
      return Zr("AUTH", "Refresh token expired"), Di({
        category: "refreshToken",
        message: "Refresh token expired",
        level: "debug"
      }), Tt.removeAuthData(), nl(), null;
    if (BE(n)) {
      if (n.message === "timeout exceeded")
        return Zr("AUTH", "Timeout exceeded"), Di({
          category: "refreshToken",
          message: "Timeout exceeded",
          level: "debug"
        }), await this.retryRefresh(r, i);
      if (n.message === "Network Error")
        return Zr("AUTH", "Network error"), Di({
          category: "refreshToken",
          message: "Network error",
          level: "debug"
        }), await this.retryRefresh(r, i);
      if (n.response?.status === 401)
        return Zr("AUTH", "Refresh token invalid (401)"), Tt.removeAuthData(), nl(), null;
      Vv(n, {
        level: "error",
        tags: {
          team: Bo.Platform,
          errorSource: "authManager.refresh"
        }
      });
    }
    return i <= 0 ? (Zr("AUTH", "Retries exhausted, logging out"), Vv(n, {
      level: "error",
      tags: {
        team: Bo.Platform,
        errorSource: "authManager.refresh"
      }
    }), Tt.removeAuthData(), nl(), null) : (Zr("AUTH", `Retrying ${i} more times`), await this.retryRefresh(r, i - 1));
  }
  accessTokenExpiresInMs() {
    return Tt.accessTokenExpiresInMs();
  }
}
const Ql = new wT();
var ey;
(function(e) {
  e[e.BadRequest = 400] = "BadRequest", e[e.Unauthorized = 401] = "Unauthorized", e[e.Forbidden = 403] = "Forbidden", e[e.NotFound = 404] = "NotFound", e[e.Conflict = 409] = "Conflict", e[e.InternalServerError = 500] = "InternalServerError", e[e.BadGateway = 502] = "BadGateway", e[e.ServiceUnavailable = 503] = "ServiceUnavailable";
})(ey || (ey = {}));
const CT = new Ry((e, n) => new $w((r) => {
  Ql.getAuthData().then((i) => {
    const a = i?.access_token, o = e.getContext().headers;
    return e.setContext({
      ...o,
      headers: {
        Authorization: a ? `Bearer ${a}` : ""
      }
    }), n(e).subscribe(r);
  }).catch((i) => r.error(i));
})), FT = new Ry(
  (e, n) => new $w((r) => {
    const i = e.getContext(), { headers: a, widgetId: o, widgetType: s, operationName: l } = i;
    Ql.getAuthData().then((d) => (e.setContext({
      ...i,
      headers: {
        ...a,
        ...o && { "x-integration-widget-id": o },
        ...s && { "x-integration-widget-type": s },
        ...l && {
          "x-integration-widget-operation": l
        },
        ...cI(Uo.url.partnerIntegrations) && d?.access_token && dI(d.access_token)
      }
    }), n(e).subscribe(r))).catch((d) => r.error(d));
  })
), IT = new AbortController(), dC = (e) => new DI({
  queryDeduplication: !1,
  cache: new OI(),
  link: Ry.from([
    CT,
    FT,
    PI({
      uri: `${e}/graphql`,
      fetch: zI,
      fetchOptions: {
        mode: "cors",
        // The `AbortSignal` object instance is used to communicate with a
        // fetch request and abort it if desired via an `AbortController`.
        // This prevents abandoned abort errors spiral up to Sentry.
        signal: IT.signal
      }
    })
  ]),
  defaultOptions: {
    watchQuery: {
      fetchPolicy: "no-cache",
      errorPolicy: "all"
    },
    query: {
      fetchPolicy: "no-cache",
      errorPolicy: "all"
    },
    mutate: {
      fetchPolicy: "no-cache",
      errorPolicy: "all"
    }
  }
}), $T = ({
  configuration: e,
  children: n
}) => {
  const r = Zn(
    () => dC(e.baseUrl),
    [e.baseUrl]
  );
  return /* @__PURE__ */ Xn.jsx(AI, { client: r, children: n });
};
function ET() {
  try {
    return LI(), !0;
  } catch {
    return !1;
  }
}
const TT = ({
  configuration: e,
  children: n
}) => ET() ? n : /* @__PURE__ */ Xn.jsx($T, { configuration: e, children: n }), RT = ({
  integrationId: e,
  type: n,
  showNotification: r,
  showModal: i,
  children: a
}) => /* @__PURE__ */ Xn.jsx(VI, { children: (o) => /* @__PURE__ */ Xn.jsx(
  uI,
  {
    value: {
      useMutation: hI(e, n),
      useQuery: fI(e, n),
      useLazyQuery: pI(e, n),
      executeQuery: mI(e, n, o),
      showNotification: r,
      showModal: i ?? (() => null)
    },
    children: a
  }
) }), uC = ({
  integrationId: e,
  type: n,
  configuration: r,
  showNotification: i,
  showModal: a,
  children: o
}) => {
  const s = !!e && !!n;
  return /* @__PURE__ */ Xn.jsx(TT, { configuration: r, children: s ? /* @__PURE__ */ Xn.jsx(
    RT,
    {
      integrationId: e,
      type: n,
      showNotification: i,
      showModal: a,
      children: o
    }
  ) : o });
}, mC = $y(
  () => {
  }
), DT = () => ql(mC), OT = ({
  children: e
}) => {
  const [n, r] = me(!1), i = {
    headline: "",
    text: "",
    onConfirm: () => r(!1),
    confirmLabel: "Confirm",
    confirmVariant: "primary"
  }, [a, o] = me(i), s = (d) => {
    r(!0), o(d);
  }, l = () => {
    r(!1), o(i);
  };
  return /* @__PURE__ */ Xn.jsxs(mC.Provider, { value: s, children: [
    e,
    /* @__PURE__ */ Xn.jsx(
      yI,
      {
        isOpen: n,
        setIsOpen: r,
        headline: a.headline,
        text: a.text,
        confirmLabel: a.confirmLabel,
        confirmVariant: a.confirmVariant,
        cancelLabel: a.cancelLabel,
        cancelVariant: a.cancelVariant,
        onConfirm: a.onConfirm ? () => {
          try {
            a.onConfirm && a.onConfirm();
          } finally {
            l();
          }
        } : void 0,
        onCancel: a.onCancel ? () => {
          try {
            a.onCancel && a.onCancel();
          } finally {
            l();
          }
        } : void 0,
        children: a.children
      }
    )
  ] });
}, PT = "_unmatchedHeader_qcj19_1", AT = {
  unmatchedHeader: PT
};
var ns = (e) => e.type === "checkbox", Li = (e) => e instanceof Date, Yt = (e) => e == null;
const pC = (e) => typeof e == "object";
var _t = (e) => !Yt(e) && !Array.isArray(e) && pC(e) && !Li(e), fC = (e) => _t(e) && e.target ? ns(e.target) ? e.target.checked : e.target.value : e, LT = (e) => e.substring(0, e.search(/\.\d+(\.|$)/)) || e, hC = (e, n) => e.has(LT(n)), VT = (e) => {
  const n = e.constructor && e.constructor.prototype;
  return _t(n) && n.hasOwnProperty("isPrototypeOf");
}, Gy = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function Ot(e) {
  let n;
  const r = Array.isArray(e), i = typeof FileList < "u" ? e instanceof FileList : !1;
  if (e instanceof Date)
    n = new Date(e);
  else if (e instanceof Set)
    n = new Set(e);
  else if (!(Gy && (e instanceof Blob || i)) && (r || _t(e)))
    if (n = r ? [] : {}, !r && !VT(e))
      n = e;
    else
      for (const a in e)
        e.hasOwnProperty(a) && (n[a] = Ot(e[a]));
  else
    return e;
  return n;
}
var Xl = (e) => Array.isArray(e) ? e.filter(Boolean) : [], kt = (e) => e === void 0, nn = (e, n, r) => {
  if (!n || !_t(e))
    return r;
  const i = Xl(n.split(/[,[\].]+?/)).reduce((a, o) => Yt(a) ? a : a[o], e);
  return kt(i) || i === e ? kt(e[n]) ? r : e[n] : i;
}, lr = (e) => typeof e == "boolean", Yy = (e) => /^\w*$/.test(e), yC = (e) => Xl(e.replace(/["|']|\]/g, "").split(/\.|\[/)), it = (e, n, r) => {
  let i = -1;
  const a = Yy(n) ? [n] : yC(n), o = a.length, s = o - 1;
  for (; ++i < o; ) {
    const l = a[i];
    let d = r;
    if (i !== s) {
      const m = e[l];
      d = _t(m) || Array.isArray(m) ? m : isNaN(+a[i + 1]) ? {} : [];
    }
    if (l === "__proto__" || l === "constructor" || l === "prototype")
      return;
    e[l] = d, e = e[l];
  }
};
const yl = {
  BLUR: "blur",
  FOCUS_OUT: "focusout",
  CHANGE: "change"
}, wr = {
  onBlur: "onBlur",
  onChange: "onChange",
  onSubmit: "onSubmit",
  onTouched: "onTouched",
  all: "all"
}, ei = {
  max: "max",
  min: "min",
  maxLength: "maxLength",
  minLength: "minLength",
  pattern: "pattern",
  required: "required",
  validate: "validate"
}, gC = He.createContext(null), Or = () => He.useContext(gC), Jy = (e) => {
  const { children: n, ...r } = e;
  return He.createElement(gC.Provider, { value: r }, n);
};
var vC = (e, n, r, i = !0) => {
  const a = {
    defaultValues: n._defaultValues
  };
  for (const o in e)
    Object.defineProperty(a, o, {
      get: () => {
        const s = o;
        return n._proxyFormState[s] !== wr.all && (n._proxyFormState[s] = !i || wr.all), r && (r[s] = !0), e[s];
      }
    });
  return a;
};
function zT(e) {
  const n = Or(), { control: r = n.control, disabled: i, name: a, exact: o } = e || {}, [s, l] = He.useState(r._formState), d = He.useRef({
    isDirty: !1,
    isLoading: !1,
    dirtyFields: !1,
    touchedFields: !1,
    validatingFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }), m = He.useRef(a);
  return m.current = a, He.useEffect(() => r._subscribe({
    name: m.current,
    formState: d.current,
    exact: o,
    callback: (u) => {
      !i && l({
        ...r._formState,
        ...u
      });
    }
  }), [r, i, o]), He.useEffect(() => {
    d.current.isValid && r._setValid(!0);
  }, [r]), He.useMemo(() => vC(s, r, d.current, !1), [s, r]);
}
var qr = (e) => typeof e == "string", kC = (e, n, r, i, a) => qr(e) ? (i && n.watch.add(e), nn(r, e, a)) : Array.isArray(e) ? e.map((o) => (i && n.watch.add(o), nn(r, o))) : (i && (n.watchAll = !0), r);
function ki(e) {
  const n = Or(), { control: r = n.control, name: i, defaultValue: a, disabled: o, exact: s } = e || {}, l = He.useRef(i), d = He.useRef(a);
  l.current = i, He.useEffect(() => r._subscribe({
    name: l.current,
    formState: {
      values: !0
    },
    exact: s,
    callback: (f) => !o && u(kC(l.current, r._names, f.values || r._formValues, !1, d.current))
  }), [r, o, s]);
  const [m, u] = He.useState(r._getWatch(i, a));
  return He.useEffect(() => r._removeUnmounted()), m;
}
function Qy(e) {
  const n = Or(), { name: r, disabled: i, control: a = n.control, shouldUnregister: o } = e, s = hC(a._names.array, r), l = ki({
    control: a,
    name: r,
    defaultValue: nn(a._formValues, r, nn(a._defaultValues, r, e.defaultValue)),
    exact: !0
  }), d = zT({
    control: a,
    name: r,
    exact: !0
  }), m = He.useRef(e), u = He.useRef(a.register(r, {
    ...e.rules,
    value: l,
    ...lr(e.disabled) ? { disabled: e.disabled } : {}
  })), f = He.useMemo(() => Object.defineProperties({}, {
    invalid: {
      enumerable: !0,
      get: () => !!nn(d.errors, r)
    },
    isDirty: {
      enumerable: !0,
      get: () => !!nn(d.dirtyFields, r)
    },
    isTouched: {
      enumerable: !0,
      get: () => !!nn(d.touchedFields, r)
    },
    isValidating: {
      enumerable: !0,
      get: () => !!nn(d.validatingFields, r)
    },
    error: {
      enumerable: !0,
      get: () => nn(d.errors, r)
    }
  }), [d, r]), h = He.useCallback((j) => u.current.onChange({
    target: {
      value: fC(j),
      name: r
    },
    type: yl.CHANGE
  }), [r]), v = He.useCallback(() => u.current.onBlur({
    target: {
      value: nn(a._formValues, r),
      name: r
    },
    type: yl.BLUR
  }), [r, a._formValues]), w = He.useCallback((j) => {
    const _ = nn(a._fields, r);
    _ && j && (_._f.ref = {
      focus: () => j.focus(),
      select: () => j.select(),
      setCustomValidity: (g) => j.setCustomValidity(g),
      reportValidity: () => j.reportValidity()
    });
  }, [a._fields, r]), N = He.useMemo(() => ({
    name: r,
    value: l,
    ...lr(i) || d.disabled ? { disabled: d.disabled || i } : {},
    onChange: h,
    onBlur: v,
    ref: w
  }), [r, i, d.disabled, h, v, w, l]);
  return He.useEffect(() => {
    const j = a._options.shouldUnregister || o;
    a.register(r, {
      ...m.current.rules,
      ...lr(m.current.disabled) ? { disabled: m.current.disabled } : {}
    });
    const _ = (g, O) => {
      const R = nn(a._fields, g);
      R && R._f && (R._f.mount = O);
    };
    if (_(r, !0), j) {
      const g = Ot(nn(a._options.defaultValues, r));
      it(a._defaultValues, r, g), kt(nn(a._formValues, r)) && it(a._formValues, r, g);
    }
    return !s && a.register(r), () => {
      (s ? j && !a._state.action : j) ? a.unregister(r) : _(r, !1);
    };
  }, [r, a, s, o]), He.useEffect(() => {
    a._setDisabledField({
      disabled: i,
      name: r
    });
  }, [i, r, a]), He.useMemo(() => ({
    field: N,
    formState: d,
    fieldState: f
  }), [N, d, f]);
}
const jt = (e) => e.render(Qy(e));
var UT = (e, n, r, i, a) => n ? {
  ...r[e],
  types: {
    ...r[e] && r[e].types ? r[e].types : {},
    [i]: a || !0
  }
} : {}, Eo = (e) => Array.isArray(e) ? e : [e], Uv = () => {
  let e = [];
  return {
    get observers() {
      return e;
    },
    next: (a) => {
      for (const o of e)
        o.next && o.next(a);
    },
    subscribe: (a) => (e.push(a), {
      unsubscribe: () => {
        e = e.filter((o) => o !== a);
      }
    }),
    unsubscribe: () => {
      e = [];
    }
  };
}, ny = (e) => Yt(e) || !pC(e);
function yi(e, n) {
  if (ny(e) || ny(n))
    return e === n;
  if (Li(e) && Li(n))
    return e.getTime() === n.getTime();
  const r = Object.keys(e), i = Object.keys(n);
  if (r.length !== i.length)
    return !1;
  for (const a of r) {
    const o = e[a];
    if (!i.includes(a))
      return !1;
    if (a !== "ref") {
      const s = n[a];
      if (Li(o) && Li(s) || _t(o) && _t(s) || Array.isArray(o) && Array.isArray(s) ? !yi(o, s) : o !== s)
        return !1;
    }
  }
  return !0;
}
var Kt = (e) => _t(e) && !Object.keys(e).length, Xy = (e) => e.type === "file", Cr = (e) => typeof e == "function", gl = (e) => {
  if (!Gy)
    return !1;
  const n = e ? e.ownerDocument : 0;
  return e instanceof (n && n.defaultView ? n.defaultView.HTMLElement : HTMLElement);
}, bC = (e) => e.type === "select-multiple", Zy = (e) => e.type === "radio", MT = (e) => Zy(e) || ns(e), Ec = (e) => gl(e) && e.isConnected;
function BT(e, n) {
  const r = n.slice(0, -1).length;
  let i = 0;
  for (; i < r; )
    e = kt(e) ? i++ : e[n[i++]];
  return e;
}
function qT(e) {
  for (const n in e)
    if (e.hasOwnProperty(n) && !kt(e[n]))
      return !1;
  return !0;
}
function Ct(e, n) {
  const r = Array.isArray(n) ? n : Yy(n) ? [n] : yC(n), i = r.length === 1 ? e : BT(e, r), a = r.length - 1, o = r[a];
  return i && delete i[o], a !== 0 && (_t(i) && Kt(i) || Array.isArray(i) && qT(i)) && Ct(e, r.slice(0, -1)), e;
}
var _C = (e) => {
  for (const n in e)
    if (Cr(e[n]))
      return !0;
  return !1;
};
function vl(e, n = {}) {
  const r = Array.isArray(e);
  if (_t(e) || r)
    for (const i in e)
      Array.isArray(e[i]) || _t(e[i]) && !_C(e[i]) ? (n[i] = Array.isArray(e[i]) ? [] : {}, vl(e[i], n[i])) : Yt(e[i]) || (n[i] = !0);
  return n;
}
function xC(e, n, r) {
  const i = Array.isArray(e);
  if (_t(e) || i)
    for (const a in e)
      Array.isArray(e[a]) || _t(e[a]) && !_C(e[a]) ? kt(n) || ny(r[a]) ? r[a] = Array.isArray(e[a]) ? vl(e[a], []) : { ...vl(e[a]) } : xC(e[a], Yt(n) ? {} : n[a], r[a]) : r[a] = !yi(e[a], n[a]);
  return r;
}
var Ha = (e, n) => xC(e, n, vl(n));
const Mv = {
  value: !1,
  isValid: !1
}, Bv = { value: !0, isValid: !0 };
var SC = (e) => {
  if (Array.isArray(e)) {
    if (e.length > 1) {
      const n = e.filter((r) => r && r.checked && !r.disabled).map((r) => r.value);
      return { value: n, isValid: !!n.length };
    }
    return e[0].checked && !e[0].disabled ? (
      // @ts-expect-error expected to work in the browser
      e[0].attributes && !kt(e[0].attributes.value) ? kt(e[0].value) || e[0].value === "" ? Bv : { value: e[0].value, isValid: !0 } : Bv
    ) : Mv;
  }
  return Mv;
}, NC = (e, { valueAsNumber: n, valueAsDate: r, setValueAs: i }) => kt(e) ? e : n ? e === "" ? NaN : e && +e : r && qr(e) ? new Date(e) : i ? i(e) : e;
const qv = {
  isValid: !1,
  value: null
};
var jC = (e) => Array.isArray(e) ? e.reduce((n, r) => r && r.checked && !r.disabled ? {
  isValid: !0,
  value: r.value
} : n, qv) : qv;
function Hv(e) {
  const n = e.ref;
  return Xy(n) ? n.files : Zy(n) ? jC(e.refs).value : bC(n) ? [...n.selectedOptions].map(({ value: r }) => r) : ns(n) ? SC(e.refs).value : NC(kt(n.value) ? e.ref.value : n.value, e);
}
var HT = (e, n, r, i) => {
  const a = {};
  for (const o of e) {
    const s = nn(n, o);
    s && it(a, o, s._f);
  }
  return {
    criteriaMode: r,
    names: [...e],
    fields: a,
    shouldUseNativeValidation: i
  };
}, kl = (e) => e instanceof RegExp, Wa = (e) => kt(e) ? e : kl(e) ? e.source : _t(e) ? kl(e.value) ? e.value.source : e.value : e, Wv = (e) => ({
  isOnSubmit: !e || e === wr.onSubmit,
  isOnBlur: e === wr.onBlur,
  isOnChange: e === wr.onChange,
  isOnAll: e === wr.all,
  isOnTouch: e === wr.onTouched
});
const Kv = "AsyncFunction";
var WT = (e) => !!e && !!e.validate && !!(Cr(e.validate) && e.validate.constructor.name === Kv || _t(e.validate) && Object.values(e.validate).find((n) => n.constructor.name === Kv)), KT = (e) => e.mount && (e.required || e.min || e.max || e.maxLength || e.minLength || e.pattern || e.validate), Gv = (e, n, r) => !r && (n.watchAll || n.watch.has(e) || [...n.watch].some((i) => e.startsWith(i) && /^\.\w+/.test(e.slice(i.length))));
const To = (e, n, r, i) => {
  for (const a of r || Object.keys(e)) {
    const o = nn(e, a);
    if (o) {
      const { _f: s, ...l } = o;
      if (s) {
        if (s.refs && s.refs[0] && n(s.refs[0], a) && !i)
          return !0;
        if (s.ref && n(s.ref, s.name) && !i)
          return !0;
        if (To(l, n))
          break;
      } else if (_t(l) && To(l, n))
        break;
    }
  }
};
function Yv(e, n, r) {
  const i = nn(e, r);
  if (i || Yy(r))
    return {
      error: i,
      name: r
    };
  const a = r.split(".");
  for (; a.length; ) {
    const o = a.join("."), s = nn(n, o), l = nn(e, o);
    if (s && !Array.isArray(s) && r !== o)
      return { name: r };
    if (l && l.type)
      return {
        name: o,
        error: l
      };
    a.pop();
  }
  return {
    name: r
  };
}
var GT = (e, n, r, i) => {
  r(e);
  const { name: a, ...o } = e;
  return Kt(o) || Object.keys(o).length >= Object.keys(n).length || Object.keys(o).find((s) => n[s] === (!i || wr.all));
}, YT = (e, n, r) => !e || !n || e === n || Eo(e).some((i) => i && (r ? i === n : i.startsWith(n) || n.startsWith(i))), JT = (e, n, r, i, a) => a.isOnAll ? !1 : !r && a.isOnTouch ? !(n || e) : (r ? i.isOnBlur : a.isOnBlur) ? !e : (r ? i.isOnChange : a.isOnChange) ? e : !0, QT = (e, n) => !Xl(nn(e, n)).length && Ct(e, n), XT = (e, n, r) => {
  const i = Eo(nn(e, r));
  return it(i, "root", n[r]), it(e, r, i), e;
}, tl = (e) => qr(e);
function Jv(e, n, r = "validate") {
  if (tl(e) || Array.isArray(e) && e.every(tl) || lr(e) && !e)
    return {
      type: r,
      message: tl(e) ? e : "",
      ref: n
    };
}
var na = (e) => _t(e) && !kl(e) ? e : {
  value: e,
  message: ""
}, Qv = async (e, n, r, i, a, o) => {
  const { ref: s, refs: l, required: d, maxLength: m, minLength: u, min: f, max: h, pattern: v, validate: w, name: N, valueAsNumber: j, mount: _ } = e._f, g = nn(r, N);
  if (!_ || n.has(N))
    return {};
  const O = l ? l[0] : s, R = (Y) => {
    a && O.reportValidity && (O.setCustomValidity(lr(Y) ? "" : Y || ""), O.reportValidity());
  }, $ = {}, I = Zy(s), L = ns(s), G = I || L, Q = (j || Xy(s)) && kt(s.value) && kt(g) || gl(s) && s.value === "" || g === "" || Array.isArray(g) && !g.length, ne = UT.bind(null, N, i, $), q = (Y, P, B, ie = ei.maxLength, je = ei.minLength) => {
    const pe = Y ? P : B;
    $[N] = {
      type: Y ? ie : je,
      message: pe,
      ref: s,
      ...ne(Y ? ie : je, pe)
    };
  };
  if (o ? !Array.isArray(g) || !g.length : d && (!G && (Q || Yt(g)) || lr(g) && !g || L && !SC(l).isValid || I && !jC(l).isValid)) {
    const { value: Y, message: P } = tl(d) ? { value: !!d, message: d } : na(d);
    if (Y && ($[N] = {
      type: ei.required,
      message: P,
      ref: O,
      ...ne(ei.required, P)
    }, !i))
      return R(P), $;
  }
  if (!Q && (!Yt(f) || !Yt(h))) {
    let Y, P;
    const B = na(h), ie = na(f);
    if (!Yt(g) && !isNaN(g)) {
      const je = s.valueAsNumber || g && +g;
      Yt(B.value) || (Y = je > B.value), Yt(ie.value) || (P = je < ie.value);
    } else {
      const je = s.valueAsDate || new Date(g), pe = (V) => /* @__PURE__ */ new Date((/* @__PURE__ */ new Date()).toDateString() + " " + V), le = s.type == "time", ge = s.type == "week";
      qr(B.value) && g && (Y = le ? pe(g) > pe(B.value) : ge ? g > B.value : je > new Date(B.value)), qr(ie.value) && g && (P = le ? pe(g) < pe(ie.value) : ge ? g < ie.value : je < new Date(ie.value));
    }
    if ((Y || P) && (q(!!Y, B.message, ie.message, ei.max, ei.min), !i))
      return R($[N].message), $;
  }
  if ((m || u) && !Q && (qr(g) || o && Array.isArray(g))) {
    const Y = na(m), P = na(u), B = !Yt(Y.value) && g.length > +Y.value, ie = !Yt(P.value) && g.length < +P.value;
    if ((B || ie) && (q(B, Y.message, P.message), !i))
      return R($[N].message), $;
  }
  if (v && !Q && qr(g)) {
    const { value: Y, message: P } = na(v);
    if (kl(Y) && !g.match(Y) && ($[N] = {
      type: ei.pattern,
      message: P,
      ref: s,
      ...ne(ei.pattern, P)
    }, !i))
      return R(P), $;
  }
  if (w) {
    if (Cr(w)) {
      const Y = await w(g, r), P = Jv(Y, O);
      if (P && ($[N] = {
        ...P,
        ...ne(ei.validate, P.message)
      }, !i))
        return R(P.message), $;
    } else if (_t(w)) {
      let Y = {};
      for (const P in w) {
        if (!Kt(Y) && !i)
          break;
        const B = Jv(await w[P](g, r), O, P);
        B && (Y = {
          ...B,
          ...ne(P, B.message)
        }, R(B.message), i && ($[N] = Y));
      }
      if (!Kt(Y) && ($[N] = {
        ref: O,
        ...Y
      }, !i))
        return $;
    }
  }
  return R(!0), $;
};
const ZT = {
  mode: wr.onSubmit,
  reValidateMode: wr.onChange,
  shouldFocusError: !0
};
function eR(e = {}) {
  let n = {
    ...ZT,
    ...e
  }, r = {
    submitCount: 0,
    isDirty: !1,
    isLoading: Cr(n.defaultValues),
    isValidating: !1,
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    touchedFields: {},
    dirtyFields: {},
    validatingFields: {},
    errors: n.errors || {},
    disabled: n.disabled || !1
  };
  const i = {};
  let a = _t(n.defaultValues) || _t(n.values) ? Ot(n.values || n.defaultValues) || {} : {}, o = n.shouldUnregister ? {} : Ot(a), s = {
    action: !1,
    mount: !1,
    watch: !1
  }, l = {
    mount: /* @__PURE__ */ new Set(),
    disabled: /* @__PURE__ */ new Set(),
    unMount: /* @__PURE__ */ new Set(),
    array: /* @__PURE__ */ new Set(),
    watch: /* @__PURE__ */ new Set()
  }, d, m = 0;
  const u = {
    isDirty: !1,
    dirtyFields: !1,
    validatingFields: !1,
    touchedFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  };
  let f = {
    ...u
  };
  const h = {
    array: Uv(),
    state: Uv()
  }, v = Wv(n.mode), w = Wv(n.reValidateMode), N = n.criteriaMode === wr.all, j = (E) => (z) => {
    clearTimeout(m), m = setTimeout(E, z);
  }, _ = async (E) => {
    if (!n.disabled && (u.isValid || f.isValid || E)) {
      const z = n.resolver ? Kt((await Q()).errors) : await q(i, !0);
      z !== r.isValid && h.state.next({
        isValid: z
      });
    }
  }, g = (E, z) => {
    !n.disabled && (u.isValidating || u.validatingFields || f.isValidating || f.validatingFields) && ((E || Array.from(l.mount)).forEach((ae) => {
      ae && (z ? it(r.validatingFields, ae, z) : Ct(r.validatingFields, ae));
    }), h.state.next({
      validatingFields: r.validatingFields,
      isValidating: !Kt(r.validatingFields)
    }));
  }, O = (E, z = [], ae, de, U = !0, J = !0) => {
    if (de && ae && !n.disabled) {
      if (s.action = !0, J && Array.isArray(nn(i, E))) {
        const ve = ae(nn(i, E), de.argA, de.argB);
        U && it(i, E, ve);
      }
      if (J && Array.isArray(nn(r.errors, E))) {
        const ve = ae(nn(r.errors, E), de.argA, de.argB);
        U && it(r.errors, E, ve), QT(r.errors, E);
      }
      if ((u.touchedFields || f.touchedFields) && J && Array.isArray(nn(r.touchedFields, E))) {
        const ve = ae(nn(r.touchedFields, E), de.argA, de.argB);
        U && it(r.touchedFields, E, ve);
      }
      (u.dirtyFields || f.dirtyFields) && (r.dirtyFields = Ha(a, o)), h.state.next({
        name: E,
        isDirty: P(E, z),
        dirtyFields: r.dirtyFields,
        errors: r.errors,
        isValid: r.isValid
      });
    } else
      it(o, E, z);
  }, R = (E, z) => {
    it(r.errors, E, z), h.state.next({
      errors: r.errors
    });
  }, $ = (E) => {
    r.errors = E, h.state.next({
      errors: r.errors,
      isValid: !1
    });
  }, I = (E, z, ae, de) => {
    const U = nn(i, E);
    if (U) {
      const J = nn(o, E, kt(ae) ? nn(a, E) : ae);
      kt(J) || de && de.defaultChecked || z ? it(o, E, z ? J : Hv(U._f)) : je(E, J), s.mount && _();
    }
  }, L = (E, z, ae, de, U) => {
    let J = !1, ve = !1;
    const we = {
      name: E
    };
    if (!n.disabled) {
      if (!ae || de) {
        (u.isDirty || f.isDirty) && (ve = r.isDirty, r.isDirty = we.isDirty = P(), J = ve !== we.isDirty);
        const Re = yi(nn(a, E), z);
        ve = !!nn(r.dirtyFields, E), Re ? Ct(r.dirtyFields, E) : it(r.dirtyFields, E, !0), we.dirtyFields = r.dirtyFields, J = J || (u.dirtyFields || f.dirtyFields) && ve !== !Re;
      }
      if (ae) {
        const Re = nn(r.touchedFields, E);
        Re || (it(r.touchedFields, E, ae), we.touchedFields = r.touchedFields, J = J || (u.touchedFields || f.touchedFields) && Re !== ae);
      }
      J && U && h.state.next(we);
    }
    return J ? we : {};
  }, G = (E, z, ae, de) => {
    const U = nn(r.errors, E), J = (u.isValid || f.isValid) && lr(z) && r.isValid !== z;
    if (n.delayError && ae ? (d = j(() => R(E, ae)), d(n.delayError)) : (clearTimeout(m), d = null, ae ? it(r.errors, E, ae) : Ct(r.errors, E)), (ae ? !yi(U, ae) : U) || !Kt(de) || J) {
      const ve = {
        ...de,
        ...J && lr(z) ? { isValid: z } : {},
        errors: r.errors,
        name: E
      };
      r = {
        ...r,
        ...ve
      }, h.state.next(ve);
    }
  }, Q = async (E) => {
    g(E, !0);
    const z = await n.resolver(o, n.context, HT(E || l.mount, i, n.criteriaMode, n.shouldUseNativeValidation));
    return g(E), z;
  }, ne = async (E) => {
    const { errors: z } = await Q(E);
    if (E)
      for (const ae of E) {
        const de = nn(z, ae);
        de ? it(r.errors, ae, de) : Ct(r.errors, ae);
      }
    else
      r.errors = z;
    return z;
  }, q = async (E, z, ae = {
    valid: !0
  }) => {
    for (const de in E) {
      const U = E[de];
      if (U) {
        const { _f: J, ...ve } = U;
        if (J) {
          const we = l.array.has(J.name), Re = U._f && WT(U._f);
          Re && u.validatingFields && g([de], !0);
          const rn = await Qv(U, l.disabled, o, N, n.shouldUseNativeValidation && !z, we);
          if (Re && u.validatingFields && g([de]), rn[J.name] && (ae.valid = !1, z))
            break;
          !z && (nn(rn, J.name) ? we ? XT(r.errors, rn, J.name) : it(r.errors, J.name, rn[J.name]) : Ct(r.errors, J.name));
        }
        !Kt(ve) && await q(ve, z, ae);
      }
    }
    return ae.valid;
  }, Y = () => {
    for (const E of l.unMount) {
      const z = nn(i, E);
      z && (z._f.refs ? z._f.refs.every((ae) => !Ec(ae)) : !Ec(z._f.ref)) && Be(E);
    }
    l.unMount = /* @__PURE__ */ new Set();
  }, P = (E, z) => !n.disabled && (E && z && it(o, E, z), !yi(Oe(), a)), B = (E, z, ae) => kC(E, l, {
    ...s.mount ? o : kt(z) ? a : qr(E) ? { [E]: z } : z
  }, ae, z), ie = (E) => Xl(nn(s.mount ? o : a, E, n.shouldUnregister ? nn(a, E, []) : [])), je = (E, z, ae = {}) => {
    const de = nn(i, E);
    let U = z;
    if (de) {
      const J = de._f;
      J && (!J.disabled && it(o, E, NC(z, J)), U = gl(J.ref) && Yt(z) ? "" : z, bC(J.ref) ? [...J.ref.options].forEach((ve) => ve.selected = U.includes(ve.value)) : J.refs ? ns(J.ref) ? J.refs.length > 1 ? J.refs.forEach((ve) => (!ve.defaultChecked || !ve.disabled) && (ve.checked = Array.isArray(U) ? !!U.find((we) => we === ve.value) : U === ve.value)) : J.refs[0] && (J.refs[0].checked = !!U) : J.refs.forEach((ve) => ve.checked = ve.value === U) : Xy(J.ref) ? J.ref.value = "" : (J.ref.value = U, J.ref.type || h.state.next({
        name: E,
        values: Ot(o)
      })));
    }
    (ae.shouldDirty || ae.shouldTouch) && L(E, U, ae.shouldTouch, ae.shouldDirty, !0), ae.shouldValidate && be(E);
  }, pe = (E, z, ae) => {
    for (const de in z) {
      const U = z[de], J = `${E}.${de}`, ve = nn(i, J);
      (l.array.has(E) || _t(U) || ve && !ve._f) && !Li(U) ? pe(J, U, ae) : je(J, U, ae);
    }
  }, le = (E, z, ae = {}) => {
    const de = nn(i, E), U = l.array.has(E), J = Ot(z);
    it(o, E, J), U ? (h.array.next({
      name: E,
      values: Ot(o)
    }), (u.isDirty || u.dirtyFields || f.isDirty || f.dirtyFields) && ae.shouldDirty && h.state.next({
      name: E,
      dirtyFields: Ha(a, o),
      isDirty: P(E, J)
    })) : de && !de._f && !Yt(J) ? pe(E, J, ae) : je(E, J, ae), Gv(E, l) && h.state.next({ ...r }), h.state.next({
      name: s.mount ? E : void 0,
      values: Ot(o)
    });
  }, ge = async (E) => {
    s.mount = !0;
    const z = E.target;
    let ae = z.name, de = !0;
    const U = nn(i, ae), J = (ve) => {
      de = Number.isNaN(ve) || Li(ve) && isNaN(ve.getTime()) || yi(ve, nn(o, ae, ve));
    };
    if (U) {
      let ve, we;
      const Re = z.type ? Hv(U._f) : fC(E), rn = E.type === yl.BLUR || E.type === yl.FOCUS_OUT, bn = !KT(U._f) && !n.resolver && !nn(r.errors, ae) && !U._f.deps || JT(rn, nn(r.touchedFields, ae), r.isSubmitted, w, v), an = Gv(ae, l, rn);
      it(o, ae, Re), rn ? (U._f.onBlur && U._f.onBlur(E), d && d(0)) : U._f.onChange && U._f.onChange(E);
      const hn = L(ae, Re, rn), En = !Kt(hn) || an;
      if (!rn && h.state.next({
        name: ae,
        type: E.type,
        values: Ot(o)
      }), bn)
        return (u.isValid || f.isValid) && (n.mode === "onBlur" ? rn && _() : rn || _()), En && h.state.next({ name: ae, ...an ? {} : hn });
      if (!rn && an && h.state.next({ ...r }), n.resolver) {
        const { errors: _n } = await Q([ae]);
        if (J(Re), de) {
          const Fn = Yv(r.errors, i, ae), Ze = Yv(_n, i, Fn.name || ae);
          ve = Ze.error, ae = Ze.name, we = Kt(_n);
        }
      } else
        g([ae], !0), ve = (await Qv(U, l.disabled, o, N, n.shouldUseNativeValidation))[ae], g([ae]), J(Re), de && (ve ? we = !1 : (u.isValid || f.isValid) && (we = await q(i, !0)));
      de && (U._f.deps && be(U._f.deps), G(ae, we, ve, hn));
    }
  }, V = (E, z) => {
    if (nn(r.errors, z) && E.focus)
      return E.focus(), 1;
  }, be = async (E, z = {}) => {
    let ae, de;
    const U = Eo(E);
    if (n.resolver) {
      const J = await ne(kt(E) ? E : U);
      ae = Kt(J), de = E ? !U.some((ve) => nn(J, ve)) : ae;
    } else E ? (de = (await Promise.all(U.map(async (J) => {
      const ve = nn(i, J);
      return await q(ve && ve._f ? { [J]: ve } : ve);
    }))).every(Boolean), !(!de && !r.isValid) && _()) : de = ae = await q(i);
    return h.state.next({
      ...!qr(E) || (u.isValid || f.isValid) && ae !== r.isValid ? {} : { name: E },
      ...n.resolver || !E ? { isValid: ae } : {},
      errors: r.errors
    }), z.shouldFocus && !de && To(i, V, E ? U : l.mount), de;
  }, Oe = (E) => {
    const z = {
      ...s.mount ? o : a
    };
    return kt(E) ? z : qr(E) ? nn(z, E) : E.map((ae) => nn(z, ae));
  }, H = (E, z) => ({
    invalid: !!nn((z || r).errors, E),
    isDirty: !!nn((z || r).dirtyFields, E),
    error: nn((z || r).errors, E),
    isValidating: !!nn(r.validatingFields, E),
    isTouched: !!nn((z || r).touchedFields, E)
  }), Ye = (E) => {
    E && Eo(E).forEach((z) => Ct(r.errors, z)), h.state.next({
      errors: E ? r.errors : {}
    });
  }, ln = (E, z, ae) => {
    const de = (nn(i, E, { _f: {} })._f || {}).ref, U = nn(r.errors, E) || {}, { ref: J, message: ve, type: we, ...Re } = U;
    it(r.errors, E, {
      ...Re,
      ...z,
      ref: de
    }), h.state.next({
      name: E,
      errors: r.errors,
      isValid: !1
    }), ae && ae.shouldFocus && de && de.focus && de.focus();
  }, Ie = (E, z) => Cr(E) ? h.state.subscribe({
    next: (ae) => E(B(void 0, z), ae)
  }) : B(E, z, !0), Ue = (E) => h.state.subscribe({
    next: (z) => {
      YT(E.name, z.name, E.exact) && GT(z, E.formState || u, Pe, E.reRenderRoot) && E.callback({
        values: { ...o },
        ...r,
        ...z
      });
    }
  }).unsubscribe, De = (E) => (s.mount = !0, f = {
    ...f,
    ...E.formState
  }, Ue({
    ...E,
    formState: f
  })), Be = (E, z = {}) => {
    for (const ae of E ? Eo(E) : l.mount)
      l.mount.delete(ae), l.array.delete(ae), z.keepValue || (Ct(i, ae), Ct(o, ae)), !z.keepError && Ct(r.errors, ae), !z.keepDirty && Ct(r.dirtyFields, ae), !z.keepTouched && Ct(r.touchedFields, ae), !z.keepIsValidating && Ct(r.validatingFields, ae), !n.shouldUnregister && !z.keepDefaultValue && Ct(a, ae);
    h.state.next({
      values: Ot(o)
    }), h.state.next({
      ...r,
      ...z.keepDirty ? { isDirty: P() } : {}
    }), !z.keepIsValid && _();
  }, Ae = ({ disabled: E, name: z }) => {
    (lr(E) && s.mount || E || l.disabled.has(z)) && (E ? l.disabled.add(z) : l.disabled.delete(z));
  }, Qe = (E, z = {}) => {
    let ae = nn(i, E);
    const de = lr(z.disabled) || lr(n.disabled);
    return it(i, E, {
      ...ae || {},
      _f: {
        ...ae && ae._f ? ae._f : { ref: { name: E } },
        name: E,
        mount: !0,
        ...z
      }
    }), l.mount.add(E), ae ? Ae({
      disabled: lr(z.disabled) ? z.disabled : n.disabled,
      name: E
    }) : I(E, !0, z.value), {
      ...de ? { disabled: z.disabled || n.disabled } : {},
      ...n.progressive ? {
        required: !!z.required,
        min: Wa(z.min),
        max: Wa(z.max),
        minLength: Wa(z.minLength),
        maxLength: Wa(z.maxLength),
        pattern: Wa(z.pattern)
      } : {},
      name: E,
      onChange: ge,
      onBlur: ge,
      ref: (U) => {
        if (U) {
          Qe(E, z), ae = nn(i, E);
          const J = kt(U.value) && U.querySelectorAll && U.querySelectorAll("input,select,textarea")[0] || U, ve = MT(J), we = ae._f.refs || [];
          if (ve ? we.find((Re) => Re === J) : J === ae._f.ref)
            return;
          it(i, E, {
            _f: {
              ...ae._f,
              ...ve ? {
                refs: [
                  ...we.filter(Ec),
                  J,
                  ...Array.isArray(nn(a, E)) ? [{}] : []
                ],
                ref: { type: J.type, name: E }
              } : { ref: J }
            }
          }), I(E, !1, void 0, J);
        } else
          ae = nn(i, E, {}), ae._f && (ae._f.mount = !1), (n.shouldUnregister || z.shouldUnregister) && !(hC(l.array, E) && s.action) && l.unMount.add(E);
      }
    };
  }, Ee = () => n.shouldFocusError && To(i, V, l.mount), Me = (E) => {
    lr(E) && (h.state.next({ disabled: E }), To(i, (z, ae) => {
      const de = nn(i, ae);
      de && (z.disabled = de._f.disabled || E, Array.isArray(de._f.refs) && de._f.refs.forEach((U) => {
        U.disabled = de._f.disabled || E;
      }));
    }, 0, !1));
  }, en = (E, z) => async (ae) => {
    let de;
    ae && (ae.preventDefault && ae.preventDefault(), ae.persist && ae.persist());
    let U = Ot(o);
    if (h.state.next({
      isSubmitting: !0
    }), n.resolver) {
      const { errors: J, values: ve } = await Q();
      r.errors = J, U = ve;
    } else
      await q(i);
    if (l.disabled.size)
      for (const J of l.disabled)
        it(U, J, void 0);
    if (Ct(r.errors, "root"), Kt(r.errors)) {
      h.state.next({
        errors: {}
      });
      try {
        await E(U, ae);
      } catch (J) {
        de = J;
      }
    } else
      z && await z({ ...r.errors }, ae), Ee(), setTimeout(Ee);
    if (h.state.next({
      isSubmitted: !0,
      isSubmitting: !1,
      isSubmitSuccessful: Kt(r.errors) && !de,
      submitCount: r.submitCount + 1,
      errors: r.errors
    }), de)
      throw de;
  }, se = (E, z = {}) => {
    nn(i, E) && (kt(z.defaultValue) ? le(E, Ot(nn(a, E))) : (le(E, z.defaultValue), it(a, E, Ot(z.defaultValue))), z.keepTouched || Ct(r.touchedFields, E), z.keepDirty || (Ct(r.dirtyFields, E), r.isDirty = z.defaultValue ? P(E, Ot(nn(a, E))) : P()), z.keepError || (Ct(r.errors, E), u.isValid && _()), h.state.next({ ...r }));
  }, ce = (E, z = {}) => {
    const ae = E ? Ot(E) : a, de = Ot(ae), U = Kt(E), J = U ? a : de;
    if (z.keepDefaultValues || (a = ae), !z.keepValues) {
      if (z.keepDirtyValues) {
        const ve = /* @__PURE__ */ new Set([
          ...l.mount,
          ...Object.keys(Ha(a, o))
        ]);
        for (const we of Array.from(ve))
          nn(r.dirtyFields, we) ? it(J, we, nn(o, we)) : le(we, nn(J, we));
      } else {
        if (Gy && kt(E))
          for (const ve of l.mount) {
            const we = nn(i, ve);
            if (we && we._f) {
              const Re = Array.isArray(we._f.refs) ? we._f.refs[0] : we._f.ref;
              if (gl(Re)) {
                const rn = Re.closest("form");
                if (rn) {
                  rn.reset();
                  break;
                }
              }
            }
          }
        for (const ve of l.mount)
          le(ve, nn(J, ve));
      }
      o = Ot(J), h.array.next({
        values: { ...J }
      }), h.state.next({
        values: { ...J }
      });
    }
    l = {
      mount: z.keepDirtyValues ? l.mount : /* @__PURE__ */ new Set(),
      unMount: /* @__PURE__ */ new Set(),
      array: /* @__PURE__ */ new Set(),
      disabled: /* @__PURE__ */ new Set(),
      watch: /* @__PURE__ */ new Set(),
      watchAll: !1,
      focus: ""
    }, s.mount = !u.isValid || !!z.keepIsValid || !!z.keepDirtyValues, s.watch = !!n.shouldUnregister, h.state.next({
      submitCount: z.keepSubmitCount ? r.submitCount : 0,
      isDirty: U ? !1 : z.keepDirty ? r.isDirty : !!(z.keepDefaultValues && !yi(E, a)),
      isSubmitted: z.keepIsSubmitted ? r.isSubmitted : !1,
      dirtyFields: U ? {} : z.keepDirtyValues ? z.keepDefaultValues && o ? Ha(a, o) : r.dirtyFields : z.keepDefaultValues && E ? Ha(a, E) : z.keepDirty ? r.dirtyFields : {},
      touchedFields: z.keepTouched ? r.touchedFields : {},
      errors: z.keepErrors ? r.errors : {},
      isSubmitSuccessful: z.keepIsSubmitSuccessful ? r.isSubmitSuccessful : !1,
      isSubmitting: !1
    });
  }, Se = (E, z) => ce(Cr(E) ? E(o) : E, z), Ve = (E, z = {}) => {
    const ae = nn(i, E), de = ae && ae._f;
    if (de) {
      const U = de.refs ? de.refs[0] : de.ref;
      U.focus && (U.focus(), z.shouldSelect && Cr(U.select) && U.select());
    }
  }, Pe = (E) => {
    r = {
      ...r,
      ...E
    };
  }, X = {
    control: {
      register: Qe,
      unregister: Be,
      getFieldState: H,
      handleSubmit: en,
      setError: ln,
      _subscribe: Ue,
      _runSchema: Q,
      _getWatch: B,
      _getDirty: P,
      _setValid: _,
      _setFieldArray: O,
      _setDisabledField: Ae,
      _setErrors: $,
      _getFieldArray: ie,
      _reset: ce,
      _resetDefaultValues: () => Cr(n.defaultValues) && n.defaultValues().then((E) => {
        Se(E, n.resetOptions), h.state.next({
          isLoading: !1
        });
      }),
      _removeUnmounted: Y,
      _disableForm: Me,
      _subjects: h,
      _proxyFormState: u,
      get _fields() {
        return i;
      },
      get _formValues() {
        return o;
      },
      get _state() {
        return s;
      },
      set _state(E) {
        s = E;
      },
      get _defaultValues() {
        return a;
      },
      get _names() {
        return l;
      },
      set _names(E) {
        l = E;
      },
      get _formState() {
        return r;
      },
      get _options() {
        return n;
      },
      set _options(E) {
        n = {
          ...n,
          ...E
        };
      }
    },
    subscribe: De,
    trigger: be,
    register: Qe,
    handleSubmit: en,
    watch: Ie,
    setValue: le,
    getValues: Oe,
    reset: Se,
    resetField: se,
    clearErrors: Ye,
    unregister: Be,
    setError: ln,
    setFocus: Ve,
    getFieldState: H
  };
  return {
    ...X,
    formControl: X
  };
}
function ot(e = {}) {
  const n = He.useRef(void 0), r = He.useRef(void 0), [i, a] = He.useState({
    isDirty: !1,
    isValidating: !1,
    isLoading: Cr(e.defaultValues),
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    submitCount: 0,
    dirtyFields: {},
    touchedFields: {},
    validatingFields: {},
    errors: e.errors || {},
    disabled: e.disabled || !1,
    defaultValues: Cr(e.defaultValues) ? void 0 : e.defaultValues
  });
  n.current || (n.current = {
    ...e.formControl ? e.formControl : eR(e),
    formState: i
  }, e.formControl && e.defaultValues && !Cr(e.defaultValues) && e.formControl.reset(e.defaultValues, e.resetOptions));
  const o = n.current.control;
  return o._options = e, He.useLayoutEffect(() => o._subscribe({
    formState: o._proxyFormState,
    callback: () => a({ ...o._formState }),
    reRenderRoot: !0
  }), [o]), He.useEffect(() => o._disableForm(e.disabled), [o, e.disabled]), He.useEffect(() => {
    if (o._proxyFormState.isDirty) {
      const s = o._getDirty();
      s !== i.isDirty && o._subjects.state.next({
        isDirty: s
      });
    }
  }, [o, i.isDirty]), He.useEffect(() => {
    e.values && !yi(e.values, r.current) ? (o._reset(e.values, o._options.resetOptions), r.current = e.values, a((s) => ({ ...s }))) : o._resetDefaultValues();
  }, [e.values, o]), He.useEffect(() => {
    e.errors && !Kt(e.errors) && o._setErrors(e.errors);
  }, [e.errors, o]), He.useEffect(() => {
    o._state.mount || (o._setValid(), o._state.mount = !0), o._state.watch && (o._state.watch = !1, o._subjects.state.next({ ...o._formState })), o._removeUnmounted();
  }), He.useEffect(() => {
    e.shouldUnregister && o._subjects.state.next({
      values: o._getWatch()
    });
  }, [e.shouldUnregister, o]), n.current.formState = vC(i, o), n.current;
}
var hs = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function wC(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Tc = { exports: {} }, Ka = {}, Xv;
function nR() {
  if (Xv) return Ka;
  Xv = 1;
  var e = He, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (v = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return Ka.Fragment = r, Ka.jsx = s, Ka.jsxs = s, Ka;
}
var ys = {}, Zv;
function tR() {
  return Zv || (Zv = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = He, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), d = /* @__PURE__ */ Symbol.for("react.forward_ref"), m = /* @__PURE__ */ Symbol.for("react.suspense"), u = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), v = /* @__PURE__ */ Symbol.for("react.offscreen"), w = Symbol.iterator, N = "@@iterator";
    function j(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = w && t[w] || t[N];
      return typeof c == "function" ? c : null;
    }
    var _ = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          p[y - 1] = arguments[y];
        O("error", t, p);
      }
    }
    function O(t, c, p) {
      {
        var y = _.ReactDebugCurrentFrame, C = y.getStackAddendum();
        C !== "" && (c += "%s", p = p.concat([C]));
        var T = p.map(function(S) {
          return String(S);
        });
        T.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, T);
      }
    }
    var R = !1, $ = !1, I = !1, L = !1, G = !1, Q;
    Q = /* @__PURE__ */ Symbol.for("react.module.reference");
    function ne(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || G || t === a || t === m || t === u || L || t === v || R || $ || I || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Q || t.getModuleId !== void 0));
    }
    function q(t, c, p) {
      var y = t.displayName;
      if (y)
        return y;
      var C = c.displayName || c.name || "";
      return C !== "" ? p + "(" + C + ")" : p;
    }
    function Y(t) {
      return t.displayName || "Context";
    }
    function P(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return Y(c) + ".Consumer";
          case s:
            var p = t;
            return Y(p._context) + ".Provider";
          case d:
            return q(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : P(t.type) || "Memo";
          case h: {
            var C = t, T = C._payload, S = C._init;
            try {
              return P(S(T));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var B = Object.assign, ie = 0, je, pe, le, ge, V, be, Oe;
    function H() {
    }
    H.__reactDisabledLog = !0;
    function Ye() {
      {
        if (ie === 0) {
          je = console.log, pe = console.info, le = console.warn, ge = console.error, V = console.group, be = console.groupCollapsed, Oe = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: H,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ie++;
      }
    }
    function ln() {
      {
        if (ie--, ie === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: B({}, t, {
              value: je
            }),
            info: B({}, t, {
              value: pe
            }),
            warn: B({}, t, {
              value: le
            }),
            error: B({}, t, {
              value: ge
            }),
            group: B({}, t, {
              value: V
            }),
            groupCollapsed: B({}, t, {
              value: be
            }),
            groupEnd: B({}, t, {
              value: Oe
            })
          });
        }
        ie < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Ie = _.ReactCurrentDispatcher, Ue;
    function De(t, c, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (C) {
            var y = C.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Be = !1, Ae;
    {
      var Qe = typeof WeakMap == "function" ? WeakMap : Map;
      Ae = new Qe();
    }
    function Ee(t, c) {
      if (!t || Be)
        return "";
      {
        var p = Ae.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Be = !0;
      var C = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var T;
      T = Ie.current, Ie.current = null, Ye();
      try {
        if (c) {
          var S = function() {
            throw Error();
          };
          if (Object.defineProperty(S.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(S, []);
            } catch (re) {
              y = re;
            }
            Reflect.construct(t, [], S);
          } else {
            try {
              S.call();
            } catch (re) {
              y = re;
            }
            t.call(S.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (re) {
            y = re;
          }
          t();
        }
      } catch (re) {
        if (re && y && typeof re.stack == "string") {
          for (var x = re.stack.split(`
`), ee = y.stack.split(`
`), A = x.length - 1, M = ee.length - 1; A >= 1 && M >= 0 && x[A] !== ee[M]; )
            M--;
          for (; A >= 1 && M >= 0; A--, M--)
            if (x[A] !== ee[M]) {
              if (A !== 1 || M !== 1)
                do
                  if (A--, M--, M < 0 || x[A] !== ee[M]) {
                    var ue = `
` + x[A].replace(" at new ", " at ");
                    return t.displayName && ue.includes("<anonymous>") && (ue = ue.replace("<anonymous>", t.displayName)), typeof t == "function" && Ae.set(t, ue), ue;
                  }
                while (A >= 1 && M >= 0);
              break;
            }
        }
      } finally {
        Be = !1, Ie.current = T, ln(), Error.prepareStackTrace = C;
      }
      var ze = t ? t.displayName || t.name : "", Te = ze ? De(ze) : "";
      return typeof t == "function" && Ae.set(t, Te), Te;
    }
    function Me(t, c, p) {
      return Ee(t, !1);
    }
    function en(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function se(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ee(t, en(t));
      if (typeof t == "string")
        return De(t);
      switch (t) {
        case m:
          return De("Suspense");
        case u:
          return De("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Me(t.render);
          case f:
            return se(t.type, c, p);
          case h: {
            var y = t, C = y._payload, T = y._init;
            try {
              return se(T(C), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var ce = Object.prototype.hasOwnProperty, Se = {}, Ve = _.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, p = se(t.type, t._source, c ? c.type : null);
        Ve.setExtraStackFrame(p);
      } else
        Ve.setExtraStackFrame(null);
    }
    function kn(t, c, p, y, C) {
      {
        var T = Function.call.bind(ce);
        for (var S in t)
          if (T(t, S)) {
            var x = void 0;
            try {
              if (typeof t[S] != "function") {
                var ee = Error((y || "React class") + ": " + p + " type `" + S + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[S] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ee.name = "Invariant Violation", ee;
              }
              x = t[S](c, S, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (A) {
              x = A;
            }
            x && !(x instanceof Error) && (Pe(C), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, S, typeof x), Pe(null)), x instanceof Error && !(x.message in Se) && (Se[x.message] = !0, Pe(C), g("Failed %s type: %s", p, x.message), Pe(null));
          }
      }
    }
    var X = Array.isArray;
    function E(t) {
      return X(t);
    }
    function z(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function ae(t) {
      try {
        return de(t), !1;
      } catch {
        return !0;
      }
    }
    function de(t) {
      return "" + t;
    }
    function U(t) {
      if (ae(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", z(t)), de(t);
    }
    var J = _.ReactCurrentOwner, ve = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, we, Re;
    function rn(t) {
      if (ce.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function bn(t) {
      if (ce.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function an(t, c) {
      typeof t.ref == "string" && J.current;
    }
    function hn(t, c) {
      {
        var p = function() {
          we || (we = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function En(t, c) {
      {
        var p = function() {
          Re || (Re = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var _n = function(t, c, p, y, C, T, S) {
      var x = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: S,
        // Record the component responsible for creating this element.
        _owner: T
      };
      return x._store = {}, Object.defineProperty(x._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(x, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(x, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: C
      }), Object.freeze && (Object.freeze(x.props), Object.freeze(x)), x;
    };
    function Fn(t, c, p, y, C) {
      {
        var T, S = {}, x = null, ee = null;
        p !== void 0 && (U(p), x = "" + p), bn(c) && (U(c.key), x = "" + c.key), rn(c) && (ee = c.ref, an(c));
        for (T in c)
          ce.call(c, T) && !ve.hasOwnProperty(T) && (S[T] = c[T]);
        if (t && t.defaultProps) {
          var A = t.defaultProps;
          for (T in A)
            S[T] === void 0 && (S[T] = A[T]);
        }
        if (x || ee) {
          var M = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          x && hn(S, M), ee && En(S, M);
        }
        return _n(t, x, ee, C, y, J.current, S);
      }
    }
    var Ze = _.ReactCurrentOwner, gn = _.ReactDebugCurrentFrame;
    function Le(t) {
      if (t) {
        var c = t._owner, p = se(t.type, t._source, c ? c.type : null);
        gn.setExtraStackFrame(p);
      } else
        gn.setExtraStackFrame(null);
    }
    var dn;
    dn = !1;
    function un(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function Nn() {
      {
        if (Ze.current) {
          var t = P(Ze.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Bn(t) {
      return "";
    }
    var Sn = {};
    function An(t) {
      {
        var c = Nn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function vn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = An(c);
        if (Sn[p])
          return;
        Sn[p] = !0;
        var y = "";
        t && t._owner && t._owner !== Ze.current && (y = " It was passed a child from " + P(t._owner.type) + "."), Le(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Le(null);
      }
    }
    function xn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (E(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            un(y) && vn(y, c);
          }
        else if (un(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var C = j(t);
          if (typeof C == "function" && C !== t.entries)
            for (var T = C.call(t), S; !(S = T.next()).done; )
              un(S.value) && vn(S.value, c);
        }
      }
    }
    function Ln(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var y = P(c);
          kn(p, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !dn) {
          dn = !0;
          var C = P(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", C || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var y = c[p];
          if (y !== "children" && y !== "key") {
            Le(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Le(null);
            break;
          }
        }
        t.ref !== null && (Le(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Le(null));
      }
    }
    var Cn = {};
    function wn(t, c, p, y, C, T) {
      {
        var S = ne(t);
        if (!S) {
          var x = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (x += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ee = Bn();
          ee ? x += ee : x += Nn();
          var A;
          t === null ? A = "null" : E(t) ? A = "array" : t !== void 0 && t.$$typeof === n ? (A = "<" + (P(t.type) || "Unknown") + " />", x = " Did you accidentally export a JSX literal instead of a component?") : A = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", A, x);
        }
        var M = Fn(t, c, p, C, T);
        if (M == null)
          return M;
        if (S) {
          var ue = c.children;
          if (ue !== void 0)
            if (y)
              if (E(ue)) {
                for (var ze = 0; ze < ue.length; ze++)
                  xn(ue[ze], t);
                Object.freeze && Object.freeze(ue);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              xn(ue, t);
        }
        if (ce.call(c, "key")) {
          var Te = P(t), re = Object.keys(c).filter(function(Gn) {
            return Gn !== "key";
          }), mn = re.length > 0 ? "{key: someKey, " + re.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Cn[Te + mn]) {
            var Dn = re.length > 0 ? "{" + re.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, mn, Te, Dn, Te), Cn[Te + mn] = !0;
          }
        }
        return t === i ? Vn(M) : Ln(M), M;
      }
    }
    function zn(t, c, p) {
      return wn(t, c, p, !0);
    }
    function qn(t, c, p) {
      return wn(t, c, p, !1);
    }
    var Un = qn, Kn = zn;
    ys.Fragment = i, ys.jsx = Un, ys.jsxs = Kn;
  })()), ys;
}
var ek;
function rR() {
  return ek || (ek = 1, process.env.NODE_ENV === "production" ? Tc.exports = nR() : Tc.exports = tR()), Tc.exports;
}
var Ui = rR();
function iR(e) {
  return !e || typeof e == "boolean" || typeof e == "string" ? !!e : e.value;
}
var Rc, nk;
function _i() {
  if (nk) return Rc;
  nk = 1;
  var e = Array.isArray;
  return Rc = e, Rc;
}
var Dc, tk;
function CC() {
  if (tk) return Dc;
  tk = 1;
  var e = typeof hs == "object" && hs && hs.Object === Object && hs;
  return Dc = e, Dc;
}
var Oc, rk;
function Yr() {
  if (rk) return Oc;
  rk = 1;
  var e = CC(), n = typeof self == "object" && self && self.Object === Object && self, r = e || n || Function("return this")();
  return Oc = r, Oc;
}
var Pc, ik;
function ts() {
  if (ik) return Pc;
  ik = 1;
  var e = Yr(), n = e.Symbol;
  return Pc = n, Pc;
}
var Ac, ak;
function aR() {
  if (ak) return Ac;
  ak = 1;
  var e = ts(), n = Object.prototype, r = n.hasOwnProperty, i = n.toString, a = e ? e.toStringTag : void 0;
  function o(s) {
    var l = r.call(s, a), d = s[a];
    try {
      s[a] = void 0;
      var m = !0;
    } catch {
    }
    var u = i.call(s);
    return m && (l ? s[a] = d : delete s[a]), u;
  }
  return Ac = o, Ac;
}
var Lc, ok;
function oR() {
  if (ok) return Lc;
  ok = 1;
  var e = Object.prototype, n = e.toString;
  function r(i) {
    return n.call(i);
  }
  return Lc = r, Lc;
}
var Vc, sk;
function Ta() {
  if (sk) return Vc;
  sk = 1;
  var e = ts(), n = aR(), r = oR(), i = "[object Null]", a = "[object Undefined]", o = e ? e.toStringTag : void 0;
  function s(l) {
    return l == null ? l === void 0 ? a : i : o && o in Object(l) ? n(l) : r(l);
  }
  return Vc = s, Vc;
}
var zc, lk;
function Ki() {
  if (lk) return zc;
  lk = 1;
  function e(n) {
    return n != null && typeof n == "object";
  }
  return zc = e, zc;
}
var Uc, ck;
function eg() {
  if (ck) return Uc;
  ck = 1;
  var e = Ta(), n = Ki(), r = "[object Symbol]";
  function i(a) {
    return typeof a == "symbol" || n(a) && e(a) == r;
  }
  return Uc = i, Uc;
}
var Mc, dk;
function sR() {
  if (dk) return Mc;
  dk = 1;
  var e = _i(), n = eg(), r = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, i = /^\w*$/;
  function a(o, s) {
    if (e(o))
      return !1;
    var l = typeof o;
    return l == "number" || l == "symbol" || l == "boolean" || o == null || n(o) ? !0 : i.test(o) || !r.test(o) || s != null && o in Object(s);
  }
  return Mc = a, Mc;
}
var Bc, uk;
function Ra() {
  if (uk) return Bc;
  uk = 1;
  function e(n) {
    var r = typeof n;
    return n != null && (r == "object" || r == "function");
  }
  return Bc = e, Bc;
}
var qc, mk;
function FC() {
  if (mk) return qc;
  mk = 1;
  var e = Ta(), n = Ra(), r = "[object AsyncFunction]", i = "[object Function]", a = "[object GeneratorFunction]", o = "[object Proxy]";
  function s(l) {
    if (!n(l))
      return !1;
    var d = e(l);
    return d == i || d == a || d == r || d == o;
  }
  return qc = s, qc;
}
var Hc, pk;
function lR() {
  if (pk) return Hc;
  pk = 1;
  var e = Yr(), n = e["__core-js_shared__"];
  return Hc = n, Hc;
}
var Wc, fk;
function cR() {
  if (fk) return Wc;
  fk = 1;
  var e = lR(), n = (function() {
    var i = /[^.]+$/.exec(e && e.keys && e.keys.IE_PROTO || "");
    return i ? "Symbol(src)_1." + i : "";
  })();
  function r(i) {
    return !!n && n in i;
  }
  return Wc = r, Wc;
}
var Kc, hk;
function IC() {
  if (hk) return Kc;
  hk = 1;
  var e = Function.prototype, n = e.toString;
  function r(i) {
    if (i != null) {
      try {
        return n.call(i);
      } catch {
      }
      try {
        return i + "";
      } catch {
      }
    }
    return "";
  }
  return Kc = r, Kc;
}
var Gc, yk;
function dR() {
  if (yk) return Gc;
  yk = 1;
  var e = FC(), n = cR(), r = Ra(), i = IC(), a = /[\\^$.*+?()[\]{}|]/g, o = /^\[object .+?Constructor\]$/, s = Function.prototype, l = Object.prototype, d = s.toString, m = l.hasOwnProperty, u = RegExp(
    "^" + d.call(m).replace(a, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  );
  function f(h) {
    if (!r(h) || n(h))
      return !1;
    var v = e(h) ? u : o;
    return v.test(i(h));
  }
  return Gc = f, Gc;
}
var Yc, gk;
function uR() {
  if (gk) return Yc;
  gk = 1;
  function e(n, r) {
    return n?.[r];
  }
  return Yc = e, Yc;
}
var Jc, vk;
function Gi() {
  if (vk) return Jc;
  vk = 1;
  var e = dR(), n = uR();
  function r(i, a) {
    var o = n(i, a);
    return e(o) ? o : void 0;
  }
  return Jc = r, Jc;
}
var Qc, kk;
function Zl() {
  if (kk) return Qc;
  kk = 1;
  var e = Gi(), n = e(Object, "create");
  return Qc = n, Qc;
}
var Xc, bk;
function mR() {
  if (bk) return Xc;
  bk = 1;
  var e = Zl();
  function n() {
    this.__data__ = e ? e(null) : {}, this.size = 0;
  }
  return Xc = n, Xc;
}
var Zc, _k;
function pR() {
  if (_k) return Zc;
  _k = 1;
  function e(n) {
    var r = this.has(n) && delete this.__data__[n];
    return this.size -= r ? 1 : 0, r;
  }
  return Zc = e, Zc;
}
var ed, xk;
function fR() {
  if (xk) return ed;
  xk = 1;
  var e = Zl(), n = "__lodash_hash_undefined__", r = Object.prototype, i = r.hasOwnProperty;
  function a(o) {
    var s = this.__data__;
    if (e) {
      var l = s[o];
      return l === n ? void 0 : l;
    }
    return i.call(s, o) ? s[o] : void 0;
  }
  return ed = a, ed;
}
var nd, Sk;
function hR() {
  if (Sk) return nd;
  Sk = 1;
  var e = Zl(), n = Object.prototype, r = n.hasOwnProperty;
  function i(a) {
    var o = this.__data__;
    return e ? o[a] !== void 0 : r.call(o, a);
  }
  return nd = i, nd;
}
var td, Nk;
function yR() {
  if (Nk) return td;
  Nk = 1;
  var e = Zl(), n = "__lodash_hash_undefined__";
  function r(i, a) {
    var o = this.__data__;
    return this.size += this.has(i) ? 0 : 1, o[i] = e && a === void 0 ? n : a, this;
  }
  return td = r, td;
}
var rd, jk;
function gR() {
  if (jk) return rd;
  jk = 1;
  var e = mR(), n = pR(), r = fR(), i = hR(), a = yR();
  function o(s) {
    var l = -1, d = s == null ? 0 : s.length;
    for (this.clear(); ++l < d; ) {
      var m = s[l];
      this.set(m[0], m[1]);
    }
  }
  return o.prototype.clear = e, o.prototype.delete = n, o.prototype.get = r, o.prototype.has = i, o.prototype.set = a, rd = o, rd;
}
var id, wk;
function vR() {
  if (wk) return id;
  wk = 1;
  function e() {
    this.__data__ = [], this.size = 0;
  }
  return id = e, id;
}
var ad, Ck;
function $C() {
  if (Ck) return ad;
  Ck = 1;
  function e(n, r) {
    return n === r || n !== n && r !== r;
  }
  return ad = e, ad;
}
var od, Fk;
function ec() {
  if (Fk) return od;
  Fk = 1;
  var e = $C();
  function n(r, i) {
    for (var a = r.length; a--; )
      if (e(r[a][0], i))
        return a;
    return -1;
  }
  return od = n, od;
}
var sd, Ik;
function kR() {
  if (Ik) return sd;
  Ik = 1;
  var e = ec(), n = Array.prototype, r = n.splice;
  function i(a) {
    var o = this.__data__, s = e(o, a);
    if (s < 0)
      return !1;
    var l = o.length - 1;
    return s == l ? o.pop() : r.call(o, s, 1), --this.size, !0;
  }
  return sd = i, sd;
}
var ld, $k;
function bR() {
  if ($k) return ld;
  $k = 1;
  var e = ec();
  function n(r) {
    var i = this.__data__, a = e(i, r);
    return a < 0 ? void 0 : i[a][1];
  }
  return ld = n, ld;
}
var cd, Ek;
function _R() {
  if (Ek) return cd;
  Ek = 1;
  var e = ec();
  function n(r) {
    return e(this.__data__, r) > -1;
  }
  return cd = n, cd;
}
var dd, Tk;
function xR() {
  if (Tk) return dd;
  Tk = 1;
  var e = ec();
  function n(r, i) {
    var a = this.__data__, o = e(a, r);
    return o < 0 ? (++this.size, a.push([r, i])) : a[o][1] = i, this;
  }
  return dd = n, dd;
}
var ud, Rk;
function nc() {
  if (Rk) return ud;
  Rk = 1;
  var e = vR(), n = kR(), r = bR(), i = _R(), a = xR();
  function o(s) {
    var l = -1, d = s == null ? 0 : s.length;
    for (this.clear(); ++l < d; ) {
      var m = s[l];
      this.set(m[0], m[1]);
    }
  }
  return o.prototype.clear = e, o.prototype.delete = n, o.prototype.get = r, o.prototype.has = i, o.prototype.set = a, ud = o, ud;
}
var md, Dk;
function ng() {
  if (Dk) return md;
  Dk = 1;
  var e = Gi(), n = Yr(), r = e(n, "Map");
  return md = r, md;
}
var pd, Ok;
function SR() {
  if (Ok) return pd;
  Ok = 1;
  var e = gR(), n = nc(), r = ng();
  function i() {
    this.size = 0, this.__data__ = {
      hash: new e(),
      map: new (r || n)(),
      string: new e()
    };
  }
  return pd = i, pd;
}
var fd, Pk;
function NR() {
  if (Pk) return fd;
  Pk = 1;
  function e(n) {
    var r = typeof n;
    return r == "string" || r == "number" || r == "symbol" || r == "boolean" ? n !== "__proto__" : n === null;
  }
  return fd = e, fd;
}
var hd, Ak;
function tc() {
  if (Ak) return hd;
  Ak = 1;
  var e = NR();
  function n(r, i) {
    var a = r.__data__;
    return e(i) ? a[typeof i == "string" ? "string" : "hash"] : a.map;
  }
  return hd = n, hd;
}
var yd, Lk;
function jR() {
  if (Lk) return yd;
  Lk = 1;
  var e = tc();
  function n(r) {
    var i = e(this, r).delete(r);
    return this.size -= i ? 1 : 0, i;
  }
  return yd = n, yd;
}
var gd, Vk;
function wR() {
  if (Vk) return gd;
  Vk = 1;
  var e = tc();
  function n(r) {
    return e(this, r).get(r);
  }
  return gd = n, gd;
}
var vd, zk;
function CR() {
  if (zk) return vd;
  zk = 1;
  var e = tc();
  function n(r) {
    return e(this, r).has(r);
  }
  return vd = n, vd;
}
var kd, Uk;
function FR() {
  if (Uk) return kd;
  Uk = 1;
  var e = tc();
  function n(r, i) {
    var a = e(this, r), o = a.size;
    return a.set(r, i), this.size += a.size == o ? 0 : 1, this;
  }
  return kd = n, kd;
}
var bd, Mk;
function EC() {
  if (Mk) return bd;
  Mk = 1;
  var e = SR(), n = jR(), r = wR(), i = CR(), a = FR();
  function o(s) {
    var l = -1, d = s == null ? 0 : s.length;
    for (this.clear(); ++l < d; ) {
      var m = s[l];
      this.set(m[0], m[1]);
    }
  }
  return o.prototype.clear = e, o.prototype.delete = n, o.prototype.get = r, o.prototype.has = i, o.prototype.set = a, bd = o, bd;
}
var _d, Bk;
function IR() {
  if (Bk) return _d;
  Bk = 1;
  var e = EC(), n = "Expected a function";
  function r(i, a) {
    if (typeof i != "function" || a != null && typeof a != "function")
      throw new TypeError(n);
    var o = function() {
      var s = arguments, l = a ? a.apply(this, s) : s[0], d = o.cache;
      if (d.has(l))
        return d.get(l);
      var m = i.apply(this, s);
      return o.cache = d.set(l, m) || d, m;
    };
    return o.cache = new (r.Cache || e)(), o;
  }
  return r.Cache = e, _d = r, _d;
}
var xd, qk;
function $R() {
  if (qk) return xd;
  qk = 1;
  var e = IR(), n = 500;
  function r(i) {
    var a = e(i, function(s) {
      return o.size === n && o.clear(), s;
    }), o = a.cache;
    return a;
  }
  return xd = r, xd;
}
var Sd, Hk;
function ER() {
  if (Hk) return Sd;
  Hk = 1;
  var e = $R(), n = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, r = /\\(\\)?/g, i = e(function(a) {
    var o = [];
    return a.charCodeAt(0) === 46 && o.push(""), a.replace(n, function(s, l, d, m) {
      o.push(d ? m.replace(r, "$1") : l || s);
    }), o;
  });
  return Sd = i, Sd;
}
var Nd, Wk;
function TC() {
  if (Wk) return Nd;
  Wk = 1;
  function e(n, r) {
    for (var i = -1, a = n == null ? 0 : n.length, o = Array(a); ++i < a; )
      o[i] = r(n[i], i, n);
    return o;
  }
  return Nd = e, Nd;
}
var jd, Kk;
function TR() {
  if (Kk) return jd;
  Kk = 1;
  var e = ts(), n = TC(), r = _i(), i = eg(), a = e ? e.prototype : void 0, o = a ? a.toString : void 0;
  function s(l) {
    if (typeof l == "string")
      return l;
    if (r(l))
      return n(l, s) + "";
    if (i(l))
      return o ? o.call(l) : "";
    var d = l + "";
    return d == "0" && 1 / l == -1 / 0 ? "-0" : d;
  }
  return jd = s, jd;
}
var wd, Gk;
function RR() {
  if (Gk) return wd;
  Gk = 1;
  var e = TR();
  function n(r) {
    return r == null ? "" : e(r);
  }
  return wd = n, wd;
}
var Cd, Yk;
function Da() {
  if (Yk) return Cd;
  Yk = 1;
  var e = _i(), n = sR(), r = ER(), i = RR();
  function a(o, s) {
    return e(o) ? o : n(o, s) ? [o] : r(i(o));
  }
  return Cd = a, Cd;
}
var Fd, Jk;
function rc() {
  if (Jk) return Fd;
  Jk = 1;
  var e = eg();
  function n(r) {
    if (typeof r == "string" || e(r))
      return r;
    var i = r + "";
    return i == "0" && 1 / r == -1 / 0 ? "-0" : i;
  }
  return Fd = n, Fd;
}
var Id, Qk;
function RC() {
  if (Qk) return Id;
  Qk = 1;
  var e = Da(), n = rc();
  function r(i, a) {
    a = e(a, i);
    for (var o = 0, s = a.length; i != null && o < s; )
      i = i[n(a[o++])];
    return o && o == s ? i : void 0;
  }
  return Id = r, Id;
}
var $d, Xk;
function DC() {
  if (Xk) return $d;
  Xk = 1;
  var e = Gi(), n = (function() {
    try {
      var r = e(Object, "defineProperty");
      return r({}, "", {}), r;
    } catch {
    }
  })();
  return $d = n, $d;
}
var Ed, Zk;
function OC() {
  if (Zk) return Ed;
  Zk = 1;
  var e = DC();
  function n(r, i, a) {
    i == "__proto__" && e ? e(r, i, {
      configurable: !0,
      enumerable: !0,
      value: a,
      writable: !0
    }) : r[i] = a;
  }
  return Ed = n, Ed;
}
var Td, eb;
function tg() {
  if (eb) return Td;
  eb = 1;
  var e = OC(), n = $C(), r = Object.prototype, i = r.hasOwnProperty;
  function a(o, s, l) {
    var d = o[s];
    (!(i.call(o, s) && n(d, l)) || l === void 0 && !(s in o)) && e(o, s, l);
  }
  return Td = a, Td;
}
var Rd, nb;
function rg() {
  if (nb) return Rd;
  nb = 1;
  var e = 9007199254740991, n = /^(?:0|[1-9]\d*)$/;
  function r(i, a) {
    var o = typeof i;
    return a = a ?? e, !!a && (o == "number" || o != "symbol" && n.test(i)) && i > -1 && i % 1 == 0 && i < a;
  }
  return Rd = r, Rd;
}
var Dd, tb;
function DR() {
  if (tb) return Dd;
  tb = 1;
  var e = tg(), n = Da(), r = rg(), i = Ra(), a = rc();
  function o(s, l, d, m) {
    if (!i(s))
      return s;
    l = n(l, s);
    for (var u = -1, f = l.length, h = f - 1, v = s; v != null && ++u < f; ) {
      var w = a(l[u]), N = d;
      if (w === "__proto__" || w === "constructor" || w === "prototype")
        return s;
      if (u != h) {
        var j = v[w];
        N = m ? m(j, w, v) : void 0, N === void 0 && (N = i(j) ? j : r(l[u + 1]) ? [] : {});
      }
      e(v, w, N), v = v[w];
    }
    return s;
  }
  return Dd = o, Dd;
}
var Od, rb;
function OR() {
  if (rb) return Od;
  rb = 1;
  var e = RC(), n = DR(), r = Da();
  function i(a, o, s) {
    for (var l = -1, d = o.length, m = {}; ++l < d; ) {
      var u = o[l], f = e(a, u);
      s(f, u) && n(m, r(u, a), f);
    }
    return m;
  }
  return Od = i, Od;
}
var Pd, ib;
function PR() {
  if (ib) return Pd;
  ib = 1;
  function e(n, r) {
    return n != null && r in Object(n);
  }
  return Pd = e, Pd;
}
var Ad, ab;
function AR() {
  if (ab) return Ad;
  ab = 1;
  var e = Ta(), n = Ki(), r = "[object Arguments]";
  function i(a) {
    return n(a) && e(a) == r;
  }
  return Ad = i, Ad;
}
var Ld, ob;
function ig() {
  if (ob) return Ld;
  ob = 1;
  var e = AR(), n = Ki(), r = Object.prototype, i = r.hasOwnProperty, a = r.propertyIsEnumerable, o = e(/* @__PURE__ */ (function() {
    return arguments;
  })()) ? e : function(s) {
    return n(s) && i.call(s, "callee") && !a.call(s, "callee");
  };
  return Ld = o, Ld;
}
var Vd, sb;
function ag() {
  if (sb) return Vd;
  sb = 1;
  var e = 9007199254740991;
  function n(r) {
    return typeof r == "number" && r > -1 && r % 1 == 0 && r <= e;
  }
  return Vd = n, Vd;
}
var zd, lb;
function LR() {
  if (lb) return zd;
  lb = 1;
  var e = Da(), n = ig(), r = _i(), i = rg(), a = ag(), o = rc();
  function s(l, d, m) {
    d = e(d, l);
    for (var u = -1, f = d.length, h = !1; ++u < f; ) {
      var v = o(d[u]);
      if (!(h = l != null && m(l, v)))
        break;
      l = l[v];
    }
    return h || ++u != f ? h : (f = l == null ? 0 : l.length, !!f && a(f) && i(v, f) && (r(l) || n(l)));
  }
  return zd = s, zd;
}
var Ud, cb;
function VR() {
  if (cb) return Ud;
  cb = 1;
  var e = PR(), n = LR();
  function r(i, a) {
    return i != null && n(i, a, e);
  }
  return Ud = r, Ud;
}
var Md, db;
function zR() {
  if (db) return Md;
  db = 1;
  var e = OR(), n = VR();
  function r(i, a) {
    return e(i, a, function(o, s) {
      return n(i, s);
    });
  }
  return Md = r, Md;
}
var Bd, ub;
function og() {
  if (ub) return Bd;
  ub = 1;
  function e(n, r) {
    for (var i = -1, a = r.length, o = n.length; ++i < a; )
      n[o + i] = r[i];
    return n;
  }
  return Bd = e, Bd;
}
var qd, mb;
function UR() {
  if (mb) return qd;
  mb = 1;
  var e = ts(), n = ig(), r = _i(), i = e ? e.isConcatSpreadable : void 0;
  function a(o) {
    return r(o) || n(o) || !!(i && o && o[i]);
  }
  return qd = a, qd;
}
var Hd, pb;
function MR() {
  if (pb) return Hd;
  pb = 1;
  var e = og(), n = UR();
  function r(i, a, o, s, l) {
    var d = -1, m = i.length;
    for (o || (o = n), l || (l = []); ++d < m; ) {
      var u = i[d];
      a > 0 && o(u) ? a > 1 ? r(u, a - 1, o, s, l) : e(l, u) : s || (l[l.length] = u);
    }
    return l;
  }
  return Hd = r, Hd;
}
var Wd, fb;
function BR() {
  if (fb) return Wd;
  fb = 1;
  var e = MR();
  function n(r) {
    var i = r == null ? 0 : r.length;
    return i ? e(r, 1) : [];
  }
  return Wd = n, Wd;
}
var Kd, hb;
function qR() {
  if (hb) return Kd;
  hb = 1;
  function e(n, r, i) {
    switch (i.length) {
      case 0:
        return n.call(r);
      case 1:
        return n.call(r, i[0]);
      case 2:
        return n.call(r, i[0], i[1]);
      case 3:
        return n.call(r, i[0], i[1], i[2]);
    }
    return n.apply(r, i);
  }
  return Kd = e, Kd;
}
var Gd, yb;
function HR() {
  if (yb) return Gd;
  yb = 1;
  var e = qR(), n = Math.max;
  function r(i, a, o) {
    return a = n(a === void 0 ? i.length - 1 : a, 0), function() {
      for (var s = arguments, l = -1, d = n(s.length - a, 0), m = Array(d); ++l < d; )
        m[l] = s[a + l];
      l = -1;
      for (var u = Array(a + 1); ++l < a; )
        u[l] = s[l];
      return u[a] = o(m), e(i, this, u);
    };
  }
  return Gd = r, Gd;
}
var Yd, gb;
function WR() {
  if (gb) return Yd;
  gb = 1;
  function e(n) {
    return function() {
      return n;
    };
  }
  return Yd = e, Yd;
}
var Jd, vb;
function PC() {
  if (vb) return Jd;
  vb = 1;
  function e(n) {
    return n;
  }
  return Jd = e, Jd;
}
var Qd, kb;
function KR() {
  if (kb) return Qd;
  kb = 1;
  var e = WR(), n = DC(), r = PC(), i = n ? function(a, o) {
    return n(a, "toString", {
      configurable: !0,
      enumerable: !1,
      value: e(o),
      writable: !0
    });
  } : r;
  return Qd = i, Qd;
}
var Xd, bb;
function GR() {
  if (bb) return Xd;
  bb = 1;
  var e = 800, n = 16, r = Date.now;
  function i(a) {
    var o = 0, s = 0;
    return function() {
      var l = r(), d = n - (l - s);
      if (s = l, d > 0) {
        if (++o >= e)
          return arguments[0];
      } else
        o = 0;
      return a.apply(void 0, arguments);
    };
  }
  return Xd = i, Xd;
}
var Zd, _b;
function YR() {
  if (_b) return Zd;
  _b = 1;
  var e = KR(), n = GR(), r = n(e);
  return Zd = r, Zd;
}
var eu, xb;
function AC() {
  if (xb) return eu;
  xb = 1;
  var e = BR(), n = HR(), r = YR();
  function i(a) {
    return r(n(a, void 0, e), a + "");
  }
  return eu = i, eu;
}
var nu, Sb;
function JR() {
  if (Sb) return nu;
  Sb = 1;
  var e = zR(), n = AC(), r = n(function(i, a) {
    return i == null ? {} : e(i, a);
  });
  return nu = r, nu;
}
var QR = JR();
const LC = /* @__PURE__ */ wC(QR), XR = [
  "control",
  "defaultValue",
  "name",
  "rules",
  "shouldUnregister"
];
function VC(e) {
  const n = LC(e, XR);
  return {
    controller: Qy(n),
    controllerProps: n
  };
}
const ZR = [
  "className",
  "description",
  "disabled",
  "helpIcon",
  "label",
  "noAlert",
  "noLabel",
  "style"
];
function zC(e) {
  const { controller: n, controllerProps: r } = VC(e), i = {
    ...LC(e, ZR),
    required: iR(r.rules?.required),
    meta: {
      touched: n.fieldState.isTouched,
      error: n.fieldState.error?.message,
      success: e.meta?.success,
      warning: e.meta?.warning
    },
    labelFor: r.name,
    noLabel: e.noLabel,
    noAlert: e.noAlert
  };
  return {
    controller: n,
    controllerProps: r,
    fieldWrapperProps: i
  };
}
var tu, Nb;
function eD() {
  if (Nb) return tu;
  Nb = 1;
  var e = nc();
  function n() {
    this.__data__ = new e(), this.size = 0;
  }
  return tu = n, tu;
}
var ru, jb;
function nD() {
  if (jb) return ru;
  jb = 1;
  function e(n) {
    var r = this.__data__, i = r.delete(n);
    return this.size = r.size, i;
  }
  return ru = e, ru;
}
var iu, wb;
function tD() {
  if (wb) return iu;
  wb = 1;
  function e(n) {
    return this.__data__.get(n);
  }
  return iu = e, iu;
}
var au, Cb;
function rD() {
  if (Cb) return au;
  Cb = 1;
  function e(n) {
    return this.__data__.has(n);
  }
  return au = e, au;
}
var ou, Fb;
function iD() {
  if (Fb) return ou;
  Fb = 1;
  var e = nc(), n = ng(), r = EC(), i = 200;
  function a(o, s) {
    var l = this.__data__;
    if (l instanceof e) {
      var d = l.__data__;
      if (!n || d.length < i - 1)
        return d.push([o, s]), this.size = ++l.size, this;
      l = this.__data__ = new r(d);
    }
    return l.set(o, s), this.size = l.size, this;
  }
  return ou = a, ou;
}
var su, Ib;
function aD() {
  if (Ib) return su;
  Ib = 1;
  var e = nc(), n = eD(), r = nD(), i = tD(), a = rD(), o = iD();
  function s(l) {
    var d = this.__data__ = new e(l);
    this.size = d.size;
  }
  return s.prototype.clear = n, s.prototype.delete = r, s.prototype.get = i, s.prototype.has = a, s.prototype.set = o, su = s, su;
}
var lu, $b;
function oD() {
  if ($b) return lu;
  $b = 1;
  function e(n, r) {
    for (var i = -1, a = n == null ? 0 : n.length; ++i < a && r(n[i], i, n) !== !1; )
      ;
    return n;
  }
  return lu = e, lu;
}
var cu, Eb;
function rs() {
  if (Eb) return cu;
  Eb = 1;
  var e = tg(), n = OC();
  function r(i, a, o, s) {
    var l = !o;
    o || (o = {});
    for (var d = -1, m = a.length; ++d < m; ) {
      var u = a[d], f = s ? s(o[u], i[u], u, o, i) : void 0;
      f === void 0 && (f = i[u]), l ? n(o, u, f) : e(o, u, f);
    }
    return o;
  }
  return cu = r, cu;
}
var du, Tb;
function sD() {
  if (Tb) return du;
  Tb = 1;
  function e(n, r) {
    for (var i = -1, a = Array(n); ++i < n; )
      a[i] = r(i);
    return a;
  }
  return du = e, du;
}
var rl = { exports: {} }, uu, Rb;
function lD() {
  if (Rb) return uu;
  Rb = 1;
  function e() {
    return !1;
  }
  return uu = e, uu;
}
rl.exports;
var Db;
function UC() {
  return Db || (Db = 1, (function(e, n) {
    var r = Yr(), i = lD(), a = n && !n.nodeType && n, o = a && !0 && e && !e.nodeType && e, s = o && o.exports === a, l = s ? r.Buffer : void 0, d = l ? l.isBuffer : void 0, m = d || i;
    e.exports = m;
  })(rl, rl.exports)), rl.exports;
}
var mu, Ob;
function cD() {
  if (Ob) return mu;
  Ob = 1;
  var e = Ta(), n = ag(), r = Ki(), i = "[object Arguments]", a = "[object Array]", o = "[object Boolean]", s = "[object Date]", l = "[object Error]", d = "[object Function]", m = "[object Map]", u = "[object Number]", f = "[object Object]", h = "[object RegExp]", v = "[object Set]", w = "[object String]", N = "[object WeakMap]", j = "[object ArrayBuffer]", _ = "[object DataView]", g = "[object Float32Array]", O = "[object Float64Array]", R = "[object Int8Array]", $ = "[object Int16Array]", I = "[object Int32Array]", L = "[object Uint8Array]", G = "[object Uint8ClampedArray]", Q = "[object Uint16Array]", ne = "[object Uint32Array]", q = {};
  q[g] = q[O] = q[R] = q[$] = q[I] = q[L] = q[G] = q[Q] = q[ne] = !0, q[i] = q[a] = q[j] = q[o] = q[_] = q[s] = q[l] = q[d] = q[m] = q[u] = q[f] = q[h] = q[v] = q[w] = q[N] = !1;
  function Y(P) {
    return r(P) && n(P.length) && !!q[e(P)];
  }
  return mu = Y, mu;
}
var pu, Pb;
function sg() {
  if (Pb) return pu;
  Pb = 1;
  function e(n) {
    return function(r) {
      return n(r);
    };
  }
  return pu = e, pu;
}
var il = { exports: {} };
il.exports;
var Ab;
function lg() {
  return Ab || (Ab = 1, (function(e, n) {
    var r = CC(), i = n && !n.nodeType && n, a = i && !0 && e && !e.nodeType && e, o = a && a.exports === i, s = o && r.process, l = (function() {
      try {
        var d = a && a.require && a.require("util").types;
        return d || s && s.binding && s.binding("util");
      } catch {
      }
    })();
    e.exports = l;
  })(il, il.exports)), il.exports;
}
var fu, Lb;
function dD() {
  if (Lb) return fu;
  Lb = 1;
  var e = cD(), n = sg(), r = lg(), i = r && r.isTypedArray, a = i ? n(i) : e;
  return fu = a, fu;
}
var hu, Vb;
function MC() {
  if (Vb) return hu;
  Vb = 1;
  var e = sD(), n = ig(), r = _i(), i = UC(), a = rg(), o = dD(), s = Object.prototype, l = s.hasOwnProperty;
  function d(m, u) {
    var f = r(m), h = !f && n(m), v = !f && !h && i(m), w = !f && !h && !v && o(m), N = f || h || v || w, j = N ? e(m.length, String) : [], _ = j.length;
    for (var g in m)
      (u || l.call(m, g)) && !(N && // Safari 9 has enumerable `arguments.length` in strict mode.
      (g == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      v && (g == "offset" || g == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      w && (g == "buffer" || g == "byteLength" || g == "byteOffset") || // Skip index properties.
      a(g, _))) && j.push(g);
    return j;
  }
  return hu = d, hu;
}
var yu, zb;
function cg() {
  if (zb) return yu;
  zb = 1;
  var e = Object.prototype;
  function n(r) {
    var i = r && r.constructor, a = typeof i == "function" && i.prototype || e;
    return r === a;
  }
  return yu = n, yu;
}
var gu, Ub;
function BC() {
  if (Ub) return gu;
  Ub = 1;
  function e(n, r) {
    return function(i) {
      return n(r(i));
    };
  }
  return gu = e, gu;
}
var vu, Mb;
function uD() {
  if (Mb) return vu;
  Mb = 1;
  var e = BC(), n = e(Object.keys, Object);
  return vu = n, vu;
}
var ku, Bb;
function mD() {
  if (Bb) return ku;
  Bb = 1;
  var e = cg(), n = uD(), r = Object.prototype, i = r.hasOwnProperty;
  function a(o) {
    if (!e(o))
      return n(o);
    var s = [];
    for (var l in Object(o))
      i.call(o, l) && l != "constructor" && s.push(l);
    return s;
  }
  return ku = a, ku;
}
var bu, qb;
function qC() {
  if (qb) return bu;
  qb = 1;
  var e = FC(), n = ag();
  function r(i) {
    return i != null && n(i.length) && !e(i);
  }
  return bu = r, bu;
}
var _u, Hb;
function dg() {
  if (Hb) return _u;
  Hb = 1;
  var e = MC(), n = mD(), r = qC();
  function i(a) {
    return r(a) ? e(a) : n(a);
  }
  return _u = i, _u;
}
var xu, Wb;
function pD() {
  if (Wb) return xu;
  Wb = 1;
  var e = rs(), n = dg();
  function r(i, a) {
    return i && e(a, n(a), i);
  }
  return xu = r, xu;
}
var Su, Kb;
function fD() {
  if (Kb) return Su;
  Kb = 1;
  function e(n) {
    var r = [];
    if (n != null)
      for (var i in Object(n))
        r.push(i);
    return r;
  }
  return Su = e, Su;
}
var Nu, Gb;
function hD() {
  if (Gb) return Nu;
  Gb = 1;
  var e = Ra(), n = cg(), r = fD(), i = Object.prototype, a = i.hasOwnProperty;
  function o(s) {
    if (!e(s))
      return r(s);
    var l = n(s), d = [];
    for (var m in s)
      m == "constructor" && (l || !a.call(s, m)) || d.push(m);
    return d;
  }
  return Nu = o, Nu;
}
var ju, Yb;
function ug() {
  if (Yb) return ju;
  Yb = 1;
  var e = MC(), n = hD(), r = qC();
  function i(a) {
    return r(a) ? e(a, !0) : n(a);
  }
  return ju = i, ju;
}
var wu, Jb;
function yD() {
  if (Jb) return wu;
  Jb = 1;
  var e = rs(), n = ug();
  function r(i, a) {
    return i && e(a, n(a), i);
  }
  return wu = r, wu;
}
var al = { exports: {} };
al.exports;
var Qb;
function gD() {
  return Qb || (Qb = 1, (function(e, n) {
    var r = Yr(), i = n && !n.nodeType && n, a = i && !0 && e && !e.nodeType && e, o = a && a.exports === i, s = o ? r.Buffer : void 0, l = s ? s.allocUnsafe : void 0;
    function d(m, u) {
      if (u)
        return m.slice();
      var f = m.length, h = l ? l(f) : new m.constructor(f);
      return m.copy(h), h;
    }
    e.exports = d;
  })(al, al.exports)), al.exports;
}
var Cu, Xb;
function vD() {
  if (Xb) return Cu;
  Xb = 1;
  function e(n, r) {
    var i = -1, a = n.length;
    for (r || (r = Array(a)); ++i < a; )
      r[i] = n[i];
    return r;
  }
  return Cu = e, Cu;
}
var Fu, Zb;
function kD() {
  if (Zb) return Fu;
  Zb = 1;
  function e(n, r) {
    for (var i = -1, a = n == null ? 0 : n.length, o = 0, s = []; ++i < a; ) {
      var l = n[i];
      r(l, i, n) && (s[o++] = l);
    }
    return s;
  }
  return Fu = e, Fu;
}
var Iu, e_;
function HC() {
  if (e_) return Iu;
  e_ = 1;
  function e() {
    return [];
  }
  return Iu = e, Iu;
}
var $u, n_;
function mg() {
  if (n_) return $u;
  n_ = 1;
  var e = kD(), n = HC(), r = Object.prototype, i = r.propertyIsEnumerable, a = Object.getOwnPropertySymbols, o = a ? function(s) {
    return s == null ? [] : (s = Object(s), e(a(s), function(l) {
      return i.call(s, l);
    }));
  } : n;
  return $u = o, $u;
}
var Eu, t_;
function bD() {
  if (t_) return Eu;
  t_ = 1;
  var e = rs(), n = mg();
  function r(i, a) {
    return e(i, n(i), a);
  }
  return Eu = r, Eu;
}
var Tu, r_;
function pg() {
  if (r_) return Tu;
  r_ = 1;
  var e = BC(), n = e(Object.getPrototypeOf, Object);
  return Tu = n, Tu;
}
var Ru, i_;
function WC() {
  if (i_) return Ru;
  i_ = 1;
  var e = og(), n = pg(), r = mg(), i = HC(), a = Object.getOwnPropertySymbols, o = a ? function(s) {
    for (var l = []; s; )
      e(l, r(s)), s = n(s);
    return l;
  } : i;
  return Ru = o, Ru;
}
var Du, a_;
function _D() {
  if (a_) return Du;
  a_ = 1;
  var e = rs(), n = WC();
  function r(i, a) {
    return e(i, n(i), a);
  }
  return Du = r, Du;
}
var Ou, o_;
function KC() {
  if (o_) return Ou;
  o_ = 1;
  var e = og(), n = _i();
  function r(i, a, o) {
    var s = a(i);
    return n(i) ? s : e(s, o(i));
  }
  return Ou = r, Ou;
}
var Pu, s_;
function xD() {
  if (s_) return Pu;
  s_ = 1;
  var e = KC(), n = mg(), r = dg();
  function i(a) {
    return e(a, r, n);
  }
  return Pu = i, Pu;
}
var Au, l_;
function GC() {
  if (l_) return Au;
  l_ = 1;
  var e = KC(), n = WC(), r = ug();
  function i(a) {
    return e(a, r, n);
  }
  return Au = i, Au;
}
var Lu, c_;
function SD() {
  if (c_) return Lu;
  c_ = 1;
  var e = Gi(), n = Yr(), r = e(n, "DataView");
  return Lu = r, Lu;
}
var Vu, d_;
function ND() {
  if (d_) return Vu;
  d_ = 1;
  var e = Gi(), n = Yr(), r = e(n, "Promise");
  return Vu = r, Vu;
}
var zu, u_;
function jD() {
  if (u_) return zu;
  u_ = 1;
  var e = Gi(), n = Yr(), r = e(n, "Set");
  return zu = r, zu;
}
var Uu, m_;
function wD() {
  if (m_) return Uu;
  m_ = 1;
  var e = Gi(), n = Yr(), r = e(n, "WeakMap");
  return Uu = r, Uu;
}
var Mu, p_;
function fg() {
  if (p_) return Mu;
  p_ = 1;
  var e = SD(), n = ng(), r = ND(), i = jD(), a = wD(), o = Ta(), s = IC(), l = "[object Map]", d = "[object Object]", m = "[object Promise]", u = "[object Set]", f = "[object WeakMap]", h = "[object DataView]", v = s(e), w = s(n), N = s(r), j = s(i), _ = s(a), g = o;
  return (e && g(new e(new ArrayBuffer(1))) != h || n && g(new n()) != l || r && g(r.resolve()) != m || i && g(new i()) != u || a && g(new a()) != f) && (g = function(O) {
    var R = o(O), $ = R == d ? O.constructor : void 0, I = $ ? s($) : "";
    if (I)
      switch (I) {
        case v:
          return h;
        case w:
          return l;
        case N:
          return m;
        case j:
          return u;
        case _:
          return f;
      }
    return R;
  }), Mu = g, Mu;
}
var Bu, f_;
function CD() {
  if (f_) return Bu;
  f_ = 1;
  var e = Object.prototype, n = e.hasOwnProperty;
  function r(i) {
    var a = i.length, o = new i.constructor(a);
    return a && typeof i[0] == "string" && n.call(i, "index") && (o.index = i.index, o.input = i.input), o;
  }
  return Bu = r, Bu;
}
var qu, h_;
function FD() {
  if (h_) return qu;
  h_ = 1;
  var e = Yr(), n = e.Uint8Array;
  return qu = n, qu;
}
var Hu, y_;
function hg() {
  if (y_) return Hu;
  y_ = 1;
  var e = FD();
  function n(r) {
    var i = new r.constructor(r.byteLength);
    return new e(i).set(new e(r)), i;
  }
  return Hu = n, Hu;
}
var Wu, g_;
function ID() {
  if (g_) return Wu;
  g_ = 1;
  var e = hg();
  function n(r, i) {
    var a = i ? e(r.buffer) : r.buffer;
    return new r.constructor(a, r.byteOffset, r.byteLength);
  }
  return Wu = n, Wu;
}
var Ku, v_;
function $D() {
  if (v_) return Ku;
  v_ = 1;
  var e = /\w*$/;
  function n(r) {
    var i = new r.constructor(r.source, e.exec(r));
    return i.lastIndex = r.lastIndex, i;
  }
  return Ku = n, Ku;
}
var Gu, k_;
function ED() {
  if (k_) return Gu;
  k_ = 1;
  var e = ts(), n = e ? e.prototype : void 0, r = n ? n.valueOf : void 0;
  function i(a) {
    return r ? Object(r.call(a)) : {};
  }
  return Gu = i, Gu;
}
var Yu, b_;
function TD() {
  if (b_) return Yu;
  b_ = 1;
  var e = hg();
  function n(r, i) {
    var a = i ? e(r.buffer) : r.buffer;
    return new r.constructor(a, r.byteOffset, r.length);
  }
  return Yu = n, Yu;
}
var Ju, __;
function RD() {
  if (__) return Ju;
  __ = 1;
  var e = hg(), n = ID(), r = $D(), i = ED(), a = TD(), o = "[object Boolean]", s = "[object Date]", l = "[object Map]", d = "[object Number]", m = "[object RegExp]", u = "[object Set]", f = "[object String]", h = "[object Symbol]", v = "[object ArrayBuffer]", w = "[object DataView]", N = "[object Float32Array]", j = "[object Float64Array]", _ = "[object Int8Array]", g = "[object Int16Array]", O = "[object Int32Array]", R = "[object Uint8Array]", $ = "[object Uint8ClampedArray]", I = "[object Uint16Array]", L = "[object Uint32Array]";
  function G(Q, ne, q) {
    var Y = Q.constructor;
    switch (ne) {
      case v:
        return e(Q);
      case o:
      case s:
        return new Y(+Q);
      case w:
        return n(Q, q);
      case N:
      case j:
      case _:
      case g:
      case O:
      case R:
      case $:
      case I:
      case L:
        return a(Q, q);
      case l:
        return new Y();
      case d:
      case f:
        return new Y(Q);
      case m:
        return r(Q);
      case u:
        return new Y();
      case h:
        return i(Q);
    }
  }
  return Ju = G, Ju;
}
var Qu, x_;
function DD() {
  if (x_) return Qu;
  x_ = 1;
  var e = Ra(), n = Object.create, r = /* @__PURE__ */ (function() {
    function i() {
    }
    return function(a) {
      if (!e(a))
        return {};
      if (n)
        return n(a);
      i.prototype = a;
      var o = new i();
      return i.prototype = void 0, o;
    };
  })();
  return Qu = r, Qu;
}
var Xu, S_;
function OD() {
  if (S_) return Xu;
  S_ = 1;
  var e = DD(), n = pg(), r = cg();
  function i(a) {
    return typeof a.constructor == "function" && !r(a) ? e(n(a)) : {};
  }
  return Xu = i, Xu;
}
var Zu, N_;
function PD() {
  if (N_) return Zu;
  N_ = 1;
  var e = fg(), n = Ki(), r = "[object Map]";
  function i(a) {
    return n(a) && e(a) == r;
  }
  return Zu = i, Zu;
}
var em, j_;
function AD() {
  if (j_) return em;
  j_ = 1;
  var e = PD(), n = sg(), r = lg(), i = r && r.isMap, a = i ? n(i) : e;
  return em = a, em;
}
var nm, w_;
function LD() {
  if (w_) return nm;
  w_ = 1;
  var e = fg(), n = Ki(), r = "[object Set]";
  function i(a) {
    return n(a) && e(a) == r;
  }
  return nm = i, nm;
}
var tm, C_;
function VD() {
  if (C_) return tm;
  C_ = 1;
  var e = LD(), n = sg(), r = lg(), i = r && r.isSet, a = i ? n(i) : e;
  return tm = a, tm;
}
var rm, F_;
function zD() {
  if (F_) return rm;
  F_ = 1;
  var e = aD(), n = oD(), r = tg(), i = pD(), a = yD(), o = gD(), s = vD(), l = bD(), d = _D(), m = xD(), u = GC(), f = fg(), h = CD(), v = RD(), w = OD(), N = _i(), j = UC(), _ = AD(), g = Ra(), O = VD(), R = dg(), $ = ug(), I = 1, L = 2, G = 4, Q = "[object Arguments]", ne = "[object Array]", q = "[object Boolean]", Y = "[object Date]", P = "[object Error]", B = "[object Function]", ie = "[object GeneratorFunction]", je = "[object Map]", pe = "[object Number]", le = "[object Object]", ge = "[object RegExp]", V = "[object Set]", be = "[object String]", Oe = "[object Symbol]", H = "[object WeakMap]", Ye = "[object ArrayBuffer]", ln = "[object DataView]", Ie = "[object Float32Array]", Ue = "[object Float64Array]", De = "[object Int8Array]", Be = "[object Int16Array]", Ae = "[object Int32Array]", Qe = "[object Uint8Array]", Ee = "[object Uint8ClampedArray]", Me = "[object Uint16Array]", en = "[object Uint32Array]", se = {};
  se[Q] = se[ne] = se[Ye] = se[ln] = se[q] = se[Y] = se[Ie] = se[Ue] = se[De] = se[Be] = se[Ae] = se[je] = se[pe] = se[le] = se[ge] = se[V] = se[be] = se[Oe] = se[Qe] = se[Ee] = se[Me] = se[en] = !0, se[P] = se[B] = se[H] = !1;
  function ce(Se, Ve, Pe, kn, X, E) {
    var z, ae = Ve & I, de = Ve & L, U = Ve & G;
    if (Pe && (z = X ? Pe(Se, kn, X, E) : Pe(Se)), z !== void 0)
      return z;
    if (!g(Se))
      return Se;
    var J = N(Se);
    if (J) {
      if (z = h(Se), !ae)
        return s(Se, z);
    } else {
      var ve = f(Se), we = ve == B || ve == ie;
      if (j(Se))
        return o(Se, ae);
      if (ve == le || ve == Q || we && !X) {
        if (z = de || we ? {} : w(Se), !ae)
          return de ? d(Se, a(z, Se)) : l(Se, i(z, Se));
      } else {
        if (!se[ve])
          return X ? Se : {};
        z = v(Se, ve, ae);
      }
    }
    E || (E = new e());
    var Re = E.get(Se);
    if (Re)
      return Re;
    E.set(Se, z), O(Se) ? Se.forEach(function(an) {
      z.add(ce(an, Ve, Pe, an, Se, E));
    }) : _(Se) && Se.forEach(function(an, hn) {
      z.set(hn, ce(an, Ve, Pe, hn, Se, E));
    });
    var rn = U ? de ? u : m : de ? $ : R, bn = J ? void 0 : rn(Se);
    return n(bn || Se, function(an, hn) {
      bn && (hn = an, an = Se[hn]), r(z, hn, ce(an, Ve, Pe, hn, Se, E));
    }), z;
  }
  return rm = ce, rm;
}
var im, I_;
function UD() {
  if (I_) return im;
  I_ = 1;
  function e(n) {
    var r = n == null ? 0 : n.length;
    return r ? n[r - 1] : void 0;
  }
  return im = e, im;
}
var am, $_;
function MD() {
  if ($_) return am;
  $_ = 1;
  function e(n, r, i) {
    var a = -1, o = n.length;
    r < 0 && (r = -r > o ? 0 : o + r), i = i > o ? o : i, i < 0 && (i += o), o = r > i ? 0 : i - r >>> 0, r >>>= 0;
    for (var s = Array(o); ++a < o; )
      s[a] = n[a + r];
    return s;
  }
  return am = e, am;
}
var om, E_;
function BD() {
  if (E_) return om;
  E_ = 1;
  var e = RC(), n = MD();
  function r(i, a) {
    return a.length < 2 ? i : e(i, n(a, 0, -1));
  }
  return om = r, om;
}
var sm, T_;
function qD() {
  if (T_) return sm;
  T_ = 1;
  var e = Da(), n = UD(), r = BD(), i = rc(), a = Object.prototype, o = a.hasOwnProperty;
  function s(l, d) {
    d = e(d, l);
    var m = -1, u = d.length;
    if (!u)
      return !0;
    for (; ++m < u; ) {
      var f = i(d[m]);
      if (f === "__proto__" && !o.call(l, "__proto__") || (f === "constructor" || f === "prototype") && m < u - 1)
        return !1;
    }
    var h = r(l, d);
    return h == null || delete h[i(n(d))];
  }
  return sm = s, sm;
}
var lm, R_;
function HD() {
  if (R_) return lm;
  R_ = 1;
  var e = Ta(), n = pg(), r = Ki(), i = "[object Object]", a = Function.prototype, o = Object.prototype, s = a.toString, l = o.hasOwnProperty, d = s.call(Object);
  function m(u) {
    if (!r(u) || e(u) != i)
      return !1;
    var f = n(u);
    if (f === null)
      return !0;
    var h = l.call(f, "constructor") && f.constructor;
    return typeof h == "function" && h instanceof h && s.call(h) == d;
  }
  return lm = m, lm;
}
var cm, D_;
function WD() {
  if (D_) return cm;
  D_ = 1;
  var e = HD();
  function n(r) {
    return e(r) ? void 0 : r;
  }
  return cm = n, cm;
}
var dm, O_;
function KD() {
  if (O_) return dm;
  O_ = 1;
  var e = TC(), n = zD(), r = qD(), i = Da(), a = rs(), o = WD(), s = AC(), l = GC(), d = 1, m = 2, u = 4, f = s(function(h, v) {
    var w = {};
    if (h == null)
      return w;
    var N = !1;
    v = e(v, function(_) {
      return _ = i(_, h), N || (N = _.length > 1), _;
    }), a(h, l(h), w), N && (w = n(w, d | m | u, o));
    for (var j = v.length; j--; )
      r(w, v[j]);
    return w;
  });
  return dm = f, dm;
}
KD();
const mr = ({
  children: e,
  ...n
}) => {
  const { controller: r, controllerProps: i, fieldWrapperProps: a } = zC(n), {
    name: o,
    onBlur: s,
    onChange: l,
    ...d
  } = r.field;
  return /* @__PURE__ */ Ui.jsx(qe, { ...a, children: /* @__PURE__ */ Ui.jsx(
    hi,
    {
      ...n.componentProps,
      ...d,
      multiple: !1,
      value: d.value ? [d.value] : [],
      onBlur: (m) => {
        n.componentProps?.onBlur?.(m), s();
      },
      onChange: (m) => {
        n.componentProps?.onChange?.(m), l(m.selectedValues[0] ?? null);
      },
      id: i.name,
      "aria-disabled": a.disabled,
      disabled: a.disabled,
      "aria-required": a.required,
      required: a.required,
      status: qe.getStatus(a.meta),
      children: e
    }
  ) });
};
var GD = PC();
const YD = /* @__PURE__ */ wC(GD), yn = ({
  transformValue: e = YD,
  label: n,
  helpIcon: r,
  className: i,
  ...a
}) => {
  const {
    controller: { field: o },
    controllerProps: { name: s }
  } = VC(a);
  return /* @__PURE__ */ Ui.jsxs(b, { gap: "200", alignItems: "center", className: i, children: [
    /* @__PURE__ */ Ui.jsx(
      Vo,
      {
        ...o,
        id: s,
        checked: e(o.value),
        disabled: a.componentProps?.disabled,
        onChange: (l) => {
          a.componentProps?.onChange?.(l), o.onChange(e(l.target.checked));
        }
      }
    ),
    n && /* @__PURE__ */ Ui.jsx(ww, { htmlFor: s, helpIcon: r, children: n })
  ] });
}, Rn = (e) => {
  const { controller: n, controllerProps: r, fieldWrapperProps: i } = zC(e);
  return /* @__PURE__ */ Ui.jsx(qe, { ...i, children: /* @__PURE__ */ Ui.jsx(
    ur,
    {
      ...e.componentProps,
      ...n.field,
      value: e.componentProps?.type === "number" && isNaN(n.field.value) ? "" : n.field.value ?? "",
      onBlur: (a) => {
        e.componentProps?.onBlur?.(a), n.field.onBlur();
      },
      onChange: (a) => {
        e.componentProps?.onChange?.(a), n.field.onChange(
          e.componentProps?.type === "number" ? a.target.valueAsNumber : a
        );
      },
      id: r.name,
      "aria-disabled": i.disabled,
      disabled: i.disabled,
      "aria-required": i.required,
      required: i.required,
      status: qe.getStatus(i.meta)
    }
  ) });
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode('@charset "UTF-8";._copyIcon_10dvk_54{cursor:pointer;color:var(--dixa-typography-color-secondary)}._list_10dvk_59{padding:0;max-height:250px;overflow-y:auto;background:linear-gradient(var(--dixa-color-neutral-000) 33%,rgba(255,255,255,0)),linear-gradient(rgba(255,255,255,0),var(--dixa-color-neutral-000) 66%) 0 100%,radial-gradient(farthest-side at 50% 0,var(--dixa-color-neutral-200),rgba(0,0,0,0)),radial-gradient(farthest-side at 50% 100%,var(--dixa-color-neutral-200),rgba(0,0,0,0)) 0 100%;background-color:var(--dixa-color-neutral-000);background-repeat:no-repeat;background-attachment:local,local,scroll,scroll;background-size:100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-200),100% var(--dixa-size-spacer-200)}._listItem_10dvk_69{background-color:transparent;padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_10dvk_69:last-child:not(:only-child){border-bottom:none}._collapsible_10dvk_78{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._collapsible_10dvk_78:hover,._collapsibleIsOpen_10dvk_86{border-color:var(--dixa-color-neutral-400)}._collapsibleHeader_10dvk_89{cursor:pointer}._collapsibleIconTrue_10dvk_92{color:var(--dixa-color-green-500)}._collapsibleIconFalse_10dvk_95{color:var(--dixa-color-red-500)}._wrapper_1xucg_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._externalLink_1xucg_7{color:var(--dixa-typography-color-primary);font-size:var(--dixa-typography-size-200)}')), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var um = { exports: {} }, Ga = {}, P_;
function JD() {
  if (P_) return Ga;
  P_ = 1;
  var e = He, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (v = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return Ga.Fragment = r, Ga.jsx = s, Ga.jsxs = s, Ga;
}
var gs = {}, A_;
function QD() {
  return A_ || (A_ = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = He, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), d = /* @__PURE__ */ Symbol.for("react.forward_ref"), m = /* @__PURE__ */ Symbol.for("react.suspense"), u = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), v = /* @__PURE__ */ Symbol.for("react.offscreen"), w = Symbol.iterator, N = "@@iterator";
    function j(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = w && t[w] || t[N];
      return typeof c == "function" ? c : null;
    }
    var _ = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          p[y - 1] = arguments[y];
        O("error", t, p);
      }
    }
    function O(t, c, p) {
      {
        var y = _.ReactDebugCurrentFrame, C = y.getStackAddendum();
        C !== "" && (c += "%s", p = p.concat([C]));
        var T = p.map(function(S) {
          return String(S);
        });
        T.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, T);
      }
    }
    var R = !1, $ = !1, I = !1, L = !1, G = !1, Q;
    Q = /* @__PURE__ */ Symbol.for("react.module.reference");
    function ne(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || G || t === a || t === m || t === u || L || t === v || R || $ || I || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Q || t.getModuleId !== void 0));
    }
    function q(t, c, p) {
      var y = t.displayName;
      if (y)
        return y;
      var C = c.displayName || c.name || "";
      return C !== "" ? p + "(" + C + ")" : p;
    }
    function Y(t) {
      return t.displayName || "Context";
    }
    function P(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return Y(c) + ".Consumer";
          case s:
            var p = t;
            return Y(p._context) + ".Provider";
          case d:
            return q(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : P(t.type) || "Memo";
          case h: {
            var C = t, T = C._payload, S = C._init;
            try {
              return P(S(T));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var B = Object.assign, ie = 0, je, pe, le, ge, V, be, Oe;
    function H() {
    }
    H.__reactDisabledLog = !0;
    function Ye() {
      {
        if (ie === 0) {
          je = console.log, pe = console.info, le = console.warn, ge = console.error, V = console.group, be = console.groupCollapsed, Oe = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: H,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ie++;
      }
    }
    function ln() {
      {
        if (ie--, ie === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: B({}, t, {
              value: je
            }),
            info: B({}, t, {
              value: pe
            }),
            warn: B({}, t, {
              value: le
            }),
            error: B({}, t, {
              value: ge
            }),
            group: B({}, t, {
              value: V
            }),
            groupCollapsed: B({}, t, {
              value: be
            }),
            groupEnd: B({}, t, {
              value: Oe
            })
          });
        }
        ie < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Ie = _.ReactCurrentDispatcher, Ue;
    function De(t, c, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (C) {
            var y = C.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Be = !1, Ae;
    {
      var Qe = typeof WeakMap == "function" ? WeakMap : Map;
      Ae = new Qe();
    }
    function Ee(t, c) {
      if (!t || Be)
        return "";
      {
        var p = Ae.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Be = !0;
      var C = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var T;
      T = Ie.current, Ie.current = null, Ye();
      try {
        if (c) {
          var S = function() {
            throw Error();
          };
          if (Object.defineProperty(S.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(S, []);
            } catch (re) {
              y = re;
            }
            Reflect.construct(t, [], S);
          } else {
            try {
              S.call();
            } catch (re) {
              y = re;
            }
            t.call(S.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (re) {
            y = re;
          }
          t();
        }
      } catch (re) {
        if (re && y && typeof re.stack == "string") {
          for (var x = re.stack.split(`
`), ee = y.stack.split(`
`), A = x.length - 1, M = ee.length - 1; A >= 1 && M >= 0 && x[A] !== ee[M]; )
            M--;
          for (; A >= 1 && M >= 0; A--, M--)
            if (x[A] !== ee[M]) {
              if (A !== 1 || M !== 1)
                do
                  if (A--, M--, M < 0 || x[A] !== ee[M]) {
                    var ue = `
` + x[A].replace(" at new ", " at ");
                    return t.displayName && ue.includes("<anonymous>") && (ue = ue.replace("<anonymous>", t.displayName)), typeof t == "function" && Ae.set(t, ue), ue;
                  }
                while (A >= 1 && M >= 0);
              break;
            }
        }
      } finally {
        Be = !1, Ie.current = T, ln(), Error.prepareStackTrace = C;
      }
      var ze = t ? t.displayName || t.name : "", Te = ze ? De(ze) : "";
      return typeof t == "function" && Ae.set(t, Te), Te;
    }
    function Me(t, c, p) {
      return Ee(t, !1);
    }
    function en(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function se(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ee(t, en(t));
      if (typeof t == "string")
        return De(t);
      switch (t) {
        case m:
          return De("Suspense");
        case u:
          return De("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Me(t.render);
          case f:
            return se(t.type, c, p);
          case h: {
            var y = t, C = y._payload, T = y._init;
            try {
              return se(T(C), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var ce = Object.prototype.hasOwnProperty, Se = {}, Ve = _.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, p = se(t.type, t._source, c ? c.type : null);
        Ve.setExtraStackFrame(p);
      } else
        Ve.setExtraStackFrame(null);
    }
    function kn(t, c, p, y, C) {
      {
        var T = Function.call.bind(ce);
        for (var S in t)
          if (T(t, S)) {
            var x = void 0;
            try {
              if (typeof t[S] != "function") {
                var ee = Error((y || "React class") + ": " + p + " type `" + S + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[S] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ee.name = "Invariant Violation", ee;
              }
              x = t[S](c, S, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (A) {
              x = A;
            }
            x && !(x instanceof Error) && (Pe(C), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, S, typeof x), Pe(null)), x instanceof Error && !(x.message in Se) && (Se[x.message] = !0, Pe(C), g("Failed %s type: %s", p, x.message), Pe(null));
          }
      }
    }
    var X = Array.isArray;
    function E(t) {
      return X(t);
    }
    function z(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function ae(t) {
      try {
        return de(t), !1;
      } catch {
        return !0;
      }
    }
    function de(t) {
      return "" + t;
    }
    function U(t) {
      if (ae(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", z(t)), de(t);
    }
    var J = _.ReactCurrentOwner, ve = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, we, Re;
    function rn(t) {
      if (ce.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function bn(t) {
      if (ce.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function an(t, c) {
      typeof t.ref == "string" && J.current;
    }
    function hn(t, c) {
      {
        var p = function() {
          we || (we = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function En(t, c) {
      {
        var p = function() {
          Re || (Re = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var _n = function(t, c, p, y, C, T, S) {
      var x = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: S,
        // Record the component responsible for creating this element.
        _owner: T
      };
      return x._store = {}, Object.defineProperty(x._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(x, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(x, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: C
      }), Object.freeze && (Object.freeze(x.props), Object.freeze(x)), x;
    };
    function Fn(t, c, p, y, C) {
      {
        var T, S = {}, x = null, ee = null;
        p !== void 0 && (U(p), x = "" + p), bn(c) && (U(c.key), x = "" + c.key), rn(c) && (ee = c.ref, an(c));
        for (T in c)
          ce.call(c, T) && !ve.hasOwnProperty(T) && (S[T] = c[T]);
        if (t && t.defaultProps) {
          var A = t.defaultProps;
          for (T in A)
            S[T] === void 0 && (S[T] = A[T]);
        }
        if (x || ee) {
          var M = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          x && hn(S, M), ee && En(S, M);
        }
        return _n(t, x, ee, C, y, J.current, S);
      }
    }
    var Ze = _.ReactCurrentOwner, gn = _.ReactDebugCurrentFrame;
    function Le(t) {
      if (t) {
        var c = t._owner, p = se(t.type, t._source, c ? c.type : null);
        gn.setExtraStackFrame(p);
      } else
        gn.setExtraStackFrame(null);
    }
    var dn;
    dn = !1;
    function un(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function Nn() {
      {
        if (Ze.current) {
          var t = P(Ze.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Bn(t) {
      return "";
    }
    var Sn = {};
    function An(t) {
      {
        var c = Nn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function vn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = An(c);
        if (Sn[p])
          return;
        Sn[p] = !0;
        var y = "";
        t && t._owner && t._owner !== Ze.current && (y = " It was passed a child from " + P(t._owner.type) + "."), Le(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Le(null);
      }
    }
    function xn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (E(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            un(y) && vn(y, c);
          }
        else if (un(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var C = j(t);
          if (typeof C == "function" && C !== t.entries)
            for (var T = C.call(t), S; !(S = T.next()).done; )
              un(S.value) && vn(S.value, c);
        }
      }
    }
    function Ln(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var y = P(c);
          kn(p, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !dn) {
          dn = !0;
          var C = P(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", C || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var y = c[p];
          if (y !== "children" && y !== "key") {
            Le(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Le(null);
            break;
          }
        }
        t.ref !== null && (Le(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Le(null));
      }
    }
    var Cn = {};
    function wn(t, c, p, y, C, T) {
      {
        var S = ne(t);
        if (!S) {
          var x = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (x += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ee = Bn();
          ee ? x += ee : x += Nn();
          var A;
          t === null ? A = "null" : E(t) ? A = "array" : t !== void 0 && t.$$typeof === n ? (A = "<" + (P(t.type) || "Unknown") + " />", x = " Did you accidentally export a JSX literal instead of a component?") : A = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", A, x);
        }
        var M = Fn(t, c, p, C, T);
        if (M == null)
          return M;
        if (S) {
          var ue = c.children;
          if (ue !== void 0)
            if (y)
              if (E(ue)) {
                for (var ze = 0; ze < ue.length; ze++)
                  xn(ue[ze], t);
                Object.freeze && Object.freeze(ue);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              xn(ue, t);
        }
        if (ce.call(c, "key")) {
          var Te = P(t), re = Object.keys(c).filter(function(Gn) {
            return Gn !== "key";
          }), mn = re.length > 0 ? "{key: someKey, " + re.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Cn[Te + mn]) {
            var Dn = re.length > 0 ? "{" + re.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, mn, Te, Dn, Te), Cn[Te + mn] = !0;
          }
        }
        return t === i ? Vn(M) : Ln(M), M;
      }
    }
    function zn(t, c, p) {
      return wn(t, c, p, !0);
    }
    function qn(t, c, p) {
      return wn(t, c, p, !1);
    }
    var Un = qn, Kn = zn;
    gs.Fragment = i, gs.jsx = Un, gs.jsxs = Kn;
  })()), gs;
}
var L_;
function XD() {
  return L_ || (L_ = 1, process.env.NODE_ENV === "production" ? um.exports = JD() : um.exports = QD()), um.exports;
}
var te = XD();
const ZD = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "getCustomerDetails" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Braze_exportUserDetails_request_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Braze" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "exportUserDetails" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Braze_exportUserDetails_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Braze_ExportedUserDetails" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }, { kind: "Field", name: { kind: "Name", value: "users" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "external_id" } }, { kind: "Field", name: { kind: "Name", value: "braze_id" } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "dob" } }, { kind: "Field", name: { kind: "Name", value: "home_city" } }, { kind: "Field", name: { kind: "Name", value: "country" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "language" } }, { kind: "Field", name: { kind: "Name", value: "time_zone" } }, { kind: "Field", name: { kind: "Name", value: "total_revenue" } }, { kind: "Field", name: { kind: "Name", value: "push_subscribe" } }, { kind: "Field", name: { kind: "Name", value: "email_subscribe" } }, { kind: "Field", name: { kind: "Name", value: "custom_attributes" } }, { kind: "Field", name: { kind: "Name", value: "apps" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "platform" } }, { kind: "Field", name: { kind: "Name", value: "version" } }, { kind: "Field", name: { kind: "Name", value: "sessions" } }, { kind: "Field", name: { kind: "Name", value: "first_used" } }, { kind: "Field", name: { kind: "Name", value: "last_used" } }] } }, { kind: "Field", name: { kind: "Name", value: "devices" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "model" } }, { kind: "Field", name: { kind: "Name", value: "os" } }, { kind: "Field", name: { kind: "Name", value: "carrier" } }, { kind: "Field", name: { kind: "Name", value: "idfv" } }, { kind: "Field", name: { kind: "Name", value: "idfa" } }, { kind: "Field", name: { kind: "Name", value: "google_ad_id" } }, { kind: "Field", name: { kind: "Name", value: "roku_ad_id" } }, { kind: "Field", name: { kind: "Name", value: "ad_tracking_enabled" } }] } }, { kind: "Field", name: { kind: "Name", value: "custom_events" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "first" } }, { kind: "Field", name: { kind: "Name", value: "last" } }, { kind: "Field", name: { kind: "Name", value: "count" } }] } }, { kind: "Field", name: { kind: "Name", value: "purchases" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "first" } }, { kind: "Field", name: { kind: "Name", value: "last" } }, { kind: "Field", name: { kind: "Name", value: "count" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Braze_BasicResponse" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] } }] }, eO = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "updateEmailSubscriptionStatus" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Braze_updateEmailSubscriptionStatus_request_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Braze" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "updateEmailSubscriptionStatus" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] }, nO = {
  "\n  mutation getCustomerDetails($input: Braze_exportUserDetails_request_Input!) {\n    Braze {\n      exportUserDetails(input: $input) {\n        ... on Braze_exportUserDetails_response {\n          ... on Braze_ExportedUserDetails {\n            message\n            users {\n              external_id\n              braze_id\n              created_at\n              email\n              first_name\n              last_name\n              dob\n              home_city\n              country\n              phone\n              language\n              time_zone\n              total_revenue\n              push_subscribe\n              email_subscribe\n              custom_attributes\n              apps {\n                name\n                platform\n                version\n                sessions\n                first_used\n                last_used\n              }\n              devices {\n                model\n                os\n                carrier\n                idfv\n                idfa\n                google_ad_id\n                roku_ad_id\n                ad_tracking_enabled\n              }\n              custom_events {\n                name\n                first\n                last\n                count\n              }\n              purchases {\n                name\n                first\n                last\n                count\n              }\n            }\n          }\n\n          ... on Braze_BasicResponse {\n            message\n          }\n        }\n      }\n    }\n  }\n": ZD,
  "\n  mutation updateEmailSubscriptionStatus(\n    $input: Braze_updateEmailSubscriptionStatus_request_Input!\n  ) {\n    Braze {\n      updateEmailSubscriptionStatus(input: $input) {\n        message\n      }\n    }\n  }\n": eO
};
function YC(e) {
  return nO[e] ?? {};
}
const tO = YC(
  /* GraphQL */
  `
  mutation getCustomerDetails($input: Braze_exportUserDetails_request_Input!) {
    Braze {
      exportUserDetails(input: $input) {
        ... on Braze_exportUserDetails_response {
          ... on Braze_ExportedUserDetails {
            message
            users {
              external_id
              braze_id
              created_at
              email
              first_name
              last_name
              dob
              home_city
              country
              phone
              language
              time_zone
              total_revenue
              push_subscribe
              email_subscribe
              custom_attributes
              apps {
                name
                platform
                version
                sessions
                first_used
                last_used
              }
              devices {
                model
                os
                carrier
                idfv
                idfa
                google_ad_id
                roku_ad_id
                ad_tracking_enabled
              }
              custom_events {
                name
                first
                last
                count
              }
              purchases {
                name
                first
                last
                count
              }
            }
          }

          ... on Braze_BasicResponse {
            message
          }
        }
      }
    }
  }
`
), rO = YC(
  /* GraphQL */
  `
  mutation updateEmailSubscriptionStatus(
    $input: Braze_updateEmailSubscriptionStatus_request_Input!
  ) {
    Braze {
      updateEmailSubscriptionStatus(input: $input) {
        message
      }
    }
  }
`
), iO = "_copyIcon_10dvk_54", aO = "_list_10dvk_59", oO = "_listItem_10dvk_69", sO = "_collapsible_10dvk_78", lO = "_collapsibleIsOpen_10dvk_86", cO = "_collapsibleHeader_10dvk_89", dO = "_collapsibleIconTrue_10dvk_92", uO = "_collapsibleIconFalse_10dvk_95", Mn = {
  copyIcon: iO,
  list: aO,
  listItem: oO,
  collapsible: sO,
  collapsibleIsOpen: lO,
  collapsibleHeader: cO,
  collapsibleIconTrue: dO,
  collapsibleIconFalse: uO
}, mO = ({
  app: e,
  openByDefault: n
}) => {
  const [r, i] = me(n);
  if (!e)
    return null;
  const {
    name: a,
    platform: o,
    version: s,
    sessions: l,
    first_used: d,
    last_used: m
  } = e;
  return /* @__PURE__ */ te.jsxs(
    b,
    {
      className: ut(Mn.collapsible, {
        [Mn.collapsibleIsOpen]: r
      }),
      gap: "200",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ te.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: Mn.collapsibleHeader,
            onClick: () => i(!r),
            children: [
              /* @__PURE__ */ te.jsx(F.Paragraph, { variant: "1", children: a }),
              /* @__PURE__ */ te.jsx(
                Xt,
                {
                  variant: "tertiary",
                  icon: r ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        r && /* @__PURE__ */ te.jsxs(Je, { className: Mn.list, children: [
          /* @__PURE__ */ te.jsx(Je.Text, { variant: "dense", className: Mn.listItem, children: /* @__PURE__ */ te.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ te.jsx(F.Paragraph, { variant: "3", children: "Platform" }),
            /* @__PURE__ */ te.jsx(F.Paragraph, { variant: "5", color: "secondary", children: o })
          ] }) }),
          /* @__PURE__ */ te.jsx(Je.Text, { variant: "dense", className: Mn.listItem, children: /* @__PURE__ */ te.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ te.jsx(F.Paragraph, { variant: "3", children: "Version" }),
            /* @__PURE__ */ te.jsx(F.Paragraph, { variant: "5", color: "secondary", children: s })
          ] }) }),
          /* @__PURE__ */ te.jsx(Je.Text, { variant: "dense", className: Mn.listItem, children: /* @__PURE__ */ te.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ te.jsx(F.Paragraph, { variant: "3", children: "Sessions" }),
            /* @__PURE__ */ te.jsx(F.Paragraph, { variant: "5", color: "secondary", children: l })
          ] }) }),
          /* @__PURE__ */ te.jsx(Je.Text, { variant: "dense", className: Mn.listItem, children: /* @__PURE__ */ te.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ te.jsx(F.Paragraph, { variant: "3", children: "First used" }),
            /* @__PURE__ */ te.jsx(F.Paragraph, { variant: "5", color: "secondary", children: Wn(d).format(It) })
          ] }) }),
          /* @__PURE__ */ te.jsx(Je.Text, { variant: "dense", className: Mn.listItem, children: /* @__PURE__ */ te.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ te.jsx(F.Paragraph, { variant: "3", children: "Last used" }),
            /* @__PURE__ */ te.jsx(F.Paragraph, { variant: "5", color: "secondary", children: Wn(m).format(It) })
          ] }) })
        ] })
      ]
    }
  );
}, pO = ({ apps: e }) => {
  const n = e && e?.length > 0;
  return /* @__PURE__ */ te.jsxs(b, { gap: "200", flexDirection: "column", margin: "200 0 0", children: [
    /* @__PURE__ */ te.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ te.jsx(F.Heading, { variant: "heading-3", children: "Apps" }),
      n && /* @__PURE__ */ te.jsx(Pn, { size: "small", variant: "success", children: e.length })
    ] }),
    !n && /* @__PURE__ */ te.jsx(
      F.Paragraph,
      {
        variant: "4",
        margin: "200 0 300 0",
        color: "secondary",
        align: "center",
        children: "There are no apps associated with this customer"
      }
    ),
    e?.map((r, i) => /* @__PURE__ */ te.jsx(mO, { app: r, openByDefault: i === 0 }, i))
  ] });
}, fO = ({
  customerDetails: e
}) => {
  if (!e)
    return null;
  const { custom_attributes: n } = e, r = !!n && Object.keys(n).length > 0;
  return /* @__PURE__ */ te.jsx(te.Fragment, { children: /* @__PURE__ */ te.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ te.jsx(F.Heading, { variant: "heading-3", children: "Custom attributes" }),
    !r && /* @__PURE__ */ te.jsx(F.Paragraph, { variant: "4", color: "secondary", align: "center", children: "No custom attributes available" }),
    r && /* @__PURE__ */ te.jsx(Je, { className: Mn.list, children: Object.entries(
      n
    ).map(([i, a], o) => (typeof a == "boolean" || typeof a == "string" || typeof a == "number") && /* @__PURE__ */ te.jsx(
      Je.Text,
      {
        variant: "dense",
        className: Mn.listItem,
        children: /* @__PURE__ */ te.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
          /* @__PURE__ */ te.jsx(F.Paragraph, { variant: "4", children: i }),
          qi(a)
        ] })
      },
      o
    )) })
  ] }) });
}, hO = ({
  customerDetails: e
}) => {
  if (!e)
    return null;
  const { custom_events: n } = e, r = n?.sort(
    (a, o) => o?.count - a?.count
  ), i = r && r.length > 0;
  return /* @__PURE__ */ te.jsx(te.Fragment, { children: /* @__PURE__ */ te.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ te.jsx(F.Heading, { variant: "heading-3", children: "Custom events" }),
    !i && /* @__PURE__ */ te.jsx(F.Paragraph, { variant: "4", color: "secondary", align: "center", children: "No custom events available" }),
    i && /* @__PURE__ */ te.jsx(Je, { className: Mn.list, children: r.map((a, o) => /* @__PURE__ */ te.jsx(
      Je.Text,
      {
        variant: "dense",
        className: Mn.listItem,
        children: /* @__PURE__ */ te.jsxs(b, { justifyContent: "space-between", children: [
          /* @__PURE__ */ te.jsx(
            Ge,
            {
              content: /* @__PURE__ */ te.jsxs(b, { flexDirection: "column", children: [
                /* @__PURE__ */ te.jsx(b, { children: `First ${Wn(a?.first).format(
                  It
                )}` }),
                /* @__PURE__ */ te.jsx(b, { children: `Last ${Wn(a?.last).format(
                  It
                )}` })
              ] }),
              children: /* @__PURE__ */ te.jsx(F.Paragraph, { variant: "4", children: a?.name })
            }
          ),
          /* @__PURE__ */ te.jsx(F.Paragraph, { variant: "5", children: a?.count })
        ] })
      },
      o
    )) })
  ] }) });
}, bl = ({
  state: e,
  noTooltip: n = !1,
  isPush: r = !1
}) => {
  if (!e) return null;
  const i = e === "subscribed", a = e === "unsubscribed", o = () => i ? "exclamation" : a ? "close-circle-filled" : "check-circle-filled", s = () => i ? "neutral.500" : a ? "red.500" : "green.500", l = () => {
    const d = r ? "push notifications" : "emails";
    return i ? `Default case "subscribed": The user has neither unsubscribed nor explicitly opted-in to receive ${d}. This is the default subscription state when a user profile is created.` : a ? `Unsubscribed: The user has explicitly unsubscribed from receiving ${d}.` : `Opted in: The user has explicitly confirmed they want to receive ${d}.`;
  };
  return /* @__PURE__ */ te.jsx(Ge, { content: n ? null : l(), children: /* @__PURE__ */ te.jsx(b, { alignItems: "center", children: /* @__PURE__ */ te.jsx(fe, { size: 14, name: o(), color: s() }) }) });
}, yO = "_wrapper_1xucg_1", gO = "_externalLink_1xucg_7", mm = {
  wrapper: yO,
  externalLink: gO
}, vO = ({
  customerDetails: e
}) => {
  const { isCopied: n, copy: r } = Qt(), { isCopied: i, copy: a } = Qt(), { isCopied: o, copy: s } = Qt(), { isCopied: l, copy: d } = Qt(), { isCopied: m, copy: u } = Qt();
  if (!e)
    return null;
  const {
    external_id: f,
    braze_id: h,
    first_name: v,
    last_name: w,
    home_city: N,
    country: j,
    email: _,
    phone: g,
    dob: O,
    created_at: R,
    email_subscribe: $,
    push_subscribe: I
  } = e, L = 14, G = `${v || ""} ${w || ""}`.trim() || "A customer has no name", Q = `${N ? `${N} /` : ""} ${j || ""}`.trim(), ne = O ? Wn(O).isSame(Date.now(), "day") : !1;
  return /* @__PURE__ */ te.jsx(b, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ te.jsxs(b, { className: mm.wrapper, gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ te.jsxs(
      b,
      {
        justifyContent: "space-between",
        className: mm.block,
        alignItems: "center",
        children: [
          /* @__PURE__ */ te.jsx(F.Heading, { variant: "heading-2", children: G }),
          ne && /* @__PURE__ */ te.jsx(F.Paragraph, { variant: "4", color: "secondary", children: "... has birthday today 🥳" })
        ]
      }
    ),
    R && /* @__PURE__ */ te.jsxs(b, { gap: "200", justifyContent: "space-between", margin: "0 0 200", children: [
      /* @__PURE__ */ te.jsx(F.Paragraph, { variant: "4", children: "Member since" }),
      /* @__PURE__ */ te.jsx(F.Paragraph, { variant: "4", children: Wn(R).format(It) })
    ] }),
    Q && /* @__PURE__ */ te.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ te.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ te.jsx(fe, { size: L, name: "map-pin" }),
        /* @__PURE__ */ te.jsx(F.Paragraph, { variant: "4", children: Q })
      ] }),
      /* @__PURE__ */ te.jsx(Ge, { content: "Copy location", children: /* @__PURE__ */ te.jsx(b, { alignItems: "center", children: /* @__PURE__ */ te.jsx(
        fe,
        {
          size: L,
          name: o ? "done" : "copy",
          onClick: () => s(Q),
          className: Mn.copyIcon
        }
      ) }) })
    ] }),
    _ && /* @__PURE__ */ te.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ te.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ te.jsx(fe, { size: L, name: "mail" }),
        /* @__PURE__ */ te.jsx("span", { className: mm.externalLink, children: _ })
      ] }),
      /* @__PURE__ */ te.jsx(Ge, { content: "Copy email", children: /* @__PURE__ */ te.jsx(b, { alignItems: "center", children: /* @__PURE__ */ te.jsx(
        fe,
        {
          size: L,
          name: n ? "done" : "copy",
          onClick: () => r(_),
          className: Mn.copyIcon
        }
      ) }) })
    ] }),
    g && /* @__PURE__ */ te.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ te.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ te.jsx(fe, { size: L, name: "phone" }),
        /* @__PURE__ */ te.jsx(F.Paragraph, { variant: "4", children: g })
      ] }),
      /* @__PURE__ */ te.jsx(Ge, { content: "Copy phone number", children: /* @__PURE__ */ te.jsx(b, { alignItems: "center", children: /* @__PURE__ */ te.jsx(
        fe,
        {
          size: L,
          name: i ? "done" : "copy",
          onClick: () => a(g),
          className: Mn.copyIcon
        }
      ) }) })
    ] }),
    h && /* @__PURE__ */ te.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ te.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ te.jsx(fe, { size: L, name: "user" }),
        /* @__PURE__ */ te.jsx(F.Paragraph, { variant: "4", children: "Braze ID" }),
        /* @__PURE__ */ te.jsxs(F.Paragraph, { variant: "5", subdued: !0, color: "tertiary", children: [
          "(",
          h,
          ")"
        ] })
      ] }),
      /* @__PURE__ */ te.jsx(Ge, { content: "Copy Braze ID", children: /* @__PURE__ */ te.jsx(b, { alignItems: "center", children: /* @__PURE__ */ te.jsx(
        fe,
        {
          size: L,
          name: l ? "done" : "copy",
          onClick: () => d(h),
          className: Mn.copyIcon
        }
      ) }) })
    ] }),
    f && /* @__PURE__ */ te.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ te.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ te.jsx(fe, { size: L, name: "tag" }),
        /* @__PURE__ */ te.jsx(F.Paragraph, { variant: "4", children: "External ID" }),
        /* @__PURE__ */ te.jsxs(F.Paragraph, { variant: "5", subdued: !0, color: "tertiary", children: [
          "(",
          f,
          ")"
        ] })
      ] }),
      /* @__PURE__ */ te.jsx(Ge, { content: "Copy External ID", children: /* @__PURE__ */ te.jsx(b, { alignItems: "center", children: /* @__PURE__ */ te.jsx(
        fe,
        {
          size: L,
          name: m ? "done" : "copy",
          onClick: () => u(f),
          className: Mn.copyIcon
        }
      ) }) })
    ] }),
    $ && /* @__PURE__ */ te.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ te.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ te.jsx(fe, { size: L, name: "sync" }),
        /* @__PURE__ */ te.jsx(F.Paragraph, { variant: "4", children: "Email subscription state" })
      ] }),
      /* @__PURE__ */ te.jsx(bl, { state: $ })
    ] }),
    I && /* @__PURE__ */ te.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ te.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ te.jsx(fe, { size: L, name: "bell" }),
        /* @__PURE__ */ te.jsx(F.Paragraph, { variant: "4", children: "Push notification subscription state" })
      ] }),
      /* @__PURE__ */ te.jsx(bl, { isPush: !0, state: I })
    ] })
  ] }) });
}, kO = ({
  device: e,
  openByDefault: n
}) => {
  const [r, i] = me(n);
  if (!e)
    return null;
  const a = 14, {
    model: o,
    os: s,
    carrier: l,
    ad_tracking_enabled: d,
    idfa: m,
    idfv: u,
    google_ad_id: f,
    roku_ad_id: h
  } = e;
  return /* @__PURE__ */ te.jsxs(
    b,
    {
      className: ut(Mn.collapsible, {
        [Mn.collapsibleIsOpen]: r
      }),
      gap: "200",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ te.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: Mn.collapsibleHeader,
            onClick: () => i(!r),
            children: [
              /* @__PURE__ */ te.jsx(F.Paragraph, { variant: "1", children: o }),
              /* @__PURE__ */ te.jsx(
                Xt,
                {
                  variant: "tertiary",
                  icon: r ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        r && /* @__PURE__ */ te.jsxs(Je, { className: Mn.list, children: [
          /* @__PURE__ */ te.jsx(Je.Text, { variant: "dense", className: Mn.listItem, children: /* @__PURE__ */ te.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ te.jsx(F.Paragraph, { variant: "3", children: "OS" }),
            /* @__PURE__ */ te.jsx(F.Paragraph, { variant: "5", color: "secondary", children: s })
          ] }) }),
          /* @__PURE__ */ te.jsx(Je.Text, { variant: "dense", className: Mn.listItem, children: /* @__PURE__ */ te.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ te.jsx(F.Paragraph, { variant: "3", children: "Carrier" }),
            /* @__PURE__ */ te.jsx(F.Paragraph, { variant: "5", color: "secondary", children: l })
          ] }) }),
          /* @__PURE__ */ te.jsx(Je.Text, { variant: "dense", className: Mn.listItem, children: /* @__PURE__ */ te.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ te.jsx(F.Paragraph, { variant: "3", children: "Ad tracking enabled" }),
            /* @__PURE__ */ te.jsx(
              fe,
              {
                size: a,
                className: ut({
                  [Mn.collapsibleIconTrue]: d,
                  [Mn.collapsibleIconFalse]: !d
                }),
                name: d ? "check-circle-filled" : "close-circle-filled"
              }
            )
          ] }) }),
          /* @__PURE__ */ te.jsx(Ge, { content: "The Apple Identifier for Vendor (iOS)", children: /* @__PURE__ */ te.jsx(Je.Text, { variant: "dense", className: Mn.listItem, children: /* @__PURE__ */ te.jsxs(
            b,
            {
              gap: "200",
              justifyContent: "space-between",
              width: "100%",
              flexWrap: "wrap",
              children: [
                /* @__PURE__ */ te.jsx(F.Paragraph, { variant: "3", children: "Braze device identifier" }),
                /* @__PURE__ */ te.jsx(F.Paragraph, { variant: "5", color: "secondary", children: u })
              ]
            }
          ) }) }),
          /* @__PURE__ */ te.jsx(Ge, { content: "For iOS", children: /* @__PURE__ */ te.jsx(Je.Text, { variant: "dense", className: Mn.listItem, children: /* @__PURE__ */ te.jsxs(
            b,
            {
              gap: "200",
              justifyContent: "space-between",
              width: "100%",
              flexWrap: "wrap",
              children: [
                /* @__PURE__ */ te.jsx(F.Paragraph, { variant: "3", children: "Identifier for Advertising" }),
                /* @__PURE__ */ te.jsx(F.Paragraph, { variant: "5", color: "secondary", children: m })
              ]
            }
          ) }) }),
          /* @__PURE__ */ te.jsx(Je.Text, { variant: "dense", className: Mn.listItem, children: /* @__PURE__ */ te.jsxs(
            b,
            {
              gap: "200",
              justifyContent: "space-between",
              width: "100%",
              flexWrap: "wrap",
              children: [
                /* @__PURE__ */ te.jsx(F.Paragraph, { variant: "3", children: "Roku Advertising id" }),
                /* @__PURE__ */ te.jsx(F.Paragraph, { variant: "5", color: "secondary", children: h })
              ]
            }
          ) }),
          /* @__PURE__ */ te.jsx(Je.Text, { variant: "dense", className: Mn.listItem, children: /* @__PURE__ */ te.jsxs(
            b,
            {
              gap: "200",
              justifyContent: "space-between",
              width: "100%",
              flexWrap: "wrap",
              children: [
                /* @__PURE__ */ te.jsx(F.Paragraph, { variant: "3", children: "Google Play Advertising id" }),
                /* @__PURE__ */ te.jsx(F.Paragraph, { variant: "5", color: "secondary", children: f })
              ]
            }
          ) })
        ] })
      ]
    }
  );
}, bO = ({ devices: e }) => {
  const n = e && e?.length > 0;
  return /* @__PURE__ */ te.jsxs(b, { gap: "200", flexDirection: "column", margin: "200 0 0", children: [
    /* @__PURE__ */ te.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ te.jsx(F.Heading, { variant: "heading-3", children: "Devices" }),
      n && /* @__PURE__ */ te.jsx(Pn, { size: "small", variant: "success", children: e.length })
    ] }),
    !n && /* @__PURE__ */ te.jsx(
      F.Paragraph,
      {
        variant: "4",
        margin: "200 0 300 0",
        color: "secondary",
        align: "center",
        children: "There are no devices associated with this customer"
      }
    ),
    e?.map((r, i) => /* @__PURE__ */ te.jsx(kO, { device: r, openByDefault: i === 0 }, i))
  ] });
}, Ya = {
  optIn: {
    label: "Opt in",
    icon: "check-circle-filled",
    color: "var(--dixa-color-green-500)",
    tooltipContent: "Opt in to receive emails",
    parameter: "opted_in"
  },
  unsubscribe: {
    label: "Unsubscribe",
    icon: "close-circle-filled",
    color: "var(--dixa-color-red-500)",
    tooltipContent: "Unsubscribe from emails",
    parameter: "unsubscribed"
  }
}, vs = ({
  email: e,
  updateTo: n,
  refetchCustomerDetails: r
}) => {
  const { track: i } = jn(), { useMutation: a } = fn(), [o, s] = me(!1), [l] = a(
    rO,
    {
      onCompleted: (m) => {
        m?.Braze?.updateEmailSubscriptionStatus?.message === "success" && i(n === "optIn" ? "braze:email:subscription:opt-in:succeeded" : "braze:email:subscription:unsubscribe:succeeded");
      }
    }
  ), d = async () => {
    s(!0), await l({
      variables: {
        input: {
          email: e,
          // eslint-disable-next-line camelcase
          subscription_state: Ya[n].parameter
        }
      }
    }), setTimeout(async () => {
      await r().finally(() => s(!1));
    }, 500);
  };
  return /* @__PURE__ */ te.jsx(Ge, { content: Ya[n].tooltipContent, children: /* @__PURE__ */ te.jsx(
    Qn,
    {
      variant: "secondary",
      color: Ya[n].color,
      isLoading: o,
      onClick: () => d(),
      "data-testid": "braze-subscription-button",
      children: /* @__PURE__ */ te.jsxs(b, { gap: "100", alignItems: "center", children: [
        /* @__PURE__ */ te.jsx(
          bl,
          {
            noTooltip: !0,
            state: Ya[n].parameter
          }
        ),
        Ya[n].label
      ] })
    }
  ) });
}, _O = ({
  customerDetails: e,
  showCustomerDetails: n,
  refetchCustomerDetails: r
}) => {
  if (!e)
    return null;
  const { email: i, email_subscribe: a } = e;
  if (!i)
    return null;
  const o = a === "subscribed", s = a === "unsubscribed", l = a === "opted_in";
  return /* @__PURE__ */ te.jsx(b, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ te.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ te.jsx(F.Heading, { variant: "heading-3", children: "Update Email subscription state" }),
    !n && /* @__PURE__ */ te.jsx(Je, { className: Mn.list, children: /* @__PURE__ */ te.jsx(Je.Text, { variant: "dense", className: Mn.listItem, children: /* @__PURE__ */ te.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ te.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ te.jsx(fe, { size: 14, name: "sync" }),
        /* @__PURE__ */ te.jsx(F.Paragraph, { variant: "4", children: "Email subscription state" })
      ] }),
      /* @__PURE__ */ te.jsx(bl, { state: a })
    ] }) }) }),
    /* @__PURE__ */ te.jsxs(b, { gap: "200", alignItems: "center", children: [
      o && /* @__PURE__ */ te.jsxs(te.Fragment, { children: [
        /* @__PURE__ */ te.jsx(
          vs,
          {
            email: i,
            updateTo: "optIn",
            refetchCustomerDetails: r
          }
        ),
        /* @__PURE__ */ te.jsx(
          vs,
          {
            email: i,
            updateTo: "unsubscribe",
            refetchCustomerDetails: r
          }
        )
      ] }),
      s && /* @__PURE__ */ te.jsx(
        vs,
        {
          email: i,
          updateTo: "optIn",
          refetchCustomerDetails: r
        }
      ),
      l && /* @__PURE__ */ te.jsx(
        vs,
        {
          email: i,
          updateTo: "unsubscribe",
          refetchCustomerDetails: r
        }
      )
    ] })
  ] }) });
}, xO = ({
  customerDetails: e
}) => {
  if (!e)
    return null;
  const { purchases: n } = e, r = n?.sort(
    (a, o) => o?.count - a?.count
  ), i = r && r.length > 0;
  return /* @__PURE__ */ te.jsx(te.Fragment, { children: /* @__PURE__ */ te.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ te.jsx(F.Heading, { variant: "heading-3", children: "Purchases" }),
    !i && /* @__PURE__ */ te.jsx(F.Paragraph, { variant: "4", color: "secondary", align: "center", children: "No purchases available" }),
    i && /* @__PURE__ */ te.jsx(Je, { className: Mn.list, children: r.map((a, o) => /* @__PURE__ */ te.jsx(
      Je.Text,
      {
        variant: "dense",
        className: Mn.listItem,
        children: /* @__PURE__ */ te.jsxs(b, { justifyContent: "space-between", children: [
          /* @__PURE__ */ te.jsx(
            Ge,
            {
              content: /* @__PURE__ */ te.jsxs(b, { flexDirection: "column", children: [
                /* @__PURE__ */ te.jsx(b, { children: `First ${Wn(a?.first).format(
                  It
                )}` }),
                /* @__PURE__ */ te.jsx(b, { children: `Last ${Wn(a?.last).format(
                  It
                )}` })
              ] }),
              children: /* @__PURE__ */ te.jsx(F.Paragraph, { variant: "4", children: a?.name })
            }
          ),
          /* @__PURE__ */ te.jsx(F.Paragraph, { variant: "5", children: a?.count })
        ] })
      },
      o
    )) })
  ] }) });
}, SO = ({
  conversationContext: e,
  settings: n
}) => {
  const { track: r } = jn(), { useMutation: i } = fn(), [a, o] = me(), [s, l] = me(!1), [d, m] = me(!1), u = e?.customer?.email, f = e?.customer?.phone_number, h = n.displayCustomerDetails ?? !1, v = n.updateEmailSubscriptionState ?? !1, w = n.displayCustomAttributes ?? !1, N = n.displayCustomEvents ?? !1, j = n.displayPuchases ?? !1, _ = n.displayDevices ?? !1, g = n.displayApps ?? !1, O = !h && !v && !w && !N && !j, [R, { error: $ }] = i(
    tO,
    {
      onError: () => {
      },
      onCompleted: (L) => {
        const G = L?.Braze?.exportUserDetails?.users?.[0];
        G ? (o(G), l(!1), r("braze:profile:received")) : (o(void 0), l(!0));
      }
    }
  ), I = async () => {
    u || f ? await R({
      variables: {
        input: {
          // Use the email if exists. Otherwise use the phone number. We decided
          // to not search for both together, because we receive a customer
          // entity for each input parameter and we only want one.
          /* eslint-disable camelcase */
          ...u ? { email_address: u } : { phone: f },
          fields_to_export: [
            "external_id",
            "braze_id",
            "created_at",
            "email",
            "first_name",
            "last_name",
            "dob",
            "home_city",
            "country",
            "phone",
            "language",
            "time_zone",
            "total_revenue",
            "push_subscribe",
            "email_subscribe",
            "custom_attributes",
            "custom_events",
            "purchases",
            "apps",
            "devices"
          ]
          /* eslint-enable camelcase */
        }
      }
    }) : l(!0);
  };
  if (Xe(() => {
    async function L() {
      m(!0), await I();
    }
    L().finally(() => m(!1));
  }, [u, f]), $) {
    const L = $.graphQLErrors;
    return Ml({ errors: L }) ? /* @__PURE__ */ te.jsx(
      F.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        "data-testid": "widget-downstream-api-forbidden-error",
        children: "The API key used for the integration does not have the necessary access rights. Please contact your administrator."
      }
    ) : Bl({ errors: L }) ? /* @__PURE__ */ te.jsx(
      F.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        "data-testid": "widget-downstream-api-authorization-error",
        children: "The integration could not authorize against Braze. Please contact your administrator."
      }
    ) : /* @__PURE__ */ te.jsx($n, { error: $ });
  }
  return d ? /* @__PURE__ */ te.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ te.jsx(sn, {}) }) : O ? /* @__PURE__ */ te.jsx(
    F.Paragraph,
    {
      margin: "200 0 300 0",
      color: "secondary",
      align: "center",
      "data-testid": "widget-no-features",
      children: "All features toggles in the settings are disabled."
    }
  ) : s ? /* @__PURE__ */ te.jsx(
    F.Paragraph,
    {
      margin: "200 0 300 0",
      color: "secondary",
      align: "center",
      "data-testid": "widget-no-customer-found",
      children: "No customer found with this email or phone number."
    }
  ) : /* @__PURE__ */ te.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "0 0 300 0",
      "data-testid": "widget-wrapper",
      children: [
        h && /* @__PURE__ */ te.jsx(vO, { customerDetails: a }),
        v && !!a && /* @__PURE__ */ te.jsx(
          _O,
          {
            customerDetails: a,
            showCustomerDetails: h,
            refetchCustomerDetails: async () => await I()
          }
        ),
        w && !!a && /* @__PURE__ */ te.jsx(fO, { customerDetails: a }),
        N && !!a && /* @__PURE__ */ te.jsx(hO, { customerDetails: a }),
        j && !!a && /* @__PURE__ */ te.jsx(xO, { customerDetails: a }),
        _ && !!a && /* @__PURE__ */ te.jsx(bO, { devices: a?.devices }),
        g && !!a && /* @__PURE__ */ te.jsx(pO, { apps: a?.apps })
      ]
    }
  );
}, qo = [
  {
    key: "apiHostName",
    label: "API endpoint",
    type: "string",
    secret: !1,
    defaultValue: ""
  },
  {
    key: "brazeApiKey",
    label: "API key",
    type: "string",
    secret: !0,
    defaultValue: ""
  },
  {
    key: "displayCustomerDetails",
    label: "Display customer details",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "updateEmailSubscriptionState",
    label: "Display the button to change the email subscription state",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "displayCustomAttributes",
    label: "Display a list of custom attributes",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "displayCustomEvents",
    label: "Display a list of custom events",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    // Yeah, there is a typo 😅 We need to stick with it now, since customers
    // might have used it in the past..
    key: "displayPuchases",
    label: "Display a list of purchases",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "displayDevices",
    label: "Display customer devices",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "displayApps",
    label: "Display customer apps",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  }
], ni = ar(qo), NO = {
  enabled: !1,
  name: "",
  brazeApiKey: "",
  ...Jo([], qo)
}, jO = ({
  integrationId: e,
  handleRedirect: n,
  showNotification: r,
  automationCouplingState: i,
  renderConditionsEditor: a
}) => {
  const o = !e, s = ot({
    mode: "onChange",
    defaultValues: NO
  }), {
    create: l,
    update: d,
    remove: m,
    isLoading: u,
    error: f,
    misconfigurationCause: h,
    setMisconfigurationCause: v
  } = pr({
    integrationId: e,
    integrationType: "BRAZE",
    handleRedirect: n,
    showNotification: r
  }), {
    isLoading: w,
    error: N,
    isWidgetUnknown: j,
    refetch: _,
    widgetConfiguration: g
  } = fr({
    integrationId: e,
    fieldDefinitions: qo,
    form: s,
    onMisconfigured: v
  }), { renderConditions: O, setRenderConditions: R, renderConditionsForSubmit: $ } = hr({
    integrationId: e,
    widgetConfiguration: g,
    renderConditionsEditor: a
  }), I = (G) => gr(G, {
    fieldDefinitions: qo,
    isCreationMode: o,
    create: l,
    update: d,
    renderConditions: $
  }), L = s.watch("name");
  return /* @__PURE__ */ te.jsxs(
    yr,
    {
      form: s,
      integrationId: e,
      onValidSubmit: I,
      error: N ?? f,
      onRetry: N ? _ : void 0,
      isLoading: u || w,
      isWidgetUnknown: j,
      children: [
        h && /* @__PURE__ */ te.jsx(vr, { cause: h }),
        /* @__PURE__ */ te.jsxs(et, { children: [
          /* @__PURE__ */ te.jsx(Z, { children: /* @__PURE__ */ te.jsx(qe, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ te.jsx(
            yn,
            {
              name: "enabled",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ te.jsx(Z, { span: 3, children: /* @__PURE__ */ te.jsx(
            Rn,
            {
              name: "name",
              label: "Widget name",
              control: s.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ te.jsx(Z, { span: 3 }),
          /* @__PURE__ */ te.jsx(Z, { span: 3, children: /* @__PURE__ */ te.jsx(
            Rn,
            {
              name: "apiHostName",
              label: ni.apiHostName,
              control: s.control,
              rules: {
                required: "API endpoint is required",
                validate: (G) => Ul(G) || !0
              },
              componentProps: {
                placeholder: "REST API endpoint for your region, e.g. rest.iad-01.braze.com",
                autoComplete: "off",
                prefix: "https://"
              }
            }
          ) }),
          /* @__PURE__ */ te.jsx(Z, { span: 3 }),
          /* @__PURE__ */ te.jsx(Z, { span: 3, children: /* @__PURE__ */ te.jsx(
            Er,
            {
              name: "brazeApiKey",
              label: ni.brazeApiKey,
              control: s.control,
              isCreationMode: o,
              rules: { required: "API key is required" },
              componentProps: {
                placeholder: "Insert your API key",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ te.jsx(Z, { span: 3 }),
          /* @__PURE__ */ te.jsx(Z, { span: 3, children: /* @__PURE__ */ te.jsx(qe, { label: ni.displayCustomerDetails, children: /* @__PURE__ */ te.jsx(
            yn,
            {
              name: "displayCustomerDetails",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ te.jsx(Z, { span: 3 }),
          /* @__PURE__ */ te.jsx(Z, { span: 3, children: /* @__PURE__ */ te.jsx(qe, { label: ni.updateEmailSubscriptionState, children: /* @__PURE__ */ te.jsx(
            yn,
            {
              name: "updateEmailSubscriptionState",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ te.jsx(Z, { span: 3 }),
          /* @__PURE__ */ te.jsx(Z, { span: 3, children: /* @__PURE__ */ te.jsx(qe, { label: ni.displayCustomAttributes, children: /* @__PURE__ */ te.jsx(
            yn,
            {
              name: "displayCustomAttributes",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ te.jsx(Z, { span: 3 }),
          /* @__PURE__ */ te.jsx(Z, { span: 3, children: /* @__PURE__ */ te.jsx(qe, { label: ni.displayCustomEvents, children: /* @__PURE__ */ te.jsx(
            yn,
            {
              name: "displayCustomEvents",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ te.jsx(Z, { span: 3 }),
          /* @__PURE__ */ te.jsx(Z, { span: 3, children: /* @__PURE__ */ te.jsx(qe, { label: ni.displayPuchases, children: /* @__PURE__ */ te.jsx(
            yn,
            {
              name: "displayPuchases",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ te.jsx(Z, { span: 3 }),
          /* @__PURE__ */ te.jsx(Z, { span: 3, children: /* @__PURE__ */ te.jsx(qe, { label: ni.displayDevices, children: /* @__PURE__ */ te.jsx(
            yn,
            {
              name: "displayDevices",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ te.jsx(Z, { span: 3 }),
          /* @__PURE__ */ te.jsx(Z, { span: 3, children: /* @__PURE__ */ te.jsx(qe, { label: ni.displayApps, children: /* @__PURE__ */ te.jsx(
            yn,
            {
              name: "displayApps",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ te.jsx(Z, { span: 3 }),
          a && O !== null && /* @__PURE__ */ te.jsx(Z, { children: a({
            value: O,
            onChange: R,
            configurationKey: g?.id
          }) })
        ] }),
        /* @__PURE__ */ te.jsx(
          kr,
          {
            integrationType: "BRAZE",
            integrationId: e,
            widgetName: L,
            isCreationMode: o,
            isSubmitting: s.formState.isSubmitting,
            automationCouplingState: i,
            onConfirmDelete: () => m()
          }
        )
      ]
    }
  );
};
function wO() {
  var e = Tr(!1), n = pt(function() {
    return e.current;
  }, []);
  return Xe(function() {
    return e.current = !0, function() {
      e.current = !1;
    };
  }, []), n;
}
var CO = function(e) {
  e === void 0 && (e = {});
  var n = me(e), r = n[0], i = n[1], a = pt(function(o) {
    i(function(s) {
      return Object.assign({}, s, o instanceof Function ? o(s) : o);
    });
  }, []);
  return [r, a];
}, FO = function(e, n) {
  return typeof n == "boolean" ? n : !e;
}, V_ = function(e) {
  return jI(FO, e);
}, pm, z_;
function IO() {
  return z_ || (z_ = 1, pm = function() {
    var e = document.getSelection();
    if (!e.rangeCount)
      return function() {
      };
    for (var n = document.activeElement, r = [], i = 0; i < e.rangeCount; i++)
      r.push(e.getRangeAt(i));
    switch (n.tagName.toUpperCase()) {
      // .toUpperCase handles XHTML
      case "INPUT":
      case "TEXTAREA":
        n.blur();
        break;
      default:
        n = null;
        break;
    }
    return e.removeAllRanges(), function() {
      e.type === "Caret" && e.removeAllRanges(), e.rangeCount || r.forEach(function(a) {
        e.addRange(a);
      }), n && n.focus();
    };
  }), pm;
}
var fm, U_;
function $O() {
  if (U_) return fm;
  U_ = 1;
  var e = IO(), n = {
    "text/plain": "Text",
    "text/html": "Url",
    default: "Text"
  }, r = "Copy to clipboard: #{key}, Enter";
  function i(o) {
    var s = (/mac os x/i.test(navigator.userAgent) ? "⌘" : "Ctrl") + "+C";
    return o.replace(/#{\s*key\s*}/g, s);
  }
  function a(o, s) {
    var l, d, m, u, f, h, v = !1;
    s || (s = {}), l = s.debug || !1;
    try {
      m = e(), u = document.createRange(), f = document.getSelection(), h = document.createElement("span"), h.textContent = o, h.ariaHidden = "true", h.style.all = "unset", h.style.position = "fixed", h.style.top = 0, h.style.clip = "rect(0, 0, 0, 0)", h.style.whiteSpace = "pre", h.style.webkitUserSelect = "text", h.style.MozUserSelect = "text", h.style.msUserSelect = "text", h.style.userSelect = "text", h.addEventListener("copy", function(N) {
        if (N.stopPropagation(), s.format)
          if (N.preventDefault(), typeof N.clipboardData > "u") {
            l && console.warn("unable to use e.clipboardData"), l && console.warn("trying IE specific stuff"), window.clipboardData.clearData();
            var j = n[s.format] || n.default;
            window.clipboardData.setData(j, o);
          } else
            N.clipboardData.clearData(), N.clipboardData.setData(s.format, o);
        s.onCopy && (N.preventDefault(), s.onCopy(N.clipboardData));
      }), document.body.appendChild(h), u.selectNodeContents(h), f.addRange(u);
      var w = document.execCommand("copy");
      if (!w)
        throw new Error("copy command was unsuccessful");
      v = !0;
    } catch (N) {
      l && console.error("unable to copy using execCommand: ", N), l && console.warn("trying IE specific stuff");
      try {
        window.clipboardData.setData(s.format || "text", o), s.onCopy && s.onCopy(window.clipboardData), v = !0;
      } catch (j) {
        l && console.error("unable to copy using clipboardData: ", j), l && console.error("falling back to prompt"), d = i("message" in s ? s.message : r), window.prompt(d, o);
      }
    } finally {
      f && (typeof f.removeRange == "function" ? f.removeRange(u) : f.removeAllRanges()), h && document.body.removeChild(h), m();
    }
    return v;
  }
  return fm = a, fm;
}
var EO = $O();
const TO = /* @__PURE__ */ Dy(EO);
var JC = function() {
  var e = wO(), n = CO({
    value: void 0,
    error: void 0,
    noUserInteraction: !0
  }), r = n[0], i = n[1], a = pt(function(o) {
    if (e()) {
      var s, l;
      try {
        if (typeof o != "string" && typeof o != "number") {
          var d = new Error("Cannot copy typeof " + typeof o + " to clipboard, must be a string");
          process.env.NODE_ENV === "development" && console.error(d), i({
            value: o,
            error: d,
            noUserInteraction: !0
          });
          return;
        } else if (o === "") {
          var d = new Error("Cannot copy empty string to clipboard.");
          process.env.NODE_ENV === "development" && console.error(d), i({
            value: o,
            error: d,
            noUserInteraction: !0
          });
          return;
        }
        l = o.toString(), s = TO(l), i({
          value: l,
          error: void 0,
          noUserInteraction: s
        });
      } catch (m) {
        i({
          value: l,
          error: m,
          noUserInteraction: s
        });
      }
    }
  }, []);
  return [r, a];
};
function RO(e, n) {
  n === void 0 && (n = 0);
  var r = Tr(!1), i = Tr(), a = Tr(e), o = pt(function() {
    return r.current;
  }, []), s = pt(function() {
    r.current = !1, i.current && clearTimeout(i.current), i.current = setTimeout(function() {
      r.current = !0, a.current();
    }, n);
  }, [n]), l = pt(function() {
    r.current = null, i.current && clearTimeout(i.current);
  }, []);
  return Xe(function() {
    a.current = e;
  }, [e]), Xe(function() {
    return s(), l;
  }, [n]), [o, l, s];
}
function xi(e, n, r) {
  n === void 0 && (n = 0), r === void 0 && (r = []);
  var i = RO(e, n), a = i[0], o = i[1], s = i[2];
  return Xe(s, r), [a, o];
}
var DO = function(e) {
  Xe(e, []);
}, OO = function(e, n) {
  var r = Tr(function() {
  });
  Xe(function() {
    r.current = e;
  }), Xe(function() {
    if (n !== null) {
      var i = setInterval(function() {
        return r.current();
      }, n || 0);
      return function() {
        return clearInterval(i);
      };
    }
  }, [n]);
}, PO = function(e) {
  e === void 0 && (e = {});
  var n = me(e), r = n[0], i = n[1], a = Zn(function() {
    return {
      set: function(s, l) {
        i(function(d) {
          var m;
          return xc(xc({}, d), (m = {}, m[s] = l, m));
        });
      },
      setAll: function(s) {
        i(s);
      },
      remove: function(s) {
        i(function(l) {
          var d = l, m = s;
          d[m];
          var u = UI(d, [typeof m == "symbol" ? m : m + ""]);
          return u;
        });
      },
      reset: function() {
        return i(e);
      }
    };
  }, [i]), o = xc({ get: pt(function(s) {
    return r[s];
  }, [r]) }, a);
  return [r, o];
}, AO = function(e) {
  var n = Tr(e);
  n.current = e, DO(function() {
    return function() {
      return n.current();
    };
  });
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._contentWrapper_1vx3c_1{margin-bottom:var(--dixa-size-spacer-300)}._contentWrapperHeadline_1vx3c_4{font-weight:var(--dixa-typography-weight-semibold);font-size:var(--dixa-typography-size-100);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-tertiary);margin-bottom:var(--dixa-size-spacer-100)}._contentWrapperBody_1vx3c_11{max-height:75vh;overflow-y:auto}._contentWrapperAssigneeIcon_1vx3c_15{border-radius:50%;width:var(--dixa-size-spacer-300);vertical-align:middle}._contentWrapperStatusTag_1vx3c_20{margin-right:var(--dixa-size-spacer-200)}._collapse_1bdjy_1{border:1px solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);padding:0}._collapseHeader_1bdjy_10>div{padding:var(--dixa-size-spacer-300) 0!important}._collapseHeader_1bdjy_10>div>div>p{white-space:unset!important}._collapseHeader_1bdjy_10>div:first-child{width:100%}._collapseHeader_1bdjy_10>div:first-child div:first-child{width:100%}._collapseHeader_1bdjy_10>div:first-child div:first-child p{width:calc(100% - 20px)}._collapseHeader_1bdjy_10{background-color:transparent!important;padding:0 var(--dixa-size-spacer-300) 0 0;letter-spacing:-.08px;color:var(--dixa-color-neutral-500)}._collapseHeaderKey_1bdjy_31{font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-color-neutral-700)}._collapseHeaderKeyIcon_1bdjy_36{margin-top:-2px;margin-right:var(--dixa-size-spacer-100);vertical-align:middle}._collapseHeaderKeyLink_1bdjy_41{text-decoration:none}._collapseHeaderIcon_1bdjy_44{padding-top:.35em;margin-left:var(--dixa-size-spacer-100);vertical-align:text-bottom}._collapseHeaderTitle_1bdjy_49{font-weight:var(--dixa-typography-weight-semibold);font-size:var(--dixa-typography-size-300);line-height:var(--dixa-typography-line-height-300);letter-spacing:-.16px;color:var(--dixa-typography-color-primary);width:100%}._collapseContent_1bdjy_57{padding:var(--dixa-size-spacer-200) var(--dixa-size-spacer-300)!important}._collapseContentButtonSpacer_1bdjy_60{margin-top:var(--dixa-size-spacer-250)}._collapseContentButtonLink_1bdjy_63{color:var(--dixa-typography-color-link)}._result_1uaom_1{padding:0 var(--dixa-size-spacer-200);margin:0;outline:0;border:0;color:var(--dixa-typography-color-primary);background-color:var(--dixa-color-neutral-000);box-sizing:border-box;display:flex;align-items:center;position:relative;font-size:12px;line-height:32px;height:48px;width:100%;cursor:pointer}._result_1uaom_1:hover,._result_1uaom_1:focus{background-color:var(--dixa-color-neutral-100)}._resultName_1uaom_21{width:100%;text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-weight:var(--dixa-typography-weight-semibold)}._resultItemIcon_1uaom_29{margin-top:-2px;margin-right:var(--dixa-size-spacer-100);vertical-align:middle}._resultDescription_1uaom_34{width:100%;text-align:left;font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-secondary);white-space:nowrap;overflow:hidden;text-overflow:ellipsis;margin-top:-.5em;margin-bottom:.5em}._resultLinkIcon_1uaom_46{position:absolute;right:5px;background-color:var(--dixa-color-neutral-000);border:1px solid var(--dixa-color-neutral-300);border-radius:5px;color:var(--dixa-color-neutral-500)}._tooltip_1uaom_55{width:500px;max-height:60vh;overflow:hidden;text-overflow:ellipsis}._tooltipName_1uaom_61{text-align:left;white-space:nowrap;font-weight:var(--dixa-typography-weight-semibold)}._tooltipNameIcon_1uaom_66{height:var(--dixa-typography-line-height-300);padding-right:var(--dixa-size-spacer-100);margin-top:-2px}._tooltipTag_1uaom_71{width:fit-content;max-width:15em}._itemButton_3sxfy_1{border:none;padding:0}._result_3sxfy_6{padding:0 var(--dixa-size-spacer-200);margin:0;outline:0;border:0;color:var(--dixa-typography-color-primary);background-color:var(--dixa-color-neutral-000);box-sizing:border-box;display:flex;align-items:center;position:relative;font-size:var(--dixa-typography-size-200);line-height:32px;height:48px;width:100%;cursor:pointer}._result_3sxfy_6:hover,._result_3sxfy_6:focus{background-color:var(--dixa-color-neutral-100)}._resultIcon_3sxfy_26{height:var(--dixa-size-spacer-400);padding-right:var(--dixa-size-spacer-250)}._resultName_3sxfy_30{width:100%;text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-weight:var(--dixa-typography-weight-normal)}._resultCheckIcon_3sxfy_38{height:var(--dixa-size-spacer-400)}._resultAssigneeIcon_3sxfy_41{border-radius:50%;width:var(--dixa-size-spacer-300);vertical-align:middle;margin-right:var(--dixa-size-spacer-200)}._modalBody_1hk1o_1{width:600px}._modalBodyFormFields_1hk1o_4{display:grid;gap:var(--dixa-size-spacer-300) var(--dixa-size-spacer-400)}._wrapper_19v8w_1{gap:var(--dixa-size-spacer-250);margin-bottom:var(--dixa-size-spacer-300)}._inputWrapper_19v8w_6{background-color:var(--dixa-color-neutral-100);border-radius:var(--dixa-size-border-radius-100);margin:var(--dixa-size-spacer-300) 0;gap:var(--dixa-size-spacer-250);padding:var(--dixa-size-spacer-300);text-align:center}._inputField_19v8w_15{text-align:center}._buttonLink_19v8w_19{color:var(--dixa-typography-color-link)}._noItemsFound_19v8w_23{color:var(--dixa-color-neutral-400);font-size:var(--dixa-typography-size-200)}._createIssueButton_19v8w_28{min-height:38px}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var hm = { exports: {} }, Ja = {}, M_;
function LO() {
  if (M_) return Ja;
  M_ = 1;
  var e = He, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (v = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return Ja.Fragment = r, Ja.jsx = s, Ja.jsxs = s, Ja;
}
var ks = {}, B_;
function VO() {
  return B_ || (B_ = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = He, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), d = /* @__PURE__ */ Symbol.for("react.forward_ref"), m = /* @__PURE__ */ Symbol.for("react.suspense"), u = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), v = /* @__PURE__ */ Symbol.for("react.offscreen"), w = Symbol.iterator, N = "@@iterator";
    function j(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = w && t[w] || t[N];
      return typeof c == "function" ? c : null;
    }
    var _ = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          p[y - 1] = arguments[y];
        O("error", t, p);
      }
    }
    function O(t, c, p) {
      {
        var y = _.ReactDebugCurrentFrame, C = y.getStackAddendum();
        C !== "" && (c += "%s", p = p.concat([C]));
        var T = p.map(function(S) {
          return String(S);
        });
        T.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, T);
      }
    }
    var R = !1, $ = !1, I = !1, L = !1, G = !1, Q;
    Q = /* @__PURE__ */ Symbol.for("react.module.reference");
    function ne(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || G || t === a || t === m || t === u || L || t === v || R || $ || I || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Q || t.getModuleId !== void 0));
    }
    function q(t, c, p) {
      var y = t.displayName;
      if (y)
        return y;
      var C = c.displayName || c.name || "";
      return C !== "" ? p + "(" + C + ")" : p;
    }
    function Y(t) {
      return t.displayName || "Context";
    }
    function P(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return Y(c) + ".Consumer";
          case s:
            var p = t;
            return Y(p._context) + ".Provider";
          case d:
            return q(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : P(t.type) || "Memo";
          case h: {
            var C = t, T = C._payload, S = C._init;
            try {
              return P(S(T));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var B = Object.assign, ie = 0, je, pe, le, ge, V, be, Oe;
    function H() {
    }
    H.__reactDisabledLog = !0;
    function Ye() {
      {
        if (ie === 0) {
          je = console.log, pe = console.info, le = console.warn, ge = console.error, V = console.group, be = console.groupCollapsed, Oe = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: H,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ie++;
      }
    }
    function ln() {
      {
        if (ie--, ie === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: B({}, t, {
              value: je
            }),
            info: B({}, t, {
              value: pe
            }),
            warn: B({}, t, {
              value: le
            }),
            error: B({}, t, {
              value: ge
            }),
            group: B({}, t, {
              value: V
            }),
            groupCollapsed: B({}, t, {
              value: be
            }),
            groupEnd: B({}, t, {
              value: Oe
            })
          });
        }
        ie < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Ie = _.ReactCurrentDispatcher, Ue;
    function De(t, c, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (C) {
            var y = C.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Be = !1, Ae;
    {
      var Qe = typeof WeakMap == "function" ? WeakMap : Map;
      Ae = new Qe();
    }
    function Ee(t, c) {
      if (!t || Be)
        return "";
      {
        var p = Ae.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Be = !0;
      var C = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var T;
      T = Ie.current, Ie.current = null, Ye();
      try {
        if (c) {
          var S = function() {
            throw Error();
          };
          if (Object.defineProperty(S.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(S, []);
            } catch (re) {
              y = re;
            }
            Reflect.construct(t, [], S);
          } else {
            try {
              S.call();
            } catch (re) {
              y = re;
            }
            t.call(S.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (re) {
            y = re;
          }
          t();
        }
      } catch (re) {
        if (re && y && typeof re.stack == "string") {
          for (var x = re.stack.split(`
`), ee = y.stack.split(`
`), A = x.length - 1, M = ee.length - 1; A >= 1 && M >= 0 && x[A] !== ee[M]; )
            M--;
          for (; A >= 1 && M >= 0; A--, M--)
            if (x[A] !== ee[M]) {
              if (A !== 1 || M !== 1)
                do
                  if (A--, M--, M < 0 || x[A] !== ee[M]) {
                    var ue = `
` + x[A].replace(" at new ", " at ");
                    return t.displayName && ue.includes("<anonymous>") && (ue = ue.replace("<anonymous>", t.displayName)), typeof t == "function" && Ae.set(t, ue), ue;
                  }
                while (A >= 1 && M >= 0);
              break;
            }
        }
      } finally {
        Be = !1, Ie.current = T, ln(), Error.prepareStackTrace = C;
      }
      var ze = t ? t.displayName || t.name : "", Te = ze ? De(ze) : "";
      return typeof t == "function" && Ae.set(t, Te), Te;
    }
    function Me(t, c, p) {
      return Ee(t, !1);
    }
    function en(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function se(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ee(t, en(t));
      if (typeof t == "string")
        return De(t);
      switch (t) {
        case m:
          return De("Suspense");
        case u:
          return De("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Me(t.render);
          case f:
            return se(t.type, c, p);
          case h: {
            var y = t, C = y._payload, T = y._init;
            try {
              return se(T(C), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var ce = Object.prototype.hasOwnProperty, Se = {}, Ve = _.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, p = se(t.type, t._source, c ? c.type : null);
        Ve.setExtraStackFrame(p);
      } else
        Ve.setExtraStackFrame(null);
    }
    function kn(t, c, p, y, C) {
      {
        var T = Function.call.bind(ce);
        for (var S in t)
          if (T(t, S)) {
            var x = void 0;
            try {
              if (typeof t[S] != "function") {
                var ee = Error((y || "React class") + ": " + p + " type `" + S + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[S] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ee.name = "Invariant Violation", ee;
              }
              x = t[S](c, S, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (A) {
              x = A;
            }
            x && !(x instanceof Error) && (Pe(C), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, S, typeof x), Pe(null)), x instanceof Error && !(x.message in Se) && (Se[x.message] = !0, Pe(C), g("Failed %s type: %s", p, x.message), Pe(null));
          }
      }
    }
    var X = Array.isArray;
    function E(t) {
      return X(t);
    }
    function z(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function ae(t) {
      try {
        return de(t), !1;
      } catch {
        return !0;
      }
    }
    function de(t) {
      return "" + t;
    }
    function U(t) {
      if (ae(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", z(t)), de(t);
    }
    var J = _.ReactCurrentOwner, ve = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, we, Re;
    function rn(t) {
      if (ce.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function bn(t) {
      if (ce.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function an(t, c) {
      typeof t.ref == "string" && J.current;
    }
    function hn(t, c) {
      {
        var p = function() {
          we || (we = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function En(t, c) {
      {
        var p = function() {
          Re || (Re = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var _n = function(t, c, p, y, C, T, S) {
      var x = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: S,
        // Record the component responsible for creating this element.
        _owner: T
      };
      return x._store = {}, Object.defineProperty(x._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(x, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(x, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: C
      }), Object.freeze && (Object.freeze(x.props), Object.freeze(x)), x;
    };
    function Fn(t, c, p, y, C) {
      {
        var T, S = {}, x = null, ee = null;
        p !== void 0 && (U(p), x = "" + p), bn(c) && (U(c.key), x = "" + c.key), rn(c) && (ee = c.ref, an(c));
        for (T in c)
          ce.call(c, T) && !ve.hasOwnProperty(T) && (S[T] = c[T]);
        if (t && t.defaultProps) {
          var A = t.defaultProps;
          for (T in A)
            S[T] === void 0 && (S[T] = A[T]);
        }
        if (x || ee) {
          var M = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          x && hn(S, M), ee && En(S, M);
        }
        return _n(t, x, ee, C, y, J.current, S);
      }
    }
    var Ze = _.ReactCurrentOwner, gn = _.ReactDebugCurrentFrame;
    function Le(t) {
      if (t) {
        var c = t._owner, p = se(t.type, t._source, c ? c.type : null);
        gn.setExtraStackFrame(p);
      } else
        gn.setExtraStackFrame(null);
    }
    var dn;
    dn = !1;
    function un(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function Nn() {
      {
        if (Ze.current) {
          var t = P(Ze.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Bn(t) {
      return "";
    }
    var Sn = {};
    function An(t) {
      {
        var c = Nn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function vn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = An(c);
        if (Sn[p])
          return;
        Sn[p] = !0;
        var y = "";
        t && t._owner && t._owner !== Ze.current && (y = " It was passed a child from " + P(t._owner.type) + "."), Le(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Le(null);
      }
    }
    function xn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (E(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            un(y) && vn(y, c);
          }
        else if (un(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var C = j(t);
          if (typeof C == "function" && C !== t.entries)
            for (var T = C.call(t), S; !(S = T.next()).done; )
              un(S.value) && vn(S.value, c);
        }
      }
    }
    function Ln(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var y = P(c);
          kn(p, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !dn) {
          dn = !0;
          var C = P(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", C || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var y = c[p];
          if (y !== "children" && y !== "key") {
            Le(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Le(null);
            break;
          }
        }
        t.ref !== null && (Le(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Le(null));
      }
    }
    var Cn = {};
    function wn(t, c, p, y, C, T) {
      {
        var S = ne(t);
        if (!S) {
          var x = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (x += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ee = Bn();
          ee ? x += ee : x += Nn();
          var A;
          t === null ? A = "null" : E(t) ? A = "array" : t !== void 0 && t.$$typeof === n ? (A = "<" + (P(t.type) || "Unknown") + " />", x = " Did you accidentally export a JSX literal instead of a component?") : A = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", A, x);
        }
        var M = Fn(t, c, p, C, T);
        if (M == null)
          return M;
        if (S) {
          var ue = c.children;
          if (ue !== void 0)
            if (y)
              if (E(ue)) {
                for (var ze = 0; ze < ue.length; ze++)
                  xn(ue[ze], t);
                Object.freeze && Object.freeze(ue);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              xn(ue, t);
        }
        if (ce.call(c, "key")) {
          var Te = P(t), re = Object.keys(c).filter(function(Gn) {
            return Gn !== "key";
          }), mn = re.length > 0 ? "{key: someKey, " + re.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Cn[Te + mn]) {
            var Dn = re.length > 0 ? "{" + re.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, mn, Te, Dn, Te), Cn[Te + mn] = !0;
          }
        }
        return t === i ? Vn(M) : Ln(M), M;
      }
    }
    function zn(t, c, p) {
      return wn(t, c, p, !0);
    }
    function qn(t, c, p) {
      return wn(t, c, p, !1);
    }
    var Un = qn, Kn = zn;
    ks.Fragment = i, ks.jsx = Un, ks.jsxs = Kn;
  })()), ks;
}
var q_;
function zO() {
  return q_ || (q_ = 1, process.env.NODE_ENV === "production" ? hm.exports = LO() : hm.exports = VO()), hm.exports;
}
var xe = zO();
const UO = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "IssueFields" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHub_Issue" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", alias: { kind: "Name", value: "issueState" }, name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] }, MO = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "PullRequestFields" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHub_PullRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", alias: { kind: "Name", value: "prState" }, name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] }, BO = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getGithubOrganizationMembersByName" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "organizationQuery" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "usersQuery" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxResults" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "organization" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "login" }, value: { kind: "Variable", name: { kind: "Name", value: "organizationQuery" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "teams" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxResults" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "members" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxResults" } } }, { kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "usersQuery" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "login" } }, { kind: "Field", name: { kind: "Name", value: "avatarUrl" } }] } }] } }] } }] } }] } }] } }] } }] } }] } }] }, qO = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createGithubIssue" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "GitHub_CreateIssueInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "createIssue" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issue" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }] } }] } }] }, HO = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getGithubRepositoriesByName" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxResults" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "search" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }, { kind: "Argument", name: { kind: "Name", value: "type" }, value: { kind: "EnumValue", value: "REPOSITORY" } }, { kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxResults" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "repositoryCount" } }, { kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHub_Repository" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }] } }] } }] } }] }, WO = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "searchItems" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueQuery" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "prQuery" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxIssueResults" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxPRResults" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", alias: { kind: "Name", value: "issues" }, name: { kind: "Name", value: "search" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "issueQuery" } } }, { kind: "Argument", name: { kind: "Name", value: "type" }, value: { kind: "EnumValue", value: "ISSUE" } }, { kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxIssueResults" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issueCount" } }, { kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHub_Issue" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "pullRequests" }, name: { kind: "Name", value: "search" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "prQuery" } } }, { kind: "Argument", name: { kind: "Name", value: "type" }, value: { kind: "EnumValue", value: "ISSUE" } }, { kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxPRResults" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issueCount" } }, { kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHub_PullRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] } }] } }] } }] } }] }, KO = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getIssue" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "owner" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "repositoryName" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueNumber" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "repository" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "owner" }, value: { kind: "Variable", name: { kind: "Name", value: "owner" } } }, { kind: "Argument", name: { kind: "Name", value: "name" }, value: { kind: "Variable", name: { kind: "Name", value: "repositoryName" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issue" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "number" }, value: { kind: "Variable", name: { kind: "Name", value: "issueNumber" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] } }] } }] } }] }, GO = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getPullRequest" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "owner" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "repositoryName" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "prNumber" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "repository" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "owner" }, value: { kind: "Variable", name: { kind: "Name", value: "owner" } } }, { kind: "Argument", name: { kind: "Name", value: "name" }, value: { kind: "Variable", name: { kind: "Name", value: "repositoryName" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pullRequest" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "number" }, value: { kind: "Variable", name: { kind: "Name", value: "prNumber" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] } }] } }] } }] }, YO = {
  "\n  query getGithubOrganizationMembersByName(\n    $organizationQuery: String!\n    $usersQuery: String!\n    $maxResults: Int!\n  ) {\n    GitHub {\n      organization(login: $organizationQuery) {\n        teams(first: $maxResults) {\n          edges {\n            node {\n              id\n              name\n              members(first: $maxResults, query: $usersQuery) {\n                edges {\n                  node {\n                    id\n                    name\n                    login\n                    avatarUrl\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": BO,
  "\n  mutation createGithubIssue($input: GitHub_CreateIssueInput!) {\n    GitHub {\n      createIssue(input: $input) {\n        issue {\n          id\n          number\n          repository {\n            name\n          }\n        }\n      }\n    }\n  }\n": qO,
  "\n  query getGithubRepositoriesByName($query: String!, $maxResults: Int!) {\n    GitHub {\n      search(query: $query, type: REPOSITORY, first: $maxResults) {\n        repositoryCount\n        edges {\n          node {\n            ... on GitHub_Repository {\n              id\n              name\n            }\n          }\n        }\n      }\n    }\n  }\n": HO,
  "\n  fragment IssueFields on GitHub_Issue {\n    id\n    number\n    title\n    body\n    bodyText\n    author {\n      avatarUrl\n      login\n    }\n    issueState: state\n    assignees(first: 10) {\n      nodes {\n        avatarUrl\n        name\n      }\n    }\n    labels(first: 10) {\n      nodes {\n        color\n        name\n      }\n    }\n    repository {\n      name\n      owner {\n        login\n      }\n    }\n  }\n": UO,
  "\n  fragment PullRequestFields on GitHub_PullRequest {\n    id\n    number\n    title\n    body\n    bodyText\n    author {\n      avatarUrl\n      login\n    }\n    prState: state\n    assignees(first: 10) {\n      nodes {\n        avatarUrl\n        name\n      }\n    }\n    labels(first: 10) {\n      nodes {\n        color\n        name\n      }\n    }\n    repository {\n      name\n      owner {\n        login\n      }\n    }\n  }\n": MO,
  "\n  query searchItems(\n    $issueQuery: String!\n    $prQuery: String!\n    $maxIssueResults: Int\n    $maxPRResults: Int\n  ) {\n    GitHub {\n      issues: search(query: $issueQuery, type: ISSUE, first: $maxIssueResults) {\n        issueCount\n        nodes {\n          ... on GitHub_Issue {\n            id\n            number\n            title\n            body\n            bodyText\n            author {\n              avatarUrl\n              login\n            }\n            state\n            assignees(first: 10) {\n              nodes {\n                avatarUrl\n                name\n              }\n            }\n            labels(first: 10) {\n              nodes {\n                color\n                name\n              }\n            }\n            repository {\n              name\n              owner {\n                login\n              }\n            }\n          }\n        }\n      }\n      pullRequests: search(query: $prQuery, type: ISSUE, first: $maxPRResults) {\n        issueCount\n        nodes {\n          ... on GitHub_PullRequest {\n            id\n            number\n            title\n            body\n            bodyText\n            author {\n              avatarUrl\n              login\n            }\n            state\n            assignees(first: 10) {\n              nodes {\n                avatarUrl\n                name\n              }\n            }\n            labels(first: 10) {\n              nodes {\n                color\n                name\n              }\n            }\n            repository {\n              name\n              owner {\n                login\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": WO,
  "\n  query getIssue(\n    $owner: String!\n    $repositoryName: String!\n    $issueNumber: Int!\n  ) {\n    GitHub {\n      repository(owner: $owner, name: $repositoryName) {\n        issue(number: $issueNumber) {\n          id\n          number\n          title\n          body\n          bodyText\n          author {\n            avatarUrl\n            login\n          }\n          state\n          assignees(first: 10) {\n            nodes {\n              avatarUrl\n              name\n            }\n          }\n          labels(first: 10) {\n            nodes {\n              color\n              name\n            }\n          }\n          repository {\n            name\n            owner {\n              login\n            }\n          }\n        }\n      }\n    }\n  }\n": KO,
  "\n  query getPullRequest(\n    $owner: String!\n    $repositoryName: String!\n    $prNumber: Int!\n  ) {\n    GitHub {\n      repository(owner: $owner, name: $repositoryName) {\n        pullRequest(number: $prNumber) {\n          id\n          number\n          title\n          body\n          bodyText\n          author {\n            avatarUrl\n            login\n          }\n          state\n          assignees(first: 10) {\n            nodes {\n              avatarUrl\n              name\n            }\n          }\n          labels(first: 10) {\n            nodes {\n              color\n              name\n            }\n          }\n          repository {\n            name\n            owner {\n              login\n            }\n          }\n        }\n      }\n    }\n  }\n": GO
};
function Oa(e) {
  return YO[e] ?? {};
}
const JO = Oa(
  /* GraphQL */
  `
  query searchItems(
    $issueQuery: String!
    $prQuery: String!
    $maxIssueResults: Int
    $maxPRResults: Int
  ) {
    GitHub {
      issues: search(query: $issueQuery, type: ISSUE, first: $maxIssueResults) {
        issueCount
        nodes {
          ... on GitHub_Issue {
            id
            number
            title
            body
            bodyText
            author {
              avatarUrl
              login
            }
            state
            assignees(first: 10) {
              nodes {
                avatarUrl
                name
              }
            }
            labels(first: 10) {
              nodes {
                color
                name
              }
            }
            repository {
              name
              owner {
                login
              }
            }
          }
        }
      }
      pullRequests: search(query: $prQuery, type: ISSUE, first: $maxPRResults) {
        issueCount
        nodes {
          ... on GitHub_PullRequest {
            id
            number
            title
            body
            bodyText
            author {
              avatarUrl
              login
            }
            state
            assignees(first: 10) {
              nodes {
                avatarUrl
                name
              }
            }
            labels(first: 10) {
              nodes {
                color
                name
              }
            }
            repository {
              name
              owner {
                login
              }
            }
          }
        }
      }
    }
  }
`
), QO = Oa(
  /* GraphQL */
  `
  query getIssue(
    $owner: String!
    $repositoryName: String!
    $issueNumber: Int!
  ) {
    GitHub {
      repository(owner: $owner, name: $repositoryName) {
        issue(number: $issueNumber) {
          id
          number
          title
          body
          bodyText
          author {
            avatarUrl
            login
          }
          state
          assignees(first: 10) {
            nodes {
              avatarUrl
              name
            }
          }
          labels(first: 10) {
            nodes {
              color
              name
            }
          }
          repository {
            name
            owner {
              login
            }
          }
        }
      }
    }
  }
`
), XO = Oa(
  /* GraphQL */
  `
  query getPullRequest(
    $owner: String!
    $repositoryName: String!
    $prNumber: Int!
  ) {
    GitHub {
      repository(owner: $owner, name: $repositoryName) {
        pullRequest(number: $prNumber) {
          id
          number
          title
          body
          bodyText
          author {
            avatarUrl
            login
          }
          state
          assignees(first: 10) {
            nodes {
              avatarUrl
              name
            }
          }
          labels(first: 10) {
            nodes {
              color
              name
            }
          }
          repository {
            name
            owner {
              login
            }
          }
        }
      }
    }
  }
`
), H_ = ({
  owner: e,
  repository: n,
  number: r
}) => `https://github.com/${e}/${n}/issues/${r}`, _r = ({
  owner: e,
  repository: n,
  number: r
}) => `${e}/${n} #${r}`, ZO = ({
  number: e,
  repository: n
}) => ({
  number: e,
  repository: n.name,
  owner: n.owner.login
}), W_ = (e) => {
  switch (e) {
    case "ISSUE":
      return "issue";
    case "PR":
      return "pull request";
    default:
      return e;
  }
}, ty = (e, n, r) => e === "ISSUE" ? {
  OPEN: /* @__PURE__ */ xe.jsxs(
    "svg",
    {
      className: r,
      fill: "#3fb950",
      height: "16",
      width: "16",
      "aria-hidden": "true",
      children: [
        /* @__PURE__ */ xe.jsx("path", { d: "M8 9.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3z" }),
        /* @__PURE__ */ xe.jsx("path", { d: "M8 0a8 8 0 100 16A8 8 0 008 0zM1.5 8a6.5 6.5 0 1113 0 6.5 6.5 0 01-13 0z" })
      ]
    }
  ),
  CLOSED: /* @__PURE__ */ xe.jsxs(
    "svg",
    {
      className: r,
      fill: "#a371f7",
      width: "16",
      height: "16",
      "aria-hidden": "true",
      children: [
        /* @__PURE__ */ xe.jsx("path", { d: "M11.28 6.78a.75.75 0 00-1.06-1.06L7.25 8.69 5.78 7.22a.75.75 0 00-1.06 1.06l2 2a.75.75 0 001.06 0l3.5-3.5z" }),
        /* @__PURE__ */ xe.jsx(
          "path",
          {
            fillRule: "evenodd",
            d: "M16 8A8 8 0 110 8a8 8 0 0116 0zm-1.5 0a6.5 6.5 0 11-13 0 6.5 6.5 0 0113 0z"
          }
        )
      ]
    }
  )
}[n] : {
  OPEN: /* @__PURE__ */ xe.jsx(
    "svg",
    {
      className: r,
      fill: "#3fb950",
      width: "16",
      height: "16",
      "aria-hidden": "true",
      children: /* @__PURE__ */ xe.jsx("path", { d: "M7.177 3.073L9.573.677A.25.25 0 0110 .854v4.792a.25.25 0 01-.427.177L7.177 3.427a.25.25 0 010-.354zM3.75 2.5a.75.75 0 100 1.5.75.75 0 000-1.5zm-2.25.75a2.25 2.25 0 113 2.122v5.256a2.251 2.251 0 11-1.5 0V5.372A2.25 2.25 0 011.5 3.25zM11 2.5h-1V4h1a1 1 0 011 1v5.628a2.251 2.251 0 101.5 0V5A2.5 2.5 0 0011 2.5zm1 10.25a.75.75 0 111.5 0 .75.75 0 01-1.5 0zM3.75 12a.75.75 0 100 1.5.75.75 0 000-1.5z" })
    }
  ),
  MERGED: /* @__PURE__ */ xe.jsx(
    "svg",
    {
      className: r,
      fill: "#a371f7",
      width: "16",
      height: "16",
      "aria-hidden": "true",
      children: /* @__PURE__ */ xe.jsx("path", { d: "M5 3.254V3.25v.005a.75.75 0 110-.005v.004zm.45 1.9a2.25 2.25 0 10-1.95.218v5.256a2.25 2.25 0 101.5 0V7.123A5.735 5.735 0 009.25 9h1.378a2.251 2.251 0 100-1.5H9.25a4.25 4.25 0 01-3.8-2.346zM12.75 9a.75.75 0 100-1.5.75.75 0 000 1.5zm-8.5 4.5a.75.75 0 100-1.5.75.75 0 000 1.5z" })
    }
  ),
  CLOSED: /* @__PURE__ */ xe.jsx(
    "svg",
    {
      className: r,
      fill: "#f85149",
      width: "16",
      height: "16",
      "aria-hidden": "true",
      children: /* @__PURE__ */ xe.jsx("path", { d: "M10.72 1.227a.75.75 0 011.06 0l.97.97.97-.97a.75.75 0 111.06 1.061l-.97.97.97.97a.75.75 0 01-1.06 1.06l-.97-.97-.97.97a.75.75 0 11-1.06-1.06l.97-.97-.97-.97a.75.75 0 010-1.06zM12.75 6.5a.75.75 0 00-.75.75v3.378a2.251 2.251 0 101.5 0V7.25a.75.75 0 00-.75-.75zm0 5.5a.75.75 0 100 1.5.75.75 0 000-1.5zM2.5 3.25a.75.75 0 111.5 0 .75.75 0 01-1.5 0zM3.25 1a2.25 2.25 0 00-.75 4.372v5.256a2.251 2.251 0 101.5 0V5.372A2.25 2.25 0 003.25 1zm0 11a.75.75 0 100 1.5.75.75 0 000-1.5z" })
    }
  )
}[n];
function eP({
  conversationId: e,
  githubOrganization: n
}) {
  const r = {
    github: { issues: [], pullRequests: [] }
  }, [i, a] = me(
    []
  ), [o, s] = me([]), [l, d] = me([]), [m, u] = me([]), [f, h] = me(), { showNotification: v, showModal: w, executeQuery: N } = fn(), { track: j } = jn(), {
    loading: _,
    data: g,
    error: O,
    store: R
  } = Iy(e ?? null), $ = g?.github?.issues || [], I = g?.github?.pullRequests || [], [L, G] = me(!1), [Q, ne] = me();
  Xe(
    () => h(O || Q || void 0),
    [O, Q]
  ), Xe(
    () => {
      !_ && ($?.length || I?.length) ? (a($), s(I), Y($, I)) : (a([]), s([]), d([]), u([]));
    },
    // Only trigger when data is loaded, not when the loading status changes.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [g]
  );
  const q = async (ge, V) => {
    await R(ge).then(() => {
      v({
        icon: "check-circle-filled",
        severity: "success",
        title: V.success.title,
        text: V.success.text
      });
    }).catch((be) => {
      v({
        title: V.error.title,
        text: `${V.error.text} ${be.message && " (" + be.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    });
  }, Y = (ge, V) => {
    if (!ge?.length && !V?.length) {
      d([]), u([]);
      return;
    }
    const be = (ge || []).map(
      (Ye) => N(QO, {
        owner: Ye.owner,
        repositoryName: Ye.repository,
        issueNumber: Ye.number
      })
    ), Oe = (V || []).map(
      (Ye) => N(XO, {
        owner: Ye.owner,
        repositoryName: Ye.repository,
        prNumber: Ye.number
      })
    ), H = [...be, ...Oe];
    G(!0), Promise.all(H).then((Ye) => {
      const ln = [], Ie = [];
      Ye.forEach((Ue) => {
        const De = Ue?.data?.GitHub;
        if (!De) {
          d([]), u([]);
          return;
        }
        Object.keys(De).forEach((Be) => {
          if (Be.startsWith("repository")) {
            const Ae = De[Be];
            Object.keys(Ae).forEach((Qe) => {
              const Ee = Ae[Qe], Me = {
                number: Ee?.number,
                owner: Ee?.repository?.owner?.login,
                repository: Ee?.repository?.name
              };
              Qe.startsWith("issue") && ln.push({
                ...Ee,
                type: "ISSUE",
                key: Me
              }), Qe.startsWith("pullRequest") && Ie.push({
                ...Ee,
                type: "PR",
                key: Me
              });
            });
          }
        });
      }), d(ln), u(Ie);
    }).catch(ne).finally(() => {
      G(!1);
    });
  }, P = ({ key: ge, type: V }) => {
    j("github:link:issue:clicked", {
      githubOrganization: n
    });
    const be = g && ($.length || I.length) ? g : r, Oe = V === "ISSUE" ? "issues" : "pullRequests";
    be.github[Oe] = Array.from(
      new Set(be.github[Oe]).add(ge)
    ), q(be, {
      success: {
        title: "GitHub issue linked",
        text: `You linked the GitHub issue ${_r(
          ge
        )} to this conversation.`
      },
      error: {
        title: "Linking failed",
        text: `Linking ${_r(ge)} failed. Please try again.`
      }
    });
  }, B = async ({ key: ge, type: V }) => {
    j("github:link:issue:clicked", {
      githubOrganization: n
    });
    const be = g && ($.length || I.length) ? g : r, Oe = V === "ISSUE" ? "issues" : "pullRequests";
    be.github[Oe] = Array.from(
      new Set(be.github[Oe]).add(ge)
    ), await R(be).catch((H) => {
      v({
        title: "Linking failed",
        text: `Linking ${ge} failed. Please try again. ${H.message && " (" + H.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    });
  }, ie = ({ key: ge, type: V }) => {
    j("github:unlink:issue:clicked", {
      githubOrganization: n
    });
    const be = V === "ISSUE" ? "issue" : "pull request";
    w({
      headline: `Unlink ${be} ${_r(ge)}?`,
      text: `You are about to unlink the ${be} ${_r(
        ge
      )}. Do you want to proceed?`,
      confirmLabel: `Unlink GitHub ${be}`,
      confirmVariant: "danger",
      cancelLabel: "Cancel",
      onConfirm: () => {
        const Oe = V === "ISSUE" ? "issues" : "pullRequests";
        if (!g)
          return;
        const H = {
          ...g,
          github: {
            ...g?.github,
            [Oe]: g?.github?.[Oe].filter(
              (Ye) => Ye.number !== ge.number || Ye.owner !== ge.owner || Ye.repository !== ge.repository
            )
          }
        };
        j("github:unlink:issue:confirmed", {
          githubOrganization: n
        }), q(H, {
          success: {
            title: `GitHub ${be} unlinked`,
            text: `You unlinked the GitHub ${be} ${_r(
              ge
            )}`
          },
          error: {
            title: "Unlinking failed",
            text: `Unlinking ${_r(ge)} failed.`
          }
        });
      },
      onCancel: () => {
        j("github:unlink:issue:canceled", {
          githubOrganization: n
        });
      }
    });
  }, je = () => {
    j("github:unlink:all:clicked", {
      githubOrganization: n
    }), w({
      headline: "Unlink all GitHub issues/pull requests?",
      text: "You are about to unlink the all GitHub issues/pull requests from the conversation. Do you want to proceed?",
      confirmLabel: "Unlink ALL issues/pull requests",
      confirmVariant: "danger",
      cancelLabel: "Cancel",
      onConfirm: () => {
        j("github:unlink:all:confirmed", {
          githubOrganization: n
        }), q(r, {
          success: {
            title: "Unlinking successful",
            text: "All GitHub issues/pull requests were unlinked"
          },
          error: {
            title: "Unlinking failed",
            text: "Unlinking all issues/pull requests failed."
          }
        });
      },
      onCancel: () => {
        j("github:unlink:all:canceled", {
          githubOrganization: n
        });
      }
    });
  }, pe = $.filter(
    (ge) => !i?.includes(ge)
  ) || [], le = I.filter(
    (ge) => !o?.includes(ge)
  ) || [];
  return {
    linkGithubItem: P,
    linkGithubItemQuietly: B,
    unlinkGithubItem: ie,
    loadGithubItems: Y,
    removeDanglingGithubItemLinks: () => {
      const ge = {
        ...g,
        github: {
          ...g?.github,
          issues: $.filter(
            (V) => !pe.includes(V)
          ) || [],
          pullRequests: I.filter(
            (V) => !le.includes(V)
          ) || []
        }
      };
      R(ge);
    },
    unlinkAllGithubItems: je,
    isLoadingGithubItemLinks: _,
    danglingIssueLinks: pe,
    danglingPullRequestLinks: le,
    isLoadingGithubItems: L,
    issues: l,
    pullRequests: m,
    error: f
  };
}
const nP = "_contentWrapper_1vx3c_1", tP = "_contentWrapperHeadline_1vx3c_4", rP = "_contentWrapperBody_1vx3c_11", iP = "_contentWrapperAssigneeIcon_1vx3c_15", aP = "_contentWrapperStatusTag_1vx3c_20", ti = {
  contentWrapper: nP,
  contentWrapperHeadline: tP,
  contentWrapperBody: rP,
  contentWrapperAssigneeIcon: iP,
  contentWrapperStatusTag: aP
}, QC = ({
  description: e,
  assignees: n,
  labels: r
}) => /* @__PURE__ */ xe.jsxs(xe.Fragment, { children: [
  e && /* @__PURE__ */ xe.jsxs(ct, { className: ti.contentWrapper, children: [
    /* @__PURE__ */ xe.jsx(ct, { className: ti.contentWrapperHeadline, children: "Description" }),
    /* @__PURE__ */ xe.jsx(ct, { className: ti.contentWrapperBody, children: e })
  ] }),
  n?.nodes && n.nodes.length > 0 && /* @__PURE__ */ xe.jsxs(ct, { className: ti.contentWrapper, children: [
    /* @__PURE__ */ xe.jsx(ct, { className: ti.contentWrapperHeadline, children: "Assignees" }),
    /* @__PURE__ */ xe.jsx(ct, { className: ti.contentWrapperBody, children: n.nodes.map(
      (i) => i && /* @__PURE__ */ xe.jsxs(ct, { margin: "100 0", children: [
        /* @__PURE__ */ xe.jsx(
          "img",
          {
            className: ti.contentWrapperAssigneeIcon,
            src: i.avatarUrl,
            alt: i.name || ""
          }
        ),
        " ",
        i.name
      ] }, i.name)
    ) })
  ] }),
  r?.nodes && r?.nodes.length > 0 && /* @__PURE__ */ xe.jsx(ct, { className: ti.contentWrapper, children: r.nodes.map(
    (i) => i && /* @__PURE__ */ xe.jsx(
      Jn,
      {
        className: ti.contentWrapperStatusTag,
        children: i.name
      },
      i.name
    )
  ) })
] }), oP = "_collapse_1bdjy_1", sP = "_collapseHeader_1bdjy_10", lP = "_collapseHeaderKey_1bdjy_31", cP = "_collapseHeaderKeyIcon_1bdjy_36", dP = "_collapseHeaderKeyLink_1bdjy_41", uP = "_collapseHeaderIcon_1bdjy_44", mP = "_collapseHeaderTitle_1bdjy_49", pP = "_collapseContent_1bdjy_57", fP = "_collapseContentButtonSpacer_1bdjy_60", hP = "_collapseContentButtonLink_1bdjy_63", Pr = {
  collapse: oP,
  collapseHeader: sP,
  collapseHeaderKey: lP,
  collapseHeaderKeyIcon: cP,
  collapseHeaderKeyLink: dP,
  collapseHeaderIcon: uP,
  collapseHeaderTitle: mP,
  collapseContent: pP,
  collapseContentButtonSpacer: fP,
  collapseContentButtonLink: hP
}, yP = ({
  items: e,
  unlinkGithubItem: n,
  githubOrganization: r
}) => {
  const i = e.reduce(
    (d, m) => ({ ...d, [m.id]: !1 }),
    {}
  ), [a, o] = me(i), { track: s } = jn(), l = (d, m) => {
    o({ ...a, [d]: m });
  };
  return /* @__PURE__ */ xe.jsx(b, { flexDirection: "column", gap: "250", children: e?.length ? e.map((d) => {
    const {
      id: m,
      number: u,
      key: f,
      title: h,
      bodyText: v,
      repository: w,
      type: N,
      state: j,
      assignees: _,
      labels: g
    } = d, O = a[m];
    return /* @__PURE__ */ xe.jsxs(
      Sr,
      {
        onToggle: () => l(m, !a[m]),
        isOpen: O,
        className: Pr.collapse,
        children: [
          /* @__PURE__ */ xe.jsx(Sr.Header, { className: Pr.collapseHeader, children: /* @__PURE__ */ xe.jsxs(
            b,
            {
              flexDirection: "column",
              gap: "200",
              justifyContent: "space-between",
              children: [
                /* @__PURE__ */ xe.jsx(ct, { children: /* @__PURE__ */ xe.jsxs(ct, { as: "span", className: Pr.collapseHeaderKey, children: [
                  ty(
                    N,
                    j,
                    Pr.collapseHeaderKeyIcon
                  ),
                  /* @__PURE__ */ xe.jsxs(
                    "a",
                    {
                      href: H_(f),
                      className: Pr.collapseHeaderKeyLink,
                      target: "_blank",
                      rel: "noreferrer",
                      onClick: (R) => {
                        R.stopPropagation();
                      },
                      children: [
                        _r(f),
                        /* @__PURE__ */ xe.jsx(
                          fe,
                          {
                            className: Pr.collapseHeaderIcon,
                            name: "external-link",
                            size: 16
                          }
                        )
                      ]
                    }
                  )
                ] }) }),
                /* @__PURE__ */ xe.jsx(ct, { className: Pr.collapseHeaderTitle, children: h })
              ]
            }
          ) }),
          /* @__PURE__ */ xe.jsx(Sr.Content, { className: Pr.collapseContent, children: /* @__PURE__ */ xe.jsxs(b, { flexDirection: "column", margin: "0 0 200 0", children: [
            /* @__PURE__ */ xe.jsx(
              QC,
              {
                description: v,
                assignees: _,
                labels: g
              }
            ),
            /* @__PURE__ */ xe.jsxs(
              Qn,
              {
                icon: "link-slash",
                variant: "secondary",
                className: Pr.collapseContentButtonSpacer,
                onClick: () => n({
                  key: {
                    number: u,
                    owner: w?.owner.login,
                    repository: d.repository.name
                  },
                  type: N
                }),
                children: [
                  "Unlink ",
                  W_(N)
                ]
              }
            ),
            /* @__PURE__ */ xe.jsxs(
              Et,
              {
                slotEnd: /* @__PURE__ */ xe.jsx(fe, { name: "external-link" }),
                variant: "tertiary",
                className: Pr.collapseContentButtonLink,
                navigate: () => {
                  s("github:view:link:clicked", {
                    githubOrganization: r
                  }), window.open(H_(f), "_blank")?.focus();
                },
                children: [
                  "View ",
                  W_(N),
                  " in GitHub"
                ]
              }
            )
          ] }) })
        ]
      },
      m
    );
  }) : /* @__PURE__ */ xe.jsx(xe.Fragment, {}) });
}, gP = "_result_1uaom_1", vP = "_resultName_1uaom_21", kP = "_resultItemIcon_1uaom_29", bP = "_resultDescription_1uaom_34", _P = "_resultLinkIcon_1uaom_46", xP = "_tooltip_1uaom_55", SP = "_tooltipName_1uaom_61", NP = "_tooltipTag_1uaom_71", ri = {
  result: gP,
  resultName: vP,
  resultItemIcon: kP,
  resultDescription: bP,
  resultLinkIcon: _P,
  tooltip: xP,
  tooltipName: SP,
  tooltipTag: NP
}, jP = ({
  item: e,
  onSelect: n
}) => {
  const { key: r, title: i, type: a, state: o, labels: s, bodyText: l, assignees: d } = e, [m, u] = me(!1);
  return /* @__PURE__ */ xe.jsx(
    Ge,
    {
      className: ri.tooltip,
      content: /* @__PURE__ */ xe.jsxs(b, { flexDirection: "column", justifyContent: "center", width: "100%", children: [
        /* @__PURE__ */ xe.jsxs(
          b,
          {
            flexDirection: "row",
            justifyContent: "space-between",
            width: "100%",
            alignItems: "center",
            margin: "0 0 300 0",
            children: [
              /* @__PURE__ */ xe.jsxs(ct, { as: "span", className: ri.tooltipName, children: [
                ty(a, o, ri.resultItemIcon),
                i
              ] }),
              /* @__PURE__ */ xe.jsx(Jn, { className: ri.tooltipTag, children: o })
            ]
          }
        ),
        /* @__PURE__ */ xe.jsx(
          QC,
          {
            description: l,
            assignees: d,
            labels: s
          }
        )
      ] }),
      side: "left",
      light: !0,
      children: /* @__PURE__ */ xe.jsxs(
        "button",
        {
          className: ri.result,
          type: "button",
          onClick: () => {
            n(e);
          },
          onMouseEnter: () => u(!0),
          onMouseLeave: () => u(!1),
          children: [
            /* @__PURE__ */ xe.jsxs(
              b,
              {
                flexDirection: "column",
                justifyContent: "center",
                width: "100%",
                style: {
                  width: m ? "calc(100% - 32px)" : "100%"
                },
                children: [
                  /* @__PURE__ */ xe.jsx(b, { flexDirection: "row", children: /* @__PURE__ */ xe.jsxs(ct, { as: "span", className: ri.resultName, children: [
                    ty(a, o, ri.resultItemIcon),
                    _r(r)
                  ] }) }),
                  /* @__PURE__ */ xe.jsx(ct, { className: ri.resultDescription, children: i })
                ]
              }
            ),
            m && /* @__PURE__ */ xe.jsx(
              fe,
              {
                className: ri.resultLinkIcon,
                name: "plus",
                size: 32
              }
            )
          ]
        }
      )
    }
  );
}, wP = ({
  className: e,
  searched: n,
  githubOrganization: r
}) => /* @__PURE__ */ xe.jsx(
  Et,
  {
    slotEnd: /* @__PURE__ */ xe.jsx(fe, { name: "external-link" }),
    variant: "tertiary",
    style: { width: "100%" },
    className: e,
    navigate: () => {
      window.open(
        `https://github.com/search?q=is:issue+org:${r}+${n}`,
        "_blank"
      )?.focus();
    },
    children: "View matching items on GitHub"
  }
), _l = "[a-zA-z0-9_.-]+", XC = "[0-9]+", CP = new RegExp(
  `(${_l})/(${_l})/(?:issues|pull)/(${XC})`,
  "i"
), K_ = new RegExp(`^${CP.source}$`), G_ = new RegExp(
  `https://github.com/(${_l})/(${_l})/(?:issues|pull)/(${XC})`,
  "i"
), FP = ({
  onSelectItem: e,
  githubOrganization: n,
  linkedIssues: r,
  linkedPullRequests: i
}) => {
  const a = Zn(() => r?.map((I) => I.id) || [], [r]), o = Zn(() => i?.map((I) => I.id) || [], [i]), [s, l] = me([]), { useLazyQuery: d } = fn(), [m, u] = me(), [f, { loading: h, error: v, data: w, networkStatus: N }] = d(JO, {
    notifyOnNetworkStatusChange: !0
  });
  xi(
    () => {
      !h && m && N === ir.ready ? f({
        variables: {
          issueQuery: `${m} type:issue`,
          prQuery: `${m} type:pr`,
          maxIssueResults: 12,
          maxPRResults: 12
        }
      }) : l([]);
    },
    500,
    [m]
  ), Xe(() => {
    let I = w?.GitHub?.issues?.nodes || [], L = w?.GitHub?.pullRequests.nodes || [];
    a.length > 0 && (I = I.filter((G) => !a.includes(G.id))), o.length > 0 && (L = L.filter(
      (G) => !o.includes(G.id)
    )), l([
      ...I.map((G) => ({
        ...G,
        type: "ISSUE",
        key: {
          number: G.number,
          owner: G.repository.owner.login,
          repository: G.repository.name
        }
      })),
      ...L.map((G) => ({
        ...G,
        type: "PR",
        key: {
          number: G.number,
          owner: G.repository.owner.login,
          repository: G.repository.name
        }
      }))
    ]);
  }, [w, a, o]);
  function j(I) {
    const L = I?.trim();
    if (K_.test(L)) {
      const [G, Q, ne, q] = L.match(K_) || [];
      return Q !== n ? void 0 : {
        owner: n,
        repository: ne,
        number: parseInt(q)
      };
    }
    if (G_.test(L)) {
      const [G, Q, ne, q] = L.match(G_) || [];
      return Q !== n ? void 0 : {
        owner: n,
        repository: ne,
        number: parseInt(q)
      };
    }
  }
  const _ = (I) => {
    e({
      key: ZO(I),
      type: I.type
    }), u(void 0);
  }, g = (I) => {
    const L = j(I);
    u(
      L ? `org:${L.owner} repo:${L.repository} ${L.number}` : `org:${n} ${I}`
    );
  }, O = () => {
    u(void 0);
  }, R = ({ className: I, searched: L }) => /* @__PURE__ */ xe.jsx(
    wP,
    {
      className: I,
      searched: L,
      githubOrganization: n
    }
  ), $ = ({ item: I, onSelect: L }) => /* @__PURE__ */ xe.jsx(jP, { item: I, onSelect: L });
  return !h && v ? /* @__PURE__ */ xe.jsx($n, { error: v }) : /* @__PURE__ */ xe.jsx(
    Rr,
    {
      items: s?.map((I) => ({ name: I.title, ...I })),
      loading: h,
      onSearch: g,
      onSelect: _,
      onClear: O,
      emptyMessage: m ? h ? "" : "No GitHub items found" : "Enter GitHub item key, link or search terms",
      suggestionComponent: R,
      itemComponent: $,
      placeholder: "Search GitHub items",
      searchable: !0,
      clearable: !0
    }
  );
}, IP = "_itemButton_3sxfy_1", $P = "_result_3sxfy_6", EP = "_resultName_3sxfy_30", TP = "_resultCheckIcon_3sxfy_38", RP = "_resultAssigneeIcon_3sxfy_41", Qa = {
  itemButton: IP,
  result: $P,
  resultName: EP,
  resultCheckIcon: TP,
  resultAssigneeIcon: RP
}, ZC = ({
  item: e,
  checked: n = !1,
  onSelectItem: r
}) => /* @__PURE__ */ xe.jsx(
  b,
  {
    flexDirection: "column",
    justifyContent: "center",
    width: "100%",
    "data-testid": "github-select-item-component",
    children: /* @__PURE__ */ xe.jsx(
      "button",
      {
        onClick: () => {
          r(e);
        },
        className: Qa.itemButton,
        children: /* @__PURE__ */ xe.jsxs(b, { className: Qa.result, flexDirection: "row", width: "100%", children: [
          e.iconUrl && /* @__PURE__ */ xe.jsx(ct, { margin: "100 0", children: /* @__PURE__ */ xe.jsx(
            "img",
            {
              className: Qa.resultAssigneeIcon,
              src: e.iconUrl,
              alt: e.name
            }
          ) }, e.name),
          /* @__PURE__ */ xe.jsx(ct, { className: Qa.resultName, children: e.name }),
          n && /* @__PURE__ */ xe.jsx(ct, { className: Qa.resultCheckIcon, children: /* @__PURE__ */ xe.jsx(fe, { name: "done" }) })
        ] })
      }
    )
  }
), DP = Oa(
  /* GraphQL */
  `
  query getGithubOrganizationMembersByName(
    $organizationQuery: String!
    $usersQuery: String!
    $maxResults: Int!
  ) {
    GitHub {
      organization(login: $organizationQuery) {
        teams(first: $maxResults) {
          edges {
            node {
              id
              name
              members(first: $maxResults, query: $usersQuery) {
                edges {
                  node {
                    id
                    name
                    login
                    avatarUrl
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`
), OP = ({
  githubOrganization: e,
  selectedItems: n,
  onChange: r,
  multiple: i = !1
}) => {
  const { useLazyQuery: a } = fn(), [o, s] = me([]), [l, d] = me(""), m = 2, [u, { loading: f, error: h, data: v, networkStatus: w }] = a(
    DP,
    {
      notifyOnNetworkStatusChange: !0
    }
  );
  return xi(
    () => {
      !f && l && l.length >= m && w === ir.ready ? u({
        variables: {
          usersQuery: l,
          organizationQuery: e,
          maxResults: 10
        }
      }) : s([]);
    },
    500,
    [l]
  ), Xe(() => {
    const N = v?.GitHub?.organization?.teams || { edges: [] }, j = [];
    N?.edges?.forEach((_) => {
      const g = _?.node?.members?.edges;
      (g?.length || 0) > 0 && g?.forEach((O) => {
        const R = O?.node;
        R && (R?.id && j.find(($) => $.id === R.id) || j.push(R));
      });
    }), s(
      j.sort((_, g) => {
        const O = _.name?.toLowerCase() || _.login?.toLowerCase(), R = g.name?.toLowerCase() || g.login?.toLowerCase();
        return O.localeCompare(R, void 0, {
          sensitivity: "base"
        });
      })
    );
  }, [v]), !f && h ? /* @__PURE__ */ xe.jsx($n, { error: h }) : /* @__PURE__ */ xe.jsx(
    Rr,
    {
      clearable: !0,
      searchable: !0,
      multiple: i,
      items: o?.map(({ id: N, name: j, login: _, avatarUrl: g }) => ({
        id: N,
        name: j || _,
        iconUrl: g
      })) || [],
      loading: f,
      onSearch: (N) => d(N),
      onChange: (N, j) => {
        const _ = N.id;
        i ? (j && !n.find(
          (g) => g.id === _
        ) && n.push(N), j || (n = n.filter(
          (g) => g.id !== _
        ))) : n = j ? [N] : [], r(n);
      },
      onClear: () => d(""),
      selectedItems: n,
      emptyMessage: l ? f ? "" : "No user found" : "Search users",
      itemComponent: ({ item: N, onSelect: j, checked: _ }) => /* @__PURE__ */ xe.jsx(
        ZC,
        {
          item: N,
          checked: _,
          onSelectItem: j
        }
      ),
      placeholder: "Search GitHub users"
    }
  );
}, PP = ({
  field: e,
  value: n,
  onChange: r,
  githubOrganization: i
}) => {
  const { multiple: a, type: o } = e;
  switch (o) {
    case "any":
      return /* @__PURE__ */ xe.jsx(ur, { onChange: r, value: n });
    case "array":
      return e?.allowedValues ? /* @__PURE__ */ xe.jsx(
        Rr,
        {
          onSelect: r,
          selectedItems: Array.isArray(n) ? n : [],
          items: e?.allowedValues.map(({ id: s, name: l, value: d }) => ({
            id: s,
            name: l || d
          }))
        }
      ) : /* @__PURE__ */ xe.jsx(
        Hl,
        {
          onChange: r,
          selectedTags: Array.isArray(n) ? n : []
        }
      );
    case "number":
      return /* @__PURE__ */ xe.jsx(ur, { type: "number", onChange: r, value: n });
    case "option":
      return /* @__PURE__ */ xe.jsx(
        Rr,
        {
          onSelect: r,
          selectedItems: Array.isArray(n) ? n : [],
          items: e?.allowedValues?.map(
            ({ id: s, name: l, value: d }) => ({
              id: s,
              name: l || d
            })
          ) || []
        }
      );
    case "string":
      return /* @__PURE__ */ xe.jsx(ur, { onChange: r, value: n || "" });
    case "textarea":
      return /* @__PURE__ */ xe.jsx(Gh, { onChange: r, value: n || "" });
    case "user":
      return /* @__PURE__ */ xe.jsx(
        OP,
        {
          githubOrganization: i,
          onChange: r,
          selectedItems: Array.isArray(n) ? n : [],
          multiple: a
        }
      );
    default:
      return /* @__PURE__ */ xe.jsx(xe.Fragment, { children: "Your organizations GitHub configuration is currently not fully supported by Dixa. Please reach out so we can have a look at this field." });
  }
}, AP = ({
  issueTypeFields: e,
  control: n,
  githubOrganization: r,
  conversationContext: i,
  errors: a
}) => /* @__PURE__ */ xe.jsx(xe.Fragment, { children: e.filter(({ key: o }) => o !== "repository").map((o) => /* @__PURE__ */ xe.jsx(
  jt,
  {
    control: n,
    render: ({ field: { onChange: s, value: l } }) => /* @__PURE__ */ xe.jsx(
      qe,
      {
        meta: {
          error: a && o.key in a ? a[o.key].message : null
        },
        label: o.name,
        required: o.required,
        children: PP({
          field: o,
          value: l,
          onChange: s,
          githubOrganization: r
        })
      },
      o.key
    ),
    name: o.key,
    rules: {
      required: o.required ? "This field is required" : !1
    }
  },
  o.key
)) }), LP = ({
  createdIssue: e,
  issueBaseLink: n,
  issueLinkCopied: r,
  setIssueLinkCopied: i,
  copyToClipboard: a
}) => {
  const o = `${n}/${e.repository.name}/issues/${e.number}`;
  return /* @__PURE__ */ xe.jsxs(
    b,
    {
      flexDirection: "column",
      gap: "400",
      "data-testid": "github-create-issue-success-message",
      children: [
        /* @__PURE__ */ xe.jsxs(F.Paragraph, { children: [
          "You can visit your new issue by following",
          " ",
          /* @__PURE__ */ xe.jsxs(F.ExternalLink, { href: o, target: "_blank", children: [
            "this link ",
            /* @__PURE__ */ xe.jsx(fe, { name: "external-link" })
          ] }),
          " ",
          "or copy it from the field below."
        ] }),
        /* @__PURE__ */ xe.jsx(qe, { label: "GitHub issue link", children: /* @__PURE__ */ xe.jsx(
          ur,
          {
            readOnly: !0,
            value: o,
            suffix: {
              type: "button",
              button: {
                icon: r ? "done" : "copy",
                onClick: () => {
                  i(!0), a(o);
                }
              }
            }
          }
        ) })
      ]
    }
  );
}, VP = "_modalBody_1hk1o_1", zP = "_modalBodyFormFields_1hk1o_4", ym = {
  modalBody: VP,
  modalBodyFormFields: zP
}, UP = Oa(
  /* GraphQL */
  `
  query getGithubRepositoriesByName($query: String!, $maxResults: Int!) {
    GitHub {
      search(query: $query, type: REPOSITORY, first: $maxResults) {
        repositoryCount
        edges {
          node {
            ... on GitHub_Repository {
              id
              name
            }
          }
        }
      }
    }
  }
`
), MP = Oa(
  /* GraphQL */
  `
  mutation createGithubIssue($input: GitHub_CreateIssueInput!) {
    GitHub {
      createIssue(input: $input) {
        issue {
          id
          number
          repository {
            name
          }
        }
      }
    }
  }
`
), BP = [
  {
    key: "title",
    name: "Title",
    type: "string",
    required: !0
  },
  {
    key: "assignees",
    name: "Assignees",
    type: "user",
    required: !1,
    multiple: !0
  },
  {
    key: "body",
    name: "Description",
    type: "textarea",
    required: !1
  }
], qP = ({
  isOpen: e,
  onClose: n,
  linkGithubIssueQuietly: r,
  conversationContext: i,
  githubOrganization: a
}) => {
  const { showNotification: o, useLazyQuery: s, useMutation: l } = fn(), { track: d } = jn(), {
    control: m,
    handleSubmit: u,
    formState: { errors: f },
    reset: h,
    getValues: v
  } = ot(), [w, N] = me(""), [j, _] = me([]), [g, O] = me(), [R, $] = me(!1), [I, L] = me(!1), [G, Q] = JC(), [
    ne,
    {
      loading: q,
      error: Y,
      networkStatus: P
    }
  ] = s(UP, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onCompleted: (Oe) => {
      _(
        Oe.GitHub.search?.edges?.map((H) => H?.node)
      );
    },
    onError: () => {
      o({
        title: "Could not get repository list",
        text: "We could not fetch the list of your repositories. Please try again later.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      }), _([]);
    }
  });
  xi(
    () => {
      !q && w && P === ir.ready ? ne({
        variables: {
          query: w,
          maxResults: 10
        }
      }) : _([]);
    },
    500,
    [w]
  );
  const [B, { error: ie }] = l(
    MP,
    {
      onError: (Oe) => {
        $(!1), o({
          title: "Creation was not successful",
          text: "Please try again later or contact your admin.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), console.warn("Error in createMutation", Oe);
      },
      onCompleted: (Oe) => {
        $(!1);
        const H = Oe.GitHub.createIssue?.issue;
        O(H), o({
          title: "Success",
          text: `GitHub issue '${H.number}' created`,
          icon: "check-circle-filled",
          severity: "success"
        }), r({
          owner: a,
          repository: H.repository.name,
          number: H.number
        });
      }
    }
  ), je = (Oe) => {
    N(`org:${a} ${Oe}`);
  }, pe = (Oe, H) => {
    H(Oe), N("");
  }, le = () => {
    N("");
  }, ge = (Oe) => {
    d("github:create:issue:confirmed", {
      githubOrganization: a
    }), $(!0), B({
      variables: {
        input: {
          repositoryId: Oe.repository.id,
          title: Oe.title,
          body: Oe.body,
          assigneeIds: Oe.assignees?.length > 0 ? Oe.assignees.map((H) => H.id) : void 0
        }
      }
    });
  };
  Xe(() => {
    const Oe = I ? window.setTimeout(() => L(!1), 2e3) : void 0;
    return () => window.clearTimeout(Oe);
  }, [I]);
  const V = () => {
    N(""), _([]), O(void 0), $(!1), L(!1);
  }, be = () => {
    d("github:create:issue:canceled", {
      githubOrganization: a
    }), V(), h(), n();
  };
  return /* @__PURE__ */ xe.jsxs(
    ht,
    {
      isOpen: e,
      "data-testid": "github-create-issue-modal",
      onClose: be,
      children: [
        /* @__PURE__ */ xe.jsx(
          yt,
          {
            title: g ? "Issue creation successful" : "Create new GitHub issue",
            onClose: be
          }
        ),
        /* @__PURE__ */ xe.jsxs(gt, { className: ym.modalBody, children: [
          !q && Y && /* @__PURE__ */ xe.jsx($n, { error: Y }),
          !R && ie && /* @__PURE__ */ xe.jsx($n, { error: ie }),
          g ? /* @__PURE__ */ xe.jsx(
            LP,
            {
              createdIssue: g,
              issueBaseLink: `https://github.com/${a}`,
              issueLinkCopied: I,
              setIssueLinkCopied: L,
              copyToClipboard: Q
            }
          ) : /* @__PURE__ */ xe.jsx(
            "form",
            {
              "data-testid": "github-create-issue-form",
              onSubmit: u(ge),
              children: /* @__PURE__ */ xe.jsxs(et, { children: [
                /* @__PURE__ */ xe.jsx(Z, { children: /* @__PURE__ */ xe.jsx(qe, { label: "Repository", required: !0, children: /* @__PURE__ */ xe.jsx(
                  jt,
                  {
                    control: m,
                    name: "repository",
                    rules: { required: "Please select a repository" },
                    render: ({ field: { onChange: Oe, value: H } }) => /* @__PURE__ */ xe.jsx(
                      Rr,
                      {
                        className: ym.modalBodyRepository,
                        searchable: !0,
                        clearable: !0,
                        loading: q,
                        onSearch: je,
                        onSelect: (Ye) => pe(Ye, Oe),
                        onClear: le,
                        selectedItems: [H],
                        placeholder: "Search GitHub repositories",
                        emptyMessage: Y ? "No repositories found" : "No repositories available",
                        items: j || [],
                        itemComponent: ({ item: Ye, onSelect: ln, checked: Ie }) => /* @__PURE__ */ xe.jsx(
                          ZC,
                          {
                            item: Ye,
                            checked: Ie,
                            onSelectItem: ln
                          }
                        )
                      }
                    )
                  }
                ) }) }),
                /* @__PURE__ */ xe.jsx(Z, { className: ym.modalBodyFormFields, children: /* @__PURE__ */ xe.jsx(
                  AP,
                  {
                    control: m,
                    errors: f,
                    getValues: v,
                    githubOrganization: a,
                    conversationContext: i,
                    issueTypeFields: BP
                  }
                ) })
              ] })
            }
          )
        ] }),
        /* @__PURE__ */ xe.jsx(
          vt,
          {
            confirmOnClick: g ? be : u(ge),
            confirmProps: {
              isLoading: R,
              loadingIndicator: /* @__PURE__ */ xe.jsx(sn, { size: 16 })
            },
            confirmName: g ? "Close" : "Save",
            cancelOnClick: g ? void 0 : be
          }
        )
      ]
    }
  );
}, HP = "_wrapper_19v8w_1", WP = "_inputWrapper_19v8w_6", KP = "_buttonLink_19v8w_19", GP = "_noItemsFound_19v8w_23", YP = "_createIssueButton_19v8w_28", ta = {
  wrapper: HP,
  inputWrapper: WP,
  buttonLink: KP,
  noItemsFound: GP,
  createIssueButton: YP
}, JP = ({
  conversationContext: e,
  settings: n
}) => {
  const [r, i] = me(!1), { track: a } = jn(), o = n?.githubOrganization, s = !!n?.enableRemoveAllLinks, {
    linkGithubItem: l,
    linkGithubItemQuietly: d,
    unlinkGithubItem: m,
    loadGithubItems: u,
    removeDanglingGithubItemLinks: f,
    unlinkAllGithubItems: h,
    isLoadingGithubItemLinks: v,
    danglingIssueLinks: w,
    danglingPullRequestLinks: N,
    isLoadingGithubItems: j,
    issues: _,
    pullRequests: g,
    error: O
  } = eP({
    conversationId: e?.conversationId || null,
    githubOrganization: o
  }), R = (Q) => d({ key: Q, type: "ISSUE" }), $ = !(!!_?.length).valueOf() && !(!!g?.length).valueOf() && !(!!w?.length).valueOf() && !(!!N?.length).valueOf(), I = !v && !j && !!w?.length && !!N?.length && !!n?.showDanglingLinks, L = n?.enableCreateIssue, G = !!_?.length || !!g?.length;
  return !j && O ? /* @__PURE__ */ xe.jsx($n, { error: O, retry: () => u() }) : /* @__PURE__ */ xe.jsxs(xe.Fragment, { children: [
    /* @__PURE__ */ xe.jsxs(b, { className: ta.wrapper, flexDirection: "column", children: [
      /* @__PURE__ */ xe.jsxs(b, { className: ta.inputWrapper, flexDirection: "column", children: [
        L && /* @__PURE__ */ xe.jsxs(xe.Fragment, { children: [
          /* @__PURE__ */ xe.jsx(
            Qn,
            {
              variant: "primary",
              onClick: () => {
                a("github:create:issue:clicked", {
                  githubOrganization: n?.githubOrganization
                }), i(!0);
              },
              className: ta.createIssueButton,
              children: "Create new issue"
            }
          ),
          /* @__PURE__ */ xe.jsx("div", { className: ta.inputSeparator, children: "or" })
        ] }),
        /* @__PURE__ */ xe.jsx(
          FP,
          {
            onSelectItem: l,
            githubOrganization: o,
            linkedIssues: _,
            linkedPullRequests: g
          }
        )
      ] }),
      j ? /* @__PURE__ */ xe.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ xe.jsx(sn, { "data-testid": "github-widget-item-spinner" }) }) : G ? /* @__PURE__ */ xe.jsx(
        yP,
        {
          items: [..._, ...g],
          unlinkGithubItem: m,
          githubOrganization: o
        }
      ) : /* @__PURE__ */ xe.jsx(F.Paragraph, { align: "center", className: ta.noItemsFound, children: "No linked items found." }),
      I && /* @__PURE__ */ xe.jsxs(
        b,
        {
          background: "neutral.100",
          padding: "300",
          borderRadius: "100",
          flexDirection: "column",
          gap: "200",
          children: [
            /* @__PURE__ */ xe.jsx(F.Heading, { variant: "heading-3", children: "Unresolved linked issues and/or pull requests" }),
            /* @__PURE__ */ xe.jsxs(b, { flexDirection: "row", flexWrap: "wrap", gap: "100", children: [
              w.map((Q) => /* @__PURE__ */ xe.jsx(
                Jn,
                {
                  onDelete: () => m({
                    key: Q,
                    type: "ISSUE"
                  }),
                  children: _r(Q)
                },
                _r(Q)
              )),
              N.map((Q) => /* @__PURE__ */ xe.jsx(
                Jn,
                {
                  onDelete: () => m({ key: Q, type: "PR" }),
                  children: _r(Q)
                },
                _r(Q)
              ))
            ] }),
            /* @__PURE__ */ xe.jsx(
              Qn,
              {
                variant: "secondary",
                onClick: () => f(),
                icon: "link-slash",
                children: "Remove all"
              }
            )
          ]
        }
      ),
      s && G && /* @__PURE__ */ xe.jsx(
        Qn,
        {
          variant: "secondary",
          disabled: $,
          onClick: h,
          children: "Remove all links"
        }
      ),
      /* @__PURE__ */ xe.jsx(
        Et,
        {
          slotEnd: /* @__PURE__ */ xe.jsx(fe, { name: "external-link" }),
          variant: "tertiary",
          className: ta.buttonLink,
          navigate: () => {
            window.open(`https://github.com/${o}`, "_blank")?.focus();
          },
          children: "Open GitHub"
        }
      )
    ] }),
    /* @__PURE__ */ xe.jsx(
      qP,
      {
        isOpen: r,
        onClose: () => i(!1),
        linkGithubIssueQuietly: R,
        conversationContext: e,
        githubOrganization: o
      }
    )
  ] });
}, xl = [
  {
    key: "githubOrganization",
    label: "GitHub organization or user",
    type: "string",
    secret: !1,
    defaultValue: ""
  },
  {
    key: "enableRemoveAllLinks",
    label: 'Enable the "Remove all links" button',
    type: "boolean",
    secret: !1,
    defaultValue: !1
  },
  {
    key: "showDanglingLinks",
    label: "Show unresolved links to GitHub items",
    type: "boolean",
    secret: !1,
    defaultValue: !1
  },
  {
    key: "enableCreateIssue",
    label: 'Enable the "Create issue" button',
    type: "boolean",
    secret: !1,
    defaultValue: !0
  }
], bs = ar(xl), wi = "GITHUB", QP = {
  enabled: !1,
  name: "",
  githubOrganization: "",
  enableRemoveAllLinks: !1,
  showDanglingLinks: !1,
  enableCreateIssue: !0
}, XP = ({
  integrationId: e,
  configuration: n,
  handleRedirect: r,
  showNotification: i,
  automationCouplingState: a,
  renderConditionsEditor: o
}) => {
  const s = !e, l = ot({
    mode: "onChange",
    defaultValues: QP
  }), {
    create: d,
    update: m,
    remove: u,
    isLoading: f,
    error: h,
    misconfigurationCause: v,
    setMisconfigurationCause: w
  } = pr({
    integrationId: e,
    integrationType: wi,
    handleRedirect: r,
    showNotification: i
  }), {
    isLoading: N,
    error: j,
    isWidgetUnknown: _,
    refetch: g,
    widgetConfiguration: O
  } = fr({
    integrationId: e,
    fieldDefinitions: xl,
    form: l,
    onMisconfigured: w
  }), { renderConditions: R, setRenderConditions: $, renderConditionsForSubmit: I } = hr({
    integrationId: e,
    widgetConfiguration: O,
    renderConditionsEditor: o
  }), L = (Q) => gr(Q, {
    fieldDefinitions: xl,
    isCreationMode: s,
    create: d,
    update: m,
    renderConditions: I
  }), G = l.watch("name");
  return /* @__PURE__ */ xe.jsxs(
    yr,
    {
      form: l,
      integrationId: e,
      onValidSubmit: L,
      error: j ?? h,
      onRetry: j ? g : void 0,
      isLoading: f || N,
      isWidgetUnknown: _,
      children: [
        v && /* @__PURE__ */ xe.jsx(vr, { cause: v }),
        /* @__PURE__ */ xe.jsxs(et, { children: [
          /* @__PURE__ */ xe.jsx(Z, { children: /* @__PURE__ */ xe.jsx(qe, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ xe.jsx(
            yn,
            {
              name: "enabled",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ xe.jsx(Z, { span: 3, children: /* @__PURE__ */ xe.jsx(
            Rn,
            {
              name: "name",
              label: "Widget name",
              control: l.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ xe.jsx(Z, { span: 3 }),
          /* @__PURE__ */ xe.jsx(Z, { span: 3, children: /* @__PURE__ */ xe.jsx(
            Rn,
            {
              name: "githubOrganization",
              label: bs.githubOrganization,
              control: l.control,
              rules: { required: "GitHub organization or user is required" },
              componentProps: {
                placeholder: "Insert your GitHub organization or user name, e.g. dixahq",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ xe.jsx(Z, { span: 3 }),
          /* @__PURE__ */ xe.jsx(Z, { span: 3, children: /* @__PURE__ */ xe.jsx(qe, { label: bs.enableRemoveAllLinks, children: /* @__PURE__ */ xe.jsx(
            yn,
            {
              name: "enableRemoveAllLinks",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ xe.jsx(Z, { span: 3 }),
          /* @__PURE__ */ xe.jsx(Z, { span: 3, children: /* @__PURE__ */ xe.jsx(qe, { label: bs.showDanglingLinks, children: /* @__PURE__ */ xe.jsx(
            yn,
            {
              name: "showDanglingLinks",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ xe.jsx(Z, { span: 3 }),
          /* @__PURE__ */ xe.jsx(Z, { span: 3, children: /* @__PURE__ */ xe.jsx(qe, { label: bs.enableCreateIssue, children: /* @__PURE__ */ xe.jsx(
            yn,
            {
              name: "enableCreateIssue",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ xe.jsx(Z, { span: 3 }),
          !s && e && /* @__PURE__ */ xe.jsx(
            bi,
            {
              configuration: n,
              integrationId: e,
              integrationType: wi,
              label: "Authorize with OAuth"
            }
          ),
          o && R !== null && /* @__PURE__ */ xe.jsx(Z, { children: o({
            value: R,
            onChange: $,
            configurationKey: O?.id
          }) })
        ] }),
        /* @__PURE__ */ xe.jsx(
          kr,
          {
            integrationType: wi,
            integrationId: e,
            widgetName: G,
            isCreationMode: s,
            isSubmitting: l.formState.isSubmitting,
            automationCouplingState: a,
            onConfirmDelete: () => u(),
            confirmDeleteVariant: "danger",
            deleteConfirmationBody: /* @__PURE__ */ xe.jsxs(b, { gap: "400", children: [
              /* @__PURE__ */ xe.jsx(
                fe,
                {
                  size: 24,
                  name: "exclamation-triangle-filled",
                  color: "red.500"
                }
              ),
              /* @__PURE__ */ xe.jsxs(b, { gap: "200", flexDirection: "column", children: [
                /* @__PURE__ */ xe.jsxs(F.Heading, { withMarginBottom: !0, children: [
                  "By deleting the ",
                  wi,
                  " integration, all links between Dixa and ",
                  wi,
                  " are also deleted."
                ] }),
                /* @__PURE__ */ xe.jsxs(F.Paragraph, { children: [
                  "All data in ",
                  wi,
                  " stays untouched."
                ] }),
                /* @__PURE__ */ xe.jsxs(F.Paragraph, { children: [
                  "Are you sure you want to delete the ",
                  wi,
                  " ",
                  'integration "',
                  G,
                  '"?'
                ] })
              ] })
            ] })
          }
        )
      ]
    }
  );
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._list_16pij_1{padding:0}._listItem_16pij_4{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_16pij_4:last-child{border-bottom:none}._listItemEdit_16pij_11{cursor:pointer}._clickableIcon_16pij_15{cursor:pointer;color:var(--dixa-typography-color-secondary)}._boxWrapper_89s7l_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300)}._boxWrapper_89s7l_1:hover{border-color:var(--dixa-color-neutral-300)}._trackButton_89s7l_10{color:var(--dixa-typography-color-link)}._order_135ze_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._order_135ze_1:hover,._orderIsOpen_135ze_9{border-color:var(--dixa-color-neutral-400)}._orderHeader_135ze_12{cursor:pointer}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var gm = { exports: {} }, Xa = {}, Y_;
function ZP() {
  if (Y_) return Xa;
  Y_ = 1;
  var e = He, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (v = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return Xa.Fragment = r, Xa.jsx = s, Xa.jsxs = s, Xa;
}
var _s = {}, J_;
function eA() {
  return J_ || (J_ = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = He, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), d = /* @__PURE__ */ Symbol.for("react.forward_ref"), m = /* @__PURE__ */ Symbol.for("react.suspense"), u = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), v = /* @__PURE__ */ Symbol.for("react.offscreen"), w = Symbol.iterator, N = "@@iterator";
    function j(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = w && t[w] || t[N];
      return typeof c == "function" ? c : null;
    }
    var _ = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          p[y - 1] = arguments[y];
        O("error", t, p);
      }
    }
    function O(t, c, p) {
      {
        var y = _.ReactDebugCurrentFrame, C = y.getStackAddendum();
        C !== "" && (c += "%s", p = p.concat([C]));
        var T = p.map(function(S) {
          return String(S);
        });
        T.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, T);
      }
    }
    var R = !1, $ = !1, I = !1, L = !1, G = !1, Q;
    Q = /* @__PURE__ */ Symbol.for("react.module.reference");
    function ne(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || G || t === a || t === m || t === u || L || t === v || R || $ || I || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Q || t.getModuleId !== void 0));
    }
    function q(t, c, p) {
      var y = t.displayName;
      if (y)
        return y;
      var C = c.displayName || c.name || "";
      return C !== "" ? p + "(" + C + ")" : p;
    }
    function Y(t) {
      return t.displayName || "Context";
    }
    function P(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return Y(c) + ".Consumer";
          case s:
            var p = t;
            return Y(p._context) + ".Provider";
          case d:
            return q(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : P(t.type) || "Memo";
          case h: {
            var C = t, T = C._payload, S = C._init;
            try {
              return P(S(T));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var B = Object.assign, ie = 0, je, pe, le, ge, V, be, Oe;
    function H() {
    }
    H.__reactDisabledLog = !0;
    function Ye() {
      {
        if (ie === 0) {
          je = console.log, pe = console.info, le = console.warn, ge = console.error, V = console.group, be = console.groupCollapsed, Oe = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: H,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ie++;
      }
    }
    function ln() {
      {
        if (ie--, ie === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: B({}, t, {
              value: je
            }),
            info: B({}, t, {
              value: pe
            }),
            warn: B({}, t, {
              value: le
            }),
            error: B({}, t, {
              value: ge
            }),
            group: B({}, t, {
              value: V
            }),
            groupCollapsed: B({}, t, {
              value: be
            }),
            groupEnd: B({}, t, {
              value: Oe
            })
          });
        }
        ie < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Ie = _.ReactCurrentDispatcher, Ue;
    function De(t, c, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (C) {
            var y = C.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Be = !1, Ae;
    {
      var Qe = typeof WeakMap == "function" ? WeakMap : Map;
      Ae = new Qe();
    }
    function Ee(t, c) {
      if (!t || Be)
        return "";
      {
        var p = Ae.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Be = !0;
      var C = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var T;
      T = Ie.current, Ie.current = null, Ye();
      try {
        if (c) {
          var S = function() {
            throw Error();
          };
          if (Object.defineProperty(S.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(S, []);
            } catch (re) {
              y = re;
            }
            Reflect.construct(t, [], S);
          } else {
            try {
              S.call();
            } catch (re) {
              y = re;
            }
            t.call(S.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (re) {
            y = re;
          }
          t();
        }
      } catch (re) {
        if (re && y && typeof re.stack == "string") {
          for (var x = re.stack.split(`
`), ee = y.stack.split(`
`), A = x.length - 1, M = ee.length - 1; A >= 1 && M >= 0 && x[A] !== ee[M]; )
            M--;
          for (; A >= 1 && M >= 0; A--, M--)
            if (x[A] !== ee[M]) {
              if (A !== 1 || M !== 1)
                do
                  if (A--, M--, M < 0 || x[A] !== ee[M]) {
                    var ue = `
` + x[A].replace(" at new ", " at ");
                    return t.displayName && ue.includes("<anonymous>") && (ue = ue.replace("<anonymous>", t.displayName)), typeof t == "function" && Ae.set(t, ue), ue;
                  }
                while (A >= 1 && M >= 0);
              break;
            }
        }
      } finally {
        Be = !1, Ie.current = T, ln(), Error.prepareStackTrace = C;
      }
      var ze = t ? t.displayName || t.name : "", Te = ze ? De(ze) : "";
      return typeof t == "function" && Ae.set(t, Te), Te;
    }
    function Me(t, c, p) {
      return Ee(t, !1);
    }
    function en(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function se(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ee(t, en(t));
      if (typeof t == "string")
        return De(t);
      switch (t) {
        case m:
          return De("Suspense");
        case u:
          return De("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Me(t.render);
          case f:
            return se(t.type, c, p);
          case h: {
            var y = t, C = y._payload, T = y._init;
            try {
              return se(T(C), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var ce = Object.prototype.hasOwnProperty, Se = {}, Ve = _.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, p = se(t.type, t._source, c ? c.type : null);
        Ve.setExtraStackFrame(p);
      } else
        Ve.setExtraStackFrame(null);
    }
    function kn(t, c, p, y, C) {
      {
        var T = Function.call.bind(ce);
        for (var S in t)
          if (T(t, S)) {
            var x = void 0;
            try {
              if (typeof t[S] != "function") {
                var ee = Error((y || "React class") + ": " + p + " type `" + S + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[S] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ee.name = "Invariant Violation", ee;
              }
              x = t[S](c, S, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (A) {
              x = A;
            }
            x && !(x instanceof Error) && (Pe(C), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, S, typeof x), Pe(null)), x instanceof Error && !(x.message in Se) && (Se[x.message] = !0, Pe(C), g("Failed %s type: %s", p, x.message), Pe(null));
          }
      }
    }
    var X = Array.isArray;
    function E(t) {
      return X(t);
    }
    function z(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function ae(t) {
      try {
        return de(t), !1;
      } catch {
        return !0;
      }
    }
    function de(t) {
      return "" + t;
    }
    function U(t) {
      if (ae(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", z(t)), de(t);
    }
    var J = _.ReactCurrentOwner, ve = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, we, Re;
    function rn(t) {
      if (ce.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function bn(t) {
      if (ce.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function an(t, c) {
      typeof t.ref == "string" && J.current;
    }
    function hn(t, c) {
      {
        var p = function() {
          we || (we = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function En(t, c) {
      {
        var p = function() {
          Re || (Re = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var _n = function(t, c, p, y, C, T, S) {
      var x = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: S,
        // Record the component responsible for creating this element.
        _owner: T
      };
      return x._store = {}, Object.defineProperty(x._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(x, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(x, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: C
      }), Object.freeze && (Object.freeze(x.props), Object.freeze(x)), x;
    };
    function Fn(t, c, p, y, C) {
      {
        var T, S = {}, x = null, ee = null;
        p !== void 0 && (U(p), x = "" + p), bn(c) && (U(c.key), x = "" + c.key), rn(c) && (ee = c.ref, an(c));
        for (T in c)
          ce.call(c, T) && !ve.hasOwnProperty(T) && (S[T] = c[T]);
        if (t && t.defaultProps) {
          var A = t.defaultProps;
          for (T in A)
            S[T] === void 0 && (S[T] = A[T]);
        }
        if (x || ee) {
          var M = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          x && hn(S, M), ee && En(S, M);
        }
        return _n(t, x, ee, C, y, J.current, S);
      }
    }
    var Ze = _.ReactCurrentOwner, gn = _.ReactDebugCurrentFrame;
    function Le(t) {
      if (t) {
        var c = t._owner, p = se(t.type, t._source, c ? c.type : null);
        gn.setExtraStackFrame(p);
      } else
        gn.setExtraStackFrame(null);
    }
    var dn;
    dn = !1;
    function un(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function Nn() {
      {
        if (Ze.current) {
          var t = P(Ze.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Bn(t) {
      return "";
    }
    var Sn = {};
    function An(t) {
      {
        var c = Nn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function vn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = An(c);
        if (Sn[p])
          return;
        Sn[p] = !0;
        var y = "";
        t && t._owner && t._owner !== Ze.current && (y = " It was passed a child from " + P(t._owner.type) + "."), Le(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Le(null);
      }
    }
    function xn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (E(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            un(y) && vn(y, c);
          }
        else if (un(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var C = j(t);
          if (typeof C == "function" && C !== t.entries)
            for (var T = C.call(t), S; !(S = T.next()).done; )
              un(S.value) && vn(S.value, c);
        }
      }
    }
    function Ln(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var y = P(c);
          kn(p, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !dn) {
          dn = !0;
          var C = P(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", C || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var y = c[p];
          if (y !== "children" && y !== "key") {
            Le(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Le(null);
            break;
          }
        }
        t.ref !== null && (Le(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Le(null));
      }
    }
    var Cn = {};
    function wn(t, c, p, y, C, T) {
      {
        var S = ne(t);
        if (!S) {
          var x = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (x += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ee = Bn();
          ee ? x += ee : x += Nn();
          var A;
          t === null ? A = "null" : E(t) ? A = "array" : t !== void 0 && t.$$typeof === n ? (A = "<" + (P(t.type) || "Unknown") + " />", x = " Did you accidentally export a JSX literal instead of a component?") : A = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", A, x);
        }
        var M = Fn(t, c, p, C, T);
        if (M == null)
          return M;
        if (S) {
          var ue = c.children;
          if (ue !== void 0)
            if (y)
              if (E(ue)) {
                for (var ze = 0; ze < ue.length; ze++)
                  xn(ue[ze], t);
                Object.freeze && Object.freeze(ue);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              xn(ue, t);
        }
        if (ce.call(c, "key")) {
          var Te = P(t), re = Object.keys(c).filter(function(Gn) {
            return Gn !== "key";
          }), mn = re.length > 0 ? "{key: someKey, " + re.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Cn[Te + mn]) {
            var Dn = re.length > 0 ? "{" + re.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, mn, Te, Dn, Te), Cn[Te + mn] = !0;
          }
        }
        return t === i ? Vn(M) : Ln(M), M;
      }
    }
    function zn(t, c, p) {
      return wn(t, c, p, !0);
    }
    function qn(t, c, p) {
      return wn(t, c, p, !1);
    }
    var Un = qn, Kn = zn;
    _s.Fragment = i, _s.jsx = Un, _s.jsxs = Kn;
  })()), _s;
}
var Q_;
function nA() {
  return Q_ || (Q_ = 1, process.env.NODE_ENV === "production" ? gm.exports = ZP() : gm.exports = eA()), gm.exports;
}
var Ce = nA(), Fo = /* @__PURE__ */ ((e) => (e.Outbound = "OUTBOUND", e.Return = "RETURN", e.UnknownDirectionType = "UNKNOWN_DIRECTION_TYPE", e.Unspecified = "UNSPECIFIED", e))(Fo || {}), Oi = /* @__PURE__ */ ((e) => (e.Delivery = "DELIVERY", e.Instore = "INSTORE", e.Inwarehouse = "INWAREHOUSE", e.Mailbox = "MAILBOX", e.Pickup = "PICKUP", e.Unknown = "UNKNOWN", e))(Oi || {}), er = /* @__PURE__ */ ((e) => (e.StepAwaitingSupplier = "STEP_AWAITING_SUPPLIER", e.StepConfirmedByMerchant = "STEP_CONFIRMED_BY_MERCHANT", e.StepDeliveredToConsumer = "STEP_DELIVERED_TO_CONSUMER", e.StepDeliveredToMerchant = "STEP_DELIVERED_TO_MERCHANT", e.StepDeliveredToPickupPoint = "STEP_DELIVERED_TO_PICKUP_POINT", e.StepLinehaulToCarrier = "STEP_LINEHAUL_TO_CARRIER", e.StepOnRoute = "STEP_ON_ROUTE", e.StepPreparedByMerchant = "STEP_PREPARED_BY_MERCHANT", e.StepReturnRequested = "STEP_RETURN_REQUESTED", e.StepSentBack = "STEP_SENT_BACK", e.StepSubmittedToCarrier = "STEP_SUBMITTED_TO_CARRIER", e.StepTerminated = "STEP_TERMINATED", e.StepUnknown = "STEP_UNKNOWN", e))(er || {});
const tA = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getOrders" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "locale" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Ingrid" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "DeliveryTracking_GetTrackingOrders" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "email" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }, { kind: "Argument", name: { kind: "Name", value: "locale" }, value: { kind: "Variable", name: { kind: "Name", value: "locale" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Ingrid_GetTrackingOrdersResponse" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orders" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "analytics_id" } }, { kind: "Field", name: { kind: "Name", value: "external_id" } }, { kind: "Field", name: { kind: "Name", value: "preselected_parcel_index" } }, { kind: "Field", name: { kind: "Name", value: "sender_name" } }, { kind: "Field", name: { kind: "Name", value: "site_name" } }, { kind: "Field", name: { kind: "Name", value: "tos_id" } }, { kind: "Field", name: { kind: "Name", value: "tracking_links" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "links" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "url" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discount" } }, { kind: "Field", name: { kind: "Name", value: "image" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "sku" } }, { kind: "Field", name: { kind: "Name", value: "total_price" } }] } }, { kind: "Field", name: { kind: "Name", value: "cart" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "currency" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "attributes" } }, { kind: "Field", name: { kind: "Name", value: "cancelled_quantity" } }, { kind: "Field", name: { kind: "Name", value: "cancelled_total_price" } }, { kind: "Field", name: { kind: "Name", value: "discount" } }, { kind: "Field", name: { kind: "Name", value: "image" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "sku" } }, { kind: "Field", name: { kind: "Name", value: "total_price" } }, { kind: "Field", name: { kind: "Name", value: "variant" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "size" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "prices" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shipping_components" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discount" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }] } }, { kind: "Field", name: { kind: "Name", value: "total" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discount" } }, { kind: "Field", name: { kind: "Name", value: "items_discount" } }, { kind: "Field", name: { kind: "Name", value: "items_price" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "shipping_discount" } }, { kind: "Field", name: { kind: "Name", value: "shipping_price" } }, { kind: "Field", name: { kind: "Name", value: "tax" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "parcels" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "alerts" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "awaiting_supplier" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "estimated_time" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "earliest" } }, { kind: "Field", name: { kind: "Name", value: "latest" } }] } }, { kind: "Field", name: { kind: "Name", value: "estimated_time_range" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "end" } }, { kind: "Field", name: { kind: "Name", value: "start" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "delivery_attempt_failed" } }, { kind: "Field", name: { kind: "Name", value: "delivery_delayed" } }, { kind: "Field", name: { kind: "Name", value: "delivery_delayed_from_carrier" } }, { kind: "Field", name: { kind: "Name", value: "estimated_delivery_time_updated" } }, { kind: "Field", name: { kind: "Name", value: "linehaul" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "estimated_time" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "earliest" } }, { kind: "Field", name: { kind: "Name", value: "latest" } }] } }, { kind: "Field", name: { kind: "Name", value: "estimated_time_range" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "end" } }, { kind: "Field", name: { kind: "Name", value: "start" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "out_for_delivery" } }, { kind: "Field", name: { kind: "Name", value: "submission_delayed" } }] } }, { kind: "Field", name: { kind: "Name", value: "carrier" } }, { kind: "Field", name: { kind: "Name", value: "carrier_fallback_enabled" } }, { kind: "Field", name: { kind: "Name", value: "carrier_link" } }, { kind: "Field", name: { kind: "Name", value: "carrier_logo_pattern" } }, { kind: "Field", name: { kind: "Name", value: "carrier_product_id" } }, { kind: "Field", name: { kind: "Name", value: "carrier_product_ref" } }, { kind: "Field", name: { kind: "Name", value: "delivery_type" } }, { kind: "Field", name: { kind: "Name", value: "direction_type" } }, { kind: "Field", name: { kind: "Name", value: "display_carrier_name" } }, { kind: "Field", name: { kind: "Name", value: "estimated_delivery_time" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "end" } }, { kind: "Field", name: { kind: "Name", value: "start" } }] } }, { kind: "Field", name: { kind: "Name", value: "exceptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "status" } }] } }, { kind: "Field", name: { kind: "Name", value: "index" } }, { kind: "Field", name: { kind: "Name", value: "line_items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "currency" } }, { kind: "Field", name: { kind: "Name", value: "discount" } }, { kind: "Field", name: { kind: "Name", value: "image" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "properties" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "sku" } }, { kind: "Field", name: { kind: "Name", value: "total_price" } }] } }, { kind: "Field", name: { kind: "Name", value: "location" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "address" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "address_lines" } }, { kind: "Field", name: { kind: "Name", value: "apartment_number" } }, { kind: "Field", name: { kind: "Name", value: "attn" } }, { kind: "Field", name: { kind: "Name", value: "building_name" } }, { kind: "Field", name: { kind: "Name", value: "care_of" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "coordinates" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "lat" } }, { kind: "Field", name: { kind: "Name", value: "lng" } }] } }, { kind: "Field", name: { kind: "Name", value: "country" } }, { kind: "Field", name: { kind: "Name", value: "door_code" } }, { kind: "Field", name: { kind: "Name", value: "floor_number" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "po_box_id" } }, { kind: "Field", name: { kind: "Name", value: "postal_code" } }, { kind: "Field", name: { kind: "Name", value: "region" } }, { kind: "Field", name: { kind: "Name", value: "street" } }, { kind: "Field", name: { kind: "Name", value: "street_number" } }, { kind: "Field", name: { kind: "Name", value: "subregion" } }] } }, { kind: "Field", name: { kind: "Name", value: "location_external_id" } }, { kind: "Field", name: { kind: "Name", value: "location_type" } }, { kind: "Field", name: { kind: "Name", value: "operational_hours" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "free_text" } }, { kind: "Field", name: { kind: "Name", value: "fri" } }, { kind: "Field", name: { kind: "Name", value: "mon" } }, { kind: "Field", name: { kind: "Name", value: "sat" } }, { kind: "Field", name: { kind: "Name", value: "sun" } }, { kind: "Field", name: { kind: "Name", value: "thu" } }, { kind: "Field", name: { kind: "Name", value: "tue" } }, { kind: "Field", name: { kind: "Name", value: "wed" } }] } }, { kind: "Field", name: { kind: "Name", value: "pickup_instructions" } }] } }, { kind: "Field", name: { kind: "Name", value: "progress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "estimated_time" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "end" } }, { kind: "Field", name: { kind: "Name", value: "start" } }] } }, { kind: "Field", name: { kind: "Name", value: "step" } }, { kind: "Field", name: { kind: "Name", value: "time" } }] } }, { kind: "Field", name: { kind: "Name", value: "requested_shipping_method" } }, { kind: "Field", name: { kind: "Name", value: "sender_name" } }, { kind: "Field", name: { kind: "Name", value: "tracking_link" } }, { kind: "Field", name: { kind: "Name", value: "tracking_number" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Ingrid_Error" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "details" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, rA = {
  "\n  query getOrders($email: String!, $locale: String!) {\n    Ingrid {\n      DeliveryTracking_GetTrackingOrders(\n        email: $email\n        locale: $locale\n      ) {\n        ... on Ingrid_GetTrackingOrdersResponse {\n          orders {\n            analytics_id\n            external_id\n            preselected_parcel_index\n            sender_name\n            site_name\n            tos_id\n            tracking_links {\n              links {\n                type\n                url\n              }\n            }\n            items {\n              discount\n              image\n              name\n              price\n              quantity\n              sku\n              total_price\n            }\n            cart {\n              currency\n              items {\n                attributes\n                cancelled_quantity\n                cancelled_total_price\n                discount\n                image\n                name\n                price\n                quantity\n                sku\n                total_price\n                variant {\n                  color\n                  size\n                }\n              }\n              prices {\n                shipping_components {\n                  discount\n                  name\n                  price\n                }\n                total {\n                  discount\n                  items_discount\n                  items_price\n                  price\n                  shipping_discount\n                  shipping_price\n                  tax\n                }\n              }\n            }\n            parcels {\n              alerts {\n                created_at\n                type\n                awaiting_supplier {\n                  estimated_time {\n                    earliest\n                    latest\n                  }\n                  estimated_time_range {\n                    end\n                    start\n                  }\n                }\n                delivery_attempt_failed\n                delivery_delayed\n                delivery_delayed_from_carrier\n                estimated_delivery_time_updated\n                linehaul {\n                  estimated_time {\n                    earliest\n                    latest\n                  }\n                  estimated_time_range {\n                    end\n                    start\n                  }\n                }\n                out_for_delivery\n                submission_delayed\n              }\n              carrier\n              carrier_fallback_enabled\n              carrier_link\n              carrier_logo_pattern\n              carrier_product_id\n              carrier_product_ref\n              delivery_type\n              direction_type\n              display_carrier_name\n              estimated_delivery_time {\n                end\n                start\n              }\n              exceptions {\n                created_at\n                status\n              }\n              index\n              line_items {\n                currency\n                discount\n                image\n                name\n                price\n                properties\n                quantity\n                sku\n                total_price\n              }\n              location {\n                address {\n                  address_lines\n                  apartment_number\n                  attn\n                  building_name\n                  care_of\n                  city\n                  coordinates {\n                    lat\n                    lng\n                  }\n                  country\n                  door_code\n                  floor_number\n                  name\n                  po_box_id\n                  postal_code\n                  region\n                  street\n                  street_number\n                  subregion\n                }\n                location_external_id\n                location_type\n                operational_hours {\n                  free_text\n                  fri\n                  mon\n                  sat\n                  sun\n                  thu\n                  tue\n                  wed\n                }\n                pickup_instructions\n              }\n              progress {\n                estimated_time {\n                  end\n                  start\n                }\n                step\n                time\n              }\n              requested_shipping_method\n              sender_name\n              tracking_link\n              tracking_number\n            }\n          }\n        }\n\n        ... on Ingrid_Error {\n          code\n          details\n          message\n        }\n      }\n    }\n  }\n": tA
};
function iA(e) {
  return rA[e] ?? {};
}
const aA = iA(
  /* GraphQL */
  `
  query getOrders($email: String!, $locale: String!) {
    Ingrid {
      DeliveryTracking_GetTrackingOrders(
        email: $email
        locale: $locale
      ) {
        ... on Ingrid_GetTrackingOrdersResponse {
          orders {
            analytics_id
            external_id
            preselected_parcel_index
            sender_name
            site_name
            tos_id
            tracking_links {
              links {
                type
                url
              }
            }
            items {
              discount
              image
              name
              price
              quantity
              sku
              total_price
            }
            cart {
              currency
              items {
                attributes
                cancelled_quantity
                cancelled_total_price
                discount
                image
                name
                price
                quantity
                sku
                total_price
                variant {
                  color
                  size
                }
              }
              prices {
                shipping_components {
                  discount
                  name
                  price
                }
                total {
                  discount
                  items_discount
                  items_price
                  price
                  shipping_discount
                  shipping_price
                  tax
                }
              }
            }
            parcels {
              alerts {
                created_at
                type
                awaiting_supplier {
                  estimated_time {
                    earliest
                    latest
                  }
                  estimated_time_range {
                    end
                    start
                  }
                }
                delivery_attempt_failed
                delivery_delayed
                delivery_delayed_from_carrier
                estimated_delivery_time_updated
                linehaul {
                  estimated_time {
                    earliest
                    latest
                  }
                  estimated_time_range {
                    end
                    start
                  }
                }
                out_for_delivery
                submission_delayed
              }
              carrier
              carrier_fallback_enabled
              carrier_link
              carrier_logo_pattern
              carrier_product_id
              carrier_product_ref
              delivery_type
              direction_type
              display_carrier_name
              estimated_delivery_time {
                end
                start
              }
              exceptions {
                created_at
                status
              }
              index
              line_items {
                currency
                discount
                image
                name
                price
                properties
                quantity
                sku
                total_price
              }
              location {
                address {
                  address_lines
                  apartment_number
                  attn
                  building_name
                  care_of
                  city
                  coordinates {
                    lat
                    lng
                  }
                  country
                  door_code
                  floor_number
                  name
                  po_box_id
                  postal_code
                  region
                  street
                  street_number
                  subregion
                }
                location_external_id
                location_type
                operational_hours {
                  free_text
                  fri
                  mon
                  sat
                  sun
                  thu
                  tue
                  wed
                }
                pickup_instructions
              }
              progress {
                estimated_time {
                  end
                  start
                }
                step
                time
              }
              requested_shipping_method
              sender_name
              tracking_link
              tracking_number
            }
          }
        }

        ... on Ingrid_Error {
          code
          details
          message
        }
      }
    }
  }
`
), X_ = (e) => {
  if (!e) return "";
  try {
    return new Intl.DateTimeFormat(void 0, {
      dateStyle: "medium",
      timeStyle: "short"
    }).format(new Date(e));
  } catch {
    return e;
  }
}, e1 = (e, n) => {
  try {
    return new Intl.NumberFormat(void 0, {
      style: "currency",
      currency: n
    }).format(e);
  } catch {
    return e.toString();
  }
}, oA = "_listItem_16pij_4", sA = "_clickableIcon_16pij_15", Ho = {
  listItem: oA,
  clickableIcon: sA
}, n1 = ({
  items: e,
  title: n,
  currency: r,
  openByDefault: i = !1
}) => {
  const [a, o] = me(i);
  return !e || e.length === 0 ? null : /* @__PURE__ */ Ce.jsx(b, { gap: "100", flexDirection: "column", children: /* @__PURE__ */ Ce.jsxs(b, { gap: "250", flexDirection: "column", children: [
    /* @__PURE__ */ Ce.jsxs(b, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ Ce.jsx(fe, { size: 14, name: "list-ul", color: "blue.900" }),
      /* @__PURE__ */ Ce.jsx(b, { gap: "200", flexDirection: "column", children: /* @__PURE__ */ Ce.jsxs(
        b,
        {
          gap: "100",
          flexDirection: "row",
          onClick: () => o(!a),
          className: Ho.clickableIcon,
          alignItems: "center",
          children: [
            /* @__PURE__ */ Ce.jsx(F.Paragraph, { variant: "3", children: n }),
            /* @__PURE__ */ Ce.jsx(
              fe,
              {
                size: 14,
                name: a ? "angle-down" : "angle-right"
              }
            )
          ]
        }
      ) })
    ] }),
    a && /* @__PURE__ */ Ce.jsx(Je, { children: e.map((l, d) => {
      if (!l) return null;
      const { name: m, quantity: u, price: f, image: h, sku: v } = l, w = l.currency ?? r;
      return /* @__PURE__ */ Ce.jsx(
        Je.Item,
        {
          contentLeft: /* @__PURE__ */ Ce.jsxs(b, { gap: "200", children: [
            /* @__PURE__ */ Ce.jsx(F.Paragraph, { children: u }),
            /* @__PURE__ */ Ce.jsx(F.Paragraph, { children: "×" })
          ] }),
          title: /* @__PURE__ */ Ce.jsxs(b, { flexDirection: "column", gap: "050", children: [
            /* @__PURE__ */ Ce.jsx(F.Paragraph, { variant: "4", children: m }),
            f != null && /* @__PURE__ */ Ce.jsx(F.Paragraph, { variant: "4", color: "tertiary", children: e1(f / 100, w) })
          ] }),
          contentRight: h && /* @__PURE__ */ Ce.jsx(Ia, { src: h, alt: m ?? "Product image" }),
          className: Ho.listItem
        },
        `item-${d}-${v}`
      );
    }) })
  ] }) });
}, lA = "_boxWrapper_89s7l_1", cA = "_trackButton_89s7l_10", Z_ = {
  boxWrapper: lA,
  trackButton: cA
}, dA = {
  [er.StepUnknown]: "Unknown",
  [er.StepConfirmedByMerchant]: "Confirmed by merchant",
  [er.StepPreparedByMerchant]: "Prepared by merchant",
  [er.StepSubmittedToCarrier]: "Submitted to carrier",
  [er.StepLinehaulToCarrier]: "Linehaul to carrier",
  [er.StepOnRoute]: "On route",
  [er.StepDeliveredToPickupPoint]: "At pickup point",
  [er.StepDeliveredToConsumer]: "Delivered to customer",
  [er.StepDeliveredToMerchant]: "Returned to merchant",
  [er.StepReturnRequested]: "Return requested",
  [er.StepSentBack]: "Sent back",
  [er.StepTerminated]: "Terminated",
  [er.StepAwaitingSupplier]: "Awaiting supplier"
}, uA = {
  [Oi.Delivery]: "Home delivery",
  [Oi.Pickup]: "Pickup point",
  [Oi.Instore]: "In-store pickup",
  [Oi.Mailbox]: "Mailbox",
  [Oi.Inwarehouse]: "Warehouse",
  [Oi.Unknown]: "Unknown"
}, mA = {
  [Fo.Outbound]: "From merchant to customer",
  [Fo.Return]: "Return from customer to merchant",
  [Fo.Unspecified]: "Unspecified",
  [Fo.UnknownDirectionType]: "Unknown"
}, pA = (e) => e ? dA[e] ?? e : "", fA = (e) => e ? uA[e] ?? e : "", hA = (e) => e ? mA[e] ?? e : "", yA = (e) => {
  if (!e) return null;
  const n = [e.street, e.street_number].filter(Boolean).join(" ");
  return [
    e.name,
    n,
    e.postal_code,
    e.city,
    e.country
  ].filter(Boolean).join(`
`);
}, gA = ({
  parcel: e
}) => {
  const { isCopied: n, copy: r } = Qt();
  if (!e)
    return null;
  const {
    carrier: i,
    progress: a,
    tracking_number: o,
    line_items: s,
    carrier_product_ref: l,
    carrier_link: d,
    display_carrier_name: m,
    delivery_type: u,
    direction_type: f,
    estimated_delivery_time: h
  } = e, v = m || l || i, w = a?.filter((R) => R?.time !== ""), N = pA(w?.[0]?.step), j = fA(u), _ = hA(f), g = yA(e.location?.address), O = 14;
  return /* @__PURE__ */ Ce.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      padding: "250",
      className: Z_.boxWrapper,
      children: [
        /* @__PURE__ */ Ce.jsx(F.Heading, { variant: "heading-4", children: v }),
        /* @__PURE__ */ Ce.jsxs(b, { justifyContent: "space-between", children: [
          /* @__PURE__ */ Ce.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ Ce.jsx(
              fe,
              {
                size: O,
                name: "magnifying-glass-chart",
                color: "blue.900"
              }
            ),
            /* @__PURE__ */ Ce.jsxs(b, { gap: "100", flexDirection: "column", children: [
              /* @__PURE__ */ Ce.jsx(F.Paragraph, { variant: "3", children: "Carrier tracking ID" }),
              /* @__PURE__ */ Ce.jsxs(b, { gap: "100", flexDirection: "row", flexWrap: "wrap", children: [
                !o && /* @__PURE__ */ Ce.jsx(F.Paragraph, { variant: "4", color: "tertiary", children: "No tracking ID here yet" }),
                o && /* @__PURE__ */ Ce.jsx(F.Paragraph, { variant: "4", color: "secondary", children: o })
              ] })
            ] })
          ] }),
          o && /* @__PURE__ */ Ce.jsx(b, { flexDirection: "row", children: /* @__PURE__ */ Ce.jsx(Ge, { content: "Copy tracking ID", children: /* @__PURE__ */ Ce.jsx(
            fe,
            {
              size: O,
              name: n ? "done" : "copy",
              className: Ho.clickableIcon,
              onClick: () => r(o)
            }
          ) }) })
        ] }),
        N && /* @__PURE__ */ Ce.jsxs(b, { gap: "250", flexDirection: "row", children: [
          /* @__PURE__ */ Ce.jsx(fe, { size: O, name: "chart-donut", color: "blue.900" }),
          /* @__PURE__ */ Ce.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ Ce.jsx(F.Paragraph, { variant: "3", children: "Status" }),
            /* @__PURE__ */ Ce.jsx(F.Paragraph, { variant: "4", color: "secondary", children: N })
          ] })
        ] }),
        _ && /* @__PURE__ */ Ce.jsxs(b, { gap: "250", flexDirection: "row", children: [
          /* @__PURE__ */ Ce.jsx(fe, { size: O, name: "arrow-right", color: "blue.900" }),
          /* @__PURE__ */ Ce.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ Ce.jsx(F.Paragraph, { variant: "3", children: "Direction" }),
            /* @__PURE__ */ Ce.jsx(F.Paragraph, { variant: "4", color: "secondary", children: _ })
          ] })
        ] }),
        h && /* @__PURE__ */ Ce.jsxs(b, { gap: "250", flexDirection: "row", children: [
          /* @__PURE__ */ Ce.jsx(fe, { size: O, name: "calendar", color: "blue.900" }),
          /* @__PURE__ */ Ce.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ Ce.jsx(F.Paragraph, { variant: "3", children: "Estimated delivery" }),
            /* @__PURE__ */ Ce.jsxs(F.Paragraph, { variant: "4", color: "secondary", children: [
              X_(h.start),
              " ",
              h.end && " until"
            ] }),
            h.end && /* @__PURE__ */ Ce.jsx(F.Paragraph, { variant: "4", color: "secondary", children: X_(h.end) })
          ] })
        ] }),
        u && /* @__PURE__ */ Ce.jsxs(b, { gap: "250", flexDirection: "row", children: [
          /* @__PURE__ */ Ce.jsx(fe, { size: O, name: "info", color: "blue.900" }),
          /* @__PURE__ */ Ce.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ Ce.jsx(F.Paragraph, { variant: "3", children: "Delivery type" }),
            /* @__PURE__ */ Ce.jsx(F.Paragraph, { variant: "4", color: "secondary", children: j })
          ] })
        ] }),
        g && /* @__PURE__ */ Ce.jsxs(b, { gap: "250", flexDirection: "row", children: [
          /* @__PURE__ */ Ce.jsx(fe, { size: O, name: "map-pin", color: "blue.900" }),
          /* @__PURE__ */ Ce.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ Ce.jsx(F.Paragraph, { variant: "3", children: "Pickup location" }),
            /* @__PURE__ */ Ce.jsx(F.Paragraph, { variant: "4", color: "secondary", children: g })
          ] })
        ] }),
        /* @__PURE__ */ Ce.jsx(n1, { title: "Parcel items", items: s }),
        d && /* @__PURE__ */ Ce.jsxs(
          Et,
          {
            variant: "secondary",
            className: Z_.trackButton,
            navigate: () => window.open(d, "_blank")?.focus(),
            slotStart: /* @__PURE__ */ Ce.jsx(fe, { name: "external-link" }),
            children: [
              "Track on ",
              v ?? "carrier",
              " website"
            ]
          }
        )
      ]
    }
  );
}, vA = "_order_135ze_1", kA = "_orderIsOpen_135ze_9", bA = "_orderHeader_135ze_12", vm = {
  order: vA,
  orderIsOpen: kA,
  orderHeader: bA
}, ex = "No order number found", _A = ({
  order: e,
  openByDefault: n
}) => {
  const [r, i] = me(n), { isCopied: a, copy: o } = Qt(), { isCopied: s, copy: l } = Qt();
  if (!e)
    return null;
  const { cart: d, parcels: m, sender_name: u, tos_id: f } = e, h = e.external_id?.trim(), v = d?.currency || "", w = d?.prices?.total?.price ?? 0, N = e1(w / 100, v), j = 14, _ = u && u.trim() !== "" ? u : "unknown sender";
  return /* @__PURE__ */ Ce.jsxs(
    b,
    {
      className: ut(vm.order, {
        [vm.orderIsOpen]: r
      }),
      gap: "300",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ Ce.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: vm.orderHeader,
            onClick: () => i(!r),
            children: [
              /* @__PURE__ */ Ce.jsxs(b, { gap: "100", flexDirection: "column", children: [
                /* @__PURE__ */ Ce.jsxs(F.Paragraph, { variant: "4", children: [
                  "From ",
                  _
                ] }),
                h ? /* @__PURE__ */ Ce.jsx(F.Paragraph, { variant: "3", children: /* @__PURE__ */ Ce.jsxs("span", { children: [
                  "#",
                  h
                ] }) }) : /* @__PURE__ */ Ce.jsx(F.Paragraph, { variant: "4", color: "tertiary", children: ex })
              ] }),
              /* @__PURE__ */ Ce.jsx(
                Xt,
                {
                  variant: "tertiary",
                  icon: r ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        r && /* @__PURE__ */ Ce.jsxs(b, { gap: "250", flexDirection: "column", margin: "200 0 0", children: [
          /* @__PURE__ */ Ce.jsxs(b, { justifyContent: "space-between", children: [
            /* @__PURE__ */ Ce.jsxs(b, { gap: "250", flexDirection: "row", children: [
              /* @__PURE__ */ Ce.jsx(fe, { size: j, name: "tag", color: "blue.900" }),
              /* @__PURE__ */ Ce.jsxs(b, { gap: "100", flexDirection: "column", children: [
                /* @__PURE__ */ Ce.jsx(F.Paragraph, { variant: "3", children: "Order number" }),
                /* @__PURE__ */ Ce.jsx(b, { gap: "100", flexDirection: "row", flexWrap: "wrap", children: h ? /* @__PURE__ */ Ce.jsx(F.Paragraph, { variant: "4", color: "secondary", children: h }) : /* @__PURE__ */ Ce.jsx(F.Paragraph, { variant: "4", color: "tertiary", children: ex }) })
              ] })
            ] }),
            h && /* @__PURE__ */ Ce.jsx(b, { flexDirection: "row", children: /* @__PURE__ */ Ce.jsx(Ge, { content: "Copy order number", children: /* @__PURE__ */ Ce.jsx(
              fe,
              {
                size: j,
                name: s ? "done" : "copy",
                className: Ho.clickableIcon,
                onClick: () => l(h)
              }
            ) }) })
          ] }),
          /* @__PURE__ */ Ce.jsxs(b, { justifyContent: "space-between", children: [
            /* @__PURE__ */ Ce.jsxs(b, { gap: "250", flexDirection: "row", children: [
              /* @__PURE__ */ Ce.jsx(
                fe,
                {
                  size: j,
                  name: "magnifying-glass-chart",
                  color: "blue.900"
                }
              ),
              /* @__PURE__ */ Ce.jsxs(b, { gap: "100", flexDirection: "column", children: [
                /* @__PURE__ */ Ce.jsx(F.Paragraph, { variant: "3", children: "Ingrid tracking ID" }),
                /* @__PURE__ */ Ce.jsxs(b, { gap: "100", flexDirection: "row", flexWrap: "wrap", children: [
                  !f && /* @__PURE__ */ Ce.jsx(F.Paragraph, { variant: "4", color: "tertiary", children: "No tracking ID here yet" }),
                  f && /* @__PURE__ */ Ce.jsx(F.Paragraph, { variant: "4", color: "secondary", children: f })
                ] })
              ] })
            ] }),
            f && /* @__PURE__ */ Ce.jsx(b, { flexDirection: "row", children: /* @__PURE__ */ Ce.jsx(Ge, { content: "Copy tracking ID", children: /* @__PURE__ */ Ce.jsx(
              fe,
              {
                size: j,
                name: a ? "done" : "copy",
                className: Ho.clickableIcon,
                onClick: () => o(f)
              }
            ) }) })
          ] }),
          u && /* @__PURE__ */ Ce.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ Ce.jsx(fe, { size: 14, name: "user", color: "blue.900" }),
            /* @__PURE__ */ Ce.jsxs(b, { gap: "100", flexDirection: "column", children: [
              /* @__PURE__ */ Ce.jsx(F.Paragraph, { variant: "3", children: "Sender" }),
              /* @__PURE__ */ Ce.jsx(F.Paragraph, { variant: "4", children: u })
            ] })
          ] }),
          /* @__PURE__ */ Ce.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ Ce.jsx(fe, { size: 14, name: "chart-bar", color: "blue.900" }),
            /* @__PURE__ */ Ce.jsxs(b, { gap: "100", flexDirection: "column", children: [
              /* @__PURE__ */ Ce.jsx(F.Paragraph, { variant: "3", children: "Order value" }),
              /* @__PURE__ */ Ce.jsx(F.Paragraph, { variant: "4", children: N })
            ] })
          ] }),
          /* @__PURE__ */ Ce.jsx(
            n1,
            {
              openByDefault: !0,
              title: "Order items",
              items: d?.items?.map((g) => g),
              currency: d?.currency
            }
          ),
          m && /* @__PURE__ */ Ce.jsxs(b, { gap: "200", flexDirection: "column", margin: "0 0 100 0", children: [
            /* @__PURE__ */ Ce.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
              /* @__PURE__ */ Ce.jsx(F.Heading, { variant: "heading-4", children: "Parcels" }),
              m.length > 0 && /* @__PURE__ */ Ce.jsx(Pn, { variant: "success", size: "small", children: m.length })
            ] }),
            m.length === 0 && /* @__PURE__ */ Ce.jsx(F.Paragraph, { variant: "4", color: "secondary", children: "No parcels here" }),
            m.map((g, O) => /* @__PURE__ */ Ce.jsx(
              gA,
              {
                parcel: g
              },
              `parcel-${O}-${g?.tracking_number}`
            ))
          ] })
        ] })
      ]
    }
  );
}, xA = (e) => {
  const n = [], r = /* @__PURE__ */ new Map();
  for (const i of e) {
    if (!i?.external_id) {
      n.push(i);
      continue;
    }
    const a = r.get(i.external_id);
    if (a)
      a.parcels = [
        ...a.parcels ?? [],
        ...i.parcels ?? []
      ];
    else {
      const o = { ...i };
      r.set(i.external_id, o), n.push(o);
    }
  }
  return n;
}, nx = (e) => {
  let n = 1 / 0;
  for (const r of e?.parcels ?? [])
    for (const i of r?.progress ?? []) {
      if (!i?.time)
        continue;
      const a = new Date(i.time).getTime();
      !Number.isNaN(a) && a < n && (n = a);
    }
  return n === 1 / 0 ? -1 / 0 : n;
}, SA = (e) => [...e].sort(
  (n, r) => nx(r) - nx(n)
), NA = ({
  customerEmail: e
}) => {
  const { useQuery: n } = fn(), [r, i] = me([]), a = !e, { data: o, loading: s, error: l } = n(aA, {
    skip: a,
    variables: {
      email: e,
      locale: "en-GB"
    }
  }), d = !s && r.length > 0, m = l ? gI({
    error: l.graphQLErrors?.[0]
  }) : !1, u = l ? xw({
    error: l.graphQLErrors?.[0]
  }) : !1;
  return Xe(() => {
    const f = o?.Ingrid?.DeliveryTracking_GetTrackingOrders;
    f?.orders && i(
      SA(
        xA(f.orders)
      )
    );
  }, [o?.Ingrid?.DeliveryTracking_GetTrackingOrders]), s ? /* @__PURE__ */ Ce.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ Ce.jsx(sn, {}) }) : m || !d && !l ? /* @__PURE__ */ Ce.jsx(F.Paragraph, { color: "tertiary", align: "center", children: "No orders to track" }) : u ? /* @__PURE__ */ Ce.jsx(F.Paragraph, { color: "tertiary", align: "center", children: "The API token used for the integration does not have the necessary access rights. Please contact your administrator." }) : l ? /* @__PURE__ */ Ce.jsx($n, { error: l }) : /* @__PURE__ */ Ce.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ Ce.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ Ce.jsx(F.Heading, { variant: "heading-3", children: "Orders" }),
      /* @__PURE__ */ Ce.jsx(Pn, { variant: "success", size: "small", children: r.length })
    ] }),
    /* @__PURE__ */ Ce.jsx(b, { gap: "200", flexDirection: "column", children: /* @__PURE__ */ Ce.jsx(b, { gap: "200", flexDirection: "column", children: r.map((f, h) => /* @__PURE__ */ Ce.jsx(
      _A,
      {
        order: f,
        openByDefault: h === 0
      },
      `${h}-${f?.tos_id}`
    )) }) })
  ] });
}, jA = ({ conversationContext: e }) => {
  const n = e?.customer?.email;
  return /* @__PURE__ */ Ce.jsx(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300",
      "data-testid": "widget-wrapper",
      children: /* @__PURE__ */ Ce.jsx(NA, { customerEmail: n })
    }
  );
}, Sl = [
  {
    key: "ingridUseStagingEnvironment",
    label: "Use Ingrid staging environment",
    type: "boolean",
    secret: !1,
    defaultValue: !1
  },
  {
    key: "ingridSiteId",
    label: "Site ID",
    type: "string",
    secret: !1,
    defaultValue: ""
  },
  {
    key: "ingridApiToken",
    label: "API token",
    type: "string",
    secret: !0,
    defaultValue: ""
  }
], km = ar(Sl), wA = {
  enabled: !1,
  name: "",
  ingridSiteId: "",
  ingridApiToken: "",
  ingridUseStagingEnvironment: !1
}, CA = ({
  integrationId: e,
  handleRedirect: n,
  showNotification: r,
  automationCouplingState: i,
  renderConditionsEditor: a
}) => {
  const o = !e, s = ot({
    mode: "onChange",
    defaultValues: wA
  }), {
    create: l,
    update: d,
    remove: m,
    isLoading: u,
    error: f,
    misconfigurationCause: h,
    setMisconfigurationCause: v
  } = pr({
    integrationId: e,
    integrationType: "INGRID",
    handleRedirect: n,
    showNotification: r
  }), {
    isLoading: w,
    error: N,
    isWidgetUnknown: j,
    refetch: _,
    widgetConfiguration: g
  } = fr({
    integrationId: e,
    fieldDefinitions: Sl,
    form: s,
    onMisconfigured: v
  }), { renderConditions: O, setRenderConditions: R, renderConditionsForSubmit: $ } = hr({
    integrationId: e,
    widgetConfiguration: g,
    renderConditionsEditor: a
  }), I = (G) => gr(G, {
    fieldDefinitions: Sl,
    isCreationMode: o,
    create: l,
    update: d,
    renderConditions: $
  }), L = s.watch("name");
  return /* @__PURE__ */ Ce.jsxs(
    yr,
    {
      form: s,
      integrationId: e,
      onValidSubmit: I,
      error: N ?? f,
      onRetry: N ? _ : void 0,
      isLoading: u || w,
      isWidgetUnknown: j,
      children: [
        h && /* @__PURE__ */ Ce.jsx(vr, { cause: h }),
        /* @__PURE__ */ Ce.jsxs(et, { children: [
          /* @__PURE__ */ Ce.jsx(Z, { children: /* @__PURE__ */ Ce.jsx(qe, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ Ce.jsx(
            yn,
            {
              name: "enabled",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ Ce.jsx(Z, { span: 3, children: /* @__PURE__ */ Ce.jsx(
            Rn,
            {
              name: "name",
              label: "Widget name",
              control: s.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ Ce.jsx(Z, { span: 3 }),
          /* @__PURE__ */ Ce.jsx(Z, { span: 3, children: /* @__PURE__ */ Ce.jsx(qe, { label: km.ingridUseStagingEnvironment, children: /* @__PURE__ */ Ce.jsx(
            yn,
            {
              name: "ingridUseStagingEnvironment",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ Ce.jsx(Z, { span: 3 }),
          /* @__PURE__ */ Ce.jsx(Z, { span: 3, children: /* @__PURE__ */ Ce.jsx(
            Rn,
            {
              name: "ingridSiteId",
              label: km.ingridSiteId,
              control: s.control,
              rules: { required: "Site ID is required" },
              componentProps: {
                placeholder: "Site ID from Ingrid",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ Ce.jsx(Z, { span: 3 }),
          /* @__PURE__ */ Ce.jsx(Z, { span: 3, children: /* @__PURE__ */ Ce.jsx(
            Er,
            {
              name: "ingridApiToken",
              label: km.ingridApiToken,
              control: s.control,
              isCreationMode: o,
              rules: { required: "API token is required" },
              componentProps: {
                placeholder: "API token from Ingrid",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ Ce.jsx(Z, { span: 3 }),
          a && O !== null && /* @__PURE__ */ Ce.jsx(Z, { children: a({
            value: O,
            onChange: R,
            configurationKey: g?.id
          }) })
        ] }),
        /* @__PURE__ */ Ce.jsx(
          kr,
          {
            integrationType: "INGRID",
            integrationId: e,
            widgetName: L,
            isCreationMode: o,
            isSubmitting: s.formState.isSubmitting,
            automationCouplingState: i,
            onConfirmDelete: () => m()
          }
        )
      ]
    }
  );
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode('@charset "UTF-8";._jiraCode_h30p6_1{padding:2px 4px;font-size:100%;font-family:var(--dixa-typography-family-code);color:var(--dixa-typography-color-primary);border-radius:4px}._jiraCodeInline_h30p6_8{background-color:var(--dixa-color-neutral-200)}._collapse_m2gjh_1{border:1px solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);padding:0}._collapseHeader_m2gjh_10>div{padding:var(--dixa-size-spacer-300) 0!important}._collapseHeader_m2gjh_10>div>div>p{white-space:unset!important}._collapseHeader_m2gjh_10>div:first-child{width:100%}._collapseHeader_m2gjh_10>div:first-child div:first-child{width:100%}._collapseHeader_m2gjh_10>div:first-child div:first-child p{width:calc(100% - 20px)}._collapseHeader_m2gjh_10{background-color:transparent!important;padding:0 var(--dixa-size-spacer-300) 0 0;letter-spacing:-.08px;color:var(--dixa-color-neutral-500)}._collapseHeaderLink_m2gjh_31{font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-link);text-decoration:none}._collapseHeaderLink_m2gjh_31:hover{text-decoration:underline}._collapseHeaderStatus_m2gjh_40{font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-color-neutral-500);float:right}._collapseHeaderIcon_m2gjh_46{padding-top:.35em;transform:scale(1.4);margin-left:var(--dixa-size-spacer-100)}._collapseHeaderTitle_m2gjh_51{font-weight:var(--dixa-typography-weight-semibold);font-size:var(--dixa-typography-size-300);line-height:var(--dixa-typography-line-height-300);letter-spacing:-.16px;color:var(--dixa-typography-color-primary);width:100%}._collapseContent_m2gjh_59{padding:var(--dixa-size-spacer-200) var(--dixa-size-spacer-300)!important}._collapseContentHeadline_m2gjh_62{font-weight:var(--dixa-typography-weight-semibold);font-size:var(--dixa-typography-size-100);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-tertiary)}._collapseContentButtonSpacer_m2gjh_68{margin-top:var(--dixa-size-spacer-250)}._collapseContentButtonLink_m2gjh_71{color:var(--dixa-typography-color-link)}._collapseContentStatusTag_m2gjh_74{max-width:10em}._collapseContentDescription_m2gjh_77{max-height:75vh;overflow-y:auto}._result_1wiub_54{padding:0 var(--dixa-size-spacer-200);margin:0;outline:0;border:0;color:var(--dixa-typography-color-primary);background-color:var(--dixa-color-neutral-000);box-sizing:border-box;display:flex;align-items:center;position:relative;font-size:12px;line-height:32px;height:48px;width:100%;cursor:pointer}._result_1wiub_54:hover,._result_1wiub_54:focus{background-color:var(--dixa-color-neutral-100)}._resultName_1wiub_74{width:100%;text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-weight:var(--dixa-typography-weight-semibold)}._resultNameIcon_1wiub_82{height:var(--dixa-typography-line-height-200);padding-right:var(--dixa-size-spacer-100);margin-top:-2px}._resultDescription_1wiub_87{width:100%;text-align:left;font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-secondary);white-space:nowrap;overflow:hidden;text-overflow:ellipsis;margin-top:-.5em;margin-bottom:.5em}._resultLinkIcon_1wiub_99{position:absolute;right:5px;background-color:var(--dixa-color-neutral-000);border:1px solid var(--dixa-color-neutral-300);border-radius:5px;color:var(--dixa-color-neutral-500)}._tooltip_1wiub_108{width:500px;max-height:60vh;overflow:hidden;text-overflow:ellipsis}._tooltipContent_1wiub_114{display:flex;flex-direction:column;width:100%;max-height:60vh;max-height:60dvh}._tooltipName_1wiub_121{text-align:left;white-space:nowrap;font-weight:var(--dixa-typography-weight-semibold)}._tooltipNameIcon_1wiub_126{height:var(--dixa-typography-line-height-300);padding-right:var(--dixa-size-spacer-100);margin-top:-2px}._tooltipDescription_1wiub_131{padding-top:.5em;width:100%;text-align:left;color:var(--dixa-typography-color-secondary);flex-grow:1;overflow-y:auto}._tooltipSummary_1wiub_139{padding-top:.5em;font-weight:var(--dixa-typography-weight-semibold)}._tooltipTag_1wiub_143{width:fit-content;max-width:15em}._itemButton_1hl53_1{border:none;padding:0}._result_1hl53_6{padding:0 var(--dixa-size-spacer-200);margin:0;outline:0;border:0;color:var(--dixa-typography-color-primary);background-color:var(--dixa-color-neutral-000);box-sizing:border-box;display:flex;align-items:center;position:relative;font-size:var(--dixa-typography-size-200);line-height:32px;height:48px;width:100%;cursor:pointer}._result_1hl53_6:hover,._result_1hl53_6:focus{background-color:var(--dixa-color-neutral-100)}._resultIcon_1hl53_26{height:var(--dixa-size-spacer-400);padding-right:var(--dixa-size-spacer-250)}._resultName_1hl53_30{width:100%;text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-weight:var(--dixa-typography-weight-semibold)}._resultCheckIcon_1hl53_38{height:var(--dixa-size-spacer-400)}._modalBody_1hk1o_1{width:600px}._modalBodyFormFields_1hk1o_4{display:grid;gap:var(--dixa-size-spacer-300) var(--dixa-size-spacer-400)}._wrapper_1bylq_1{gap:var(--dixa-size-spacer-250);margin-bottom:var(--dixa-size-spacer-300)}._inputWrapper_1bylq_6{background-color:var(--dixa-color-neutral-100);border-radius:var(--dixa-size-border-radius-100);margin:var(--dixa-size-spacer-300) 0;gap:var(--dixa-size-spacer-250);padding:var(--dixa-size-spacer-300)}._inputField_1bylq_14{text-align:center}._inputSeparator_1bylq_18{color:var(--dixa-color-neutral-600);text-align:center}._buttonLink_1bylq_23{color:var(--dixa-typography-color-link)}._noIssuesFound_1bylq_27{color:var(--dixa-color-neutral-400);font-size:var(--dixa-typography-size-200)}')), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var bm = { exports: {} }, Za = {}, tx;
function FA() {
  if (tx) return Za;
  tx = 1;
  var e = He, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (v = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return Za.Fragment = r, Za.jsx = s, Za.jsxs = s, Za;
}
var xs = {}, rx;
function IA() {
  return rx || (rx = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = He, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), d = /* @__PURE__ */ Symbol.for("react.forward_ref"), m = /* @__PURE__ */ Symbol.for("react.suspense"), u = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), v = /* @__PURE__ */ Symbol.for("react.offscreen"), w = Symbol.iterator, N = "@@iterator";
    function j(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = w && t[w] || t[N];
      return typeof c == "function" ? c : null;
    }
    var _ = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          p[y - 1] = arguments[y];
        O("error", t, p);
      }
    }
    function O(t, c, p) {
      {
        var y = _.ReactDebugCurrentFrame, C = y.getStackAddendum();
        C !== "" && (c += "%s", p = p.concat([C]));
        var T = p.map(function(S) {
          return String(S);
        });
        T.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, T);
      }
    }
    var R = !1, $ = !1, I = !1, L = !1, G = !1, Q;
    Q = /* @__PURE__ */ Symbol.for("react.module.reference");
    function ne(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || G || t === a || t === m || t === u || L || t === v || R || $ || I || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Q || t.getModuleId !== void 0));
    }
    function q(t, c, p) {
      var y = t.displayName;
      if (y)
        return y;
      var C = c.displayName || c.name || "";
      return C !== "" ? p + "(" + C + ")" : p;
    }
    function Y(t) {
      return t.displayName || "Context";
    }
    function P(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return Y(c) + ".Consumer";
          case s:
            var p = t;
            return Y(p._context) + ".Provider";
          case d:
            return q(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : P(t.type) || "Memo";
          case h: {
            var C = t, T = C._payload, S = C._init;
            try {
              return P(S(T));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var B = Object.assign, ie = 0, je, pe, le, ge, V, be, Oe;
    function H() {
    }
    H.__reactDisabledLog = !0;
    function Ye() {
      {
        if (ie === 0) {
          je = console.log, pe = console.info, le = console.warn, ge = console.error, V = console.group, be = console.groupCollapsed, Oe = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: H,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ie++;
      }
    }
    function ln() {
      {
        if (ie--, ie === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: B({}, t, {
              value: je
            }),
            info: B({}, t, {
              value: pe
            }),
            warn: B({}, t, {
              value: le
            }),
            error: B({}, t, {
              value: ge
            }),
            group: B({}, t, {
              value: V
            }),
            groupCollapsed: B({}, t, {
              value: be
            }),
            groupEnd: B({}, t, {
              value: Oe
            })
          });
        }
        ie < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Ie = _.ReactCurrentDispatcher, Ue;
    function De(t, c, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (C) {
            var y = C.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Be = !1, Ae;
    {
      var Qe = typeof WeakMap == "function" ? WeakMap : Map;
      Ae = new Qe();
    }
    function Ee(t, c) {
      if (!t || Be)
        return "";
      {
        var p = Ae.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Be = !0;
      var C = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var T;
      T = Ie.current, Ie.current = null, Ye();
      try {
        if (c) {
          var S = function() {
            throw Error();
          };
          if (Object.defineProperty(S.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(S, []);
            } catch (re) {
              y = re;
            }
            Reflect.construct(t, [], S);
          } else {
            try {
              S.call();
            } catch (re) {
              y = re;
            }
            t.call(S.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (re) {
            y = re;
          }
          t();
        }
      } catch (re) {
        if (re && y && typeof re.stack == "string") {
          for (var x = re.stack.split(`
`), ee = y.stack.split(`
`), A = x.length - 1, M = ee.length - 1; A >= 1 && M >= 0 && x[A] !== ee[M]; )
            M--;
          for (; A >= 1 && M >= 0; A--, M--)
            if (x[A] !== ee[M]) {
              if (A !== 1 || M !== 1)
                do
                  if (A--, M--, M < 0 || x[A] !== ee[M]) {
                    var ue = `
` + x[A].replace(" at new ", " at ");
                    return t.displayName && ue.includes("<anonymous>") && (ue = ue.replace("<anonymous>", t.displayName)), typeof t == "function" && Ae.set(t, ue), ue;
                  }
                while (A >= 1 && M >= 0);
              break;
            }
        }
      } finally {
        Be = !1, Ie.current = T, ln(), Error.prepareStackTrace = C;
      }
      var ze = t ? t.displayName || t.name : "", Te = ze ? De(ze) : "";
      return typeof t == "function" && Ae.set(t, Te), Te;
    }
    function Me(t, c, p) {
      return Ee(t, !1);
    }
    function en(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function se(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ee(t, en(t));
      if (typeof t == "string")
        return De(t);
      switch (t) {
        case m:
          return De("Suspense");
        case u:
          return De("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Me(t.render);
          case f:
            return se(t.type, c, p);
          case h: {
            var y = t, C = y._payload, T = y._init;
            try {
              return se(T(C), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var ce = Object.prototype.hasOwnProperty, Se = {}, Ve = _.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, p = se(t.type, t._source, c ? c.type : null);
        Ve.setExtraStackFrame(p);
      } else
        Ve.setExtraStackFrame(null);
    }
    function kn(t, c, p, y, C) {
      {
        var T = Function.call.bind(ce);
        for (var S in t)
          if (T(t, S)) {
            var x = void 0;
            try {
              if (typeof t[S] != "function") {
                var ee = Error((y || "React class") + ": " + p + " type `" + S + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[S] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ee.name = "Invariant Violation", ee;
              }
              x = t[S](c, S, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (A) {
              x = A;
            }
            x && !(x instanceof Error) && (Pe(C), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, S, typeof x), Pe(null)), x instanceof Error && !(x.message in Se) && (Se[x.message] = !0, Pe(C), g("Failed %s type: %s", p, x.message), Pe(null));
          }
      }
    }
    var X = Array.isArray;
    function E(t) {
      return X(t);
    }
    function z(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function ae(t) {
      try {
        return de(t), !1;
      } catch {
        return !0;
      }
    }
    function de(t) {
      return "" + t;
    }
    function U(t) {
      if (ae(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", z(t)), de(t);
    }
    var J = _.ReactCurrentOwner, ve = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, we, Re;
    function rn(t) {
      if (ce.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function bn(t) {
      if (ce.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function an(t, c) {
      typeof t.ref == "string" && J.current;
    }
    function hn(t, c) {
      {
        var p = function() {
          we || (we = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function En(t, c) {
      {
        var p = function() {
          Re || (Re = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var _n = function(t, c, p, y, C, T, S) {
      var x = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: S,
        // Record the component responsible for creating this element.
        _owner: T
      };
      return x._store = {}, Object.defineProperty(x._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(x, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(x, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: C
      }), Object.freeze && (Object.freeze(x.props), Object.freeze(x)), x;
    };
    function Fn(t, c, p, y, C) {
      {
        var T, S = {}, x = null, ee = null;
        p !== void 0 && (U(p), x = "" + p), bn(c) && (U(c.key), x = "" + c.key), rn(c) && (ee = c.ref, an(c));
        for (T in c)
          ce.call(c, T) && !ve.hasOwnProperty(T) && (S[T] = c[T]);
        if (t && t.defaultProps) {
          var A = t.defaultProps;
          for (T in A)
            S[T] === void 0 && (S[T] = A[T]);
        }
        if (x || ee) {
          var M = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          x && hn(S, M), ee && En(S, M);
        }
        return _n(t, x, ee, C, y, J.current, S);
      }
    }
    var Ze = _.ReactCurrentOwner, gn = _.ReactDebugCurrentFrame;
    function Le(t) {
      if (t) {
        var c = t._owner, p = se(t.type, t._source, c ? c.type : null);
        gn.setExtraStackFrame(p);
      } else
        gn.setExtraStackFrame(null);
    }
    var dn;
    dn = !1;
    function un(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function Nn() {
      {
        if (Ze.current) {
          var t = P(Ze.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Bn(t) {
      return "";
    }
    var Sn = {};
    function An(t) {
      {
        var c = Nn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function vn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = An(c);
        if (Sn[p])
          return;
        Sn[p] = !0;
        var y = "";
        t && t._owner && t._owner !== Ze.current && (y = " It was passed a child from " + P(t._owner.type) + "."), Le(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Le(null);
      }
    }
    function xn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (E(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            un(y) && vn(y, c);
          }
        else if (un(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var C = j(t);
          if (typeof C == "function" && C !== t.entries)
            for (var T = C.call(t), S; !(S = T.next()).done; )
              un(S.value) && vn(S.value, c);
        }
      }
    }
    function Ln(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var y = P(c);
          kn(p, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !dn) {
          dn = !0;
          var C = P(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", C || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var y = c[p];
          if (y !== "children" && y !== "key") {
            Le(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Le(null);
            break;
          }
        }
        t.ref !== null && (Le(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Le(null));
      }
    }
    var Cn = {};
    function wn(t, c, p, y, C, T) {
      {
        var S = ne(t);
        if (!S) {
          var x = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (x += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ee = Bn();
          ee ? x += ee : x += Nn();
          var A;
          t === null ? A = "null" : E(t) ? A = "array" : t !== void 0 && t.$$typeof === n ? (A = "<" + (P(t.type) || "Unknown") + " />", x = " Did you accidentally export a JSX literal instead of a component?") : A = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", A, x);
        }
        var M = Fn(t, c, p, C, T);
        if (M == null)
          return M;
        if (S) {
          var ue = c.children;
          if (ue !== void 0)
            if (y)
              if (E(ue)) {
                for (var ze = 0; ze < ue.length; ze++)
                  xn(ue[ze], t);
                Object.freeze && Object.freeze(ue);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              xn(ue, t);
        }
        if (ce.call(c, "key")) {
          var Te = P(t), re = Object.keys(c).filter(function(Gn) {
            return Gn !== "key";
          }), mn = re.length > 0 ? "{key: someKey, " + re.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Cn[Te + mn]) {
            var Dn = re.length > 0 ? "{" + re.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, mn, Te, Dn, Te), Cn[Te + mn] = !0;
          }
        }
        return t === i ? Vn(M) : Ln(M), M;
      }
    }
    function zn(t, c, p) {
      return wn(t, c, p, !0);
    }
    function qn(t, c, p) {
      return wn(t, c, p, !1);
    }
    var Un = qn, Kn = zn;
    xs.Fragment = i, xs.jsx = Un, xs.jsxs = Kn;
  })()), xs;
}
var ix;
function $A() {
  return ix || (ix = 1, process.env.NODE_ENV === "production" ? bm.exports = FA() : bm.exports = IA()), bm.exports;
}
var he = $A();
const yg = (e, n) => {
  const r = (o) => (e.marks || []).map((s) => ({
    formatterFunction: n.marks[e.type]?.[s.type],
    mark: s
  })).reduce(
    (s, l) => () => l.formatterFunction?.(l.mark, s) || o,
    () => o
  )(), i = (o, s) => () => o.content ? o.content.map((l) => yg(l, s)) : [], a = n.nodes[e.type] || n.default;
  return r(
    a(e, i(e, n))
  );
}, EA = "_jiraCode_h30p6_1", TA = "_jiraCodeInline_h30p6_8", _m = {
  jiraCode: EA,
  jiraCodeInline: TA
}, t1 = {
  default: (e, n) => n().every((r) => typeof r == "string") ? n().join(" ") : /* @__PURE__ */ he.jsx(he.Fragment, { children: n() }),
  nodes: {
    doc: (e, n) => /* @__PURE__ */ he.jsx("div", { children: n() }),
    paragraph: (e, n) => /* @__PURE__ */ he.jsx("p", { children: n() }),
    text: (e) => e.text || "",
    hardBreak: () => /* @__PURE__ */ he.jsx("br", {}),
    bulletList: (e, n) => /* @__PURE__ */ he.jsx("ul", { children: n() }),
    orderedList: (e, n) => /* @__PURE__ */ he.jsx("ol", { children: n() }),
    listItem: (e, n) => /* @__PURE__ */ he.jsx("li", { children: n() }),
    codeBlock: (e, n) => /* @__PURE__ */ he.jsx("pre", { children: /* @__PURE__ */ he.jsx("code", { className: _m.jiraCode, children: n() }) }),
    heading: (e, n) => {
      switch (e.attrs?.level) {
        // Not using headlines above level 3
        case 1:
          return /* @__PURE__ */ he.jsx("h3", { children: n() });
        case 2:
          return /* @__PURE__ */ he.jsx("h4", { children: n() });
        case 3:
          return /* @__PURE__ */ he.jsx("h5", { children: n() });
        case 4:
          return /* @__PURE__ */ he.jsx("h6", { children: n() });
        case 5:
          return /* @__PURE__ */ he.jsx("b", { children: n() });
        case 6:
          return /* @__PURE__ */ he.jsx("b", { children: n() });
        default:
          return /* @__PURE__ */ he.jsx("h4", { children: n() });
      }
    }
  },
  marks: {
    text: {
      em: (e, n) => /* @__PURE__ */ he.jsx("em", { children: n() }),
      strong: (e, n) => /* @__PURE__ */ he.jsx("b", { children: n() }),
      underline: (e, n) => /* @__PURE__ */ he.jsx("u", { children: n() }),
      link: (e, n) => /* @__PURE__ */ he.jsx("a", { href: e.attrs?.href || "", target: "_blank", rel: "noreferrer", children: n() }),
      code: (e, n) => /* @__PURE__ */ he.jsx("code", { className: ut(_m.jiraCode, _m.jiraCodeInline), children: n() })
      // Removing color support for now.
      // textColor: (mark, next) => (
      // 	<span style={{ color: mark.attrs?.['color'] }}>{next()}</span>
      // ),
    }
  }
}, Nl = ({
  iconUrl: e,
  className: n,
  width: r
}) => {
  const [i, a] = me(!1);
  return !e || i ? /* @__PURE__ */ he.jsx(fe, { size: r, name: "question", className: n }) : /* @__PURE__ */ he.jsx(
    "img",
    {
      src: e,
      width: r,
      className: n,
      onError: ({ currentTarget: o }) => {
        o.onerror = null, a(!0);
      }
    }
  );
}, RA = "_collapse_m2gjh_1", DA = "_collapseHeader_m2gjh_10", OA = "_collapseHeaderLink_m2gjh_31", PA = "_collapseHeaderStatus_m2gjh_40", AA = "_collapseHeaderTitle_m2gjh_51", LA = "_collapseContent_m2gjh_59", VA = "_collapseContentHeadline_m2gjh_62", zA = "_collapseContentButtonSpacer_m2gjh_68", UA = "_collapseContentButtonLink_m2gjh_71", MA = "_collapseContentStatusTag_m2gjh_74", BA = "_collapseContentDescription_m2gjh_77", jr = {
  collapse: RA,
  collapseHeader: DA,
  collapseHeaderLink: OA,
  collapseHeaderStatus: PA,
  collapseHeaderTitle: AA,
  collapseContent: LA,
  collapseContentHeadline: VA,
  collapseContentButtonSpacer: zA,
  collapseContentButtonLink: UA,
  collapseContentStatusTag: MA,
  collapseContentDescription: BA
}, r1 = ({
  jiraInstanceUrl: e,
  avatarId: n,
  iconUrl: r
}) => n ? `${e}/rest/api/3/universal_avatar/view/type/issuetype/avatar/${n}?size=medium` : r, qA = ({
  issues: e,
  jiraInstanceUrl: n,
  unlinkIssue: r
}) => {
  const i = e.reduce(
    (d, m) => m?.id ? { ...d, [m.id]: !1 } : d,
    {}
  ), [a, o] = me(i), { track: s } = jn(), l = (d, m) => {
    o({ ...a, [d]: m });
  };
  return /* @__PURE__ */ he.jsx(b, { flexDirection: "column", gap: "250", children: e?.length ? e.map((d) => {
    const { summary: m, description: u, status: f, issuetype: h } = d?.fields || {}, v = r1({
      avatarId: h?.avatarId,
      iconUrl: h?.iconUrl,
      jiraInstanceUrl: n
    }), w = !!(d?.id && a[d.id]);
    return /* @__PURE__ */ he.jsxs(
      Sr,
      {
        onToggle: () => d?.id && l(d.id, !a[d.id]),
        isOpen: w,
        className: jr.collapse,
        children: [
          /* @__PURE__ */ he.jsx(Sr.Header, { className: jr.collapseHeader, children: /* @__PURE__ */ he.jsxs(
            b,
            {
              flexDirection: "column",
              gap: "200",
              justifyContent: "space-between",
              children: [
                /* @__PURE__ */ he.jsxs(b, { flexDirection: "row", justifyContent: "space-between", children: [
                  /* @__PURE__ */ he.jsxs(b, { alignItems: "center", gap: "200", children: [
                    /* @__PURE__ */ he.jsx(Nl, { width: 16, iconUrl: v }),
                    /* @__PURE__ */ he.jsx(
                      "a",
                      {
                        className: jr.collapseHeaderLink,
                        href: `${n}/browse/${d?.key}`,
                        target: "_blank",
                        rel: "noreferrer",
                        onClick: (N) => {
                          N.stopPropagation(), d?.key && s("jira:view:issue:clicked", {
                            jiraIssueKey: d.key,
                            jiraInstanceUrl: n
                          });
                        },
                        children: /* @__PURE__ */ he.jsxs(b, { alignItems: "center", gap: "200", children: [
                          d?.key,
                          /* @__PURE__ */ he.jsx(fe, { name: "external-link", size: 16 })
                        ] })
                      },
                      d?.key
                    )
                  ] }),
                  /* @__PURE__ */ he.jsx("span", { className: jr.collapseHeaderStatus, children: f?.name && /* @__PURE__ */ he.jsx(Jn, { className: jr.collapseContentStatusTag, children: f.name }) })
                ] }),
                /* @__PURE__ */ he.jsx("div", { className: jr.collapseHeaderTitle, children: m })
              ]
            }
          ) }),
          /* @__PURE__ */ he.jsx(Sr.Content, { className: jr.collapseContent, children: /* @__PURE__ */ he.jsxs(b, { flexDirection: "column", gap: "250", margin: "0 0 200 0", children: [
            /* @__PURE__ */ he.jsx("div", { className: jr.collapseContentHeadline, children: "Description" }),
            /* @__PURE__ */ he.jsx(ct, { className: jr.collapseContentDescription, children: u ? yg(u, t1) : "" }),
            /* @__PURE__ */ he.jsx(
              Qn,
              {
                icon: "link-slash",
                variant: "secondary",
                className: jr.collapseContentButtonSpacer,
                onClick: () => d?.key && r(d.key),
                children: "Unlink issue from Jira"
              }
            ),
            /* @__PURE__ */ he.jsx(
              Et,
              {
                slotEnd: /* @__PURE__ */ he.jsx(fe, { name: "external-link" }),
                variant: "tertiary",
                className: jr.collapseContentButtonLink,
                navigate: () => {
                  d?.key && (s("jira:view:issue:clicked", {
                    jiraIssueKey: d.key,
                    jiraInstanceUrl: n
                  }), window.open(
                    `${n}/browse/${d.key}`,
                    "_blank"
                  )?.focus());
                },
                children: "View issue in Jira"
              }
            )
          ] }) })
        ]
      },
      d?.id
    );
  }) : /* @__PURE__ */ he.jsx(he.Fragment, {}) });
}, HA = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createBacklink" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueKey" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "title" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "url" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "globalId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "createOrUpdateRemoteIssueLink" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "issueIdOrKey" }, value: { kind: "Variable", name: { kind: "Name", value: "issueKey" } } }, { kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "globalId" }, value: { kind: "Variable", name: { kind: "Name", value: "globalId" } } }, { kind: "ObjectField", name: { kind: "Name", value: "application" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "name" }, value: { kind: "StringValue", value: "Dixa Conversations", block: !1 } }, { kind: "ObjectField", name: { kind: "Name", value: "type" }, value: { kind: "StringValue", value: "com.dixa.conversations", block: !1 } }] } }, { kind: "ObjectField", name: { kind: "Name", value: "relationship" }, value: { kind: "StringValue", value: "dixa-backlink", block: !1 } }, { kind: "ObjectField", name: { kind: "Name", value: "object" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "title" }, value: { kind: "Variable", name: { kind: "Name", value: "title" } } }, { kind: "ObjectField", name: { kind: "Name", value: "url" }, value: { kind: "Variable", name: { kind: "Name", value: "url" } } }, { kind: "ObjectField", name: { kind: "Name", value: "icon" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "url16x16" }, value: { kind: "StringValue", value: "https://www.dixa.com/app/themes/dixa/app/frontend/src/images/favicons/favicon-32x32.png?v=2", block: !1 } }, { kind: "ObjectField", name: { kind: "Name", value: "title" }, value: { kind: "StringValue", value: "Dixa", block: !1 } }] } }] } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "__typename" } }] } }] } }] } }] }, WA = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "removeBacklink" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueKey" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "globalId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "deleteRemoteIssueLinkByGlobalId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "issueIdOrKey" }, value: { kind: "Variable", name: { kind: "Name", value: "issueKey" } } }, { kind: "Argument", name: { kind: "Name", value: "globalId" }, value: { kind: "Variable", name: { kind: "Name", value: "globalId" } } }] }] } }] } }] }, KA = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createIssue" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Jira_IssueUpdateDetails_Input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "createIssue" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Jira_CreatedIssue" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "key" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Jira_ErrorCollection" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errorMessages" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "errors" } }] } }] } }] } }] } }] }, GA = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getAllProjects" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "avatarUrls" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "_24x24" } }] } }] } }] } }] } }] }, YA = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCreateIssueMeta" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "projectKey" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getCreateIssueMeta" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "projectKeys" }, value: { kind: "ListValue", values: [{ kind: "Variable", name: { kind: "Name", value: "projectKey" } }] } }, { kind: "Argument", name: { kind: "Name", value: "expand" }, value: { kind: "StringValue", value: "projects.issuetypes.fields", block: !1 } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "projects" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "issuetypes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "iconUrl" } }, { kind: "Field", name: { kind: "Name", value: "entityId" } }, { kind: "Field", name: { kind: "Name", value: "hierarchyLevel" } }, { kind: "Field", name: { kind: "Name", value: "subtask" } }, { kind: "Field", name: { kind: "Name", value: "scope" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "project" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "additionalProperties" } }] } }, { kind: "Field", name: { kind: "Name", value: "expand" } }, { kind: "Field", name: { kind: "Name", value: "subtask" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "fields" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "additionalProperties" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "value" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "required" } }, { kind: "Field", name: { kind: "Name", value: "hasDefaultValue" } }, { kind: "Field", name: { kind: "Name", value: "schema" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "system" } }, { kind: "Field", name: { kind: "Name", value: "items" } }, { kind: "Field", name: { kind: "Name", value: "custom" } }, { kind: "Field", name: { kind: "Name", value: "customId" } }] } }, { kind: "Field", name: { kind: "Name", value: "allowedValues" } }, { kind: "Field", name: { kind: "Name", value: "defaultValue" } }, { kind: "Field", name: { kind: "Name", value: "operations" } }, { kind: "Field", name: { kind: "Name", value: "autoCompleteUrl" } }] } }] } }] } }] } }] } }] } }] } }] } }] }, JA = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "searchAndReconsileIssuesUsingJql" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "jql" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxResults" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "searchAndReconsileIssuesUsingJql" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "jql" }, value: { kind: "Variable", name: { kind: "Name", value: "jql" } } }, { kind: "Argument", name: { kind: "Name", value: "maxResults" }, value: { kind: "Variable", name: { kind: "Name", value: "maxResults" } } }, { kind: "Argument", name: { kind: "Name", value: "fields" }, value: { kind: "ListValue", values: [{ kind: "StringValue", value: "summary", block: !1 }, { kind: "StringValue", value: "description", block: !1 }, { kind: "StringValue", value: "status", block: !1 }, { kind: "StringValue", value: "updated", block: !1 }, { kind: "StringValue", value: "issuetype", block: !1 }, { kind: "StringValue", value: "project", block: !1 }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issues" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "fields" } }] } }] } }] } }] } }] }, QA = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "findUsers" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "findUsers" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "accountId" } }, { kind: "Field", name: { kind: "Name", value: "displayName" } }, { kind: "Field", name: { kind: "Name", value: "self" } }, { kind: "Field", name: { kind: "Name", value: "active" } }, { kind: "Field", name: { kind: "Name", value: "avatarUrls" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "_24x24" } }] } }] } }] } }] } }] }, XA = {
  '\n  mutation createBacklink(\n    $issueKey: String!\n    $title: String!\n    $url: String!\n    $globalId: String!\n  ) {\n    Jira {\n      createOrUpdateRemoteIssueLink(\n        issueIdOrKey: $issueKey\n        input: {\n          globalId: $globalId\n          application: {\n            name: "Dixa Conversations"\n            type: "com.dixa.conversations"\n          }\n          relationship: "dixa-backlink"\n          object: {\n            title: $title\n            url: $url\n            icon: {\n              url16x16: "https://www.dixa.com/app/themes/dixa/app/frontend/src/images/favicons/favicon-32x32.png?v=2"\n              title: "Dixa"\n            }\n          }\n        }\n      ) {\n        __typename\n      }\n    }\n  }\n': HA,
  "\n  mutation removeBacklink($issueKey: String!, $globalId: String!) {\n    Jira {\n      deleteRemoteIssueLinkByGlobalId(\n        issueIdOrKey: $issueKey\n        globalId: $globalId\n      )\n    }\n  }\n": WA,
  "\n  mutation createIssue($input: Jira_IssueUpdateDetails_Input) {\n    Jira {\n      createIssue(input: $input) {\n        ... on Jira_CreatedIssue {\n          id\n          key\n        }\n        ... on Jira_ErrorCollection {\n          errorMessages\n          status\n          errors\n        }\n      }\n    }\n  }\n": KA,
  "\n  query jira {\n    Jira {\n      getAllProjects {\n        id\n        key\n        name\n        avatarUrls {\n          _24x24\n        }\n      }\n    }\n  }\n": GA,
  '\n  query getCreateIssueMeta($projectKey: String) {\n    Jira {\n      getCreateIssueMeta(\n        projectKeys: [$projectKey]\n        expand: "projects.issuetypes.fields"\n      ) {\n        projects {\n          id\n          key\n          name\n          issuetypes {\n            id\n            name\n            iconUrl\n            entityId\n            hierarchyLevel\n            subtask\n            scope {\n              type\n              project {\n                id\n                key\n                name\n              }\n              additionalProperties\n            }\n            expand\n            subtask\n            description\n            fields {\n              additionalProperties {\n                key\n                value {\n                  key\n                  name\n                  required\n                  hasDefaultValue\n                  schema {\n                    type\n                    system\n                    items\n                    custom\n                    customId\n                  }\n                  allowedValues\n                  defaultValue\n                  operations\n                  autoCompleteUrl\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n': YA,
  '\n  query searchAndReconsileIssuesUsingJql($jql: String!, $maxResults: Int) {\n    Jira {\n      searchAndReconsileIssuesUsingJql(\n        jql: $jql\n        maxResults: $maxResults\n        fields: [\n          "summary"\n          "description"\n          "status"\n          "updated"\n          "issuetype"\n          "project"\n        ]\n      ) {\n        issues {\n          id\n          key\n          fields\n        }\n      }\n    }\n  }\n': JA,
  "\n  query findUsers($query: String) {\n    Jira {\n      findUsers(query: $query) {\n        accountId\n        displayName\n        self\n        active\n        avatarUrls {\n          _24x24\n        }\n      }\n    }\n  }\n": QA
};
function Yi(e) {
  return XA[e] ?? {};
}
const i1 = Yi(
  /* GraphQL */
  `
  query searchAndReconsileIssuesUsingJql($jql: String!, $maxResults: Int) {
    Jira {
      searchAndReconsileIssuesUsingJql(
        jql: $jql
        maxResults: $maxResults
        fields: [
          "summary"
          "description"
          "status"
          "updated"
          "issuetype"
          "project"
        ]
      ) {
        issues {
          id
          key
          fields
        }
      }
    }
  }
`
), ZA = Yi(
  /* GraphQL */
  `
  mutation createBacklink(
    $issueKey: String!
    $title: String!
    $url: String!
    $globalId: String!
  ) {
    Jira {
      createOrUpdateRemoteIssueLink(
        issueIdOrKey: $issueKey
        input: {
          globalId: $globalId
          application: {
            name: "Dixa Conversations"
            type: "com.dixa.conversations"
          }
          relationship: "dixa-backlink"
          object: {
            title: $title
            url: $url
            icon: {
              url16x16: "https://www.dixa.com/app/themes/dixa/app/frontend/src/images/favicons/favicon-32x32.png?v=2"
              title: "Dixa"
            }
          }
        }
      ) {
        __typename
      }
    }
  }
`
), e2 = Yi(
  /* GraphQL */
  `
  mutation removeBacklink($issueKey: String!, $globalId: String!) {
    Jira {
      deleteRemoteIssueLinkByGlobalId(
        issueIdOrKey: $issueKey
        globalId: $globalId
      )
    }
  }
`
), n2 = Yi(
  /* GraphQL */
  `
  query jira {
    Jira {
      getAllProjects {
        id
        key
        name
        avatarUrls {
          _24x24
        }
      }
    }
  }
`
), t2 = Yi(
  /* GraphQL */
  `
  query getCreateIssueMeta($projectKey: String) {
    Jira {
      getCreateIssueMeta(
        projectKeys: [$projectKey]
        expand: "projects.issuetypes.fields"
      ) {
        projects {
          id
          key
          name
          issuetypes {
            id
            name
            iconUrl
            entityId
            hierarchyLevel
            subtask
            scope {
              type
              project {
                id
                key
                name
              }
              additionalProperties
            }
            expand
            subtask
            description
            fields {
              additionalProperties {
                key
                value {
                  key
                  name
                  required
                  hasDefaultValue
                  schema {
                    type
                    system
                    items
                    custom
                    customId
                  }
                  allowedValues
                  defaultValue
                  operations
                  autoCompleteUrl
                }
              }
            }
          }
        }
      }
    }
  }
`
), r2 = Yi(
  /* GraphQL */
  `
  mutation createIssue($input: Jira_IssueUpdateDetails_Input) {
    Jira {
      createIssue(input: $input) {
        ... on Jira_CreatedIssue {
          id
          key
        }
        ... on Jira_ErrorCollection {
          errorMessages
          status
          errors
        }
      }
    }
  }
`
), i2 = Yi(
  /* GraphQL */
  `
  query findUsers($query: String) {
    Jira {
      findUsers(query: $query) {
        accountId
        displayName
        self
        active
        avatarUrls {
          _24x24
        }
      }
    }
  }
`
), gg = new RegExp("[a-zA-Z0-9_]{2,}-[0-9]+"), a2 = new RegExp(`^${gg.source}$`), o2 = new RegExp(`/${gg.source}$`), ax = new RegExp(
  `.+?[&?]selectedIssue=(${gg.source})[&?]?.*`
);
function a1(e, n) {
  const r = { jira: { issues: [] } }, [i, a] = me([]), [o, s] = me([]), [l, d] = me(), { track: m } = jn(), { showNotification: u, showModal: f, useLazyQuery: h, useMutation: v } = fn(), {
    loading: w,
    data: N,
    error: j,
    store: _
  } = Iy(e ?? null), [
    g,
    { loading: O, error: R, data: $ }
  ] = h(i1, {
    notifyOnNetworkStatusChange: !0
  });
  Xe(() => {
    const le = $?.Jira?.searchAndReconsileIssuesUsingJql?.issues || [];
    le?.length && (s(le), a(le.map((ge) => ge?.key).filter(Boolean)));
  }, [$]), Xe(
    () => d(j || R || void 0),
    [j, R]
  ), Xe(
    () => {
      w || Y();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [N?.jira?.issues, w]
  );
  const I = async (le, ge) => {
    await _(le).then(() => {
      u({
        icon: "check-circle-filled",
        severity: "success",
        title: ge.success.title,
        text: ge.success.text
      });
    }).catch((V) => {
      u({
        title: ge.error.title,
        text: `${ge.error.text} ${V.message && " (" + V.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    });
  }, [L] = v(ZA, {
    onError: (le) => {
      u({
        title: "Something went wrong",
        text: `It looks like something went wrong when trying to create a link back from the issue to the conversation. Please create it manually in Jira.
				${le.message && " (" + le.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    }
  }), G = (le, ge) => {
    const V = window.location.href, be = ge ? V.replace(
      e?.toString() ?? "",
      ge?.toString()
    ) : V, Oe = ge ? `# ${ge}` : `# ${e}`;
    L({
      variables: {
        issueKey: le,
        title: Oe,
        url: be,
        globalId: `system=${be}`
      }
    });
  }, [Q] = v(e2, {
    onError: (le) => {
      u({
        title: "Something went wrong",
        text: `It looks like something went wrong when trying to remove a link back from the issue to the conversation. Please remove it manually from Jira.
					${le.message && " (" + le.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    }
  }), ne = (le) => {
    const ge = window.location.href;
    Q({
      variables: {
        issueKey: le,
        globalId: `system=${ge}`
      }
    });
  }, q = (le) => ({
    jiraInstanceUrl: n,
    jiraIssueKey: le
  }), Y = () => {
    N && N.jira?.issues?.length > 0 ? g({
      variables: {
        jql: `key in (${N?.jira?.issues.join(",")})`,
        maxResults: 15
      }
    }) : s([]);
  }, P = async (le, ge) => {
    m("jira:issue:link:clicked", q(le));
    const V = N?.jira?.issues ? N : r;
    V.jira.issues = Array.from(
      new Set(V.jira.issues).add(le)
    ), await _(V, ge?.toString()).then(() => G(le, ge)).catch((be) => {
      u({
        title: "Linking failed",
        text: `Linking ${le} failed. Please try again. ${be.message && " (" + be.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    });
  }, B = (le) => {
    m("jira:issue:link:clicked", q(le));
    const ge = N?.jira?.issues ? N : r;
    ge.jira.issues = Array.from(
      new Set(ge.jira.issues).add(le)
    ), I(ge, {
      success: {
        title: "Jira issue linked",
        text: `You linked the Jira issue ${le} to this conversation.`
      },
      error: {
        title: "Linking failed",
        text: `Linking ${le} failed. Please try again.`
      }
    }).then(() => G(le));
  }, ie = (le) => {
    m("jira:issue:unlink:clicked", q(le)), f({
      headline: `Unlink issue ${le}?`,
      text: `You are about to unlink the issue ${le}. Do you want to proceed?`,
      confirmLabel: "Unlink Jira issue",
      confirmVariant: "danger",
      cancelLabel: "Cancel",
      onConfirm: () => {
        m("jira:issue:unlink:confirmed", q(le));
        const ge = {
          ...N,
          jira: {
            ...N?.jira,
            issues: N?.jira?.issues.filter((V) => V !== le) || []
          }
        };
        I(ge, {
          success: {
            title: "Jira issue unlinked",
            text: `You unlinked the Jira issue ${le}`
          },
          error: {
            title: "Unlinking failed",
            text: `Unlinking ${le} failed.`
          }
        }).then(() => ne(le));
      },
      onCancel: () => m("jira:issue:unlink:cancelled", q(le))
    });
  }, je = () => {
    m("jira:issue:unlink-all:clicked", { jiraInstanceUrl: n }), f({
      headline: "Unlink all Jira issues?",
      text: "You are about to unlink the all Jira issues from the conversation. Do you want to proceed?",
      confirmLabel: "Unlink ALL issues",
      confirmVariant: "danger",
      cancelLabel: "Cancel",
      onConfirm: () => {
        m("jira:issue:unlink-all:confirmed", { jiraInstanceUrl: n }), o?.forEach((le) => le?.key && ne(le.key)), I(r, {
          success: {
            title: "Unlinking successful",
            text: "All Jira issues were unlinked"
          },
          error: {
            title: "Unlinking failed",
            text: "Unlinking all issues failed."
          }
        });
      },
      onCancel: () => m("jira:issue:unlink-all:cancelled", { jiraInstanceUrl: n })
    });
  }, pe = N?.jira?.issues?.filter(
    (le) => !i?.includes(le)
  ) || [];
  return {
    linkIssue: B,
    linkIssueQuietly: P,
    unlinkIssue: ie,
    loadIssues: Y,
    removeDanglingIssueLinks: () => {
      m("jira:issue:unlink-all-dangling:clicked", {
        jiraInstanceUrl: n
      });
      const le = {
        ...N,
        jira: {
          ...N?.jira,
          issues: N?.jira?.issues.filter(
            (ge) => !pe.includes(ge)
          ) || []
        }
      };
      _(le);
    },
    unlinkAllIssues: je,
    maybeExtractIssueKey: (le) => {
      const ge = le.replace(/\s/g, "");
      if (a2.test(ge))
        return ge;
      if (ax.test(le))
        return le.match(ax)?.[1];
      if (le.startsWith(n) && o2.test(le))
        return le.substring(le.lastIndexOf("/") + 1);
    },
    isLoadingIssueLinks: w,
    danglingIssueLinks: pe,
    isLoadingIssues: O,
    issues: o,
    error: l
  };
}
function s2(e = !1, n) {
  const [r, i] = me(e);
  return Xe(() => {
    const a = r ? window.setTimeout(() => i(!1), 2e3) : void 0;
    return () => window.clearTimeout(a);
  }, [n, r]), { isCopied: r, copyToClipboard: (a) => {
    navigator.clipboard.writeText(a), i(!0);
  } };
}
const l2 = "_result_1wiub_54", c2 = "_resultName_1wiub_74", d2 = "_resultNameIcon_1wiub_82", u2 = "_resultDescription_1wiub_87", m2 = "_resultLinkIcon_1wiub_99", p2 = "_tooltip_1wiub_108", f2 = "_tooltipContent_1wiub_114", h2 = "_tooltipName_1wiub_121", y2 = "_tooltipNameIcon_1wiub_126", g2 = "_tooltipDescription_1wiub_131", v2 = "_tooltipSummary_1wiub_139", k2 = "_tooltipTag_1wiub_143", br = {
  result: l2,
  resultName: c2,
  resultNameIcon: d2,
  resultDescription: u2,
  resultLinkIcon: m2,
  tooltip: p2,
  tooltipContent: f2,
  tooltipName: h2,
  tooltipNameIcon: y2,
  tooltipDescription: g2,
  tooltipSummary: v2,
  tooltipTag: k2
}, b2 = ({
  item: e,
  jiraInstanceUrl: n,
  onSelect: r,
  disableTooltip: i = !1,
  ...a
}) => {
  const { issuetype: o, name: s, status: l, text: d, description: m } = e, [u, f] = me(!1), h = r1({
    avatarId: o?.avatarId,
    iconUrl: o?.iconUrl,
    jiraInstanceUrl: n
  });
  return /* @__PURE__ */ he.jsx(
    Ge,
    {
      disabled: i,
      className: br.tooltip,
      content: /* @__PURE__ */ he.jsxs("div", { className: br.tooltipContent, children: [
        /* @__PURE__ */ he.jsxs(
          b,
          {
            flexDirection: "row",
            justifyContent: "space-between",
            width: "100%",
            children: [
              /* @__PURE__ */ he.jsxs("span", { className: br.tooltipName, children: [
                /* @__PURE__ */ he.jsx(
                  Nl,
                  {
                    width: 16,
                    iconUrl: h,
                    className: br.tooltipNameIcon
                  }
                ),
                " ",
                s
              ] }),
              /* @__PURE__ */ he.jsx(Jn, { className: br.tooltipTag, children: l.name })
            ]
          }
        ),
        m && /* @__PURE__ */ he.jsx("div", { className: br.tooltipSummary, children: m }),
        d && /* @__PURE__ */ he.jsx("div", { className: br.tooltipDescription, children: d })
      ] }),
      side: "left",
      light: !0,
      children: /* @__PURE__ */ he.jsxs(
        "button",
        {
          ...a,
          className: br.result,
          type: "button",
          onClick: () => {
            r(e);
          },
          onMouseEnter: () => f(!0),
          onMouseLeave: () => f(!1),
          children: [
            /* @__PURE__ */ he.jsxs(
              b,
              {
                flexDirection: "column",
                justifyContent: "center",
                style: {
                  width: u ? "calc(100% - 32px)" : "100%"
                },
                children: [
                  /* @__PURE__ */ he.jsx(b, { flexDirection: "row", children: /* @__PURE__ */ he.jsxs("span", { className: br.resultName, children: [
                    /* @__PURE__ */ he.jsx(
                      Nl,
                      {
                        width: 16,
                        iconUrl: h,
                        className: br.resultNameIcon
                      }
                    ),
                    " ",
                    s
                  ] }) }),
                  m && /* @__PURE__ */ he.jsx("div", { className: br.resultDescription, children: m })
                ]
              }
            ),
            u && /* @__PURE__ */ he.jsx(
              fe,
              {
                className: br.resultLinkIcon,
                name: "plus",
                size: 32
              }
            )
          ]
        }
      )
    }
  );
}, _2 = ({
  className: e,
  searched: n,
  jiraInstanceUrl: r
}) => /* @__PURE__ */ he.jsx(
  Et,
  {
    slotEnd: /* @__PURE__ */ he.jsx(fe, { name: "external-link" }),
    variant: "tertiary",
    style: { width: "100%" },
    className: e,
    navigate: () => {
      window.open(
        `${r}/secure/QuickSearch.jspa?searchString=${n}`,
        "_blank"
      )?.focus();
    },
    children: "View matching issues in Jira"
  }
), x2 = ({
  onSelectIssue: e,
  jiraInstanceUrl: n,
  filterByProjectKey: r,
  disableTooltip: i
}) => {
  const { useLazyQuery: a } = fn(), [o, s] = me([]), [l, d] = me(""), [m, { loading: u, error: f, data: h, networkStatus: v }] = a(i1, {
    notifyOnNetworkStatusChange: !0
  }), { maybeExtractIssueKey: w } = a1(null, n);
  xi(
    () => {
      !u && l && v === ir.ready ? m({
        variables: {
          jql: l,
          maxResults: 25
        }
      }) : s([]);
    },
    500,
    [l]
  ), Xe(() => {
    const R = h?.Jira?.searchAndReconsileIssuesUsingJql?.issues || [];
    s(
      R.map(($) => ({
        id: $?.key ?? "",
        name: $?.key ?? "",
        description: $?.fields.summary,
        status: $?.fields.status,
        issuetype: $?.fields.issuetype,
        text: $?.fields.description ? yg($?.fields.description, t1) : /* @__PURE__ */ he.jsx(he.Fragment, {})
      }))
    );
  }, [h]);
  const N = (R) => {
    e(R.id), d("");
  }, j = (R) => {
    const $ = R.trim(), I = w($);
    if (I) {
      const L = I.replaceAll("[-_|]", "\\\\$0");
      d(`key = '${L}'`);
    } else $ !== "" && d(
      `text ~ '${$}'${r ? " and project = " + r : ""}`
    );
  }, _ = () => {
    d("");
  }, g = (R) => /* @__PURE__ */ he.jsx(_2, { ...R, jiraInstanceUrl: n }), O = (R) => /* @__PURE__ */ he.jsx(
    b2,
    {
      ...R,
      jiraInstanceUrl: n,
      disableTooltip: i
    }
  );
  return !u && f ? /* @__PURE__ */ he.jsx($n, { error: f }) : /* @__PURE__ */ he.jsx(
    Rr,
    {
      items: o,
      loading: u,
      onSearch: j,
      onSelect: N,
      onClear: _,
      emptyMessage: l ? u ? "" : "No Jira Issues found" : "Enter Jira issue key, link or search terms",
      suggestionComponent: g,
      itemComponent: O,
      placeholder: "Search and link existing issue",
      searchable: !0,
      clearable: !0
    }
  );
}, S2 = ({
  field: e,
  value: n,
  onChange: r
}) => {
  const [i, a] = me(n ? [n] : []), o = (s, l) => {
    a(
      l ? [...i, s] : i.filter(({ id: d }) => d !== s.id)
    );
  };
  return Xe(() => {
    r(i);
  }, [i]), /* @__PURE__ */ he.jsx(
    Rr,
    {
      multiple: !0,
      onChange: o,
      selectedItems: i,
      items: e?.allowedValues?.map(
        ({ id: s, name: l, value: d }) => ({
          id: s,
          name: l || d
        })
      )
    }
  );
}, N2 = "_itemButton_1hl53_1", j2 = "_result_1hl53_6", w2 = "_resultIcon_1hl53_26", C2 = "_resultName_1hl53_30", F2 = "_resultCheckIcon_1hl53_38", eo = {
  itemButton: N2,
  result: j2,
  resultIcon: w2,
  resultName: C2,
  resultCheckIcon: F2
}, ry = ({
  item: e,
  checked: n = !1,
  onSelectItem: r,
  jiraInstanceUrl: i
}) => {
  const a = (s) => {
    const l = s.indexOf("/rest/api/");
    return l >= 0 ? `${i}${s?.substring(l)}` : s;
  };
  let o = e?.iconUrl || e?.avatarUrls?._24x24 || null;
  return o && (o = o?.startsWith("https://api.atlassian.com/ex/") ? a(o) : o), /* @__PURE__ */ he.jsx(
    b,
    {
      flexDirection: "column",
      justifyContent: "center",
      width: "100%",
      "data-testid": "jira-select-item-component",
      children: /* @__PURE__ */ he.jsx(
        "button",
        {
          onClick: () => {
            r(e);
          },
          className: eo.itemButton,
          children: /* @__PURE__ */ he.jsxs(b, { className: eo.result, flexDirection: "row", width: "100%", children: [
            /* @__PURE__ */ he.jsx(
              Nl,
              {
                width: 36,
                iconUrl: o || "",
                className: eo.resultIcon
              }
            ),
            /* @__PURE__ */ he.jsx(ct, { className: eo.resultName, children: e.name }),
            n && /* @__PURE__ */ he.jsx(ct, { className: eo.resultCheckIcon, children: /* @__PURE__ */ he.jsx(fe, { name: "done" }) })
          ] })
        }
      )
    }
  );
}, I2 = ({
  selectedItems: e,
  agentEmail: n,
  onSelect: r,
  jiraInstanceUrl: i
}) => {
  const { useLazyQuery: a } = fn(), [o, s] = me([]), [l, d] = me(), m = 2, [u, { loading: f, error: h, data: v, networkStatus: w }] = a(i2, {
    notifyOnNetworkStatusChange: !0
  });
  return xi(
    () => {
      !f && l && l.length >= m && w === ir.ready ? u({
        variables: {
          query: l,
          maxResults: 10
        }
      }) : s([]);
    },
    500,
    [l]
  ), Xe(() => {
    n && u({
      variables: {
        query: n,
        maxResults: 1
      }
    }).then((N) => {
      if (N?.data?.Jira.findUsers?.length === 1) {
        const j = N?.data?.Jira?.findUsers[0];
        r(j.accountId), s([
          {
            id: j.accountId,
            name: j.displayName
          }
        ]);
      }
    });
  }, []), Xe(() => {
    const N = v?.Jira?.findUsers || [];
    s(
      N.filter(({ active: j }) => j).map(({ accountId: j, displayName: _, avatarUrls: g, active: O }) => ({
        id: j,
        name: _,
        avatarUrls: g,
        active: O
      }))
    );
  }, [v]), !f && h ? /* @__PURE__ */ he.jsx($n, { error: h }) : /* @__PURE__ */ he.jsx(
    Rr,
    {
      clearable: !0,
      searchable: !0,
      items: o,
      loading: f,
      onSearch: (N) => d(N),
      onSelect: r,
      onClear: () => d(void 0),
      selectedItems: e,
      emptyMessage: l ? f ? "" : "No user found" : "Enter keyword to search for user",
      itemComponent: ({ item: N, onSelect: j, checked: _ }) => /* @__PURE__ */ he.jsx(
        ry,
        {
          item: N,
          checked: _,
          onSelectItem: j,
          jiraInstanceUrl: i
        }
      ),
      placeholder: "Search Jira users"
    }
  );
}, ox = ({
  field: e
}) => {
  const [n, r] = me(!1), [i, a] = JC();
  return Xe(() => {
    const o = n ? window.setTimeout(() => r(!1), 2e3) : void 0;
    return () => window.clearTimeout(o);
  }, [n]), /* @__PURE__ */ he.jsxs(b, { alignItems: "center", gap: "400", justifyContent: "space-between", children: [
    /* @__PURE__ */ he.jsx(b, { children: /* @__PURE__ */ he.jsx(fe, { size: 24, name: "exclamation-triangle-filled", color: "red.500" }) }),
    /* @__PURE__ */ he.jsx(F.Paragraph, { children: "Your organizations Jira configuration is currently not fully supported by Dixa. Please reach out so we can have a look at this field. Please, attach a copy of the field details when contacting us. You can use the copy button to do so." }),
    /* @__PURE__ */ he.jsx(Ge, { content: n ? "Copied" : "Copy field details", children: /* @__PURE__ */ he.jsx(
      Xt,
      {
        variant: "secondary",
        icon: n ? "done" : "copy",
        onClick: () => {
          a(JSON.stringify(e, null, 2)), r(!0);
        }
      }
    ) })
  ] });
}, $2 = ({
  field: e,
  onChange: n,
  value: r,
  conversationContext: i,
  jiraInstanceUrl: a
}) => {
  const { type: o, system: s } = e.schema;
  if (["array", "option", "priority"].includes(o) && (!e?.allowedValues || e.allowedValues.length === 0))
    return /* @__PURE__ */ he.jsx(ox, { field: e });
  switch (o) {
    case "issuelink":
    case "environment":
    case "any":
      return /* @__PURE__ */ he.jsx(ur, { onChange: n, value: r });
    case "string":
      return s === "description" ? /* @__PURE__ */ he.jsx(Gh, { onChange: n, value: r }) : /* @__PURE__ */ he.jsx(ur, { onChange: n, value: r });
    case "textarea":
      return /* @__PURE__ */ he.jsx(Gh, { onChange: n, value: r });
    case "number":
      return /* @__PURE__ */ he.jsx(ur, { type: "number", onChange: n, value: r });
    case "user":
      return /* @__PURE__ */ he.jsx(
        I2,
        {
          onSelect: n,
          selectedItems: r ? [r] : [],
          agentEmail: e.key === "reporter" && i?.agent?.email || void 0,
          jiraInstanceUrl: a
        }
      );
    case "option":
    case "priority":
      return /* @__PURE__ */ he.jsx(
        Rr,
        {
          onSelect: n,
          selectedItems: r ? [r] : [],
          items: e?.allowedValues?.map(
            ({ id: l, name: d, value: m }) => ({
              id: l,
              name: d || m
            })
          ) || []
        }
      );
    case "array":
      return /* @__PURE__ */ he.jsx(S2, { field: e, value: r, onChange: n });
    default:
      return /* @__PURE__ */ he.jsx(ox, { field: e });
  }
}, E2 = ["description", "reporter", "summary"], T2 = ({
  issueTypeFields: e,
  control: n,
  jiraInstanceUrl: r,
  conversationContext: i,
  errors: a
}) => /* @__PURE__ */ he.jsx(he.Fragment, { children: e.filter(({ key: o }) => o !== "project" && o !== "issuetype").filter(
  ({ key: o, required: s }) => s || E2.includes(o)
).map((o) => /* @__PURE__ */ he.jsx(
  jt,
  {
    control: n,
    render: ({ field: { onChange: s, value: l } }) => /* @__PURE__ */ he.jsx(
      qe,
      {
        meta: {
          error: a && o.key in a ? a[o.key].message : null
        },
        label: o.name,
        required: o.required,
        children: $2({
          field: o,
          onChange: s,
          value: l,
          conversationContext: i,
          jiraInstanceUrl: r
        })
      },
      o.key
    ),
    name: o.key,
    rules: {
      required: o.required ? "This field is required" : !1
    }
  },
  o.key
)) }), R2 = ({
  createdIssue: e,
  issueBaseLink: n,
  issueLinkCopied: r,
  setIssueLinkCopied: i,
  copyToClipboard: a
}) => /* @__PURE__ */ he.jsxs(
  b,
  {
    flexDirection: "column",
    gap: "400",
    "data-testid": "jira-create-issue-success-message",
    children: [
      /* @__PURE__ */ he.jsxs(F.Paragraph, { children: [
        "You can visit your new issue by following",
        " ",
        /* @__PURE__ */ he.jsxs(
          F.ExternalLink,
          {
            href: `${n}/${e.key}`,
            target: "_blank",
            children: [
              "this link ",
              /* @__PURE__ */ he.jsx(fe, { name: "external-link" })
            ]
          }
        ),
        " ",
        "or copy it from the field below."
      ] }),
      /* @__PURE__ */ he.jsx(qe, { label: "Jira issue link", children: /* @__PURE__ */ he.jsx(
        ur,
        {
          readOnly: !0,
          value: `${n}/${e.key}`,
          suffix: {
            type: "button",
            button: {
              icon: r ? "done" : "copy",
              onClick: () => {
                i(!0), a(`${n}/${e.key}`);
              }
            }
          }
        }
      ) })
    ]
  }
), D2 = "_modalBody_1hk1o_1", O2 = "_modalBodyFormFields_1hk1o_4", sx = {
  modalBody: D2,
  modalBodyFormFields: O2
}, P2 = (e) => ({
  version: 1,
  type: "doc",
  content: e?.trim()?.split(`
`).filter((n) => n !== "").map((n) => ({
    type: "paragraph",
    content: [
      {
        type: "text",
        text: n
      }
    ]
  }))
}), A2 = (e) => e?.custom?.split(":")?.[1] || null, L2 = (e, n) => {
  if (e.startsWith("customfield_")) {
    const r = n.find((i) => i.key === e)?.schema;
    if (r)
      return r;
  }
  return null;
}, V2 = (e, n) => {
  const r = ["environment", "textarea", "description"];
  return {
    fields: {
      ...Object.entries(e).reduce((i, [a, o]) => {
        if (!o || o === "")
          return delete e[a], i;
        const s = L2(a, n), l = A2(s) ?? a;
        return r.includes(l) ? i[a] = P2(o) : s?.type === "number" ? i[a] = parseInt(o) : i[a] = o, i;
      }, {}),
      summary: e.summary,
      project: { id: e.project.id },
      issuetype: { id: e.issuetype.id },
      ...e?.parent && { parent: { key: e.parent } },
      ...e?.reporter && {
        reporter: { id: e.reporter?.id ?? e.reporter }
      },
      ...e?.assignee && {
        assignee: { id: e.assignee?.id ?? e.assignee }
      }
    }
  };
}, z2 = ({
  isOpen: e,
  onClose: n,
  linkIssueQuietly: r,
  conversationContext: i,
  jiraInstanceUrl: a,
  hasSortIssueTypeByLabelEnabled: o
}) => {
  const s = { project: void 0, issuetype: void 0 }, [l, d] = me([]), [m, u] = me(), [f, h] = me(0), [v, w] = me([]), [N, j] = me([]), [_, g] = me(!1), [O, R] = me(!1), [$, I] = me({}), { track: L } = jn(), { isCopied: G, copyToClipboard: Q } = s2(), ne = Zn(() => i?.conversationId, [e]), { useMutation: q, useLazyQuery: Y, showNotification: P } = fn(), {
    control: B,
    handleSubmit: ie,
    formState: { errors: je },
    reset: pe,
    setValue: le,
    getValues: ge
  } = ot({
    defaultValues: s
  }), V = N.length > 0, be = `${a}/browse`, Oe = Object.keys($).length > 0, [H, { loading: Ye, error: ln }] = Y(n2, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onCompleted: (ce) => {
      d(ce.Jira.getAllProjects);
    },
    onError: (ce) => {
      P({
        title: "Could not get project list",
        text: "We could not fetch the list of your projects. Please try again later.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      }), console.warn("Error response when fetching projects", ce), d([]);
    }
  }), [
    Ie,
    { loading: Ue, error: De }
  ] = Y(t2, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onCompleted: (ce) => {
      h(0);
      const Se = ce?.Jira?.getCreateIssueMeta?.projects[0];
      if (Se) {
        const Ve = Se?.issuetypes.filter(
          ({ subtask: Pe }) => !Pe
        );
        w(Ve || []), le(
          "issuetype",
          Ve.length > 0 ? Ve[0] : void 0
        );
      } else
        P({
          title: "Could not get issue-type list",
          text: "It seems that there are no issue-types for this project or you might not have the necessary access rights to view them.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), w([]), j([]);
    },
    onError: (ce) => {
      P({
        title: "Could not get issue list",
        text: "We could not fetch the list of issue-types for this project. Please try again later.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      }), console.warn("Error in getCreateIssueMeta", ce), w([]), j([]), h(0);
    }
  }), [Be, { error: Ae }] = q(
    r2,
    {
      onError: () => {
        g(!1), P({
          title: "Creation was not successful",
          text: "Please try again later or contact your admin.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), L("jira:issue:create:failed", { jiraInstanceUrl: a });
      },
      onCompleted: (ce) => {
        if (g(!1), ce?.Jira && "key" in ce.Jira.createIssue)
          u(ce?.Jira?.createIssue), P({
            title: "Success",
            text: `Jira issue '${ce.Jira.createIssue.key}' created`,
            icon: "check-circle-filled",
            severity: "success"
          }), L("jira:issue:create:succeeded", {
            jiraInstanceUrl: a,
            jiraIssueKey: ce.Jira.createIssue.key
          }), ne && r(
            ce.Jira.createIssue.key,
            ne
          );
        else if ("errorMessages" in ce.Jira.createIssue || "errors" in ce.Jira.createIssue) {
          const Se = ce?.Jira?.createIssue?.errors;
          console.warn("There was a problem creating a Jira issue.", Se), P({
            title: "Creation was not successful",
            text: "Something went wrong. Please get in contact with Dixa.",
            icon: "exclamation-triangle-filled",
            severity: "warning"
          });
        }
      }
    }
  ), Qe = (ce) => {
    g(!0), I({}), Be({
      variables: {
        input: V2(ce, N)
      }
    });
  };
  Xe(() => {
    if (e)
      try {
        H();
      } catch (ce) {
        console.warn("Error when fetching initial projects", ce);
      }
  }, [e]), Xe(() => {
    const ce = O ? window.setTimeout(() => R(!1), 2e3) : void 0;
    return () => window.clearTimeout(ce);
  }, [O]), Xe(() => {
    if (v?.length > 0) {
      le("issuetype", v[f]);
      const ce = v[f]?.fields?.additionalProperties;
      if (ce?.length > 0) {
        const Se = ce.map(
          ({ value: X }) => X
        ), Ve = (o ? Se.sort(({ name: X }, { name: E }) => X.localeCompare(E)) : Se).sort(
          ({ required: X }, { required: E }) => Number(E) - Number(X)
        ), { project: Pe, issuetype: kn } = ge();
        pe({ project: Pe, issuetype: kn }), j(Ve);
      }
    } else
      j([]), le("issuetype", void 0);
  }, [v, le, f]), Xe(() => {
    if (Ae && Ew(Ae)) {
      if (Ae?.graphQLErrors?.length > 0) {
        const { graphQLErrors: ce } = Ae, Se = ce[0].extensions?.integration?.responseBody;
        try {
          const Ve = JSON.parse(Se);
          if (Ve?.errors) {
            const Pe = Object.keys(Ve.errors).reduce(
              (kn, X) => ({
                ...kn,
                [X]: {
                  type: "required",
                  message: Ve.errors[X],
                  ref: {
                    name: X
                  }
                }
              }),
              {}
            );
            I(Pe);
          }
        } catch {
        }
      }
    } else
      I({});
  }, [Ae]);
  const Ee = () => {
    d([]), j([]), w([]), u(void 0), h(0), g(!1), I({});
  }, Me = () => {
    Ee(), pe(s), n();
  }, en = (ce) => {
    ce && Ie({
      variables: {
        projectKey: ce
      }
    });
  }, se = (ce) => {
    const Se = v.map((Ve) => Ve.id).indexOf(ce);
    h(Se ?? 0);
  };
  return /* @__PURE__ */ he.jsxs(
    ht,
    {
      isOpen: e,
      "data-testid": "jira-create-issue-modal",
      onClose: Me,
      children: [
        /* @__PURE__ */ he.jsx(
          yt,
          {
            title: m ? "Issue creation successful" : "Create new Jira issue",
            onClose: Me
          }
        ),
        /* @__PURE__ */ he.jsxs(gt, { className: sx.modalBody, children: [
          !Ye && ln && /* @__PURE__ */ he.jsx($n, { error: ln, retry: H }),
          !Ue && De && /* @__PURE__ */ he.jsx(
            $n,
            {
              error: De,
              retry: Ie
            }
          ),
          !_ && Oe && /* @__PURE__ */ he.jsx(b, { margin: "0 0 400", children: /* @__PURE__ */ he.jsx(
            Ey,
            {
              variant: "warning",
              description: /* @__PURE__ */ he.jsxs(
                b,
                {
                  gap: "300",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  children: [
                    /* @__PURE__ */ he.jsx(F.Paragraph, { variant: "4", children: "The form contains input validation errors. Please correct them and try again to save. If your inputs seem fine, please contact our support team and provide the form schema to debug further." }),
                    /* @__PURE__ */ he.jsx(
                      Qn,
                      {
                        icon: G ? "done" : "copy",
                        variant: "secondary",
                        onClick: () => Q(JSON.stringify(N, null, 2)),
                        children: "Copy form schema"
                      }
                    )
                  ]
                }
              )
            }
          ) }),
          m ? /* @__PURE__ */ he.jsx(
            R2,
            {
              createdIssue: m,
              issueBaseLink: be,
              issueLinkCopied: O,
              setIssueLinkCopied: R,
              copyToClipboard: Q
            }
          ) : /* @__PURE__ */ he.jsx(
            "form",
            {
              "data-testid": "jira-create-issue-form",
              onSubmit: ie(Qe),
              children: /* @__PURE__ */ he.jsxs(et, { children: [
                /* @__PURE__ */ he.jsx(Z, { span: 3, children: /* @__PURE__ */ he.jsx(qe, { label: "Project", required: !0, children: /* @__PURE__ */ he.jsx(
                  jt,
                  {
                    control: B,
                    name: "project",
                    rules: { required: "Please select a project" },
                    render: ({ field: { onChange: ce, value: Se } }) => /* @__PURE__ */ he.jsx(
                      Rr,
                      {
                        searchable: !0,
                        loading: Ye,
                        onSelect: (Ve) => {
                          en(Ve.key), ce(Ve);
                        },
                        selectedItems: [Se],
                        placeholder: "Select Jira project",
                        emptyMessage: ln ? "No projects found" : "No projects available",
                        items: l || [],
                        itemComponent: ({ item: Ve, onSelect: Pe, checked: kn }) => /* @__PURE__ */ he.jsx(
                          ry,
                          {
                            item: Ve,
                            checked: kn,
                            onSelectItem: Pe,
                            jiraInstanceUrl: a
                          }
                        )
                      }
                    )
                  }
                ) }) }),
                /* @__PURE__ */ he.jsx(Z, { span: 3, children: /* @__PURE__ */ he.jsx(qe, { label: "Issue type", required: !0, children: /* @__PURE__ */ he.jsx(
                  jt,
                  {
                    control: B,
                    name: "issuetype",
                    rules: { required: "Please select an issue type" },
                    render: ({ field: { onChange: ce, value: Se } }) => /* @__PURE__ */ he.jsx(
                      Rr,
                      {
                        disabled: v.length === 0,
                        loading: Ue,
                        onSelect: (Ve) => {
                          se(Ve.id), ce(Ve);
                        },
                        selectedItems: [Se],
                        placeholder: v.length > 0 ? "Select Jira issue type" : "",
                        emptyMessage: De ? "No issues found" : "No issues available",
                        items: v,
                        itemComponent: ({ item: Ve, onSelect: Pe, checked: kn }) => /* @__PURE__ */ he.jsx(
                          ry,
                          {
                            item: Ve,
                            checked: kn,
                            onSelectItem: Pe,
                            jiraInstanceUrl: a
                          }
                        )
                      }
                    )
                  }
                ) }) }),
                V && // Wrapping all dynamic input fields inside one `FormField`
                // which can handle the overflow scrolling in case we get many
                // input fields in the form
                /* @__PURE__ */ he.jsx(Z, { className: sx.modalBodyFormFields, children: /* @__PURE__ */ he.jsx(
                  T2,
                  {
                    control: B,
                    errors: { ...je, ...$ },
                    getValues: ge,
                    conversationContext: i,
                    jiraInstanceUrl: a,
                    issueTypeFields: N
                  }
                ) })
              ] })
            }
          )
        ] }),
        /* @__PURE__ */ he.jsx(
          vt,
          {
            confirmOnClick: m ? Me : ie(Qe),
            confirmProps: {
              disabled: !V,
              isLoading: _,
              loadingIndicator: /* @__PURE__ */ he.jsx(sn, { size: 16 })
            },
            confirmName: m ? "Close" : "Save",
            cancelOnClick: m ? void 0 : Me
          }
        )
      ]
    }
  );
}, U2 = (e) => {
  if (!e) return "";
  const n = "https://", r = (e.startsWith(n) ? e.slice(n.length) : e).split("/")[0];
  return `${n}${r}`;
}, M2 = (e) => {
  if (!e?.trim())
    return "Please add a value";
  const n = "https://";
  if (e.startsWith(" ") || e.endsWith(" "))
    return "Please remove any empty spaces before or after the URL";
  const r = e.startsWith(n);
  if (r) {
    const i = e.slice(n.length).split("/");
    if (i.length > 1) {
      const a = r ? n.length + i[0].length : i[0].length;
      return i.length === 2 && i[1] === "" ? "Please remove the trailing slash `/`" : `Please remove the trailing path \`${e.slice(a)}\``;
    }
  } else
    return e.includes("://") ? `The protocol \`${e.substring(
      0,
      e.indexOf("://") + 3
    )}\` is not supported` : `Please add \`${n}\` as protocol`;
}, B2 = "_wrapper_1bylq_1", q2 = "_inputWrapper_1bylq_6", H2 = "_inputSeparator_1bylq_18", W2 = "_buttonLink_1bylq_23", K2 = "_noIssuesFound_1bylq_27", no = {
  wrapper: B2,
  inputWrapper: q2,
  inputSeparator: H2,
  buttonLink: W2,
  noIssuesFound: K2
}, G2 = ({
  conversationContext: e,
  settings: n
}) => {
  const { track: r } = jn(), i = U2(n?.jiraSiteUrl), [a, o] = me(!1), s = !!e?.conversationId, {
    linkIssue: l,
    linkIssueQuietly: d,
    unlinkIssue: m,
    unlinkAllIssues: u,
    loadIssues: f,
    removeDanglingIssueLinks: h,
    danglingIssueLinks: v,
    isLoadingIssueLinks: w,
    isLoadingIssues: N,
    issues: j,
    error: _
  } = a1(
    s ? e.conversationId : null,
    i
  ), g = !!n?.enableCreateIssue, O = !!n?.enableSortIssueTypeByLabel, R = !!(j?.length || v?.length), $ = !!n?.enableRemoveAllLinks && R, I = !w && !N && v?.length > 0 && !!n?.showDanglingLinks;
  return !N && _ ? /* @__PURE__ */ he.jsx($n, { error: _, retry: () => f() }) : /* @__PURE__ */ he.jsxs(he.Fragment, { children: [
    /* @__PURE__ */ he.jsxs(b, { className: no.wrapper, flexDirection: "column", children: [
      /* @__PURE__ */ he.jsxs(b, { className: no.inputWrapper, flexDirection: "column", children: [
        g && /* @__PURE__ */ he.jsxs(he.Fragment, { children: [
          /* @__PURE__ */ he.jsx(
            Qn,
            {
              variant: "primary",
              onClick: () => o(!0),
              style: {
                minHeight: "38px"
              },
              children: "Create new issue"
            }
          ),
          /* @__PURE__ */ he.jsx("div", { className: no.inputSeparator, children: "or" })
        ] }),
        /* @__PURE__ */ he.jsx(
          x2,
          {
            onSelectIssue: l,
            jiraInstanceUrl: i
          }
        )
      ] }),
      N ? /* @__PURE__ */ he.jsx(b, { justifyContent: "center", margin: "0 0 300 0", children: /* @__PURE__ */ he.jsx(sn, { "data-testid": "jira-widget-issue-spinner" }) }) : j?.length ? /* @__PURE__ */ he.jsx(
        qA,
        {
          issues: j,
          jiraInstanceUrl: i,
          unlinkIssue: m
        }
      ) : /* @__PURE__ */ he.jsx(F.Paragraph, { align: "center", className: no.noIssuesFound, children: "No linked issues found" }),
      $ && j?.length > 0 && /* @__PURE__ */ he.jsx(
        Qn,
        {
          variant: "secondary",
          disabled: !j?.length && !v?.length,
          onClick: u,
          children: "Unlink all issues"
        }
      ),
      I && /* @__PURE__ */ he.jsxs(
        b,
        {
          background: "neutral.100",
          padding: "300",
          borderRadius: "100",
          flexDirection: "column",
          gap: "200",
          children: [
            /* @__PURE__ */ he.jsx(F.Heading, { variant: "heading-3", children: "Unresolved linked issues" }),
            /* @__PURE__ */ he.jsx(b, { flexDirection: "row", flexWrap: "wrap", gap: "100", children: v.map((L) => /* @__PURE__ */ he.jsx(Jn, { onDelete: () => m(L), children: L }, L)) }),
            /* @__PURE__ */ he.jsx(
              Qn,
              {
                variant: "secondary",
                onClick: () => h(),
                icon: "link-slash",
                children: "Remove all unresolved issues"
              }
            )
          ]
        }
      ),
      /* @__PURE__ */ he.jsx(
        Et,
        {
          slotEnd: /* @__PURE__ */ he.jsx(fe, { name: "external-link" }),
          variant: "tertiary",
          className: no.buttonLink,
          navigate: () => {
            r("jira:view:jira:clicked", { jiraInstanceUrl: i }), window.open(i, "_blank")?.focus();
          },
          children: "Open Jira"
        }
      )
    ] }),
    a && /* @__PURE__ */ he.jsx(
      z2,
      {
        isOpen: a,
        onClose: () => o(!1),
        linkIssueQuietly: d,
        conversationContext: e,
        jiraInstanceUrl: i,
        hasSortIssueTypeByLabelEnabled: O
      }
    )
  ] });
}, jl = [
  {
    key: "jiraSiteUrl",
    label: "Jira site URL",
    type: "string",
    secret: !1,
    defaultValue: ""
  },
  {
    key: "enableRemoveAllLinks",
    label: 'Enable the "Remove all links" button',
    type: "boolean",
    secret: !1,
    defaultValue: !1
  },
  {
    key: "showDanglingLinks",
    label: "Show unresolved links to Jira issues",
    type: "boolean",
    secret: !1,
    defaultValue: !1
  },
  {
    key: "enableCreateIssue",
    label: 'Enable the "Create issue" button',
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "enableSortIssueTypeByLabel",
    label: "Enable to sort the issue types by label",
    type: "boolean",
    secret: !1,
    defaultValue: !1
  }
], Y2 = (e) => {
  const n = M2(e);
  return typeof n == "string" ? n : !0;
}, to = ar(jl), Ci = "JIRA", J2 = {
  enabled: !1,
  name: "",
  jiraSiteUrl: "",
  enableRemoveAllLinks: !1,
  showDanglingLinks: !1,
  enableCreateIssue: !0,
  enableSortIssueTypeByLabel: !1
}, Q2 = ({
  integrationId: e,
  configuration: n,
  handleRedirect: r,
  showNotification: i,
  automationCouplingState: a,
  renderConditionsEditor: o
}) => {
  const s = !e, l = ot({
    mode: "onChange",
    defaultValues: J2
  }), {
    create: d,
    update: m,
    remove: u,
    isLoading: f,
    error: h,
    misconfigurationCause: v,
    setMisconfigurationCause: w
  } = pr({
    integrationId: e,
    integrationType: Ci,
    handleRedirect: r,
    showNotification: i
  }), {
    isLoading: N,
    error: j,
    isWidgetUnknown: _,
    refetch: g,
    widgetConfiguration: O
  } = fr({
    integrationId: e,
    fieldDefinitions: jl,
    form: l,
    onMisconfigured: w
  }), { renderConditions: R, setRenderConditions: $, renderConditionsForSubmit: I } = hr({
    integrationId: e,
    widgetConfiguration: O,
    renderConditionsEditor: o
  }), L = (Q) => gr(Q, {
    fieldDefinitions: jl,
    isCreationMode: s,
    create: d,
    update: m,
    renderConditions: I
  }), G = l.watch("name");
  return /* @__PURE__ */ he.jsxs(
    yr,
    {
      form: l,
      integrationId: e,
      onValidSubmit: L,
      error: j ?? h,
      onRetry: j ? g : void 0,
      isLoading: f || N,
      isWidgetUnknown: _,
      children: [
        v && /* @__PURE__ */ he.jsx(vr, { cause: v }),
        /* @__PURE__ */ he.jsxs(et, { children: [
          /* @__PURE__ */ he.jsx(Z, { children: /* @__PURE__ */ he.jsx(qe, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ he.jsx(
            yn,
            {
              name: "enabled",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ he.jsx(Z, { span: 3, children: /* @__PURE__ */ he.jsx(
            Rn,
            {
              name: "name",
              label: "Widget name",
              control: l.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ he.jsx(Z, { span: 3 }),
          /* @__PURE__ */ he.jsx(Z, { span: 3, children: /* @__PURE__ */ he.jsx(
            Rn,
            {
              name: "jiraSiteUrl",
              label: to.jiraSiteUrl,
              control: l.control,
              rules: {
                validate: (Q) => Y2(Q)
              },
              componentProps: {
                placeholder: 'Insert your Jira site URL, e.g. "https://your-site.atlassian.net/"',
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ he.jsx(Z, { span: 3 }),
          /* @__PURE__ */ he.jsx(Z, { span: 3, children: /* @__PURE__ */ he.jsx(qe, { label: to.enableRemoveAllLinks, children: /* @__PURE__ */ he.jsx(
            yn,
            {
              name: "enableRemoveAllLinks",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ he.jsx(Z, { span: 3 }),
          /* @__PURE__ */ he.jsx(Z, { span: 3, children: /* @__PURE__ */ he.jsx(qe, { label: to.showDanglingLinks, children: /* @__PURE__ */ he.jsx(
            yn,
            {
              name: "showDanglingLinks",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ he.jsx(Z, { span: 3 }),
          /* @__PURE__ */ he.jsx(Z, { span: 3, children: /* @__PURE__ */ he.jsx(qe, { label: to.enableCreateIssue, children: /* @__PURE__ */ he.jsx(
            yn,
            {
              name: "enableCreateIssue",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ he.jsx(Z, { span: 3 }),
          /* @__PURE__ */ he.jsx(Z, { span: 3, children: /* @__PURE__ */ he.jsx(qe, { label: to.enableSortIssueTypeByLabel, children: /* @__PURE__ */ he.jsx(
            yn,
            {
              name: "enableSortIssueTypeByLabel",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ he.jsx(Z, { span: 3 }),
          !s && e && /* @__PURE__ */ he.jsx(
            bi,
            {
              configuration: n,
              integrationId: e,
              integrationType: Ci,
              label: "Authorize with OAuth"
            }
          ),
          o && R !== null && /* @__PURE__ */ he.jsx(Z, { children: o({
            value: R,
            onChange: $,
            configurationKey: O?.id
          }) })
        ] }),
        /* @__PURE__ */ he.jsx(
          kr,
          {
            integrationType: Ci,
            integrationId: e,
            widgetName: G,
            isCreationMode: s,
            isSubmitting: l.formState.isSubmitting,
            automationCouplingState: a,
            onConfirmDelete: () => u(),
            confirmDeleteVariant: "danger",
            deleteConfirmationBody: /* @__PURE__ */ he.jsxs(b, { gap: "400", children: [
              /* @__PURE__ */ he.jsx(
                fe,
                {
                  size: 24,
                  name: "exclamation-triangle-filled",
                  color: "red.500"
                }
              ),
              /* @__PURE__ */ he.jsxs(b, { gap: "200", flexDirection: "column", children: [
                /* @__PURE__ */ he.jsxs(F.Heading, { withMarginBottom: !0, children: [
                  "By deleting the ",
                  Ci,
                  " integration, all links between Dixa and ",
                  Ci,
                  " are also deleted."
                ] }),
                /* @__PURE__ */ he.jsxs(F.Paragraph, { children: [
                  "All data in ",
                  Ci,
                  " stays untouched."
                ] }),
                /* @__PURE__ */ he.jsxs(F.Paragraph, { children: [
                  "Are you sure you want to delete the ",
                  Ci,
                  " ",
                  'integration "',
                  G,
                  '"?'
                ] })
              ] })
            ] })
          }
        )
      ]
    }
  );
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode('@charset "UTF-8";._notificationText_1polx_1{color:var(--dixa-color-neutral-500)}._message_zrl8q_54{padding:var(--dixa-size-spacer-250);border-radius:var(--dixa-size-border-radius-100);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300)}._message_zrl8q_54:hover,._messageIsOpen_zrl8q_62{border-color:var(--dixa-color-neutral-400)}._messageHeader_zrl8q_65{cursor:pointer}._messageUnattended_zrl8q_68{text-decoration:line-through}._messageLabel_zrl8q_71{color:var(--dixa-typography-color-secondary)}._messageText_zrl8q_74{max-height:150px;overflow:scroll;padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-200);border:1px solid var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);overflow:auto}._messageText_zrl8q_74::-webkit-scrollbar{width:7px;height:7px}._messageText_zrl8q_74::-webkit-scrollbar-track{background-color:var(--dixa-color-neutral-000)}._messageText_zrl8q_74::-webkit-scrollbar-thumb{background-color:var(--dixa-color-neutral-400);border-radius:4px}._messageText_zrl8q_74::-webkit-scrollbar-thumb:hover{background-color:var(--dixa-color-neutral-500)}._list_ld0hf_1{padding:0}._listItem_ld0hf_4{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_ld0hf_4:last-child{border-bottom:none}._tagHover_kzbzk_1:hover{cursor:pointer;border-color:var(--dixa-color-neutral-400)}._channelUnsubscribed_kzbzk_6{color:var(--dixa-color-neutral-500)}._subscriptionError_1qhhx_1{color:var(--dixa-typography-color-error);font-size:var(--dixa-typography-size-200)}._settingsWrapper_eleyu_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);margin-bottom:var(--dixa-size-spacer-300)}')), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var xm = { exports: {} }, ro = {}, lx;
function X2() {
  if (lx) return ro;
  lx = 1;
  var e = He, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (v = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return ro.Fragment = r, ro.jsx = s, ro.jsxs = s, ro;
}
var Ss = {}, cx;
function Z2() {
  return cx || (cx = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = He, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), d = /* @__PURE__ */ Symbol.for("react.forward_ref"), m = /* @__PURE__ */ Symbol.for("react.suspense"), u = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), v = /* @__PURE__ */ Symbol.for("react.offscreen"), w = Symbol.iterator, N = "@@iterator";
    function j(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = w && t[w] || t[N];
      return typeof c == "function" ? c : null;
    }
    var _ = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          p[y - 1] = arguments[y];
        O("error", t, p);
      }
    }
    function O(t, c, p) {
      {
        var y = _.ReactDebugCurrentFrame, C = y.getStackAddendum();
        C !== "" && (c += "%s", p = p.concat([C]));
        var T = p.map(function(S) {
          return String(S);
        });
        T.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, T);
      }
    }
    var R = !1, $ = !1, I = !1, L = !1, G = !1, Q;
    Q = /* @__PURE__ */ Symbol.for("react.module.reference");
    function ne(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || G || t === a || t === m || t === u || L || t === v || R || $ || I || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Q || t.getModuleId !== void 0));
    }
    function q(t, c, p) {
      var y = t.displayName;
      if (y)
        return y;
      var C = c.displayName || c.name || "";
      return C !== "" ? p + "(" + C + ")" : p;
    }
    function Y(t) {
      return t.displayName || "Context";
    }
    function P(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return Y(c) + ".Consumer";
          case s:
            var p = t;
            return Y(p._context) + ".Provider";
          case d:
            return q(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : P(t.type) || "Memo";
          case h: {
            var C = t, T = C._payload, S = C._init;
            try {
              return P(S(T));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var B = Object.assign, ie = 0, je, pe, le, ge, V, be, Oe;
    function H() {
    }
    H.__reactDisabledLog = !0;
    function Ye() {
      {
        if (ie === 0) {
          je = console.log, pe = console.info, le = console.warn, ge = console.error, V = console.group, be = console.groupCollapsed, Oe = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: H,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ie++;
      }
    }
    function ln() {
      {
        if (ie--, ie === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: B({}, t, {
              value: je
            }),
            info: B({}, t, {
              value: pe
            }),
            warn: B({}, t, {
              value: le
            }),
            error: B({}, t, {
              value: ge
            }),
            group: B({}, t, {
              value: V
            }),
            groupCollapsed: B({}, t, {
              value: be
            }),
            groupEnd: B({}, t, {
              value: Oe
            })
          });
        }
        ie < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Ie = _.ReactCurrentDispatcher, Ue;
    function De(t, c, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (C) {
            var y = C.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Be = !1, Ae;
    {
      var Qe = typeof WeakMap == "function" ? WeakMap : Map;
      Ae = new Qe();
    }
    function Ee(t, c) {
      if (!t || Be)
        return "";
      {
        var p = Ae.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Be = !0;
      var C = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var T;
      T = Ie.current, Ie.current = null, Ye();
      try {
        if (c) {
          var S = function() {
            throw Error();
          };
          if (Object.defineProperty(S.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(S, []);
            } catch (re) {
              y = re;
            }
            Reflect.construct(t, [], S);
          } else {
            try {
              S.call();
            } catch (re) {
              y = re;
            }
            t.call(S.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (re) {
            y = re;
          }
          t();
        }
      } catch (re) {
        if (re && y && typeof re.stack == "string") {
          for (var x = re.stack.split(`
`), ee = y.stack.split(`
`), A = x.length - 1, M = ee.length - 1; A >= 1 && M >= 0 && x[A] !== ee[M]; )
            M--;
          for (; A >= 1 && M >= 0; A--, M--)
            if (x[A] !== ee[M]) {
              if (A !== 1 || M !== 1)
                do
                  if (A--, M--, M < 0 || x[A] !== ee[M]) {
                    var ue = `
` + x[A].replace(" at new ", " at ");
                    return t.displayName && ue.includes("<anonymous>") && (ue = ue.replace("<anonymous>", t.displayName)), typeof t == "function" && Ae.set(t, ue), ue;
                  }
                while (A >= 1 && M >= 0);
              break;
            }
        }
      } finally {
        Be = !1, Ie.current = T, ln(), Error.prepareStackTrace = C;
      }
      var ze = t ? t.displayName || t.name : "", Te = ze ? De(ze) : "";
      return typeof t == "function" && Ae.set(t, Te), Te;
    }
    function Me(t, c, p) {
      return Ee(t, !1);
    }
    function en(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function se(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ee(t, en(t));
      if (typeof t == "string")
        return De(t);
      switch (t) {
        case m:
          return De("Suspense");
        case u:
          return De("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Me(t.render);
          case f:
            return se(t.type, c, p);
          case h: {
            var y = t, C = y._payload, T = y._init;
            try {
              return se(T(C), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var ce = Object.prototype.hasOwnProperty, Se = {}, Ve = _.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, p = se(t.type, t._source, c ? c.type : null);
        Ve.setExtraStackFrame(p);
      } else
        Ve.setExtraStackFrame(null);
    }
    function kn(t, c, p, y, C) {
      {
        var T = Function.call.bind(ce);
        for (var S in t)
          if (T(t, S)) {
            var x = void 0;
            try {
              if (typeof t[S] != "function") {
                var ee = Error((y || "React class") + ": " + p + " type `" + S + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[S] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ee.name = "Invariant Violation", ee;
              }
              x = t[S](c, S, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (A) {
              x = A;
            }
            x && !(x instanceof Error) && (Pe(C), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, S, typeof x), Pe(null)), x instanceof Error && !(x.message in Se) && (Se[x.message] = !0, Pe(C), g("Failed %s type: %s", p, x.message), Pe(null));
          }
      }
    }
    var X = Array.isArray;
    function E(t) {
      return X(t);
    }
    function z(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function ae(t) {
      try {
        return de(t), !1;
      } catch {
        return !0;
      }
    }
    function de(t) {
      return "" + t;
    }
    function U(t) {
      if (ae(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", z(t)), de(t);
    }
    var J = _.ReactCurrentOwner, ve = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, we, Re;
    function rn(t) {
      if (ce.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function bn(t) {
      if (ce.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function an(t, c) {
      typeof t.ref == "string" && J.current;
    }
    function hn(t, c) {
      {
        var p = function() {
          we || (we = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function En(t, c) {
      {
        var p = function() {
          Re || (Re = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var _n = function(t, c, p, y, C, T, S) {
      var x = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: S,
        // Record the component responsible for creating this element.
        _owner: T
      };
      return x._store = {}, Object.defineProperty(x._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(x, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(x, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: C
      }), Object.freeze && (Object.freeze(x.props), Object.freeze(x)), x;
    };
    function Fn(t, c, p, y, C) {
      {
        var T, S = {}, x = null, ee = null;
        p !== void 0 && (U(p), x = "" + p), bn(c) && (U(c.key), x = "" + c.key), rn(c) && (ee = c.ref, an(c));
        for (T in c)
          ce.call(c, T) && !ve.hasOwnProperty(T) && (S[T] = c[T]);
        if (t && t.defaultProps) {
          var A = t.defaultProps;
          for (T in A)
            S[T] === void 0 && (S[T] = A[T]);
        }
        if (x || ee) {
          var M = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          x && hn(S, M), ee && En(S, M);
        }
        return _n(t, x, ee, C, y, J.current, S);
      }
    }
    var Ze = _.ReactCurrentOwner, gn = _.ReactDebugCurrentFrame;
    function Le(t) {
      if (t) {
        var c = t._owner, p = se(t.type, t._source, c ? c.type : null);
        gn.setExtraStackFrame(p);
      } else
        gn.setExtraStackFrame(null);
    }
    var dn;
    dn = !1;
    function un(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function Nn() {
      {
        if (Ze.current) {
          var t = P(Ze.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Bn(t) {
      return "";
    }
    var Sn = {};
    function An(t) {
      {
        var c = Nn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function vn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = An(c);
        if (Sn[p])
          return;
        Sn[p] = !0;
        var y = "";
        t && t._owner && t._owner !== Ze.current && (y = " It was passed a child from " + P(t._owner.type) + "."), Le(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Le(null);
      }
    }
    function xn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (E(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            un(y) && vn(y, c);
          }
        else if (un(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var C = j(t);
          if (typeof C == "function" && C !== t.entries)
            for (var T = C.call(t), S; !(S = T.next()).done; )
              un(S.value) && vn(S.value, c);
        }
      }
    }
    function Ln(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var y = P(c);
          kn(p, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !dn) {
          dn = !0;
          var C = P(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", C || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var y = c[p];
          if (y !== "children" && y !== "key") {
            Le(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Le(null);
            break;
          }
        }
        t.ref !== null && (Le(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Le(null));
      }
    }
    var Cn = {};
    function wn(t, c, p, y, C, T) {
      {
        var S = ne(t);
        if (!S) {
          var x = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (x += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ee = Bn();
          ee ? x += ee : x += Nn();
          var A;
          t === null ? A = "null" : E(t) ? A = "array" : t !== void 0 && t.$$typeof === n ? (A = "<" + (P(t.type) || "Unknown") + " />", x = " Did you accidentally export a JSX literal instead of a component?") : A = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", A, x);
        }
        var M = Fn(t, c, p, C, T);
        if (M == null)
          return M;
        if (S) {
          var ue = c.children;
          if (ue !== void 0)
            if (y)
              if (E(ue)) {
                for (var ze = 0; ze < ue.length; ze++)
                  xn(ue[ze], t);
                Object.freeze && Object.freeze(ue);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              xn(ue, t);
        }
        if (ce.call(c, "key")) {
          var Te = P(t), re = Object.keys(c).filter(function(Gn) {
            return Gn !== "key";
          }), mn = re.length > 0 ? "{key: someKey, " + re.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Cn[Te + mn]) {
            var Dn = re.length > 0 ? "{" + re.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, mn, Te, Dn, Te), Cn[Te + mn] = !0;
          }
        }
        return t === i ? Vn(M) : Ln(M), M;
      }
    }
    function zn(t, c, p) {
      return wn(t, c, p, !0);
    }
    function qn(t, c, p) {
      return wn(t, c, p, !1);
    }
    var Un = qn, Kn = zn;
    Ss.Fragment = i, Ss.jsx = Un, Ss.jsxs = Kn;
  })()), Ss;
}
var dx;
function eL() {
  return dx || (dx = 1, process.env.NODE_ENV === "production" ? xm.exports = X2() : xm.exports = Z2()), xm.exports;
}
var ke = eL();
function nL({
  query: e,
  options: n,
  delayMs: r
}) {
  const { useLazyQuery: i } = fn(), [a, o] = me([]), [s] = i(e, n), [l, d] = me(
    []
  );
  return Xe(() => () => {
    l.forEach((m) => window.clearTimeout(m));
  }, []), [async (m) => {
    const u = [];
    for (const [f, h] of m.entries()) {
      f !== 0 && await new Promise((w) => {
        const N = setTimeout(w, r);
        d([...l, N]);
      });
      const v = await s({
        variables: h
      });
      u.push(v);
    }
    o(u);
  }, a];
}
var o1 = /* @__PURE__ */ ((e) => (e.List = "list", e))(o1 || {}), iy = /* @__PURE__ */ ((e) => (e.Profile = "profile", e))(iy || {}), ay = /* @__PURE__ */ ((e) => (e.Subscribed = "SUBSCRIBED", e))(ay || {}), oy = /* @__PURE__ */ ((e) => (e.Unsubscribed = "UNSUBSCRIBED", e))(oy || {});
const tL = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, rL = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, iL = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "GetEventResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "timestamp" } }, { kind: "Field", name: { kind: "Name", value: "event_properties" } }] } }] } }] } }] }, aL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getLists" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_lists" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetListListResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "created" } }, { kind: "Field", name: { kind: "Name", value: "updated" } }] } }, { kind: "Field", name: { kind: "Name", value: "links" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "self" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "links" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "self" } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, oL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "subscribeProfileToChannel" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "attributes" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_mutationInput_bulk_subscribe_profiles_input_data_attributes_Input" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "relationships" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_mutationInput_bulk_subscribe_profiles_input_data_relationships_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "bulk_subscribe_profiles" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "data" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "type" }, value: { kind: "EnumValue", value: "profile_subscription_bulk_create_job" } }, { kind: "ObjectField", name: { kind: "Name", value: "attributes" }, value: { kind: "Variable", name: { kind: "Name", value: "attributes" } } }, { kind: "ObjectField", name: { kind: "Name", value: "relationships" }, value: { kind: "Variable", name: { kind: "Name", value: "relationships" } } }] } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, sL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "unsubscribeProfileByContact" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "attributes" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_mutationInput_bulk_unsubscribe_profiles_input_data_attributes_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "bulk_unsubscribe_profiles" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "data" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "type" }, value: { kind: "EnumValue", value: "profile_subscription_bulk_delete_job" } }, { kind: "ObjectField", name: { kind: "Name", value: "attributes" }, value: { kind: "Variable", name: { kind: "Name", value: "attributes" } } }] } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, lL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getEvents" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "receivedEmailEventsFilter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "openedEmailEventsFilter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "clickedEmailEventsFilter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "bouncedEmailEventsFilter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "receivedSmsEventsFilter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "pageSize" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_PositiveInt" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", alias: { kind: "Name", value: "receivedEmail" }, name: { kind: "Name", value: "get_events" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "receivedEmailEventsFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "EnumValue", value: "_datetime" } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "pageSize" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GetEventResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "openedEmail" }, name: { kind: "Name", value: "get_events" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "openedEmailEventsFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "EnumValue", value: "_datetime" } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "pageSize" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GetEventResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "clickedEmail" }, name: { kind: "Name", value: "get_events" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "clickedEmailEventsFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "EnumValue", value: "_datetime" } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "pageSize" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GetEventResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "bouncedEmail" }, name: { kind: "Name", value: "get_events" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "bouncedEmailEventsFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "EnumValue", value: "_datetime" } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "pageSize" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GetEventResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "receivedSms" }, name: { kind: "Name", value: "get_events" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "receivedSmsEventsFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "EnumValue", value: "_datetime" } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "pageSize" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GetEventResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "GetEventResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "timestamp" } }, { kind: "Field", name: { kind: "Name", value: "event_properties" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, cL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getFlowMessage" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "messageId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_flow_message" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "messageId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetFlowMessageEncodedResponseCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "definition" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_FlowEmail" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "preview_text" } }] } }] } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, dL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getMetrics" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_metrics" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetMetricResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, uL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getProfileByFilter" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "emailFilter" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "phoneNumberFilter" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "hasEmail" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "hasPhoneNumber" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", alias: { kind: "Name", value: "profileByEmail" }, name: { kind: "Name", value: "get_profiles" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "emailFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "IntValue", value: "1" } }], directives: [{ kind: "Directive", name: { kind: "Name", value: "include" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "if" }, value: { kind: "Variable", name: { kind: "Name", value: "hasEmail" } } }] }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetProfileResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "profileByPhoneNumber" }, name: { kind: "Name", value: "get_profiles" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "phoneNumberFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "IntValue", value: "1" } }], directives: [{ kind: "Directive", name: { kind: "Name", value: "include" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "if" }, value: { kind: "Variable", name: { kind: "Name", value: "hasPhoneNumber" } } }] }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetProfileResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, mL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getProfileById" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "profileId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_profile" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "profileId" } } }, { kind: "Argument", name: { kind: "Name", value: "fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_" }, value: { kind: "ListValue", values: [{ kind: "EnumValue", value: "subscriptions" }, { kind: "EnumValue", value: "properties" }, { kind: "EnumValue", value: "predictive_analytics" }] } }, { kind: "Argument", name: { kind: "Name", value: "additional_fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_" }, value: { kind: "ListValue", values: [{ kind: "EnumValue", value: "subscriptions" }, { kind: "EnumValue", value: "predictive_analytics" }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetProfileResponseCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "email" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "marketing" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "consent" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "sms" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "marketing" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "consent" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "properties" } }, { kind: "Field", name: { kind: "Name", value: "predictive_analytics" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "average_order_value" } }, { kind: "Field", name: { kind: "Name", value: "churn_probability" } }, { kind: "Field", name: { kind: "Name", value: "predicted_clv" } }, { kind: "Field", name: { kind: "Name", value: "historic_clv" } }, { kind: "Field", name: { kind: "Name", value: "total_clv" } }, { kind: "Field", name: { kind: "Name", value: "historic_number_of_orders" } }, { kind: "Field", name: { kind: "Name", value: "predicted_number_of_orders" } }, { kind: "Field", name: { kind: "Name", value: "average_days_between_orders" } }, { kind: "Field", name: { kind: "Name", value: "expected_date_of_next_order" } }, { kind: "Field", name: { kind: "Name", value: "ranked_channel_affinity" } }] } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, pL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getListsByProfileId" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "profileId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_lists_for_profile" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "profileId" } } }, { kind: "Argument", name: { kind: "Name", value: "fields_LEFT_SQUARE_BRACE_list_RIGHT_SQUARE_BRACE_" }, value: { kind: "ListValue", values: [{ kind: "EnumValue", value: "name" }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetListResponseCollection" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, fL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getSegmentsByProfileId" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "profileId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_segments_for_profile" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "profileId" } } }, { kind: "Argument", name: { kind: "Name", value: "fields_LEFT_SQUARE_BRACE_segment_RIGHT_SQUARE_BRACE_" }, value: { kind: "ListValue", values: [{ kind: "EnumValue", value: "name" }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetSegmentResponseCollection" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, hL = {
  "\n  query getLists {\n    Klaviyo {\n      get_lists {\n        ... on Klaviyo_GetListListResponseCollectionCompoundDocument {\n          data {\n            type\n            id\n            attributes {\n              name\n              created\n              updated\n            }\n            links {\n              self\n            }\n          }\n          links {\n            self\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": aL,
  "\n  fragment ClientErrorResponseFragment on Klaviyo_ClientError_response {\n    errors {\n      id\n      code\n      title\n      detail\n      source {\n        pointer\n        parameter\n      }\n    }\n  }\n": tL,
  "\n  fragment ServerErrorResponseFragment on Klaviyo_ServerError_response {\n    errors {\n      id\n      code\n      title\n      detail\n      source {\n        pointer\n        parameter\n      }\n    }\n  }\n": rL,
  "\n  mutation subscribeProfileToChannel(\n    $attributes: Klaviyo_mutationInput_bulk_subscribe_profiles_input_data_attributes_Input!\n    $relationships: Klaviyo_mutationInput_bulk_subscribe_profiles_input_data_relationships_Input!\n  ) {\n    Klaviyo {\n      bulk_subscribe_profiles(\n        input: {\n          data: {\n            type: profile_subscription_bulk_create_job\n            attributes: $attributes\n            relationships: $relationships\n          }\n        }\n      ) {\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": oL,
  "\n  mutation unsubscribeProfileByContact(\n    $attributes: Klaviyo_mutationInput_bulk_unsubscribe_profiles_input_data_attributes_Input!\n  ) {\n    Klaviyo {\n      bulk_unsubscribe_profiles(\n        input: {\n          data: {\n            type: profile_subscription_bulk_delete_job\n            attributes: $attributes\n          }\n        }\n      ) {\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": sL,
  "\n  fragment GetEventResponseFragment on Klaviyo_GetEventResponseCollectionCompoundDocument {\n    data {\n      id\n      type\n      attributes {\n        timestamp\n        event_properties\n      }\n    }\n  }\n": iL,
  "\n  query getEvents(\n    $receivedEmailEventsFilter: String!\n    $openedEmailEventsFilter: String!\n    $clickedEmailEventsFilter: String!\n    $bouncedEmailEventsFilter: String!\n    $receivedSmsEventsFilter: String!\n    $pageSize: Klaviyo_PositiveInt!\n  ) {\n    Klaviyo {\n      receivedEmail: get_events(\n        filter: $receivedEmailEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      openedEmail: get_events(\n        filter: $openedEmailEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      clickedEmail: get_events(\n        filter: $clickedEmailEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      bouncedEmail: get_events(\n        filter: $bouncedEmailEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      receivedSms: get_events(\n        filter: $receivedSmsEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": lL,
  "\n  query getFlowMessage($messageId: String!) {\n    Klaviyo {\n      get_flow_message(id: $messageId) {\n        ... on Klaviyo_GetFlowMessageEncodedResponseCompoundDocument {\n          data {\n            id\n            type\n            attributes {\n              definition {\n                ... on Klaviyo_FlowEmail {\n                  preview_text\n                }\n              }\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": cL,
  "\n  query getMetrics {\n    Klaviyo {\n      get_metrics {\n        ... on Klaviyo_GetMetricResponseCollectionCompoundDocument {\n          data {\n            id\n            attributes {\n              name\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": dL,
  "\n  query getProfileByFilter(\n    $emailFilter: String\n    $phoneNumberFilter: String\n    $hasEmail: Boolean!\n    $hasPhoneNumber: Boolean!\n  ) {\n    Klaviyo {\n      profileByEmail: get_profiles(\n        filter: $emailFilter\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: 1\n      ) @include(if: $hasEmail) {\n        ... on Klaviyo_GetProfileResponseCollectionCompoundDocument {\n          data {\n            id\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      profileByPhoneNumber: get_profiles(\n        filter: $phoneNumberFilter\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: 1\n      ) @include(if: $hasPhoneNumber) {\n        ... on Klaviyo_GetProfileResponseCollectionCompoundDocument {\n          data {\n            id\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": uL,
  "\n  query getProfileById($profileId: String!) {\n    Klaviyo {\n      get_profile(\n        id: $profileId\n        fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_: [\n          subscriptions\n          properties\n          predictive_analytics\n        ]\n        additional_fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_: [\n          subscriptions\n          predictive_analytics\n        ]\n      ) {\n        ... on Klaviyo_GetProfileResponseCompoundDocument {\n          data {\n            attributes {\n              subscriptions {\n                email {\n                  marketing {\n                    consent\n                  }\n                }\n                sms {\n                  marketing {\n                    consent\n                  }\n                }\n              }\n              properties\n              predictive_analytics {\n                average_order_value\n                churn_probability\n                predicted_clv\n                historic_clv\n                total_clv\n                historic_number_of_orders\n                predicted_number_of_orders\n                average_days_between_orders\n                expected_date_of_next_order\n                ranked_channel_affinity\n              }\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": mL,
  "\n  query getListsByProfileId($profileId: String!) {\n    Klaviyo {\n      get_lists_for_profile(\n        id: $profileId\n        fields_LEFT_SQUARE_BRACE_list_RIGHT_SQUARE_BRACE_: [name]\n      ) {\n        ... on Klaviyo_GetListResponseCollection {\n          data {\n            id\n            attributes {\n              name\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": pL,
  "\n  query getSegmentsByProfileId($profileId: String!) {\n    Klaviyo {\n      get_segments_for_profile(\n        id: $profileId\n        fields_LEFT_SQUARE_BRACE_segment_RIGHT_SQUARE_BRACE_: [name]\n      ) {\n        ... on Klaviyo_GetSegmentResponseCollection {\n          data {\n            id\n            attributes {\n              name\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": fL
};
function Jr(e) {
  return hL[e] ?? {};
}
const yL = Jr(
  /* GraphQL */
  `
  query getEvents(
    $receivedEmailEventsFilter: String!
    $openedEmailEventsFilter: String!
    $clickedEmailEventsFilter: String!
    $bouncedEmailEventsFilter: String!
    $receivedSmsEventsFilter: String!
    $pageSize: Klaviyo_PositiveInt!
  ) {
    Klaviyo {
      receivedEmail: get_events(
        filter: $receivedEmailEventsFilter
        sort: _datetime
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize
      ) {
        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {
          ...GetEventResponseFragment
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
      openedEmail: get_events(
        filter: $openedEmailEventsFilter
        sort: _datetime
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize
      ) {
        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {
          ...GetEventResponseFragment
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
      clickedEmail: get_events(
        filter: $clickedEmailEventsFilter
        sort: _datetime
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize
      ) {
        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {
          ...GetEventResponseFragment
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
      bouncedEmail: get_events(
        filter: $bouncedEmailEventsFilter
        sort: _datetime
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize
      ) {
        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {
          ...GetEventResponseFragment
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
      receivedSms: get_events(
        filter: $receivedSmsEventsFilter
        sort: _datetime
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize
      ) {
        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {
          ...GetEventResponseFragment
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), gL = Jr(
  /* GraphQL */
  `
  query getFlowMessage($messageId: String!) {
    Klaviyo {
      get_flow_message(id: $messageId) {
        ... on Klaviyo_GetFlowMessageEncodedResponseCompoundDocument {
          data {
            id
            type
            attributes {
              definition {
                ... on Klaviyo_FlowEmail {
                  preview_text
                }
              }
            }
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), vL = Jr(
  /* GraphQL */
  `
  query getMetrics {
    Klaviyo {
      get_metrics {
        ... on Klaviyo_GetMetricResponseCollectionCompoundDocument {
          data {
            id
            attributes {
              name
            }
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), kL = Jr(
  /* GraphQL */
  `
  query getProfileByFilter(
    $emailFilter: String
    $phoneNumberFilter: String
    $hasEmail: Boolean!
    $hasPhoneNumber: Boolean!
  ) {
    Klaviyo {
      profileByEmail: get_profiles(
        filter: $emailFilter
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: 1
      ) @include(if: $hasEmail) {
        ... on Klaviyo_GetProfileResponseCollectionCompoundDocument {
          data {
            id
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
      profileByPhoneNumber: get_profiles(
        filter: $phoneNumberFilter
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: 1
      ) @include(if: $hasPhoneNumber) {
        ... on Klaviyo_GetProfileResponseCollectionCompoundDocument {
          data {
            id
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), bL = Jr(
  /* GraphQL */
  `
  query getProfileById($profileId: String!) {
    Klaviyo {
      get_profile(
        id: $profileId
        fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_: [
          subscriptions
          properties
          predictive_analytics
        ]
        additional_fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_: [
          subscriptions
          predictive_analytics
        ]
      ) {
        ... on Klaviyo_GetProfileResponseCompoundDocument {
          data {
            attributes {
              subscriptions {
                email {
                  marketing {
                    consent
                  }
                }
                sms {
                  marketing {
                    consent
                  }
                }
              }
              properties
              predictive_analytics {
                average_order_value
                churn_probability
                predicted_clv
                historic_clv
                total_clv
                historic_number_of_orders
                predicted_number_of_orders
                average_days_between_orders
                expected_date_of_next_order
                ranked_channel_affinity
              }
            }
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), _L = Jr(
  /* GraphQL */
  `
  query getListsByProfileId($profileId: String!) {
    Klaviyo {
      get_lists_for_profile(
        id: $profileId
        fields_LEFT_SQUARE_BRACE_list_RIGHT_SQUARE_BRACE_: [name]
      ) {
        ... on Klaviyo_GetListResponseCollection {
          data {
            id
            attributes {
              name
            }
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), xL = Jr(
  /* GraphQL */
  `
  query getSegmentsByProfileId($profileId: String!) {
    Klaviyo {
      get_segments_for_profile(
        id: $profileId
        fields_LEFT_SQUARE_BRACE_segment_RIGHT_SQUARE_BRACE_: [name]
      ) {
        ... on Klaviyo_GetSegmentResponseCollection {
          data {
            id
            attributes {
              name
            }
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), SL = Jr(
  /* GraphQL */
  `
  mutation subscribeProfileToChannel(
    $attributes: Klaviyo_mutationInput_bulk_subscribe_profiles_input_data_attributes_Input!
    $relationships: Klaviyo_mutationInput_bulk_subscribe_profiles_input_data_relationships_Input!
  ) {
    Klaviyo {
      bulk_subscribe_profiles(
        input: {
          data: {
            type: profile_subscription_bulk_create_job
            attributes: $attributes
            relationships: $relationships
          }
        }
      ) {
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), NL = Jr(
  /* GraphQL */
  `
  mutation unsubscribeProfileByContact(
    $attributes: Klaviyo_mutationInput_bulk_unsubscribe_profiles_input_data_attributes_Input!
  ) {
    Klaviyo {
      bulk_unsubscribe_profiles(
        input: {
          data: {
            type: profile_subscription_bulk_delete_job
            attributes: $attributes
          }
        }
      ) {
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
);
function sy(e) {
  return e?.attributes?.event_properties?.$flow !== void 0;
}
function ux(e) {
  return sy(e) && e?.attributes?.event_properties?.$message;
}
function jL(e) {
  return e?.attributes?.event_properties?.["Bounce Type"] !== void 0;
}
function mx(e) {
  const n = e?.attributes?.timestamp;
  if (n)
    return n;
}
function wL(e) {
  return e.Klaviyo?.get_metrics?.__typename === "Klaviyo_GetMetricResponseCollectionCompoundDocument" && e.Klaviyo.get_metrics.data || [];
}
function CL(e) {
  return (e?.Klaviyo?.receivedEmail?.__typename === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.receivedEmail.data || [])?.map((n) => ({
    ...n,
    eventType: "EMAIL"
  }));
}
function FL(e) {
  return (e?.Klaviyo?.receivedSms?.__typename === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.receivedSms.data || [])?.map((n) => ({
    ...n,
    eventType: "SMS"
  }));
}
function IL(e) {
  return (e?.Klaviyo?.openedEmail?.__typename === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.openedEmail.data || [])?.map((n) => ({
    ...n,
    eventType: "EMAIL"
  }));
}
function $L(e) {
  return (e?.Klaviyo?.clickedEmail?.__typename === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.clickedEmail.data || [])?.map((n) => ({
    ...n,
    eventType: "EMAIL"
  }));
}
function EL(e) {
  return (e?.Klaviyo?.bouncedEmail?.__typename === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.bouncedEmail.data || [])?.map((n) => ({
    ...n,
    eventType: "EMAIL"
  }));
}
function px(e) {
  return e?.Klaviyo?.get_flow_message?.__typename === "Klaviyo_GetFlowMessageEncodedResponseCompoundDocument" && e.Klaviyo.get_flow_message.data || void 0;
}
function TL(e) {
  return e?.attributes?.definition?.__typename === "Klaviyo_FlowEmail" && e.attributes.definition.preview_text || void 0;
}
function RL(e) {
  try {
    return JSON.parse(JSON.stringify(e));
  } catch {
    return console.error(`Could not make a copy of ${JSON.stringify(e)}`), {};
  }
}
const DL = (e) => e.charAt(0).toUpperCase() + e.slice(1).toLowerCase();
function OL(e) {
  return e?.data?.attributes?.subscriptions?.email?.marketing?.consent === "SUBSCRIBED";
}
function PL(e) {
  return e?.data?.attributes?.subscriptions?.sms?.marketing?.consent === "SUBSCRIBED";
}
function AL({
  profileId: e,
  noOfMessagesToShow: n
}) {
  const { useLazyQuery: r, useQuery: i } = fn(), { track: a } = jn(), [o, s] = me(null), [l, d] = me(
    null
  ), [m, u] = me(null), [f, h] = me(null), [v, w] = me(
    null
  ), [N, j] = me([]), {
    data: _,
    error: g,
    loading: O,
    networkStatus: R
  } = i(vL, {
    /*
    	Since metrics should rarely be changed, query once when the client initializes
    	and then read from the cache for the subsequent queries.
    */
    fetchPolicy: "network-only",
    // Used for first execution
    nextFetchPolicy: "cache-first",
    // Used for subsequent executions
    notifyOnNetworkStatusChange: !0
  }), [
    $,
    {
      data: I,
      error: L,
      loading: G,
      networkStatus: Q
    }
  ] = r(yL, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0
  });
  return Xe(() => {
    if (_ && !O && R === ir.ready) {
      const ne = wL(_);
      s(
        ne.find((q) => q?.attributes?.name === "Received Email")?.id || null
      ), d(
        ne.find((q) => q?.attributes?.name === "Opened Email")?.id || null
      ), u(
        ne.find((q) => q?.attributes?.name === "Clicked Email")?.id || null
      ), h(
        ne.find((q) => q?.attributes?.name === "Bounced Email")?.id || null
      ), w(
        ne.find((q) => q?.attributes?.name === "Received SMS")?.id || null
      );
    } else
      s(null), d(null), u(null), h(null), w(null);
  }, [_]), Xe(() => {
    o && l && m && f && v && !G && Q === ir.ready ? $({
      variables: {
        receivedEmailEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${o}")`,
        openedEmailEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${l}")`,
        clickedEmailEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${m}")`,
        bouncedEmailEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${f}")`,
        receivedSmsEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${v}")`,
        pageSize: n
      }
    }) : j([]);
  }, [
    o,
    l,
    m,
    f,
    v
  ]), Xe(() => {
    if (!G && I) {
      const ne = CL(I), q = IL(
        I
      ).map(
        (pe) => pe?.attributes?.event_properties.$message
      ), Y = $L(
        I
      ).map(
        (pe) => pe?.attributes?.event_properties.$message
      );
      ne.forEach((pe) => {
        const le = pe.attributes?.event_properties.$message;
        pe.opened = q.includes(le), pe.clicked = Y.includes(le);
      });
      const P = FL(I), B = EL(I), ie = [
        ...ne,
        ...B,
        ...P
      ].sort((pe, le) => {
        const ge = mx(pe), V = mx(le);
        return ge == null && V == null ? 0 : ge == null ? 1 : V == null ? -1 : V - ge;
      }).slice(0, n);
      j(ie);
      const je = ie.map((pe) => pe.id);
      a("klaviyo:messages:received", {
        emailsReceived: ne.filter(
          (pe) => je.includes(pe.id)
        ).length,
        emailsBounced: B.filter(
          (pe) => je.includes(pe.id)
        ).length,
        smsReceived: P.filter(
          (pe) => je.includes(pe.id)
        ).length,
        total: je.length
      });
    } else
      j([]);
  }, [G, I]), Zn(
    () => ({
      receivedMessages: N,
      isLoading: O || G,
      error: g || L
    }),
    [
      N,
      O,
      G,
      g,
      L
    ]
  );
}
function LL({ profileId: e }) {
  const { useQuery: n } = fn(), [r, i] = me(), [a, o] = me(), {
    data: s,
    error: l,
    loading: d,
    refetch: m
  } = n(bL, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    variables: {
      profileId: e
    }
  });
  Xe(() => {
    l && o(l);
  }, [l]), Xe(() => {
    !d && s && i(s.Klaviyo.get_profile);
  }, [d, s]);
  const u = async () => {
    const f = await m();
    f.error ? o(f.error) : f.data && i(
      f.data.Klaviyo.get_profile
    );
  };
  return Zn(
    () => ({
      profile: r,
      refetchProfile: u,
      isLoading: d,
      error: a
    }),
    // No need to add `refetchProfile` as a dependency here
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [r, d, a]
  );
}
function VL({
  email: e,
  phoneNumber: n
}) {
  const { track: r } = jn(), { useLazyQuery: i } = fn(), [a, o] = me(), [s, l] = me(), [
    d,
    { data: m, error: u, loading: f }
  ] = i(kL, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0
  });
  Xe(() => {
    if (!f && m) {
      const v = m.Klaviyo?.profileByEmail?.__typename === "Klaviyo_GetProfileResponseCollectionCompoundDocument" && m.Klaviyo.profileByEmail || void 0, w = m.Klaviyo?.profileByPhoneNumber?.__typename === "Klaviyo_GetProfileResponseCollectionCompoundDocument" && m.Klaviyo.profileByPhoneNumber || void 0;
      h(v, w);
    }
  }, [f, m]);
  const h = (v, w) => {
    const N = v?.data?.length === 1 && v.data[0]?.id || void 0, j = w?.data?.length === 1 && w.data[0]?.id || void 0, _ = N || j, g = !N || !j || N === j;
    if (_ && g) {
      o(N || j), r("klaviyo:profile:received", { hasProfile: !0 });
      return;
    }
    o(void 0), r("klaviyo:profile:received", { hasProfile: !1 }), g || l(
      new Error(
        `Two different profiles were retrieved from Klaviyo for the email ${e} (profile ID ${N}) and phone number ${n} (profile ID ${j}).`
      )
    );
  };
  return Zn(
    () => ({
      profileId: a,
      getProfileId: d,
      isLoading: f,
      error: u || s
    }),
    [a, d, f, u, s]
  );
}
const fx = 800, zL = {
  min: 800,
  // 0.8 seconds
  max: 1200
  // 1.2 seconds
}, UL = 3, ML = 1.5, BL = ({
  query: e,
  delay: n,
  delayRange: r,
  maxCount: i = UL,
  useDelayRange: a = !1
}) => {
  const o = (L) => Math.floor(Math.random() * (L.max - L.min) + L.min), [s, l] = me(0), [d, m] = me(n || fx), [u, f] = me(r || zL), [h, v] = me(!1), [w, N] = me(!1), j = a || !!r, _ = j ? o(u) : n || fx, [g, O] = me(_);
  OO(
    async () => {
      const L = s + 1, G = ML ** L;
      l(L), O(
        (j ? o(u) : d) * G
      ), await e().then(() => {
        N(!0), I();
      });
    },
    h ? g : null
  ), AO(() => I());
  const R = pt(() => {
    l(0), O(_);
  }, [_]), $ = pt(
    (L = {}) => {
      const { delay: G, delayRange: Q } = L;
      N(!1), R(), Q && (f(Q), O(o(Q))), G && (m(G), O(G)), v(!0);
    },
    [R]
  ), I = pt(() => {
    v(!1), R();
  }, [R]);
  return Xe(() => {
    s >= i && I();
  }, [s, i, I]), Zn(
    () => ({ isRunning: h, isSuccessful: w, start: $, stop: I }),
    [h, w, $, I]
  );
}, qL = (e) => {
  const n = e.graphQLErrors[0]?.extensions.integration?.responseHeaders?.["retry-after"];
  return n ? parseInt(n, 10) : void 0;
}, HL = (e) => ({
  min: e * 1e3,
  max: e * 1e3 + 500
});
function WL({
  profileId: e,
  query: n
}) {
  const { useQuery: r } = fn(), [i, a] = me(), [o, s] = me(), {
    data: l,
    error: d,
    loading: m,
    refetch: u,
    networkStatus: f
  } = r(
    n === "lists" ? _L : xL,
    {
      fetchPolicy: "no-cache",
      notifyOnNetworkStatusChange: !0,
      variables: {
        profileId: e
      }
    }
  ), {
    isRunning: h,
    start: v,
    stop: w
  } = BL({
    query: u,
    useDelayRange: !0
  }), N = m || h;
  return Xe(() => {
    if (d)
      if (bI({
        errors: d.graphQLErrors
      })) {
        if (!h) {
          const j = qL(d);
          v({
            ...j && {
              delayRange: HL(j)
            }
          });
        }
      } else
        s(d);
  }, [d]), Xe(() => {
    if (!m && l?.Klaviyo) {
      let j = {}, _ = {};
      n === "lists" && (j = l?.Klaviyo?.get_lists_for_profile), n === "segments" && (_ = l?.Klaviyo?.get_segments_for_profile), (j?.data || _?.data) && (w(), a(
        (n === "lists" ? j?.data : _?.data)?.map((g) => ({
          ...g,
          type: n === "lists" ? "list" : "segment"
        }))
      ));
    }
  }, [m, l]), Zn(
    () => ({
      listsOrSegments: i,
      refetchListOrSegments: v,
      isLoading: N,
      error: o,
      networkStatus: f
    }),
    [i, N, o, f, v]
  );
}
const KL = "_notificationText_1polx_1", vg = {
  notificationText: KL
}, ic = ({ error: e }) => {
  const { track: n } = jn();
  let r = e;
  if (Ew(e)) {
    const i = e.graphQLErrors, a = i.length === 1 && xw({ error: i[0] }), o = i.length === 1 && vI({ error: i[0] });
    if (a)
      n("klaviyo:profile:failed", { reason: "Invalid access token" }), r = new Error(
        "It was not possible to retrieve data from Klaviyo due to an access issue. Please contact your administrator."
      );
    else if (o)
      n("klaviyo:profile:failed", { reason: "Insufficient permissions" }), r = new Error(
        "You don't have enough permissions to see Klaviyo profile data for this conversation. This is typically due to a misconfiguration of the Klaviyo integration."
      );
    else
      return n("klaviyo:profile:failed", { reason: "Unexpected error" }), /* @__PURE__ */ ke.jsx($n, { error: e });
  }
  return /* @__PURE__ */ ke.jsx(b, { margin: "0 0 300", children: /* @__PURE__ */ ke.jsx(
    Je.Item,
    {
      contentLeft: /* @__PURE__ */ ke.jsx(fe, { color: "red.500", size: 20, name: "exclamation-triangle-filled" }),
      titleSecondary: r.message,
      title: "Unable to show Klaviyo profile data",
      variant: "dense"
    }
  ) });
}, GL = "_message_zrl8q_54", YL = "_messageIsOpen_zrl8q_62", JL = "_messageHeader_zrl8q_65", QL = "_messageLabel_zrl8q_71", XL = "_messageText_zrl8q_74", ga = {
  message: GL,
  messageIsOpen: YL,
  messageHeader: JL,
  messageLabel: QL,
  messageText: XL
}, ZL = ({ event: e, isLoadingPreview: n }) => {
  const r = e?.attributes?.event_properties, i = e.flowMessage && TL(e.flowMessage);
  return /* @__PURE__ */ ke.jsxs(ke.Fragment, { children: [
    /* @__PURE__ */ ke.jsxs(b, { flexDirection: "column", justifyContent: "space-between", gap: "100", children: [
      /* @__PURE__ */ ke.jsx(F.Paragraph, { variant: "4", className: ga.messageLabel, children: "Campaign name" }),
      /* @__PURE__ */ ke.jsx(F.Paragraph, { children: r["Campaign Name"] })
    ] }),
    n ? /* @__PURE__ */ ke.jsx(b, { justifyContent: "center", margin: "100", children: /* @__PURE__ */ ke.jsx(sn, { size: 22 }) }) : i && i.length > 0 && /* @__PURE__ */ ke.jsxs(
      b,
      {
        flexDirection: "column",
        justifyContent: "space-between",
        gap: "100",
        children: [
          /* @__PURE__ */ ke.jsx(b, { children: /* @__PURE__ */ ke.jsx(
            F.Paragraph,
            {
              variant: "4",
              className: ga.messageLabel,
              children: "Preview text"
            }
          ) }),
          /* @__PURE__ */ ke.jsx(F.Paragraph, { variant: "4", className: ga.messageText, children: i })
        ]
      }
    )
  ] });
}, eV = ({ event: e }) => {
  const n = e?.attributes?.event_properties;
  return /* @__PURE__ */ ke.jsx(ke.Fragment, { children: /* @__PURE__ */ ke.jsxs(b, { flexDirection: "column", justifyContent: "space-between", gap: "100", children: [
    /* @__PURE__ */ ke.jsx(b, { children: /* @__PURE__ */ ke.jsx(F.Heading, { variant: "heading-4", children: "Message" }) }),
    /* @__PURE__ */ ke.jsx(b, { children: n?.extra?.["Message Body"] })
  ] }) });
}, nV = ({
  event: e,
  isLoadingPreview: n,
  openByDefault: r
}) => {
  const [i, a] = me(r), { attributes: o, eventType: s } = e, l = o?.datetime, d = o?.timestamp, m = "DD MMM YYYY @ HH:mm", u = Zn(
    () => () => l ? Wn(l).format(m) : d ? Wn.unix(d).format(m) : null,
    [d, l]
  )(), f = s === "EMAIL", h = s === "SMS", v = f && e.opened, w = f && e.clicked, N = f && o?.event_properties.Subject, j = h && o?.event_properties["Message Name"], _ = f ? "mail" : "sms";
  return /* @__PURE__ */ ke.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      className: ut(ga.message, {
        [ga.messageIsOpen]: i
      }),
      children: [
        /* @__PURE__ */ ke.jsxs(
          b,
          {
            alignItems: "center",
            justifyContent: "space-between",
            className: ga.messageHeader,
            onClick: () => a(!i),
            children: [
              /* @__PURE__ */ ke.jsxs(b, { gap: "100", flexDirection: "column", children: [
                /* @__PURE__ */ ke.jsxs(b, { gap: "200", alignItems: "center", children: [
                  /* @__PURE__ */ ke.jsx(fe, { size: 16, name: _ }),
                  " ",
                  DL(s),
                  u && /* @__PURE__ */ ke.jsx(Pn, { size: "small", variant: "info", children: u })
                ] }),
                N && N,
                j && j
              ] }),
              /* @__PURE__ */ ke.jsx(
                Xt,
                {
                  variant: "tertiary",
                  icon: i ? "angle-up" : "angle-down"
                }
              )
            ]
          }
        ),
        i && /* @__PURE__ */ ke.jsxs(b, { flexDirection: "column", gap: "300", children: [
          /* @__PURE__ */ ke.jsx(Wl, {}),
          jL(e) && /* @__PURE__ */ ke.jsx(b, { children: /* @__PURE__ */ ke.jsx(Pn, { size: "medium", variant: "error", children: "Bounced" }) }),
          f && /* @__PURE__ */ ke.jsxs(ke.Fragment, { children: [
            /* @__PURE__ */ ke.jsxs(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", children: [
              /* @__PURE__ */ ke.jsx(Jn, { children: /* @__PURE__ */ ke.jsxs(b, { alignItems: "center", gap: "200", children: [
                /* @__PURE__ */ ke.jsx(
                  fe,
                  {
                    size: 16,
                    color: v ? "green.400" : "red.400",
                    name: v ? "check-circle-filled" : "close-circle-filled"
                  }
                ),
                " ",
                "Opened"
              ] }) }),
              /* @__PURE__ */ ke.jsx(Jn, { children: /* @__PURE__ */ ke.jsxs(b, { alignItems: "center", gap: "200", children: [
                /* @__PURE__ */ ke.jsx(
                  fe,
                  {
                    size: 16,
                    color: w ? "green.400" : "red.400",
                    name: w ? "check-circle-filled" : "close-circle-filled"
                  }
                ),
                " ",
                "Clicked"
              ] }) })
            ] }),
            /* @__PURE__ */ ke.jsx(ZL, { event: e, isLoadingPreview: n })
          ] }),
          h && /* @__PURE__ */ ke.jsx(eV, { event: e })
        ] })
      ]
    }
  );
}, tV = {
  /*
  	Compiler needs this casting so as not to complain that the string literal 'no-cache'
  	is actually of type "FetchPolicy", which type is defined as one of many string values,
  	including 'no-cache'.
  */
  fetchPolicy: "no-cache",
  notifyOnNetworkStatusChange: !0
}, rV = ({
  profileId: e,
  noOfMessagesToShow: n
}) => {
  const [r, i] = me(!1), {
    receivedMessages: a,
    isLoading: o,
    error: s
  } = AL({
    profileId: e,
    noOfMessagesToShow: n
  }), [l, d] = nL({
    query: gL,
    options: tV,
    delayMs: 1e3
  }), [m, u] = me([]);
  Xe(() => {
    if (a.length > 0) {
      u(a);
      const h = a.filter((v) => sy(v)).map((v) => ux(v));
      h.length > 0 && (i(!0), l(
        h.map((v) => ({
          messageId: v
        }))
      ).finally(() => i(!1)));
    }
  }, [a]), Xe(() => {
    d.length > 0 && u(
      a?.map((h) => {
        if (h.eventType === "EMAIL" && sy(h) && !h.flowMessage) {
          const v = ux(h), w = d.find((j) => (j.data && px(j.data))?.id === v), N = w?.data && px(w.data);
          if (N)
            return {
              ...RL(h),
              flowMessage: N
            };
        }
        return h;
      })
    );
  }, [d]);
  const f = [];
  return s && f.push(s), d.length > 0 && f.push(
    ...d.map((h) => h.error).filter((h) => h)
  ), f && f.length > 0 ? /* @__PURE__ */ ke.jsx(ke.Fragment, { children: f.map((h, v) => h.graphQLErrors ? /* @__PURE__ */ ke.jsx(
    $n,
    {
      error: h
    },
    `lastMessagesError${v}`
  ) : /* @__PURE__ */ ke.jsx(
    ic,
    {
      error: h
    },
    `lastMessagesError${v}`
  )) }) : /* @__PURE__ */ ke.jsxs(ke.Fragment, { children: [
    /* @__PURE__ */ ke.jsx(F.Heading, { variant: "heading-3", children: "Messages" }),
    o ? /* @__PURE__ */ ke.jsx(b, { justifyContent: "center", margin: "0 0 300 0", children: /* @__PURE__ */ ke.jsx(sn, {}) }) : /* @__PURE__ */ ke.jsx(ke.Fragment, { children: m?.length > 0 ? /* @__PURE__ */ ke.jsx(b, { gap: "200", flexDirection: "column", children: m.map((h, v) => /* @__PURE__ */ ke.jsx(
      nV,
      {
        event: h,
        isLoadingPreview: r,
        openByDefault: v === 0
      },
      h.id
    )) }) : /* @__PURE__ */ ke.jsx(
      b,
      {
        justifyContent: "center",
        margin: "200",
        className: vg.notificationText,
        children: "No messages found for the profile"
      }
    ) })
  ] });
}, iV = "_list_ld0hf_1", aV = "_listItem_ld0hf_4", oi = {
  list: iV,
  listItem: aV
}, oV = ({
  profile: e
}) => {
  const n = e?.data?.attributes?.properties, r = Object.entries(
    n ?? {}
  ).filter(([a, o]) => a !== "__typename" && o != null), i = r.length > 0;
  return /* @__PURE__ */ ke.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ ke.jsx(F.Heading, { variant: "heading-3", children: "Custom properties" }),
    !i && /* @__PURE__ */ ke.jsx(F.Paragraph, { variant: "4", color: "secondary", align: "center", children: "No custom properties available" }),
    i && /* @__PURE__ */ ke.jsx(Je, { className: oi.list, children: r.map(([a, o]) => typeof o == "boolean" || typeof o == "string" || typeof o == "number" || Array.isArray(o) && o.every((s) => typeof s == "string") ? /* @__PURE__ */ ke.jsx(Je.Text, { variant: "dense", className: oi.listItem, children: /* @__PURE__ */ ke.jsxs(
      b,
      {
        justifyContent: "space-between",
        alignItems: "flex-start",
        gap: "200",
        children: [
          /* @__PURE__ */ ke.jsx(F.Paragraph, { variant: "4", children: kI(a) }),
          /* @__PURE__ */ ke.jsx(
            b,
            {
              style: { flex: 1, minWidth: 0 },
              justifyContent: "flex-end",
              children: qi(o)
            }
          )
        ]
      }
    ) }, a) : null) })
  ] });
}, hx = ({
  profileId: e,
  type: n
}) => {
  const [r, i] = me(!1), {
    listsOrSegments: a,
    error: o,
    isLoading: s,
    networkStatus: l,
    refetchListOrSegments: d
  } = WL({ profileId: e, query: n });
  Xe(() => {
    l === 4 && i(!0);
  }, [l]);
  const m = () => {
    a || d();
  }, u = a || [];
  return o ? /* @__PURE__ */ ke.jsx(ic, { error: o }) : s ? /* @__PURE__ */ ke.jsx(Je.Text, { variant: "dense", className: oi.listItem, children: /* @__PURE__ */ ke.jsx(sn, { size: 14 }) }, "loading") : u.length > 0 ? /* @__PURE__ */ ke.jsx(ke.Fragment, { children: u.map(
    ({ attributes: f, type: h }, v) => /* @__PURE__ */ ke.jsx(Je.Text, { variant: "dense", className: oi.listItem, children: /* @__PURE__ */ ke.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
      /* @__PURE__ */ ke.jsx(F.Paragraph, { variant: "4", children: f?.name }),
      !!h && /* @__PURE__ */ ke.jsx(Jn, { children: Sw(h) })
    ] }) }, v)
  ) }) : r && !a ? /* @__PURE__ */ ke.jsx(Je.Text, { variant: "dense", className: oi.listItem, children: /* @__PURE__ */ ke.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
    /* @__PURE__ */ ke.jsxs(b, { gap: "200", children: [
      /* @__PURE__ */ ke.jsx(fe, { name: "exclamation-triangle-filled", color: "red" }),
      /* @__PURE__ */ ke.jsxs(F.Paragraph, { variant: "4", color: "red.500", children: [
        n === "lists" ? "Lists" : "Segments",
        " could not be loaded"
      ] })
    ] }),
    /* @__PURE__ */ ke.jsx(Ge, { content: "Refresh lists and segments", children: /* @__PURE__ */ ke.jsx(Qn, { icon: "sync", variant: "secondary", onClick: () => m(), children: "Retry" }) })
  ] }) }, "refetch") : /* @__PURE__ */ ke.jsx(Je.Text, { variant: "dense", className: oi.listItem, children: /* @__PURE__ */ ke.jsx(b, { justifyContent: "space-between", alignItems: "center", children: /* @__PURE__ */ ke.jsx(F.Paragraph, { variant: "4", subdued: !0, children: /* @__PURE__ */ ke.jsx("i", { children: `No ${n === "lists" ? "lists" : "segments"} available` }) }) }) }, "refetch");
}, sV = 0.7, lV = 0.3, cV = (e) => e >= sV ? { variant: "error", label: "High risk" } : e >= lV ? { variant: "warning", label: "Medium risk" } : { variant: "success", label: "Low risk" }, dV = (e) => /* @__PURE__ */ ke.jsx(F.Paragraph, { as: "span", variant: "4", children: e.toFixed(2) }), uV = (e) => {
  const n = cV(e);
  return /* @__PURE__ */ ke.jsxs(b, { alignItems: "center", gap: "100", children: [
    /* @__PURE__ */ ke.jsx(Pn, { size: "small", variant: n.variant, children: n.label }),
    /* @__PURE__ */ ke.jsx(F.Paragraph, { as: "span", variant: "4", children: `${(e * 100).toFixed(1)}%` })
  ] });
}, mV = (e) => {
  const n = e?.data?.attributes?.predictive_analytics ?? null;
  if (!n)
    return [];
  const r = [
    ["Average order value", n.average_order_value],
    ["Historic lifetime value", n.historic_clv],
    ["Predicted lifetime value", n.predicted_clv],
    ["Total lifetime value", n.total_clv]
  ], i = [
    ["Historic orders", n.historic_number_of_orders],
    ["Predicted orders", n.predicted_number_of_orders],
    [
      "Average days between orders",
      n.average_days_between_orders
    ],
    ["Expected next order", n.expected_date_of_next_order]
  ], a = n.churn_probability, o = n.ranked_channel_affinity?.filter(Boolean) ?? null;
  return [
    ...r.flatMap(
      ([s, l]) => l ? [{ label: s, content: dV(l) }] : []
    ),
    ...i.flatMap(
      ([s, l]) => l ? [{ label: s, content: qi(l) }] : []
    ),
    ...a ? [
      {
        label: "Churn probability",
        content: uV(a)
      }
    ] : [],
    ...o?.length ? [
      {
        label: "Channel affinity",
        content: qi(o)
      }
    ] : []
  ];
}, pV = ({
  profile: e
}) => {
  const n = mV(e);
  return /* @__PURE__ */ ke.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ ke.jsx(F.Heading, { variant: "heading-3", children: "Predictive analytics" }),
    n.length === 0 && /* @__PURE__ */ ke.jsx(F.Paragraph, { variant: "4", color: "secondary", align: "center", children: "No predictive analytics available" }),
    n.length > 0 && /* @__PURE__ */ ke.jsx(Je, { className: oi.list, children: n.map(({ label: r, content: i }) => /* @__PURE__ */ ke.jsx(Je.Text, { variant: "dense", className: oi.listItem, children: /* @__PURE__ */ ke.jsxs(
      b,
      {
        justifyContent: "space-between",
        alignItems: "center",
        gap: "200",
        children: [
          /* @__PURE__ */ ke.jsx(F.Paragraph, { as: "span", variant: "4", children: r }),
          i
        ]
      }
    ) }, r)) })
  ] });
}, fV = "_tagHover_kzbzk_1", hV = "_channelUnsubscribed_kzbzk_6", yx = {
  tagHover: fV,
  channelUnsubscribed: hV
}, gx = ({
  isSubscribed: e,
  isLoading: n,
  channelName: r,
  channelIcon: i,
  hasReSubscriptionFeature: a,
  handleAction: o
}) => {
  const s = e ? "Unsubscribe" : "Subscribe", l = !e && !a;
  return /* @__PURE__ */ ke.jsx(
    Ge,
    {
      content: l ? "You have to select a resubscription list in the settings." : s,
      children: /* @__PURE__ */ ke.jsx(
        Jn,
        {
          className: yx.tagHover,
          color: e ? "green.500" : "neutral.200",
          children: /* @__PURE__ */ ke.jsxs(
            b,
            {
              "data-testid": `widget-preference-${e ? "subscribed" : "unsubscribed"}`,
              gap: "200",
              alignItems: "center",
              className: ut({
                [yx.channelUnsubscribed]: !e || l
              }),
              onClick: () => {
                l || o();
              },
              children: [
                n ? /* @__PURE__ */ ke.jsx(sn, { size: 16 }) : /* @__PURE__ */ ke.jsx(fe, { size: 16, name: i }),
                r
              ]
            }
          )
        }
      )
    }
  );
}, yV = "_subscriptionError_1qhhx_1", gV = {
  subscriptionError: yV
}, vV = ({
  subscriptionListId: e,
  profile: n,
  email: r,
  phoneNumber: i,
  profileId: a,
  refetchProfile: o
}) => {
  const [s, l] = me(!1), [d, m] = me(!1), [u, f] = me(), { track: h } = jn(), [v, w] = PO({
    channel: null,
    request: null
  }), N = OL(n), j = PL(n), _ = !!e, { useMutation: g } = fn(), [O] = g(
    SL
  ), [R] = g(
    NL
  ), $ = (G) => {
    h("klaviyo:profile:subscribe:clicked", { channel: G }), w.setAll({
      channel: G,
      request: "subscribed"
    }), ((Q) => O({
      variables: {
        attributes: {
          // eslint-disable-next-line camelcase
          custom_source: "Dixa integration",
          profiles: {
            data: [
              {
                type: iy.Profile,
                id: a,
                attributes: {
                  email: r,
                  // eslint-disable-next-line camelcase
                  ...i ? { phone_number: i } : {},
                  subscriptions: {
                    ...Q === "EMAIL" && {
                      email: {
                        marketing: {
                          consent: ay.Subscribed
                        }
                      }
                    },
                    ...Q === "SMS" && {
                      sms: {
                        marketing: {
                          consent: ay.Subscribed
                        }
                      }
                    }
                  }
                }
              }
            ]
          }
        },
        relationships: {
          list: {
            data: {
              type: o1.List,
              id: e
            }
          }
        }
      }
    }))(G).then(
      (Q) => L({
        channel: G,
        mutationResponse: Q,
        isSubscriptionRequest: !0
      })
    ).catch(
      (Q) => L({
        channel: G,
        mutationErrorResponse: Q,
        isSubscriptionRequest: !0
      })
    );
  }, I = (G) => {
    h("klaviyo:profile:unsubscribe:clicked", { channel: G }), w.setAll({
      channel: G,
      request: "unsubscribed"
    }), R({
      variables: {
        attributes: {
          profiles: {
            data: [
              {
                type: iy.Profile,
                attributes: {
                  ...G === "EMAIL" ? { email: r } : {},
                  // eslint-disable-next-line camelcase
                  ...G === "SMS" ? { phone_number: i } : {},
                  subscriptions: {
                    ...G === "EMAIL" && {
                      email: {
                        marketing: {
                          consent: oy.Unsubscribed
                        }
                      }
                    },
                    ...G === "SMS" && {
                      sms: {
                        marketing: {
                          consent: oy.Unsubscribed
                        }
                      }
                    }
                  }
                }
              }
            ]
          }
        }
      }
    }).then(
      (Q) => L({
        channel: G,
        mutationResponse: Q,
        isSubscriptionRequest: !1
      })
    ).catch(
      (Q) => L({
        channel: G,
        mutationErrorResponse: Q,
        isSubscriptionRequest: !1
      })
    );
  }, L = async ({
    channel: G,
    mutationResponse: Q,
    mutationErrorResponse: ne,
    isSubscriptionRequest: q
  }) => {
    const Y = ne?.networkError, P = Y ? Y?.statusCode : NaN, B = Q?.errors, ie = !!B && Nw({
      errors: B
    });
    P === 202 ? (h(
      q ? "klaviyo:profile:subscribe:succeeded" : "klaviyo:profile:unsubscribe:succeeded",
      { channel: G }
    ), await o()) : ie ? (h(
      q ? "klaviyo:profile:subscribe:failed" : "klaviyo:profile:unsubscribe:failed",
      {
        channel: G,
        reason: "Insufficient permissions"
      }
    ), f(
      `Request failed with a permission error. Could not ${q ? "opt-in" : "opt-out"}.`
    )) : (h(
      q ? "klaviyo:profile:subscribe:failed" : "klaviyo:profile:unsubscribe:failed",
      {
        channel: G,
        reason: Y?.message || "Unexpected error"
      }
    ), f(
      `Request failed. Could not ${q ? "opt-in" : "opt-out"}.`
    )), m(!1), l(!1);
  };
  return Xe(() => {
    if (v.request === "subscribed") {
      const G = `This subscription might be a double opt-in. The customer needs to check if they received a confirmation ${v.channel === "EMAIL" ? "email" : "sms"} to give consent.`;
      v.channel === "EMAIL" && !s && n?.data?.attributes?.subscriptions?.email?.marketing?.consent !== "SUBSCRIBED" && (f(G), w.reset()), v.channel === "SMS" && !d && n?.data?.attributes?.subscriptions?.sms?.marketing?.consent !== "SUBSCRIBED" && (f(G), w.reset());
    }
  }, [
    n?.data?.attributes?.subscriptions?.email?.marketing?.consent,
    n?.data?.attributes?.subscriptions?.sms?.marketing?.consent,
    s,
    d
  ]), /* @__PURE__ */ ke.jsx(
    b,
    {
      "data-testid": "subscription-channels",
      gap: "200",
      flexDirection: "column",
      children: /* @__PURE__ */ ke.jsxs(b, { gap: "200", flexDirection: "column", children: [
        /* @__PURE__ */ ke.jsx(F.Heading, { variant: "heading-3", children: "Subscription channels" }),
        /* @__PURE__ */ ke.jsxs(b, { gap: "100", flexDirection: "row", children: [
          /* @__PURE__ */ ke.jsx(
            gx,
            {
              "data-testid": "subscription-channels-email-button",
              isLoading: s,
              isSubscribed: N,
              channelName: "Email",
              channelIcon: "mail",
              hasReSubscriptionFeature: _,
              handleAction: () => {
                l(!0), f(void 0), N ? I("EMAIL") : $("EMAIL");
              }
            }
          ),
          /* @__PURE__ */ ke.jsx(
            gx,
            {
              "data-testid": "subscription-channels-sms-button",
              isLoading: d,
              isSubscribed: j,
              channelName: "Sms",
              channelIcon: "sms",
              hasReSubscriptionFeature: _,
              handleAction: () => {
                m(!0), f(void 0), j ? I("SMS") : $("SMS");
              }
            }
          )
        ] }),
        u && /* @__PURE__ */ ke.jsx(b, { className: gV.subscriptionError, children: u })
      ] })
    }
  );
}, kV = ({
  profileId: e,
  email: n,
  phoneNumber: r,
  showProfileLists: i,
  showProfileSegments: a,
  showSubscriptions: o,
  showCustomProperties: s,
  showPredictiveAnalytics: l,
  noOfMessagesToShow: d,
  subscriptionListId: m
}) => {
  const {
    profile: u,
    error: f,
    isLoading: h,
    refetchProfile: v
  } = LL({ profileId: e });
  return f ? /* @__PURE__ */ ke.jsx(ic, { error: f }) : h ? /* @__PURE__ */ ke.jsx(b, { justifyContent: "center", margin: "0 0 300 0", children: /* @__PURE__ */ ke.jsx(sn, {}) }) : !u && !h ? /* @__PURE__ */ ke.jsx(
    b,
    {
      justifyContent: "center",
      margin: "200",
      className: vg.notificationText,
      children: "No Klaviyo profile data found"
    }
  ) : /* @__PURE__ */ ke.jsxs(b, { flexDirection: "column", gap: "300", margin: "200 0 300", children: [
    (i || a) && /* @__PURE__ */ ke.jsxs(b, { gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ ke.jsx(F.Heading, { variant: "heading-3", children: "Lists & Segments" }),
      /* @__PURE__ */ ke.jsxs(Je, { className: oi.list, children: [
        i && /* @__PURE__ */ ke.jsx(hx, { profileId: e, type: "lists" }),
        a && /* @__PURE__ */ ke.jsx(
          hx,
          {
            profileId: e,
            type: "segments"
          }
        )
      ] })
    ] }),
    u && e && o && /* @__PURE__ */ ke.jsx(
      vV,
      {
        profile: u,
        profileId: e,
        subscriptionListId: m,
        refetchProfile: v,
        email: n,
        phoneNumber: r
      }
    ),
    u && l && /* @__PURE__ */ ke.jsx(pV, { profile: u }),
    u && s && /* @__PURE__ */ ke.jsx(oV, { profile: u }),
    /* @__PURE__ */ ke.jsx(
      rV,
      {
        profileId: e,
        noOfMessagesToShow: d
      }
    )
  ] });
}, bV = ({
  conversationContext: e,
  settings: n
}) => {
  const r = e.customer?.email || void 0, i = e.customer?.phone_number || void 0, a = n?.showProfileLists, o = n?.showProfileSegments, s = n?.showSubscriptions, l = n?.showCustomProperties, d = n?.showPredictiveAnalytics, m = Number(n?.noOfMessagesToShow), u = n?.subscriptionListId, {
    profileId: f,
    getProfileId: h,
    isLoading: v,
    error: w
  } = VL({ email: r, phoneNumber: i });
  return wI(() => {
    (r || i) && h({
      variables: {
        emailFilter: r ? `equals(email,"${r}")` : void 0,
        phoneNumberFilter: i ? `equals(phone_number,"${i}")` : void 0,
        hasEmail: !!r,
        hasPhoneNumber: !!i
      }
    });
  }, [r, i]), !r && !i ? /* @__PURE__ */ ke.jsx(b, { justifyContent: "center", margin: "0 0 300 0", children: "The customer does not have an email nor a phone number" }) : v ? /* @__PURE__ */ ke.jsx(b, { justifyContent: "center", margin: "0 0 300 0", children: /* @__PURE__ */ ke.jsx(sn, {}) }) : w ? /* @__PURE__ */ ke.jsx(ic, { error: w }) : f ? /* @__PURE__ */ ke.jsx(
    kV,
    {
      profileId: f,
      email: r,
      phoneNumber: i,
      showProfileLists: a,
      showProfileSegments: o,
      showSubscriptions: s,
      showCustomProperties: l,
      showPredictiveAnalytics: d,
      noOfMessagesToShow: m,
      subscriptionListId: u
    }
  ) : /* @__PURE__ */ ke.jsx(
    b,
    {
      justifyContent: "center",
      margin: "0 0 300 0",
      className: vg.notificationText,
      children: "No profile ID found"
    }
  );
}, ja = [
  {
    key: "klaviyoApiKey",
    label: "API key",
    type: "string",
    secret: !0,
    defaultValue: ""
  },
  {
    key: "showProfileLists",
    label: "Show Klaviyo lists for a profile",
    type: "boolean",
    secret: !1,
    defaultValue: !1
  },
  {
    key: "showProfileSegments",
    label: "Show Klaviyo segments for a profile",
    type: "boolean",
    secret: !1,
    defaultValue: !1
  },
  {
    key: "showSubscriptions",
    label: "Show subscription channels for Klaviyo messages",
    type: "boolean",
    secret: !1,
    defaultValue: !1
  },
  {
    key: "showCustomProperties",
    label: "Show custom properties for a profile",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showPredictiveAnalytics",
    label: "Show predictive analytics for a profile",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  // Populated by the subscribe-list selector; empty means the feature is off.
  {
    key: "subscriptionListId",
    label: "Re-/subscription list",
    type: "string",
    secret: !1,
    defaultValue: ""
  },
  {
    key: "noOfMessagesToShow",
    label: "Choose how many messages to show",
    type: "string",
    secret: !1,
    defaultValue: "5"
  }
], _V = [
  {
    key: "authorizeWithOauth",
    label: "Authorize with OAuth",
    secret: !1,
    type: "custom",
    hideOnCreate: !0,
    component: bi
  }
], xV = [
  {
    key: "klaviyoApiKey",
    label: "API key",
    placeholder: "API key from Klaviyo",
    required: !0,
    secret: !0,
    type: "input"
  }
], SV = ar(ja), vx = [
  { value: "3", label: "The three latest messages" },
  { value: "4", label: "The four latest messages" },
  { value: "5", label: "The five latest messages" }
], NV = ({
  control: e,
  name: n
}) => /* @__PURE__ */ ke.jsx(
  mr,
  {
    name: n,
    control: e,
    label: SV.noOfMessagesToShow,
    rules: { required: "Please choose how many messages to show" },
    componentProps: {
      placeholder: "Select an option",
      equalityFn: (r, i) => r === i,
      getItemTitleByValue: (r) => {
        const i = vx.find(
          (a) => a.value === r
        )?.label;
        return i ? /* @__PURE__ */ ke.jsx(F.Paragraph, { children: i }) : null;
      }
    },
    children: vx.map((r) => /* @__PURE__ */ ke.jsx(mt.Item, { value: r.value, children: r.label }, r.value))
  }
), jV = "_settingsWrapper_eleyu_1", wV = {
  settingsWrapper: jV
}, CV = Jr(
  /* GraphQL */
  `
  query getLists {
    Klaviyo {
      get_lists {
        ... on Klaviyo_GetListListResponseCollectionCompoundDocument {
          data {
            type
            id
            attributes {
              name
              created
              updated
            }
            links {
              self
            }
          }
          links {
            self
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), kx = [], FV = ({
  value: e,
  onChange: n
}) => {
  const { useQuery: r } = fn(), [i, a] = me(kx), [o, s] = me(!!e), {
    data: l,
    error: d,
    loading: m
  } = r(CV, {
    skip: !o,
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0
  });
  return Xe(() => {
    e && s(!0);
  }, [e]), Xe(() => {
    const u = l?.Klaviyo?.get_lists;
    if (o && u && !m && !d) {
      const f = u?.data?.map(
        (h) => ({
          value: h?.id,
          label: h?.attributes?.name
        })
      ) || kx;
      a(f);
    }
  }, [o, l, m, d]), /* @__PURE__ */ ke.jsxs(ke.Fragment, { children: [
    /* @__PURE__ */ ke.jsx(Z, { span: 3, children: /* @__PURE__ */ ke.jsxs(
      b,
      {
        gap: "300",
        flexDirection: "column",
        className: wV.settingsWrapper,
        children: [
          /* @__PURE__ */ ke.jsx(qe, { label: "Activate re-/subscription list selection", children: /* @__PURE__ */ ke.jsx(
            Cw,
            {
              input: {
                name: "subscriptionListId-switch",
                value: "switchValueFromComponent",
                checked: o,
                onChange: () => {
                  const u = !o;
                  u || n(""), s(u);
                }
              }
            }
          ) }),
          o && d && !m && /* @__PURE__ */ ke.jsx(qe, { children: /* @__PURE__ */ ke.jsx($n, { error: d }) }),
          o && !d && m && /* @__PURE__ */ ke.jsx(qe, { children: /* @__PURE__ */ ke.jsx(b, { justifyContent: "center", margin: "0 0 300 0", children: /* @__PURE__ */ ke.jsx(sn, {}) }) }),
          o && !d && !m && i && /* @__PURE__ */ ke.jsx(qe, { label: "Available lists to subscribe to", children: /* @__PURE__ */ ke.jsx(
            hi,
            {
              required: !0,
              placeholder: "Select a list",
              onChange: (u) => n(u?.selectedValues?.[0]?.value ?? ""),
              getItemTitleByValue: (u) => u ? /* @__PURE__ */ ke.jsx(F.Paragraph, { children: u.label }) : null,
              value: e ? [
                {
                  label: (i || []).find(
                    (u) => u.value === e
                  )?.label,
                  value: e
                }
              ] : [],
              equalityFn: (u, f) => u.value === f.value,
              children: i.map((u) => /* @__PURE__ */ ke.jsx(mt.Item, { value: u, children: u.label }, u.value))
            }
          ) })
        ]
      }
    ) }),
    /* @__PURE__ */ ke.jsx(Z, { span: 3 })
  ] });
}, ra = ar(ja), Sm = "KLAVIYO", IV = {
  enabled: !1,
  name: "",
  ...Jo(
    [],
    ja
  )
}, $V = ({
  integrationId: e,
  configuration: n,
  handleRedirect: r,
  showNotification: i,
  automationCouplingState: a,
  renderConditionsEditor: o
}) => {
  const s = !e, l = ot({
    mode: "onChange",
    defaultValues: IV
  }), {
    create: d,
    update: m,
    remove: u,
    isLoading: f,
    error: h,
    misconfigurationCause: v,
    setMisconfigurationCause: w
  } = pr({
    integrationId: e,
    integrationType: Sm,
    handleRedirect: r,
    showNotification: i
  }), {
    isLoading: N,
    error: j,
    isWidgetUnknown: _,
    refetch: g,
    widgetConfiguration: O
  } = fr({
    integrationId: e,
    fieldDefinitions: ja,
    form: l,
    onMisconfigured: w
  }), { renderConditions: R, setRenderConditions: $, renderConditionsForSubmit: I } = hr({
    integrationId: e,
    widgetConfiguration: O,
    renderConditionsEditor: o
  }), L = s || !!O?.additionalProperties?.isUsingOAuth, G = (ne) => gr(ne, {
    fieldDefinitions: ja,
    isCreationMode: s,
    create: d,
    update: m,
    renderConditions: I
  }), Q = l.watch("name");
  return /* @__PURE__ */ ke.jsxs(
    yr,
    {
      form: l,
      integrationId: e,
      onValidSubmit: G,
      error: j ?? h,
      onRetry: j ? g : void 0,
      isLoading: f || N,
      isWidgetUnknown: _,
      children: [
        v && /* @__PURE__ */ ke.jsx(vr, { cause: v }),
        /* @__PURE__ */ ke.jsxs(et, { children: [
          /* @__PURE__ */ ke.jsx(Z, { children: /* @__PURE__ */ ke.jsx(qe, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ ke.jsx(
            yn,
            {
              name: "enabled",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ ke.jsx(Z, { span: 3, children: /* @__PURE__ */ ke.jsx(
            Rn,
            {
              name: "name",
              label: "Widget name",
              control: l.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ ke.jsx(Z, { span: 3 }),
          !L && /* @__PURE__ */ ke.jsxs(ke.Fragment, { children: [
            /* @__PURE__ */ ke.jsx(Z, { span: 3, children: /* @__PURE__ */ ke.jsx(
              Er,
              {
                name: "klaviyoApiKey",
                label: ra.klaviyoApiKey,
                control: l.control,
                isCreationMode: s,
                rules: { required: "API key is required" },
                componentProps: {
                  placeholder: "API key from Klaviyo",
                  autoComplete: "off"
                }
              }
            ) }),
            /* @__PURE__ */ ke.jsx(Z, { span: 3 })
          ] }),
          /* @__PURE__ */ ke.jsx(Z, { span: 3, children: /* @__PURE__ */ ke.jsx(qe, { label: ra.showProfileLists, children: /* @__PURE__ */ ke.jsx(
            yn,
            {
              name: "showProfileLists",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ ke.jsx(Z, { span: 3 }),
          /* @__PURE__ */ ke.jsx(Z, { span: 3, children: /* @__PURE__ */ ke.jsx(qe, { label: ra.showProfileSegments, children: /* @__PURE__ */ ke.jsx(
            yn,
            {
              name: "showProfileSegments",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ ke.jsx(Z, { span: 3 }),
          /* @__PURE__ */ ke.jsx(Z, { span: 3, children: /* @__PURE__ */ ke.jsx(qe, { label: ra.showSubscriptions, children: /* @__PURE__ */ ke.jsx(
            yn,
            {
              name: "showSubscriptions",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ ke.jsx(Z, { span: 3 }),
          /* @__PURE__ */ ke.jsx(Z, { span: 3, children: /* @__PURE__ */ ke.jsx(qe, { label: ra.showCustomProperties, children: /* @__PURE__ */ ke.jsx(
            yn,
            {
              name: "showCustomProperties",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ ke.jsx(Z, { span: 3 }),
          /* @__PURE__ */ ke.jsx(Z, { span: 3, children: /* @__PURE__ */ ke.jsx(qe, { label: ra.showPredictiveAnalytics, children: /* @__PURE__ */ ke.jsx(
            yn,
            {
              name: "showPredictiveAnalytics",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ ke.jsx(Z, { span: 3 }),
          !s && /* @__PURE__ */ ke.jsx(
            jt,
            {
              name: "subscriptionListId",
              control: l.control,
              render: ({ field: ne }) => /* @__PURE__ */ ke.jsx(
                FV,
                {
                  value: ne.value,
                  onChange: ne.onChange
                }
              )
            }
          ),
          /* @__PURE__ */ ke.jsx(Z, { span: 3, children: /* @__PURE__ */ ke.jsx(
            NV,
            {
              name: "noOfMessagesToShow",
              control: l.control
            }
          ) }),
          /* @__PURE__ */ ke.jsx(Z, { span: 3 }),
          L && !s && e && /* @__PURE__ */ ke.jsx(
            bi,
            {
              configuration: n,
              integrationId: e,
              integrationType: Sm,
              label: "Authorize with OAuth"
            }
          ),
          o && R !== null && /* @__PURE__ */ ke.jsx(Z, { children: o({
            value: R,
            onChange: $,
            configurationKey: O?.id
          }) })
        ] }),
        /* @__PURE__ */ ke.jsx(
          kr,
          {
            integrationType: Sm,
            integrationId: e,
            widgetName: Q,
            isCreationMode: s,
            isSubmitting: l.formState.isSubmitting,
            automationCouplingState: a,
            onConfirmDelete: () => u()
          }
        )
      ]
    }
  );
};
function EV(e, n) {
  const r = {};
  return (e[e.length - 1] === "" ? [...e, ""] : e).join(
    (r.padRight ? " " : "") + "," + (r.padLeft === !1 ? "" : " ")
  ).trim();
}
const TV = /^[$_\p{ID_Start}][$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, RV = /^[$_\p{ID_Start}][-$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, DV = {};
function bx(e, n) {
  return (DV.jsx ? RV : TV).test(e);
}
const OV = /[ \t\n\f\r]/g;
function PV(e) {
  return typeof e == "object" ? e.type === "text" ? _x(e.value) : !1 : _x(e);
}
function _x(e) {
  return e.replace(OV, "") === "";
}
class is {
  /**
   * @constructor
   * @param {Properties} property
   * @param {Normal} normal
   * @param {string} [space]
   */
  constructor(n, r, i) {
    this.property = n, this.normal = r, i && (this.space = i);
  }
}
is.prototype.property = {};
is.prototype.normal = {};
is.prototype.space = null;
function s1(e, n) {
  const r = {}, i = {};
  let a = -1;
  for (; ++a < e.length; )
    Object.assign(r, e[a].property), Object.assign(i, e[a].normal);
  return new is(r, i, n);
}
function ly(e) {
  return e.toLowerCase();
}
class Nr {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   */
  constructor(n, r) {
    this.property = n, this.attribute = r;
  }
}
Nr.prototype.space = null;
Nr.prototype.boolean = !1;
Nr.prototype.booleanish = !1;
Nr.prototype.overloadedBoolean = !1;
Nr.prototype.number = !1;
Nr.prototype.commaSeparated = !1;
Nr.prototype.spaceSeparated = !1;
Nr.prototype.commaOrSpaceSeparated = !1;
Nr.prototype.mustUseProperty = !1;
Nr.prototype.defined = !1;
let AV = 0;
const Tn = Ji(), Nt = Ji(), l1 = Ji(), Ke = Ji(), lt = Ji(), va = Ji(), sr = Ji();
function Ji() {
  return 2 ** ++AV;
}
const cy = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  boolean: Tn,
  booleanish: Nt,
  commaOrSpaceSeparated: sr,
  commaSeparated: va,
  number: Ke,
  overloadedBoolean: l1,
  spaceSeparated: lt
}, Symbol.toStringTag, { value: "Module" })), Nm = Object.keys(cy);
class kg extends Nr {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   * @param {number|null} [mask]
   * @param {string} [space]
   */
  constructor(n, r, i, a) {
    let o = -1;
    if (super(n, r), xx(this, "space", a), typeof i == "number")
      for (; ++o < Nm.length; ) {
        const s = Nm[o];
        xx(this, Nm[o], (i & cy[s]) === cy[s]);
      }
  }
}
kg.prototype.defined = !0;
function xx(e, n, r) {
  r && (e[n] = r);
}
const LV = {}.hasOwnProperty;
function Pa(e) {
  const n = {}, r = {};
  let i;
  for (i in e.properties)
    if (LV.call(e.properties, i)) {
      const a = e.properties[i], o = new kg(
        i,
        e.transform(e.attributes || {}, i),
        a,
        e.space
      );
      e.mustUseProperty && e.mustUseProperty.includes(i) && (o.mustUseProperty = !0), n[i] = o, r[ly(i)] = i, r[ly(o.attribute)] = i;
    }
  return new is(n, r, e.space);
}
const c1 = Pa({
  space: "xlink",
  transform(e, n) {
    return "xlink:" + n.slice(5).toLowerCase();
  },
  properties: {
    xLinkActuate: null,
    xLinkArcRole: null,
    xLinkHref: null,
    xLinkRole: null,
    xLinkShow: null,
    xLinkTitle: null,
    xLinkType: null
  }
}), d1 = Pa({
  space: "xml",
  transform(e, n) {
    return "xml:" + n.slice(3).toLowerCase();
  },
  properties: { xmlLang: null, xmlBase: null, xmlSpace: null }
});
function u1(e, n) {
  return n in e ? e[n] : n;
}
function m1(e, n) {
  return u1(e, n.toLowerCase());
}
const p1 = Pa({
  space: "xmlns",
  attributes: { xmlnsxlink: "xmlns:xlink" },
  transform: m1,
  properties: { xmlns: null, xmlnsXLink: null }
}), f1 = Pa({
  transform(e, n) {
    return n === "role" ? n : "aria-" + n.slice(4).toLowerCase();
  },
  properties: {
    ariaActiveDescendant: null,
    ariaAtomic: Nt,
    ariaAutoComplete: null,
    ariaBusy: Nt,
    ariaChecked: Nt,
    ariaColCount: Ke,
    ariaColIndex: Ke,
    ariaColSpan: Ke,
    ariaControls: lt,
    ariaCurrent: null,
    ariaDescribedBy: lt,
    ariaDetails: null,
    ariaDisabled: Nt,
    ariaDropEffect: lt,
    ariaErrorMessage: null,
    ariaExpanded: Nt,
    ariaFlowTo: lt,
    ariaGrabbed: Nt,
    ariaHasPopup: null,
    ariaHidden: Nt,
    ariaInvalid: null,
    ariaKeyShortcuts: null,
    ariaLabel: null,
    ariaLabelledBy: lt,
    ariaLevel: Ke,
    ariaLive: null,
    ariaModal: Nt,
    ariaMultiLine: Nt,
    ariaMultiSelectable: Nt,
    ariaOrientation: null,
    ariaOwns: lt,
    ariaPlaceholder: null,
    ariaPosInSet: Ke,
    ariaPressed: Nt,
    ariaReadOnly: Nt,
    ariaRelevant: null,
    ariaRequired: Nt,
    ariaRoleDescription: lt,
    ariaRowCount: Ke,
    ariaRowIndex: Ke,
    ariaRowSpan: Ke,
    ariaSelected: Nt,
    ariaSetSize: Ke,
    ariaSort: null,
    ariaValueMax: Ke,
    ariaValueMin: Ke,
    ariaValueNow: Ke,
    ariaValueText: null,
    role: null
  }
}), VV = Pa({
  space: "html",
  attributes: {
    acceptcharset: "accept-charset",
    classname: "class",
    htmlfor: "for",
    httpequiv: "http-equiv"
  },
  transform: m1,
  mustUseProperty: ["checked", "multiple", "muted", "selected"],
  properties: {
    // Standard Properties.
    abbr: null,
    accept: va,
    acceptCharset: lt,
    accessKey: lt,
    action: null,
    allow: null,
    allowFullScreen: Tn,
    allowPaymentRequest: Tn,
    allowUserMedia: Tn,
    alt: null,
    as: null,
    async: Tn,
    autoCapitalize: null,
    autoComplete: lt,
    autoFocus: Tn,
    autoPlay: Tn,
    blocking: lt,
    capture: null,
    charSet: null,
    checked: Tn,
    cite: null,
    className: lt,
    cols: Ke,
    colSpan: null,
    content: null,
    contentEditable: Nt,
    controls: Tn,
    controlsList: lt,
    coords: Ke | va,
    crossOrigin: null,
    data: null,
    dateTime: null,
    decoding: null,
    default: Tn,
    defer: Tn,
    dir: null,
    dirName: null,
    disabled: Tn,
    download: l1,
    draggable: Nt,
    encType: null,
    enterKeyHint: null,
    fetchPriority: null,
    form: null,
    formAction: null,
    formEncType: null,
    formMethod: null,
    formNoValidate: Tn,
    formTarget: null,
    headers: lt,
    height: Ke,
    hidden: Tn,
    high: Ke,
    href: null,
    hrefLang: null,
    htmlFor: lt,
    httpEquiv: lt,
    id: null,
    imageSizes: null,
    imageSrcSet: null,
    inert: Tn,
    inputMode: null,
    integrity: null,
    is: null,
    isMap: Tn,
    itemId: null,
    itemProp: lt,
    itemRef: lt,
    itemScope: Tn,
    itemType: lt,
    kind: null,
    label: null,
    lang: null,
    language: null,
    list: null,
    loading: null,
    loop: Tn,
    low: Ke,
    manifest: null,
    max: null,
    maxLength: Ke,
    media: null,
    method: null,
    min: null,
    minLength: Ke,
    multiple: Tn,
    muted: Tn,
    name: null,
    nonce: null,
    noModule: Tn,
    noValidate: Tn,
    onAbort: null,
    onAfterPrint: null,
    onAuxClick: null,
    onBeforeMatch: null,
    onBeforePrint: null,
    onBeforeToggle: null,
    onBeforeUnload: null,
    onBlur: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onContextLost: null,
    onContextMenu: null,
    onContextRestored: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFormData: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLanguageChange: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadEnd: null,
    onLoadStart: null,
    onMessage: null,
    onMessageError: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRejectionHandled: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onScrollEnd: null,
    onSecurityPolicyViolation: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onSlotChange: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnhandledRejection: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onWheel: null,
    open: Tn,
    optimum: Ke,
    pattern: null,
    ping: lt,
    placeholder: null,
    playsInline: Tn,
    popover: null,
    popoverTarget: null,
    popoverTargetAction: null,
    poster: null,
    preload: null,
    readOnly: Tn,
    referrerPolicy: null,
    rel: lt,
    required: Tn,
    reversed: Tn,
    rows: Ke,
    rowSpan: Ke,
    sandbox: lt,
    scope: null,
    scoped: Tn,
    seamless: Tn,
    selected: Tn,
    shadowRootClonable: Tn,
    shadowRootDelegatesFocus: Tn,
    shadowRootMode: null,
    shape: null,
    size: Ke,
    sizes: null,
    slot: null,
    span: Ke,
    spellCheck: Nt,
    src: null,
    srcDoc: null,
    srcLang: null,
    srcSet: null,
    start: Ke,
    step: null,
    style: null,
    tabIndex: Ke,
    target: null,
    title: null,
    translate: null,
    type: null,
    typeMustMatch: Tn,
    useMap: null,
    value: Nt,
    width: Ke,
    wrap: null,
    writingSuggestions: null,
    // Legacy.
    // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
    align: null,
    // Several. Use CSS `text-align` instead,
    aLink: null,
    // `<body>`. Use CSS `a:active {color}` instead
    archive: lt,
    // `<object>`. List of URIs to archives
    axis: null,
    // `<td>` and `<th>`. Use `scope` on `<th>`
    background: null,
    // `<body>`. Use CSS `background-image` instead
    bgColor: null,
    // `<body>` and table elements. Use CSS `background-color` instead
    border: Ke,
    // `<table>`. Use CSS `border-width` instead,
    borderColor: null,
    // `<table>`. Use CSS `border-color` instead,
    bottomMargin: Ke,
    // `<body>`
    cellPadding: null,
    // `<table>`
    cellSpacing: null,
    // `<table>`
    char: null,
    // Several table elements. When `align=char`, sets the character to align on
    charOff: null,
    // Several table elements. When `char`, offsets the alignment
    classId: null,
    // `<object>`
    clear: null,
    // `<br>`. Use CSS `clear` instead
    code: null,
    // `<object>`
    codeBase: null,
    // `<object>`
    codeType: null,
    // `<object>`
    color: null,
    // `<font>` and `<hr>`. Use CSS instead
    compact: Tn,
    // Lists. Use CSS to reduce space between items instead
    declare: Tn,
    // `<object>`
    event: null,
    // `<script>`
    face: null,
    // `<font>`. Use CSS instead
    frame: null,
    // `<table>`
    frameBorder: null,
    // `<iframe>`. Use CSS `border` instead
    hSpace: Ke,
    // `<img>` and `<object>`
    leftMargin: Ke,
    // `<body>`
    link: null,
    // `<body>`. Use CSS `a:link {color: *}` instead
    longDesc: null,
    // `<frame>`, `<iframe>`, and `<img>`. Use an `<a>`
    lowSrc: null,
    // `<img>`. Use a `<picture>`
    marginHeight: Ke,
    // `<body>`
    marginWidth: Ke,
    // `<body>`
    noResize: Tn,
    // `<frame>`
    noHref: Tn,
    // `<area>`. Use no href instead of an explicit `nohref`
    noShade: Tn,
    // `<hr>`. Use background-color and height instead of borders
    noWrap: Tn,
    // `<td>` and `<th>`
    object: null,
    // `<applet>`
    profile: null,
    // `<head>`
    prompt: null,
    // `<isindex>`
    rev: null,
    // `<link>`
    rightMargin: Ke,
    // `<body>`
    rules: null,
    // `<table>`
    scheme: null,
    // `<meta>`
    scrolling: Nt,
    // `<frame>`. Use overflow in the child context
    standby: null,
    // `<object>`
    summary: null,
    // `<table>`
    text: null,
    // `<body>`. Use CSS `color` instead
    topMargin: Ke,
    // `<body>`
    valueType: null,
    // `<param>`
    version: null,
    // `<html>`. Use a doctype.
    vAlign: null,
    // Several. Use CSS `vertical-align` instead
    vLink: null,
    // `<body>`. Use CSS `a:visited {color}` instead
    vSpace: Ke,
    // `<img>` and `<object>`
    // Non-standard Properties.
    allowTransparency: null,
    autoCorrect: null,
    autoSave: null,
    disablePictureInPicture: Tn,
    disableRemotePlayback: Tn,
    prefix: null,
    property: null,
    results: Ke,
    security: null,
    unselectable: null
  }
}), zV = Pa({
  space: "svg",
  attributes: {
    accentHeight: "accent-height",
    alignmentBaseline: "alignment-baseline",
    arabicForm: "arabic-form",
    baselineShift: "baseline-shift",
    capHeight: "cap-height",
    className: "class",
    clipPath: "clip-path",
    clipRule: "clip-rule",
    colorInterpolation: "color-interpolation",
    colorInterpolationFilters: "color-interpolation-filters",
    colorProfile: "color-profile",
    colorRendering: "color-rendering",
    crossOrigin: "crossorigin",
    dataType: "datatype",
    dominantBaseline: "dominant-baseline",
    enableBackground: "enable-background",
    fillOpacity: "fill-opacity",
    fillRule: "fill-rule",
    floodColor: "flood-color",
    floodOpacity: "flood-opacity",
    fontFamily: "font-family",
    fontSize: "font-size",
    fontSizeAdjust: "font-size-adjust",
    fontStretch: "font-stretch",
    fontStyle: "font-style",
    fontVariant: "font-variant",
    fontWeight: "font-weight",
    glyphName: "glyph-name",
    glyphOrientationHorizontal: "glyph-orientation-horizontal",
    glyphOrientationVertical: "glyph-orientation-vertical",
    hrefLang: "hreflang",
    horizAdvX: "horiz-adv-x",
    horizOriginX: "horiz-origin-x",
    horizOriginY: "horiz-origin-y",
    imageRendering: "image-rendering",
    letterSpacing: "letter-spacing",
    lightingColor: "lighting-color",
    markerEnd: "marker-end",
    markerMid: "marker-mid",
    markerStart: "marker-start",
    navDown: "nav-down",
    navDownLeft: "nav-down-left",
    navDownRight: "nav-down-right",
    navLeft: "nav-left",
    navNext: "nav-next",
    navPrev: "nav-prev",
    navRight: "nav-right",
    navUp: "nav-up",
    navUpLeft: "nav-up-left",
    navUpRight: "nav-up-right",
    onAbort: "onabort",
    onActivate: "onactivate",
    onAfterPrint: "onafterprint",
    onBeforePrint: "onbeforeprint",
    onBegin: "onbegin",
    onCancel: "oncancel",
    onCanPlay: "oncanplay",
    onCanPlayThrough: "oncanplaythrough",
    onChange: "onchange",
    onClick: "onclick",
    onClose: "onclose",
    onCopy: "oncopy",
    onCueChange: "oncuechange",
    onCut: "oncut",
    onDblClick: "ondblclick",
    onDrag: "ondrag",
    onDragEnd: "ondragend",
    onDragEnter: "ondragenter",
    onDragExit: "ondragexit",
    onDragLeave: "ondragleave",
    onDragOver: "ondragover",
    onDragStart: "ondragstart",
    onDrop: "ondrop",
    onDurationChange: "ondurationchange",
    onEmptied: "onemptied",
    onEnd: "onend",
    onEnded: "onended",
    onError: "onerror",
    onFocus: "onfocus",
    onFocusIn: "onfocusin",
    onFocusOut: "onfocusout",
    onHashChange: "onhashchange",
    onInput: "oninput",
    onInvalid: "oninvalid",
    onKeyDown: "onkeydown",
    onKeyPress: "onkeypress",
    onKeyUp: "onkeyup",
    onLoad: "onload",
    onLoadedData: "onloadeddata",
    onLoadedMetadata: "onloadedmetadata",
    onLoadStart: "onloadstart",
    onMessage: "onmessage",
    onMouseDown: "onmousedown",
    onMouseEnter: "onmouseenter",
    onMouseLeave: "onmouseleave",
    onMouseMove: "onmousemove",
    onMouseOut: "onmouseout",
    onMouseOver: "onmouseover",
    onMouseUp: "onmouseup",
    onMouseWheel: "onmousewheel",
    onOffline: "onoffline",
    onOnline: "ononline",
    onPageHide: "onpagehide",
    onPageShow: "onpageshow",
    onPaste: "onpaste",
    onPause: "onpause",
    onPlay: "onplay",
    onPlaying: "onplaying",
    onPopState: "onpopstate",
    onProgress: "onprogress",
    onRateChange: "onratechange",
    onRepeat: "onrepeat",
    onReset: "onreset",
    onResize: "onresize",
    onScroll: "onscroll",
    onSeeked: "onseeked",
    onSeeking: "onseeking",
    onSelect: "onselect",
    onShow: "onshow",
    onStalled: "onstalled",
    onStorage: "onstorage",
    onSubmit: "onsubmit",
    onSuspend: "onsuspend",
    onTimeUpdate: "ontimeupdate",
    onToggle: "ontoggle",
    onUnload: "onunload",
    onVolumeChange: "onvolumechange",
    onWaiting: "onwaiting",
    onZoom: "onzoom",
    overlinePosition: "overline-position",
    overlineThickness: "overline-thickness",
    paintOrder: "paint-order",
    panose1: "panose-1",
    pointerEvents: "pointer-events",
    referrerPolicy: "referrerpolicy",
    renderingIntent: "rendering-intent",
    shapeRendering: "shape-rendering",
    stopColor: "stop-color",
    stopOpacity: "stop-opacity",
    strikethroughPosition: "strikethrough-position",
    strikethroughThickness: "strikethrough-thickness",
    strokeDashArray: "stroke-dasharray",
    strokeDashOffset: "stroke-dashoffset",
    strokeLineCap: "stroke-linecap",
    strokeLineJoin: "stroke-linejoin",
    strokeMiterLimit: "stroke-miterlimit",
    strokeOpacity: "stroke-opacity",
    strokeWidth: "stroke-width",
    tabIndex: "tabindex",
    textAnchor: "text-anchor",
    textDecoration: "text-decoration",
    textRendering: "text-rendering",
    transformOrigin: "transform-origin",
    typeOf: "typeof",
    underlinePosition: "underline-position",
    underlineThickness: "underline-thickness",
    unicodeBidi: "unicode-bidi",
    unicodeRange: "unicode-range",
    unitsPerEm: "units-per-em",
    vAlphabetic: "v-alphabetic",
    vHanging: "v-hanging",
    vIdeographic: "v-ideographic",
    vMathematical: "v-mathematical",
    vectorEffect: "vector-effect",
    vertAdvY: "vert-adv-y",
    vertOriginX: "vert-origin-x",
    vertOriginY: "vert-origin-y",
    wordSpacing: "word-spacing",
    writingMode: "writing-mode",
    xHeight: "x-height",
    // These were camelcased in Tiny. Now lowercased in SVG 2
    playbackOrder: "playbackorder",
    timelineBegin: "timelinebegin"
  },
  transform: u1,
  properties: {
    about: sr,
    accentHeight: Ke,
    accumulate: null,
    additive: null,
    alignmentBaseline: null,
    alphabetic: Ke,
    amplitude: Ke,
    arabicForm: null,
    ascent: Ke,
    attributeName: null,
    attributeType: null,
    azimuth: Ke,
    bandwidth: null,
    baselineShift: null,
    baseFrequency: null,
    baseProfile: null,
    bbox: null,
    begin: null,
    bias: Ke,
    by: null,
    calcMode: null,
    capHeight: Ke,
    className: lt,
    clip: null,
    clipPath: null,
    clipPathUnits: null,
    clipRule: null,
    color: null,
    colorInterpolation: null,
    colorInterpolationFilters: null,
    colorProfile: null,
    colorRendering: null,
    content: null,
    contentScriptType: null,
    contentStyleType: null,
    crossOrigin: null,
    cursor: null,
    cx: null,
    cy: null,
    d: null,
    dataType: null,
    defaultAction: null,
    descent: Ke,
    diffuseConstant: Ke,
    direction: null,
    display: null,
    dur: null,
    divisor: Ke,
    dominantBaseline: null,
    download: Tn,
    dx: null,
    dy: null,
    edgeMode: null,
    editable: null,
    elevation: Ke,
    enableBackground: null,
    end: null,
    event: null,
    exponent: Ke,
    externalResourcesRequired: null,
    fill: null,
    fillOpacity: Ke,
    fillRule: null,
    filter: null,
    filterRes: null,
    filterUnits: null,
    floodColor: null,
    floodOpacity: null,
    focusable: null,
    focusHighlight: null,
    fontFamily: null,
    fontSize: null,
    fontSizeAdjust: null,
    fontStretch: null,
    fontStyle: null,
    fontVariant: null,
    fontWeight: null,
    format: null,
    fr: null,
    from: null,
    fx: null,
    fy: null,
    g1: va,
    g2: va,
    glyphName: va,
    glyphOrientationHorizontal: null,
    glyphOrientationVertical: null,
    glyphRef: null,
    gradientTransform: null,
    gradientUnits: null,
    handler: null,
    hanging: Ke,
    hatchContentUnits: null,
    hatchUnits: null,
    height: null,
    href: null,
    hrefLang: null,
    horizAdvX: Ke,
    horizOriginX: Ke,
    horizOriginY: Ke,
    id: null,
    ideographic: Ke,
    imageRendering: null,
    initialVisibility: null,
    in: null,
    in2: null,
    intercept: Ke,
    k: Ke,
    k1: Ke,
    k2: Ke,
    k3: Ke,
    k4: Ke,
    kernelMatrix: sr,
    kernelUnitLength: null,
    keyPoints: null,
    // SEMI_COLON_SEPARATED
    keySplines: null,
    // SEMI_COLON_SEPARATED
    keyTimes: null,
    // SEMI_COLON_SEPARATED
    kerning: null,
    lang: null,
    lengthAdjust: null,
    letterSpacing: null,
    lightingColor: null,
    limitingConeAngle: Ke,
    local: null,
    markerEnd: null,
    markerMid: null,
    markerStart: null,
    markerHeight: null,
    markerUnits: null,
    markerWidth: null,
    mask: null,
    maskContentUnits: null,
    maskUnits: null,
    mathematical: null,
    max: null,
    media: null,
    mediaCharacterEncoding: null,
    mediaContentEncodings: null,
    mediaSize: Ke,
    mediaTime: null,
    method: null,
    min: null,
    mode: null,
    name: null,
    navDown: null,
    navDownLeft: null,
    navDownRight: null,
    navLeft: null,
    navNext: null,
    navPrev: null,
    navRight: null,
    navUp: null,
    navUpLeft: null,
    navUpRight: null,
    numOctaves: null,
    observer: null,
    offset: null,
    onAbort: null,
    onActivate: null,
    onAfterPrint: null,
    onBeforePrint: null,
    onBegin: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnd: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFocusIn: null,
    onFocusOut: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadStart: null,
    onMessage: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onMouseWheel: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRepeat: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onShow: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onZoom: null,
    opacity: null,
    operator: null,
    order: null,
    orient: null,
    orientation: null,
    origin: null,
    overflow: null,
    overlay: null,
    overlinePosition: Ke,
    overlineThickness: Ke,
    paintOrder: null,
    panose1: null,
    path: null,
    pathLength: Ke,
    patternContentUnits: null,
    patternTransform: null,
    patternUnits: null,
    phase: null,
    ping: lt,
    pitch: null,
    playbackOrder: null,
    pointerEvents: null,
    points: null,
    pointsAtX: Ke,
    pointsAtY: Ke,
    pointsAtZ: Ke,
    preserveAlpha: null,
    preserveAspectRatio: null,
    primitiveUnits: null,
    propagate: null,
    property: sr,
    r: null,
    radius: null,
    referrerPolicy: null,
    refX: null,
    refY: null,
    rel: sr,
    rev: sr,
    renderingIntent: null,
    repeatCount: null,
    repeatDur: null,
    requiredExtensions: sr,
    requiredFeatures: sr,
    requiredFonts: sr,
    requiredFormats: sr,
    resource: null,
    restart: null,
    result: null,
    rotate: null,
    rx: null,
    ry: null,
    scale: null,
    seed: null,
    shapeRendering: null,
    side: null,
    slope: null,
    snapshotTime: null,
    specularConstant: Ke,
    specularExponent: Ke,
    spreadMethod: null,
    spacing: null,
    startOffset: null,
    stdDeviation: null,
    stemh: null,
    stemv: null,
    stitchTiles: null,
    stopColor: null,
    stopOpacity: null,
    strikethroughPosition: Ke,
    strikethroughThickness: Ke,
    string: null,
    stroke: null,
    strokeDashArray: sr,
    strokeDashOffset: null,
    strokeLineCap: null,
    strokeLineJoin: null,
    strokeMiterLimit: Ke,
    strokeOpacity: Ke,
    strokeWidth: null,
    style: null,
    surfaceScale: Ke,
    syncBehavior: null,
    syncBehaviorDefault: null,
    syncMaster: null,
    syncTolerance: null,
    syncToleranceDefault: null,
    systemLanguage: sr,
    tabIndex: Ke,
    tableValues: null,
    target: null,
    targetX: Ke,
    targetY: Ke,
    textAnchor: null,
    textDecoration: null,
    textRendering: null,
    textLength: null,
    timelineBegin: null,
    title: null,
    transformBehavior: null,
    type: null,
    typeOf: sr,
    to: null,
    transform: null,
    transformOrigin: null,
    u1: null,
    u2: null,
    underlinePosition: Ke,
    underlineThickness: Ke,
    unicode: null,
    unicodeBidi: null,
    unicodeRange: null,
    unitsPerEm: Ke,
    values: null,
    vAlphabetic: Ke,
    vMathematical: Ke,
    vectorEffect: null,
    vHanging: Ke,
    vIdeographic: Ke,
    version: null,
    vertAdvY: Ke,
    vertOriginX: Ke,
    vertOriginY: Ke,
    viewBox: null,
    viewTarget: null,
    visibility: null,
    width: null,
    widths: null,
    wordSpacing: null,
    writingMode: null,
    x: null,
    x1: null,
    x2: null,
    xChannelSelector: null,
    xHeight: Ke,
    y: null,
    y1: null,
    y2: null,
    yChannelSelector: null,
    z: null,
    zoomAndPan: null
  }
}), UV = /^data[-\w.:]+$/i, Sx = /-[a-z]/g, MV = /[A-Z]/g;
function BV(e, n) {
  const r = ly(n);
  let i = n, a = Nr;
  if (r in e.normal)
    return e.property[e.normal[r]];
  if (r.length > 4 && r.slice(0, 4) === "data" && UV.test(n)) {
    if (n.charAt(4) === "-") {
      const o = n.slice(5).replace(Sx, HV);
      i = "data" + o.charAt(0).toUpperCase() + o.slice(1);
    } else {
      const o = n.slice(4);
      if (!Sx.test(o)) {
        let s = o.replace(MV, qV);
        s.charAt(0) !== "-" && (s = "-" + s), n = "data" + s;
      }
    }
    a = kg;
  }
  return new a(i, n);
}
function qV(e) {
  return "-" + e.toLowerCase();
}
function HV(e) {
  return e.charAt(1).toUpperCase();
}
const WV = {
  classId: "classID",
  dataType: "datatype",
  itemId: "itemID",
  strokeDashArray: "strokeDasharray",
  strokeDashOffset: "strokeDashoffset",
  strokeLineCap: "strokeLinecap",
  strokeLineJoin: "strokeLinejoin",
  strokeMiterLimit: "strokeMiterlimit",
  typeOf: "typeof",
  xLinkActuate: "xlinkActuate",
  xLinkArcRole: "xlinkArcrole",
  xLinkHref: "xlinkHref",
  xLinkRole: "xlinkRole",
  xLinkShow: "xlinkShow",
  xLinkTitle: "xlinkTitle",
  xLinkType: "xlinkType",
  xmlnsXLink: "xmlnsXlink"
}, KV = s1([d1, c1, p1, f1, VV], "html"), bg = s1([d1, c1, p1, f1, zV], "svg");
function GV(e) {
  return e.join(" ").trim();
}
var ia = {}, jm, Nx;
function YV() {
  if (Nx) return jm;
  Nx = 1;
  var e = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g, n = /\n/g, r = /^\s*/, i = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/, a = /^:\s*/, o = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/, s = /^[;\s]*/, l = /^\s+|\s+$/g, d = `
`, m = "/", u = "*", f = "", h = "comment", v = "declaration";
  jm = function(N, j) {
    if (typeof N != "string")
      throw new TypeError("First argument must be a string");
    if (!N) return [];
    j = j || {};
    var _ = 1, g = 1;
    function O(P) {
      var B = P.match(n);
      B && (_ += B.length);
      var ie = P.lastIndexOf(d);
      g = ~ie ? P.length - ie : g + P.length;
    }
    function R() {
      var P = { line: _, column: g };
      return function(B) {
        return B.position = new $(P), G(), B;
      };
    }
    function $(P) {
      this.start = P, this.end = { line: _, column: g }, this.source = j.source;
    }
    $.prototype.content = N;
    function I(P) {
      var B = new Error(
        j.source + ":" + _ + ":" + g + ": " + P
      );
      if (B.reason = P, B.filename = j.source, B.line = _, B.column = g, B.source = N, !j.silent) throw B;
    }
    function L(P) {
      var B = P.exec(N);
      if (B) {
        var ie = B[0];
        return O(ie), N = N.slice(ie.length), B;
      }
    }
    function G() {
      L(r);
    }
    function Q(P) {
      var B;
      for (P = P || []; B = ne(); )
        B !== !1 && P.push(B);
      return P;
    }
    function ne() {
      var P = R();
      if (!(m != N.charAt(0) || u != N.charAt(1))) {
        for (var B = 2; f != N.charAt(B) && (u != N.charAt(B) || m != N.charAt(B + 1)); )
          ++B;
        if (B += 2, f === N.charAt(B - 1))
          return I("End of comment missing");
        var ie = N.slice(2, B - 2);
        return g += 2, O(ie), N = N.slice(B), g += 2, P({
          type: h,
          comment: ie
        });
      }
    }
    function q() {
      var P = R(), B = L(i);
      if (B) {
        if (ne(), !L(a)) return I("property missing ':'");
        var ie = L(o), je = P({
          type: v,
          property: w(B[0].replace(e, f)),
          value: ie ? w(ie[0].replace(e, f)) : f
        });
        return L(s), je;
      }
    }
    function Y() {
      var P = [];
      Q(P);
      for (var B; B = q(); )
        B !== !1 && (P.push(B), Q(P));
      return P;
    }
    return G(), Y();
  };
  function w(N) {
    return N ? N.replace(l, f) : f;
  }
  return jm;
}
var jx;
function JV() {
  if (jx) return ia;
  jx = 1;
  var e = ia && ia.__importDefault || function(i) {
    return i && i.__esModule ? i : { default: i };
  };
  Object.defineProperty(ia, "__esModule", { value: !0 }), ia.default = r;
  var n = e(YV());
  function r(i, a) {
    var o = null;
    if (!i || typeof i != "string")
      return o;
    var s = (0, n.default)(i), l = typeof a == "function";
    return s.forEach(function(d) {
      if (d.type === "declaration") {
        var m = d.property, u = d.value;
        l ? a(m, u, d) : u && (o = o || {}, o[m] = u);
      }
    }), o;
  }
  return ia;
}
var QV = JV();
const wx = /* @__PURE__ */ Dy(QV), XV = wx.default || wx, h1 = y1("end"), _g = y1("start");
function y1(e) {
  return n;
  function n(r) {
    const i = r && r.position && r.position[e] || {};
    if (typeof i.line == "number" && i.line > 0 && typeof i.column == "number" && i.column > 0)
      return {
        line: i.line,
        column: i.column,
        offset: typeof i.offset == "number" && i.offset > -1 ? i.offset : void 0
      };
  }
}
function ZV(e) {
  const n = _g(e), r = h1(e);
  if (n && r)
    return { start: n, end: r };
}
function Ro(e) {
  return !e || typeof e != "object" ? "" : "position" in e || "type" in e ? Cx(e.position) : "start" in e || "end" in e ? Cx(e) : "line" in e || "column" in e ? dy(e) : "";
}
function dy(e) {
  return Fx(e && e.line) + ":" + Fx(e && e.column);
}
function Cx(e) {
  return dy(e && e.start) + "-" + dy(e && e.end);
}
function Fx(e) {
  return e && typeof e == "number" ? e : 1;
}
class qt extends Error {
  /**
   * Create a message for `reason`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {Options | null | undefined} [options]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | Options | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns
   *   Instance of `VFileMessage`.
   */
  // eslint-disable-next-line complexity
  constructor(n, r, i) {
    super(), typeof r == "string" && (i = r, r = void 0);
    let a = "", o = {}, s = !1;
    if (r && ("line" in r && "column" in r ? o = { place: r } : "start" in r && "end" in r ? o = { place: r } : "type" in r ? o = {
      ancestors: [r],
      place: r.position
    } : o = { ...r }), typeof n == "string" ? a = n : !o.cause && n && (s = !0, a = n.message, o.cause = n), !o.ruleId && !o.source && typeof i == "string") {
      const d = i.indexOf(":");
      d === -1 ? o.ruleId = i : (o.source = i.slice(0, d), o.ruleId = i.slice(d + 1));
    }
    if (!o.place && o.ancestors && o.ancestors) {
      const d = o.ancestors[o.ancestors.length - 1];
      d && (o.place = d.position);
    }
    const l = o.place && "start" in o.place ? o.place.start : o.place;
    this.ancestors = o.ancestors || void 0, this.cause = o.cause || void 0, this.column = l ? l.column : void 0, this.fatal = void 0, this.file, this.message = a, this.line = l ? l.line : void 0, this.name = Ro(o.place) || "1:1", this.place = o.place || void 0, this.reason = this.message, this.ruleId = o.ruleId || void 0, this.source = o.source || void 0, this.stack = s && o.cause && typeof o.cause.stack == "string" ? o.cause.stack : "", this.actual, this.expected, this.note, this.url;
  }
}
qt.prototype.file = "";
qt.prototype.name = "";
qt.prototype.reason = "";
qt.prototype.message = "";
qt.prototype.stack = "";
qt.prototype.column = void 0;
qt.prototype.line = void 0;
qt.prototype.ancestors = void 0;
qt.prototype.cause = void 0;
qt.prototype.fatal = void 0;
qt.prototype.place = void 0;
qt.prototype.ruleId = void 0;
qt.prototype.source = void 0;
const xg = {}.hasOwnProperty, e3 = /* @__PURE__ */ new Map(), n3 = /[A-Z]/g, t3 = /-([a-z])/g, r3 = /* @__PURE__ */ new Set(["table", "tbody", "thead", "tfoot", "tr"]), i3 = /* @__PURE__ */ new Set(["td", "th"]), g1 = "https://github.com/syntax-tree/hast-util-to-jsx-runtime";
function a3(e, n) {
  if (!n || n.Fragment === void 0)
    throw new TypeError("Expected `Fragment` in options");
  const r = n.filePath || void 0;
  let i;
  if (n.development) {
    if (typeof n.jsxDEV != "function")
      throw new TypeError(
        "Expected `jsxDEV` in options when `development: true`"
      );
    i = p3(r, n.jsxDEV);
  } else {
    if (typeof n.jsx != "function")
      throw new TypeError("Expected `jsx` in production options");
    if (typeof n.jsxs != "function")
      throw new TypeError("Expected `jsxs` in production options");
    i = m3(r, n.jsx, n.jsxs);
  }
  const a = {
    Fragment: n.Fragment,
    ancestors: [],
    components: n.components || {},
    create: i,
    elementAttributeNameCase: n.elementAttributeNameCase || "react",
    evaluater: n.createEvaluater ? n.createEvaluater() : void 0,
    filePath: r,
    ignoreInvalidStyle: n.ignoreInvalidStyle || !1,
    passKeys: n.passKeys !== !1,
    passNode: n.passNode || !1,
    schema: n.space === "svg" ? bg : KV,
    stylePropertyNameCase: n.stylePropertyNameCase || "dom",
    tableCellAlignToStyle: n.tableCellAlignToStyle !== !1
  }, o = v1(a, e, void 0);
  return o && typeof o != "string" ? o : a.create(
    e,
    a.Fragment,
    { children: o || void 0 },
    void 0
  );
}
function v1(e, n, r) {
  if (n.type === "element")
    return o3(e, n, r);
  if (n.type === "mdxFlowExpression" || n.type === "mdxTextExpression")
    return s3(e, n);
  if (n.type === "mdxJsxFlowElement" || n.type === "mdxJsxTextElement")
    return c3(e, n, r);
  if (n.type === "mdxjsEsm")
    return l3(e, n);
  if (n.type === "root")
    return d3(e, n, r);
  if (n.type === "text")
    return u3(e, n);
}
function o3(e, n, r) {
  const i = e.schema;
  let a = i;
  n.tagName.toLowerCase() === "svg" && i.space === "html" && (a = bg, e.schema = a), e.ancestors.push(n);
  const o = b1(e, n.tagName, !1), s = f3(e, n);
  let l = Ng(e, n);
  return r3.has(n.tagName) && (l = l.filter(function(d) {
    return typeof d == "string" ? !PV(d) : !0;
  })), k1(e, s, o, n), Sg(s, l), e.ancestors.pop(), e.schema = i, e.create(n, o, s, r);
}
function s3(e, n) {
  if (n.data && n.data.estree && e.evaluater) {
    const i = n.data.estree.body[0];
    return i.type, /** @type {Child | undefined} */
    e.evaluater.evaluateExpression(i.expression);
  }
  Wo(e, n.position);
}
function l3(e, n) {
  if (n.data && n.data.estree && e.evaluater)
    return (
      /** @type {Child | undefined} */
      e.evaluater.evaluateProgram(n.data.estree)
    );
  Wo(e, n.position);
}
function c3(e, n, r) {
  const i = e.schema;
  let a = i;
  n.name === "svg" && i.space === "html" && (a = bg, e.schema = a), e.ancestors.push(n);
  const o = n.name === null ? e.Fragment : b1(e, n.name, !0), s = h3(e, n), l = Ng(e, n);
  return k1(e, s, o, n), Sg(s, l), e.ancestors.pop(), e.schema = i, e.create(n, o, s, r);
}
function d3(e, n, r) {
  const i = {};
  return Sg(i, Ng(e, n)), e.create(n, e.Fragment, i, r);
}
function u3(e, n) {
  return n.value;
}
function k1(e, n, r, i) {
  typeof r != "string" && r !== e.Fragment && e.passNode && (n.node = i);
}
function Sg(e, n) {
  if (n.length > 0) {
    const r = n.length > 1 ? n : n[0];
    r && (e.children = r);
  }
}
function m3(e, n, r) {
  return i;
  function i(a, o, s, l) {
    const m = Array.isArray(s.children) ? r : n;
    return l ? m(o, s, l) : m(o, s);
  }
}
function p3(e, n) {
  return r;
  function r(i, a, o, s) {
    const l = Array.isArray(o.children), d = _g(i);
    return n(
      a,
      o,
      s,
      l,
      {
        columnNumber: d ? d.column - 1 : void 0,
        fileName: e,
        lineNumber: d ? d.line : void 0
      },
      void 0
    );
  }
}
function f3(e, n) {
  const r = {};
  let i, a;
  for (a in n.properties)
    if (a !== "children" && xg.call(n.properties, a)) {
      const o = y3(e, a, n.properties[a]);
      if (o) {
        const [s, l] = o;
        e.tableCellAlignToStyle && s === "align" && typeof l == "string" && i3.has(n.tagName) ? i = l : r[s] = l;
      }
    }
  if (i) {
    const o = (
      /** @type {Style} */
      r.style || (r.style = {})
    );
    o[e.stylePropertyNameCase === "css" ? "text-align" : "textAlign"] = i;
  }
  return r;
}
function h3(e, n) {
  const r = {};
  for (const i of n.attributes)
    if (i.type === "mdxJsxExpressionAttribute")
      if (i.data && i.data.estree && e.evaluater) {
        const o = i.data.estree.body[0];
        o.type;
        const s = o.expression;
        s.type;
        const l = s.properties[0];
        l.type, Object.assign(
          r,
          e.evaluater.evaluateExpression(l.argument)
        );
      } else
        Wo(e, n.position);
    else {
      const a = i.name;
      let o;
      if (i.value && typeof i.value == "object")
        if (i.value.data && i.value.data.estree && e.evaluater) {
          const l = i.value.data.estree.body[0];
          l.type, o = e.evaluater.evaluateExpression(l.expression);
        } else
          Wo(e, n.position);
      else
        o = i.value === null ? !0 : i.value;
      r[a] = /** @type {Props[keyof Props]} */
      o;
    }
  return r;
}
function Ng(e, n) {
  const r = [];
  let i = -1;
  const a = e.passKeys ? /* @__PURE__ */ new Map() : e3;
  for (; ++i < n.children.length; ) {
    const o = n.children[i];
    let s;
    if (e.passKeys) {
      const d = o.type === "element" ? o.tagName : o.type === "mdxJsxFlowElement" || o.type === "mdxJsxTextElement" ? o.name : void 0;
      if (d) {
        const m = a.get(d) || 0;
        s = d + "-" + m, a.set(d, m + 1);
      }
    }
    const l = v1(e, o, s);
    l !== void 0 && r.push(l);
  }
  return r;
}
function y3(e, n, r) {
  const i = BV(e.schema, n);
  if (!(r == null || typeof r == "number" && Number.isNaN(r))) {
    if (Array.isArray(r) && (r = i.commaSeparated ? EV(r) : GV(r)), i.property === "style") {
      let a = typeof r == "object" ? r : g3(e, String(r));
      return e.stylePropertyNameCase === "css" && (a = v3(a)), ["style", a];
    }
    return [
      e.elementAttributeNameCase === "react" && i.space ? WV[i.property] || i.property : i.attribute,
      r
    ];
  }
}
function g3(e, n) {
  const r = {};
  try {
    XV(n, i);
  } catch (a) {
    if (!e.ignoreInvalidStyle) {
      const o = (
        /** @type {Error} */
        a
      ), s = new qt("Cannot parse `style` attribute", {
        ancestors: e.ancestors,
        cause: o,
        ruleId: "style",
        source: "hast-util-to-jsx-runtime"
      });
      throw s.file = e.filePath || void 0, s.url = g1 + "#cannot-parse-style-attribute", s;
    }
  }
  return r;
  function i(a, o) {
    let s = a;
    s.slice(0, 2) !== "--" && (s.slice(0, 4) === "-ms-" && (s = "ms-" + s.slice(4)), s = s.replace(t3, b3)), r[s] = o;
  }
}
function b1(e, n, r) {
  let i;
  if (!r)
    i = { type: "Literal", value: n };
  else if (n.includes(".")) {
    const a = n.split(".");
    let o = -1, s;
    for (; ++o < a.length; ) {
      const l = bx(a[o]) ? { type: "Identifier", name: a[o] } : { type: "Literal", value: a[o] };
      s = s ? {
        type: "MemberExpression",
        object: s,
        property: l,
        computed: !!(o && l.type === "Literal"),
        optional: !1
      } : l;
    }
    i = s;
  } else
    i = bx(n) && !/^[a-z]/.test(n) ? { type: "Identifier", name: n } : { type: "Literal", value: n };
  if (i.type === "Literal") {
    const a = (
      /** @type {keyof JSX.IntrinsicElements} */
      i.value
    );
    return xg.call(e.components, a) ? e.components[a] : a;
  }
  if (e.evaluater)
    return e.evaluater.evaluateExpression(i);
  Wo(e);
}
function Wo(e, n) {
  const r = new qt(
    "Cannot handle MDX estrees without `createEvaluater`",
    {
      ancestors: e.ancestors,
      place: n,
      ruleId: "mdx-estree",
      source: "hast-util-to-jsx-runtime"
    }
  );
  throw r.file = e.filePath || void 0, r.url = g1 + "#cannot-handle-mdx-estrees-without-createevaluater", r;
}
function v3(e) {
  const n = {};
  let r;
  for (r in e)
    xg.call(e, r) && (n[k3(r)] = e[r]);
  return n;
}
function k3(e) {
  let n = e.replace(n3, _3);
  return n.slice(0, 3) === "ms-" && (n = "-" + n), n;
}
function b3(e, n) {
  return n.toUpperCase();
}
function _3(e) {
  return "-" + e.toLowerCase();
}
const wm = {
  action: ["form"],
  cite: ["blockquote", "del", "ins", "q"],
  data: ["object"],
  formAction: ["button", "input"],
  href: ["a", "area", "base", "link"],
  icon: ["menuitem"],
  itemId: null,
  manifest: ["html"],
  ping: ["a", "area"],
  poster: ["video"],
  src: [
    "audio",
    "embed",
    "iframe",
    "img",
    "input",
    "script",
    "source",
    "track",
    "video"
  ]
}, x3 = {};
function S3(e, n) {
  const r = x3, i = typeof r.includeImageAlt == "boolean" ? r.includeImageAlt : !0, a = typeof r.includeHtml == "boolean" ? r.includeHtml : !0;
  return _1(e, i, a);
}
function _1(e, n, r) {
  if (N3(e)) {
    if ("value" in e)
      return e.type === "html" && !r ? "" : e.value;
    if (n && "alt" in e && e.alt)
      return e.alt;
    if ("children" in e)
      return Ix(e.children, n, r);
  }
  return Array.isArray(e) ? Ix(e, n, r) : "";
}
function Ix(e, n, r) {
  const i = [];
  let a = -1;
  for (; ++a < e.length; )
    i[a] = _1(e[a], n, r);
  return i.join("");
}
function N3(e) {
  return !!(e && typeof e == "object");
}
const $x = document.createElement("i");
function jg(e) {
  const n = "&" + e + ";";
  $x.innerHTML = n;
  const r = $x.textContent;
  return r.charCodeAt(r.length - 1) === 59 && e !== "semi" || r === n ? !1 : r;
}
function Gr(e, n, r, i) {
  const a = e.length;
  let o = 0, s;
  if (n < 0 ? n = -n > a ? 0 : a + n : n = n > a ? a : n, r = r > 0 ? r : 0, i.length < 1e4)
    s = Array.from(i), s.unshift(n, r), e.splice(...s);
  else
    for (r && e.splice(n, r); o < i.length; )
      s = i.slice(o, o + 1e4), s.unshift(n, 0), e.splice(...s), o += 1e4, n += 1e4;
}
function xr(e, n) {
  return e.length > 0 ? (Gr(e, e.length, 0, n), e) : n;
}
const Ex = {}.hasOwnProperty;
function j3(e) {
  const n = {};
  let r = -1;
  for (; ++r < e.length; )
    w3(n, e[r]);
  return n;
}
function w3(e, n) {
  let r;
  for (r in n) {
    const a = (Ex.call(e, r) ? e[r] : void 0) || (e[r] = {}), o = n[r];
    let s;
    if (o)
      for (s in o) {
        Ex.call(a, s) || (a[s] = []);
        const l = o[s];
        C3(
          // @ts-expect-error Looks like a list.
          a[s],
          Array.isArray(l) ? l : l ? [l] : []
        );
      }
  }
}
function C3(e, n) {
  let r = -1;
  const i = [];
  for (; ++r < n.length; )
    (n[r].add === "after" ? e : i).push(n[r]);
  Gr(e, 0, 0, i);
}
function x1(e, n) {
  const r = Number.parseInt(e, n);
  return (
    // C0 except for HT, LF, FF, CR, space.
    r < 9 || r === 11 || r > 13 && r < 32 || // Control character (DEL) of C0, and C1 controls.
    r > 126 && r < 160 || // Lone high surrogates and low surrogates.
    r > 55295 && r < 57344 || // Noncharacters.
    r > 64975 && r < 65008 || /* eslint-disable no-bitwise */
    (r & 65535) === 65535 || (r & 65535) === 65534 || /* eslint-enable no-bitwise */
    // Out of range
    r > 1114111 ? "�" : String.fromCodePoint(r)
  );
}
function ka(e) {
  return e.replace(/[\t\n\r ]+/g, " ").replace(/^ | $/g, "").toLowerCase().toUpperCase();
}
const Mr = Si(/[A-Za-z]/), dr = Si(/[\dA-Za-z]/), F3 = Si(/[#-'*+\--9=?A-Z^-~]/);
function uy(e) {
  return (
    // Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    e !== null && (e < 32 || e === 127)
  );
}
const my = Si(/\d/), I3 = Si(/[\dA-Fa-f]/), $3 = Si(/[!-/:-@[-`{-~]/);
function In(e) {
  return e !== null && e < -2;
}
function rr(e) {
  return e !== null && (e < 0 || e === 32);
}
function Yn(e) {
  return e === -2 || e === -1 || e === 32;
}
const E3 = Si(new RegExp("\\p{P}|\\p{S}", "u")), T3 = Si(/\s/);
function Si(e) {
  return n;
  function n(r) {
    return r !== null && r > -1 && e.test(String.fromCharCode(r));
  }
}
function Aa(e) {
  const n = [];
  let r = -1, i = 0, a = 0;
  for (; ++r < e.length; ) {
    const o = e.charCodeAt(r);
    let s = "";
    if (o === 37 && dr(e.charCodeAt(r + 1)) && dr(e.charCodeAt(r + 2)))
      a = 2;
    else if (o < 128)
      /[!#$&-;=?-Z_a-z~]/.test(String.fromCharCode(o)) || (s = String.fromCharCode(o));
    else if (o > 55295 && o < 57344) {
      const l = e.charCodeAt(r + 1);
      o < 56320 && l > 56319 && l < 57344 ? (s = String.fromCharCode(o, l), a = 1) : s = "�";
    } else
      s = String.fromCharCode(o);
    s && (n.push(e.slice(i, r), encodeURIComponent(s)), i = r + a + 1, s = ""), a && (r += a, a = 0);
  }
  return n.join("") + e.slice(i);
}
function dt(e, n, r, i) {
  const a = i ? i - 1 : Number.POSITIVE_INFINITY;
  let o = 0;
  return s;
  function s(d) {
    return Yn(d) ? (e.enter(r), l(d)) : n(d);
  }
  function l(d) {
    return Yn(d) && o++ < a ? (e.consume(d), l) : (e.exit(r), n(d));
  }
}
const R3 = {
  tokenize: D3
};
function D3(e) {
  const n = e.attempt(this.parser.constructs.contentInitial, i, a);
  let r;
  return n;
  function i(l) {
    if (l === null) {
      e.consume(l);
      return;
    }
    return e.enter("lineEnding"), e.consume(l), e.exit("lineEnding"), dt(e, n, "linePrefix");
  }
  function a(l) {
    return e.enter("paragraph"), o(l);
  }
  function o(l) {
    const d = e.enter("chunkText", {
      contentType: "text",
      previous: r
    });
    return r && (r.next = d), r = d, s(l);
  }
  function s(l) {
    if (l === null) {
      e.exit("chunkText"), e.exit("paragraph"), e.consume(l);
      return;
    }
    return In(l) ? (e.consume(l), e.exit("chunkText"), o) : (e.consume(l), s);
  }
}
const O3 = {
  tokenize: P3
}, Tx = {
  tokenize: A3
};
function P3(e) {
  const n = this, r = [];
  let i = 0, a, o, s;
  return l;
  function l(O) {
    if (i < r.length) {
      const R = r[i];
      return n.containerState = R[1], e.attempt(R[0].continuation, d, m)(O);
    }
    return m(O);
  }
  function d(O) {
    if (i++, n.containerState._closeFlow) {
      n.containerState._closeFlow = void 0, a && g();
      const R = n.events.length;
      let $ = R, I;
      for (; $--; )
        if (n.events[$][0] === "exit" && n.events[$][1].type === "chunkFlow") {
          I = n.events[$][1].end;
          break;
        }
      _(i);
      let L = R;
      for (; L < n.events.length; )
        n.events[L][1].end = {
          ...I
        }, L++;
      return Gr(n.events, $ + 1, 0, n.events.slice(R)), n.events.length = L, m(O);
    }
    return l(O);
  }
  function m(O) {
    if (i === r.length) {
      if (!a)
        return h(O);
      if (a.currentConstruct && a.currentConstruct.concrete)
        return w(O);
      n.interrupt = !!(a.currentConstruct && !a._gfmTableDynamicInterruptHack);
    }
    return n.containerState = {}, e.check(Tx, u, f)(O);
  }
  function u(O) {
    return a && g(), _(i), h(O);
  }
  function f(O) {
    return n.parser.lazy[n.now().line] = i !== r.length, s = n.now().offset, w(O);
  }
  function h(O) {
    return n.containerState = {}, e.attempt(Tx, v, w)(O);
  }
  function v(O) {
    return i++, r.push([n.currentConstruct, n.containerState]), h(O);
  }
  function w(O) {
    if (O === null) {
      a && g(), _(0), e.consume(O);
      return;
    }
    return a = a || n.parser.flow(n.now()), e.enter("chunkFlow", {
      _tokenizer: a,
      contentType: "flow",
      previous: o
    }), N(O);
  }
  function N(O) {
    if (O === null) {
      j(e.exit("chunkFlow"), !0), _(0), e.consume(O);
      return;
    }
    return In(O) ? (e.consume(O), j(e.exit("chunkFlow")), i = 0, n.interrupt = void 0, l) : (e.consume(O), N);
  }
  function j(O, R) {
    const $ = n.sliceStream(O);
    if (R && $.push(null), O.previous = o, o && (o.next = O), o = O, a.defineSkip(O.start), a.write($), n.parser.lazy[O.start.line]) {
      let I = a.events.length;
      for (; I--; )
        if (
          // The token starts before the line ending…
          a.events[I][1].start.offset < s && // …and either is not ended yet…
          (!a.events[I][1].end || // …or ends after it.
          a.events[I][1].end.offset > s)
        )
          return;
      const L = n.events.length;
      let G = L, Q, ne;
      for (; G--; )
        if (n.events[G][0] === "exit" && n.events[G][1].type === "chunkFlow") {
          if (Q) {
            ne = n.events[G][1].end;
            break;
          }
          Q = !0;
        }
      for (_(i), I = L; I < n.events.length; )
        n.events[I][1].end = {
          ...ne
        }, I++;
      Gr(n.events, G + 1, 0, n.events.slice(L)), n.events.length = I;
    }
  }
  function _(O) {
    let R = r.length;
    for (; R-- > O; ) {
      const $ = r[R];
      n.containerState = $[1], $[0].exit.call(n, e);
    }
    r.length = O;
  }
  function g() {
    a.write([null]), o = void 0, a = void 0, n.containerState._closeFlow = void 0;
  }
}
function A3(e, n, r) {
  return dt(e, e.attempt(this.parser.constructs.document, n, r), "linePrefix", this.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4);
}
function Rx(e) {
  if (e === null || rr(e) || T3(e))
    return 1;
  if (E3(e))
    return 2;
}
function wg(e, n, r) {
  const i = [];
  let a = -1;
  for (; ++a < e.length; ) {
    const o = e[a].resolveAll;
    o && !i.includes(o) && (n = o(n, r), i.push(o));
  }
  return n;
}
const py = {
  name: "attention",
  resolveAll: L3,
  tokenize: V3
};
function L3(e, n) {
  let r = -1, i, a, o, s, l, d, m, u;
  for (; ++r < e.length; )
    if (e[r][0] === "enter" && e[r][1].type === "attentionSequence" && e[r][1]._close) {
      for (i = r; i--; )
        if (e[i][0] === "exit" && e[i][1].type === "attentionSequence" && e[i][1]._open && // If the markers are the same:
        n.sliceSerialize(e[i][1]).charCodeAt(0) === n.sliceSerialize(e[r][1]).charCodeAt(0)) {
          if ((e[i][1]._close || e[r][1]._open) && (e[r][1].end.offset - e[r][1].start.offset) % 3 && !((e[i][1].end.offset - e[i][1].start.offset + e[r][1].end.offset - e[r][1].start.offset) % 3))
            continue;
          d = e[i][1].end.offset - e[i][1].start.offset > 1 && e[r][1].end.offset - e[r][1].start.offset > 1 ? 2 : 1;
          const f = {
            ...e[i][1].end
          }, h = {
            ...e[r][1].start
          };
          Dx(f, -d), Dx(h, d), s = {
            type: d > 1 ? "strongSequence" : "emphasisSequence",
            start: f,
            end: {
              ...e[i][1].end
            }
          }, l = {
            type: d > 1 ? "strongSequence" : "emphasisSequence",
            start: {
              ...e[r][1].start
            },
            end: h
          }, o = {
            type: d > 1 ? "strongText" : "emphasisText",
            start: {
              ...e[i][1].end
            },
            end: {
              ...e[r][1].start
            }
          }, a = {
            type: d > 1 ? "strong" : "emphasis",
            start: {
              ...s.start
            },
            end: {
              ...l.end
            }
          }, e[i][1].end = {
            ...s.start
          }, e[r][1].start = {
            ...l.end
          }, m = [], e[i][1].end.offset - e[i][1].start.offset && (m = xr(m, [["enter", e[i][1], n], ["exit", e[i][1], n]])), m = xr(m, [["enter", a, n], ["enter", s, n], ["exit", s, n], ["enter", o, n]]), m = xr(m, wg(n.parser.constructs.insideSpan.null, e.slice(i + 1, r), n)), m = xr(m, [["exit", o, n], ["enter", l, n], ["exit", l, n], ["exit", a, n]]), e[r][1].end.offset - e[r][1].start.offset ? (u = 2, m = xr(m, [["enter", e[r][1], n], ["exit", e[r][1], n]])) : u = 0, Gr(e, i - 1, r - i + 3, m), r = i + m.length - u - 2;
          break;
        }
    }
  for (r = -1; ++r < e.length; )
    e[r][1].type === "attentionSequence" && (e[r][1].type = "data");
  return e;
}
function V3(e, n) {
  const r = this.parser.constructs.attentionMarkers.null, i = this.previous, a = Rx(i);
  let o;
  return s;
  function s(d) {
    return o = d, e.enter("attentionSequence"), l(d);
  }
  function l(d) {
    if (d === o)
      return e.consume(d), l;
    const m = e.exit("attentionSequence"), u = Rx(d), f = !u || u === 2 && a || r.includes(d), h = !a || a === 2 && u || r.includes(i);
    return m._open = !!(o === 42 ? f : f && (a || !h)), m._close = !!(o === 42 ? h : h && (u || !f)), n(d);
  }
}
function Dx(e, n) {
  e.column += n, e.offset += n, e._bufferIndex += n;
}
const z3 = {
  name: "autolink",
  tokenize: U3
};
function U3(e, n, r) {
  let i = 0;
  return a;
  function a(v) {
    return e.enter("autolink"), e.enter("autolinkMarker"), e.consume(v), e.exit("autolinkMarker"), e.enter("autolinkProtocol"), o;
  }
  function o(v) {
    return Mr(v) ? (e.consume(v), s) : v === 64 ? r(v) : m(v);
  }
  function s(v) {
    return v === 43 || v === 45 || v === 46 || dr(v) ? (i = 1, l(v)) : m(v);
  }
  function l(v) {
    return v === 58 ? (e.consume(v), i = 0, d) : (v === 43 || v === 45 || v === 46 || dr(v)) && i++ < 32 ? (e.consume(v), l) : (i = 0, m(v));
  }
  function d(v) {
    return v === 62 ? (e.exit("autolinkProtocol"), e.enter("autolinkMarker"), e.consume(v), e.exit("autolinkMarker"), e.exit("autolink"), n) : v === null || v === 32 || v === 60 || uy(v) ? r(v) : (e.consume(v), d);
  }
  function m(v) {
    return v === 64 ? (e.consume(v), u) : F3(v) ? (e.consume(v), m) : r(v);
  }
  function u(v) {
    return dr(v) ? f(v) : r(v);
  }
  function f(v) {
    return v === 46 ? (e.consume(v), i = 0, u) : v === 62 ? (e.exit("autolinkProtocol").type = "autolinkEmail", e.enter("autolinkMarker"), e.consume(v), e.exit("autolinkMarker"), e.exit("autolink"), n) : h(v);
  }
  function h(v) {
    if ((v === 45 || dr(v)) && i++ < 63) {
      const w = v === 45 ? h : f;
      return e.consume(v), w;
    }
    return r(v);
  }
}
const ac = {
  partial: !0,
  tokenize: M3
};
function M3(e, n, r) {
  return i;
  function i(o) {
    return Yn(o) ? dt(e, a, "linePrefix")(o) : a(o);
  }
  function a(o) {
    return o === null || In(o) ? n(o) : r(o);
  }
}
const S1 = {
  continuation: {
    tokenize: q3
  },
  exit: H3,
  name: "blockQuote",
  tokenize: B3
};
function B3(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    if (s === 62) {
      const l = i.containerState;
      return l.open || (e.enter("blockQuote", {
        _container: !0
      }), l.open = !0), e.enter("blockQuotePrefix"), e.enter("blockQuoteMarker"), e.consume(s), e.exit("blockQuoteMarker"), o;
    }
    return r(s);
  }
  function o(s) {
    return Yn(s) ? (e.enter("blockQuotePrefixWhitespace"), e.consume(s), e.exit("blockQuotePrefixWhitespace"), e.exit("blockQuotePrefix"), n) : (e.exit("blockQuotePrefix"), n(s));
  }
}
function q3(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    return Yn(s) ? dt(e, o, "linePrefix", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(s) : o(s);
  }
  function o(s) {
    return e.attempt(S1, n, r)(s);
  }
}
function H3(e) {
  e.exit("blockQuote");
}
const N1 = {
  name: "characterEscape",
  tokenize: W3
};
function W3(e, n, r) {
  return i;
  function i(o) {
    return e.enter("characterEscape"), e.enter("escapeMarker"), e.consume(o), e.exit("escapeMarker"), a;
  }
  function a(o) {
    return $3(o) ? (e.enter("characterEscapeValue"), e.consume(o), e.exit("characterEscapeValue"), e.exit("characterEscape"), n) : r(o);
  }
}
const j1 = {
  name: "characterReference",
  tokenize: K3
};
function K3(e, n, r) {
  const i = this;
  let a = 0, o, s;
  return l;
  function l(f) {
    return e.enter("characterReference"), e.enter("characterReferenceMarker"), e.consume(f), e.exit("characterReferenceMarker"), d;
  }
  function d(f) {
    return f === 35 ? (e.enter("characterReferenceMarkerNumeric"), e.consume(f), e.exit("characterReferenceMarkerNumeric"), m) : (e.enter("characterReferenceValue"), o = 31, s = dr, u(f));
  }
  function m(f) {
    return f === 88 || f === 120 ? (e.enter("characterReferenceMarkerHexadecimal"), e.consume(f), e.exit("characterReferenceMarkerHexadecimal"), e.enter("characterReferenceValue"), o = 6, s = I3, u) : (e.enter("characterReferenceValue"), o = 7, s = my, u(f));
  }
  function u(f) {
    if (f === 59 && a) {
      const h = e.exit("characterReferenceValue");
      return s === dr && !jg(i.sliceSerialize(h)) ? r(f) : (e.enter("characterReferenceMarker"), e.consume(f), e.exit("characterReferenceMarker"), e.exit("characterReference"), n);
    }
    return s(f) && a++ < o ? (e.consume(f), u) : r(f);
  }
}
const Ox = {
  partial: !0,
  tokenize: Y3
}, Px = {
  concrete: !0,
  name: "codeFenced",
  tokenize: G3
};
function G3(e, n, r) {
  const i = this, a = {
    partial: !0,
    tokenize: $
  };
  let o = 0, s = 0, l;
  return d;
  function d(I) {
    return m(I);
  }
  function m(I) {
    const L = i.events[i.events.length - 1];
    return o = L && L[1].type === "linePrefix" ? L[2].sliceSerialize(L[1], !0).length : 0, l = I, e.enter("codeFenced"), e.enter("codeFencedFence"), e.enter("codeFencedFenceSequence"), u(I);
  }
  function u(I) {
    return I === l ? (s++, e.consume(I), u) : s < 3 ? r(I) : (e.exit("codeFencedFenceSequence"), Yn(I) ? dt(e, f, "whitespace")(I) : f(I));
  }
  function f(I) {
    return I === null || In(I) ? (e.exit("codeFencedFence"), i.interrupt ? n(I) : e.check(Ox, N, R)(I)) : (e.enter("codeFencedFenceInfo"), e.enter("chunkString", {
      contentType: "string"
    }), h(I));
  }
  function h(I) {
    return I === null || In(I) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), f(I)) : Yn(I) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), dt(e, v, "whitespace")(I)) : I === 96 && I === l ? r(I) : (e.consume(I), h);
  }
  function v(I) {
    return I === null || In(I) ? f(I) : (e.enter("codeFencedFenceMeta"), e.enter("chunkString", {
      contentType: "string"
    }), w(I));
  }
  function w(I) {
    return I === null || In(I) ? (e.exit("chunkString"), e.exit("codeFencedFenceMeta"), f(I)) : I === 96 && I === l ? r(I) : (e.consume(I), w);
  }
  function N(I) {
    return e.attempt(a, R, j)(I);
  }
  function j(I) {
    return e.enter("lineEnding"), e.consume(I), e.exit("lineEnding"), _;
  }
  function _(I) {
    return o > 0 && Yn(I) ? dt(e, g, "linePrefix", o + 1)(I) : g(I);
  }
  function g(I) {
    return I === null || In(I) ? e.check(Ox, N, R)(I) : (e.enter("codeFlowValue"), O(I));
  }
  function O(I) {
    return I === null || In(I) ? (e.exit("codeFlowValue"), g(I)) : (e.consume(I), O);
  }
  function R(I) {
    return e.exit("codeFenced"), n(I);
  }
  function $(I, L, G) {
    let Q = 0;
    return ne;
    function ne(ie) {
      return I.enter("lineEnding"), I.consume(ie), I.exit("lineEnding"), q;
    }
    function q(ie) {
      return I.enter("codeFencedFence"), Yn(ie) ? dt(I, Y, "linePrefix", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(ie) : Y(ie);
    }
    function Y(ie) {
      return ie === l ? (I.enter("codeFencedFenceSequence"), P(ie)) : G(ie);
    }
    function P(ie) {
      return ie === l ? (Q++, I.consume(ie), P) : Q >= s ? (I.exit("codeFencedFenceSequence"), Yn(ie) ? dt(I, B, "whitespace")(ie) : B(ie)) : G(ie);
    }
    function B(ie) {
      return ie === null || In(ie) ? (I.exit("codeFencedFence"), L(ie)) : G(ie);
    }
  }
}
function Y3(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    return s === null ? r(s) : (e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), o);
  }
  function o(s) {
    return i.parser.lazy[i.now().line] ? r(s) : n(s);
  }
}
const Cm = {
  name: "codeIndented",
  tokenize: Q3
}, J3 = {
  partial: !0,
  tokenize: X3
};
function Q3(e, n, r) {
  const i = this;
  return a;
  function a(m) {
    return e.enter("codeIndented"), dt(e, o, "linePrefix", 5)(m);
  }
  function o(m) {
    const u = i.events[i.events.length - 1];
    return u && u[1].type === "linePrefix" && u[2].sliceSerialize(u[1], !0).length >= 4 ? s(m) : r(m);
  }
  function s(m) {
    return m === null ? d(m) : In(m) ? e.attempt(J3, s, d)(m) : (e.enter("codeFlowValue"), l(m));
  }
  function l(m) {
    return m === null || In(m) ? (e.exit("codeFlowValue"), s(m)) : (e.consume(m), l);
  }
  function d(m) {
    return e.exit("codeIndented"), n(m);
  }
}
function X3(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    return i.parser.lazy[i.now().line] ? r(s) : In(s) ? (e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), a) : dt(e, o, "linePrefix", 5)(s);
  }
  function o(s) {
    const l = i.events[i.events.length - 1];
    return l && l[1].type === "linePrefix" && l[2].sliceSerialize(l[1], !0).length >= 4 ? n(s) : In(s) ? a(s) : r(s);
  }
}
const Z3 = {
  name: "codeText",
  previous: nz,
  resolve: ez,
  tokenize: tz
};
function ez(e) {
  let n = e.length - 4, r = 3, i, a;
  if ((e[r][1].type === "lineEnding" || e[r][1].type === "space") && (e[n][1].type === "lineEnding" || e[n][1].type === "space")) {
    for (i = r; ++i < n; )
      if (e[i][1].type === "codeTextData") {
        e[r][1].type = "codeTextPadding", e[n][1].type = "codeTextPadding", r += 2, n -= 2;
        break;
      }
  }
  for (i = r - 1, n++; ++i <= n; )
    a === void 0 ? i !== n && e[i][1].type !== "lineEnding" && (a = i) : (i === n || e[i][1].type === "lineEnding") && (e[a][1].type = "codeTextData", i !== a + 2 && (e[a][1].end = e[i - 1][1].end, e.splice(a + 2, i - a - 2), n -= i - a - 2, i = a + 2), a = void 0);
  return e;
}
function nz(e) {
  return e !== 96 || this.events[this.events.length - 1][1].type === "characterEscape";
}
function tz(e, n, r) {
  let i = 0, a, o;
  return s;
  function s(f) {
    return e.enter("codeText"), e.enter("codeTextSequence"), l(f);
  }
  function l(f) {
    return f === 96 ? (e.consume(f), i++, l) : (e.exit("codeTextSequence"), d(f));
  }
  function d(f) {
    return f === null ? r(f) : f === 32 ? (e.enter("space"), e.consume(f), e.exit("space"), d) : f === 96 ? (o = e.enter("codeTextSequence"), a = 0, u(f)) : In(f) ? (e.enter("lineEnding"), e.consume(f), e.exit("lineEnding"), d) : (e.enter("codeTextData"), m(f));
  }
  function m(f) {
    return f === null || f === 32 || f === 96 || In(f) ? (e.exit("codeTextData"), d(f)) : (e.consume(f), m);
  }
  function u(f) {
    return f === 96 ? (e.consume(f), a++, u) : a === i ? (e.exit("codeTextSequence"), e.exit("codeText"), n(f)) : (o.type = "codeTextData", m(f));
  }
}
class rz {
  /**
   * @param {ReadonlyArray<T> | null | undefined} [initial]
   *   Initial items (optional).
   * @returns
   *   Splice buffer.
   */
  constructor(n) {
    this.left = n ? [...n] : [], this.right = [];
  }
  /**
   * Array access;
   * does not move the cursor.
   *
   * @param {number} index
   *   Index.
   * @return {T}
   *   Item.
   */
  get(n) {
    if (n < 0 || n >= this.left.length + this.right.length)
      throw new RangeError("Cannot access index `" + n + "` in a splice buffer of size `" + (this.left.length + this.right.length) + "`");
    return n < this.left.length ? this.left[n] : this.right[this.right.length - n + this.left.length - 1];
  }
  /**
   * The length of the splice buffer, one greater than the largest index in the
   * array.
   */
  get length() {
    return this.left.length + this.right.length;
  }
  /**
   * Remove and return `list[0]`;
   * moves the cursor to `0`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  shift() {
    return this.setCursor(0), this.right.pop();
  }
  /**
   * Slice the buffer to get an array;
   * does not move the cursor.
   *
   * @param {number} start
   *   Start.
   * @param {number | null | undefined} [end]
   *   End (optional).
   * @returns {Array<T>}
   *   Array of items.
   */
  slice(n, r) {
    const i = r ?? Number.POSITIVE_INFINITY;
    return i < this.left.length ? this.left.slice(n, i) : n > this.left.length ? this.right.slice(this.right.length - i + this.left.length, this.right.length - n + this.left.length).reverse() : this.left.slice(n).concat(this.right.slice(this.right.length - i + this.left.length).reverse());
  }
  /**
   * Mimics the behavior of Array.prototype.splice() except for the change of
   * interface necessary to avoid segfaults when patching in very large arrays.
   *
   * This operation moves cursor is moved to `start` and results in the cursor
   * placed after any inserted items.
   *
   * @param {number} start
   *   Start;
   *   zero-based index at which to start changing the array;
   *   negative numbers count backwards from the end of the array and values
   *   that are out-of bounds are clamped to the appropriate end of the array.
   * @param {number | null | undefined} [deleteCount=0]
   *   Delete count (default: `0`);
   *   maximum number of elements to delete, starting from start.
   * @param {Array<T> | null | undefined} [items=[]]
   *   Items to include in place of the deleted items (default: `[]`).
   * @return {Array<T>}
   *   Any removed items.
   */
  splice(n, r, i) {
    const a = r || 0;
    this.setCursor(Math.trunc(n));
    const o = this.right.splice(this.right.length - a, Number.POSITIVE_INFINITY);
    return i && io(this.left, i), o.reverse();
  }
  /**
   * Remove and return the highest-numbered item in the array, so
   * `list[list.length - 1]`;
   * Moves the cursor to `length`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  pop() {
    return this.setCursor(Number.POSITIVE_INFINITY), this.left.pop();
  }
  /**
   * Inserts a single item to the high-numbered side of the array;
   * moves the cursor to `length`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  push(n) {
    this.setCursor(Number.POSITIVE_INFINITY), this.left.push(n);
  }
  /**
   * Inserts many items to the high-numbered side of the array.
   * Moves the cursor to `length`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  pushMany(n) {
    this.setCursor(Number.POSITIVE_INFINITY), io(this.left, n);
  }
  /**
   * Inserts a single item to the low-numbered side of the array;
   * Moves the cursor to `0`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  unshift(n) {
    this.setCursor(0), this.right.push(n);
  }
  /**
   * Inserts many items to the low-numbered side of the array;
   * moves the cursor to `0`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  unshiftMany(n) {
    this.setCursor(0), io(this.right, n.reverse());
  }
  /**
   * Move the cursor to a specific position in the array. Requires
   * time proportional to the distance moved.
   *
   * If `n < 0`, the cursor will end up at the beginning.
   * If `n > length`, the cursor will end up at the end.
   *
   * @param {number} n
   *   Position.
   * @return {undefined}
   *   Nothing.
   */
  setCursor(n) {
    if (!(n === this.left.length || n > this.left.length && this.right.length === 0 || n < 0 && this.left.length === 0))
      if (n < this.left.length) {
        const r = this.left.splice(n, Number.POSITIVE_INFINITY);
        io(this.right, r.reverse());
      } else {
        const r = this.right.splice(this.left.length + this.right.length - n, Number.POSITIVE_INFINITY);
        io(this.left, r.reverse());
      }
  }
}
function io(e, n) {
  let r = 0;
  if (n.length < 1e4)
    e.push(...n);
  else
    for (; r < n.length; )
      e.push(...n.slice(r, r + 1e4)), r += 1e4;
}
function w1(e) {
  const n = {};
  let r = -1, i, a, o, s, l, d, m;
  const u = new rz(e);
  for (; ++r < u.length; ) {
    for (; r in n; )
      r = n[r];
    if (i = u.get(r), r && i[1].type === "chunkFlow" && u.get(r - 1)[1].type === "listItemPrefix" && (d = i[1]._tokenizer.events, o = 0, o < d.length && d[o][1].type === "lineEndingBlank" && (o += 2), o < d.length && d[o][1].type === "content"))
      for (; ++o < d.length && d[o][1].type !== "content"; )
        d[o][1].type === "chunkText" && (d[o][1]._isInFirstContentOfListItem = !0, o++);
    if (i[0] === "enter")
      i[1].contentType && (Object.assign(n, iz(u, r)), r = n[r], m = !0);
    else if (i[1]._container) {
      for (o = r, a = void 0; o-- && (s = u.get(o), s[1].type === "lineEnding" || s[1].type === "lineEndingBlank"); )
        s[0] === "enter" && (a && (u.get(a)[1].type = "lineEndingBlank"), s[1].type = "lineEnding", a = o);
      a && (i[1].end = {
        ...u.get(a)[1].start
      }, l = u.slice(a, r), l.unshift(i), u.splice(a, r - a + 1, l));
    }
  }
  return Gr(e, 0, Number.POSITIVE_INFINITY, u.slice(0)), !m;
}
function iz(e, n) {
  const r = e.get(n)[1], i = e.get(n)[2];
  let a = n - 1;
  const o = [], s = r._tokenizer || i.parser[r.contentType](r.start), l = s.events, d = [], m = {};
  let u, f, h = -1, v = r, w = 0, N = 0;
  const j = [N];
  for (; v; ) {
    for (; e.get(++a)[1] !== v; )
      ;
    o.push(a), v._tokenizer || (u = i.sliceStream(v), v.next || u.push(null), f && s.defineSkip(v.start), v._isInFirstContentOfListItem && (s._gfmTasklistFirstContentOfListItem = !0), s.write(u), v._isInFirstContentOfListItem && (s._gfmTasklistFirstContentOfListItem = void 0)), f = v, v = v.next;
  }
  for (v = r; ++h < l.length; )
    // Find a void token that includes a break.
    l[h][0] === "exit" && l[h - 1][0] === "enter" && l[h][1].type === l[h - 1][1].type && l[h][1].start.line !== l[h][1].end.line && (N = h + 1, j.push(N), v._tokenizer = void 0, v.previous = void 0, v = v.next);
  for (s.events = [], v ? (v._tokenizer = void 0, v.previous = void 0) : j.pop(), h = j.length; h--; ) {
    const _ = l.slice(j[h], j[h + 1]), g = o.pop();
    d.push([g, g + _.length - 1]), e.splice(g, 2, _);
  }
  for (d.reverse(), h = -1; ++h < d.length; )
    m[w + d[h][0]] = w + d[h][1], w += d[h][1] - d[h][0] - 1;
  return m;
}
const az = {
  resolve: sz,
  tokenize: lz
}, oz = {
  partial: !0,
  tokenize: cz
};
function sz(e) {
  return w1(e), e;
}
function lz(e, n) {
  let r;
  return i;
  function i(l) {
    return e.enter("content"), r = e.enter("chunkContent", {
      contentType: "content"
    }), a(l);
  }
  function a(l) {
    return l === null ? o(l) : In(l) ? e.check(oz, s, o)(l) : (e.consume(l), a);
  }
  function o(l) {
    return e.exit("chunkContent"), e.exit("content"), n(l);
  }
  function s(l) {
    return e.consume(l), e.exit("chunkContent"), r.next = e.enter("chunkContent", {
      contentType: "content",
      previous: r
    }), r = r.next, a;
  }
}
function cz(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    return e.exit("chunkContent"), e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), dt(e, o, "linePrefix");
  }
  function o(s) {
    if (s === null || In(s))
      return r(s);
    const l = i.events[i.events.length - 1];
    return !i.parser.constructs.disable.null.includes("codeIndented") && l && l[1].type === "linePrefix" && l[2].sliceSerialize(l[1], !0).length >= 4 ? n(s) : e.interrupt(i.parser.constructs.flow, r, n)(s);
  }
}
function C1(e, n, r, i, a, o, s, l, d) {
  const m = d || Number.POSITIVE_INFINITY;
  let u = 0;
  return f;
  function f(_) {
    return _ === 60 ? (e.enter(i), e.enter(a), e.enter(o), e.consume(_), e.exit(o), h) : _ === null || _ === 32 || _ === 41 || uy(_) ? r(_) : (e.enter(i), e.enter(s), e.enter(l), e.enter("chunkString", {
      contentType: "string"
    }), N(_));
  }
  function h(_) {
    return _ === 62 ? (e.enter(o), e.consume(_), e.exit(o), e.exit(a), e.exit(i), n) : (e.enter(l), e.enter("chunkString", {
      contentType: "string"
    }), v(_));
  }
  function v(_) {
    return _ === 62 ? (e.exit("chunkString"), e.exit(l), h(_)) : _ === null || _ === 60 || In(_) ? r(_) : (e.consume(_), _ === 92 ? w : v);
  }
  function w(_) {
    return _ === 60 || _ === 62 || _ === 92 ? (e.consume(_), v) : v(_);
  }
  function N(_) {
    return !u && (_ === null || _ === 41 || rr(_)) ? (e.exit("chunkString"), e.exit(l), e.exit(s), e.exit(i), n(_)) : u < m && _ === 40 ? (e.consume(_), u++, N) : _ === 41 ? (e.consume(_), u--, N) : _ === null || _ === 32 || _ === 40 || uy(_) ? r(_) : (e.consume(_), _ === 92 ? j : N);
  }
  function j(_) {
    return _ === 40 || _ === 41 || _ === 92 ? (e.consume(_), N) : N(_);
  }
}
function F1(e, n, r, i, a, o) {
  const s = this;
  let l = 0, d;
  return m;
  function m(v) {
    return e.enter(i), e.enter(a), e.consume(v), e.exit(a), e.enter(o), u;
  }
  function u(v) {
    return l > 999 || v === null || v === 91 || v === 93 && !d || // To do: remove in the future once we’ve switched from
    // `micromark-extension-footnote` to `micromark-extension-gfm-footnote`,
    // which doesn’t need this.
    // Hidden footnotes hook.
    /* c8 ignore next 3 */
    v === 94 && !l && "_hiddenFootnoteSupport" in s.parser.constructs ? r(v) : v === 93 ? (e.exit(o), e.enter(a), e.consume(v), e.exit(a), e.exit(i), n) : In(v) ? (e.enter("lineEnding"), e.consume(v), e.exit("lineEnding"), u) : (e.enter("chunkString", {
      contentType: "string"
    }), f(v));
  }
  function f(v) {
    return v === null || v === 91 || v === 93 || In(v) || l++ > 999 ? (e.exit("chunkString"), u(v)) : (e.consume(v), d || (d = !Yn(v)), v === 92 ? h : f);
  }
  function h(v) {
    return v === 91 || v === 92 || v === 93 ? (e.consume(v), l++, f) : f(v);
  }
}
function I1(e, n, r, i, a, o) {
  let s;
  return l;
  function l(h) {
    return h === 34 || h === 39 || h === 40 ? (e.enter(i), e.enter(a), e.consume(h), e.exit(a), s = h === 40 ? 41 : h, d) : r(h);
  }
  function d(h) {
    return h === s ? (e.enter(a), e.consume(h), e.exit(a), e.exit(i), n) : (e.enter(o), m(h));
  }
  function m(h) {
    return h === s ? (e.exit(o), d(s)) : h === null ? r(h) : In(h) ? (e.enter("lineEnding"), e.consume(h), e.exit("lineEnding"), dt(e, m, "linePrefix")) : (e.enter("chunkString", {
      contentType: "string"
    }), u(h));
  }
  function u(h) {
    return h === s || h === null || In(h) ? (e.exit("chunkString"), m(h)) : (e.consume(h), h === 92 ? f : u);
  }
  function f(h) {
    return h === s || h === 92 ? (e.consume(h), u) : u(h);
  }
}
function Do(e, n) {
  let r;
  return i;
  function i(a) {
    return In(a) ? (e.enter("lineEnding"), e.consume(a), e.exit("lineEnding"), r = !0, i) : Yn(a) ? dt(e, i, r ? "linePrefix" : "lineSuffix")(a) : n(a);
  }
}
const dz = {
  name: "definition",
  tokenize: mz
}, uz = {
  partial: !0,
  tokenize: pz
};
function mz(e, n, r) {
  const i = this;
  let a;
  return o;
  function o(v) {
    return e.enter("definition"), s(v);
  }
  function s(v) {
    return F1.call(
      i,
      e,
      l,
      // Note: we don’t need to reset the way `markdown-rs` does.
      r,
      "definitionLabel",
      "definitionLabelMarker",
      "definitionLabelString"
    )(v);
  }
  function l(v) {
    return a = ka(i.sliceSerialize(i.events[i.events.length - 1][1]).slice(1, -1)), v === 58 ? (e.enter("definitionMarker"), e.consume(v), e.exit("definitionMarker"), d) : r(v);
  }
  function d(v) {
    return rr(v) ? Do(e, m)(v) : m(v);
  }
  function m(v) {
    return C1(
      e,
      u,
      // Note: we don’t need to reset the way `markdown-rs` does.
      r,
      "definitionDestination",
      "definitionDestinationLiteral",
      "definitionDestinationLiteralMarker",
      "definitionDestinationRaw",
      "definitionDestinationString"
    )(v);
  }
  function u(v) {
    return e.attempt(uz, f, f)(v);
  }
  function f(v) {
    return Yn(v) ? dt(e, h, "whitespace")(v) : h(v);
  }
  function h(v) {
    return v === null || In(v) ? (e.exit("definition"), i.parser.defined.push(a), n(v)) : r(v);
  }
}
function pz(e, n, r) {
  return i;
  function i(l) {
    return rr(l) ? Do(e, a)(l) : r(l);
  }
  function a(l) {
    return I1(e, o, r, "definitionTitle", "definitionTitleMarker", "definitionTitleString")(l);
  }
  function o(l) {
    return Yn(l) ? dt(e, s, "whitespace")(l) : s(l);
  }
  function s(l) {
    return l === null || In(l) ? n(l) : r(l);
  }
}
const fz = {
  name: "hardBreakEscape",
  tokenize: hz
};
function hz(e, n, r) {
  return i;
  function i(o) {
    return e.enter("hardBreakEscape"), e.consume(o), a;
  }
  function a(o) {
    return In(o) ? (e.exit("hardBreakEscape"), n(o)) : r(o);
  }
}
const yz = {
  name: "headingAtx",
  resolve: gz,
  tokenize: vz
};
function gz(e, n) {
  let r = e.length - 2, i = 3, a, o;
  return e[i][1].type === "whitespace" && (i += 2), r - 2 > i && e[r][1].type === "whitespace" && (r -= 2), e[r][1].type === "atxHeadingSequence" && (i === r - 1 || r - 4 > i && e[r - 2][1].type === "whitespace") && (r -= i + 1 === r ? 2 : 4), r > i && (a = {
    type: "atxHeadingText",
    start: e[i][1].start,
    end: e[r][1].end
  }, o = {
    type: "chunkText",
    start: e[i][1].start,
    end: e[r][1].end,
    contentType: "text"
  }, Gr(e, i, r - i + 1, [["enter", a, n], ["enter", o, n], ["exit", o, n], ["exit", a, n]])), e;
}
function vz(e, n, r) {
  let i = 0;
  return a;
  function a(u) {
    return e.enter("atxHeading"), o(u);
  }
  function o(u) {
    return e.enter("atxHeadingSequence"), s(u);
  }
  function s(u) {
    return u === 35 && i++ < 6 ? (e.consume(u), s) : u === null || rr(u) ? (e.exit("atxHeadingSequence"), l(u)) : r(u);
  }
  function l(u) {
    return u === 35 ? (e.enter("atxHeadingSequence"), d(u)) : u === null || In(u) ? (e.exit("atxHeading"), n(u)) : Yn(u) ? dt(e, l, "whitespace")(u) : (e.enter("atxHeadingText"), m(u));
  }
  function d(u) {
    return u === 35 ? (e.consume(u), d) : (e.exit("atxHeadingSequence"), l(u));
  }
  function m(u) {
    return u === null || u === 35 || rr(u) ? (e.exit("atxHeadingText"), l(u)) : (e.consume(u), m);
  }
}
const kz = [
  "address",
  "article",
  "aside",
  "base",
  "basefont",
  "blockquote",
  "body",
  "caption",
  "center",
  "col",
  "colgroup",
  "dd",
  "details",
  "dialog",
  "dir",
  "div",
  "dl",
  "dt",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "frame",
  "frameset",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hr",
  "html",
  "iframe",
  "legend",
  "li",
  "link",
  "main",
  "menu",
  "menuitem",
  "nav",
  "noframes",
  "ol",
  "optgroup",
  "option",
  "p",
  "param",
  "search",
  "section",
  "summary",
  "table",
  "tbody",
  "td",
  "tfoot",
  "th",
  "thead",
  "title",
  "tr",
  "track",
  "ul"
], Ax = ["pre", "script", "style", "textarea"], bz = {
  concrete: !0,
  name: "htmlFlow",
  resolveTo: Sz,
  tokenize: Nz
}, _z = {
  partial: !0,
  tokenize: wz
}, xz = {
  partial: !0,
  tokenize: jz
};
function Sz(e) {
  let n = e.length;
  for (; n-- && !(e[n][0] === "enter" && e[n][1].type === "htmlFlow"); )
    ;
  return n > 1 && e[n - 2][1].type === "linePrefix" && (e[n][1].start = e[n - 2][1].start, e[n + 1][1].start = e[n - 2][1].start, e.splice(n - 2, 2)), e;
}
function Nz(e, n, r) {
  const i = this;
  let a, o, s, l, d;
  return m;
  function m(H) {
    return u(H);
  }
  function u(H) {
    return e.enter("htmlFlow"), e.enter("htmlFlowData"), e.consume(H), f;
  }
  function f(H) {
    return H === 33 ? (e.consume(H), h) : H === 47 ? (e.consume(H), o = !0, N) : H === 63 ? (e.consume(H), a = 3, i.interrupt ? n : V) : Mr(H) ? (e.consume(H), s = String.fromCharCode(H), j) : r(H);
  }
  function h(H) {
    return H === 45 ? (e.consume(H), a = 2, v) : H === 91 ? (e.consume(H), a = 5, l = 0, w) : Mr(H) ? (e.consume(H), a = 4, i.interrupt ? n : V) : r(H);
  }
  function v(H) {
    return H === 45 ? (e.consume(H), i.interrupt ? n : V) : r(H);
  }
  function w(H) {
    const Ye = "CDATA[";
    return H === Ye.charCodeAt(l++) ? (e.consume(H), l === Ye.length ? i.interrupt ? n : Y : w) : r(H);
  }
  function N(H) {
    return Mr(H) ? (e.consume(H), s = String.fromCharCode(H), j) : r(H);
  }
  function j(H) {
    if (H === null || H === 47 || H === 62 || rr(H)) {
      const Ye = H === 47, ln = s.toLowerCase();
      return !Ye && !o && Ax.includes(ln) ? (a = 1, i.interrupt ? n(H) : Y(H)) : kz.includes(s.toLowerCase()) ? (a = 6, Ye ? (e.consume(H), _) : i.interrupt ? n(H) : Y(H)) : (a = 7, i.interrupt && !i.parser.lazy[i.now().line] ? r(H) : o ? g(H) : O(H));
    }
    return H === 45 || dr(H) ? (e.consume(H), s += String.fromCharCode(H), j) : r(H);
  }
  function _(H) {
    return H === 62 ? (e.consume(H), i.interrupt ? n : Y) : r(H);
  }
  function g(H) {
    return Yn(H) ? (e.consume(H), g) : ne(H);
  }
  function O(H) {
    return H === 47 ? (e.consume(H), ne) : H === 58 || H === 95 || Mr(H) ? (e.consume(H), R) : Yn(H) ? (e.consume(H), O) : ne(H);
  }
  function R(H) {
    return H === 45 || H === 46 || H === 58 || H === 95 || dr(H) ? (e.consume(H), R) : $(H);
  }
  function $(H) {
    return H === 61 ? (e.consume(H), I) : Yn(H) ? (e.consume(H), $) : O(H);
  }
  function I(H) {
    return H === null || H === 60 || H === 61 || H === 62 || H === 96 ? r(H) : H === 34 || H === 39 ? (e.consume(H), d = H, L) : Yn(H) ? (e.consume(H), I) : G(H);
  }
  function L(H) {
    return H === d ? (e.consume(H), d = null, Q) : H === null || In(H) ? r(H) : (e.consume(H), L);
  }
  function G(H) {
    return H === null || H === 34 || H === 39 || H === 47 || H === 60 || H === 61 || H === 62 || H === 96 || rr(H) ? $(H) : (e.consume(H), G);
  }
  function Q(H) {
    return H === 47 || H === 62 || Yn(H) ? O(H) : r(H);
  }
  function ne(H) {
    return H === 62 ? (e.consume(H), q) : r(H);
  }
  function q(H) {
    return H === null || In(H) ? Y(H) : Yn(H) ? (e.consume(H), q) : r(H);
  }
  function Y(H) {
    return H === 45 && a === 2 ? (e.consume(H), je) : H === 60 && a === 1 ? (e.consume(H), pe) : H === 62 && a === 4 ? (e.consume(H), be) : H === 63 && a === 3 ? (e.consume(H), V) : H === 93 && a === 5 ? (e.consume(H), ge) : In(H) && (a === 6 || a === 7) ? (e.exit("htmlFlowData"), e.check(_z, Oe, P)(H)) : H === null || In(H) ? (e.exit("htmlFlowData"), P(H)) : (e.consume(H), Y);
  }
  function P(H) {
    return e.check(xz, B, Oe)(H);
  }
  function B(H) {
    return e.enter("lineEnding"), e.consume(H), e.exit("lineEnding"), ie;
  }
  function ie(H) {
    return H === null || In(H) ? P(H) : (e.enter("htmlFlowData"), Y(H));
  }
  function je(H) {
    return H === 45 ? (e.consume(H), V) : Y(H);
  }
  function pe(H) {
    return H === 47 ? (e.consume(H), s = "", le) : Y(H);
  }
  function le(H) {
    if (H === 62) {
      const Ye = s.toLowerCase();
      return Ax.includes(Ye) ? (e.consume(H), be) : Y(H);
    }
    return Mr(H) && s.length < 8 ? (e.consume(H), s += String.fromCharCode(H), le) : Y(H);
  }
  function ge(H) {
    return H === 93 ? (e.consume(H), V) : Y(H);
  }
  function V(H) {
    return H === 62 ? (e.consume(H), be) : H === 45 && a === 2 ? (e.consume(H), V) : Y(H);
  }
  function be(H) {
    return H === null || In(H) ? (e.exit("htmlFlowData"), Oe(H)) : (e.consume(H), be);
  }
  function Oe(H) {
    return e.exit("htmlFlow"), n(H);
  }
}
function jz(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    return In(s) ? (e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), o) : r(s);
  }
  function o(s) {
    return i.parser.lazy[i.now().line] ? r(s) : n(s);
  }
}
function wz(e, n, r) {
  return i;
  function i(a) {
    return e.enter("lineEnding"), e.consume(a), e.exit("lineEnding"), e.attempt(ac, n, r);
  }
}
const Cz = {
  name: "htmlText",
  tokenize: Fz
};
function Fz(e, n, r) {
  const i = this;
  let a, o, s;
  return l;
  function l(V) {
    return e.enter("htmlText"), e.enter("htmlTextData"), e.consume(V), d;
  }
  function d(V) {
    return V === 33 ? (e.consume(V), m) : V === 47 ? (e.consume(V), $) : V === 63 ? (e.consume(V), O) : Mr(V) ? (e.consume(V), G) : r(V);
  }
  function m(V) {
    return V === 45 ? (e.consume(V), u) : V === 91 ? (e.consume(V), o = 0, w) : Mr(V) ? (e.consume(V), g) : r(V);
  }
  function u(V) {
    return V === 45 ? (e.consume(V), v) : r(V);
  }
  function f(V) {
    return V === null ? r(V) : V === 45 ? (e.consume(V), h) : In(V) ? (s = f, pe(V)) : (e.consume(V), f);
  }
  function h(V) {
    return V === 45 ? (e.consume(V), v) : f(V);
  }
  function v(V) {
    return V === 62 ? je(V) : V === 45 ? h(V) : f(V);
  }
  function w(V) {
    const be = "CDATA[";
    return V === be.charCodeAt(o++) ? (e.consume(V), o === be.length ? N : w) : r(V);
  }
  function N(V) {
    return V === null ? r(V) : V === 93 ? (e.consume(V), j) : In(V) ? (s = N, pe(V)) : (e.consume(V), N);
  }
  function j(V) {
    return V === 93 ? (e.consume(V), _) : N(V);
  }
  function _(V) {
    return V === 62 ? je(V) : V === 93 ? (e.consume(V), _) : N(V);
  }
  function g(V) {
    return V === null || V === 62 ? je(V) : In(V) ? (s = g, pe(V)) : (e.consume(V), g);
  }
  function O(V) {
    return V === null ? r(V) : V === 63 ? (e.consume(V), R) : In(V) ? (s = O, pe(V)) : (e.consume(V), O);
  }
  function R(V) {
    return V === 62 ? je(V) : O(V);
  }
  function $(V) {
    return Mr(V) ? (e.consume(V), I) : r(V);
  }
  function I(V) {
    return V === 45 || dr(V) ? (e.consume(V), I) : L(V);
  }
  function L(V) {
    return In(V) ? (s = L, pe(V)) : Yn(V) ? (e.consume(V), L) : je(V);
  }
  function G(V) {
    return V === 45 || dr(V) ? (e.consume(V), G) : V === 47 || V === 62 || rr(V) ? Q(V) : r(V);
  }
  function Q(V) {
    return V === 47 ? (e.consume(V), je) : V === 58 || V === 95 || Mr(V) ? (e.consume(V), ne) : In(V) ? (s = Q, pe(V)) : Yn(V) ? (e.consume(V), Q) : je(V);
  }
  function ne(V) {
    return V === 45 || V === 46 || V === 58 || V === 95 || dr(V) ? (e.consume(V), ne) : q(V);
  }
  function q(V) {
    return V === 61 ? (e.consume(V), Y) : In(V) ? (s = q, pe(V)) : Yn(V) ? (e.consume(V), q) : Q(V);
  }
  function Y(V) {
    return V === null || V === 60 || V === 61 || V === 62 || V === 96 ? r(V) : V === 34 || V === 39 ? (e.consume(V), a = V, P) : In(V) ? (s = Y, pe(V)) : Yn(V) ? (e.consume(V), Y) : (e.consume(V), B);
  }
  function P(V) {
    return V === a ? (e.consume(V), a = void 0, ie) : V === null ? r(V) : In(V) ? (s = P, pe(V)) : (e.consume(V), P);
  }
  function B(V) {
    return V === null || V === 34 || V === 39 || V === 60 || V === 61 || V === 96 ? r(V) : V === 47 || V === 62 || rr(V) ? Q(V) : (e.consume(V), B);
  }
  function ie(V) {
    return V === 47 || V === 62 || rr(V) ? Q(V) : r(V);
  }
  function je(V) {
    return V === 62 ? (e.consume(V), e.exit("htmlTextData"), e.exit("htmlText"), n) : r(V);
  }
  function pe(V) {
    return e.exit("htmlTextData"), e.enter("lineEnding"), e.consume(V), e.exit("lineEnding"), le;
  }
  function le(V) {
    return Yn(V) ? dt(e, ge, "linePrefix", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(V) : ge(V);
  }
  function ge(V) {
    return e.enter("htmlTextData"), s(V);
  }
}
const Cg = {
  name: "labelEnd",
  resolveAll: Tz,
  resolveTo: Rz,
  tokenize: Dz
}, Iz = {
  tokenize: Oz
}, $z = {
  tokenize: Pz
}, Ez = {
  tokenize: Az
};
function Tz(e) {
  let n = -1;
  const r = [];
  for (; ++n < e.length; ) {
    const i = e[n][1];
    if (r.push(e[n]), i.type === "labelImage" || i.type === "labelLink" || i.type === "labelEnd") {
      const a = i.type === "labelImage" ? 4 : 2;
      i.type = "data", n += a;
    }
  }
  return e.length !== r.length && Gr(e, 0, e.length, r), e;
}
function Rz(e, n) {
  let r = e.length, i = 0, a, o, s, l;
  for (; r--; )
    if (a = e[r][1], o) {
      if (a.type === "link" || a.type === "labelLink" && a._inactive)
        break;
      e[r][0] === "enter" && a.type === "labelLink" && (a._inactive = !0);
    } else if (s) {
      if (e[r][0] === "enter" && (a.type === "labelImage" || a.type === "labelLink") && !a._balanced && (o = r, a.type !== "labelLink")) {
        i = 2;
        break;
      }
    } else a.type === "labelEnd" && (s = r);
  const d = {
    type: e[o][1].type === "labelLink" ? "link" : "image",
    start: {
      ...e[o][1].start
    },
    end: {
      ...e[e.length - 1][1].end
    }
  }, m = {
    type: "label",
    start: {
      ...e[o][1].start
    },
    end: {
      ...e[s][1].end
    }
  }, u = {
    type: "labelText",
    start: {
      ...e[o + i + 2][1].end
    },
    end: {
      ...e[s - 2][1].start
    }
  };
  return l = [["enter", d, n], ["enter", m, n]], l = xr(l, e.slice(o + 1, o + i + 3)), l = xr(l, [["enter", u, n]]), l = xr(l, wg(n.parser.constructs.insideSpan.null, e.slice(o + i + 4, s - 3), n)), l = xr(l, [["exit", u, n], e[s - 2], e[s - 1], ["exit", m, n]]), l = xr(l, e.slice(s + 1)), l = xr(l, [["exit", d, n]]), Gr(e, o, e.length, l), e;
}
function Dz(e, n, r) {
  const i = this;
  let a = i.events.length, o, s;
  for (; a--; )
    if ((i.events[a][1].type === "labelImage" || i.events[a][1].type === "labelLink") && !i.events[a][1]._balanced) {
      o = i.events[a][1];
      break;
    }
  return l;
  function l(h) {
    return o ? o._inactive ? f(h) : (s = i.parser.defined.includes(ka(i.sliceSerialize({
      start: o.end,
      end: i.now()
    }))), e.enter("labelEnd"), e.enter("labelMarker"), e.consume(h), e.exit("labelMarker"), e.exit("labelEnd"), d) : r(h);
  }
  function d(h) {
    return h === 40 ? e.attempt(Iz, u, s ? u : f)(h) : h === 91 ? e.attempt($z, u, s ? m : f)(h) : s ? u(h) : f(h);
  }
  function m(h) {
    return e.attempt(Ez, u, f)(h);
  }
  function u(h) {
    return n(h);
  }
  function f(h) {
    return o._balanced = !0, r(h);
  }
}
function Oz(e, n, r) {
  return i;
  function i(f) {
    return e.enter("resource"), e.enter("resourceMarker"), e.consume(f), e.exit("resourceMarker"), a;
  }
  function a(f) {
    return rr(f) ? Do(e, o)(f) : o(f);
  }
  function o(f) {
    return f === 41 ? u(f) : C1(e, s, l, "resourceDestination", "resourceDestinationLiteral", "resourceDestinationLiteralMarker", "resourceDestinationRaw", "resourceDestinationString", 32)(f);
  }
  function s(f) {
    return rr(f) ? Do(e, d)(f) : u(f);
  }
  function l(f) {
    return r(f);
  }
  function d(f) {
    return f === 34 || f === 39 || f === 40 ? I1(e, m, r, "resourceTitle", "resourceTitleMarker", "resourceTitleString")(f) : u(f);
  }
  function m(f) {
    return rr(f) ? Do(e, u)(f) : u(f);
  }
  function u(f) {
    return f === 41 ? (e.enter("resourceMarker"), e.consume(f), e.exit("resourceMarker"), e.exit("resource"), n) : r(f);
  }
}
function Pz(e, n, r) {
  const i = this;
  return a;
  function a(l) {
    return F1.call(i, e, o, s, "reference", "referenceMarker", "referenceString")(l);
  }
  function o(l) {
    return i.parser.defined.includes(ka(i.sliceSerialize(i.events[i.events.length - 1][1]).slice(1, -1))) ? n(l) : r(l);
  }
  function s(l) {
    return r(l);
  }
}
function Az(e, n, r) {
  return i;
  function i(o) {
    return e.enter("reference"), e.enter("referenceMarker"), e.consume(o), e.exit("referenceMarker"), a;
  }
  function a(o) {
    return o === 93 ? (e.enter("referenceMarker"), e.consume(o), e.exit("referenceMarker"), e.exit("reference"), n) : r(o);
  }
}
const Lz = {
  name: "labelStartImage",
  resolveAll: Cg.resolveAll,
  tokenize: Vz
};
function Vz(e, n, r) {
  const i = this;
  return a;
  function a(l) {
    return e.enter("labelImage"), e.enter("labelImageMarker"), e.consume(l), e.exit("labelImageMarker"), o;
  }
  function o(l) {
    return l === 91 ? (e.enter("labelMarker"), e.consume(l), e.exit("labelMarker"), e.exit("labelImage"), s) : r(l);
  }
  function s(l) {
    return l === 94 && "_hiddenFootnoteSupport" in i.parser.constructs ? r(l) : n(l);
  }
}
const zz = {
  name: "labelStartLink",
  resolveAll: Cg.resolveAll,
  tokenize: Uz
};
function Uz(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    return e.enter("labelLink"), e.enter("labelMarker"), e.consume(s), e.exit("labelMarker"), e.exit("labelLink"), o;
  }
  function o(s) {
    return s === 94 && "_hiddenFootnoteSupport" in i.parser.constructs ? r(s) : n(s);
  }
}
const Fm = {
  name: "lineEnding",
  tokenize: Mz
};
function Mz(e, n) {
  return r;
  function r(i) {
    return e.enter("lineEnding"), e.consume(i), e.exit("lineEnding"), dt(e, n, "linePrefix");
  }
}
const ol = {
  name: "thematicBreak",
  tokenize: Bz
};
function Bz(e, n, r) {
  let i = 0, a;
  return o;
  function o(m) {
    return e.enter("thematicBreak"), s(m);
  }
  function s(m) {
    return a = m, l(m);
  }
  function l(m) {
    return m === a ? (e.enter("thematicBreakSequence"), d(m)) : i >= 3 && (m === null || In(m)) ? (e.exit("thematicBreak"), n(m)) : r(m);
  }
  function d(m) {
    return m === a ? (e.consume(m), i++, d) : (e.exit("thematicBreakSequence"), Yn(m) ? dt(e, l, "whitespace")(m) : l(m));
  }
}
const nr = {
  continuation: {
    tokenize: Kz
  },
  exit: Yz,
  name: "list",
  tokenize: Wz
}, qz = {
  partial: !0,
  tokenize: Jz
}, Hz = {
  partial: !0,
  tokenize: Gz
};
function Wz(e, n, r) {
  const i = this, a = i.events[i.events.length - 1];
  let o = a && a[1].type === "linePrefix" ? a[2].sliceSerialize(a[1], !0).length : 0, s = 0;
  return l;
  function l(v) {
    const w = i.containerState.type || (v === 42 || v === 43 || v === 45 ? "listUnordered" : "listOrdered");
    if (w === "listUnordered" ? !i.containerState.marker || v === i.containerState.marker : my(v)) {
      if (i.containerState.type || (i.containerState.type = w, e.enter(w, {
        _container: !0
      })), w === "listUnordered")
        return e.enter("listItemPrefix"), v === 42 || v === 45 ? e.check(ol, r, m)(v) : m(v);
      if (!i.interrupt || v === 49)
        return e.enter("listItemPrefix"), e.enter("listItemValue"), d(v);
    }
    return r(v);
  }
  function d(v) {
    return my(v) && ++s < 10 ? (e.consume(v), d) : (!i.interrupt || s < 2) && (i.containerState.marker ? v === i.containerState.marker : v === 41 || v === 46) ? (e.exit("listItemValue"), m(v)) : r(v);
  }
  function m(v) {
    return e.enter("listItemMarker"), e.consume(v), e.exit("listItemMarker"), i.containerState.marker = i.containerState.marker || v, e.check(
      ac,
      // Can’t be empty when interrupting.
      i.interrupt ? r : u,
      e.attempt(qz, h, f)
    );
  }
  function u(v) {
    return i.containerState.initialBlankLine = !0, o++, h(v);
  }
  function f(v) {
    return Yn(v) ? (e.enter("listItemPrefixWhitespace"), e.consume(v), e.exit("listItemPrefixWhitespace"), h) : r(v);
  }
  function h(v) {
    return i.containerState.size = o + i.sliceSerialize(e.exit("listItemPrefix"), !0).length, n(v);
  }
}
function Kz(e, n, r) {
  const i = this;
  return i.containerState._closeFlow = void 0, e.check(ac, a, o);
  function a(l) {
    return i.containerState.furtherBlankLines = i.containerState.furtherBlankLines || i.containerState.initialBlankLine, dt(e, n, "listItemIndent", i.containerState.size + 1)(l);
  }
  function o(l) {
    return i.containerState.furtherBlankLines || !Yn(l) ? (i.containerState.furtherBlankLines = void 0, i.containerState.initialBlankLine = void 0, s(l)) : (i.containerState.furtherBlankLines = void 0, i.containerState.initialBlankLine = void 0, e.attempt(Hz, n, s)(l));
  }
  function s(l) {
    return i.containerState._closeFlow = !0, i.interrupt = void 0, dt(e, e.attempt(nr, n, r), "linePrefix", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(l);
  }
}
function Gz(e, n, r) {
  const i = this;
  return dt(e, a, "listItemIndent", i.containerState.size + 1);
  function a(o) {
    const s = i.events[i.events.length - 1];
    return s && s[1].type === "listItemIndent" && s[2].sliceSerialize(s[1], !0).length === i.containerState.size ? n(o) : r(o);
  }
}
function Yz(e) {
  e.exit(this.containerState.type);
}
function Jz(e, n, r) {
  const i = this;
  return dt(e, a, "listItemPrefixWhitespace", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 5);
  function a(o) {
    const s = i.events[i.events.length - 1];
    return !Yn(o) && s && s[1].type === "listItemPrefixWhitespace" ? n(o) : r(o);
  }
}
const Lx = {
  name: "setextUnderline",
  resolveTo: Qz,
  tokenize: Xz
};
function Qz(e, n) {
  let r = e.length, i, a, o;
  for (; r--; )
    if (e[r][0] === "enter") {
      if (e[r][1].type === "content") {
        i = r;
        break;
      }
      e[r][1].type === "paragraph" && (a = r);
    } else
      e[r][1].type === "content" && e.splice(r, 1), !o && e[r][1].type === "definition" && (o = r);
  const s = {
    type: "setextHeading",
    start: {
      ...e[a][1].start
    },
    end: {
      ...e[e.length - 1][1].end
    }
  };
  return e[a][1].type = "setextHeadingText", o ? (e.splice(a, 0, ["enter", s, n]), e.splice(o + 1, 0, ["exit", e[i][1], n]), e[i][1].end = {
    ...e[o][1].end
  }) : e[i][1] = s, e.push(["exit", s, n]), e;
}
function Xz(e, n, r) {
  const i = this;
  let a;
  return o;
  function o(m) {
    let u = i.events.length, f;
    for (; u--; )
      if (i.events[u][1].type !== "lineEnding" && i.events[u][1].type !== "linePrefix" && i.events[u][1].type !== "content") {
        f = i.events[u][1].type === "paragraph";
        break;
      }
    return !i.parser.lazy[i.now().line] && (i.interrupt || f) ? (e.enter("setextHeadingLine"), a = m, s(m)) : r(m);
  }
  function s(m) {
    return e.enter("setextHeadingLineSequence"), l(m);
  }
  function l(m) {
    return m === a ? (e.consume(m), l) : (e.exit("setextHeadingLineSequence"), Yn(m) ? dt(e, d, "lineSuffix")(m) : d(m));
  }
  function d(m) {
    return m === null || In(m) ? (e.exit("setextHeadingLine"), n(m)) : r(m);
  }
}
const Zz = {
  tokenize: eU
};
function eU(e) {
  const n = this, r = e.attempt(
    // Try to parse a blank line.
    ac,
    i,
    // Try to parse initial flow (essentially, only code).
    e.attempt(this.parser.constructs.flowInitial, a, dt(e, e.attempt(this.parser.constructs.flow, a, e.attempt(az, a)), "linePrefix"))
  );
  return r;
  function i(o) {
    if (o === null) {
      e.consume(o);
      return;
    }
    return e.enter("lineEndingBlank"), e.consume(o), e.exit("lineEndingBlank"), n.currentConstruct = void 0, r;
  }
  function a(o) {
    if (o === null) {
      e.consume(o);
      return;
    }
    return e.enter("lineEnding"), e.consume(o), e.exit("lineEnding"), n.currentConstruct = void 0, r;
  }
}
const nU = {
  resolveAll: E1()
}, tU = $1("string"), rU = $1("text");
function $1(e) {
  return {
    resolveAll: E1(e === "text" ? iU : void 0),
    tokenize: n
  };
  function n(r) {
    const i = this, a = this.parser.constructs[e], o = r.attempt(a, s, l);
    return s;
    function s(u) {
      return m(u) ? o(u) : l(u);
    }
    function l(u) {
      if (u === null) {
        r.consume(u);
        return;
      }
      return r.enter("data"), r.consume(u), d;
    }
    function d(u) {
      return m(u) ? (r.exit("data"), o(u)) : (r.consume(u), d);
    }
    function m(u) {
      if (u === null)
        return !0;
      const f = a[u];
      let h = -1;
      if (f)
        for (; ++h < f.length; ) {
          const v = f[h];
          if (!v.previous || v.previous.call(i, i.previous))
            return !0;
        }
      return !1;
    }
  }
}
function E1(e) {
  return n;
  function n(r, i) {
    let a = -1, o;
    for (; ++a <= r.length; )
      o === void 0 ? r[a] && r[a][1].type === "data" && (o = a, a++) : (!r[a] || r[a][1].type !== "data") && (a !== o + 2 && (r[o][1].end = r[a - 1][1].end, r.splice(o + 2, a - o - 2), a = o + 2), o = void 0);
    return e ? e(r, i) : r;
  }
}
function iU(e, n) {
  let r = 0;
  for (; ++r <= e.length; )
    if ((r === e.length || e[r][1].type === "lineEnding") && e[r - 1][1].type === "data") {
      const i = e[r - 1][1], a = n.sliceStream(i);
      let o = a.length, s = -1, l = 0, d;
      for (; o--; ) {
        const m = a[o];
        if (typeof m == "string") {
          for (s = m.length; m.charCodeAt(s - 1) === 32; )
            l++, s--;
          if (s) break;
          s = -1;
        } else if (m === -2)
          d = !0, l++;
        else if (m !== -1) {
          o++;
          break;
        }
      }
      if (l) {
        const m = {
          type: r === e.length || d || l < 2 ? "lineSuffix" : "hardBreakTrailing",
          start: {
            _bufferIndex: o ? s : i.start._bufferIndex + s,
            _index: i.start._index + o,
            line: i.end.line,
            column: i.end.column - l,
            offset: i.end.offset - l
          },
          end: {
            ...i.end
          }
        };
        i.end = {
          ...m.start
        }, i.start.offset === i.end.offset ? Object.assign(i, m) : (e.splice(r, 0, ["enter", m, n], ["exit", m, n]), r += 2);
      }
      r++;
    }
  return e;
}
const aU = {
  42: nr,
  43: nr,
  45: nr,
  48: nr,
  49: nr,
  50: nr,
  51: nr,
  52: nr,
  53: nr,
  54: nr,
  55: nr,
  56: nr,
  57: nr,
  62: S1
}, oU = {
  91: dz
}, sU = {
  [-2]: Cm,
  [-1]: Cm,
  32: Cm
}, lU = {
  35: yz,
  42: ol,
  45: [Lx, ol],
  60: bz,
  61: Lx,
  95: ol,
  96: Px,
  126: Px
}, cU = {
  38: j1,
  92: N1
}, dU = {
  [-5]: Fm,
  [-4]: Fm,
  [-3]: Fm,
  33: Lz,
  38: j1,
  42: py,
  60: [z3, Cz],
  91: zz,
  92: [fz, N1],
  93: Cg,
  95: py,
  96: Z3
}, uU = {
  null: [py, nU]
}, mU = {
  null: [42, 95]
}, pU = {
  null: []
}, fU = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  attentionMarkers: mU,
  contentInitial: oU,
  disable: pU,
  document: aU,
  flow: lU,
  flowInitial: sU,
  insideSpan: uU,
  string: cU,
  text: dU
}, Symbol.toStringTag, { value: "Module" }));
function hU(e, n, r) {
  let i = {
    _bufferIndex: -1,
    _index: 0,
    line: r && r.line || 1,
    column: r && r.column || 1,
    offset: r && r.offset || 0
  };
  const a = {}, o = [];
  let s = [], l = [];
  const d = {
    attempt: L($),
    check: L(I),
    consume: g,
    enter: O,
    exit: R,
    interrupt: L(I, {
      interrupt: !0
    })
  }, m = {
    code: null,
    containerState: {},
    defineSkip: N,
    events: [],
    now: w,
    parser: e,
    previous: null,
    sliceSerialize: h,
    sliceStream: v,
    write: f
  };
  let u = n.tokenize.call(m, d);
  return n.resolveAll && o.push(n), m;
  function f(q) {
    return s = xr(s, q), j(), s[s.length - 1] !== null ? [] : (G(n, 0), m.events = wg(o, m.events, m), m.events);
  }
  function h(q, Y) {
    return gU(v(q), Y);
  }
  function v(q) {
    return yU(s, q);
  }
  function w() {
    const {
      _bufferIndex: q,
      _index: Y,
      line: P,
      column: B,
      offset: ie
    } = i;
    return {
      _bufferIndex: q,
      _index: Y,
      line: P,
      column: B,
      offset: ie
    };
  }
  function N(q) {
    a[q.line] = q.column, ne();
  }
  function j() {
    let q;
    for (; i._index < s.length; ) {
      const Y = s[i._index];
      if (typeof Y == "string")
        for (q = i._index, i._bufferIndex < 0 && (i._bufferIndex = 0); i._index === q && i._bufferIndex < Y.length; )
          _(Y.charCodeAt(i._bufferIndex));
      else
        _(Y);
    }
  }
  function _(q) {
    u = u(q);
  }
  function g(q) {
    In(q) ? (i.line++, i.column = 1, i.offset += q === -3 ? 2 : 1, ne()) : q !== -1 && (i.column++, i.offset++), i._bufferIndex < 0 ? i._index++ : (i._bufferIndex++, i._bufferIndex === // Points w/ non-negative `_bufferIndex` reference
    // strings.
    /** @type {string} */
    s[i._index].length && (i._bufferIndex = -1, i._index++)), m.previous = q;
  }
  function O(q, Y) {
    const P = Y || {};
    return P.type = q, P.start = w(), m.events.push(["enter", P, m]), l.push(P), P;
  }
  function R(q) {
    const Y = l.pop();
    return Y.end = w(), m.events.push(["exit", Y, m]), Y;
  }
  function $(q, Y) {
    G(q, Y.from);
  }
  function I(q, Y) {
    Y.restore();
  }
  function L(q, Y) {
    return P;
    function P(B, ie, je) {
      let pe, le, ge, V;
      return Array.isArray(B) ? (
        /* c8 ignore next 1 */
        Oe(B)
      ) : "tokenize" in B ? (
        // Looks like a construct.
        Oe([
          /** @type {Construct} */
          B
        ])
      ) : be(B);
      function be(Ie) {
        return Ue;
        function Ue(De) {
          const Be = De !== null && Ie[De], Ae = De !== null && Ie.null, Qe = [
            // To do: add more extension tests.
            /* c8 ignore next 2 */
            ...Array.isArray(Be) ? Be : Be ? [Be] : [],
            ...Array.isArray(Ae) ? Ae : Ae ? [Ae] : []
          ];
          return Oe(Qe)(De);
        }
      }
      function Oe(Ie) {
        return pe = Ie, le = 0, Ie.length === 0 ? je : H(Ie[le]);
      }
      function H(Ie) {
        return Ue;
        function Ue(De) {
          return V = Q(), ge = Ie, Ie.partial || (m.currentConstruct = Ie), Ie.name && m.parser.constructs.disable.null.includes(Ie.name) ? ln() : Ie.tokenize.call(
            // If we do have fields, create an object w/ `context` as its
            // prototype.
            // This allows a “live binding”, which is needed for `interrupt`.
            Y ? Object.assign(Object.create(m), Y) : m,
            d,
            Ye,
            ln
          )(De);
        }
      }
      function Ye(Ie) {
        return q(ge, V), ie;
      }
      function ln(Ie) {
        return V.restore(), ++le < pe.length ? H(pe[le]) : je;
      }
    }
  }
  function G(q, Y) {
    q.resolveAll && !o.includes(q) && o.push(q), q.resolve && Gr(m.events, Y, m.events.length - Y, q.resolve(m.events.slice(Y), m)), q.resolveTo && (m.events = q.resolveTo(m.events, m));
  }
  function Q() {
    const q = w(), Y = m.previous, P = m.currentConstruct, B = m.events.length, ie = Array.from(l);
    return {
      from: B,
      restore: je
    };
    function je() {
      i = q, m.previous = Y, m.currentConstruct = P, m.events.length = B, l = ie, ne();
    }
  }
  function ne() {
    i.line in a && i.column < 2 && (i.column = a[i.line], i.offset += a[i.line] - 1);
  }
}
function yU(e, n) {
  const r = n.start._index, i = n.start._bufferIndex, a = n.end._index, o = n.end._bufferIndex;
  let s;
  if (r === a)
    s = [e[r].slice(i, o)];
  else {
    if (s = e.slice(r, a), i > -1) {
      const l = s[0];
      typeof l == "string" ? s[0] = l.slice(i) : s.shift();
    }
    o > 0 && s.push(e[a].slice(0, o));
  }
  return s;
}
function gU(e, n) {
  let r = -1;
  const i = [];
  let a;
  for (; ++r < e.length; ) {
    const o = e[r];
    let s;
    if (typeof o == "string")
      s = o;
    else switch (o) {
      case -5: {
        s = "\r";
        break;
      }
      case -4: {
        s = `
`;
        break;
      }
      case -3: {
        s = `\r
`;
        break;
      }
      case -2: {
        s = n ? " " : "	";
        break;
      }
      case -1: {
        if (!n && a) continue;
        s = " ";
        break;
      }
      default:
        s = String.fromCharCode(o);
    }
    a = o === -2, i.push(s);
  }
  return i.join("");
}
function vU(e) {
  const i = {
    constructs: (
      /** @type {FullNormalizedExtension} */
      j3([fU, ...(e || {}).extensions || []])
    ),
    content: a(R3),
    defined: [],
    document: a(O3),
    flow: a(Zz),
    lazy: {},
    string: a(tU),
    text: a(rU)
  };
  return i;
  function a(o) {
    return s;
    function s(l) {
      return hU(i, o, l);
    }
  }
}
function kU(e) {
  for (; !w1(e); )
    ;
  return e;
}
const Vx = /[\0\t\n\r]/g;
function bU() {
  let e = 1, n = "", r = !0, i;
  return a;
  function a(o, s, l) {
    const d = [];
    let m, u, f, h, v;
    for (o = n + (typeof o == "string" ? o.toString() : new TextDecoder(s || void 0).decode(o)), f = 0, n = "", r && (o.charCodeAt(0) === 65279 && f++, r = void 0); f < o.length; ) {
      if (Vx.lastIndex = f, m = Vx.exec(o), h = m && m.index !== void 0 ? m.index : o.length, v = o.charCodeAt(h), !m) {
        n = o.slice(f);
        break;
      }
      if (v === 10 && f === h && i)
        d.push(-3), i = void 0;
      else
        switch (i && (d.push(-5), i = void 0), f < h && (d.push(o.slice(f, h)), e += h - f), v) {
          case 0: {
            d.push(65533), e++;
            break;
          }
          case 9: {
            for (u = Math.ceil(e / 4) * 4, d.push(-2); e++ < u; ) d.push(-1);
            break;
          }
          case 10: {
            d.push(-4), e = 1;
            break;
          }
          default:
            i = !0, e = 1;
        }
      f = h + 1;
    }
    return l && (i && d.push(-5), n && d.push(n), d.push(null)), d;
  }
}
const _U = /\\([!-/:-@[-`{-~])|&(#(?:\d{1,7}|x[\da-f]{1,6})|[\da-z]{1,31});/gi;
function xU(e) {
  return e.replace(_U, SU);
}
function SU(e, n, r) {
  if (n)
    return n;
  if (r.charCodeAt(0) === 35) {
    const a = r.charCodeAt(1), o = a === 120 || a === 88;
    return x1(r.slice(o ? 2 : 1), o ? 16 : 10);
  }
  return jg(r) || e;
}
const T1 = {}.hasOwnProperty;
function NU(e, n, r) {
  return typeof n != "string" && (r = n, n = void 0), jU(r)(kU(vU(r).document().write(bU()(e, n, !0))));
}
function jU(e) {
  const n = {
    transforms: [],
    canContainEols: ["emphasis", "fragment", "heading", "paragraph", "strong"],
    enter: {
      autolink: o(Pe),
      autolinkProtocol: Q,
      autolinkEmail: Q,
      atxHeading: o(se),
      blockQuote: o(Ae),
      characterEscape: Q,
      characterReference: Q,
      codeFenced: o(Qe),
      codeFencedFenceInfo: s,
      codeFencedFenceMeta: s,
      codeIndented: o(Qe, s),
      codeText: o(Ee, s),
      codeTextData: Q,
      data: Q,
      codeFlowValue: Q,
      definition: o(Me),
      definitionDestinationString: s,
      definitionLabelString: s,
      definitionTitleString: s,
      emphasis: o(en),
      hardBreakEscape: o(ce),
      hardBreakTrailing: o(ce),
      htmlFlow: o(Se, s),
      htmlFlowData: Q,
      htmlText: o(Se, s),
      htmlTextData: Q,
      image: o(Ve),
      label: s,
      link: o(Pe),
      listItem: o(X),
      listItemValue: h,
      listOrdered: o(kn, f),
      listUnordered: o(kn),
      paragraph: o(E),
      reference: H,
      referenceString: s,
      resourceDestinationString: s,
      resourceTitleString: s,
      setextHeading: o(se),
      strong: o(z),
      thematicBreak: o(de)
    },
    exit: {
      atxHeading: d(),
      atxHeadingSequence: $,
      autolink: d(),
      autolinkEmail: Be,
      autolinkProtocol: De,
      blockQuote: d(),
      characterEscapeValue: ne,
      characterReferenceMarkerHexadecimal: ln,
      characterReferenceMarkerNumeric: ln,
      characterReferenceValue: Ie,
      characterReference: Ue,
      codeFenced: d(j),
      codeFencedFence: N,
      codeFencedFenceInfo: v,
      codeFencedFenceMeta: w,
      codeFlowValue: ne,
      codeIndented: d(_),
      codeText: d(ie),
      codeTextData: ne,
      data: ne,
      definition: d(),
      definitionDestinationString: R,
      definitionLabelString: g,
      definitionTitleString: O,
      emphasis: d(),
      hardBreakEscape: d(Y),
      hardBreakTrailing: d(Y),
      htmlFlow: d(P),
      htmlFlowData: ne,
      htmlText: d(B),
      htmlTextData: ne,
      image: d(pe),
      label: ge,
      labelText: le,
      lineEnding: q,
      link: d(je),
      listItem: d(),
      listOrdered: d(),
      listUnordered: d(),
      paragraph: d(),
      referenceString: Ye,
      resourceDestinationString: V,
      resourceTitleString: be,
      resource: Oe,
      setextHeading: d(G),
      setextHeadingLineSequence: L,
      setextHeadingText: I,
      strong: d(),
      thematicBreak: d()
    }
  };
  R1(n, (e || {}).mdastExtensions || []);
  const r = {};
  return i;
  function i(U) {
    let J = {
      type: "root",
      children: []
    };
    const ve = {
      stack: [J],
      tokenStack: [],
      config: n,
      enter: l,
      exit: m,
      buffer: s,
      resume: u,
      data: r
    }, we = [];
    let Re = -1;
    for (; ++Re < U.length; )
      if (U[Re][1].type === "listOrdered" || U[Re][1].type === "listUnordered")
        if (U[Re][0] === "enter")
          we.push(Re);
        else {
          const rn = we.pop();
          Re = a(U, rn, Re);
        }
    for (Re = -1; ++Re < U.length; ) {
      const rn = n[U[Re][0]];
      T1.call(rn, U[Re][1].type) && rn[U[Re][1].type].call(Object.assign({
        sliceSerialize: U[Re][2].sliceSerialize
      }, ve), U[Re][1]);
    }
    if (ve.tokenStack.length > 0) {
      const rn = ve.tokenStack[ve.tokenStack.length - 1];
      (rn[1] || zx).call(ve, void 0, rn[0]);
    }
    for (J.position = {
      start: mi(U.length > 0 ? U[0][1].start : {
        line: 1,
        column: 1,
        offset: 0
      }),
      end: mi(U.length > 0 ? U[U.length - 2][1].end : {
        line: 1,
        column: 1,
        offset: 0
      })
    }, Re = -1; ++Re < n.transforms.length; )
      J = n.transforms[Re](J) || J;
    return J;
  }
  function a(U, J, ve) {
    let we = J - 1, Re = -1, rn = !1, bn, an, hn, En;
    for (; ++we <= ve; ) {
      const _n = U[we];
      switch (_n[1].type) {
        case "listUnordered":
        case "listOrdered":
        case "blockQuote": {
          _n[0] === "enter" ? Re++ : Re--, En = void 0;
          break;
        }
        case "lineEndingBlank": {
          _n[0] === "enter" && (bn && !En && !Re && !hn && (hn = we), En = void 0);
          break;
        }
        case "linePrefix":
        case "listItemValue":
        case "listItemMarker":
        case "listItemPrefix":
        case "listItemPrefixWhitespace":
          break;
        default:
          En = void 0;
      }
      if (!Re && _n[0] === "enter" && _n[1].type === "listItemPrefix" || Re === -1 && _n[0] === "exit" && (_n[1].type === "listUnordered" || _n[1].type === "listOrdered")) {
        if (bn) {
          let Fn = we;
          for (an = void 0; Fn--; ) {
            const Ze = U[Fn];
            if (Ze[1].type === "lineEnding" || Ze[1].type === "lineEndingBlank") {
              if (Ze[0] === "exit") continue;
              an && (U[an][1].type = "lineEndingBlank", rn = !0), Ze[1].type = "lineEnding", an = Fn;
            } else if (!(Ze[1].type === "linePrefix" || Ze[1].type === "blockQuotePrefix" || Ze[1].type === "blockQuotePrefixWhitespace" || Ze[1].type === "blockQuoteMarker" || Ze[1].type === "listItemIndent")) break;
          }
          hn && (!an || hn < an) && (bn._spread = !0), bn.end = Object.assign({}, an ? U[an][1].start : _n[1].end), U.splice(an || we, 0, ["exit", bn, _n[2]]), we++, ve++;
        }
        if (_n[1].type === "listItemPrefix") {
          const Fn = {
            type: "listItem",
            _spread: !1,
            start: Object.assign({}, _n[1].start),
            // @ts-expect-error: we’ll add `end` in a second.
            end: void 0
          };
          bn = Fn, U.splice(we, 0, ["enter", Fn, _n[2]]), we++, ve++, hn = void 0, En = !0;
        }
      }
    }
    return U[J][1]._spread = rn, ve;
  }
  function o(U, J) {
    return ve;
    function ve(we) {
      l.call(this, U(we), we), J && J.call(this, we);
    }
  }
  function s() {
    this.stack.push({
      type: "fragment",
      children: []
    });
  }
  function l(U, J, ve) {
    this.stack[this.stack.length - 1].children.push(U), this.stack.push(U), this.tokenStack.push([J, ve || void 0]), U.position = {
      start: mi(J.start),
      // @ts-expect-error: `end` will be patched later.
      end: void 0
    };
  }
  function d(U) {
    return J;
    function J(ve) {
      U && U.call(this, ve), m.call(this, ve);
    }
  }
  function m(U, J) {
    const ve = this.stack.pop(), we = this.tokenStack.pop();
    if (we)
      we[0].type !== U.type && (J ? J.call(this, U, we[0]) : (we[1] || zx).call(this, U, we[0]));
    else throw new Error("Cannot close `" + U.type + "` (" + Ro({
      start: U.start,
      end: U.end
    }) + "): it’s not open");
    ve.position.end = mi(U.end);
  }
  function u() {
    return S3(this.stack.pop());
  }
  function f() {
    this.data.expectingFirstListItemValue = !0;
  }
  function h(U) {
    if (this.data.expectingFirstListItemValue) {
      const J = this.stack[this.stack.length - 2];
      J.start = Number.parseInt(this.sliceSerialize(U), 10), this.data.expectingFirstListItemValue = void 0;
    }
  }
  function v() {
    const U = this.resume(), J = this.stack[this.stack.length - 1];
    J.lang = U;
  }
  function w() {
    const U = this.resume(), J = this.stack[this.stack.length - 1];
    J.meta = U;
  }
  function N() {
    this.data.flowCodeInside || (this.buffer(), this.data.flowCodeInside = !0);
  }
  function j() {
    const U = this.resume(), J = this.stack[this.stack.length - 1];
    J.value = U.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, ""), this.data.flowCodeInside = void 0;
  }
  function _() {
    const U = this.resume(), J = this.stack[this.stack.length - 1];
    J.value = U.replace(/(\r?\n|\r)$/g, "");
  }
  function g(U) {
    const J = this.resume(), ve = this.stack[this.stack.length - 1];
    ve.label = J, ve.identifier = ka(this.sliceSerialize(U)).toLowerCase();
  }
  function O() {
    const U = this.resume(), J = this.stack[this.stack.length - 1];
    J.title = U;
  }
  function R() {
    const U = this.resume(), J = this.stack[this.stack.length - 1];
    J.url = U;
  }
  function $(U) {
    const J = this.stack[this.stack.length - 1];
    if (!J.depth) {
      const ve = this.sliceSerialize(U).length;
      J.depth = ve;
    }
  }
  function I() {
    this.data.setextHeadingSlurpLineEnding = !0;
  }
  function L(U) {
    const J = this.stack[this.stack.length - 1];
    J.depth = this.sliceSerialize(U).codePointAt(0) === 61 ? 1 : 2;
  }
  function G() {
    this.data.setextHeadingSlurpLineEnding = void 0;
  }
  function Q(U) {
    const ve = this.stack[this.stack.length - 1].children;
    let we = ve[ve.length - 1];
    (!we || we.type !== "text") && (we = ae(), we.position = {
      start: mi(U.start),
      // @ts-expect-error: we’ll add `end` later.
      end: void 0
    }, ve.push(we)), this.stack.push(we);
  }
  function ne(U) {
    const J = this.stack.pop();
    J.value += this.sliceSerialize(U), J.position.end = mi(U.end);
  }
  function q(U) {
    const J = this.stack[this.stack.length - 1];
    if (this.data.atHardBreak) {
      const ve = J.children[J.children.length - 1];
      ve.position.end = mi(U.end), this.data.atHardBreak = void 0;
      return;
    }
    !this.data.setextHeadingSlurpLineEnding && n.canContainEols.includes(J.type) && (Q.call(this, U), ne.call(this, U));
  }
  function Y() {
    this.data.atHardBreak = !0;
  }
  function P() {
    const U = this.resume(), J = this.stack[this.stack.length - 1];
    J.value = U;
  }
  function B() {
    const U = this.resume(), J = this.stack[this.stack.length - 1];
    J.value = U;
  }
  function ie() {
    const U = this.resume(), J = this.stack[this.stack.length - 1];
    J.value = U;
  }
  function je() {
    const U = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const J = this.data.referenceType || "shortcut";
      U.type += "Reference", U.referenceType = J, delete U.url, delete U.title;
    } else
      delete U.identifier, delete U.label;
    this.data.referenceType = void 0;
  }
  function pe() {
    const U = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const J = this.data.referenceType || "shortcut";
      U.type += "Reference", U.referenceType = J, delete U.url, delete U.title;
    } else
      delete U.identifier, delete U.label;
    this.data.referenceType = void 0;
  }
  function le(U) {
    const J = this.sliceSerialize(U), ve = this.stack[this.stack.length - 2];
    ve.label = xU(J), ve.identifier = ka(J).toLowerCase();
  }
  function ge() {
    const U = this.stack[this.stack.length - 1], J = this.resume(), ve = this.stack[this.stack.length - 1];
    if (this.data.inReference = !0, ve.type === "link") {
      const we = U.children;
      ve.children = we;
    } else
      ve.alt = J;
  }
  function V() {
    const U = this.resume(), J = this.stack[this.stack.length - 1];
    J.url = U;
  }
  function be() {
    const U = this.resume(), J = this.stack[this.stack.length - 1];
    J.title = U;
  }
  function Oe() {
    this.data.inReference = void 0;
  }
  function H() {
    this.data.referenceType = "collapsed";
  }
  function Ye(U) {
    const J = this.resume(), ve = this.stack[this.stack.length - 1];
    ve.label = J, ve.identifier = ka(this.sliceSerialize(U)).toLowerCase(), this.data.referenceType = "full";
  }
  function ln(U) {
    this.data.characterReferenceType = U.type;
  }
  function Ie(U) {
    const J = this.sliceSerialize(U), ve = this.data.characterReferenceType;
    let we;
    ve ? (we = x1(J, ve === "characterReferenceMarkerNumeric" ? 10 : 16), this.data.characterReferenceType = void 0) : we = jg(J);
    const Re = this.stack[this.stack.length - 1];
    Re.value += we;
  }
  function Ue(U) {
    const J = this.stack.pop();
    J.position.end = mi(U.end);
  }
  function De(U) {
    ne.call(this, U);
    const J = this.stack[this.stack.length - 1];
    J.url = this.sliceSerialize(U);
  }
  function Be(U) {
    ne.call(this, U);
    const J = this.stack[this.stack.length - 1];
    J.url = "mailto:" + this.sliceSerialize(U);
  }
  function Ae() {
    return {
      type: "blockquote",
      children: []
    };
  }
  function Qe() {
    return {
      type: "code",
      lang: null,
      meta: null,
      value: ""
    };
  }
  function Ee() {
    return {
      type: "inlineCode",
      value: ""
    };
  }
  function Me() {
    return {
      type: "definition",
      identifier: "",
      label: null,
      title: null,
      url: ""
    };
  }
  function en() {
    return {
      type: "emphasis",
      children: []
    };
  }
  function se() {
    return {
      type: "heading",
      // @ts-expect-error `depth` will be set later.
      depth: 0,
      children: []
    };
  }
  function ce() {
    return {
      type: "break"
    };
  }
  function Se() {
    return {
      type: "html",
      value: ""
    };
  }
  function Ve() {
    return {
      type: "image",
      title: null,
      url: "",
      alt: null
    };
  }
  function Pe() {
    return {
      type: "link",
      title: null,
      url: "",
      children: []
    };
  }
  function kn(U) {
    return {
      type: "list",
      ordered: U.type === "listOrdered",
      start: null,
      spread: U._spread,
      children: []
    };
  }
  function X(U) {
    return {
      type: "listItem",
      spread: U._spread,
      checked: null,
      children: []
    };
  }
  function E() {
    return {
      type: "paragraph",
      children: []
    };
  }
  function z() {
    return {
      type: "strong",
      children: []
    };
  }
  function ae() {
    return {
      type: "text",
      value: ""
    };
  }
  function de() {
    return {
      type: "thematicBreak"
    };
  }
}
function mi(e) {
  return {
    line: e.line,
    column: e.column,
    offset: e.offset
  };
}
function R1(e, n) {
  let r = -1;
  for (; ++r < n.length; ) {
    const i = n[r];
    Array.isArray(i) ? R1(e, i) : wU(e, i);
  }
}
function wU(e, n) {
  let r;
  for (r in n)
    if (T1.call(n, r))
      switch (r) {
        case "canContainEols": {
          const i = n[r];
          i && e[r].push(...i);
          break;
        }
        case "transforms": {
          const i = n[r];
          i && e[r].push(...i);
          break;
        }
        case "enter":
        case "exit": {
          const i = n[r];
          i && Object.assign(e[r], i);
          break;
        }
      }
}
function zx(e, n) {
  throw e ? new Error("Cannot close `" + e.type + "` (" + Ro({
    start: e.start,
    end: e.end
  }) + "): a different token (`" + n.type + "`, " + Ro({
    start: n.start,
    end: n.end
  }) + ") is open") : new Error("Cannot close document, a token (`" + n.type + "`, " + Ro({
    start: n.start,
    end: n.end
  }) + ") is still open");
}
function CU(e) {
  const n = this;
  n.parser = r;
  function r(i) {
    return NU(i, {
      ...n.data("settings"),
      ...e,
      // Note: these options are not in the readme.
      // The goal is for them to be set by plugins on `data` instead of being
      // passed by users.
      extensions: n.data("micromarkExtensions") || [],
      mdastExtensions: n.data("fromMarkdownExtensions") || []
    });
  }
}
function FU(e, n) {
  const r = {
    type: "element",
    tagName: "blockquote",
    properties: {},
    children: e.wrap(e.all(n), !0)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function IU(e, n) {
  const r = { type: "element", tagName: "br", properties: {}, children: [] };
  return e.patch(n, r), [e.applyData(n, r), { type: "text", value: `
` }];
}
function $U(e, n) {
  const r = n.value ? n.value + `
` : "", i = {}, a = n.lang ? n.lang.split(/\s+/) : [];
  a.length > 0 && (i.className = ["language-" + a[0]]);
  let o = {
    type: "element",
    tagName: "code",
    properties: i,
    children: [{ type: "text", value: r }]
  };
  return n.meta && (o.data = { meta: n.meta }), e.patch(n, o), o = e.applyData(n, o), o = { type: "element", tagName: "pre", properties: {}, children: [o] }, e.patch(n, o), o;
}
function EU(e, n) {
  const r = {
    type: "element",
    tagName: "del",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function TU(e, n) {
  const r = {
    type: "element",
    tagName: "em",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function RU(e, n) {
  const r = typeof e.options.clobberPrefix == "string" ? e.options.clobberPrefix : "user-content-", i = String(n.identifier).toUpperCase(), a = Aa(i.toLowerCase()), o = e.footnoteOrder.indexOf(i);
  let s, l = e.footnoteCounts.get(i);
  l === void 0 ? (l = 0, e.footnoteOrder.push(i), s = e.footnoteOrder.length) : s = o + 1, l += 1, e.footnoteCounts.set(i, l);
  const d = {
    type: "element",
    tagName: "a",
    properties: {
      href: "#" + r + "fn-" + a,
      id: r + "fnref-" + a + (l > 1 ? "-" + l : ""),
      dataFootnoteRef: !0,
      ariaDescribedBy: ["footnote-label"]
    },
    children: [{ type: "text", value: String(s) }]
  };
  e.patch(n, d);
  const m = {
    type: "element",
    tagName: "sup",
    properties: {},
    children: [d]
  };
  return e.patch(n, m), e.applyData(n, m);
}
function DU(e, n) {
  const r = {
    type: "element",
    tagName: "h" + n.depth,
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function OU(e, n) {
  if (e.options.allowDangerousHtml) {
    const r = { type: "raw", value: n.value };
    return e.patch(n, r), e.applyData(n, r);
  }
}
function D1(e, n) {
  const r = n.referenceType;
  let i = "]";
  if (r === "collapsed" ? i += "[]" : r === "full" && (i += "[" + (n.label || n.identifier) + "]"), n.type === "imageReference")
    return [{ type: "text", value: "![" + n.alt + i }];
  const a = e.all(n), o = a[0];
  o && o.type === "text" ? o.value = "[" + o.value : a.unshift({ type: "text", value: "[" });
  const s = a[a.length - 1];
  return s && s.type === "text" ? s.value += i : a.push({ type: "text", value: i }), a;
}
function PU(e, n) {
  const r = String(n.identifier).toUpperCase(), i = e.definitionById.get(r);
  if (!i)
    return D1(e, n);
  const a = { src: Aa(i.url || ""), alt: n.alt };
  i.title !== null && i.title !== void 0 && (a.title = i.title);
  const o = { type: "element", tagName: "img", properties: a, children: [] };
  return e.patch(n, o), e.applyData(n, o);
}
function AU(e, n) {
  const r = { src: Aa(n.url) };
  n.alt !== null && n.alt !== void 0 && (r.alt = n.alt), n.title !== null && n.title !== void 0 && (r.title = n.title);
  const i = { type: "element", tagName: "img", properties: r, children: [] };
  return e.patch(n, i), e.applyData(n, i);
}
function LU(e, n) {
  const r = { type: "text", value: n.value.replace(/\r?\n|\r/g, " ") };
  e.patch(n, r);
  const i = {
    type: "element",
    tagName: "code",
    properties: {},
    children: [r]
  };
  return e.patch(n, i), e.applyData(n, i);
}
function VU(e, n) {
  const r = String(n.identifier).toUpperCase(), i = e.definitionById.get(r);
  if (!i)
    return D1(e, n);
  const a = { href: Aa(i.url || "") };
  i.title !== null && i.title !== void 0 && (a.title = i.title);
  const o = {
    type: "element",
    tagName: "a",
    properties: a,
    children: e.all(n)
  };
  return e.patch(n, o), e.applyData(n, o);
}
function zU(e, n) {
  const r = { href: Aa(n.url) };
  n.title !== null && n.title !== void 0 && (r.title = n.title);
  const i = {
    type: "element",
    tagName: "a",
    properties: r,
    children: e.all(n)
  };
  return e.patch(n, i), e.applyData(n, i);
}
function UU(e, n, r) {
  const i = e.all(n), a = r ? MU(r) : O1(n), o = {}, s = [];
  if (typeof n.checked == "boolean") {
    const u = i[0];
    let f;
    u && u.type === "element" && u.tagName === "p" ? f = u : (f = { type: "element", tagName: "p", properties: {}, children: [] }, i.unshift(f)), f.children.length > 0 && f.children.unshift({ type: "text", value: " " }), f.children.unshift({
      type: "element",
      tagName: "input",
      properties: { type: "checkbox", checked: n.checked, disabled: !0 },
      children: []
    }), o.className = ["task-list-item"];
  }
  let l = -1;
  for (; ++l < i.length; ) {
    const u = i[l];
    (a || l !== 0 || u.type !== "element" || u.tagName !== "p") && s.push({ type: "text", value: `
` }), u.type === "element" && u.tagName === "p" && !a ? s.push(...u.children) : s.push(u);
  }
  const d = i[i.length - 1];
  d && (a || d.type !== "element" || d.tagName !== "p") && s.push({ type: "text", value: `
` });
  const m = { type: "element", tagName: "li", properties: o, children: s };
  return e.patch(n, m), e.applyData(n, m);
}
function MU(e) {
  let n = !1;
  if (e.type === "list") {
    n = e.spread || !1;
    const r = e.children;
    let i = -1;
    for (; !n && ++i < r.length; )
      n = O1(r[i]);
  }
  return n;
}
function O1(e) {
  const n = e.spread;
  return n ?? e.children.length > 1;
}
function BU(e, n) {
  const r = {}, i = e.all(n);
  let a = -1;
  for (typeof n.start == "number" && n.start !== 1 && (r.start = n.start); ++a < i.length; ) {
    const s = i[a];
    if (s.type === "element" && s.tagName === "li" && s.properties && Array.isArray(s.properties.className) && s.properties.className.includes("task-list-item")) {
      r.className = ["contains-task-list"];
      break;
    }
  }
  const o = {
    type: "element",
    tagName: n.ordered ? "ol" : "ul",
    properties: r,
    children: e.wrap(i, !0)
  };
  return e.patch(n, o), e.applyData(n, o);
}
function qU(e, n) {
  const r = {
    type: "element",
    tagName: "p",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function HU(e, n) {
  const r = { type: "root", children: e.wrap(e.all(n)) };
  return e.patch(n, r), e.applyData(n, r);
}
function WU(e, n) {
  const r = {
    type: "element",
    tagName: "strong",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function KU(e, n) {
  const r = e.all(n), i = r.shift(), a = [];
  if (i) {
    const s = {
      type: "element",
      tagName: "thead",
      properties: {},
      children: e.wrap([i], !0)
    };
    e.patch(n.children[0], s), a.push(s);
  }
  if (r.length > 0) {
    const s = {
      type: "element",
      tagName: "tbody",
      properties: {},
      children: e.wrap(r, !0)
    }, l = _g(n.children[1]), d = h1(n.children[n.children.length - 1]);
    l && d && (s.position = { start: l, end: d }), a.push(s);
  }
  const o = {
    type: "element",
    tagName: "table",
    properties: {},
    children: e.wrap(a, !0)
  };
  return e.patch(n, o), e.applyData(n, o);
}
function GU(e, n, r) {
  const i = r ? r.children : void 0, o = (i ? i.indexOf(n) : 1) === 0 ? "th" : "td", s = r && r.type === "table" ? r.align : void 0, l = s ? s.length : n.children.length;
  let d = -1;
  const m = [];
  for (; ++d < l; ) {
    const f = n.children[d], h = {}, v = s ? s[d] : void 0;
    v && (h.align = v);
    let w = { type: "element", tagName: o, properties: h, children: [] };
    f && (w.children = e.all(f), e.patch(f, w), w = e.applyData(f, w)), m.push(w);
  }
  const u = {
    type: "element",
    tagName: "tr",
    properties: {},
    children: e.wrap(m, !0)
  };
  return e.patch(n, u), e.applyData(n, u);
}
function YU(e, n) {
  const r = {
    type: "element",
    tagName: "td",
    // Assume body cell.
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
const Ux = 9, Mx = 32;
function JU(e) {
  const n = String(e), r = /\r?\n|\r/g;
  let i = r.exec(n), a = 0;
  const o = [];
  for (; i; )
    o.push(
      Bx(n.slice(a, i.index), a > 0, !0),
      i[0]
    ), a = i.index + i[0].length, i = r.exec(n);
  return o.push(Bx(n.slice(a), a > 0, !1)), o.join("");
}
function Bx(e, n, r) {
  let i = 0, a = e.length;
  if (n) {
    let o = e.codePointAt(i);
    for (; o === Ux || o === Mx; )
      i++, o = e.codePointAt(i);
  }
  if (r) {
    let o = e.codePointAt(a - 1);
    for (; o === Ux || o === Mx; )
      a--, o = e.codePointAt(a - 1);
  }
  return a > i ? e.slice(i, a) : "";
}
function QU(e, n) {
  const r = { type: "text", value: JU(String(n.value)) };
  return e.patch(n, r), e.applyData(n, r);
}
function XU(e, n) {
  const r = {
    type: "element",
    tagName: "hr",
    properties: {},
    children: []
  };
  return e.patch(n, r), e.applyData(n, r);
}
const ZU = {
  blockquote: FU,
  break: IU,
  code: $U,
  delete: EU,
  emphasis: TU,
  footnoteReference: RU,
  heading: DU,
  html: OU,
  imageReference: PU,
  image: AU,
  inlineCode: LU,
  linkReference: VU,
  link: zU,
  listItem: UU,
  list: BU,
  paragraph: qU,
  // @ts-expect-error: root is different, but hard to type.
  root: HU,
  strong: WU,
  table: KU,
  tableCell: YU,
  tableRow: GU,
  text: QU,
  thematicBreak: XU,
  toml: Ns,
  yaml: Ns,
  definition: Ns,
  footnoteDefinition: Ns
};
function Ns() {
}
const P1 = -1, oc = 0, wl = 1, Cl = 2, Fg = 3, Ig = 4, $g = 5, Eg = 6, A1 = 7, L1 = 8, qx = typeof self == "object" ? self : globalThis, eM = (e, n) => {
  const r = (a, o) => (e.set(o, a), a), i = (a) => {
    if (e.has(a))
      return e.get(a);
    const [o, s] = n[a];
    switch (o) {
      case oc:
      case P1:
        return r(s, a);
      case wl: {
        const l = r([], a);
        for (const d of s)
          l.push(i(d));
        return l;
      }
      case Cl: {
        const l = r({}, a);
        for (const [d, m] of s)
          l[i(d)] = i(m);
        return l;
      }
      case Fg:
        return r(new Date(s), a);
      case Ig: {
        const { source: l, flags: d } = s;
        return r(new RegExp(l, d), a);
      }
      case $g: {
        const l = r(/* @__PURE__ */ new Map(), a);
        for (const [d, m] of s)
          l.set(i(d), i(m));
        return l;
      }
      case Eg: {
        const l = r(/* @__PURE__ */ new Set(), a);
        for (const d of s)
          l.add(i(d));
        return l;
      }
      case A1: {
        const { name: l, message: d } = s;
        return r(new qx[l](d), a);
      }
      case L1:
        return r(BigInt(s), a);
      case "BigInt":
        return r(Object(BigInt(s)), a);
    }
    return r(new qx[o](s), a);
  };
  return i;
}, Hx = (e) => eM(/* @__PURE__ */ new Map(), e)(0), aa = "", { toString: nM } = {}, { keys: tM } = Object, ao = (e) => {
  const n = typeof e;
  if (n !== "object" || !e)
    return [oc, n];
  const r = nM.call(e).slice(8, -1);
  switch (r) {
    case "Array":
      return [wl, aa];
    case "Object":
      return [Cl, aa];
    case "Date":
      return [Fg, aa];
    case "RegExp":
      return [Ig, aa];
    case "Map":
      return [$g, aa];
    case "Set":
      return [Eg, aa];
  }
  return r.includes("Array") ? [wl, r] : r.includes("Error") ? [A1, r] : [Cl, r];
}, js = ([e, n]) => e === oc && (n === "function" || n === "symbol"), rM = (e, n, r, i) => {
  const a = (s, l) => {
    const d = i.push(s) - 1;
    return r.set(l, d), d;
  }, o = (s) => {
    if (r.has(s))
      return r.get(s);
    let [l, d] = ao(s);
    switch (l) {
      case oc: {
        let u = s;
        switch (d) {
          case "bigint":
            l = L1, u = s.toString();
            break;
          case "function":
          case "symbol":
            if (e)
              throw new TypeError("unable to serialize " + d);
            u = null;
            break;
          case "undefined":
            return a([P1], s);
        }
        return a([l, u], s);
      }
      case wl: {
        if (d)
          return a([d, [...s]], s);
        const u = [], f = a([l, u], s);
        for (const h of s)
          u.push(o(h));
        return f;
      }
      case Cl: {
        if (d)
          switch (d) {
            case "BigInt":
              return a([d, s.toString()], s);
            case "Boolean":
            case "Number":
            case "String":
              return a([d, s.valueOf()], s);
          }
        if (n && "toJSON" in s)
          return o(s.toJSON());
        const u = [], f = a([l, u], s);
        for (const h of tM(s))
          (e || !js(ao(s[h]))) && u.push([o(h), o(s[h])]);
        return f;
      }
      case Fg:
        return a([l, s.toISOString()], s);
      case Ig: {
        const { source: u, flags: f } = s;
        return a([l, { source: u, flags: f }], s);
      }
      case $g: {
        const u = [], f = a([l, u], s);
        for (const [h, v] of s)
          (e || !(js(ao(h)) || js(ao(v)))) && u.push([o(h), o(v)]);
        return f;
      }
      case Eg: {
        const u = [], f = a([l, u], s);
        for (const h of s)
          (e || !js(ao(h))) && u.push(o(h));
        return f;
      }
    }
    const { message: m } = s;
    return a([l, { name: d, message: m }], s);
  };
  return o;
}, Wx = (e, { json: n, lossy: r } = {}) => {
  const i = [];
  return rM(!(n || r), !!n, /* @__PURE__ */ new Map(), i)(e), i;
}, Fl = typeof structuredClone == "function" ? (
  /* c8 ignore start */
  (e, n) => n && ("json" in n || "lossy" in n) ? Hx(Wx(e, n)) : structuredClone(e)
) : (e, n) => Hx(Wx(e, n));
function iM(e, n) {
  const r = [{ type: "text", value: "↩" }];
  return n > 1 && r.push({
    type: "element",
    tagName: "sup",
    properties: {},
    children: [{ type: "text", value: String(n) }]
  }), r;
}
function aM(e, n) {
  return "Back to reference " + (e + 1) + (n > 1 ? "-" + n : "");
}
function oM(e) {
  const n = typeof e.options.clobberPrefix == "string" ? e.options.clobberPrefix : "user-content-", r = e.options.footnoteBackContent || iM, i = e.options.footnoteBackLabel || aM, a = e.options.footnoteLabel || "Footnotes", o = e.options.footnoteLabelTagName || "h2", s = e.options.footnoteLabelProperties || {
    className: ["sr-only"]
  }, l = [];
  let d = -1;
  for (; ++d < e.footnoteOrder.length; ) {
    const m = e.footnoteById.get(
      e.footnoteOrder[d]
    );
    if (!m)
      continue;
    const u = e.all(m), f = String(m.identifier).toUpperCase(), h = Aa(f.toLowerCase());
    let v = 0;
    const w = [], N = e.footnoteCounts.get(f);
    for (; N !== void 0 && ++v <= N; ) {
      w.length > 0 && w.push({ type: "text", value: " " });
      let g = typeof r == "string" ? r : r(d, v);
      typeof g == "string" && (g = { type: "text", value: g }), w.push({
        type: "element",
        tagName: "a",
        properties: {
          href: "#" + n + "fnref-" + h + (v > 1 ? "-" + v : ""),
          dataFootnoteBackref: "",
          ariaLabel: typeof i == "string" ? i : i(d, v),
          className: ["data-footnote-backref"]
        },
        children: Array.isArray(g) ? g : [g]
      });
    }
    const j = u[u.length - 1];
    if (j && j.type === "element" && j.tagName === "p") {
      const g = j.children[j.children.length - 1];
      g && g.type === "text" ? g.value += " " : j.children.push({ type: "text", value: " " }), j.children.push(...w);
    } else
      u.push(...w);
    const _ = {
      type: "element",
      tagName: "li",
      properties: { id: n + "fn-" + h },
      children: e.wrap(u, !0)
    };
    e.patch(m, _), l.push(_);
  }
  if (l.length !== 0)
    return {
      type: "element",
      tagName: "section",
      properties: { dataFootnotes: !0, className: ["footnotes"] },
      children: [
        {
          type: "element",
          tagName: o,
          properties: {
            ...Fl(s),
            id: "footnote-label"
          },
          children: [{ type: "text", value: a }]
        },
        { type: "text", value: `
` },
        {
          type: "element",
          tagName: "ol",
          properties: {},
          children: e.wrap(l, !0)
        },
        { type: "text", value: `
` }
      ]
    };
}
const V1 = (
  // Note: overloads in JSDoc can’t yet use different `@template`s.
  /**
   * @type {(
   *   (<Condition extends string>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((test?: null | undefined) => (node?: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((test?: Test) => Check)
   * )}
   */
  /**
   * @param {Test} [test]
   * @returns {Check}
   */
  (function(e) {
    if (e == null)
      return dM;
    if (typeof e == "function")
      return sc(e);
    if (typeof e == "object")
      return Array.isArray(e) ? sM(e) : lM(e);
    if (typeof e == "string")
      return cM(e);
    throw new Error("Expected function, string, or object as test");
  })
);
function sM(e) {
  const n = [];
  let r = -1;
  for (; ++r < e.length; )
    n[r] = V1(e[r]);
  return sc(i);
  function i(...a) {
    let o = -1;
    for (; ++o < n.length; )
      if (n[o].apply(this, a)) return !0;
    return !1;
  }
}
function lM(e) {
  const n = (
    /** @type {Record<string, unknown>} */
    e
  );
  return sc(r);
  function r(i) {
    const a = (
      /** @type {Record<string, unknown>} */
      /** @type {unknown} */
      i
    );
    let o;
    for (o in e)
      if (a[o] !== n[o]) return !1;
    return !0;
  }
}
function cM(e) {
  return sc(n);
  function n(r) {
    return r && r.type === e;
  }
}
function sc(e) {
  return n;
  function n(r, i, a) {
    return !!(uM(r) && e.call(
      this,
      r,
      typeof i == "number" ? i : void 0,
      a || void 0
    ));
  }
}
function dM() {
  return !0;
}
function uM(e) {
  return e !== null && typeof e == "object" && "type" in e;
}
const z1 = [], mM = !0, Kx = !1, pM = "skip";
function fM(e, n, r, i) {
  let a;
  typeof n == "function" && typeof r != "function" ? (i = r, r = n) : a = n;
  const o = V1(a), s = i ? -1 : 1;
  l(e, void 0, [])();
  function l(d, m, u) {
    const f = (
      /** @type {Record<string, unknown>} */
      d && typeof d == "object" ? d : {}
    );
    if (typeof f.type == "string") {
      const v = (
        // `hast`
        typeof f.tagName == "string" ? f.tagName : (
          // `xast`
          typeof f.name == "string" ? f.name : void 0
        )
      );
      Object.defineProperty(h, "name", {
        value: "node (" + (d.type + (v ? "<" + v + ">" : "")) + ")"
      });
    }
    return h;
    function h() {
      let v = z1, w, N, j;
      if ((!n || o(d, m, u[u.length - 1] || void 0)) && (v = hM(r(d, u)), v[0] === Kx))
        return v;
      if ("children" in d && d.children) {
        const _ = (
          /** @type {UnistParent} */
          d
        );
        if (_.children && v[0] !== pM)
          for (N = (i ? _.children.length : -1) + s, j = u.concat(_); N > -1 && N < _.children.length; ) {
            const g = _.children[N];
            if (w = l(g, N, j)(), w[0] === Kx)
              return w;
            N = typeof w[1] == "number" ? w[1] : N + s;
          }
      }
      return v;
    }
  }
}
function hM(e) {
  return Array.isArray(e) ? e : typeof e == "number" ? [mM, e] : e == null ? z1 : [e];
}
function U1(e, n, r, i) {
  let a, o, s;
  typeof n == "function" && typeof r != "function" ? (o = void 0, s = n, a = r) : (o = n, s = r, a = i), fM(e, o, l, a);
  function l(d, m) {
    const u = m[m.length - 1], f = u ? u.children.indexOf(d) : void 0;
    return s(d, f, u);
  }
}
const fy = {}.hasOwnProperty, yM = {};
function gM(e, n) {
  const r = n || yM, i = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Map(), o = /* @__PURE__ */ new Map(), s = { ...ZU, ...r.handlers }, l = {
    all: m,
    applyData: kM,
    definitionById: i,
    footnoteById: a,
    footnoteCounts: o,
    footnoteOrder: [],
    handlers: s,
    one: d,
    options: r,
    patch: vM,
    wrap: _M
  };
  return U1(e, function(u) {
    if (u.type === "definition" || u.type === "footnoteDefinition") {
      const f = u.type === "definition" ? i : a, h = String(u.identifier).toUpperCase();
      f.has(h) || f.set(h, u);
    }
  }), l;
  function d(u, f) {
    const h = u.type, v = l.handlers[h];
    if (fy.call(l.handlers, h) && v)
      return v(l, u, f);
    if (l.options.passThrough && l.options.passThrough.includes(h)) {
      if ("children" in u) {
        const { children: N, ...j } = u, _ = Fl(j);
        return _.children = l.all(u), _;
      }
      return Fl(u);
    }
    return (l.options.unknownHandler || bM)(l, u, f);
  }
  function m(u) {
    const f = [];
    if ("children" in u) {
      const h = u.children;
      let v = -1;
      for (; ++v < h.length; ) {
        const w = l.one(h[v], u);
        if (w) {
          if (v && h[v - 1].type === "break" && (!Array.isArray(w) && w.type === "text" && (w.value = Gx(w.value)), !Array.isArray(w) && w.type === "element")) {
            const N = w.children[0];
            N && N.type === "text" && (N.value = Gx(N.value));
          }
          Array.isArray(w) ? f.push(...w) : f.push(w);
        }
      }
    }
    return f;
  }
}
function vM(e, n) {
  e.position && (n.position = ZV(e));
}
function kM(e, n) {
  let r = n;
  if (e && e.data) {
    const i = e.data.hName, a = e.data.hChildren, o = e.data.hProperties;
    if (typeof i == "string")
      if (r.type === "element")
        r.tagName = i;
      else {
        const s = "children" in r ? r.children : [r];
        r = { type: "element", tagName: i, properties: {}, children: s };
      }
    r.type === "element" && o && Object.assign(r.properties, Fl(o)), "children" in r && r.children && a !== null && a !== void 0 && (r.children = a);
  }
  return r;
}
function bM(e, n) {
  const r = n.data || {}, i = "value" in n && !(fy.call(r, "hProperties") || fy.call(r, "hChildren")) ? { type: "text", value: n.value } : {
    type: "element",
    tagName: "div",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, i), e.applyData(n, i);
}
function _M(e, n) {
  const r = [];
  let i = -1;
  for (n && r.push({ type: "text", value: `
` }); ++i < e.length; )
    i && r.push({ type: "text", value: `
` }), r.push(e[i]);
  return n && e.length > 0 && r.push({ type: "text", value: `
` }), r;
}
function Gx(e) {
  let n = 0, r = e.charCodeAt(n);
  for (; r === 9 || r === 32; )
    n++, r = e.charCodeAt(n);
  return e.slice(n);
}
function Yx(e, n) {
  const r = gM(e, n), i = r.one(e, void 0), a = oM(r), o = Array.isArray(i) ? { type: "root", children: i } : i || { type: "root", children: [] };
  return a && o.children.push({ type: "text", value: `
` }, a), o;
}
function xM(e, n) {
  return e && "run" in e ? async function(r, i) {
    const a = (
      /** @type {HastRoot} */
      Yx(r, { file: i, ...n })
    );
    await e.run(a, i);
  } : function(r, i) {
    return (
      /** @type {HastRoot} */
      Yx(r, { file: i, ...e || n })
    );
  };
}
function Jx(e) {
  if (e)
    throw e;
}
var Im, Qx;
function SM() {
  if (Qx) return Im;
  Qx = 1;
  var e = Object.prototype.hasOwnProperty, n = Object.prototype.toString, r = Object.defineProperty, i = Object.getOwnPropertyDescriptor, a = function(m) {
    return typeof Array.isArray == "function" ? Array.isArray(m) : n.call(m) === "[object Array]";
  }, o = function(m) {
    if (!m || n.call(m) !== "[object Object]")
      return !1;
    var u = e.call(m, "constructor"), f = m.constructor && m.constructor.prototype && e.call(m.constructor.prototype, "isPrototypeOf");
    if (m.constructor && !u && !f)
      return !1;
    var h;
    for (h in m)
      ;
    return typeof h > "u" || e.call(m, h);
  }, s = function(m, u) {
    r && u.name === "__proto__" ? r(m, u.name, {
      enumerable: !0,
      configurable: !0,
      value: u.newValue,
      writable: !0
    }) : m[u.name] = u.newValue;
  }, l = function(m, u) {
    if (u === "__proto__")
      if (e.call(m, u)) {
        if (i)
          return i(m, u).value;
      } else return;
    return m[u];
  };
  return Im = function d() {
    var m, u, f, h, v, w, N = arguments[0], j = 1, _ = arguments.length, g = !1;
    for (typeof N == "boolean" && (g = N, N = arguments[1] || {}, j = 2), (N == null || typeof N != "object" && typeof N != "function") && (N = {}); j < _; ++j)
      if (m = arguments[j], m != null)
        for (u in m)
          f = l(N, u), h = l(m, u), N !== h && (g && h && (o(h) || (v = a(h))) ? (v ? (v = !1, w = f && a(f) ? f : []) : w = f && o(f) ? f : {}, s(N, { name: u, newValue: d(g, w, h) })) : typeof h < "u" && s(N, { name: u, newValue: h }));
    return N;
  }, Im;
}
var NM = SM();
const $m = /* @__PURE__ */ Dy(NM);
function hy(e) {
  if (typeof e != "object" || e === null)
    return !1;
  const n = Object.getPrototypeOf(e);
  return (n === null || n === Object.prototype || Object.getPrototypeOf(n) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}
function jM() {
  const e = [], n = { run: r, use: i };
  return n;
  function r(...a) {
    let o = -1;
    const s = a.pop();
    if (typeof s != "function")
      throw new TypeError("Expected function as last argument, not " + s);
    l(null, ...a);
    function l(d, ...m) {
      const u = e[++o];
      let f = -1;
      if (d) {
        s(d);
        return;
      }
      for (; ++f < a.length; )
        (m[f] === null || m[f] === void 0) && (m[f] = a[f]);
      a = m, u ? wM(u, l)(...m) : s(null, ...m);
    }
  }
  function i(a) {
    if (typeof a != "function")
      throw new TypeError(
        "Expected `middelware` to be a function, not " + a
      );
    return e.push(a), n;
  }
}
function wM(e, n) {
  let r;
  return i;
  function i(...s) {
    const l = e.length > s.length;
    let d;
    l && s.push(a);
    try {
      d = e.apply(this, s);
    } catch (m) {
      const u = (
        /** @type {Error} */
        m
      );
      if (l && r)
        throw u;
      return a(u);
    }
    l || (d instanceof Promise ? d.then(o, a) : d instanceof Error ? a(d) : o(d));
  }
  function a(s, ...l) {
    r || (r = !0, n(s, ...l));
  }
  function o(s) {
    a(null, s);
  }
}
const zr = { basename: CM, dirname: FM, extname: IM, join: $M, sep: "/" };
function CM(e, n) {
  if (n !== void 0 && typeof n != "string")
    throw new TypeError('"ext" argument must be a string');
  as(e);
  let r = 0, i = -1, a = e.length, o;
  if (n === void 0 || n.length === 0 || n.length > e.length) {
    for (; a--; )
      if (e.codePointAt(a) === 47) {
        if (o) {
          r = a + 1;
          break;
        }
      } else i < 0 && (o = !0, i = a + 1);
    return i < 0 ? "" : e.slice(r, i);
  }
  if (n === e)
    return "";
  let s = -1, l = n.length - 1;
  for (; a--; )
    if (e.codePointAt(a) === 47) {
      if (o) {
        r = a + 1;
        break;
      }
    } else
      s < 0 && (o = !0, s = a + 1), l > -1 && (e.codePointAt(a) === n.codePointAt(l--) ? l < 0 && (i = a) : (l = -1, i = s));
  return r === i ? i = s : i < 0 && (i = e.length), e.slice(r, i);
}
function FM(e) {
  if (as(e), e.length === 0)
    return ".";
  let n = -1, r = e.length, i;
  for (; --r; )
    if (e.codePointAt(r) === 47) {
      if (i) {
        n = r;
        break;
      }
    } else i || (i = !0);
  return n < 0 ? e.codePointAt(0) === 47 ? "/" : "." : n === 1 && e.codePointAt(0) === 47 ? "//" : e.slice(0, n);
}
function IM(e) {
  as(e);
  let n = e.length, r = -1, i = 0, a = -1, o = 0, s;
  for (; n--; ) {
    const l = e.codePointAt(n);
    if (l === 47) {
      if (s) {
        i = n + 1;
        break;
      }
      continue;
    }
    r < 0 && (s = !0, r = n + 1), l === 46 ? a < 0 ? a = n : o !== 1 && (o = 1) : a > -1 && (o = -1);
  }
  return a < 0 || r < 0 || // We saw a non-dot character immediately before the dot.
  o === 0 || // The (right-most) trimmed path component is exactly `..`.
  o === 1 && a === r - 1 && a === i + 1 ? "" : e.slice(a, r);
}
function $M(...e) {
  let n = -1, r;
  for (; ++n < e.length; )
    as(e[n]), e[n] && (r = r === void 0 ? e[n] : r + "/" + e[n]);
  return r === void 0 ? "." : EM(r);
}
function EM(e) {
  as(e);
  const n = e.codePointAt(0) === 47;
  let r = TM(e, !n);
  return r.length === 0 && !n && (r = "."), r.length > 0 && e.codePointAt(e.length - 1) === 47 && (r += "/"), n ? "/" + r : r;
}
function TM(e, n) {
  let r = "", i = 0, a = -1, o = 0, s = -1, l, d;
  for (; ++s <= e.length; ) {
    if (s < e.length)
      l = e.codePointAt(s);
    else {
      if (l === 47)
        break;
      l = 47;
    }
    if (l === 47) {
      if (!(a === s - 1 || o === 1)) if (a !== s - 1 && o === 2) {
        if (r.length < 2 || i !== 2 || r.codePointAt(r.length - 1) !== 46 || r.codePointAt(r.length - 2) !== 46) {
          if (r.length > 2) {
            if (d = r.lastIndexOf("/"), d !== r.length - 1) {
              d < 0 ? (r = "", i = 0) : (r = r.slice(0, d), i = r.length - 1 - r.lastIndexOf("/")), a = s, o = 0;
              continue;
            }
          } else if (r.length > 0) {
            r = "", i = 0, a = s, o = 0;
            continue;
          }
        }
        n && (r = r.length > 0 ? r + "/.." : "..", i = 2);
      } else
        r.length > 0 ? r += "/" + e.slice(a + 1, s) : r = e.slice(a + 1, s), i = s - a - 1;
      a = s, o = 0;
    } else l === 46 && o > -1 ? o++ : o = -1;
  }
  return r;
}
function as(e) {
  if (typeof e != "string")
    throw new TypeError(
      "Path must be a string. Received " + JSON.stringify(e)
    );
}
const RM = { cwd: DM };
function DM() {
  return "/";
}
function yy(e) {
  return !!(e !== null && typeof e == "object" && "href" in e && e.href && "protocol" in e && e.protocol && // @ts-expect-error: indexing is fine.
  e.auth === void 0);
}
function OM(e) {
  if (typeof e == "string")
    e = new URL(e);
  else if (!yy(e)) {
    const n = new TypeError(
      'The "path" argument must be of type string or an instance of URL. Received `' + e + "`"
    );
    throw n.code = "ERR_INVALID_ARG_TYPE", n;
  }
  if (e.protocol !== "file:") {
    const n = new TypeError("The URL must be of scheme file");
    throw n.code = "ERR_INVALID_URL_SCHEME", n;
  }
  return PM(e);
}
function PM(e) {
  if (e.hostname !== "") {
    const i = new TypeError(
      'File URL host must be "localhost" or empty on darwin'
    );
    throw i.code = "ERR_INVALID_FILE_URL_HOST", i;
  }
  const n = e.pathname;
  let r = -1;
  for (; ++r < n.length; )
    if (n.codePointAt(r) === 37 && n.codePointAt(r + 1) === 50) {
      const i = n.codePointAt(r + 2);
      if (i === 70 || i === 102) {
        const a = new TypeError(
          "File URL path must not include encoded / characters"
        );
        throw a.code = "ERR_INVALID_FILE_URL_PATH", a;
      }
    }
  return decodeURIComponent(n);
}
const Em = (
  /** @type {const} */
  [
    "history",
    "path",
    "basename",
    "stem",
    "extname",
    "dirname"
  ]
);
class M1 {
  /**
   * Create a new virtual file.
   *
   * `options` is treated as:
   *
   * *   `string` or `Uint8Array` — `{value: options}`
   * *   `URL` — `{path: options}`
   * *   `VFile` — shallow copies its data over to the new file
   * *   `object` — all fields are shallow copied over to the new file
   *
   * Path related fields are set in the following order (least specific to
   * most specific): `history`, `path`, `basename`, `stem`, `extname`,
   * `dirname`.
   *
   * You cannot set `dirname` or `extname` without setting either `history`,
   * `path`, `basename`, or `stem` too.
   *
   * @param {Compatible | null | undefined} [value]
   *   File value.
   * @returns
   *   New instance.
   */
  constructor(n) {
    let r;
    n ? yy(n) ? r = { path: n } : typeof n == "string" || AM(n) ? r = { value: n } : r = n : r = {}, this.cwd = "cwd" in r ? "" : RM.cwd(), this.data = {}, this.history = [], this.messages = [], this.value, this.map, this.result, this.stored;
    let i = -1;
    for (; ++i < Em.length; ) {
      const o = Em[i];
      o in r && r[o] !== void 0 && r[o] !== null && (this[o] = o === "history" ? [...r[o]] : r[o]);
    }
    let a;
    for (a in r)
      Em.includes(a) || (this[a] = r[a]);
  }
  /**
   * Get the basename (including extname) (example: `'index.min.js'`).
   *
   * @returns {string | undefined}
   *   Basename.
   */
  get basename() {
    return typeof this.path == "string" ? zr.basename(this.path) : void 0;
  }
  /**
   * Set basename (including extname) (`'index.min.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} basename
   *   Basename.
   * @returns {undefined}
   *   Nothing.
   */
  set basename(n) {
    Rm(n, "basename"), Tm(n, "basename"), this.path = zr.join(this.dirname || "", n);
  }
  /**
   * Get the parent path (example: `'~'`).
   *
   * @returns {string | undefined}
   *   Dirname.
   */
  get dirname() {
    return typeof this.path == "string" ? zr.dirname(this.path) : void 0;
  }
  /**
   * Set the parent path (example: `'~'`).
   *
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} dirname
   *   Dirname.
   * @returns {undefined}
   *   Nothing.
   */
  set dirname(n) {
    Xx(this.basename, "dirname"), this.path = zr.join(n || "", this.basename);
  }
  /**
   * Get the extname (including dot) (example: `'.js'`).
   *
   * @returns {string | undefined}
   *   Extname.
   */
  get extname() {
    return typeof this.path == "string" ? zr.extname(this.path) : void 0;
  }
  /**
   * Set the extname (including dot) (example: `'.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} extname
   *   Extname.
   * @returns {undefined}
   *   Nothing.
   */
  set extname(n) {
    if (Tm(n, "extname"), Xx(this.dirname, "extname"), n) {
      if (n.codePointAt(0) !== 46)
        throw new Error("`extname` must start with `.`");
      if (n.includes(".", 1))
        throw new Error("`extname` cannot contain multiple dots");
    }
    this.path = zr.join(this.dirname, this.stem + (n || ""));
  }
  /**
   * Get the full path (example: `'~/index.min.js'`).
   *
   * @returns {string}
   *   Path.
   */
  get path() {
    return this.history[this.history.length - 1];
  }
  /**
   * Set the full path (example: `'~/index.min.js'`).
   *
   * Cannot be nullified.
   * You can set a file URL (a `URL` object with a `file:` protocol) which will
   * be turned into a path with `url.fileURLToPath`.
   *
   * @param {URL | string} path
   *   Path.
   * @returns {undefined}
   *   Nothing.
   */
  set path(n) {
    yy(n) && (n = OM(n)), Rm(n, "path"), this.path !== n && this.history.push(n);
  }
  /**
   * Get the stem (basename w/o extname) (example: `'index.min'`).
   *
   * @returns {string | undefined}
   *   Stem.
   */
  get stem() {
    return typeof this.path == "string" ? zr.basename(this.path, this.extname) : void 0;
  }
  /**
   * Set the stem (basename w/o extname) (example: `'index.min'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} stem
   *   Stem.
   * @returns {undefined}
   *   Nothing.
   */
  set stem(n) {
    Rm(n, "stem"), Tm(n, "stem"), this.path = zr.join(this.dirname || "", n + (this.extname || ""));
  }
  // Normal prototypal methods.
  /**
   * Create a fatal message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `true` (error; file not usable)
   * and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {never}
   *   Never.
   * @throws {VFileMessage}
   *   Message.
   */
  fail(n, r, i) {
    const a = this.message(n, r, i);
    throw a.fatal = !0, a;
  }
  /**
   * Create an info message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `undefined` (info; change
   * likely not needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  info(n, r, i) {
    const a = this.message(n, r, i);
    return a.fatal = void 0, a;
  }
  /**
   * Create a message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `false` (warning; change may be
   * needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  message(n, r, i) {
    const a = new qt(
      // @ts-expect-error: the overloads are fine.
      n,
      r,
      i
    );
    return this.path && (a.name = this.path + ":" + a.name, a.file = this.path), a.fatal = !1, this.messages.push(a), a;
  }
  /**
   * Serialize the file.
   *
   * > **Note**: which encodings are supported depends on the engine.
   * > For info on Node.js, see:
   * > <https://nodejs.org/api/util.html#whatwg-supported-encodings>.
   *
   * @param {string | null | undefined} [encoding='utf8']
   *   Character encoding to understand `value` as when it’s a `Uint8Array`
   *   (default: `'utf-8'`).
   * @returns {string}
   *   Serialized file.
   */
  toString(n) {
    return this.value === void 0 ? "" : typeof this.value == "string" ? this.value : new TextDecoder(n || void 0).decode(this.value);
  }
}
function Tm(e, n) {
  if (e && e.includes(zr.sep))
    throw new Error(
      "`" + n + "` cannot be a path: did not expect `" + zr.sep + "`"
    );
}
function Rm(e, n) {
  if (!e)
    throw new Error("`" + n + "` cannot be empty");
}
function Xx(e, n) {
  if (!e)
    throw new Error("Setting `" + n + "` requires `path` to be set too");
}
function AM(e) {
  return !!(e && typeof e == "object" && "byteLength" in e && "byteOffset" in e);
}
const LM = (
  /**
   * @type {new <Parameters extends Array<unknown>, Result>(property: string | symbol) => (...parameters: Parameters) => Result}
   */
  /** @type {unknown} */
  /**
   * @this {Function}
   * @param {string | symbol} property
   * @returns {(...parameters: Array<unknown>) => unknown}
   */
  (function(e) {
    const i = (
      /** @type {Record<string | symbol, Function>} */
      // Prototypes do exist.
      // type-coverage:ignore-next-line
      this.constructor.prototype
    ), a = i[e], o = function() {
      return a.apply(o, arguments);
    };
    return Object.setPrototypeOf(o, i), o;
  })
), VM = {}.hasOwnProperty;
class Tg extends LM {
  /**
   * Create a processor.
   */
  constructor() {
    super("copy"), this.Compiler = void 0, this.Parser = void 0, this.attachers = [], this.compiler = void 0, this.freezeIndex = -1, this.frozen = void 0, this.namespace = {}, this.parser = void 0, this.transformers = jM();
  }
  /**
   * Copy a processor.
   *
   * @deprecated
   *   This is a private internal method and should not be used.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   New *unfrozen* processor ({@linkcode Processor}) that is
   *   configured to work the same as its ancestor.
   *   When the descendant processor is configured in the future it does not
   *   affect the ancestral processor.
   */
  copy() {
    const n = (
      /** @type {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>} */
      new Tg()
    );
    let r = -1;
    for (; ++r < this.attachers.length; ) {
      const i = this.attachers[r];
      n.use(...i);
    }
    return n.data($m(!0, {}, this.namespace)), n;
  }
  /**
   * Configure the processor with info available to all plugins.
   * Information is stored in an object.
   *
   * Typically, options can be given to a specific plugin, but sometimes it
   * makes sense to have information shared with several plugins.
   * For example, a list of HTML elements that are self-closing, which is
   * needed during all phases.
   *
   * > **Note**: setting information cannot occur on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * > **Note**: to register custom data in TypeScript, augment the
   * > {@linkcode Data} interface.
   *
   * @example
   *   This example show how to get and set info:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   const processor = unified().data('alpha', 'bravo')
   *
   *   processor.data('alpha') // => 'bravo'
   *
   *   processor.data() // => {alpha: 'bravo'}
   *
   *   processor.data({charlie: 'delta'})
   *
   *   processor.data() // => {charlie: 'delta'}
   *   ```
   *
   * @template {keyof Data} Key
   *
   * @overload
   * @returns {Data}
   *
   * @overload
   * @param {Data} dataset
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Key} key
   * @returns {Data[Key]}
   *
   * @overload
   * @param {Key} key
   * @param {Data[Key]} value
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @param {Data | Key} [key]
   *   Key to get or set, or entire dataset to set, or nothing to get the
   *   entire dataset (optional).
   * @param {Data[Key]} [value]
   *   Value to set (optional).
   * @returns {unknown}
   *   The current processor when setting, the value at `key` when getting, or
   *   the entire dataset when getting without key.
   */
  data(n, r) {
    return typeof n == "string" ? arguments.length === 2 ? (Pm("data", this.frozen), this.namespace[n] = r, this) : VM.call(this.namespace, n) && this.namespace[n] || void 0 : n ? (Pm("data", this.frozen), this.namespace = n, this) : this.namespace;
  }
  /**
   * Freeze a processor.
   *
   * Frozen processors are meant to be extended and not to be configured
   * directly.
   *
   * When a processor is frozen it cannot be unfrozen.
   * New processors working the same way can be created by calling the
   * processor.
   *
   * It’s possible to freeze processors explicitly by calling `.freeze()`.
   * Processors freeze automatically when `.parse()`, `.run()`, `.runSync()`,
   * `.stringify()`, `.process()`, or `.processSync()` are called.
   *
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   The current processor.
   */
  freeze() {
    if (this.frozen)
      return this;
    const n = (
      /** @type {Processor} */
      /** @type {unknown} */
      this
    );
    for (; ++this.freezeIndex < this.attachers.length; ) {
      const [r, ...i] = this.attachers[this.freezeIndex];
      if (i[0] === !1)
        continue;
      i[0] === !0 && (i[0] = void 0);
      const a = r.call(n, ...i);
      typeof a == "function" && this.transformers.use(a);
    }
    return this.frozen = !0, this.freezeIndex = Number.POSITIVE_INFINITY, this;
  }
  /**
   * Parse text to a syntax tree.
   *
   * > **Note**: `parse` freezes the processor if not already *frozen*.
   *
   * > **Note**: `parse` performs the parse phase, not the run phase or other
   * > phases.
   *
   * @param {Compatible | undefined} [file]
   *   file to parse (optional); typically `string` or `VFile`; any value
   *   accepted as `x` in `new VFile(x)`.
   * @returns {ParseTree extends undefined ? Node : ParseTree}
   *   Syntax tree representing `file`.
   */
  parse(n) {
    this.freeze();
    const r = ws(n), i = this.parser || this.Parser;
    return Dm("parse", i), i(String(r), r);
  }
  /**
   * Process the given file as configured on the processor.
   *
   * > **Note**: `process` freezes the processor if not already *frozen*.
   *
   * > **Note**: `process` performs the parse, run, and stringify phases.
   *
   * @overload
   * @param {Compatible | undefined} file
   * @param {ProcessCallback<VFileWithOutput<CompileResult>>} done
   * @returns {undefined}
   *
   * @overload
   * @param {Compatible | undefined} [file]
   * @returns {Promise<VFileWithOutput<CompileResult>>}
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`]; any value accepted as
   *   `x` in `new VFile(x)`.
   * @param {ProcessCallback<VFileWithOutput<CompileResult>> | undefined} [done]
   *   Callback (optional).
   * @returns {Promise<VFile> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise a promise, rejected with a fatal error or resolved with the
   *   processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  process(n, r) {
    const i = this;
    return this.freeze(), Dm("process", this.parser || this.Parser), Om("process", this.compiler || this.Compiler), r ? a(void 0, r) : new Promise(a);
    function a(o, s) {
      const l = ws(n), d = (
        /** @type {HeadTree extends undefined ? Node : HeadTree} */
        /** @type {unknown} */
        i.parse(l)
      );
      i.run(d, l, function(u, f, h) {
        if (u || !f || !h)
          return m(u);
        const v = (
          /** @type {CompileTree extends undefined ? Node : CompileTree} */
          /** @type {unknown} */
          f
        ), w = i.stringify(v, h);
        MM(w) ? h.value = w : h.result = w, m(
          u,
          /** @type {VFileWithOutput<CompileResult>} */
          h
        );
      });
      function m(u, f) {
        u || !f ? s(u) : o ? o(f) : r(void 0, f);
      }
    }
  }
  /**
   * Process the given file as configured on the processor.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `processSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `processSync` performs the parse, run, and stringify phases.
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`; any value accepted as
   *   `x` in `new VFile(x)`.
   * @returns {VFileWithOutput<CompileResult>}
   *   The processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  processSync(n) {
    let r = !1, i;
    return this.freeze(), Dm("processSync", this.parser || this.Parser), Om("processSync", this.compiler || this.Compiler), this.process(n, a), eS("processSync", "process", r), i;
    function a(o, s) {
      r = !0, Jx(o), i = s;
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * > **Note**: `run` freezes the processor if not already *frozen*.
   *
   * > **Note**: `run` performs the run phase, not other phases.
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} file
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} [file]
   * @returns {Promise<TailTree extends undefined ? Node : TailTree>}
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {(
   *   RunCallback<TailTree extends undefined ? Node : TailTree> |
   *   Compatible
   * )} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} [done]
   *   Callback (optional).
   * @returns {Promise<TailTree extends undefined ? Node : TailTree> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise, a promise rejected with a fatal error or resolved with the
   *   transformed tree.
   */
  run(n, r, i) {
    Zx(n), this.freeze();
    const a = this.transformers;
    return !i && typeof r == "function" && (i = r, r = void 0), i ? o(void 0, i) : new Promise(o);
    function o(s, l) {
      const d = ws(r);
      a.run(n, d, m);
      function m(u, f, h) {
        const v = (
          /** @type {TailTree extends undefined ? Node : TailTree} */
          f || n
        );
        u ? l(u) : s ? s(v) : i(void 0, v, h);
      }
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `runSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `runSync` performs the run phase, not other phases.
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {TailTree extends undefined ? Node : TailTree}
   *   Transformed tree.
   */
  runSync(n, r) {
    let i = !1, a;
    return this.run(n, r, o), eS("runSync", "run", i), a;
    function o(s, l) {
      Jx(s), a = l, i = !0;
    }
  }
  /**
   * Compile a syntax tree.
   *
   * > **Note**: `stringify` freezes the processor if not already *frozen*.
   *
   * > **Note**: `stringify` performs the stringify phase, not the run phase
   * > or other phases.
   *
   * @param {CompileTree extends undefined ? Node : CompileTree} tree
   *   Tree to compile.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {CompileResult extends undefined ? Value : CompileResult}
   *   Textual representation of the tree (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most compilers
   *   > return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  stringify(n, r) {
    this.freeze();
    const i = ws(r), a = this.compiler || this.Compiler;
    return Om("stringify", a), Zx(n), a(n, i);
  }
  /**
   * Configure the processor to use a plugin, a list of usable values, or a
   * preset.
   *
   * If the processor is already using a plugin, the previous plugin
   * configuration is changed based on the options that are passed in.
   * In other words, the plugin is not added a second time.
   *
   * > **Note**: `use` cannot be called on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * @example
   *   There are many ways to pass plugins to `.use()`.
   *   This example gives an overview:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   unified()
   *     // Plugin with options:
   *     .use(pluginA, {x: true, y: true})
   *     // Passing the same plugin again merges configuration (to `{x: true, y: false, z: true}`):
   *     .use(pluginA, {y: false, z: true})
   *     // Plugins:
   *     .use([pluginB, pluginC])
   *     // Two plugins, the second with options:
   *     .use([pluginD, [pluginE, {}]])
   *     // Preset with plugins and settings:
   *     .use({plugins: [pluginF, [pluginG, {}]], settings: {position: false}})
   *     // Settings only:
   *     .use({settings: {position: false}})
   *   ```
   *
   * @template {Array<unknown>} [Parameters=[]]
   * @template {Node | string | undefined} [Input=undefined]
   * @template [Output=Input]
   *
   * @overload
   * @param {Preset | null | undefined} [preset]
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {PluggableList} list
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Plugin<Parameters, Input, Output>} plugin
   * @param {...(Parameters | [boolean])} parameters
   * @returns {UsePlugin<ParseTree, HeadTree, TailTree, CompileTree, CompileResult, Input, Output>}
   *
   * @param {PluggableList | Plugin | Preset | null | undefined} value
   *   Usable value.
   * @param {...unknown} parameters
   *   Parameters, when a plugin is given as a usable value.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   Current processor.
   */
  use(n, ...r) {
    const i = this.attachers, a = this.namespace;
    if (Pm("use", this.frozen), n != null) if (typeof n == "function")
      d(n, r);
    else if (typeof n == "object")
      Array.isArray(n) ? l(n) : s(n);
    else
      throw new TypeError("Expected usable value, not `" + n + "`");
    return this;
    function o(m) {
      if (typeof m == "function")
        d(m, []);
      else if (typeof m == "object")
        if (Array.isArray(m)) {
          const [u, ...f] = (
            /** @type {PluginTuple<Array<unknown>>} */
            m
          );
          d(u, f);
        } else
          s(m);
      else
        throw new TypeError("Expected usable value, not `" + m + "`");
    }
    function s(m) {
      if (!("plugins" in m) && !("settings" in m))
        throw new Error(
          "Expected usable value but received an empty preset, which is probably a mistake: presets typically come with `plugins` and sometimes with `settings`, but this has neither"
        );
      l(m.plugins), m.settings && (a.settings = $m(!0, a.settings, m.settings));
    }
    function l(m) {
      let u = -1;
      if (m != null) if (Array.isArray(m))
        for (; ++u < m.length; ) {
          const f = m[u];
          o(f);
        }
      else
        throw new TypeError("Expected a list of plugins, not `" + m + "`");
    }
    function d(m, u) {
      let f = -1, h = -1;
      for (; ++f < i.length; )
        if (i[f][0] === m) {
          h = f;
          break;
        }
      if (h === -1)
        i.push([m, ...u]);
      else if (u.length > 0) {
        let [v, ...w] = u;
        const N = i[h][1];
        hy(N) && hy(v) && (v = $m(!0, N, v)), i[h] = [m, v, ...w];
      }
    }
  }
}
const zM = new Tg().freeze();
function Dm(e, n) {
  if (typeof n != "function")
    throw new TypeError("Cannot `" + e + "` without `parser`");
}
function Om(e, n) {
  if (typeof n != "function")
    throw new TypeError("Cannot `" + e + "` without `compiler`");
}
function Pm(e, n) {
  if (n)
    throw new Error(
      "Cannot call `" + e + "` on a frozen processor.\nCreate a new processor first, by calling it: use `processor()` instead of `processor`."
    );
}
function Zx(e) {
  if (!hy(e) || typeof e.type != "string")
    throw new TypeError("Expected node, got `" + e + "`");
}
function eS(e, n, r) {
  if (!r)
    throw new Error(
      "`" + e + "` finished async. Use `" + n + "` instead"
    );
}
function ws(e) {
  return UM(e) ? e : new M1(e);
}
function UM(e) {
  return !!(e && typeof e == "object" && "message" in e && "messages" in e);
}
function MM(e) {
  return typeof e == "string" || BM(e);
}
function BM(e) {
  return !!(e && typeof e == "object" && "byteLength" in e && "byteOffset" in e);
}
const qM = "https://github.com/remarkjs/react-markdown/blob/main/changelog.md", nS = [], tS = { allowDangerousHtml: !0 }, HM = /^(https?|ircs?|mailto|xmpp)$/i, WM = [
  { from: "astPlugins", id: "remove-buggy-html-in-markdown-parser" },
  { from: "allowDangerousHtml", id: "remove-buggy-html-in-markdown-parser" },
  {
    from: "allowNode",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "allowElement"
  },
  {
    from: "allowedTypes",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "allowedElements"
  },
  {
    from: "disallowedTypes",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "disallowedElements"
  },
  { from: "escapeHtml", id: "remove-buggy-html-in-markdown-parser" },
  { from: "includeElementIndex", id: "#remove-includeelementindex" },
  {
    from: "includeNodeIndex",
    id: "change-includenodeindex-to-includeelementindex"
  },
  { from: "linkTarget", id: "remove-linktarget" },
  { from: "plugins", id: "change-plugins-to-remarkplugins", to: "remarkPlugins" },
  { from: "rawSourcePos", id: "#remove-rawsourcepos" },
  { from: "renderers", id: "change-renderers-to-components", to: "components" },
  { from: "source", id: "change-source-to-children", to: "children" },
  { from: "sourcePos", id: "#remove-sourcepos" },
  { from: "transformImageUri", id: "#add-urltransform", to: "urlTransform" },
  { from: "transformLinkUri", id: "#add-urltransform", to: "urlTransform" }
];
function KM(e) {
  const n = e.allowedElements, r = e.allowElement, i = e.children || "", a = e.className, o = e.components, s = e.disallowedElements, l = e.rehypePlugins || nS, d = e.remarkPlugins || nS, m = e.remarkRehypeOptions ? { ...e.remarkRehypeOptions, ...tS } : tS, u = e.skipHtml, f = e.unwrapDisallowed, h = e.urlTransform || GM, v = zM().use(CU).use(d).use(xM, m).use(l), w = new M1();
  typeof i == "string" && (w.value = i);
  for (const g of WM)
    Object.hasOwn(e, g.from) && ("" + g.from + (g.to ? "use `" + g.to + "` instead" : "remove it") + qM + g.id, void 0);
  const N = v.parse(w);
  let j = v.runSync(N, w);
  return a && (j = {
    type: "element",
    tagName: "div",
    properties: { className: a },
    // Assume no doctypes.
    children: (
      /** @type {Array<ElementContent>} */
      j.type === "root" ? j.children : [j]
    )
  }), U1(j, _), a3(j, {
    Fragment: Xn.Fragment,
    components: o,
    ignoreInvalidStyle: !0,
    jsx: Xn.jsx,
    jsxs: Xn.jsxs,
    passKeys: !0,
    passNode: !0
  });
  function _(g, O, R) {
    if (g.type === "raw" && R && typeof O == "number")
      return u ? R.children.splice(O, 1) : R.children[O] = { type: "text", value: g.value }, O;
    if (g.type === "element") {
      let $;
      for ($ in wm)
        if (Object.hasOwn(wm, $) && Object.hasOwn(g.properties, $)) {
          const I = g.properties[$], L = wm[$];
          (L === null || L.includes(g.tagName)) && (g.properties[$] = h(String(I || ""), $, g));
        }
    }
    if (g.type === "element") {
      let $ = n ? !n.includes(g.tagName) : s ? s.includes(g.tagName) : !1;
      if (!$ && r && typeof O == "number" && ($ = !r(g, O, R)), $ && R && typeof O == "number")
        return f && g.children ? R.children.splice(O, 1, ...g.children) : R.children.splice(O, 1), O;
    }
  }
}
function GM(e) {
  const n = e.indexOf(":"), r = e.indexOf("?"), i = e.indexOf("#"), a = e.indexOf("/");
  return (
    // If there is no protocol, it’s relative.
    n < 0 || // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
    a > -1 && n > a || r > -1 && n > r || i > -1 && n > i || // It is a protocol, it should be allowed.
    HM.test(e.slice(0, n)) ? e : ""
  );
}
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode('._issueAvatar_kc0sw_1{margin:var(--dixa-size-spacer-100) 0}._issueAvatar_kc0sw_1 h2{font-weight:var(--dixa-typography-weight-normal);align-items:center;display:flex}._issueField_kc0sw_9{font-weight:var(--dixa-typography-weight-normal)}._issueDescription_kc0sw_12{font-weight:var(--dixa-typography-weight-normal);color:var(--dixa-color-neutral-800);padding:var(--dixa-size-spacer-200);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100)}._issueDescription_kc0sw_12 p{margin:unset}._wrapper_e0qj3_1{width:400px;padding:0 0 var(--dixa-size-spacer-200) 0;max-height:400px;overflow:hidden;position:relative}._wrapper_e0qj3_1 ._description_e0qj3_8{color:var(--dixa-color-neutral-600)}._wrapper_e0qj3_1:after{width:100%;height:var(--dixa-size-spacer-400);content:"";position:absolute;bottom:0;left:0;background:linear-gradient(0deg,#fff,#ffffffbc 19%,#ffffff8a 34%,#ffffff61 47%,#ffffff47 56.5%,#ffffff31 65%,#ffffff20 73%,#ffffff13 80.2%,#ffffff0b 86.1%,#ffffff05 91%,#ffffff02 95.2%,#ffffff01 98.2%,#fff0)}._resultTitle_e0qj3_21{text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;color:var(--dixa-color-neutral-600)}._resultTooltipTitle_e0qj3_28{margin-bottom:var(--dixa-size-spacer-200)}._resultLinkIcon_e0qj3_31{position:absolute;right:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-000);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);color:var(--dixa-color-neutral-500)}._loader_13xpk_1{width:100%;display:flex;padding:var(--dixa-size-spacer-200);justify-content:center}._dropdown_13xpk_8{max-height:300px;overflow-y:scroll}._loadMore_13xpk_13{cursor:pointer}._loadMore_13xpk_13:hover{background-color:var(--dixa-color-neutral-100)}._loadMore_13xpk_13:hover p{color:var(--dixa-color-purple-600)}._loadMore_13xpk_13 p{color:var(--dixa-color-purple-500)}._collapse_su0f9_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);padding:var(--dixa-size-spacer-100)}._collapseHeader_su0f9_8{padding:var(--dixa-size-spacer-250);width:100%;box-sizing:border-box;background-color:transparent;gap:var(--dixa-size-spacer-100)}._collapseHeader_su0f9_8>div:first-of-type{padding:0!important;padding-right:var(--dixa-size-spacer-300);width:100%}._collapseHeader_su0f9_8>div>div:first-of-type{padding:0!important;width:100%}._collapseHeader_su0f9_8 p>div:first-of-type{justify-content:space-between}._collapseHeader_su0f9_8>div>div>p{white-space:unset!important;margin:0}._collapseContent_su0f9_31{padding:0 var(--dixa-size-spacer-250) var(--dixa-size-spacer-250) var(--dixa-size-spacer-250)}._url_su0f9_35{align-items:center;display:flex;flex-direction:row;gap:var(--dixa-size-spacer-100);color:var(--dixa-color-purple-500);font-weight:var(--dixa-typography-weight-semibold);cursor:pointer;font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200)}._empty_su0f9_47 p{color:var(--dixa-color-neutral-400)}._externalLink_su0f9_51{color:var(--dixa-typography-color-link)}._emptyState_su0f9_55{font-weight:var(--dixa-typography-weight-normal)}._modalBody_iv3ua_1{width:600px}._error_iv3ua_5{border:var(--dixa-size-border-100) solid var(--dixa-typography-color-error)}._emptyState_iv3ua_9{padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-200) var(--dixa-size-spacer-200)}._emptyState_iv3ua_9 p{color:var(--dixa-color-neutral-400)}._dropdown_iv3ua_16{max-height:300px;overflow-y:scroll}._modalWrapper_4kh9u_1{min-width:600px;position:relative}._copyButton_4kh9u_6{height:var(--dixa-size-spacer-500);width:var(--dixa-size-spacer-500)}._copyButton_4kh9u_6 button{background-color:var(--dixa-color-neutral-100);border-radius:0 var(--dixa-size-border-radius-100) var(--dixa-size-border-radius-100) 0}._copyWrapper_4kh9u_15{box-sizing:border-box}._copyWrapper_4kh9u_15:focus-within{border-radius:var(--dixa-size-border-radius-100);outline:solid var(--dixa-size-border-100) var(--dixa-color-purple-500);box-shadow:0 0 0 3px var(--dixa-color-purple-300)}._copyField_4kh9u_24{cursor:pointer;min-width:62ch;height:var(--dixa-size-spacer-500);border-radius:var(--dixa-size-border-radius-100) 0 0 var(--dixa-size-border-radius-100);border:none}._copyField_4kh9u_24:hover{border:none}._copyField_4kh9u_24:focus-within{box-shadow:none;border:none;outline:none}._copyField_4kh9u_24 input{color:var(--dixa-color-neutral-800);background-color:var(--dixa-color-neutral-100);cursor:pointer;border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200);border-right:none}._externalLink_4kh9u_47{display:flex;align-items:center}._externalLinkIcon_4kh9u_52{align-self:center}._textWrapper_4kh9u_56{display:flex;gap:var(--dixa-size-spacer-100)}')), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Am = { exports: {} }, oo = {}, rS;
function YM() {
  if (rS) return oo;
  rS = 1;
  var e = He, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (v = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return oo.Fragment = r, oo.jsx = s, oo.jsxs = s, oo;
}
var Cs = {}, iS;
function JM() {
  return iS || (iS = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = He, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), d = /* @__PURE__ */ Symbol.for("react.forward_ref"), m = /* @__PURE__ */ Symbol.for("react.suspense"), u = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), v = /* @__PURE__ */ Symbol.for("react.offscreen"), w = Symbol.iterator, N = "@@iterator";
    function j(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = w && t[w] || t[N];
      return typeof c == "function" ? c : null;
    }
    var _ = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          p[y - 1] = arguments[y];
        O("error", t, p);
      }
    }
    function O(t, c, p) {
      {
        var y = _.ReactDebugCurrentFrame, C = y.getStackAddendum();
        C !== "" && (c += "%s", p = p.concat([C]));
        var T = p.map(function(S) {
          return String(S);
        });
        T.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, T);
      }
    }
    var R = !1, $ = !1, I = !1, L = !1, G = !1, Q;
    Q = /* @__PURE__ */ Symbol.for("react.module.reference");
    function ne(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || G || t === a || t === m || t === u || L || t === v || R || $ || I || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Q || t.getModuleId !== void 0));
    }
    function q(t, c, p) {
      var y = t.displayName;
      if (y)
        return y;
      var C = c.displayName || c.name || "";
      return C !== "" ? p + "(" + C + ")" : p;
    }
    function Y(t) {
      return t.displayName || "Context";
    }
    function P(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return Y(c) + ".Consumer";
          case s:
            var p = t;
            return Y(p._context) + ".Provider";
          case d:
            return q(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : P(t.type) || "Memo";
          case h: {
            var C = t, T = C._payload, S = C._init;
            try {
              return P(S(T));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var B = Object.assign, ie = 0, je, pe, le, ge, V, be, Oe;
    function H() {
    }
    H.__reactDisabledLog = !0;
    function Ye() {
      {
        if (ie === 0) {
          je = console.log, pe = console.info, le = console.warn, ge = console.error, V = console.group, be = console.groupCollapsed, Oe = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: H,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ie++;
      }
    }
    function ln() {
      {
        if (ie--, ie === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: B({}, t, {
              value: je
            }),
            info: B({}, t, {
              value: pe
            }),
            warn: B({}, t, {
              value: le
            }),
            error: B({}, t, {
              value: ge
            }),
            group: B({}, t, {
              value: V
            }),
            groupCollapsed: B({}, t, {
              value: be
            }),
            groupEnd: B({}, t, {
              value: Oe
            })
          });
        }
        ie < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Ie = _.ReactCurrentDispatcher, Ue;
    function De(t, c, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (C) {
            var y = C.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Be = !1, Ae;
    {
      var Qe = typeof WeakMap == "function" ? WeakMap : Map;
      Ae = new Qe();
    }
    function Ee(t, c) {
      if (!t || Be)
        return "";
      {
        var p = Ae.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Be = !0;
      var C = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var T;
      T = Ie.current, Ie.current = null, Ye();
      try {
        if (c) {
          var S = function() {
            throw Error();
          };
          if (Object.defineProperty(S.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(S, []);
            } catch (re) {
              y = re;
            }
            Reflect.construct(t, [], S);
          } else {
            try {
              S.call();
            } catch (re) {
              y = re;
            }
            t.call(S.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (re) {
            y = re;
          }
          t();
        }
      } catch (re) {
        if (re && y && typeof re.stack == "string") {
          for (var x = re.stack.split(`
`), ee = y.stack.split(`
`), A = x.length - 1, M = ee.length - 1; A >= 1 && M >= 0 && x[A] !== ee[M]; )
            M--;
          for (; A >= 1 && M >= 0; A--, M--)
            if (x[A] !== ee[M]) {
              if (A !== 1 || M !== 1)
                do
                  if (A--, M--, M < 0 || x[A] !== ee[M]) {
                    var ue = `
` + x[A].replace(" at new ", " at ");
                    return t.displayName && ue.includes("<anonymous>") && (ue = ue.replace("<anonymous>", t.displayName)), typeof t == "function" && Ae.set(t, ue), ue;
                  }
                while (A >= 1 && M >= 0);
              break;
            }
        }
      } finally {
        Be = !1, Ie.current = T, ln(), Error.prepareStackTrace = C;
      }
      var ze = t ? t.displayName || t.name : "", Te = ze ? De(ze) : "";
      return typeof t == "function" && Ae.set(t, Te), Te;
    }
    function Me(t, c, p) {
      return Ee(t, !1);
    }
    function en(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function se(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ee(t, en(t));
      if (typeof t == "string")
        return De(t);
      switch (t) {
        case m:
          return De("Suspense");
        case u:
          return De("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Me(t.render);
          case f:
            return se(t.type, c, p);
          case h: {
            var y = t, C = y._payload, T = y._init;
            try {
              return se(T(C), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var ce = Object.prototype.hasOwnProperty, Se = {}, Ve = _.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, p = se(t.type, t._source, c ? c.type : null);
        Ve.setExtraStackFrame(p);
      } else
        Ve.setExtraStackFrame(null);
    }
    function kn(t, c, p, y, C) {
      {
        var T = Function.call.bind(ce);
        for (var S in t)
          if (T(t, S)) {
            var x = void 0;
            try {
              if (typeof t[S] != "function") {
                var ee = Error((y || "React class") + ": " + p + " type `" + S + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[S] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ee.name = "Invariant Violation", ee;
              }
              x = t[S](c, S, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (A) {
              x = A;
            }
            x && !(x instanceof Error) && (Pe(C), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, S, typeof x), Pe(null)), x instanceof Error && !(x.message in Se) && (Se[x.message] = !0, Pe(C), g("Failed %s type: %s", p, x.message), Pe(null));
          }
      }
    }
    var X = Array.isArray;
    function E(t) {
      return X(t);
    }
    function z(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function ae(t) {
      try {
        return de(t), !1;
      } catch {
        return !0;
      }
    }
    function de(t) {
      return "" + t;
    }
    function U(t) {
      if (ae(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", z(t)), de(t);
    }
    var J = _.ReactCurrentOwner, ve = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, we, Re;
    function rn(t) {
      if (ce.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function bn(t) {
      if (ce.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function an(t, c) {
      typeof t.ref == "string" && J.current;
    }
    function hn(t, c) {
      {
        var p = function() {
          we || (we = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function En(t, c) {
      {
        var p = function() {
          Re || (Re = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var _n = function(t, c, p, y, C, T, S) {
      var x = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: S,
        // Record the component responsible for creating this element.
        _owner: T
      };
      return x._store = {}, Object.defineProperty(x._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(x, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(x, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: C
      }), Object.freeze && (Object.freeze(x.props), Object.freeze(x)), x;
    };
    function Fn(t, c, p, y, C) {
      {
        var T, S = {}, x = null, ee = null;
        p !== void 0 && (U(p), x = "" + p), bn(c) && (U(c.key), x = "" + c.key), rn(c) && (ee = c.ref, an(c));
        for (T in c)
          ce.call(c, T) && !ve.hasOwnProperty(T) && (S[T] = c[T]);
        if (t && t.defaultProps) {
          var A = t.defaultProps;
          for (T in A)
            S[T] === void 0 && (S[T] = A[T]);
        }
        if (x || ee) {
          var M = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          x && hn(S, M), ee && En(S, M);
        }
        return _n(t, x, ee, C, y, J.current, S);
      }
    }
    var Ze = _.ReactCurrentOwner, gn = _.ReactDebugCurrentFrame;
    function Le(t) {
      if (t) {
        var c = t._owner, p = se(t.type, t._source, c ? c.type : null);
        gn.setExtraStackFrame(p);
      } else
        gn.setExtraStackFrame(null);
    }
    var dn;
    dn = !1;
    function un(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function Nn() {
      {
        if (Ze.current) {
          var t = P(Ze.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Bn(t) {
      return "";
    }
    var Sn = {};
    function An(t) {
      {
        var c = Nn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function vn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = An(c);
        if (Sn[p])
          return;
        Sn[p] = !0;
        var y = "";
        t && t._owner && t._owner !== Ze.current && (y = " It was passed a child from " + P(t._owner.type) + "."), Le(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Le(null);
      }
    }
    function xn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (E(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            un(y) && vn(y, c);
          }
        else if (un(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var C = j(t);
          if (typeof C == "function" && C !== t.entries)
            for (var T = C.call(t), S; !(S = T.next()).done; )
              un(S.value) && vn(S.value, c);
        }
      }
    }
    function Ln(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var y = P(c);
          kn(p, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !dn) {
          dn = !0;
          var C = P(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", C || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var y = c[p];
          if (y !== "children" && y !== "key") {
            Le(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Le(null);
            break;
          }
        }
        t.ref !== null && (Le(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Le(null));
      }
    }
    var Cn = {};
    function wn(t, c, p, y, C, T) {
      {
        var S = ne(t);
        if (!S) {
          var x = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (x += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ee = Bn();
          ee ? x += ee : x += Nn();
          var A;
          t === null ? A = "null" : E(t) ? A = "array" : t !== void 0 && t.$$typeof === n ? (A = "<" + (P(t.type) || "Unknown") + " />", x = " Did you accidentally export a JSX literal instead of a component?") : A = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", A, x);
        }
        var M = Fn(t, c, p, C, T);
        if (M == null)
          return M;
        if (S) {
          var ue = c.children;
          if (ue !== void 0)
            if (y)
              if (E(ue)) {
                for (var ze = 0; ze < ue.length; ze++)
                  xn(ue[ze], t);
                Object.freeze && Object.freeze(ue);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              xn(ue, t);
        }
        if (ce.call(c, "key")) {
          var Te = P(t), re = Object.keys(c).filter(function(Gn) {
            return Gn !== "key";
          }), mn = re.length > 0 ? "{key: someKey, " + re.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Cn[Te + mn]) {
            var Dn = re.length > 0 ? "{" + re.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, mn, Te, Dn, Te), Cn[Te + mn] = !0;
          }
        }
        return t === i ? Vn(M) : Ln(M), M;
      }
    }
    function zn(t, c, p) {
      return wn(t, c, p, !0);
    }
    function qn(t, c, p) {
      return wn(t, c, p, !1);
    }
    var Un = qn, Kn = zn;
    Cs.Fragment = i, Cs.jsx = Un, Cs.jsxs = Kn;
  })()), Cs;
}
var aS;
function QM() {
  return aS || (aS = 1, process.env.NODE_ENV === "production" ? Am.exports = YM() : Am.exports = JM()), Am.exports;
}
var oe = QM();
const XM = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createIssue" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueTitle" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueDescription" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "teamId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "projectId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "statusId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "priority" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Linear" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issueCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "title" }, value: { kind: "Variable", name: { kind: "Name", value: "issueTitle" } } }, { kind: "ObjectField", name: { kind: "Name", value: "description" }, value: { kind: "Variable", name: { kind: "Name", value: "issueDescription" } } }, { kind: "ObjectField", name: { kind: "Name", value: "teamId" }, value: { kind: "Variable", name: { kind: "Name", value: "teamId" } } }, { kind: "ObjectField", name: { kind: "Name", value: "projectId" }, value: { kind: "Variable", name: { kind: "Name", value: "projectId" } } }, { kind: "ObjectField", name: { kind: "Name", value: "stateId" }, value: { kind: "Variable", name: { kind: "Name", value: "statusId" } } }, { kind: "ObjectField", name: { kind: "Name", value: "priority" }, value: { kind: "Variable", name: { kind: "Name", value: "priority" } } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "success" } }, { kind: "Field", name: { kind: "Name", value: "issue" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "identifier" } }, { kind: "Field", name: { kind: "Name", value: "url" } }] } }] } }] } }] } }] }, ZM = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "staticData" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Linear" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "teams" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "organization" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "urlKey" } }] } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "issuePriorityValues" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "priority" } }, { kind: "Field", name: { kind: "Name", value: "label" } }] } }, { kind: "Field", name: { kind: "Name", value: "organization" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "urlKey" } }] } }] } }] } }] }, e4 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "teamData" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "teamId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Linear" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "team" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "teamId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "projects" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "states" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "color" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "templates" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "templateData" } }] } }] } }] } }] } }] } }] } }] }, n4 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "searchIssues" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueQuery" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "after" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "first" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Linear" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "searchIssues" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }, { kind: "Argument", name: { kind: "Name", value: "after" }, value: { kind: "Variable", name: { kind: "Name", value: "after" } } }, { kind: "Argument", name: { kind: "Name", value: "term" }, value: { kind: "Variable", name: { kind: "Name", value: "issueQuery" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "identifier" } }, { kind: "Field", name: { kind: "Name", value: "priority" } }, { kind: "Field", name: { kind: "Name", value: "priorityLabel" } }, { kind: "Field", name: { kind: "Name", value: "url" } }, { kind: "Field", name: { kind: "Name", value: "state" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "color" } }] } }, { kind: "Field", name: { kind: "Name", value: "assignee" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "displayName" } }, { kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "email" } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "color" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "team" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "organization" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "urlKey" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "project" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "pageInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "hasNextPage" } }, { kind: "Field", name: { kind: "Name", value: "endCursor" } }] } }] } }] } }] } }] }, t4 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "searchLinkedIssues" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "linkedIssues" } }, type: { kind: "ListType", type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Linear" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issues" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "id" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "in" }, value: { kind: "Variable", name: { kind: "Name", value: "linkedIssues" } } }] } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "identifier" } }, { kind: "Field", name: { kind: "Name", value: "priority" } }, { kind: "Field", name: { kind: "Name", value: "priorityLabel" } }, { kind: "Field", name: { kind: "Name", value: "url" } }, { kind: "Field", name: { kind: "Name", value: "state" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "color" } }] } }, { kind: "Field", name: { kind: "Name", value: "assignee" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "displayName" } }, { kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "email" } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "color" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "team" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "organization" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "urlKey" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "project" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }] } }] } }] } }] }, r4 = {
  "\n  mutation createIssue(\n    $issueTitle: String!\n    $issueDescription: String\n    $teamId: String!\n    $projectId: String\n    $statusId: String\n    $priority: Int\n  ) {\n    Linear {\n      issueCreate(\n        input: {\n          title: $issueTitle\n          description: $issueDescription\n          teamId: $teamId\n          projectId: $projectId\n          stateId: $statusId\n          priority: $priority\n        }\n      ) {\n        success\n        issue {\n          id\n          title\n          identifier\n          url\n        }\n      }\n    }\n  }\n": XM,
  "\n  query staticData {\n    Linear {\n      teams {\n        edges {\n          node {\n            id\n            name\n            organization {\n              urlKey\n            }\n          }\n        }\n      }\n      issuePriorityValues {\n        priority\n        label\n      }\n      organization {\n        urlKey\n      }\n    }\n  }\n": ZM,
  "\n  query teamData($teamId: String!) {\n    Linear {\n      team(id: $teamId) {\n        projects {\n          edges {\n            node {\n              id\n              name\n            }\n          }\n        }\n        states {\n          edges {\n            node {\n              id\n              name\n              type\n              color\n            }\n          }\n        }\n        templates {\n          edges {\n            node {\n              id\n              name\n              type\n              templateData\n            }\n          }\n        }\n      }\n    }\n  }\n": e4,
  "\n  query searchIssues($issueQuery: String! $after: String, $first: Int ) {\n    Linear {\n      searchIssues(\n        first:$first\n        after:$after\n        term: $issueQuery\n      ) {\n        edges {\n          node {\n            id\n            title\n            description\n            identifier\n            priority\n            priorityLabel\n            url\n            state {\n              id\n              type\n              name\n              color\n            }\n            assignee {\n              name\n              displayName\n              avatarUrl\n              email\n            }\n            labels {\n              edges {\n                node {\n                  id\n                  name\n                  color\n                }\n              }\n            }\n            team {\n              name\n              organization {\n                urlKey\n              }\n            }\n            project {\n              id\n              name\n            }\n          }\n        }\n        pageInfo {\n          hasNextPage\n          endCursor\n        }\n      }\n    }\n  }\n": n4,
  "\n  query searchLinkedIssues($linkedIssues: [ID!]) {\n    Linear {\n      issues(filter: { id: { in: $linkedIssues } }) {\n        edges {\n          node {\n            id\n            title\n            description\n            identifier\n            priority\n            priorityLabel\n            url\n            state {\n              id\n              type\n              name\n              color\n            }\n            assignee {\n              name\n              displayName\n              avatarUrl\n              email\n            }\n            labels {\n              edges {\n                node {\n                  id\n                  name\n                  color\n                }\n              }\n            }\n            team {\n              name\n              organization {\n                urlKey\n              }\n            }\n            project {\n              id\n              name\n            }\n          }\n        }\n      }\n    }\n  }\n": t4
};
function os(e) {
  return r4[e] ?? {};
}
const i4 = os(
  /* GraphQL */
  `
  query searchIssues($issueQuery: String! $after: String, $first: Int ) {
    Linear {
      searchIssues(
        first:$first
        after:$after
        term: $issueQuery
      ) {
        edges {
          node {
            id
            title
            description
            identifier
            priority
            priorityLabel
            url
            state {
              id
              type
              name
              color
            }
            assignee {
              name
              displayName
              avatarUrl
              email
            }
            labels {
              edges {
                node {
                  id
                  name
                  color
                }
              }
            }
            team {
              name
              organization {
                urlKey
              }
            }
            project {
              id
              name
            }
          }
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
`
), a4 = os(
  /* GraphQL */
  `
  query searchLinkedIssues($linkedIssues: [ID!]) {
    Linear {
      issues(filter: { id: { in: $linkedIssues } }) {
        edges {
          node {
            id
            title
            description
            identifier
            priority
            priorityLabel
            url
            state {
              id
              type
              name
              color
            }
            assignee {
              name
              displayName
              avatarUrl
              email
            }
            labels {
              edges {
                node {
                  id
                  name
                  color
                }
              }
            }
            team {
              name
              organization {
                urlKey
              }
            }
            project {
              id
              name
            }
          }
        }
      }
    }
  }
`
), Fs = ({
  title: e,
  children: n
}) => /* @__PURE__ */ oe.jsxs(b, { flexDirection: "column", gap: "100", children: [
  /* @__PURE__ */ oe.jsx(F.Paragraph, { variant: "5", color: "neutral.500", children: e }),
  n
] }), o4 = "_issueAvatar_kc0sw_1", s4 = "_issueField_kc0sw_9", l4 = "_issueDescription_kc0sw_12", Is = {
  issueAvatar: o4,
  issueField: s4,
  issueDescription: l4
}, B1 = ({ issue: e }) => /* @__PURE__ */ oe.jsxs(oe.Fragment, { children: [
  /* @__PURE__ */ oe.jsx(Fs, { title: "Assignee", children: /* @__PURE__ */ oe.jsxs(
    b,
    {
      gap: "200",
      flexDirection: "row",
      alignContent: "center",
      className: Is.issueAvatar,
      children: [
        /* @__PURE__ */ oe.jsx(
          Ty,
          {
            size: "24",
            user: e.assignee ? {
              name: e.assignee.name || null,
              // eslint-disable-next-line camelcase
              avatar_url: e.assignee.avatarUrl || null,
              email: e.assignee.email
            } : void 0
          }
        ),
        /* @__PURE__ */ oe.jsx(F.Heading, { variant: "heading-4", children: e.assignee ? e.assignee.name : "Unassigned" })
      ]
    }
  ) }),
  e.team?.name && /* @__PURE__ */ oe.jsx(Fs, { title: "Team", children: /* @__PURE__ */ oe.jsx(
    F.Paragraph,
    {
      variant: "3",
      color: "neutral.800",
      className: Is.issueField,
      children: e.team.name
    }
  ) }),
  e.project?.name && /* @__PURE__ */ oe.jsx(Fs, { title: "Project", children: /* @__PURE__ */ oe.jsx(
    F.Paragraph,
    {
      variant: "3",
      color: "neutral.800",
      className: Is.issueField,
      children: e.project.name
    }
  ) }),
  /* @__PURE__ */ oe.jsx(Fs, { title: "Description", children: /* @__PURE__ */ oe.jsx(KM, { className: Is.issueDescription, children: e.description }) })
] }), c4 = /* @__PURE__ */ oe.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "var(--dixa-color-neutral-500)",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    "aria-label": "No Priority",
    "data-testid": "noPriorityIcon",
    children: [
      /* @__PURE__ */ oe.jsx("rect", { width: "2", height: "2", rx: "1", transform: "matrix(-1 0 0 1 5 7)" }),
      /* @__PURE__ */ oe.jsx("rect", { width: "2", height: "2", rx: "1", transform: "matrix(-1 0 0 1 8 7)" }),
      /* @__PURE__ */ oe.jsx("rect", { width: "2", height: "2", rx: "1", transform: "matrix(-1 0 0 1 11 7)" })
    ]
  }
), d4 = /* @__PURE__ */ oe.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "var(--dixa-color-neutral-500)",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    "aria-label": "Low Priority",
    children: [
      /* @__PURE__ */ oe.jsx("rect", { x: "1", y: "8", width: "3", height: "6", rx: "1" }),
      /* @__PURE__ */ oe.jsx("rect", { x: "6", y: "5", width: "3", height: "9", rx: "1", fillOpacity: "0.4" }),
      /* @__PURE__ */ oe.jsx("rect", { x: "11", y: "2", width: "3", height: "12", rx: "1", fillOpacity: "0.4" })
    ]
  }
), u4 = /* @__PURE__ */ oe.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "var(--dixa-color-neutral-500)",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    "aria-label": "Medium Priority",
    children: [
      /* @__PURE__ */ oe.jsx("rect", { x: "1", y: "8", width: "3", height: "6", rx: "1" }),
      /* @__PURE__ */ oe.jsx("rect", { x: "6", y: "5", width: "3", height: "9", rx: "1" }),
      /* @__PURE__ */ oe.jsx("rect", { x: "11", y: "2", width: "3", height: "12", rx: "1", fillOpacity: "0.4" })
    ]
  }
), m4 = /* @__PURE__ */ oe.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "var(--dixa-color-neutral-500)",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    "aria-label": "High Priority",
    children: [
      /* @__PURE__ */ oe.jsx("rect", { x: "1", y: "8", width: "3", height: "6", rx: "1" }),
      /* @__PURE__ */ oe.jsx("rect", { x: "6", y: "5", width: "3", height: "9", rx: "1" }),
      /* @__PURE__ */ oe.jsx("rect", { x: "11", y: "2", width: "3", height: "12", rx: "1" })
    ]
  }
), p4 = /* @__PURE__ */ oe.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    viewBox: "-1 -1 15 15",
    "aria-label": "Urgent Priority",
    fill: "var(--dixa-color-orange-400)",
    children: /* @__PURE__ */ oe.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2 0a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2V2a2 2 0 00-2-2H2zm3.914 3h1.738L7.5 8.602H6.07L5.914 3zm1.809 7.164a.95.95 0 01-.938.938.934.934 0 110-1.867c.5 0 .934.417.938.93z"
      }
    )
  }
), q1 = {
  0: c4,
  1: p4,
  2: m4,
  3: u4,
  4: d4
}, f4 = (e) => e in q1, Il = ({ priority: e }) => f4(e) ? q1[e] : /* @__PURE__ */ oe.jsx(Jn, { "data-testid": "defaultPriorityTag", children: e }), h4 = (e, n) => /* @__PURE__ */ oe.jsx(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    "aria-label": n,
    fill: e,
    "data-testid": "defaultStatusIcon",
    children: /* @__PURE__ */ oe.jsx(
      "path",
      {
        d: "M13.9408 7.91426L11.9576 7.65557C11.9855 7.4419 12 7.22314 12 7C12 6.77686 11.9855 6.5581 11.9576 6.34443L13.9408 6.08573C13.9799 6.38496 14 6.69013 14 7C14 7.30987 13.9799 7.61504 13.9408 7.91426ZM13.4688 4.32049C13.2328 3.7514 12.9239 3.22019 12.5538 2.73851L10.968 3.95716C11.2328 4.30185 11.4533 4.68119 11.6214 5.08659L13.4688 4.32049ZM11.2615 1.4462L10.0428 3.03204C9.69815 2.76716 9.31881 2.54673 8.91341 2.37862L9.67951 0.531163C10.2486 0.767153 10.7798 1.07605 11.2615 1.4462ZM7.91426 0.0591659L7.65557 2.04237C7.4419 2.01449 7.22314 2 7 2C6.77686 2 6.5581 2.01449 6.34443 2.04237L6.08574 0.059166C6.38496 0.0201343 6.69013 0 7 0C7.30987 0 7.61504 0.0201343 7.91426 0.0591659ZM4.32049 0.531164L5.08659 2.37862C4.68119 2.54673 4.30185 2.76716 3.95716 3.03204L2.73851 1.4462C3.22019 1.07605 3.7514 0.767153 4.32049 0.531164ZM1.4462 2.73851L3.03204 3.95716C2.76716 4.30185 2.54673 4.68119 2.37862 5.08659L0.531164 4.32049C0.767153 3.7514 1.07605 3.22019 1.4462 2.73851ZM0.0591659 6.08574C0.0201343 6.38496 0 6.69013 0 7C0 7.30987 0.0201343 7.61504 0.059166 7.91426L2.04237 7.65557C2.01449 7.4419 2 7.22314 2 7C2 6.77686 2.01449 6.5581 2.04237 6.34443L0.0591659 6.08574ZM0.531164 9.67951L2.37862 8.91341C2.54673 9.31881 2.76716 9.69815 3.03204 10.0428L1.4462 11.2615C1.07605 10.7798 0.767153 10.2486 0.531164 9.67951ZM2.73851 12.5538L3.95716 10.968C4.30185 11.2328 4.68119 11.4533 5.08659 11.6214L4.32049 13.4688C3.7514 13.2328 3.22019 12.9239 2.73851 12.5538ZM6.08574 13.9408L6.34443 11.9576C6.5581 11.9855 6.77686 12 7 12C7.22314 12 7.4419 11.9855 7.65557 11.9576L7.91427 13.9408C7.61504 13.9799 7.30987 14 7 14C6.69013 14 6.38496 13.9799 6.08574 13.9408ZM9.67951 13.4688L8.91341 11.6214C9.31881 11.4533 9.69815 11.2328 10.0428 10.968L11.2615 12.5538C10.7798 12.9239 10.2486 13.2328 9.67951 13.4688ZM12.5538 11.2615L10.968 10.0428C11.2328 9.69815 11.4533 9.31881 11.6214 8.91341L13.4688 9.67951C13.2328 10.2486 12.924 10.7798 12.5538 11.2615Z",
        stroke: "none"
      }
    )
  }
), y4 = (e, n) => /* @__PURE__ */ oe.jsxs(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    "aria-label": n,
    "data-testid": "unstartedStatusIcon",
    children: [
      /* @__PURE__ */ oe.jsx(
        "rect",
        {
          x: "1",
          y: "1",
          width: "12",
          height: "12",
          rx: "6",
          stroke: e,
          strokeWidth: "2",
          fill: "none"
        }
      ),
      /* @__PURE__ */ oe.jsx(
        "path",
        {
          fill: e,
          stroke: "none",
          d: "M 3.5,3.5 L3.5,0 A3.5,3.5 0 0,1 3.5, 0 z",
          transform: "translate(3.5,3.5)"
        }
      )
    ]
  }
), g4 = (e, n) => /* @__PURE__ */ oe.jsxs("svg", { width: "14", height: "14", viewBox: "0 0 14 14", fill: "none", "aria-label": n, children: [
  /* @__PURE__ */ oe.jsx(
    "rect",
    {
      x: "1",
      y: "1",
      width: "12",
      height: "12",
      rx: "6",
      stroke: e,
      strokeWidth: "2",
      fill: "none"
    }
  ),
  /* @__PURE__ */ oe.jsx(
    "path",
    {
      fill: e,
      stroke: "none",
      d: "M 3.5,3.5 L3.5,0 A3.5,3.5 0 0,1 3.5, 7 z",
      transform: "translate(3.5,3.5)"
    }
  )
] }), v4 = (e, n) => /* @__PURE__ */ oe.jsx(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    "aria-label": n,
    fill: e,
    children: /* @__PURE__ */ oe.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0ZM11.101 5.10104C11.433 4.76909 11.433 4.23091 11.101 3.89896C10.7691 3.56701 10.2309 3.56701 9.89896 3.89896L5.5 8.29792L4.10104 6.89896C3.7691 6.56701 3.2309 6.56701 2.89896 6.89896C2.56701 7.2309 2.56701 7.7691 2.89896 8.10104L4.89896 10.101C5.2309 10.433 5.7691 10.433 6.10104 10.101L11.101 5.10104Z"
      }
    )
  }
), k4 = (e, n) => /* @__PURE__ */ oe.jsx(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    "aria-label": n,
    fill: e,
    children: /* @__PURE__ */ oe.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14ZM5.03033 3.96967C4.73744 3.67678 4.26256 3.67678 3.96967 3.96967C3.67678 4.26256 3.67678 4.73744 3.96967 5.03033L5.93934 7L3.96967 8.96967C3.67678 9.26256 3.67678 9.73744 3.96967 10.0303C4.26256 10.3232 4.73744 10.3232 5.03033 10.0303L7 8.06066L8.96967 10.0303C9.26256 10.3232 9.73744 10.3232 10.0303 10.0303C10.3232 9.73744 10.3232 9.26256 10.0303 8.96967L8.06066 7L10.0303 5.03033C10.3232 4.73744 10.3232 4.26256 10.0303 3.96967C9.73744 3.67678 9.26256 3.67678 8.96967 3.96967L7 5.93934L5.03033 3.96967Z",
        stroke: "none"
      }
    )
  }
), b4 = (e, n) => /* @__PURE__ */ oe.jsx(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    "aria-label": n,
    fill: e,
    children: /* @__PURE__ */ oe.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0ZM11.101 5.10104C11.433 4.76909 11.433 4.23091 11.101 3.89896C10.7691 3.56701 10.2309 3.56701 9.89896 3.89896L5.5 8.29792L4.10104 6.89896C3.7691 6.56701 3.2309 6.56701 2.89896 6.89896C2.56701 7.2309 2.56701 7.7691 2.89896 8.10104L4.89896 10.101C5.2309 10.433 5.7691 10.433 6.10104 10.101L11.101 5.10104Z"
      }
    )
  }
), gy = {
  backlog: (e, n) => h4(e, n),
  unstarted: (e, n) => y4(e, n),
  started: (e, n) => g4(e, n),
  done: (e, n) => v4(e, n),
  canceled: (e, n) => k4(e, n),
  completed: (e, n) => b4(e, n)
}, _4 = (e) => e in gy, $l = ({
  type: e = "backlog",
  color: n = "var(--dixa-color-neutral-400)",
  name: r = "linear-backlog-icon"
}) => _4(e) ? gy[e](n, r) : gy.backlog(
  "var(--dixa-color-neutral-400)",
  "linear-backlog-icon"
), x4 = "_wrapper_e0qj3_1", S4 = "_resultTitle_e0qj3_21", N4 = "_resultTooltipTitle_e0qj3_28", j4 = "_resultLinkIcon_e0qj3_31", so = {
  wrapper: x4,
  resultTitle: S4,
  resultTooltipTitle: N4,
  resultLinkIcon: j4
}, w4 = ({
  issue: e
}) => {
  const [n, r] = me(!1), {
    list: { isDisabled: i },
    item: { onSelect: a }
  } = ql(EI()), o = pt(
    (s) => {
      i || a({
        value: e,
        meta: {
          target: s?.target,
          event: s || void 0
        }
      });
    },
    [i, a, e]
  );
  return /* @__PURE__ */ oe.jsx(
    Ge,
    {
      wrap: "none",
      side: "left",
      content: /* @__PURE__ */ oe.jsxs(b, { flexDirection: "column", gap: "300", className: so.wrapper, children: [
        /* @__PURE__ */ oe.jsxs(b, { flexDirection: "row", justifyContent: "space-between", gap: "300", children: [
          /* @__PURE__ */ oe.jsxs(b, { flexDirection: "row", gap: "200", alignItems: "center", children: [
            /* @__PURE__ */ oe.jsx(
              $l,
              {
                type: e.state.type,
                name: e.state.name,
                color: e.state.color
              }
            ),
            /* @__PURE__ */ oe.jsx(F.Heading, { variant: "heading-3", children: e.identifier }),
            /* @__PURE__ */ oe.jsx(Il, { priority: e.priority })
          ] }),
          /* @__PURE__ */ oe.jsx(Jn, { children: e.state.name })
        ] }),
        /* @__PURE__ */ oe.jsxs(b, { gap: "200", flexDirection: "column", children: [
          /* @__PURE__ */ oe.jsx(
            F.Heading,
            {
              variant: "heading-3",
              className: so.resultTooltipTitle,
              children: e.title
            }
          ),
          /* @__PURE__ */ oe.jsx(B1, { issue: e })
        ] })
      ] }),
      light: !0,
      children: /* @__PURE__ */ oe.jsx(
        mt.Item,
        {
          value: e,
          noFixedSelectionStateSpace: !0,
          className: so.result,
          onMouseEnter: () => r(!0),
          onMouseLeave: () => r(!1),
          "data-testid": "selectionListItemWrapper",
          onClick: o,
          children: /* @__PURE__ */ oe.jsxs(
            b,
            {
              flexDirection: "column",
              style: {
                width: n ? "calc(100% - 32px)" : "100%"
              },
              children: [
                /* @__PURE__ */ oe.jsxs(b, { flexDirection: "row", gap: "200", alignItems: "center", children: [
                  /* @__PURE__ */ oe.jsx(
                    $l,
                    {
                      type: e.state.type,
                      color: e.state.color,
                      name: e.state.name
                    }
                  ),
                  /* @__PURE__ */ oe.jsx(F.Heading, { variant: "heading-3", children: e.identifier }),
                  /* @__PURE__ */ oe.jsx(Il, { priority: e.priority })
                ] }),
                /* @__PURE__ */ oe.jsx(F.Paragraph, { variant: "4", className: so.resultTitle, children: e.title }),
                n && /* @__PURE__ */ oe.jsx(
                  fe,
                  {
                    className: so.resultLinkIcon,
                    name: "plus",
                    size: 32
                  }
                )
              ]
            }
          )
        },
        e.id
      )
    }
  );
}, C4 = "_loader_13xpk_1", F4 = "_dropdown_13xpk_8", I4 = "_loadMore_13xpk_13", Lm = {
  loader: C4,
  dropdown: F4,
  loadMore: I4
}, $4 = ({
  handleSelect: e,
  linkedIssues: n
}) => {
  const [r, i] = me(), [a, o] = me([]), [s, l] = me(""), [d, m] = me(!1), { useLazyQuery: u } = fn(), [f, { data: h, loading: v, networkStatus: w }] = u(
    i4,
    {
      fetchPolicy: "no-cache",
      notifyOnNetworkStatusChange: !0
    }
  );
  xi(
    () => {
      !v && s !== "" && w === ir.ready ? f({
        variables: {
          issueQuery: s,
          first: 8
        }
      }) : o([]);
    },
    500,
    [s]
  ), Xe(() => {
    v || o([]);
  }, [s]), Xe(() => {
    if (h && Object.keys(h).length > 0) {
      const j = h.Linear.searchIssues.edges.map(
        ({ node: R }) => R
      ), _ = a.filter(
        (R) => !n.find(($) => $.id === R.id)
      ), g = _.filter(
        (R) => !j.find(
          ($) => $.id === R.id
        )
      ), O = j.filter(
        (R) => !n.find(($) => $.id === R.id)
      );
      n.length > 0 ? o(
        d ? [...g, ...O] : O
      ) : h?.Linear?.searchIssues?.edges && o(
        d ? [..._, ...j] : j
      ), h.Linear.searchIssues.pageInfo.hasNextPage && m(!1), i(h.Linear.searchIssues?.pageInfo);
    }
  }, [h, n]);
  const N = () => {
    !v && s !== "" && w === ir.ready ? (m(!0), f({
      variables: {
        issueQuery: s,
        first: 8,
        after: r?.endCursor
      }
    })) : o([]);
  };
  return /* @__PURE__ */ oe.jsx(b, { flexDirection: "column", gap: "200", "data-testid": "searchBarWrapper", children: /* @__PURE__ */ oe.jsxs(
    hi,
    {
      "data-testid": "searchBarComponent",
      clearable: !0,
      getItemTitleByValue: (j) => j?.title,
      onChange: (j) => e(j.selectedValues[0]),
      dropdownProps: { className: Lm.dropdown },
      filter: {
        value: s,
        onChange: (j) => {
          const _ = j.target.value;
          l(_);
        }
      },
      placeholder: "Search Linear issues",
      children: [
        a?.map((j) => /* @__PURE__ */ oe.jsx(w4, { issue: j }, j.id)),
        r?.hasNextPage && !v && s !== "" && a.length && /* @__PURE__ */ oe.jsx(
          b,
          {
            gap: "100",
            justifyContent: "center",
            padding: "200",
            alignItems: "center",
            onClick: () => N(),
            className: Lm.loadMore,
            children: /* @__PURE__ */ oe.jsx(F.Paragraph, { variant: "3", children: "Load more ..." })
          }
        ),
        v && s !== "" && /* @__PURE__ */ oe.jsx(b, { justifyContent: "center", className: Lm.loader, children: /* @__PURE__ */ oe.jsx(sn, { size: 24 }) }),
        s === "" && a.length === 0 && /* @__PURE__ */ oe.jsx(
          b,
          {
            justifyContent: "center",
            style: { margin: "var(--dixa-size-spacer-250)" },
            children: /* @__PURE__ */ oe.jsx(F.Paragraph, { variant: "3", color: "neutral.400", children: "Enter issue title or description" })
          }
        ),
        a.length === 0 && s !== "" && !v && /* @__PURE__ */ oe.jsx(
          b,
          {
            justifyContent: "center",
            style: { margin: "var(--dixa-size-spacer-250)" },
            children: /* @__PURE__ */ oe.jsx(F.Paragraph, { variant: "3", color: "neutral.400", children: "No Linear issues found" })
          }
        )
      ]
    }
  ) });
}, E4 = "_collapse_su0f9_1", T4 = "_collapseHeader_su0f9_8", R4 = "_collapseContent_su0f9_31", D4 = "_url_su0f9_35", O4 = "_externalLink_su0f9_51", P4 = "_emptyState_su0f9_55", pi = {
  collapse: E4,
  collapseHeader: T4,
  collapseContent: R4,
  url: D4,
  externalLink: O4,
  emptyState: P4
}, A4 = ({
  linkedIssues: e,
  isLoading: n,
  handleUnlinkIssue: r,
  showUnlinkAllModal: i,
  showUnlinkAllButton: a,
  organizationUrl: o
}) => {
  const s = e.reduce(
    (u, f) => ({ ...u, [f.id]: !1 }),
    {}
  ), [l, d] = me(s), { track: m } = jn();
  return n ? /* @__PURE__ */ oe.jsx(
    b,
    {
      flexDirection: "column",
      margin: "0 0 400 0",
      justifyContent: "center",
      alignItems: "center",
      children: /* @__PURE__ */ oe.jsx(sn, { size: 24 })
    }
  ) : e.length === 0 ? /* @__PURE__ */ oe.jsxs(
    b,
    {
      flexDirection: "column",
      justifyContent: "center",
      margin: "0 0 300 0",
      gap: "300",
      children: [
        /* @__PURE__ */ oe.jsx(
          F.Paragraph,
          {
            align: "center",
            variant: "3",
            color: "neutral.400",
            className: pi.emptyState,
            children: "No linked issues found"
          }
        ),
        /* @__PURE__ */ oe.jsx(
          Et,
          {
            slotEnd: /* @__PURE__ */ oe.jsx(fe, { name: "external-link" }),
            variant: "tertiary",
            className: pi.externalLink,
            navigate: () => window.open(
              `https://linear.app/${e[0]?.team?.organization.urlKey ?? ""}`,
              "_blank"
            )?.focus(),
            children: "Open Linear"
          }
        )
      ]
    }
  ) : /* @__PURE__ */ oe.jsxs(
    b,
    {
      flexDirection: "column",
      gap: "250",
      margin: "0 0 400 0",
      "data-testid": "linkedIssueWrapper",
      children: [
        e.map((u) => {
          const f = l[u.id];
          return /* @__PURE__ */ oe.jsxs(
            Sr,
            {
              "data-testid": "collapseCard",
              onToggle: () => d({ ...l, [u.id]: !l[u.id] }),
              isOpen: f,
              className: pi.collapse,
              children: [
                /* @__PURE__ */ oe.jsx(Sr.Header, { className: pi.collapseHeader, children: /* @__PURE__ */ oe.jsxs(b, { flexDirection: "column", gap: "100", children: [
                  /* @__PURE__ */ oe.jsxs(b, { flexDirection: "row", justifyContent: "space-between", children: [
                    /* @__PURE__ */ oe.jsxs(b, { gap: "100", alignItems: "center", children: [
                      /* @__PURE__ */ oe.jsx(Ge, { content: /* @__PURE__ */ oe.jsx(b, { children: u.state.name }), children: /* @__PURE__ */ oe.jsx(b, { alignSelf: "center", children: /* @__PURE__ */ oe.jsx(
                        $l,
                        {
                          type: u.state.type,
                          color: u.state.color,
                          name: u.state.name
                        }
                      ) }) }),
                      /* @__PURE__ */ oe.jsxs(
                        F.ExternalLink,
                        {
                          className: pi.url,
                          href: u.url,
                          target: "_blank",
                          rel: "noreferrer",
                          children: [
                            u.identifier,
                            /* @__PURE__ */ oe.jsx(fe, { name: "external-link" })
                          ]
                        }
                      ),
                      /* @__PURE__ */ oe.jsx(Ge, { content: /* @__PURE__ */ oe.jsx(b, { children: u.priorityLabel }), children: /* @__PURE__ */ oe.jsx(b, { alignSelf: "center", children: /* @__PURE__ */ oe.jsx(Il, { priority: u.priority }) }) })
                    ] }),
                    /* @__PURE__ */ oe.jsx(Jn, { children: u.state.name })
                  ] }),
                  u.title
                ] }) }),
                /* @__PURE__ */ oe.jsx(Sr.Content, { className: pi.collapseContent, children: /* @__PURE__ */ oe.jsxs(b, { flexDirection: "column", gap: "300", children: [
                  u?.labels && u?.labels?.edges?.length > 0 && /* @__PURE__ */ oe.jsx(
                    b,
                    {
                      flexDirection: "row",
                      gap: "200",
                      alignItems: "center",
                      flexWrap: "wrap",
                      children: u.labels?.edges.map((h) => /* @__PURE__ */ oe.jsx(Jn, { color: h.node.color, children: h.node.name }, h.node.id))
                    }
                  ),
                  /* @__PURE__ */ oe.jsx(B1, { issue: u }),
                  /* @__PURE__ */ oe.jsx(
                    Qn,
                    {
                      slotStart: /* @__PURE__ */ oe.jsx(fe, { name: "link-slash" }),
                      variant: "secondary",
                      onClick: () => r(u.id),
                      style: { marginTop: "var(--dixa-size-spacer-200)" },
                      children: "Unlink issue from Linear"
                    }
                  ),
                  /* @__PURE__ */ oe.jsxs(
                    Et,
                    {
                      slotEnd: /* @__PURE__ */ oe.jsx(fe, { name: "external-link" }),
                      variant: "tertiary",
                      className: pi.externalLink,
                      onClick: () => {
                        m("linear:open:issue:clicked", {
                          linearInstanceUrl: o,
                          linearIssueKey: u.id
                        });
                      },
                      navigate: () => window.open(u.url, "_blank")?.focus(),
                      children: [
                        "View ",
                        u.identifier,
                        " in Linear"
                      ]
                    }
                  )
                ] }) })
              ]
            },
            u.id
          );
        }),
        e.length > 1 && a && /* @__PURE__ */ oe.jsx(
          Qn,
          {
            slotStart: /* @__PURE__ */ oe.jsx(fe, { name: "link-slash" }),
            variant: "secondary",
            onClick: () => i(!0),
            children: "Unlink all issues"
          }
        ),
        /* @__PURE__ */ oe.jsx(
          Et,
          {
            slotEnd: /* @__PURE__ */ oe.jsx(fe, { name: "external-link" }),
            variant: "tertiary",
            className: pi.externalLink,
            onClick: () => {
              m("linear:open:linear:clicked", {
                // we check against empty linkedIssues earlier in the code.
                // function is using item at index 0 since all teams belong in the same organization/workspace,
                linearInstanceUrl: o,
                linearIssueKey: e[0].id
              });
            },
            disabled: !o,
            navigate: () => window.open(o, "_blank")?.focus(),
            children: "Open Linear"
          }
        )
      ]
    }
  );
}, L4 = {
  default: (e, n) => (n() ?? []).join(""),
  nodes: {
    doc: (e, n) => (n() ?? []).join(""),
    heading: (e, n) => `
${"#".repeat(
      parseInt(e.attrs?.level) || 1
    )} ${n()}

`,
    bullet_list: (e, n) => `
` + n().map((r) => `- ${r}`).join(""),
    ordered_list: (e, n) => `
` + n().map((r) => `1. ${r}`).join(""),
    // We're not emitting list items from the listItem formatter but from the
    // ordered/bullet list nodes above, as markdown does not encapsulate list items
    //listItem: (_node, children) => '- ' + children(),
    paragraph: (e, n) => n().join("") + `
`,
    text: (e) => e.text ?? "",
    hard_break: () => `
`,
    blockquote: (e, n) => `> ${n().join("")}
`,
    code_block: (e, n) => "\n```" + (e.attrs?.language || "") + `
` + n() + "\n```\n"
  },
  marks: {
    text: {
      strong: (e, n) => `**${n()}**`,
      strike: (e, n) => `~~${n()}~~`,
      subsup: (e, n) => {
        switch (e.attrs?.type) {
          case "sub":
            return `<sub>${n()}</sub>`;
          case "sup":
            return `<sup>${n()}</sup>`;
          default:
            return n();
        }
      },
      underline: (e, n) => `<u>${n()}</u>`,
      em: (e, n) => `*${n()}*`,
      link: (e, n) => `[${n()}](${e.attrs?.href})`,
      code: (e, n) => `\`${n()}\``
    }
  }
}, H1 = (e, n) => {
  const r = (o) => (e.marks || []).map((s) => ({
    formatterFunction: n.marks[e.type]?.[s.type],
    mark: s
  })).reduce(
    (s, l) => () => l.formatterFunction?.(l.mark, s) || o,
    () => o
  )(), i = (o, s) => () => o.content ? o.content.map((l) => H1(l, s)) : [], a = n.nodes[e.type] || n.default;
  return r(
    a(e, i(e, n))
  );
}, V4 = "_modalBody_iv3ua_1", z4 = "_error_iv3ua_5", U4 = "_dropdown_iv3ua_16", oa = {
  modalBody: V4,
  error: z4,
  dropdown: U4
}, M4 = os(
  /* GraphQL */
  `
  mutation createIssue(
    $issueTitle: String!
    $issueDescription: String
    $teamId: String!
    $projectId: String
    $statusId: String
    $priority: Int
  ) {
    Linear {
      issueCreate(
        input: {
          title: $issueTitle
          description: $issueDescription
          teamId: $teamId
          projectId: $projectId
          stateId: $statusId
          priority: $priority
        }
      ) {
        success
        issue {
          id
          title
          identifier
          url
        }
      }
    }
  }
`
), B4 = os(
  /* GraphQL */
  `
  query staticData {
    Linear {
      teams {
        edges {
          node {
            id
            name
            organization {
              urlKey
            }
          }
        }
      }
      issuePriorityValues {
        priority
        label
      }
      organization {
        urlKey
      }
    }
  }
`
), q4 = os(
  /* GraphQL */
  `
  query teamData($teamId: String!) {
    Linear {
      team(id: $teamId) {
        projects {
          edges {
            node {
              id
              name
            }
          }
        }
        states {
          edges {
            node {
              id
              name
              type
              color
            }
          }
        }
        templates {
          edges {
            node {
              id
              name
              type
              templateData
            }
          }
        }
      }
    }
  }
`
), H4 = ({
  setCreatedIssue: e,
  isCreateIssueModalOpen: n,
  setIsCreateIssueModalOpen: r,
  setIsCreationSuccessfulModalOpen: i,
  addToLinkedIssueIds: a,
  organizationUrl: o,
  setOrganizationUrl: s
}) => {
  const { useLazyQuery: l, showNotification: d } = fn(), { control: m, handleSubmit: u, reset: f } = ot(), [h, v] = me([]), [w, N] = me(), [j, _] = me([]), [g, O] = me(), [R, $] = me([]), [I, L] = me(), [G, Q] = me([]), [ne, q] = me(), [Y, P] = me([]), [B, ie] = me(), [je, pe] = me(!1), { useMutation: le } = fn(), { track: ge } = jn(), [V, { loading: be }] = le(
    M4,
    {
      onError: () => {
        pe(!1), d({
          title: "Creation was not successful",
          text: "Please try again later or contact your admin.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        });
      },
      onCompleted: (Ee) => {
        const Me = {
          identifier: Ee.Linear?.issueCreate?.issue?.identifier,
          url: Ee.Linear?.issueCreate?.issue?.url
        };
        Ee.Linear && Ee.Linear?.issueCreate?.issue?.id && (a(Ee.Linear?.issueCreate?.issue?.id), Be(Me), pe(!1), d({
          title: "Issue was created and linked to the conversation",
          text: `Issue ${Ee.Linear.issueCreate.issue.identifier} was created and added to the active conversation`,
          icon: "exclamation-triangle-filled",
          severity: "success"
        }), ge("linear:create:new:issue:confirmed", {
          linearInstanceUrl: o
        }));
      }
    }
  ), [
    Oe,
    { data: H, loading: Ye, error: ln }
  ] = l(B4, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onError: () => d({
      title: "Error while fetching team ID",
      text: "Please try again later or contact your admin.",
      icon: "exclamation-triangle-filled",
      severity: "warning"
    }),
    onCompleted: (Ee) => {
      const Me = Ee.Linear.teams.edges.map(
        ({ node: en }) => en
      );
      v(Me), Q(Ee.Linear.issuePriorityValues), s(`${e5}${Ee.Linear.organization.urlKey}`);
    }
  }), [Ie, { data: Ue, loading: De }] = l(q4, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onError: () => d({
      title: "Error while fetching team projects",
      text: "Please try again later or contact your admin.",
      icon: "exclamation-triangle-filled",
      severity: "warning"
    }),
    onCompleted: (Ee) => {
      const Me = Ee?.Linear?.team?.projects?.edges?.map(
        ({ node: ce }) => ce
      );
      _(Me);
      const en = Ee?.Linear?.team?.states?.edges?.map(
        ({ node: ce }) => ce
      );
      $(en);
      const se = Ee?.Linear?.team?.templates?.edges?.map(
        ({ node: ce }) => ce
      );
      P(
        se.filter(
          (ce) => ce.type === "issue"
        )
      );
    }
  }), Be = (Ee) => {
    r(!1), O(void 0), N(void 0), L(void 0), q(void 0), ie(void 0), Ee && (e(Ee), i(!0)), f({
      title: "",
      description: "",
      projectId: "",
      teamId: "",
      statusId: "",
      priority: void 0
    });
  }, Ae = (Ee) => {
    H && !Ye && (V({
      variables: {
        issueTitle: Ee.title,
        issueDescription: Ee?.description,
        teamId: Ee.team.id,
        projectId: Ee?.project?.id,
        statusId: Ee?.status?.id,
        priority: Ee?.priority?.priority
      }
    }), pe(!0));
  };
  Xe(() => {
    n && Oe();
  }, [n]);
  const Qe = () => {
    ge("linear:create:new:issue:cancelled", {
      linearInstanceUrl: o
    });
  };
  return /* @__PURE__ */ oe.jsxs(
    ht,
    {
      isOpen: n,
      onClose: () => {
        Qe(), Be();
      },
      children: [
        /* @__PURE__ */ oe.jsx(
          yt,
          {
            title: "Create new Linear issue",
            onClose: () => {
              Qe(), Be();
            }
          }
        ),
        /* @__PURE__ */ oe.jsx(
          gt,
          {
            className: oa.modalBody,
            "data-testid": "createIssueModalBody",
            children: ln ? /* @__PURE__ */ oe.jsx($n, { error: ln }) : /* @__PURE__ */ oe.jsx("form", { onSubmit: u(Ae), id: "issueCreationForm", children: /* @__PURE__ */ oe.jsxs(et, { children: [
              /* @__PURE__ */ oe.jsx(Z, { span: 3, children: /* @__PURE__ */ oe.jsx(
                jt,
                {
                  control: m,
                  name: "team",
                  rules: {
                    required: "Team is required"
                  },
                  render: ({
                    field: { value: Ee, onChange: Me },
                    fieldState: { error: en }
                  }) => /* @__PURE__ */ oe.jsx(
                    qe,
                    {
                      required: !0,
                      label: "Team",
                      meta: {
                        error: en?.message ?? null
                      },
                      children: /* @__PURE__ */ oe.jsx(
                        hi,
                        {
                          dropdownProps: { className: oa.dropdown },
                          placeholder: "Select Linear team",
                          className: ut({ [oa.error]: en }),
                          getItemTitleByValue: (se) => se?.name,
                          onChange: (se) => {
                            O(void 0), L(void 0), q(void 0), ie(void 0), N(se.selectedValues[0]), Ie({
                              variables: { teamId: se.selectedValues[0].id }
                            }), Me(se.selectedValues[0]);
                          },
                          value: w ? [Ee] : void 0,
                          children: h?.map((se) => /* @__PURE__ */ oe.jsx(
                            mt.Item,
                            {
                              value: se,
                              noFixedSelectionStateSpace: !0,
                              children: /* @__PURE__ */ oe.jsx(F.Paragraph, { children: se.name })
                            },
                            se.id
                          ))
                        }
                      )
                    }
                  )
                }
              ) }),
              /* @__PURE__ */ oe.jsx(Z, { span: 3, children: /* @__PURE__ */ oe.jsx(
                jt,
                {
                  control: m,
                  name: "project",
                  render: ({ field: { value: Ee, onChange: Me } }) => {
                    const en = De ? [{ name: "Loading projects...", id: "" }] : void 0;
                    return /* @__PURE__ */ oe.jsx(qe, { label: "Project", children: /* @__PURE__ */ oe.jsx(
                      hi,
                      {
                        dropdownProps: { className: oa.dropdown },
                        clearable: !0,
                        getItemTitleByValue: (se) => se?.name,
                        disabled: w === void 0,
                        placeholder: w ? "Select Linear project" : "Select a Team first",
                        onChange: (se) => {
                          O(se.selectedValues[0]), Me(se.selectedValues[0]);
                        },
                        value: g ? [Ee] : en,
                        children: /* @__PURE__ */ oe.jsxs(oe.Fragment, { children: [
                          De && /* @__PURE__ */ oe.jsx(
                            b,
                            {
                              justifyContent: "center",
                              style: {
                                padding: "var(--dixa-size-spacer-200)"
                              },
                              children: /* @__PURE__ */ oe.jsx(sn, { size: 24 })
                            }
                          ),
                          Ue && !De && j.map((se) => /* @__PURE__ */ oe.jsx(
                            mt.Item,
                            {
                              value: se,
                              noFixedSelectionStateSpace: !0,
                              children: /* @__PURE__ */ oe.jsx(F.Paragraph, { children: se.name })
                            },
                            se.id
                          ))
                        ] })
                      }
                    ) });
                  }
                }
              ) }),
              /* @__PURE__ */ oe.jsx(Z, { span: 6, children: /* @__PURE__ */ oe.jsx(qe, { label: "Template", children: /* @__PURE__ */ oe.jsx(
                hi,
                {
                  clearable: !0,
                  dropdownProps: { className: oa.dropdown },
                  disabled: !w || De,
                  placeholder: w ? "Select template" : "Select a Team first",
                  getItemTitleByValue: (Ee) => Ee?.name,
                  onChange: (Ee) => {
                    if (Ee.selectedValues.length > 0) {
                      ie(Ee.selectedValues[0]);
                      const Me = JSON.parse(
                        Ee.selectedValues[0].templateData
                      ), en = G.filter(
                        (Ve) => Ve.priority === Me.priority
                      );
                      q(
                        en ? en[0] : void 0
                      );
                      const se = R.filter(
                        (Ve) => Ve.id === Me.stateId
                      );
                      L(
                        se ? se[0] : void 0
                      );
                      const ce = j.filter(
                        (Ve) => Ve.id === Me.projectId
                      );
                      O(
                        ce ? ce[0] : void 0
                      );
                      const Se = Me.description;
                      f({
                        title: Me?.title,
                        priority: en[0],
                        status: se[0],
                        project: ce[0],
                        description: Se ? H1(Se, L4) : "",
                        team: w
                      });
                    } else
                      f({
                        title: "",
                        description: "",
                        team: w
                      }), O(void 0), q(void 0), L(void 0), ie(void 0);
                  },
                  value: B ? [B] : void 0,
                  children: Y?.map((Ee) => /* @__PURE__ */ oe.jsx(
                    mt.Item,
                    {
                      value: Ee,
                      noFixedSelectionStateSpace: !0,
                      children: /* @__PURE__ */ oe.jsx(F.Paragraph, { children: Ee.name })
                    },
                    Ee.id
                  ))
                }
              ) }) }),
              /* @__PURE__ */ oe.jsx(Z, { span: 6, children: /* @__PURE__ */ oe.jsx(
                jt,
                {
                  control: m,
                  name: "title",
                  rules: {
                    required: "Title field is required",
                    minLength: 2
                  },
                  render: ({
                    field: { onChange: Ee, value: Me },
                    fieldState: { error: en }
                  }) => /* @__PURE__ */ oe.jsx(
                    Kr,
                    {
                      required: !0,
                      label: "Title",
                      placeholder: "Insert issue title here",
                      input: {
                        name: "issueTitle",
                        value: Me || "",
                        onChange: Ee
                      },
                      meta: {
                        error: en?.message ?? null
                      }
                    }
                  )
                }
              ) }),
              /* @__PURE__ */ oe.jsx(Z, { span: 3, children: /* @__PURE__ */ oe.jsx(
                jt,
                {
                  control: m,
                  name: "status",
                  render: ({ field: { value: Ee, onChange: Me } }) => {
                    const en = De ? [
                      {
                        name: "Loading statuses...",
                        id: "",
                        type: "",
                        color: ""
                      }
                    ] : void 0;
                    return /* @__PURE__ */ oe.jsx(qe, { label: "Status", children: /* @__PURE__ */ oe.jsx(
                      hi,
                      {
                        dropdownProps: { className: oa.dropdown },
                        clearable: !0,
                        getItemTitleByValue: (se) => se?.name,
                        disabled: w === void 0,
                        placeholder: w ? "Select Issue status" : "Select a Team first",
                        onChange: (se) => {
                          L(se.selectedValues[0]), Me(se.selectedValues[0]);
                        },
                        value: I ? [Ee] : en,
                        children: /* @__PURE__ */ oe.jsxs(oe.Fragment, { children: [
                          De && /* @__PURE__ */ oe.jsx(
                            b,
                            {
                              justifyContent: "center",
                              style: {
                                padding: "var(--dixa-size-spacer-200)"
                              },
                              children: /* @__PURE__ */ oe.jsx(sn, { size: 24 })
                            }
                          ),
                          Ue && !De && R.map((se) => /* @__PURE__ */ oe.jsx(
                            mt.Item,
                            {
                              value: se,
                              noFixedSelectionStateSpace: !0,
                              children: /* @__PURE__ */ oe.jsxs(
                                b,
                                {
                                  flexDirection: "row",
                                  gap: "300",
                                  alignItems: "center",
                                  children: [
                                    /* @__PURE__ */ oe.jsx(
                                      $l,
                                      {
                                        type: se.type,
                                        color: se.color,
                                        name: se.name
                                      }
                                    ),
                                    /* @__PURE__ */ oe.jsx(F.Paragraph, { children: se.name })
                                  ]
                                }
                              )
                            },
                            se.id
                          ))
                        ] })
                      }
                    ) });
                  }
                }
              ) }),
              /* @__PURE__ */ oe.jsx(Z, { span: 3, children: /* @__PURE__ */ oe.jsx(
                jt,
                {
                  control: m,
                  name: "priority",
                  render: ({ field: { value: Ee, onChange: Me } }) => {
                    const en = Ye ? [
                      {
                        label: "Loading Priorities...",
                        priority: 0
                      }
                    ] : void 0;
                    return /* @__PURE__ */ oe.jsx(qe, { label: "Priority", children: /* @__PURE__ */ oe.jsx(
                      hi,
                      {
                        clearable: !0,
                        getItemTitleByValue: (se) => se?.label,
                        disabled: w === void 0,
                        placeholder: w ? "Select Issue priority" : "Select a Team first",
                        onChange: (se) => {
                          q(se.selectedValues[0]), Me(se.selectedValues[0]);
                        },
                        value: ne ? [Ee] : en,
                        children: /* @__PURE__ */ oe.jsxs(oe.Fragment, { children: [
                          De && /* @__PURE__ */ oe.jsx(
                            b,
                            {
                              justifyContent: "center",
                              style: {
                                padding: "var(--dixa-size-spacer-200)"
                              },
                              children: /* @__PURE__ */ oe.jsx(sn, { size: 24 })
                            }
                          ),
                          H && !Ye && G.map((se) => /* @__PURE__ */ oe.jsx(
                            mt.Item,
                            {
                              value: se,
                              noFixedSelectionStateSpace: !0,
                              children: /* @__PURE__ */ oe.jsxs(
                                b,
                                {
                                  flexDirection: "row",
                                  gap: "300",
                                  alignItems: "center",
                                  children: [
                                    /* @__PURE__ */ oe.jsx(
                                      Il,
                                      {
                                        priority: se.priority
                                      }
                                    ),
                                    /* @__PURE__ */ oe.jsx(F.Paragraph, { children: se.label })
                                  ]
                                }
                              )
                            },
                            se.priority
                          ))
                        ] })
                      }
                    ) });
                  }
                }
              ) }),
              /* @__PURE__ */ oe.jsx(Z, { children: /* @__PURE__ */ oe.jsx(
                jt,
                {
                  control: m,
                  name: "description",
                  render: ({
                    field: { onChange: Ee, value: Me },
                    fieldState: { error: en }
                  }) => /* @__PURE__ */ oe.jsx(
                    II,
                    {
                      label: "Description",
                      placeholder: "Insert Issue description here",
                      input: {
                        name: "description",
                        value: Me || "",
                        onChange: Ee
                      },
                      meta: {
                        error: en?.message ?? null
                      }
                    }
                  )
                }
              ) })
            ] }) })
          }
        ),
        /* @__PURE__ */ oe.jsx(
          vt,
          {
            confirmOnClick: u(Ae),
            confirmProps: {
              disabled: be || !H,
              isLoading: je || Ye || De,
              loadingIndicator: /* @__PURE__ */ oe.jsx(sn, { size: 16 })
            },
            confirmName: "Save",
            cancelOnClick: () => {
              Qe(), Be();
            }
          }
        )
      ]
    }
  );
}, W4 = "_modalWrapper_4kh9u_1", K4 = "_copyButton_4kh9u_6", G4 = "_copyWrapper_4kh9u_15", Y4 = "_copyField_4kh9u_24", J4 = "_externalLink_4kh9u_47", Q4 = "_externalLinkIcon_4kh9u_52", X4 = "_textWrapper_4kh9u_56", Fi = {
  modalWrapper: W4,
  copyButton: K4,
  copyWrapper: G4,
  copyField: Y4,
  externalLink: J4,
  externalLinkIcon: Q4,
  textWrapper: X4
}, Z4 = ({
  isCreationSuccessfulModalOpen: e,
  createdIssueData: n,
  setIsCreationSuccessfulModalOpen: r
}) => /* @__PURE__ */ oe.jsxs(
  ht,
  {
    isOpen: !!n && e,
    className: Fi.modalWrapper,
    onClose: () => r(!1),
    children: [
      /* @__PURE__ */ oe.jsx(
        yt,
        {
          title: "Issue creation successful",
          onClose: () => r(!1)
        }
      ),
      /* @__PURE__ */ oe.jsx(gt, { children: /* @__PURE__ */ oe.jsxs(
        b,
        {
          gap: "300",
          flexDirection: "column",
          "data-testid": "creationSuccessfulModal",
          children: [
            /* @__PURE__ */ oe.jsxs(F.Paragraph, { className: Fi.textWrapper, children: [
              `You can visit issue ${n?.identifier} by following `,
              " ",
              /* @__PURE__ */ oe.jsxs(
                F.ExternalLink,
                {
                  href: n?.url,
                  target: "_blank",
                  className: Fi.externalLink,
                  children: [
                    "this link",
                    " ",
                    /* @__PURE__ */ oe.jsx(fe, { name: "external-link", className: Fi.externalLinkIcon })
                  ]
                }
              ),
              "or copy it from the field below."
            ] }),
            /* @__PURE__ */ oe.jsx(qe, { label: "Linear issue link", children: /* @__PURE__ */ oe.jsxs(
              b,
              {
                flexDirection: "row",
                alignItems: "center",
                "data-testid": "copyInputField",
                className: Fi.copyWrapper,
                children: [
                  /* @__PURE__ */ oe.jsx(
                    ur,
                    {
                      readOnly: !0,
                      value: n?.url,
                      className: Fi.copyField
                    }
                  ),
                  /* @__PURE__ */ oe.jsx(
                    $I,
                    {
                      className: Fi.copyButton,
                      textToCopy: n?.url || "",
                      clickedProps: {
                        icon: "check-circle-filled"
                      }
                    }
                  )
                ]
              }
            ) })
          ]
        }
      ) }),
      /* @__PURE__ */ oe.jsx(
        vt,
        {
          cancelOnClick: () => r(!1),
          cancelProps: { variant: "primary" },
          cancelName: "Close"
        }
      )
    ]
  }
), e5 = "https://linear.app/", n5 = ({
  conversationContext: e,
  settings: n
}) => {
  const [r, i] = me([]), [a, o] = me([]), [s, l] = me(!1), [d, m] = me(!1), [u, f] = me(!1), [h, v] = me(), { useLazyQuery: w } = fn(), [N, j] = me(""), _ = n?.enableCreateIssue, g = !!n?.enableUnlinkAll, { track: O } = jn(), {
    loading: R,
    data: $,
    error: I,
    store: L
  } = Iy(e?.conversationId ?? null), [
    G,
    {
      data: Q,
      loading: ne,
      networkStatus: q,
      error: Y
    }
  ] = w(a4, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0
  });
  Xe(() => {
    !R && !I && $ && $?.linear?.issues?.length > 0 ? (o($.linear.issues), G({
      variables: {
        linkedIssues: $.linear.issues
      }
    })) : !R && !I && (i([]), o([]));
  }, [$, R, I]), Xe(() => {
    Q && Q?.Linear && !ne && q === ir.ready && Object.keys(Q).length > 0 && i(Q.Linear.issues?.edges?.map(({ node: pe }) => pe));
  }, [Q, ne, q]);
  const P = (pe) => {
    pe && pe?.team?.organization?.urlKey && O("linear:link:issue:clicked", {
      linearInstanceUrl: N,
      linearIssueKey: pe.id
    });
    const le = (ge) => ge.id === pe?.id;
    r.some((ge) => ge && le(ge)) || ($ && a.length === 0 && o([]), L({
      linear: {
        issues: [...a, pe.id]
      }
    }));
  }, B = (pe) => {
    const le = $?.linear.issues.filter((ge) => ge !== pe) || [];
    O("linear:unlink:issue:clicked", {
      linearInstanceUrl: N,
      linearIssueKey: pe
    }), i(r.filter(({ id: ge }) => ge !== pe)), o(le), L({
      linear: {
        issues: le
      }
    });
  }, ie = () => {
    l(!1), i([]), o([]), L({
      linear: {
        issues: []
      }
    });
  }, je = R || ne || !$ && !I || ($?.linear?.issues?.length ?? 0) > 0 && r.length === 0;
  return !R && !ne && (Y || I) ? /* @__PURE__ */ oe.jsx($n, { error: Y || I }) : /* @__PURE__ */ oe.jsxs(b, { flexDirection: "column", gap: "300", children: [
    /* @__PURE__ */ oe.jsxs(
      ht,
      {
        isOpen: s,
        onClose: () => l(!1),
        children: [
          /* @__PURE__ */ oe.jsx(
            yt,
            {
              title: "Unlink all Linear issues?",
              onClose: () => l(!1)
            }
          ),
          /* @__PURE__ */ oe.jsx(gt, { "data-testid": "unlinkAllIssuesModalBody", children: "You are about to unlink all Linear issues from the conversation. Do you want to proceed?" }),
          /* @__PURE__ */ oe.jsx(
            vt,
            {
              confirmOnClick: () => ie(),
              confirmName: "Unlink all",
              cancelOnClick: () => l(!1)
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ oe.jsx(
      H4,
      {
        isCreateIssueModalOpen: d,
        setIsCreateIssueModalOpen: (pe) => m(pe),
        setIsCreationSuccessfulModalOpen: (pe) => f(pe),
        addToLinkedIssueIds: (pe) => {
          L({
            linear: {
              issues: [...a, pe]
            }
          });
        },
        setCreatedIssue: (pe) => v(pe),
        organizationUrl: N,
        setOrganizationUrl: (pe) => j(pe)
      }
    ),
    /* @__PURE__ */ oe.jsx(
      Z4,
      {
        isCreationSuccessfulModalOpen: u,
        setIsCreationSuccessfulModalOpen: (pe) => f(pe),
        createdIssueData: h
      }
    ),
    /* @__PURE__ */ oe.jsxs(
      b,
      {
        flexDirection: "column",
        background: "neutral.100",
        padding: "300",
        borderRadius: "100",
        gap: "250",
        children: [
          _ && /* @__PURE__ */ oe.jsxs(oe.Fragment, { children: [
            /* @__PURE__ */ oe.jsx(
              Qn,
              {
                variant: "primary",
                onClick: () => {
                  O("linear:create:new:issue:clicked", {
                    linearInstanceUrl: N
                  }), m(!0);
                },
                style: { minHeight: "38px" },
                children: "Create new issue"
              }
            ),
            /* @__PURE__ */ oe.jsx(F.Paragraph, { color: "neutral.600", align: "center", children: "or" })
          ] }),
          /* @__PURE__ */ oe.jsx($4, { handleSelect: P, linkedIssues: r })
        ]
      }
    ),
    /* @__PURE__ */ oe.jsx(
      A4,
      {
        linkedIssues: r,
        isLoading: je,
        handleUnlinkIssue: B,
        showUnlinkAllModal: (pe) => l(pe),
        showUnlinkAllButton: g,
        organizationUrl: N
      }
    )
  ] });
}, El = [
  {
    key: "enableCreateIssue",
    label: 'Enable the "Create issue" button',
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "enableUnlinkAll",
    label: 'Enable the "Unlink all" button',
    type: "boolean",
    secret: !1,
    defaultValue: !0
  }
], oS = ar(El), Ii = "LINEAR", t5 = {
  enabled: !1,
  name: "",
  enableCreateIssue: !0,
  enableUnlinkAll: !0
}, r5 = ({
  integrationId: e,
  configuration: n,
  handleRedirect: r,
  showNotification: i,
  automationCouplingState: a,
  renderConditionsEditor: o
}) => {
  const s = !e, l = ot({
    mode: "onChange",
    defaultValues: t5
  }), {
    create: d,
    update: m,
    remove: u,
    isLoading: f,
    error: h,
    misconfigurationCause: v,
    setMisconfigurationCause: w
  } = pr({
    integrationId: e,
    integrationType: Ii,
    handleRedirect: r,
    showNotification: i
  }), {
    isLoading: N,
    error: j,
    isWidgetUnknown: _,
    refetch: g,
    widgetConfiguration: O
  } = fr({
    integrationId: e,
    fieldDefinitions: El,
    form: l,
    onMisconfigured: w
  }), { renderConditions: R, setRenderConditions: $, renderConditionsForSubmit: I } = hr({
    integrationId: e,
    widgetConfiguration: O,
    renderConditionsEditor: o
  }), L = (Q) => gr(Q, {
    fieldDefinitions: El,
    isCreationMode: s,
    create: d,
    update: m,
    renderConditions: I
  }), G = l.watch("name");
  return /* @__PURE__ */ oe.jsxs(
    yr,
    {
      form: l,
      integrationId: e,
      onValidSubmit: L,
      error: j ?? h,
      onRetry: j ? g : void 0,
      isLoading: f || N,
      isWidgetUnknown: _,
      children: [
        v && /* @__PURE__ */ oe.jsx(vr, { cause: v }),
        /* @__PURE__ */ oe.jsxs(et, { children: [
          /* @__PURE__ */ oe.jsx(Z, { children: /* @__PURE__ */ oe.jsx(qe, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ oe.jsx(
            yn,
            {
              name: "enabled",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ oe.jsx(Z, { span: 3, children: /* @__PURE__ */ oe.jsx(
            Rn,
            {
              name: "name",
              label: "Widget name",
              control: l.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ oe.jsx(Z, { span: 3 }),
          /* @__PURE__ */ oe.jsx(Z, { span: 3, children: /* @__PURE__ */ oe.jsx(qe, { label: oS.enableCreateIssue, children: /* @__PURE__ */ oe.jsx(
            yn,
            {
              name: "enableCreateIssue",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ oe.jsx(Z, { span: 3 }),
          /* @__PURE__ */ oe.jsx(Z, { span: 3, children: /* @__PURE__ */ oe.jsx(qe, { label: oS.enableUnlinkAll, children: /* @__PURE__ */ oe.jsx(
            yn,
            {
              name: "enableUnlinkAll",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ oe.jsx(Z, { span: 3 }),
          !s && e && /* @__PURE__ */ oe.jsx(
            bi,
            {
              configuration: n,
              integrationId: e,
              integrationType: Ii,
              label: "Authorize with OAuth"
            }
          ),
          o && R !== null && /* @__PURE__ */ oe.jsx(Z, { children: o({
            value: R,
            onChange: $,
            configurationKey: O?.id
          }) })
        ] }),
        /* @__PURE__ */ oe.jsx(
          kr,
          {
            integrationType: Ii,
            integrationId: e,
            widgetName: G,
            isCreationMode: s,
            isSubmitting: l.formState.isSubmitting,
            automationCouplingState: a,
            onConfirmDelete: () => u(),
            confirmDeleteVariant: "danger",
            deleteConfirmationBody: /* @__PURE__ */ oe.jsxs(b, { gap: "400", children: [
              /* @__PURE__ */ oe.jsx(
                fe,
                {
                  size: 24,
                  name: "exclamation-triangle-filled",
                  color: "red.500"
                }
              ),
              /* @__PURE__ */ oe.jsxs(b, { gap: "200", flexDirection: "column", children: [
                /* @__PURE__ */ oe.jsxs(F.Heading, { withMarginBottom: !0, children: [
                  "By deleting the ",
                  Ii,
                  " integration, all links between Dixa and ",
                  Ii,
                  " are also deleted."
                ] }),
                /* @__PURE__ */ oe.jsxs(F.Paragraph, { children: [
                  "All data in ",
                  Ii,
                  " stays untouched."
                ] }),
                /* @__PURE__ */ oe.jsxs(F.Paragraph, { children: [
                  "Are you sure you want to delete the ",
                  Ii,
                  " ",
                  'integration "',
                  G,
                  '"?'
                ] })
              ] })
            ] })
          }
        )
      ]
    }
  );
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._wrapper_27vny_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._textVariant_27vny_7{color:var(--dixa-typography-color-secondary);font-size:var(--dixa-typography-size-300)}._copyIcon_27vny_12{cursor:pointer;color:var(--dixa-typography-color-secondary)}._labelText_1q5b5_1{color:var(--dixa-typography-color-secondary)}._list_1q5b5_5{padding:0}._listItem_1q5b5_8{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_1q5b5_8:last-child{border-bottom:none}._listItemEdit_1q5b5_15{cursor:pointer}._notificationText_1q5b5_19{color:var(--dixa-color-neutral-500)}._modalBody_1clhs_1{width:400px}._reward_1wxia_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._reward_1wxia_1:hover{border-color:var(--dixa-color-neutral-400)}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Vm = { exports: {} }, lo = {}, sS;
function i5() {
  if (sS) return lo;
  sS = 1;
  var e = He, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (v = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return lo.Fragment = r, lo.jsx = s, lo.jsxs = s, lo;
}
var $s = {}, lS;
function a5() {
  return lS || (lS = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = He, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), d = /* @__PURE__ */ Symbol.for("react.forward_ref"), m = /* @__PURE__ */ Symbol.for("react.suspense"), u = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), v = /* @__PURE__ */ Symbol.for("react.offscreen"), w = Symbol.iterator, N = "@@iterator";
    function j(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = w && t[w] || t[N];
      return typeof c == "function" ? c : null;
    }
    var _ = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          p[y - 1] = arguments[y];
        O("error", t, p);
      }
    }
    function O(t, c, p) {
      {
        var y = _.ReactDebugCurrentFrame, C = y.getStackAddendum();
        C !== "" && (c += "%s", p = p.concat([C]));
        var T = p.map(function(S) {
          return String(S);
        });
        T.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, T);
      }
    }
    var R = !1, $ = !1, I = !1, L = !1, G = !1, Q;
    Q = /* @__PURE__ */ Symbol.for("react.module.reference");
    function ne(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || G || t === a || t === m || t === u || L || t === v || R || $ || I || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Q || t.getModuleId !== void 0));
    }
    function q(t, c, p) {
      var y = t.displayName;
      if (y)
        return y;
      var C = c.displayName || c.name || "";
      return C !== "" ? p + "(" + C + ")" : p;
    }
    function Y(t) {
      return t.displayName || "Context";
    }
    function P(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return Y(c) + ".Consumer";
          case s:
            var p = t;
            return Y(p._context) + ".Provider";
          case d:
            return q(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : P(t.type) || "Memo";
          case h: {
            var C = t, T = C._payload, S = C._init;
            try {
              return P(S(T));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var B = Object.assign, ie = 0, je, pe, le, ge, V, be, Oe;
    function H() {
    }
    H.__reactDisabledLog = !0;
    function Ye() {
      {
        if (ie === 0) {
          je = console.log, pe = console.info, le = console.warn, ge = console.error, V = console.group, be = console.groupCollapsed, Oe = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: H,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ie++;
      }
    }
    function ln() {
      {
        if (ie--, ie === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: B({}, t, {
              value: je
            }),
            info: B({}, t, {
              value: pe
            }),
            warn: B({}, t, {
              value: le
            }),
            error: B({}, t, {
              value: ge
            }),
            group: B({}, t, {
              value: V
            }),
            groupCollapsed: B({}, t, {
              value: be
            }),
            groupEnd: B({}, t, {
              value: Oe
            })
          });
        }
        ie < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Ie = _.ReactCurrentDispatcher, Ue;
    function De(t, c, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (C) {
            var y = C.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Be = !1, Ae;
    {
      var Qe = typeof WeakMap == "function" ? WeakMap : Map;
      Ae = new Qe();
    }
    function Ee(t, c) {
      if (!t || Be)
        return "";
      {
        var p = Ae.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Be = !0;
      var C = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var T;
      T = Ie.current, Ie.current = null, Ye();
      try {
        if (c) {
          var S = function() {
            throw Error();
          };
          if (Object.defineProperty(S.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(S, []);
            } catch (re) {
              y = re;
            }
            Reflect.construct(t, [], S);
          } else {
            try {
              S.call();
            } catch (re) {
              y = re;
            }
            t.call(S.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (re) {
            y = re;
          }
          t();
        }
      } catch (re) {
        if (re && y && typeof re.stack == "string") {
          for (var x = re.stack.split(`
`), ee = y.stack.split(`
`), A = x.length - 1, M = ee.length - 1; A >= 1 && M >= 0 && x[A] !== ee[M]; )
            M--;
          for (; A >= 1 && M >= 0; A--, M--)
            if (x[A] !== ee[M]) {
              if (A !== 1 || M !== 1)
                do
                  if (A--, M--, M < 0 || x[A] !== ee[M]) {
                    var ue = `
` + x[A].replace(" at new ", " at ");
                    return t.displayName && ue.includes("<anonymous>") && (ue = ue.replace("<anonymous>", t.displayName)), typeof t == "function" && Ae.set(t, ue), ue;
                  }
                while (A >= 1 && M >= 0);
              break;
            }
        }
      } finally {
        Be = !1, Ie.current = T, ln(), Error.prepareStackTrace = C;
      }
      var ze = t ? t.displayName || t.name : "", Te = ze ? De(ze) : "";
      return typeof t == "function" && Ae.set(t, Te), Te;
    }
    function Me(t, c, p) {
      return Ee(t, !1);
    }
    function en(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function se(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ee(t, en(t));
      if (typeof t == "string")
        return De(t);
      switch (t) {
        case m:
          return De("Suspense");
        case u:
          return De("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Me(t.render);
          case f:
            return se(t.type, c, p);
          case h: {
            var y = t, C = y._payload, T = y._init;
            try {
              return se(T(C), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var ce = Object.prototype.hasOwnProperty, Se = {}, Ve = _.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, p = se(t.type, t._source, c ? c.type : null);
        Ve.setExtraStackFrame(p);
      } else
        Ve.setExtraStackFrame(null);
    }
    function kn(t, c, p, y, C) {
      {
        var T = Function.call.bind(ce);
        for (var S in t)
          if (T(t, S)) {
            var x = void 0;
            try {
              if (typeof t[S] != "function") {
                var ee = Error((y || "React class") + ": " + p + " type `" + S + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[S] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ee.name = "Invariant Violation", ee;
              }
              x = t[S](c, S, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (A) {
              x = A;
            }
            x && !(x instanceof Error) && (Pe(C), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, S, typeof x), Pe(null)), x instanceof Error && !(x.message in Se) && (Se[x.message] = !0, Pe(C), g("Failed %s type: %s", p, x.message), Pe(null));
          }
      }
    }
    var X = Array.isArray;
    function E(t) {
      return X(t);
    }
    function z(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function ae(t) {
      try {
        return de(t), !1;
      } catch {
        return !0;
      }
    }
    function de(t) {
      return "" + t;
    }
    function U(t) {
      if (ae(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", z(t)), de(t);
    }
    var J = _.ReactCurrentOwner, ve = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, we, Re;
    function rn(t) {
      if (ce.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function bn(t) {
      if (ce.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function an(t, c) {
      typeof t.ref == "string" && J.current;
    }
    function hn(t, c) {
      {
        var p = function() {
          we || (we = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function En(t, c) {
      {
        var p = function() {
          Re || (Re = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var _n = function(t, c, p, y, C, T, S) {
      var x = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: S,
        // Record the component responsible for creating this element.
        _owner: T
      };
      return x._store = {}, Object.defineProperty(x._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(x, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(x, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: C
      }), Object.freeze && (Object.freeze(x.props), Object.freeze(x)), x;
    };
    function Fn(t, c, p, y, C) {
      {
        var T, S = {}, x = null, ee = null;
        p !== void 0 && (U(p), x = "" + p), bn(c) && (U(c.key), x = "" + c.key), rn(c) && (ee = c.ref, an(c));
        for (T in c)
          ce.call(c, T) && !ve.hasOwnProperty(T) && (S[T] = c[T]);
        if (t && t.defaultProps) {
          var A = t.defaultProps;
          for (T in A)
            S[T] === void 0 && (S[T] = A[T]);
        }
        if (x || ee) {
          var M = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          x && hn(S, M), ee && En(S, M);
        }
        return _n(t, x, ee, C, y, J.current, S);
      }
    }
    var Ze = _.ReactCurrentOwner, gn = _.ReactDebugCurrentFrame;
    function Le(t) {
      if (t) {
        var c = t._owner, p = se(t.type, t._source, c ? c.type : null);
        gn.setExtraStackFrame(p);
      } else
        gn.setExtraStackFrame(null);
    }
    var dn;
    dn = !1;
    function un(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function Nn() {
      {
        if (Ze.current) {
          var t = P(Ze.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Bn(t) {
      return "";
    }
    var Sn = {};
    function An(t) {
      {
        var c = Nn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function vn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = An(c);
        if (Sn[p])
          return;
        Sn[p] = !0;
        var y = "";
        t && t._owner && t._owner !== Ze.current && (y = " It was passed a child from " + P(t._owner.type) + "."), Le(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Le(null);
      }
    }
    function xn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (E(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            un(y) && vn(y, c);
          }
        else if (un(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var C = j(t);
          if (typeof C == "function" && C !== t.entries)
            for (var T = C.call(t), S; !(S = T.next()).done; )
              un(S.value) && vn(S.value, c);
        }
      }
    }
    function Ln(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var y = P(c);
          kn(p, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !dn) {
          dn = !0;
          var C = P(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", C || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var y = c[p];
          if (y !== "children" && y !== "key") {
            Le(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Le(null);
            break;
          }
        }
        t.ref !== null && (Le(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Le(null));
      }
    }
    var Cn = {};
    function wn(t, c, p, y, C, T) {
      {
        var S = ne(t);
        if (!S) {
          var x = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (x += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ee = Bn();
          ee ? x += ee : x += Nn();
          var A;
          t === null ? A = "null" : E(t) ? A = "array" : t !== void 0 && t.$$typeof === n ? (A = "<" + (P(t.type) || "Unknown") + " />", x = " Did you accidentally export a JSX literal instead of a component?") : A = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", A, x);
        }
        var M = Fn(t, c, p, C, T);
        if (M == null)
          return M;
        if (S) {
          var ue = c.children;
          if (ue !== void 0)
            if (y)
              if (E(ue)) {
                for (var ze = 0; ze < ue.length; ze++)
                  xn(ue[ze], t);
                Object.freeze && Object.freeze(ue);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              xn(ue, t);
        }
        if (ce.call(c, "key")) {
          var Te = P(t), re = Object.keys(c).filter(function(Gn) {
            return Gn !== "key";
          }), mn = re.length > 0 ? "{key: someKey, " + re.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Cn[Te + mn]) {
            var Dn = re.length > 0 ? "{" + re.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, mn, Te, Dn, Te), Cn[Te + mn] = !0;
          }
        }
        return t === i ? Vn(M) : Ln(M), M;
      }
    }
    function zn(t, c, p) {
      return wn(t, c, p, !0);
    }
    function qn(t, c, p) {
      return wn(t, c, p, !1);
    }
    var Un = qn, Kn = zn;
    $s.Fragment = i, $s.jsx = Un, $s.jsxs = Kn;
  })()), $s;
}
var cS;
function o5() {
  return cS || (cS = 1, process.env.NODE_ENV === "production" ? Vm.exports = i5() : Vm.exports = a5()), Vm.exports;
}
var Fe = o5();
const s5 = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "BadRequest" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_BadRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }] }, l5 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "addPoints" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "merchantId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_updateCustomersPoints_request_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "LoyaltyLion" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "updateCustomersPoints" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "merchant_id" }, value: { kind: "Variable", name: { kind: "Name", value: "merchantId" } } }, { kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_updateCustomersPoints_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "UpdateCustomersPointsResponse" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "BadRequest" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_BadRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Unauthorized" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Unauthorized" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Forbidden" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Forbidden" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "NotFound" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_NotFound" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "UnprocessableEntity" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_UnprocessableEntity" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerError" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_ServerError" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "UpdateCustomersPointsResponse" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_updateCustomersPoints_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "BadRequest" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Unauthorized" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Forbidden" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "NotFound" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "UnprocessableEntity" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "ServerError" } }] } }] }, c5 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "removePoints" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "merchantId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_removeCustomersPoints_request_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "LoyaltyLion" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "removeCustomersPoints" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "merchant_id" }, value: { kind: "Variable", name: { kind: "Name", value: "merchantId" } } }, { kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_removeCustomersPoints_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "RemoveCustomersPointsResponse" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "BadRequest" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_BadRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Unauthorized" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Unauthorized" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Forbidden" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Forbidden" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "NotFound" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_NotFound" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "UnprocessableEntity" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_UnprocessableEntity" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerError" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_ServerError" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "RemoveCustomersPointsResponse" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_removeCustomersPoints_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "BadRequest" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Unauthorized" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Forbidden" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "NotFound" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "UnprocessableEntity" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "ServerError" } }] } }] }, d5 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCustomers" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "LoyaltyLion" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getCustomers" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "email" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_getCustomers_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Customers" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "customers" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "merchant_id" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "points_approved" } }, { kind: "Field", name: { kind: "Name", value: "points_pending" } }, { kind: "Field", name: { kind: "Name", value: "points_spent" } }, { kind: "Field", name: { kind: "Name", value: "rewards_claimed" } }, { kind: "Field", name: { kind: "Name", value: "birthday" } }, { kind: "Field", name: { kind: "Name", value: "guest" } }, { kind: "Field", name: { kind: "Name", value: "blocked" } }, { kind: "Field", name: { kind: "Name", value: "enrolled" } }, { kind: "Field", name: { kind: "Name", value: "enrolled_at" } }, { kind: "Field", name: { kind: "Name", value: "referral_id" } }, { kind: "Field", name: { kind: "Name", value: "referred_by" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "merchant_id" } }] } }, { kind: "Field", name: { kind: "Name", value: "loyalty_tier_membership" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "started_at" } }, { kind: "Field", name: { kind: "Name", value: "expires_at" } }, { kind: "Field", name: { kind: "Name", value: "manual" } }, { kind: "Field", name: { kind: "Name", value: "loyalty_tier" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "position" } }, { kind: "Field", name: { kind: "Name", value: "default" } }, { kind: "Field", name: { kind: "Name", value: "hidden" } }, { kind: "Field", name: { kind: "Name", value: "lower_bound" } }, { kind: "Field", name: { kind: "Name", value: "upper_bound" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "insights_segment" } }, { kind: "Field", name: { kind: "Name", value: "referral_url" } }, { kind: "Field", name: { kind: "Name", value: "metadata" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shopify_source_url" } }] } }, { kind: "Field", name: { kind: "Name", value: "properties" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }] } }] } }] } }] } }] } }] } }] } }] }, u5 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getRewards" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "merchantId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "LoyaltyLion" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getAvailableRewards" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "merchant_id" }, value: { kind: "Variable", name: { kind: "Name", value: "merchantId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_getAvailableRewards_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Rewards" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "rewards" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "site_id" } }, { kind: "Field", name: { kind: "Name", value: "target_site" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "url" } }] } }, { kind: "Field", name: { kind: "Name", value: "content" } }, { kind: "Field", name: { kind: "Name", value: "kind" } }, { kind: "Field", name: { kind: "Name", value: "point_cost" } }] } }] } }, { kind: "FragmentSpread", name: { kind: "Name", value: "BadRequest" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Unauthorized" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Forbidden" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "NotFound" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "ServerError" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "BadRequest" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_BadRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Unauthorized" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Unauthorized" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Forbidden" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Forbidden" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "NotFound" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_NotFound" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerError" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_ServerError" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }] }, m5 = {
  "\n  fragment BadRequest on LoyaltyLion_BadRequest {\n    message\n  }\n  fragment Unauthorized on LoyaltyLion_Unauthorized {\n    message\n  }\n  fragment Forbidden on LoyaltyLion_Forbidden {\n    message\n  }\n  fragment NotFound on LoyaltyLion_NotFound {\n    message\n  }\n  fragment UnprocessableEntity on LoyaltyLion_UnprocessableEntity {\n    message\n  }\n  fragment ServerError on LoyaltyLion_ServerError {\n    message\n  }\n\n  fragment UpdateCustomersPointsResponse on LoyaltyLion_updateCustomersPoints_response {\n    ...BadRequest\n    ...Unauthorized\n    ...Forbidden\n    ...NotFound\n    ...UnprocessableEntity\n    ...ServerError\n  }\n\n  fragment RemoveCustomersPointsResponse on LoyaltyLion_removeCustomersPoints_response {\n    ...BadRequest\n    ...Unauthorized\n    ...Forbidden\n    ...NotFound\n    ...UnprocessableEntity\n    ...ServerError\n  }\n": s5,
  "\n  mutation addPoints(\n    $merchantId: String!\n    $input: LoyaltyLion_updateCustomersPoints_request_Input!\n  ) {\n    LoyaltyLion {\n      updateCustomersPoints(merchant_id: $merchantId, input: $input) {\n        ... on LoyaltyLion_updateCustomersPoints_response {\n          ...UpdateCustomersPointsResponse\n        }\n      }\n    }\n  }\n": l5,
  "\n  mutation removePoints(\n    $merchantId: String!\n    $input: LoyaltyLion_removeCustomersPoints_request_Input!\n  ) {\n    LoyaltyLion {\n      removeCustomersPoints(merchant_id: $merchantId, input: $input) {\n        ... on LoyaltyLion_removeCustomersPoints_response {\n          ...RemoveCustomersPointsResponse\n        }\n      }\n    }\n  }\n": c5,
  "\n  query getCustomers($email: String!) {\n    LoyaltyLion {\n      getCustomers(email: $email) {\n        ... on LoyaltyLion_getCustomers_response {\n          ... on LoyaltyLion_Customers {\n            customers {\n              id\n              merchant_id\n              email\n              points_approved\n              points_pending\n              points_spent\n              rewards_claimed\n              birthday\n              guest\n              blocked\n              enrolled\n              enrolled_at\n              referral_id\n              referred_by {\n                id\n                merchant_id\n              }\n              loyalty_tier_membership {\n                started_at\n                expires_at\n                manual\n                loyalty_tier {\n                  id\n                  name\n                  position\n                  default\n                  hidden\n                  lower_bound\n                  upper_bound\n                }\n              }\n              insights_segment\n              referral_url\n              metadata {\n                shopify_source_url\n              }\n              properties {\n                name\n                first_name\n                last_name\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": d5,
  "\n  query getRewards($merchantId: String!) {\n    LoyaltyLion {\n      getAvailableRewards(merchant_id: $merchantId) {\n        ... on LoyaltyLion_getAvailableRewards_response {\n          ... on LoyaltyLion_Rewards {\n            rewards {\n              id\n              title\n              description\n              site_id\n              target_site {\n                id\n                name\n                url\n              }\n              content\n              kind\n              point_cost\n            }\n          }\n          ...BadRequest\n          ...Unauthorized\n          ...Forbidden\n          ...NotFound\n          ...ServerError\n        }\n      }\n    }\n  }\n": u5
};
function lc(e) {
  return m5[e] ?? {};
}
const p5 = lc(
  /* GraphQL */
  `
  query getCustomers($email: String!) {
    LoyaltyLion {
      getCustomers(email: $email) {
        ... on LoyaltyLion_getCustomers_response {
          ... on LoyaltyLion_Customers {
            customers {
              id
              merchant_id
              email
              points_approved
              points_pending
              points_spent
              rewards_claimed
              birthday
              guest
              blocked
              enrolled
              enrolled_at
              referral_id
              referred_by {
                id
                merchant_id
              }
              loyalty_tier_membership {
                started_at
                expires_at
                manual
                loyalty_tier {
                  id
                  name
                  position
                  default
                  hidden
                  lower_bound
                  upper_bound
                }
              }
              insights_segment
              referral_url
              metadata {
                shopify_source_url
              }
              properties {
                name
                first_name
                last_name
              }
            }
          }
        }
      }
    }
  }
`
), f5 = lc(
  /* GraphQL */
  `
  query getRewards($merchantId: String!) {
    LoyaltyLion {
      getAvailableRewards(merchant_id: $merchantId) {
        ... on LoyaltyLion_getAvailableRewards_response {
          ... on LoyaltyLion_Rewards {
            rewards {
              id
              title
              description
              site_id
              target_site {
                id
                name
                url
              }
              content
              kind
              point_cost
            }
          }
          ...BadRequest
          ...Unauthorized
          ...Forbidden
          ...NotFound
          ...ServerError
        }
      }
    }
  }
`
), h5 = lc(
  /* GraphQL */
  `
  mutation addPoints(
    $merchantId: String!
    $input: LoyaltyLion_updateCustomersPoints_request_Input!
  ) {
    LoyaltyLion {
      updateCustomersPoints(merchant_id: $merchantId, input: $input) {
        ... on LoyaltyLion_updateCustomersPoints_response {
          ...UpdateCustomersPointsResponse
        }
      }
    }
  }
`
), y5 = lc(
  /* GraphQL */
  `
  mutation removePoints(
    $merchantId: String!
    $input: LoyaltyLion_removeCustomersPoints_request_Input!
  ) {
    LoyaltyLion {
      removeCustomersPoints(merchant_id: $merchantId, input: $input) {
        ... on LoyaltyLion_removeCustomersPoints_response {
          ...RemoveCustomersPointsResponse
        }
      }
    }
  }
`
);
function zm(e = !1, n) {
  const [r, i] = me(e);
  return Xe(() => {
    const a = r ? window.setTimeout(() => i(!1), 2e3) : void 0;
    return () => window.clearTimeout(a);
  }, [n, r]), { isCopied: r, copy: (a) => {
    navigator.clipboard.writeText(a), i(!0);
  } };
}
const g5 = "_wrapper_27vny_1", v5 = "_copyIcon_27vny_12", co = {
  wrapper: g5,
  copyIcon: v5
}, k5 = ({
  customer: e
}) => {
  const { isCopied: n, copy: r } = zm(), { isCopied: i, copy: a } = zm(), { isCopied: o, copy: s } = zm();
  if (!e)
    return null;
  const l = 14, {
    email: d,
    properties: m,
    metadata: u,
    birthday: f,
    created_at: h,
    enrolled: v,
    enrolled_at: w,
    referral_url: N
  } = e, j = f ? Wn(f).isSame(Date.now(), "day") : !1, { name: _, first_name: g, last_name: O } = m ?? {}, R = _ ?? (`${g} ${O}`.trim() || "A customer has no name"), $ = u?.shopify_source_url ? u.shopify_source_url.startsWith("https://") ? u.shopify_source_url : `https://${u.shopify_source_url}` : "";
  return /* @__PURE__ */ Fe.jsx(b, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ Fe.jsxs(b, { className: co.wrapper, gap: "250", flexDirection: "column", children: [
    /* @__PURE__ */ Fe.jsxs(
      b,
      {
        justifyContent: "space-between",
        className: co.block,
        alignItems: "center",
        children: [
          /* @__PURE__ */ Fe.jsx(F.Heading, { variant: "heading-2", children: R }),
          j && /* @__PURE__ */ Fe.jsx(F.Paragraph, { variant: "4", color: "primary", children: "... has birthday today 🥳" })
        ]
      }
    ),
    h && /* @__PURE__ */ Fe.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Fe.jsx(F.Paragraph, { variant: "4", color: "secondary", children: "Member since" }),
      /* @__PURE__ */ Fe.jsx(F.Paragraph, { variant: "4", color: "secondary", children: Wn(h).format("DD MMM YYYY @ HH:mm") })
    ] }),
    v && /* @__PURE__ */ Fe.jsx(b, { gap: "200", children: /* @__PURE__ */ Fe.jsxs(F.Paragraph, { variant: "4", color: "secondary", children: [
      "Enrolled since ",
      Wn(w).format("DD MMM YYYY @ HH:mm")
    ] }) }),
    /* @__PURE__ */ Fe.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Fe.jsxs(b, { alignItems: "center", gap: "200", children: [
        /* @__PURE__ */ Fe.jsx(fe, { size: l, name: "mail" }),
        /* @__PURE__ */ Fe.jsx(F.ExternalLink, { href: `mailto:${d}`, children: d })
      ] }),
      /* @__PURE__ */ Fe.jsx(Ge, { content: n ? "Copied" : "Copy", children: /* @__PURE__ */ Fe.jsx(
        fe,
        {
          size: l,
          name: n ? "done" : "copy",
          onClick: () => r(d),
          className: co.copyIcon
        }
      ) })
    ] }),
    $ && /* @__PURE__ */ Fe.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Fe.jsxs(b, { alignItems: "center", gap: "200", children: [
        /* @__PURE__ */ Fe.jsx(fe, { size: l, name: "link" }),
        /* @__PURE__ */ Fe.jsx(Ge, { content: "Shopify shop", children: /* @__PURE__ */ Fe.jsx(
          F.ExternalLink,
          {
            href: $,
            target: "_blank",
            rel: "noreferrer",
            children: $.replace("https://", "")
          }
        ) })
      ] }),
      /* @__PURE__ */ Fe.jsx(Ge, { content: i ? "Copied" : "Copy", children: /* @__PURE__ */ Fe.jsx(
        fe,
        {
          size: l,
          name: i ? "done" : "copy",
          onClick: () => a($),
          className: co.copyIcon
        }
      ) })
    ] }),
    N && /* @__PURE__ */ Fe.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Fe.jsxs(b, { alignItems: "center", gap: "200", children: [
        /* @__PURE__ */ Fe.jsx(fe, { size: l, name: "external-link" }),
        /* @__PURE__ */ Fe.jsx(Ge, { content: "Referral link", children: /* @__PURE__ */ Fe.jsx(
          F.ExternalLink,
          {
            href: N,
            target: "_blank",
            rel: "noreferrer",
            children: N.replace("https://", "")
          }
        ) })
      ] }),
      /* @__PURE__ */ Fe.jsx(Ge, { content: o ? "Copied" : "Copy", children: /* @__PURE__ */ Fe.jsx(
        fe,
        {
          size: l,
          name: o ? "done" : "copy",
          onClick: () => s(N),
          className: co.copyIcon
        }
      ) })
    ] })
  ] }) });
}, b5 = "_list_1q5b5_5", _5 = "_listItem_1q5b5_8", x5 = "_listItemEdit_1q5b5_15", S5 = "_notificationText_1q5b5_19", wa = {
  list: b5,
  listItem: _5,
  listItemEdit: x5,
  notificationText: S5
}, N5 = "_modalBody_1clhs_1", j5 = {
  modalBody: N5
}, w5 = ({
  isOpen: e,
  points: n,
  merchantId: r,
  onClose: i,
  refetchCustomerData: a
}) => {
  const { useMutation: o, showNotification: s } = fn(), { track: l } = jn(), [d, m] = me(n), [u, f] = me(""), [h, v] = me(), [w, { loading: N }] = o(
    h5,
    {
      onCompleted: () => {
        s({
          title: "Success",
          text: "Added points successfully",
          icon: "check-circle-filled",
          severity: "success"
        }), l("loyaltylion:add:points:succeeded"), q();
      }
    }
  ), [j, { loading: _ }] = o(y5), g = N || _, O = !!h, R = n === d ? "Change the value to update the points" : "", $ = isNaN(d), I = $ ? "Points can not be empty" : "", L = d > n && d - n > 1e6, G = L ? "Points can not exceed 1,000,000" : "", Q = () => {
    if (!r) {
      v(["Merchant information is missing."]), d > n ? l("loyaltylion:add:points:failed") : d < n && l("loyaltylion:remove:points:failed");
      return;
    }
    d > n && w({
      variables: {
        input: {
          points: d - n,
          reason: u
        },
        merchantId: r
      }
    }).catch((Y) => {
      const P = Y?.networkError;
      (P ? P?.statusCode : NaN) === 201 ? (l("loyaltylion:add:points:succeeded"), s({
        title: "Success",
        text: "Added points successfully",
        icon: "check-circle-filled",
        severity: "success"
      }), q()) : (l("loyaltylion:add:points:failed"), v(["Failed to add points, try again later."]));
    }), d < n && j({
      variables: {
        input: {
          points: n - d,
          reason: u
        },
        merchantId: r
      }
    }).then((Y) => {
      Y.data?.LoyaltyLion?.removeCustomersPoints?.__typename === "LoyaltyLion_Void_container" ? (l("loyaltylion:remove:points:succeeded"), s({
        title: "Success",
        text: "Removed points successfully",
        icon: "check-circle-filled",
        severity: "success"
      }), q()) : "errors" in Y && (l("loyaltylion:remove:points:failed"), v(
        Y.errors?.map((P) => P.message) ?? [
          "Failed to remove points, try again later."
        ]
      ));
    }).catch(() => {
      l("loyaltylion:remove:points:failed"), v(["Failed to remove points, try again later."]);
    });
  }, ne = () => {
    $ && m(n), f(""), i();
  }, q = () => {
    a(), ne();
  };
  return /* @__PURE__ */ Fe.jsxs(
    ht,
    {
      isOpen: e,
      onClose: ne,
      "data-testid": "change-points-modal",
      children: [
        /* @__PURE__ */ Fe.jsx(yt, { title: "Change points", onClose: ne }),
        /* @__PURE__ */ Fe.jsxs(gt, { className: j5.modalBody, children: [
          /* @__PURE__ */ Fe.jsxs(et, { children: [
            /* @__PURE__ */ Fe.jsx(Z, { span: 6, children: /* @__PURE__ */ Fe.jsx(
              Kr,
              {
                required: !0,
                label: "New points",
                type: "number",
                placeholder: "Insert new points",
                min: 0,
                max: 1e5,
                meta: {
                  error: G || I,
                  warning: R
                },
                input: {
                  name: "points",
                  value: d.toString(),
                  onChange: (Y) => m(Y?.target.valueAsNumber ?? 0)
                },
                "data-testid": "points-input"
              }
            ) }),
            /* @__PURE__ */ Fe.jsx(Z, { span: 6, children: /* @__PURE__ */ Fe.jsx(
              Kr,
              {
                label: "Reason",
                placeholder: "Insert an optional reason",
                input: {
                  name: "reason",
                  value: u,
                  onChange: (Y) => f(Y?.target.value ?? "")
                }
              }
            ) })
          ] }),
          !g && O && /* @__PURE__ */ Fe.jsx(b, { margin: "200 0", flexDirection: "column", children: /* @__PURE__ */ Fe.jsx(Je, { children: h?.map((Y, P) => /* @__PURE__ */ Fe.jsx(
            Je.Item,
            {
              variant: "dense",
              title: Y,
              contentLeft: /* @__PURE__ */ Fe.jsx(
                fe,
                {
                  color: "red.500",
                  size: 16,
                  name: "exclamation-triangle-filled"
                }
              )
            },
            P
          )) }) })
        ] }),
        /* @__PURE__ */ Fe.jsx(
          vt,
          {
            confirmName: "Save",
            confirmOnClick: () => Q(),
            confirmProps: {
              isLoading: g,
              disabled: $ || L || n === d,
              loadingIndicator: /* @__PURE__ */ Fe.jsx(sn, { size: 16 })
            },
            cancelOnClick: ne
          }
        )
      ]
    }
  );
}, C5 = ({
  label: e,
  points: n,
  setIsModalOpen: r
}) => {
  const i = n > 0 ? "green.500" : "neutral.400", a = n > 0 ? "warning" : "secondary", o = 10;
  return /* @__PURE__ */ Fe.jsx(Je.Text, { variant: "dense", className: wa.listItem, children: /* @__PURE__ */ Fe.jsxs(b, { justifyContent: "space-between", children: [
    /* @__PURE__ */ Fe.jsxs(b, { gap: "200", alignItems: "center", children: [
      /* @__PURE__ */ Fe.jsx(fe, { color: i, size: o, name: "star-full" }),
      /* @__PURE__ */ Fe.jsx(F.Paragraph, { variant: "4", children: e })
    ] }),
    /* @__PURE__ */ Fe.jsxs(b, { gap: "200", alignItems: "center", children: [
      r && /* @__PURE__ */ Fe.jsx(Ge, { content: "Edit points", children: /* @__PURE__ */ Fe.jsx(
        fe,
        {
          name: "pen",
          size: o,
          "aria-label": "Edit points",
          className: wa.listItemEdit,
          onClick: () => r(!0)
        }
      ) }),
      /* @__PURE__ */ Fe.jsx(Pn, { size: "small", variant: a, children: n })
    ] })
  ] }) });
}, F5 = ({
  customer: e,
  refetchCustomerData: n
}) => {
  const [r, i] = me(!1);
  if (!e)
    return null;
  const {
    merchant_id: a,
    points_approved: o,
    points_pending: s,
    points_spent: l,
    rewards_claimed: d
  } = e, m = [
    {
      id: "pointsApproved",
      label: "Points approved",
      points: o ?? 0,
      setIsModalOpen: i
    },
    {
      id: "pointsPending",
      label: "Points pending",
      points: s ?? 0
    },
    {
      id: "pointsSpent",
      label: "Points spent",
      points: l ?? 0
    },
    {
      id: "rewardClaimed",
      label: "Rewards claimed",
      points: d ?? 0
    }
  ];
  return /* @__PURE__ */ Fe.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ Fe.jsx(F.Heading, { variant: "heading-3", children: "Points balance" }),
    /* @__PURE__ */ Fe.jsx(Je, { className: wa.list, children: m.map(({ id: u, points: f, label: h, setIsModalOpen: v }) => /* @__PURE__ */ Fe.jsx(
      C5,
      {
        points: f,
        label: h,
        setIsModalOpen: v
      },
      u
    )) }),
    /* @__PURE__ */ Fe.jsx(
      w5,
      {
        isOpen: r,
        points: o,
        merchantId: a,
        onClose: () => i(!1),
        refetchCustomerData: n
      }
    )
  ] });
}, I5 = "_reward_1wxia_1", $5 = {
  reward: I5
}, E5 = ({ reward: e }) => {
  const {
    title: n,
    point_cost: r,
    target_site: i,
    description: a
  } = e, o = i?.name, s = i?.url;
  return /* @__PURE__ */ Fe.jsx(b, { gap: "100", flexDirection: "column", className: $5.reward, children: /* @__PURE__ */ Fe.jsx(Ge, { content: a ?? "No description", children: /* @__PURE__ */ Fe.jsxs(b, { gap: "100", flexDirection: "column", children: [
    /* @__PURE__ */ Fe.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ Fe.jsxs(b, { gap: "100", alignItems: "center", children: [
        /* @__PURE__ */ Fe.jsx(fe, { name: "star", size: 12, color: "neutral.500" }),
        n
      ] }),
      /* @__PURE__ */ Fe.jsxs(Pn, { size: "small", variant: "info", children: [
        r ?? 0,
        " points"
      ] })
    ] }),
    o && s && /* @__PURE__ */ Fe.jsxs(b, { gap: "100", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ Fe.jsx(fe, { size: 14, name: "external-link" }),
      /* @__PURE__ */ Fe.jsx(
        F.ExternalLink,
        {
          href: s,
          target: "_blank",
          rel: "noreferrer",
          children: o
        }
      )
    ] })
  ] }) }) });
}, T5 = ({ customer: e }) => {
  const { useQuery: n } = fn(), [r, i] = me(), { merchant_id: a } = e, {
    loading: o,
    error: s,
    data: l
  } = n(f5, {
    skip: !a,
    variables: {
      merchantId: a
    }
  });
  if (Xe(() => {
    if (l?.LoyaltyLion) {
      const d = l.LoyaltyLion?.getAvailableRewards?.rewards;
      d && i(d);
    }
  }, [l]), s) {
    const d = s.graphQLErrors;
    return Fa({ errors: d }) ? /* @__PURE__ */ Fe.jsx(
      b,
      {
        justifyContent: "center",
        margin: "200 0 300 0",
        className: wa.notificationText,
        children: "No rewards found"
      }
    ) : Nw({ errors: d }) ? /* @__PURE__ */ Fe.jsx(
      b,
      {
        justifyContent: "center",
        margin: "200 0 300 0",
        className: wa.notificationText,
        children: "You don't have permissions to view rewards"
      }
    ) : /* @__PURE__ */ Fe.jsx($n, { error: s });
  }
  return /* @__PURE__ */ Fe.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ Fe.jsx(F.Heading, { variant: "heading-3", children: "Available rewards" }),
    o ? /* @__PURE__ */ Fe.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ Fe.jsx(sn, {}) }) : /* @__PURE__ */ Fe.jsx(b, { gap: "200", flexDirection: "column", children: r?.map((d) => /* @__PURE__ */ Fe.jsx(E5, { reward: d }, d.id)) })
  ] });
}, R5 = ({ customer: e }) => {
  const { blocked: n, guest: r, insights_segment: i } = e ?? {}, a = n || r || i, o = 14;
  return a ? /* @__PURE__ */ Fe.jsxs(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", children: [
    n && /* @__PURE__ */ Fe.jsx(b, { alignItems: "start", children: /* @__PURE__ */ Fe.jsx(Jn, { children: /* @__PURE__ */ Fe.jsxs(b, { gap: "200", alignItems: "center", children: [
      /* @__PURE__ */ Fe.jsx(
        fe,
        {
          size: o,
          color: "red.500",
          name: "exclamation-triangle-filled"
        }
      ),
      "Blocked"
    ] }) }) }),
    r && /* @__PURE__ */ Fe.jsx(b, { alignItems: "start", children: /* @__PURE__ */ Fe.jsx(Jn, { children: /* @__PURE__ */ Fe.jsxs(b, { gap: "200", alignItems: "center", children: [
      /* @__PURE__ */ Fe.jsx(fe, { size: o, color: "green.500", name: "user" }),
      "Guest"
    ] }) }) }),
    i && /* @__PURE__ */ Fe.jsx(b, { alignItems: "start", children: /* @__PURE__ */ Fe.jsx(Ge, { content: "Insights segment", children: /* @__PURE__ */ Fe.jsx(Jn, { children: /* @__PURE__ */ Fe.jsxs(b, { gap: "200", alignItems: "center", children: [
      /* @__PURE__ */ Fe.jsx(fe, { size: o, color: "green.500", name: "team" }),
      i
    ] }) }) }) })
  ] }) : null;
}, D5 = ({
  conversationContext: e,
  settings: n
}) => {
  const { useQuery: r } = fn(), { track: i } = jn(), [a, o] = me(null), { customer: s } = e, {
    showCustomerSummary: l,
    showTags: d,
    showPointsBalance: m,
    showAvailableRewards: u
  } = n, f = !l && !d && !m && !u, {
    loading: h,
    error: v,
    data: w,
    refetch: N
  } = r(p5, {
    skip: !s?.email,
    variables: {
      email: s?.email ?? ""
    }
  });
  return Xe(() => {
    if (w && !h) {
      const j = (w?.LoyaltyLion?.getCustomers).customers;
      j && j.length > 0 && (o(j[0]), i("loyaltylion:customer:received"));
    }
  }, [w, h]), s?.email ? v ? Fa({
    errors: v.graphQLErrors
  }) ? /* @__PURE__ */ Fe.jsxs(
    b,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      className: wa.notificationText,
      children: [
        "No user found for email: ",
        s?.email
      ]
    }
  ) : /* @__PURE__ */ Fe.jsx($n, { error: v }) : h ? /* @__PURE__ */ Fe.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ Fe.jsx(sn, {}) }) : f ? /* @__PURE__ */ Fe.jsx(
    b,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      "data-testid": "no-feature-enabled-message",
      children: "All features toggles in the integration settings are disabled"
    }
  ) : /* @__PURE__ */ Fe.jsx(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "0 0 300 0",
      "data-testid": "widget-wrapper",
      children: a ? /* @__PURE__ */ Fe.jsxs(Fe.Fragment, { children: [
        l && /* @__PURE__ */ Fe.jsx(k5, { customer: a }),
        d && /* @__PURE__ */ Fe.jsx(R5, { customer: a }),
        m && /* @__PURE__ */ Fe.jsx(
          F5,
          {
            customer: a,
            refetchCustomerData: N
          }
        ),
        u && /* @__PURE__ */ Fe.jsx(T5, { customer: a })
      ] }) : /* @__PURE__ */ Fe.jsx(b, { justifyContent: "center", padding: "200", children: "Nothing found" })
    }
  ) : /* @__PURE__ */ Fe.jsx(
    b,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      "data-testid": "no-email-message",
      children: "We can only search LoyaltyLion with an email and there seems to be no email in this conversation"
    }
  );
}, Tl = [
  {
    key: "basicAuthorization",
    label: "LoyaltyLion authorization",
    type: "string",
    secret: !0,
    defaultValue: ""
  },
  {
    key: "showCustomerSummary",
    label: "Show customer summary",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showTags",
    label: "Show tags",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showPointsBalance",
    label: "Show points balance",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showAvailableRewards",
    label: "Show available rewards",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  }
], uo = ar(Tl), dS = "LOYALTYLION", O5 = {
  enabled: !1,
  name: "",
  basicAuthorization: "",
  showCustomerSummary: !0,
  showTags: !0,
  showPointsBalance: !0,
  showAvailableRewards: !0
}, P5 = ({
  integrationId: e,
  handleRedirect: n,
  showNotification: r,
  automationCouplingState: i,
  renderConditionsEditor: a
}) => {
  const o = !e, s = ot({
    mode: "onChange",
    defaultValues: O5
  }), {
    create: l,
    update: d,
    remove: m,
    isLoading: u,
    error: f,
    misconfigurationCause: h,
    setMisconfigurationCause: v
  } = pr({
    integrationId: e,
    integrationType: dS,
    handleRedirect: n,
    showNotification: r
  }), {
    isLoading: w,
    error: N,
    isWidgetUnknown: j,
    refetch: _,
    widgetConfiguration: g
  } = fr({
    integrationId: e,
    fieldDefinitions: Tl,
    form: s,
    onMisconfigured: v
  }), { renderConditions: O, setRenderConditions: R, renderConditionsForSubmit: $ } = hr({
    integrationId: e,
    widgetConfiguration: g,
    renderConditionsEditor: a
  }), I = (G) => gr(G, {
    fieldDefinitions: Tl,
    isCreationMode: o,
    create: l,
    update: d,
    renderConditions: $
  }), L = s.watch("name");
  return /* @__PURE__ */ Fe.jsxs(
    yr,
    {
      form: s,
      integrationId: e,
      onValidSubmit: I,
      error: N ?? f,
      onRetry: N ? _ : void 0,
      isLoading: u || w,
      isWidgetUnknown: j,
      children: [
        h && /* @__PURE__ */ Fe.jsx(vr, { cause: h }),
        /* @__PURE__ */ Fe.jsxs(et, { children: [
          /* @__PURE__ */ Fe.jsx(Z, { children: /* @__PURE__ */ Fe.jsx(qe, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ Fe.jsx(
            yn,
            {
              name: "enabled",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ Fe.jsx(Z, { span: 3, children: /* @__PURE__ */ Fe.jsx(
            Rn,
            {
              name: "name",
              label: "Widget name",
              control: s.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ Fe.jsx(Z, { span: 3 }),
          /* @__PURE__ */ Fe.jsx(Z, { span: 3, children: /* @__PURE__ */ Fe.jsx(
            _I,
            {
              name: "basicAuthorization",
              label: uo.basicAuthorization,
              control: s.control,
              isCreationMode: o,
              rules: { required: "Please insert a value for both fields" },
              usernameLabel: "Token",
              passwordLabel: "Secret",
              usernamePlaceholder: "Insert your token",
              passwordPlaceholder: "Insert your secret"
            }
          ) }),
          /* @__PURE__ */ Fe.jsx(Z, { span: 3 }),
          /* @__PURE__ */ Fe.jsx(Z, { span: 3, children: /* @__PURE__ */ Fe.jsx(qe, { label: uo.showCustomerSummary, children: /* @__PURE__ */ Fe.jsx(
            yn,
            {
              name: "showCustomerSummary",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ Fe.jsx(Z, { span: 3 }),
          /* @__PURE__ */ Fe.jsx(Z, { span: 3, children: /* @__PURE__ */ Fe.jsx(qe, { label: uo.showTags, children: /* @__PURE__ */ Fe.jsx(
            yn,
            {
              name: "showTags",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ Fe.jsx(Z, { span: 3 }),
          /* @__PURE__ */ Fe.jsx(Z, { span: 3, children: /* @__PURE__ */ Fe.jsx(qe, { label: uo.showPointsBalance, children: /* @__PURE__ */ Fe.jsx(
            yn,
            {
              name: "showPointsBalance",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ Fe.jsx(Z, { span: 3 }),
          /* @__PURE__ */ Fe.jsx(Z, { span: 3, children: /* @__PURE__ */ Fe.jsx(qe, { label: uo.showAvailableRewards, children: /* @__PURE__ */ Fe.jsx(
            yn,
            {
              name: "showAvailableRewards",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ Fe.jsx(Z, { span: 3 }),
          a && O !== null && /* @__PURE__ */ Fe.jsx(Z, { children: a({
            value: O,
            onChange: R,
            configurationKey: g?.id
          }) })
        ] }),
        /* @__PURE__ */ Fe.jsx(
          kr,
          {
            integrationType: dS,
            integrationId: e,
            widgetName: L,
            isCreationMode: o,
            isSubmitting: s.formState.isSubmitting,
            automationCouplingState: i,
            onConfirmDelete: () => m()
          }
        )
      ]
    }
  );
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._messageContainer_1rxr4_1{padding:var(--dixa-size-spacer-250);border-radius:var(--dixa-size-border-radius-100);border:var(--dixa-size-border-100) solid}._chip_1rxr4_7{color:var(--dixa-typography-color-secondary)}._chipLabel_1rxr4_10{font-weight:var(--dixa-typography-weight-semibold)}._chipValue_1rxr4_13{font-weight:var(--dixa-typography-weight-normal)}._conversation_1draa_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._conversation_1draa_1:hover{border-color:var(--dixa-color-neutral-400)}._conversationSubLine_1draa_9{font-size:var(--dixa-typography-size-200);color:var(--dixa-typography-color-tertiary)}._modal_1draa_14{width:800px}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Um = { exports: {} }, mo = {}, uS;
function A5() {
  if (uS) return mo;
  uS = 1;
  var e = He, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (v = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return mo.Fragment = r, mo.jsx = s, mo.jsxs = s, mo;
}
var Es = {}, mS;
function L5() {
  return mS || (mS = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = He, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), d = /* @__PURE__ */ Symbol.for("react.forward_ref"), m = /* @__PURE__ */ Symbol.for("react.suspense"), u = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), v = /* @__PURE__ */ Symbol.for("react.offscreen"), w = Symbol.iterator, N = "@@iterator";
    function j(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = w && t[w] || t[N];
      return typeof c == "function" ? c : null;
    }
    var _ = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          p[y - 1] = arguments[y];
        O("error", t, p);
      }
    }
    function O(t, c, p) {
      {
        var y = _.ReactDebugCurrentFrame, C = y.getStackAddendum();
        C !== "" && (c += "%s", p = p.concat([C]));
        var T = p.map(function(S) {
          return String(S);
        });
        T.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, T);
      }
    }
    var R = !1, $ = !1, I = !1, L = !1, G = !1, Q;
    Q = /* @__PURE__ */ Symbol.for("react.module.reference");
    function ne(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || G || t === a || t === m || t === u || L || t === v || R || $ || I || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Q || t.getModuleId !== void 0));
    }
    function q(t, c, p) {
      var y = t.displayName;
      if (y)
        return y;
      var C = c.displayName || c.name || "";
      return C !== "" ? p + "(" + C + ")" : p;
    }
    function Y(t) {
      return t.displayName || "Context";
    }
    function P(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return Y(c) + ".Consumer";
          case s:
            var p = t;
            return Y(p._context) + ".Provider";
          case d:
            return q(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : P(t.type) || "Memo";
          case h: {
            var C = t, T = C._payload, S = C._init;
            try {
              return P(S(T));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var B = Object.assign, ie = 0, je, pe, le, ge, V, be, Oe;
    function H() {
    }
    H.__reactDisabledLog = !0;
    function Ye() {
      {
        if (ie === 0) {
          je = console.log, pe = console.info, le = console.warn, ge = console.error, V = console.group, be = console.groupCollapsed, Oe = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: H,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ie++;
      }
    }
    function ln() {
      {
        if (ie--, ie === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: B({}, t, {
              value: je
            }),
            info: B({}, t, {
              value: pe
            }),
            warn: B({}, t, {
              value: le
            }),
            error: B({}, t, {
              value: ge
            }),
            group: B({}, t, {
              value: V
            }),
            groupCollapsed: B({}, t, {
              value: be
            }),
            groupEnd: B({}, t, {
              value: Oe
            })
          });
        }
        ie < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Ie = _.ReactCurrentDispatcher, Ue;
    function De(t, c, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (C) {
            var y = C.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Be = !1, Ae;
    {
      var Qe = typeof WeakMap == "function" ? WeakMap : Map;
      Ae = new Qe();
    }
    function Ee(t, c) {
      if (!t || Be)
        return "";
      {
        var p = Ae.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Be = !0;
      var C = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var T;
      T = Ie.current, Ie.current = null, Ye();
      try {
        if (c) {
          var S = function() {
            throw Error();
          };
          if (Object.defineProperty(S.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(S, []);
            } catch (re) {
              y = re;
            }
            Reflect.construct(t, [], S);
          } else {
            try {
              S.call();
            } catch (re) {
              y = re;
            }
            t.call(S.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (re) {
            y = re;
          }
          t();
        }
      } catch (re) {
        if (re && y && typeof re.stack == "string") {
          for (var x = re.stack.split(`
`), ee = y.stack.split(`
`), A = x.length - 1, M = ee.length - 1; A >= 1 && M >= 0 && x[A] !== ee[M]; )
            M--;
          for (; A >= 1 && M >= 0; A--, M--)
            if (x[A] !== ee[M]) {
              if (A !== 1 || M !== 1)
                do
                  if (A--, M--, M < 0 || x[A] !== ee[M]) {
                    var ue = `
` + x[A].replace(" at new ", " at ");
                    return t.displayName && ue.includes("<anonymous>") && (ue = ue.replace("<anonymous>", t.displayName)), typeof t == "function" && Ae.set(t, ue), ue;
                  }
                while (A >= 1 && M >= 0);
              break;
            }
        }
      } finally {
        Be = !1, Ie.current = T, ln(), Error.prepareStackTrace = C;
      }
      var ze = t ? t.displayName || t.name : "", Te = ze ? De(ze) : "";
      return typeof t == "function" && Ae.set(t, Te), Te;
    }
    function Me(t, c, p) {
      return Ee(t, !1);
    }
    function en(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function se(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ee(t, en(t));
      if (typeof t == "string")
        return De(t);
      switch (t) {
        case m:
          return De("Suspense");
        case u:
          return De("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Me(t.render);
          case f:
            return se(t.type, c, p);
          case h: {
            var y = t, C = y._payload, T = y._init;
            try {
              return se(T(C), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var ce = Object.prototype.hasOwnProperty, Se = {}, Ve = _.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, p = se(t.type, t._source, c ? c.type : null);
        Ve.setExtraStackFrame(p);
      } else
        Ve.setExtraStackFrame(null);
    }
    function kn(t, c, p, y, C) {
      {
        var T = Function.call.bind(ce);
        for (var S in t)
          if (T(t, S)) {
            var x = void 0;
            try {
              if (typeof t[S] != "function") {
                var ee = Error((y || "React class") + ": " + p + " type `" + S + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[S] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ee.name = "Invariant Violation", ee;
              }
              x = t[S](c, S, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (A) {
              x = A;
            }
            x && !(x instanceof Error) && (Pe(C), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, S, typeof x), Pe(null)), x instanceof Error && !(x.message in Se) && (Se[x.message] = !0, Pe(C), g("Failed %s type: %s", p, x.message), Pe(null));
          }
      }
    }
    var X = Array.isArray;
    function E(t) {
      return X(t);
    }
    function z(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function ae(t) {
      try {
        return de(t), !1;
      } catch {
        return !0;
      }
    }
    function de(t) {
      return "" + t;
    }
    function U(t) {
      if (ae(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", z(t)), de(t);
    }
    var J = _.ReactCurrentOwner, ve = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, we, Re;
    function rn(t) {
      if (ce.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function bn(t) {
      if (ce.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function an(t, c) {
      typeof t.ref == "string" && J.current;
    }
    function hn(t, c) {
      {
        var p = function() {
          we || (we = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function En(t, c) {
      {
        var p = function() {
          Re || (Re = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var _n = function(t, c, p, y, C, T, S) {
      var x = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: S,
        // Record the component responsible for creating this element.
        _owner: T
      };
      return x._store = {}, Object.defineProperty(x._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(x, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(x, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: C
      }), Object.freeze && (Object.freeze(x.props), Object.freeze(x)), x;
    };
    function Fn(t, c, p, y, C) {
      {
        var T, S = {}, x = null, ee = null;
        p !== void 0 && (U(p), x = "" + p), bn(c) && (U(c.key), x = "" + c.key), rn(c) && (ee = c.ref, an(c));
        for (T in c)
          ce.call(c, T) && !ve.hasOwnProperty(T) && (S[T] = c[T]);
        if (t && t.defaultProps) {
          var A = t.defaultProps;
          for (T in A)
            S[T] === void 0 && (S[T] = A[T]);
        }
        if (x || ee) {
          var M = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          x && hn(S, M), ee && En(S, M);
        }
        return _n(t, x, ee, C, y, J.current, S);
      }
    }
    var Ze = _.ReactCurrentOwner, gn = _.ReactDebugCurrentFrame;
    function Le(t) {
      if (t) {
        var c = t._owner, p = se(t.type, t._source, c ? c.type : null);
        gn.setExtraStackFrame(p);
      } else
        gn.setExtraStackFrame(null);
    }
    var dn;
    dn = !1;
    function un(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function Nn() {
      {
        if (Ze.current) {
          var t = P(Ze.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Bn(t) {
      return "";
    }
    var Sn = {};
    function An(t) {
      {
        var c = Nn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function vn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = An(c);
        if (Sn[p])
          return;
        Sn[p] = !0;
        var y = "";
        t && t._owner && t._owner !== Ze.current && (y = " It was passed a child from " + P(t._owner.type) + "."), Le(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Le(null);
      }
    }
    function xn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (E(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            un(y) && vn(y, c);
          }
        else if (un(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var C = j(t);
          if (typeof C == "function" && C !== t.entries)
            for (var T = C.call(t), S; !(S = T.next()).done; )
              un(S.value) && vn(S.value, c);
        }
      }
    }
    function Ln(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var y = P(c);
          kn(p, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !dn) {
          dn = !0;
          var C = P(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", C || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var y = c[p];
          if (y !== "children" && y !== "key") {
            Le(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Le(null);
            break;
          }
        }
        t.ref !== null && (Le(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Le(null));
      }
    }
    var Cn = {};
    function wn(t, c, p, y, C, T) {
      {
        var S = ne(t);
        if (!S) {
          var x = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (x += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ee = Bn();
          ee ? x += ee : x += Nn();
          var A;
          t === null ? A = "null" : E(t) ? A = "array" : t !== void 0 && t.$$typeof === n ? (A = "<" + (P(t.type) || "Unknown") + " />", x = " Did you accidentally export a JSX literal instead of a component?") : A = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", A, x);
        }
        var M = Fn(t, c, p, C, T);
        if (M == null)
          return M;
        if (S) {
          var ue = c.children;
          if (ue !== void 0)
            if (y)
              if (E(ue)) {
                for (var ze = 0; ze < ue.length; ze++)
                  xn(ue[ze], t);
                Object.freeze && Object.freeze(ue);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              xn(ue, t);
        }
        if (ce.call(c, "key")) {
          var Te = P(t), re = Object.keys(c).filter(function(Gn) {
            return Gn !== "key";
          }), mn = re.length > 0 ? "{key: someKey, " + re.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Cn[Te + mn]) {
            var Dn = re.length > 0 ? "{" + re.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, mn, Te, Dn, Te), Cn[Te + mn] = !0;
          }
        }
        return t === i ? Vn(M) : Ln(M), M;
      }
    }
    function zn(t, c, p) {
      return wn(t, c, p, !0);
    }
    function qn(t, c, p) {
      return wn(t, c, p, !1);
    }
    var Un = qn, Kn = zn;
    Es.Fragment = i, Es.jsx = Un, Es.jsxs = Kn;
  })()), Es;
}
var pS;
function V5() {
  return pS || (pS = 1, process.env.NODE_ENV === "production" ? Um.exports = A5() : Um.exports = L5()), Um.exports;
}
var pn = V5();
const z5 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "conversationsQuery" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Miuros" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "findTickets" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }, { kind: "Argument", name: { kind: "Name", value: "page_size" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "labels" } }, { kind: "Field", name: { kind: "Name", value: "subject" } }, { kind: "Field", name: { kind: "Name", value: "messages" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "direction" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "agent" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }] } }, { kind: "Field", name: { kind: "Name", value: "custom_fields" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "additionalProperties" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "value" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "value" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }] } }] } }] } }] } }] }, U5 = {
  "\n  query conversationsQuery($query: String) {\n    Miuros {\n      findTickets(query: $query, page_size: 10) {\n        data {\n          id\n          labels\n          subject\n          messages {\n            direction\n            body\n            agent {\n              email\n              name\n            }\n            created_at\n          }\n          custom_fields {\n            additionalProperties {\n              key\n              value {\n                value\n              }\n            }\n          }\n          created_at\n        }\n      }\n    }\n  }\n": z5
};
function M5(e) {
  return U5[e] ?? {};
}
function fS(e, n) {
  (n == null || n > e.length) && (n = e.length);
  for (var r = 0, i = Array(n); r < n; r++) i[r] = e[r];
  return i;
}
function B5(e) {
  if (Array.isArray(e)) return e;
}
function q5(e, n) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var i, a, o, s, l = [], d = !0, m = !1;
    try {
      if (o = (r = r.call(e)).next, n !== 0) for (; !(d = (i = o.call(r)).done) && (l.push(i.value), l.length !== n); d = !0) ;
    } catch (u) {
      m = !0, a = u;
    } finally {
      try {
        if (!d && r.return != null && (s = r.return(), Object(s) !== s)) return;
      } finally {
        if (m) throw a;
      }
    }
    return l;
  }
}
function H5() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function W5(e, n) {
  return B5(e) || q5(e, n) || K5(e, n) || H5();
}
function K5(e, n) {
  if (e) {
    if (typeof e == "string") return fS(e, n);
    var r = {}.toString.call(e).slice(8, -1);
    return r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set" ? Array.from(e) : r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? fS(e, n) : void 0;
  }
}
const W1 = Object.entries, hS = Object.setPrototypeOf, G5 = Object.isFrozen, Y5 = Object.getPrototypeOf, J5 = Object.getOwnPropertyDescriptor;
let Lt = Object.freeze, zt = Object.seal, ma = Object.create, K1 = typeof Reflect < "u" && Reflect, vy = K1.apply, ky = K1.construct;
Lt || (Lt = function(e) {
  return e;
});
zt || (zt = function(e) {
  return e;
});
vy || (vy = function(e, n) {
  for (var r = arguments.length, i = new Array(r > 2 ? r - 2 : 0), a = 2; a < r; a++)
    i[a - 2] = arguments[a];
  return e.apply(n, i);
});
ky || (ky = function(e) {
  for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++)
    r[i - 1] = arguments[i];
  return new e(...r);
});
const po = wt(Array.prototype.forEach), Q5 = wt(Array.prototype.lastIndexOf), yS = wt(Array.prototype.pop), sa = wt(Array.prototype.push), X5 = wt(Array.prototype.splice), gi = Array.isArray, Io = wt(String.prototype.toLowerCase), Mm = wt(String.prototype.toString), gS = wt(String.prototype.match), fo = wt(String.prototype.replace), vS = wt(String.prototype.indexOf), Z5 = wt(String.prototype.trim), eB = wt(Number.prototype.toString), nB = wt(Boolean.prototype.toString), kS = typeof BigInt > "u" ? null : wt(BigInt.prototype.toString), bS = typeof Symbol > "u" ? null : wt(Symbol.prototype.toString), $t = wt(Object.prototype.hasOwnProperty), ho = wt(Object.prototype.toString), Rt = wt(RegExp.prototype.test), $i = tB(TypeError);
function wt(e) {
  return function(n) {
    n instanceof RegExp && (n.lastIndex = 0);
    for (var r = arguments.length, i = new Array(r > 1 ? r - 1 : 0), a = 1; a < r; a++)
      i[a - 1] = arguments[a];
    return vy(e, n, i);
  };
}
function tB(e) {
  return function() {
    for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++)
      r[i] = arguments[i];
    return ky(e, r);
  };
}
function Hn(e, n) {
  let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Io;
  if (hS && hS(e, null), !gi(n))
    return e;
  let i = n.length;
  for (; i--; ) {
    let a = n[i];
    if (typeof a == "string") {
      const o = r(a);
      o !== a && (G5(n) || (n[i] = o), a = o);
    }
    e[a] = !0;
  }
  return e;
}
function rB(e) {
  for (let n = 0; n < e.length; n++)
    $t(e, n) || (e[n] = null);
  return e;
}
function Wt(e) {
  const n = ma(null);
  for (const i of W1(e)) {
    var r = W5(i, 2);
    const a = r[0], o = r[1];
    $t(e, a) && (gi(o) ? n[a] = rB(o) : o && typeof o == "object" && o.constructor === Object ? n[a] = Wt(o) : n[a] = o);
  }
  return n;
}
function iB(e) {
  switch (typeof e) {
    case "string":
      return e;
    case "number":
      return eB(e);
    case "boolean":
      return nB(e);
    case "bigint":
      return kS ? kS(e) : "0";
    case "symbol":
      return bS ? bS(e) : "Symbol()";
    case "undefined":
      return ho(e);
    case "function":
    case "object": {
      if (e === null)
        return ho(e);
      const n = e, r = Vr(n, "toString");
      if (typeof r == "function") {
        const i = r(n);
        return typeof i == "string" ? i : ho(i);
      }
      return ho(e);
    }
    default:
      return ho(e);
  }
}
function Vr(e, n) {
  for (; e !== null; ) {
    const i = J5(e, n);
    if (i) {
      if (i.get)
        return wt(i.get);
      if (typeof i.value == "function")
        return wt(i.value);
    }
    e = Y5(e);
  }
  function r() {
    return null;
  }
  return r;
}
function aB(e) {
  try {
    return Rt(e, ""), !0;
  } catch {
    return !1;
  }
}
const _S = Lt(["a", "abbr", "acronym", "address", "area", "article", "aside", "audio", "b", "bdi", "bdo", "big", "blink", "blockquote", "body", "br", "button", "canvas", "caption", "center", "cite", "code", "col", "colgroup", "content", "data", "datalist", "dd", "decorator", "del", "details", "dfn", "dialog", "dir", "div", "dl", "dt", "element", "em", "fieldset", "figcaption", "figure", "font", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "img", "input", "ins", "kbd", "label", "legend", "li", "main", "map", "mark", "marquee", "menu", "menuitem", "meter", "nav", "nobr", "ol", "optgroup", "option", "output", "p", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "search", "section", "select", "shadow", "slot", "small", "source", "spacer", "span", "strike", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "tt", "u", "ul", "var", "video", "wbr"]), Bm = Lt(["svg", "a", "altglyph", "altglyphdef", "altglyphitem", "animatecolor", "animatemotion", "animatetransform", "circle", "clippath", "defs", "desc", "ellipse", "enterkeyhint", "exportparts", "filter", "font", "g", "glyph", "glyphref", "hkern", "image", "inputmode", "line", "lineargradient", "marker", "mask", "metadata", "mpath", "part", "path", "pattern", "polygon", "polyline", "radialgradient", "rect", "stop", "style", "switch", "symbol", "text", "textpath", "title", "tref", "tspan", "view", "vkern"]), qm = Lt(["feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence"]), oB = Lt(["animate", "color-profile", "cursor", "discard", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "foreignobject", "hatch", "hatchpath", "mesh", "meshgradient", "meshpatch", "meshrow", "missing-glyph", "script", "set", "solidcolor", "unknown", "use"]), Hm = Lt(["math", "menclose", "merror", "mfenced", "mfrac", "mglyph", "mi", "mlabeledtr", "mmultiscripts", "mn", "mo", "mover", "mpadded", "mphantom", "mroot", "mrow", "ms", "mspace", "msqrt", "mstyle", "msub", "msup", "msubsup", "mtable", "mtd", "mtext", "mtr", "munder", "munderover", "mprescripts"]), sB = Lt(["maction", "maligngroup", "malignmark", "mlongdiv", "mscarries", "mscarry", "msgroup", "mstack", "msline", "msrow", "semantics", "annotation", "annotation-xml", "mprescripts", "none"]), xS = Lt(["#text"]), SS = Lt(["accept", "action", "align", "alt", "autocapitalize", "autocomplete", "autopictureinpicture", "autoplay", "background", "bgcolor", "border", "capture", "cellpadding", "cellspacing", "checked", "cite", "class", "clear", "color", "cols", "colspan", "command", "commandfor", "controls", "controlslist", "coords", "crossorigin", "datetime", "decoding", "default", "dir", "disabled", "disablepictureinpicture", "disableremoteplayback", "download", "draggable", "enctype", "enterkeyhint", "exportparts", "face", "for", "headers", "height", "hidden", "high", "href", "hreflang", "id", "inert", "inputmode", "integrity", "ismap", "kind", "label", "lang", "list", "loading", "loop", "low", "max", "maxlength", "media", "method", "min", "minlength", "multiple", "muted", "name", "nonce", "noshade", "novalidate", "nowrap", "open", "optimum", "part", "pattern", "placeholder", "playsinline", "popover", "popovertarget", "popovertargetaction", "poster", "preload", "pubdate", "radiogroup", "readonly", "rel", "required", "rev", "reversed", "role", "rows", "rowspan", "spellcheck", "scope", "selected", "shape", "size", "sizes", "slot", "span", "srclang", "start", "src", "srcset", "step", "style", "summary", "tabindex", "title", "translate", "type", "usemap", "valign", "value", "width", "wrap", "xmlns"]), Wm = Lt(["accent-height", "accumulate", "additive", "alignment-baseline", "amplitude", "ascent", "attributename", "attributetype", "azimuth", "basefrequency", "baseline-shift", "begin", "bias", "by", "class", "clip", "clippathunits", "clip-path", "clip-rule", "color", "color-interpolation", "color-interpolation-filters", "color-profile", "color-rendering", "cx", "cy", "d", "dx", "dy", "diffuseconstant", "direction", "display", "divisor", "dur", "edgemode", "elevation", "end", "exponent", "fill", "fill-opacity", "fill-rule", "filter", "filterunits", "flood-color", "flood-opacity", "font-family", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-variant", "font-weight", "fx", "fy", "g1", "g2", "glyph-name", "glyphref", "gradientunits", "gradienttransform", "height", "href", "id", "image-rendering", "in", "in2", "intercept", "k", "k1", "k2", "k3", "k4", "kerning", "keypoints", "keysplines", "keytimes", "lang", "lengthadjust", "letter-spacing", "kernelmatrix", "kernelunitlength", "lighting-color", "local", "marker-end", "marker-mid", "marker-start", "markerheight", "markerunits", "markerwidth", "maskcontentunits", "maskunits", "max", "mask", "mask-type", "media", "method", "mode", "min", "name", "numoctaves", "offset", "operator", "opacity", "order", "orient", "orientation", "origin", "overflow", "paint-order", "path", "pathlength", "patterncontentunits", "patterntransform", "patternunits", "points", "preservealpha", "preserveaspectratio", "primitiveunits", "r", "rx", "ry", "radius", "refx", "refy", "repeatcount", "repeatdur", "restart", "result", "rotate", "scale", "seed", "shape-rendering", "slope", "specularconstant", "specularexponent", "spreadmethod", "startoffset", "stddeviation", "stitchtiles", "stop-color", "stop-opacity", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke", "stroke-width", "style", "surfacescale", "systemlanguage", "tabindex", "tablevalues", "targetx", "targety", "transform", "transform-origin", "text-anchor", "text-decoration", "text-rendering", "textlength", "type", "u1", "u2", "unicode", "values", "viewbox", "visibility", "version", "vert-adv-y", "vert-origin-x", "vert-origin-y", "width", "word-spacing", "wrap", "writing-mode", "xchannelselector", "ychannelselector", "x", "x1", "x2", "xmlns", "y", "y1", "y2", "z", "zoomandpan"]), NS = Lt(["accent", "accentunder", "align", "bevelled", "close", "columnalign", "columnlines", "columnspacing", "columnspan", "denomalign", "depth", "dir", "display", "displaystyle", "encoding", "fence", "frame", "height", "href", "id", "largeop", "length", "linethickness", "lquote", "lspace", "mathbackground", "mathcolor", "mathsize", "mathvariant", "maxsize", "minsize", "movablelimits", "notation", "numalign", "open", "rowalign", "rowlines", "rowspacing", "rowspan", "rspace", "rquote", "scriptlevel", "scriptminsize", "scriptsizemultiplier", "selection", "separator", "separators", "stretchy", "subscriptshift", "supscriptshift", "symmetric", "voffset", "width", "xmlns"]), Ts = Lt(["xlink:href", "xml:id", "xlink:title", "xml:space", "xmlns:xlink"]), lB = zt(/{{[\w\W]*|^[\w\W]*}}/g), cB = zt(/<%[\w\W]*|^[\w\W]*%>/g), dB = zt(/\${[\w\W]*/g), uB = zt(/^data-[\-\w.\u00B7-\uFFFF]+$/), mB = zt(/^aria-[\-\w]+$/), jS = zt(
  /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp|matrix):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i
  // eslint-disable-line no-useless-escape
), pB = zt(/^(?:\w+script|data):/i), fB = zt(
  /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g
  // eslint-disable-line no-control-regex
), hB = zt(/^html$/i), yB = zt(/^[a-z][.\w]*(-[.\w]+)+$/i), wS = zt(/<[/\w!]/g), gB = zt(/<[/\w]/g), vB = zt(/<\/no(script|embed|frames)/i), kB = zt(/\/>/i), Ar = {
  element: 1,
  attribute: 2,
  text: 3,
  cdataSection: 4,
  entityReference: 5,
  // Deprecated
  entityNode: 6,
  // Deprecated
  processingInstruction: 7,
  comment: 8,
  document: 9,
  documentType: 10,
  documentFragment: 11,
  notation: 12
  // Deprecated
}, bB = function() {
  return typeof window > "u" ? null : window;
}, _B = function(e, n) {
  if (typeof e != "object" || typeof e.createPolicy != "function")
    return null;
  let r = null;
  const i = "data-tt-policy-suffix";
  n && n.hasAttribute(i) && (r = n.getAttribute(i));
  const a = "dompurify" + (r ? "#" + r : "");
  try {
    return e.createPolicy(a, {
      createHTML(o) {
        return o;
      },
      createScriptURL(o) {
        return o;
      }
    });
  } catch {
    return console.warn("TrustedTypes policy " + a + " could not be created."), null;
  }
}, CS = function() {
  return {
    afterSanitizeAttributes: [],
    afterSanitizeElements: [],
    afterSanitizeShadowDOM: [],
    beforeSanitizeAttributes: [],
    beforeSanitizeElements: [],
    beforeSanitizeShadowDOM: [],
    uponSanitizeAttribute: [],
    uponSanitizeElement: [],
    uponSanitizeShadowNode: []
  };
}, fi = function(e, n, r, i) {
  return $t(e, n) && gi(e[n]) ? Hn(i.base ? Wt(i.base) : {}, e[n], i.transform) : r;
};
function G1() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : bB();
  const n = (W) => G1(W);
  if (n.version = "3.4.11", n.removed = [], !e || !e.document || e.document.nodeType !== Ar.document || !e.Element)
    return n.isSupported = !1, n;
  let r = e.document;
  const i = r, a = i.currentScript;
  e.DocumentFragment;
  const o = e.HTMLTemplateElement, s = e.Node, l = e.Element, d = e.NodeFilter;
  e.NamedNodeMap === void 0 && (e.NamedNodeMap || e.MozNamedAttrMap), e.HTMLFormElement;
  const u = e.DOMParser, f = e.trustedTypes, h = l.prototype, v = Vr(h, "cloneNode"), w = Vr(h, "remove"), N = Vr(h, "nextSibling"), j = Vr(h, "childNodes"), _ = Vr(h, "parentNode"), g = Vr(h, "shadowRoot"), O = Vr(h, "attributes"), R = s && s.prototype ? Vr(s.prototype, "nodeType") : null, $ = s && s.prototype ? Vr(s.prototype, "nodeName") : null;
  if (typeof o == "function") {
    const W = r.createElement("template");
    W.content && W.content.ownerDocument && (r = W.content.ownerDocument);
  }
  let I, L = "", G, Q = !1, ne = 0;
  const q = function() {
    if (ne > 0)
      throw $i('A configured TRUSTED_TYPES_POLICY callback (createHTML or createScriptURL) must not call DOMPurify.sanitize, as that causes infinite recursion. Do not pass a policy whose callbacks wrap DOMPurify as TRUSTED_TYPES_POLICY; see the "DOMPurify and Trusted Types" section of the README.');
  }, Y = function(W) {
    q(), ne++;
    try {
      return I.createHTML(W);
    } finally {
      ne--;
    }
  }, P = function(W) {
    q(), ne++;
    try {
      return I.createScriptURL(W);
    } finally {
      ne--;
    }
  }, B = function() {
    return Q || (G = _B(f, a), Q = !0), G;
  }, ie = r, je = ie.implementation, pe = ie.createNodeIterator, le = ie.createDocumentFragment, ge = ie.getElementsByTagName, V = i.importNode;
  let be = CS();
  n.isSupported = typeof W1 == "function" && typeof _ == "function" && je && je.createHTMLDocument !== void 0;
  const Oe = lB, H = cB, Ye = dB, ln = uB, Ie = mB, Ue = pB, De = fB, Be = yB;
  let Ae = jS, Qe = null;
  const Ee = Hn({}, [..._S, ...Bm, ...qm, ...Hm, ...xS]);
  let Me = null;
  const en = Hn({}, [...SS, ...Wm, ...NS, ...Ts]);
  let se = Object.seal(ma(null, {
    tagNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    attributeNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    allowCustomizedBuiltInElements: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: !1
    }
  })), ce = null, Se = null;
  const Ve = Object.seal(ma(null, {
    tagCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    attributeCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    }
  }));
  let Pe = !0, kn = !0, X = !1, E = !0, z = !1, ae = !0, de = !1, U = !1, J = null, ve = null, we = !1, Re = !1, rn = !1, bn = !1, an = !0, hn = !1;
  const En = "user-content-";
  let _n = !0, Fn = !1, Ze = {}, gn = null;
  const Le = Hn({}, [
    "annotation-xml",
    "audio",
    "colgroup",
    "desc",
    "foreignobject",
    "head",
    "iframe",
    "math",
    "mi",
    "mn",
    "mo",
    "ms",
    "mtext",
    "noembed",
    "noframes",
    "noscript",
    "plaintext",
    "script",
    // <selectedcontent> mirrors the selected <option>'s subtree, cloned by
    // the UA (customizable <select>) — including any on* handlers — and the
    // engine re-mirrors synchronously whenever a removal changes which
    // option/selectedcontent is current, even inside DOMPurify's inert
    // DOMParser document. Hoisting its children on removal re-inserts a fresh
    // mirror target ahead of the walk, which the engine refills, looping
    // forever (DoS) and amplifying output. Dropping its content on removal
    // (rather than hoisting) breaks that cascade; the content is a duplicate
    // of the option, which is sanitized on its own. See campaign-3 F1/F6.
    "selectedcontent",
    "style",
    "svg",
    "template",
    "thead",
    "title",
    "video",
    "xmp"
  ]);
  let dn = null;
  const un = Hn({}, ["audio", "video", "img", "source", "image", "track"]);
  let Nn = null;
  const Bn = Hn({}, ["alt", "class", "for", "id", "label", "name", "pattern", "placeholder", "role", "summary", "title", "value", "style", "xmlns"]), Sn = "http://www.w3.org/1998/Math/MathML", An = "http://www.w3.org/2000/svg", vn = "http://www.w3.org/1999/xhtml";
  let xn = vn, Ln = !1, Vn = null;
  const Cn = Hn({}, [Sn, An, vn], Mm), wn = Lt(["mi", "mo", "mn", "ms", "mtext"]);
  let zn = Hn({}, wn);
  const qn = Lt(["annotation-xml"]);
  let Un = Hn({}, qn);
  const Kn = Hn({}, ["title", "style", "font", "a", "script"]);
  let t = null;
  const c = ["application/xhtml+xml", "text/html"], p = "text/html";
  let y = null, C = null;
  const T = r.createElement("form"), S = function(W) {
    return W instanceof RegExp || W instanceof Function;
  }, x = function() {
    let W = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (C && C === W)
      return;
    (!W || typeof W != "object") && (W = {}), W = Wt(W), t = // eslint-disable-next-line unicorn/prefer-includes
    c.indexOf(W.PARSER_MEDIA_TYPE) === -1 ? p : W.PARSER_MEDIA_TYPE, y = t === "application/xhtml+xml" ? Mm : Io, Qe = fi(W, "ALLOWED_TAGS", Ee, {
      transform: y
    }), Me = fi(W, "ALLOWED_ATTR", en, {
      transform: y
    }), Vn = fi(W, "ALLOWED_NAMESPACES", Cn, {
      transform: Mm
    }), Nn = fi(W, "ADD_URI_SAFE_ATTR", Bn, {
      transform: y,
      base: Bn
    }), dn = fi(W, "ADD_DATA_URI_TAGS", un, {
      transform: y,
      base: un
    }), gn = fi(W, "FORBID_CONTENTS", Le, {
      transform: y
    }), ce = fi(W, "FORBID_TAGS", Wt({}), {
      transform: y
    }), Se = fi(W, "FORBID_ATTR", Wt({}), {
      transform: y
    }), Ze = $t(W, "USE_PROFILES") ? W.USE_PROFILES && typeof W.USE_PROFILES == "object" ? Wt(W.USE_PROFILES) : W.USE_PROFILES : !1, Pe = W.ALLOW_ARIA_ATTR !== !1, kn = W.ALLOW_DATA_ATTR !== !1, X = W.ALLOW_UNKNOWN_PROTOCOLS || !1, E = W.ALLOW_SELF_CLOSE_IN_ATTR !== !1, z = W.SAFE_FOR_TEMPLATES || !1, ae = W.SAFE_FOR_XML !== !1, de = W.WHOLE_DOCUMENT || !1, Re = W.RETURN_DOM || !1, rn = W.RETURN_DOM_FRAGMENT || !1, bn = W.RETURN_TRUSTED_TYPE || !1, we = W.FORCE_BODY || !1, an = W.SANITIZE_DOM !== !1, hn = W.SANITIZE_NAMED_PROPS || !1, _n = W.KEEP_CONTENT !== !1, Fn = W.IN_PLACE || !1, Ae = aB(W.ALLOWED_URI_REGEXP) ? W.ALLOWED_URI_REGEXP : jS, xn = typeof W.NAMESPACE == "string" ? W.NAMESPACE : vn, zn = $t(W, "MATHML_TEXT_INTEGRATION_POINTS") && W.MATHML_TEXT_INTEGRATION_POINTS && typeof W.MATHML_TEXT_INTEGRATION_POINTS == "object" ? Wt(W.MATHML_TEXT_INTEGRATION_POINTS) : Hn({}, wn), Un = $t(W, "HTML_INTEGRATION_POINTS") && W.HTML_INTEGRATION_POINTS && typeof W.HTML_INTEGRATION_POINTS == "object" ? Wt(W.HTML_INTEGRATION_POINTS) : Hn({}, qn);
    const $e = $t(W, "CUSTOM_ELEMENT_HANDLING") && W.CUSTOM_ELEMENT_HANDLING && typeof W.CUSTOM_ELEMENT_HANDLING == "object" ? Wt(W.CUSTOM_ELEMENT_HANDLING) : ma(null);
    if (se = ma(null), $t($e, "tagNameCheck") && S($e.tagNameCheck) && (se.tagNameCheck = $e.tagNameCheck), $t($e, "attributeNameCheck") && S($e.attributeNameCheck) && (se.attributeNameCheck = $e.attributeNameCheck), $t($e, "allowCustomizedBuiltInElements") && typeof $e.allowCustomizedBuiltInElements == "boolean" && (se.allowCustomizedBuiltInElements = $e.allowCustomizedBuiltInElements), zt(se), z && (kn = !1), rn && (Re = !0), Ze && (Qe = Hn({}, xS), Me = ma(null), Ze.html === !0 && (Hn(Qe, _S), Hn(Me, SS)), Ze.svg === !0 && (Hn(Qe, Bm), Hn(Me, Wm), Hn(Me, Ts)), Ze.svgFilters === !0 && (Hn(Qe, qm), Hn(Me, Wm), Hn(Me, Ts)), Ze.mathMl === !0 && (Hn(Qe, Hm), Hn(Me, NS), Hn(Me, Ts))), Ve.tagCheck = null, Ve.attributeCheck = null, $t(W, "ADD_TAGS") && (typeof W.ADD_TAGS == "function" ? Ve.tagCheck = W.ADD_TAGS : gi(W.ADD_TAGS) && (Qe === Ee && (Qe = Wt(Qe)), Hn(Qe, W.ADD_TAGS, y))), $t(W, "ADD_ATTR") && (typeof W.ADD_ATTR == "function" ? Ve.attributeCheck = W.ADD_ATTR : gi(W.ADD_ATTR) && (Me === en && (Me = Wt(Me)), Hn(Me, W.ADD_ATTR, y))), $t(W, "ADD_URI_SAFE_ATTR") && gi(W.ADD_URI_SAFE_ATTR) && Hn(Nn, W.ADD_URI_SAFE_ATTR, y), $t(W, "FORBID_CONTENTS") && gi(W.FORBID_CONTENTS) && (gn === Le && (gn = Wt(gn)), Hn(gn, W.FORBID_CONTENTS, y)), $t(W, "ADD_FORBID_CONTENTS") && gi(W.ADD_FORBID_CONTENTS) && (gn === Le && (gn = Wt(gn)), Hn(gn, W.ADD_FORBID_CONTENTS, y)), _n && (Qe["#text"] = !0), de && Hn(Qe, ["html", "head", "body"]), Qe.table && (Hn(Qe, ["tbody"]), delete ce.tbody), W.TRUSTED_TYPES_POLICY) {
      if (typeof W.TRUSTED_TYPES_POLICY.createHTML != "function")
        throw $i('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
      if (typeof W.TRUSTED_TYPES_POLICY.createScriptURL != "function")
        throw $i('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
      const We = I;
      I = W.TRUSTED_TYPES_POLICY;
      try {
        L = Y("");
      } catch (cn) {
        throw I = We, cn;
      }
    } else W.TRUSTED_TYPES_POLICY === null ? (I = void 0, L = "") : (I === void 0 && (I = B()), I && typeof L == "string" && (L = Y("")));
    Lt && Lt(W), C = W;
  }, ee = Hn({}, [...Bm, ...qm, ...oB]), A = Hn({}, [...Hm, ...sB]), M = function(W, $e, We) {
    return $e.namespaceURI === vn ? W === "svg" : $e.namespaceURI === Sn ? W === "svg" && (We === "annotation-xml" || zn[We]) : !!ee[W];
  }, ue = function(W, $e, We) {
    return $e.namespaceURI === vn ? W === "math" : $e.namespaceURI === An ? W === "math" && Un[We] : !!A[W];
  }, ze = function(W, $e, We) {
    return $e.namespaceURI === An && !Un[We] || $e.namespaceURI === Sn && !zn[We] ? !1 : !A[W] && (Kn[W] || !ee[W]);
  }, Te = function(W) {
    let $e = _(W);
    (!$e || !$e.tagName) && ($e = {
      namespaceURI: xn,
      tagName: "template"
    });
    const We = Io(W.tagName), cn = Io($e.tagName);
    return Vn[W.namespaceURI] ? W.namespaceURI === An ? M(We, $e, cn) : W.namespaceURI === Sn ? ue(We, $e, cn) : W.namespaceURI === vn ? ze(We, $e, cn) : !!(t === "application/xhtml+xml" && Vn[W.namespaceURI]) : !1;
  }, re = function(W) {
    sa(n.removed, {
      element: W
    });
    try {
      _(W).removeChild(W);
    } catch {
      if (w(W), !_(W))
        throw $i("a node selected for removal could not be detached from its tree and cannot be safely returned; refusing to sanitize in place");
    }
  }, mn = function(W) {
    const $e = j(W);
    if ($e) {
      const cn = [];
      po($e, (On) => {
        sa(cn, On);
      }), po(cn, (On) => {
        try {
          w(On);
        } catch {
        }
      });
    }
    const We = O(W);
    if (We)
      for (let cn = We.length - 1; cn >= 0; --cn) {
        const On = We[cn], tt = On && On.name;
        if (typeof tt == "string")
          try {
            W.removeAttribute(tt);
          } catch {
          }
      }
  }, Dn = function(W, $e) {
    try {
      sa(n.removed, {
        attribute: $e.getAttributeNode(W),
        from: $e
      });
    } catch {
      sa(n.removed, {
        attribute: null,
        from: $e
      });
    }
    if ($e.removeAttribute(W), W === "is")
      if (Re || rn)
        try {
          re($e);
        } catch {
        }
      else
        try {
          $e.setAttribute(W, "");
        } catch {
        }
  }, Gn = function(W) {
    const $e = O(W);
    if ($e)
      for (let We = $e.length - 1; We >= 0; --We) {
        const cn = $e[We], On = cn && cn.name;
        if (!(typeof On != "string" || Me[y(On)]))
          try {
            W.removeAttribute(On);
          } catch {
          }
      }
  }, rI = function(W) {
    const $e = [W];
    for (; $e.length > 0; ) {
      const We = $e.pop();
      (R ? R(We) : We.nodeType) === Ar.element && Gn(We);
      const cn = j(We);
      if (cn)
        for (let On = cn.length - 1; On >= 0; --On)
          $e.push(cn[On]);
    }
  }, iv = function(W) {
    let $e = null, We = null;
    if (we)
      W = "<remove></remove>" + W;
    else {
      const tt = gS(W, /^[\r\n\t ]+/);
      We = tt && tt[0];
    }
    t === "application/xhtml+xml" && xn === vn && (W = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + W + "</body></html>");
    const cn = I ? Y(W) : W;
    if (xn === vn)
      try {
        $e = new u().parseFromString(cn, t);
      } catch {
      }
    if (!$e || !$e.documentElement) {
      $e = je.createDocument(xn, "template", null);
      try {
        $e.documentElement.innerHTML = Ln ? L : cn;
      } catch {
      }
    }
    const On = $e.body || $e.documentElement;
    return W && We && On.insertBefore(r.createTextNode(We), On.childNodes[0] || null), xn === vn ? ge.call($e, de ? "html" : "body")[0] : de ? $e.documentElement : On;
  }, av = function(W) {
    return pe.call(
      W.ownerDocument || W,
      W,
      // eslint-disable-next-line no-bitwise
      d.SHOW_ELEMENT | d.SHOW_COMMENT | d.SHOW_TEXT | d.SHOW_PROCESSING_INSTRUCTION | d.SHOW_CDATA_SECTION,
      null
    );
  }, ds = function(W) {
    return W = fo(W, Oe, " "), W = fo(W, H, " "), W = fo(W, Ye, " "), W;
  }, bc = function(W) {
    var $e;
    W.normalize();
    const We = pe.call(
      W.ownerDocument || W,
      W,
      // eslint-disable-next-line no-bitwise
      d.SHOW_TEXT | d.SHOW_COMMENT | d.SHOW_CDATA_SECTION | d.SHOW_PROCESSING_INSTRUCTION,
      null
    );
    let cn = We.nextNode();
    for (; cn; )
      cn.data = ds(cn.data), cn = We.nextNode();
    const On = ($e = W.querySelectorAll) === null || $e === void 0 ? void 0 : $e.call(W, "template");
    On && po(On, (tt) => {
      Zi(tt.content) && bc(tt.content);
    });
  }, us = function(W) {
    const $e = $ ? $(W) : null;
    return typeof $e != "string" || y($e) !== "form" ? !1 : typeof W.nodeName != "string" || typeof W.textContent != "string" || typeof W.removeChild != "function" || // Realm-safe NamedNodeMap detection: equality against the cached
    // prototype getter. Clobbered .attributes (e.g. <input name="attributes">)
    // makes the direct read diverge from the cached read; a clean form
    // (same-realm OR foreign-realm) has both reads pointing at the same
    // canonical NamedNodeMap.
    W.attributes !== O(W) || typeof W.removeAttribute != "function" || typeof W.setAttribute != "function" || typeof W.namespaceURI != "string" || typeof W.insertBefore != "function" || typeof W.hasChildNodes != "function" || // NodeType clobbering probe. Cached Node.prototype.nodeType getter
    // returns the integer 1 for any Element regardless of realm; direct
    // read on a clobbered form (e.g. <input name="nodeType">) returns
    // the named child element. Cheap addition — nodeType is read from
    // an internal slot, no serialization cost — and removes a residual
    // clobbering surface used by several mXSS / PI / comment branches
    // in _sanitizeElements that compare currentNode.nodeType directly.
    W.nodeType !== R(W) || // HTMLFormElement has [LegacyOverrideBuiltIns]: a descendant named
    // "childNodes" shadows the prototype getter. Direct reads of
    // form.childNodes from a clobbered form return the named child
    // instead of the real NodeList, so any walk that reads it directly
    // skips the form's real children. Compare the direct read to the
    // cached Node.prototype getter — when the form's named-property
    // getter intercepts the read, the two values differ and we flag
    // the form. This catches every clobbering child type (input,
    // select, etc.) regardless of whether the named child happens to
    // carry a numeric .length, which a typeof-based probe would miss
    // (e.g. HTMLSelectElement.length is a defined unsigned-long).
    W.childNodes !== j(W);
  }, Zi = function(W) {
    if (!R || typeof W != "object" || W === null)
      return !1;
    try {
      return R(W) === Ar.documentFragment;
    } catch {
      return !1;
    }
  }, Ua = function(W) {
    if (!R || typeof W != "object" || W === null)
      return !1;
    try {
      return typeof R(W) == "number";
    } catch {
      return !1;
    }
  };
  function Xr(W, $e, We) {
    W.length !== 0 && po(W, (cn) => {
      cn.call(n, $e, We, C);
    });
  }
  const iI = function(W, $e) {
    return !!(ae && W.hasChildNodes() && !Ua(W.firstElementChild) && Rt(wS, W.textContent) && Rt(wS, W.innerHTML) || ae && W.namespaceURI === vn && $e === "style" && Ua(W.firstElementChild) || W.nodeType === Ar.processingInstruction || ae && W.nodeType === Ar.comment && Rt(gB, W.data));
  }, aI = function(W, $e) {
    if (!ce[$e] && lv($e) && (se.tagNameCheck instanceof RegExp && Rt(se.tagNameCheck, $e) || se.tagNameCheck instanceof Function && se.tagNameCheck($e)))
      return !1;
    if (_n && !gn[$e]) {
      const We = _(W), cn = j(W);
      if (cn && We) {
        const On = cn.length;
        for (let tt = On - 1; tt >= 0; --tt) {
          const rt = Fn ? cn[tt] : v(cn[tt], !0);
          We.insertBefore(rt, N(W));
        }
      }
    }
    return re(W), !0;
  }, ov = function(W) {
    if (Xr(be.beforeSanitizeElements, W, null), us(W))
      return re(W), !0;
    const $e = y($ ? $(W) : W.nodeName);
    if (Xr(be.uponSanitizeElement, W, {
      tagName: $e,
      allowedTags: Qe
    }), iI(W, $e))
      return re(W), !0;
    if (ce[$e] || !(Ve.tagCheck instanceof Function && Ve.tagCheck($e)) && !Qe[$e])
      return aI(W, $e);
    if ((R ? R(W) : W.nodeType) === Ar.element && !Te(W) || ($e === "noscript" || $e === "noembed" || $e === "noframes") && Rt(vB, W.innerHTML))
      return re(W), !0;
    if (z && W.nodeType === Ar.text) {
      const We = ds(W.textContent);
      W.textContent !== We && (sa(n.removed, {
        element: W.cloneNode()
      }), W.textContent = We);
    }
    return Xr(be.afterSanitizeElements, W, null), !1;
  }, sv = function(W, $e, We) {
    if (Se[$e] || an && ($e === "id" || $e === "name") && (We in r || We in T))
      return !1;
    const cn = Me[$e] || Ve.attributeCheck instanceof Function && Ve.attributeCheck($e, W);
    if (!(kn && Rt(ln, $e)) && !(Pe && Rt(Ie, $e))) {
      if (cn) {
        if (!Nn[$e] && !Rt(Ae, fo(We, De, "")) && !(($e === "src" || $e === "xlink:href" || $e === "href") && W !== "script" && vS(We, "data:") === 0 && dn[W]) && !(X && !Rt(Ue, fo(We, De, ""))) && We)
          return !1;
      } else if (
        // First condition does a very basic check if a) it's basically a valid custom element tagname AND
        // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
        // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
        !(lv(W) && (se.tagNameCheck instanceof RegExp && Rt(se.tagNameCheck, W) || se.tagNameCheck instanceof Function && se.tagNameCheck(W)) && (se.attributeNameCheck instanceof RegExp && Rt(se.attributeNameCheck, $e) || se.attributeNameCheck instanceof Function && se.attributeNameCheck($e, W)) || // Alternative, second condition checks if it's an `is`-attribute, AND
        // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
        $e === "is" && se.allowCustomizedBuiltInElements && (se.tagNameCheck instanceof RegExp && Rt(se.tagNameCheck, We) || se.tagNameCheck instanceof Function && se.tagNameCheck(We)))
      ) return !1;
    }
    return !0;
  }, oI = Hn({}, ["annotation-xml", "color-profile", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "missing-glyph"]), lv = function(W) {
    return !oI[Io(W)] && Rt(Be, W);
  }, sI = function(W, $e, We, cn) {
    if (I && typeof f == "object" && typeof f.getAttributeType == "function" && !We)
      switch (f.getAttributeType(W, $e)) {
        case "TrustedHTML":
          return Y(cn);
        case "TrustedScriptURL":
          return P(cn);
      }
    return cn;
  }, lI = function(W, $e, We, cn) {
    try {
      We ? W.setAttributeNS(We, $e, cn) : W.setAttribute($e, cn), us(W) ? re(W) : yS(n.removed);
    } catch {
      Dn($e, W);
    }
  }, cv = function(W) {
    Xr(be.beforeSanitizeAttributes, W, null);
    const $e = W.attributes;
    if (!$e || us(W))
      return;
    const We = {
      attrName: "",
      attrValue: "",
      keepAttr: !0,
      allowedAttributes: Me,
      forceKeepAttr: void 0
    };
    let cn = $e.length;
    const On = y(W.nodeName);
    for (; cn--; ) {
      const tt = $e[cn], rt = tt.name, ji = tt.namespaceURI, di = tt.value, Zt = y(rt), ui = di;
      let Ht = rt === "value" ? ui : Z5(ui);
      if (We.attrName = Zt, We.attrValue = Ht, We.keepAttr = !0, We.forceKeepAttr = void 0, Xr(be.uponSanitizeAttribute, W, We), Ht = We.attrValue, hn && (Zt === "id" || Zt === "name") && vS(Ht, En) !== 0 && (Dn(rt, W), Ht = En + Ht), ae && Rt(/((--!?|])>)|<\/(style|script|title|xmp|textarea|noscript|iframe|noembed|noframes)/i, Ht)) {
        Dn(rt, W);
        continue;
      }
      if (Zt === "attributename" && gS(Ht, "href")) {
        Dn(rt, W);
        continue;
      }
      if (!We.forceKeepAttr) {
        if (!We.keepAttr) {
          Dn(rt, W);
          continue;
        }
        if (!E && Rt(kB, Ht)) {
          Dn(rt, W);
          continue;
        }
        if (z && (Ht = ds(Ht)), !sv(On, Zt, Ht)) {
          Dn(rt, W);
          continue;
        }
        Ht = sI(On, Zt, ji, Ht), Ht !== ui && lI(W, rt, ji, Ht);
      }
    }
    Xr(be.afterSanitizeAttributes, W, null);
  }, ms = function(W) {
    let $e = null;
    const We = av(W);
    for (Xr(be.beforeSanitizeShadowDOM, W, null); $e = We.nextNode(); )
      if (Xr(be.uponSanitizeShadowNode, $e, null), ov($e), cv($e), Zi($e.content) && ms($e.content), (R ? R($e) : $e.nodeType) === Ar.element) {
        const cn = g($e);
        Zi(cn) && (_c(cn), ms(cn));
      }
    Xr(be.afterSanitizeShadowDOM, W, null);
  }, _c = function(W) {
    const $e = [{
      node: W,
      shadow: null
    }];
    for (; $e.length > 0; ) {
      const We = $e.pop();
      if (We.shadow) {
        ms(We.shadow);
        continue;
      }
      const cn = We.node, On = (R ? R(cn) : cn.nodeType) === Ar.element, tt = j(cn);
      if (tt)
        for (let rt = tt.length - 1; rt >= 0; --rt)
          $e.push({
            node: tt[rt],
            shadow: null
          });
      if (On) {
        const rt = $ ? $(cn) : null;
        if (typeof rt == "string" && y(rt) === "template") {
          const ji = cn.content;
          Zi(ji) && $e.push({
            node: ji,
            shadow: null
          });
        }
      }
      if (On) {
        const rt = g(cn);
        Zi(rt) && $e.push({
          node: null,
          shadow: rt
        }, {
          node: rt,
          shadow: null
        });
      }
    }
  };
  return n.sanitize = function(W) {
    let $e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, We = null, cn = null, On = null, tt = null;
    if (Ln = !W, Ln && (W = "<!-->"), typeof W != "string" && !Ua(W) && (W = iB(W), typeof W != "string"))
      throw $i("dirty is not a string, aborting");
    if (!n.isSupported)
      return W;
    U ? (Qe = J, Me = ve) : x($e), (be.uponSanitizeElement.length > 0 || be.uponSanitizeAttribute.length > 0) && (Qe = Wt(Qe)), be.uponSanitizeAttribute.length > 0 && (Me = Wt(Me)), n.removed = [];
    const rt = Fn && typeof W != "string" && Ua(W);
    if (rt) {
      const Zt = $ ? $(W) : W.nodeName;
      if (typeof Zt == "string") {
        const ui = y(Zt);
        if (!Qe[ui] || ce[ui])
          throw $i("root node is forbidden and cannot be sanitized in-place");
      }
      if (us(W))
        throw $i("root node is clobbered and cannot be sanitized in-place");
      try {
        _c(W);
      } catch (ui) {
        throw mn(W), ui;
      }
    } else if (Ua(W))
      We = iv("<!---->"), cn = We.ownerDocument.importNode(W, !0), cn.nodeType === Ar.element && cn.nodeName === "BODY" || cn.nodeName === "HTML" ? We = cn : We.appendChild(cn), _c(cn);
    else {
      if (!Re && !z && !de && // eslint-disable-next-line unicorn/prefer-includes
      W.indexOf("<") === -1)
        return I && bn ? Y(W) : W;
      if (We = iv(W), !We)
        return Re ? null : bn ? L : "";
    }
    We && we && re(We.firstChild);
    const ji = av(rt ? W : We);
    try {
      for (; On = ji.nextNode(); )
        ov(On), cv(On), Zi(On.content) && ms(On.content);
    } catch (Zt) {
      throw rt && mn(W), Zt;
    }
    if (rt)
      return po(n.removed, (Zt) => {
        Zt.element && rI(Zt.element);
      }), z && bc(W), W;
    if (Re) {
      if (z && bc(We), rn)
        for (tt = le.call(We.ownerDocument); We.firstChild; )
          tt.appendChild(We.firstChild);
      else
        tt = We;
      return (Me.shadowroot || Me.shadowrootmode) && (tt = V.call(i, tt, !0)), tt;
    }
    let di = de ? We.outerHTML : We.innerHTML;
    return de && Qe["!doctype"] && We.ownerDocument && We.ownerDocument.doctype && We.ownerDocument.doctype.name && Rt(hB, We.ownerDocument.doctype.name) && (di = "<!DOCTYPE " + We.ownerDocument.doctype.name + `>
` + di), z && (di = ds(di)), I && bn ? Y(di) : di;
  }, n.setConfig = function() {
    let W = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    x(W), U = !0, J = Qe, ve = Me;
  }, n.clearConfig = function() {
    C = null, U = !1, J = null, ve = null, I = G, L = "";
  }, n.isValidAttribute = function(W, $e, We) {
    C || x({});
    const cn = y(W), On = y($e);
    return sv(cn, On, We);
  }, n.addHook = function(W, $e) {
    typeof $e == "function" && $t(be, W) && sa(be[W], $e);
  }, n.removeHook = function(W, $e) {
    if ($t(be, W)) {
      if ($e !== void 0) {
        const We = Q5(be[W], $e);
        return We === -1 ? void 0 : X5(be[W], We, 1)[0];
      }
      return yS(be[W]);
    }
  }, n.removeHooks = function(W) {
    $t(be, W) && (be[W] = []);
  }, n.removeAllHooks = function() {
    be = CS();
  }, n;
}
var xB = G1();
const SB = "_messageContainer_1rxr4_1", NB = "_chip_1rxr4_7", jB = "_chipLabel_1rxr4_10", wB = "_chipValue_1rxr4_13", Rs = {
  messageContainer: SB,
  chip: NB,
  chipLabel: jB,
  chipValue: wB
}, FS = {
  INBOUND: {
    background: "var(--dixa-color-neutral-000)",
    borderColor: "var(--dixa-color-neutral-100)"
  },
  OUTBOUND: {
    background: "var(--dixa-color-neutral-100)",
    borderColor: "var(--dixa-color-neutral-200)"
  },
  INTERNAL: {
    background: "var(--dixa-color-orange-100)",
    borderColor: "var(--dixa-color-orange-200)"
  }
}, CB = ({
  messages: e,
  customFields: n,
  attachments: r,
  conversationContext: i
}) => {
  Xe(() => {
    document.getElementById("endOfConversationAnchor") && document.getElementById("endOfConversationAnchor")?.scrollIntoView({ behavior: "smooth" });
  }, [e]);
  const a = () => {
    const o = "Contact";
    if (!i?.customer)
      return o;
    const {
      name: s,
      given_name: l,
      family_name: d,
      email: m,
      phone_number: u
    } = i.customer;
    return s ?? l ?? d ?? m ?? u ?? o;
  };
  return /* @__PURE__ */ pn.jsxs(b, { flexDirection: "column", gap: "200", children: [
    /* @__PURE__ */ pn.jsx(b, { flexDirection: "row", flexWrap: "wrap", margin: "0 0 300", children: !!n?.length && /* @__PURE__ */ pn.jsxs(b, { gap: "100", children: [
      /* @__PURE__ */ pn.jsx(Ge, { content: "Conversation Attributes", children: /* @__PURE__ */ pn.jsx(
        Ty,
        {
          icon: "input",
          color: {
            contentColor: "var(--dixa-color-neutral-700)",
            backgroundColor: "var(--dixa-color-neutral-200)"
          }
        }
      ) }),
      n.map((o, s) => /* @__PURE__ */ pn.jsx(b, { alignItems: "center", children: /* @__PURE__ */ pn.jsx(Jn, { className: Rs.chip, children: /* @__PURE__ */ pn.jsxs(b, { gap: "100", children: [
        /* @__PURE__ */ pn.jsxs(ct, { className: Rs.chipLabel, children: [
          o.name,
          ":"
        ] }),
        /* @__PURE__ */ pn.jsx(ct, { className: Rs.chipValue, children: o.value })
      ] }) }) }, `${s}-${o.name}`))
    ] }) }),
    e?.map((o) => /* @__PURE__ */ pn.jsx(
      b,
      {
        className: Rs.messageContainer,
        gap: "200",
        style: {
          backgroundColor: o?.direction ? FS[o.direction].background : "var(--dixa-color-neutral-000)",
          borderColor: o?.direction ? FS[o.direction].borderColor : "var(--dixa-color-neutral-100)"
        },
        children: /* @__PURE__ */ pn.jsxs(b, { flexDirection: "column", gap: "200", width: "100%", children: [
          /* @__PURE__ */ pn.jsxs(b, { flexDirection: "row", justifyContent: "space-between", children: [
            /* @__PURE__ */ pn.jsx(F.Heading, { variant: "heading-3", children: o?.direction == "INBOUND" ? a() : o?.agent?.name }),
            /* @__PURE__ */ pn.jsx(F.Paragraph, { variant: "4", children: /* @__PURE__ */ pn.jsx(TI, { relative: !0, time: o?.created_at }) })
          ] }),
          /* @__PURE__ */ pn.jsx(
            "div",
            {
              dangerouslySetInnerHTML: {
                __html: xB.sanitize(
                  o?.body?.replaceAll(/\r\n?|\n/g, "<br />") || ""
                )
              }
            }
          )
        ] })
      },
      o?.created_at
    )),
    r && /* @__PURE__ */ pn.jsx(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", margin: "300 0 0", children: r.map((o, s) => /* @__PURE__ */ pn.jsx(
      RI,
      {
        fileName: o.url,
        label: o.label,
        onDownload: () => {
          window.open(o.url, "_blank")?.focus();
        }
      },
      `${s}-${o.url}`
    )) }),
    /* @__PURE__ */ pn.jsx("div", { id: "endOfConversationAnchor", children: " " })
  ] });
}, FB = "_conversation_1draa_1", IB = "_conversationSubLine_1draa_9", $B = "_modal_1draa_14", Km = {
  conversation: FB,
  conversationSubLine: IB,
  modal: $B
}, EB = (e) => (e && JSON.parse(e) || []).map((n) => ({
  url: n.URL__c,
  label: n.Name,
  type: n.File_Type__c
})), TB = (e) => Object.entries(e || {}).filter(([n]) => n.endsWith("__c")).map(([n, r]) => ({
  name: n.replace("__c", "").replaceAll("_", " "),
  // transform key into readable name
  value: r?.value ? r.value.toString() : ""
})), RB = ({
  conversation: e,
  conversationContext: n
}) => {
  const [r, i] = me(!1), a = e?.created_at, o = e?.custom_fields, s = o && "attachments" in o;
  return /* @__PURE__ */ pn.jsxs(b, { className: Km.conversation, gap: "300", flexDirection: "column", children: [
    /* @__PURE__ */ pn.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
      /* @__PURE__ */ pn.jsxs(b, { flexDirection: "column", gap: "100", children: [
        /* @__PURE__ */ pn.jsxs(b, { flexDirection: "row", gap: "100", children: [
          /* @__PURE__ */ pn.jsx(F.Heading, { variant: "heading-4", children: e?.id }),
          a && /* @__PURE__ */ pn.jsx(Pn, { size: "small", variant: "info", children: Wn(e?.created_at).format("DD MMM YYYY @ HH:mm") })
        ] }),
        /* @__PURE__ */ pn.jsx(
          F.Heading,
          {
            variant: "heading-4",
            className: Km.conversationSubLine,
            children: e?.subject
          }
        ),
        !!e?.labels?.length && /* @__PURE__ */ pn.jsx(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", children: [...new Set(e.labels)].map((l) => /* @__PURE__ */ pn.jsx(Jn, { children: l }, `${e.id}-${l}`)) })
      ] }),
      /* @__PURE__ */ pn.jsx(Ge, { content: "Show conversation preview", children: /* @__PURE__ */ pn.jsx(
        Xt,
        {
          variant: "secondary",
          icon: "eye",
          onClick: () => i(!0),
          "data-testid": "open-messages-preview"
        }
      ) })
    ] }),
    /* @__PURE__ */ pn.jsxs(
      ht,
      {
        isOpen: r,
        allowEscClose: !0,
        onClose: () => i(!1),
        className: Km.modal,
        children: [
          /* @__PURE__ */ pn.jsx(
            yt,
            {
              title: "Conversation preview",
              onClose: () => i(!1)
            }
          ),
          /* @__PURE__ */ pn.jsx(gt, { children: /* @__PURE__ */ pn.jsx(
            CB,
            {
              messages: e?.messages || [],
              ...s && {
                attachments: EB(
                  o?.attachments?.value
                )
              },
              conversationContext: n,
              customFields: TB(
                e?.custom_fields
              )
            }
          ) })
        ]
      }
    )
  ] });
}, DB = ({
  conversations: e,
  conversationContext: n,
  conversationsToShow: r
}) => {
  const [i, a] = me(!1), o = r > 0 ? r : 1, s = e?.length > o, l = Zn(
    () => e?.sort((d, m) => m?.created_at.localeCompare(d?.created_at)).slice(
      0,
      i ? e.length : o
    ),
    [e, i, o]
  );
  return /* @__PURE__ */ pn.jsxs(b, { flexDirection: "column", gap: "200", margin: "200 0 300 0", children: [
    l.map((d, m) => /* @__PURE__ */ pn.jsx(
      RB,
      {
        conversation: d,
        conversationContext: n
      },
      `${m}-${d?.id}`
    )),
    s && /* @__PURE__ */ pn.jsxs(
      Qn,
      {
        variant: "secondary",
        onClick: () => a(!i),
        children: [
          "Show ",
          i ? "less" : "all"
        ]
      }
    )
  ] });
}, OB = M5(
  /* GraphQL*/
  `
  query conversationsQuery($query: String) {
    Miuros {
      findTickets(query: $query, page_size: 10) {
        data {
          id
          labels
          subject
          messages {
            direction
            body
            agent {
              email
              name
            }
            created_at
          }
          custom_fields {
            additionalProperties {
              key
              value {
                value
              }
            }
          }
          created_at
        }
      }
    }
  }
`
), PB = ({
  conversationContext: e,
  settings: n
}) => {
  const [r, i] = me([]), a = Number.parseInt(n?.amountOfConversationsToShow) || 1, o = [
    e.customer?.email,
    e.customer?.phone_number
  ].filter((u) => !!u).map((u) => `'${u}'`).join(","), { useQuery: s } = fn(), { data: l, loading: d, error: m } = s(OB, {
    skip: o.length === 0,
    variables: {
      query: `requester_id=in=(${o})`
    }
  });
  return Xe(() => {
    if (l?.Miuros) {
      const u = l?.Miuros?.findTickets?.data;
      u && i(u);
    }
  }, [l]), m ? /* @__PURE__ */ pn.jsx($n, { error: m }) : d ? /* @__PURE__ */ pn.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ pn.jsx(sn, {}) }) : r?.length === 0 ? /* @__PURE__ */ pn.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: "No conversations found for this customer" }) : /* @__PURE__ */ pn.jsx(
    DB,
    {
      "data-testid": "conversation-list",
      conversationsToShow: a,
      conversations: r,
      conversationContext: e
    }
  );
}, Rl = [
  {
    key: "miurosClientId",
    label: "Authorization: Client ID",
    type: "string",
    secret: !1,
    defaultValue: ""
  },
  {
    key: "miurosClientSecret",
    label: "Authorization: Client secret",
    type: "string",
    secret: !0,
    defaultValue: ""
  },
  {
    key: "amountOfConversationsToShow",
    label: "Number of conversation to show before the fold",
    type: "string",
    secret: !1,
    defaultValue: "1"
  }
], Gm = ar(Rl), Ym = "MIUROS", AB = {
  enabled: !1,
  name: "",
  miurosClientId: "",
  miurosClientSecret: "",
  amountOfConversationsToShow: "1"
}, LB = ({
  integrationId: e,
  configuration: n,
  handleRedirect: r,
  showNotification: i,
  automationCouplingState: a,
  renderConditionsEditor: o
}) => {
  const s = !e, l = ot({
    mode: "onChange",
    defaultValues: AB
  }), {
    create: d,
    update: m,
    remove: u,
    isLoading: f,
    error: h,
    misconfigurationCause: v,
    setMisconfigurationCause: w
  } = pr({
    integrationId: e,
    integrationType: Ym,
    handleRedirect: r,
    showNotification: i
  }), {
    isLoading: N,
    error: j,
    isWidgetUnknown: _,
    refetch: g,
    widgetConfiguration: O
  } = fr({
    integrationId: e,
    fieldDefinitions: Rl,
    form: l,
    onMisconfigured: w
  }), { renderConditions: R, setRenderConditions: $, renderConditionsForSubmit: I } = hr({
    integrationId: e,
    widgetConfiguration: O,
    renderConditionsEditor: o
  }), L = (Q) => gr(Q, {
    fieldDefinitions: Rl,
    isCreationMode: s,
    create: d,
    update: m,
    renderConditions: I
  }), G = l.watch("name");
  return /* @__PURE__ */ pn.jsxs(
    yr,
    {
      form: l,
      integrationId: e,
      onValidSubmit: L,
      error: j ?? h,
      onRetry: j ? g : void 0,
      isLoading: f || N,
      isWidgetUnknown: _,
      children: [
        v && /* @__PURE__ */ pn.jsx(vr, { cause: v }),
        /* @__PURE__ */ pn.jsxs(et, { children: [
          /* @__PURE__ */ pn.jsx(Z, { children: /* @__PURE__ */ pn.jsx(qe, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ pn.jsx(
            yn,
            {
              name: "enabled",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ pn.jsx(Z, { span: 3, children: /* @__PURE__ */ pn.jsx(
            Rn,
            {
              name: "name",
              label: "Widget name",
              control: l.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ pn.jsx(Z, { span: 3 }),
          /* @__PURE__ */ pn.jsx(Z, { span: 3, children: /* @__PURE__ */ pn.jsx(
            Rn,
            {
              name: "miurosClientId",
              label: Gm.miurosClientId,
              control: l.control,
              rules: { required: "Client ID is required" },
              componentProps: {
                placeholder: "Insert client ID",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ pn.jsx(Z, { span: 3 }),
          /* @__PURE__ */ pn.jsx(Z, { span: 3, children: /* @__PURE__ */ pn.jsx(
            Er,
            {
              name: "miurosClientSecret",
              label: Gm.miurosClientSecret,
              control: l.control,
              isCreationMode: s,
              rules: { required: "Client secret is required" },
              componentProps: {
                placeholder: "Insert client secret",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ pn.jsx(Z, { span: 3 }),
          /* @__PURE__ */ pn.jsx(Z, { span: 3, children: /* @__PURE__ */ pn.jsx(
            Rn,
            {
              name: "amountOfConversationsToShow",
              label: Gm.amountOfConversationsToShow,
              control: l.control,
              rules: {
                required: "Please enter a number",
                validate: (Q) => !Number.isNaN(Number.parseInt(Q, 10)) || "Please enter a number"
              },
              componentProps: {
                placeholder: "Enter number",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ pn.jsx(Z, { span: 3 }),
          !s && e && /* @__PURE__ */ pn.jsx(
            bi,
            {
              configuration: n,
              integrationId: e,
              integrationType: Ym,
              label: "Authorize"
            }
          ),
          o && R !== null && /* @__PURE__ */ pn.jsx(Z, { children: o({
            value: R,
            onChange: $,
            configurationKey: O?.id
          }) })
        ] }),
        /* @__PURE__ */ pn.jsx(
          kr,
          {
            integrationType: Ym,
            integrationId: e,
            widgetName: G,
            isCreationMode: s,
            isSubmitting: l.formState.isSubmitting,
            automationCouplingState: a,
            onConfirmDelete: () => u()
          }
        )
      ]
    }
  );
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._list_18ybb_1{padding:0}._listItem_18ybb_4{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_18ybb_4:last-child{border-bottom:none}._copyIcon_18ybb_12{cursor:pointer;color:var(--dixa-typography-color-secondary)}._fullWidth_18ybb_17{width:100%}._wrapper_1nher_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._order_1dlaa_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._order_1dlaa_1:hover,._orderIsOpen_1dlaa_9{border-color:var(--dixa-color-neutral-400)}._orderHeader_1dlaa_12{cursor:pointer}._note_1dlaa_16{border:var(--dixa-size-border-100) dashed var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-200);max-height:100px;overflow-y:auto}._modal_1op1u_1{min-width:600px}._subscription_1xxl7_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._subscription_1xxl7_1:hover,._subscriptionIsOpen_1xxl7_9{border-color:var(--dixa-color-neutral-400)}._subscriptionHeader_1xxl7_12{cursor:pointer}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Jm = { exports: {} }, yo = {}, IS;
function VB() {
  if (IS) return yo;
  IS = 1;
  var e = He, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (v = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return yo.Fragment = r, yo.jsx = s, yo.jsxs = s, yo;
}
var Ds = {}, $S;
function zB() {
  return $S || ($S = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = He, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), d = /* @__PURE__ */ Symbol.for("react.forward_ref"), m = /* @__PURE__ */ Symbol.for("react.suspense"), u = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), v = /* @__PURE__ */ Symbol.for("react.offscreen"), w = Symbol.iterator, N = "@@iterator";
    function j(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = w && t[w] || t[N];
      return typeof c == "function" ? c : null;
    }
    var _ = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          p[y - 1] = arguments[y];
        O("error", t, p);
      }
    }
    function O(t, c, p) {
      {
        var y = _.ReactDebugCurrentFrame, C = y.getStackAddendum();
        C !== "" && (c += "%s", p = p.concat([C]));
        var T = p.map(function(S) {
          return String(S);
        });
        T.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, T);
      }
    }
    var R = !1, $ = !1, I = !1, L = !1, G = !1, Q;
    Q = /* @__PURE__ */ Symbol.for("react.module.reference");
    function ne(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || G || t === a || t === m || t === u || L || t === v || R || $ || I || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Q || t.getModuleId !== void 0));
    }
    function q(t, c, p) {
      var y = t.displayName;
      if (y)
        return y;
      var C = c.displayName || c.name || "";
      return C !== "" ? p + "(" + C + ")" : p;
    }
    function Y(t) {
      return t.displayName || "Context";
    }
    function P(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return Y(c) + ".Consumer";
          case s:
            var p = t;
            return Y(p._context) + ".Provider";
          case d:
            return q(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : P(t.type) || "Memo";
          case h: {
            var C = t, T = C._payload, S = C._init;
            try {
              return P(S(T));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var B = Object.assign, ie = 0, je, pe, le, ge, V, be, Oe;
    function H() {
    }
    H.__reactDisabledLog = !0;
    function Ye() {
      {
        if (ie === 0) {
          je = console.log, pe = console.info, le = console.warn, ge = console.error, V = console.group, be = console.groupCollapsed, Oe = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: H,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ie++;
      }
    }
    function ln() {
      {
        if (ie--, ie === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: B({}, t, {
              value: je
            }),
            info: B({}, t, {
              value: pe
            }),
            warn: B({}, t, {
              value: le
            }),
            error: B({}, t, {
              value: ge
            }),
            group: B({}, t, {
              value: V
            }),
            groupCollapsed: B({}, t, {
              value: be
            }),
            groupEnd: B({}, t, {
              value: Oe
            })
          });
        }
        ie < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Ie = _.ReactCurrentDispatcher, Ue;
    function De(t, c, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (C) {
            var y = C.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Be = !1, Ae;
    {
      var Qe = typeof WeakMap == "function" ? WeakMap : Map;
      Ae = new Qe();
    }
    function Ee(t, c) {
      if (!t || Be)
        return "";
      {
        var p = Ae.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Be = !0;
      var C = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var T;
      T = Ie.current, Ie.current = null, Ye();
      try {
        if (c) {
          var S = function() {
            throw Error();
          };
          if (Object.defineProperty(S.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(S, []);
            } catch (re) {
              y = re;
            }
            Reflect.construct(t, [], S);
          } else {
            try {
              S.call();
            } catch (re) {
              y = re;
            }
            t.call(S.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (re) {
            y = re;
          }
          t();
        }
      } catch (re) {
        if (re && y && typeof re.stack == "string") {
          for (var x = re.stack.split(`
`), ee = y.stack.split(`
`), A = x.length - 1, M = ee.length - 1; A >= 1 && M >= 0 && x[A] !== ee[M]; )
            M--;
          for (; A >= 1 && M >= 0; A--, M--)
            if (x[A] !== ee[M]) {
              if (A !== 1 || M !== 1)
                do
                  if (A--, M--, M < 0 || x[A] !== ee[M]) {
                    var ue = `
` + x[A].replace(" at new ", " at ");
                    return t.displayName && ue.includes("<anonymous>") && (ue = ue.replace("<anonymous>", t.displayName)), typeof t == "function" && Ae.set(t, ue), ue;
                  }
                while (A >= 1 && M >= 0);
              break;
            }
        }
      } finally {
        Be = !1, Ie.current = T, ln(), Error.prepareStackTrace = C;
      }
      var ze = t ? t.displayName || t.name : "", Te = ze ? De(ze) : "";
      return typeof t == "function" && Ae.set(t, Te), Te;
    }
    function Me(t, c, p) {
      return Ee(t, !1);
    }
    function en(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function se(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ee(t, en(t));
      if (typeof t == "string")
        return De(t);
      switch (t) {
        case m:
          return De("Suspense");
        case u:
          return De("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Me(t.render);
          case f:
            return se(t.type, c, p);
          case h: {
            var y = t, C = y._payload, T = y._init;
            try {
              return se(T(C), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var ce = Object.prototype.hasOwnProperty, Se = {}, Ve = _.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, p = se(t.type, t._source, c ? c.type : null);
        Ve.setExtraStackFrame(p);
      } else
        Ve.setExtraStackFrame(null);
    }
    function kn(t, c, p, y, C) {
      {
        var T = Function.call.bind(ce);
        for (var S in t)
          if (T(t, S)) {
            var x = void 0;
            try {
              if (typeof t[S] != "function") {
                var ee = Error((y || "React class") + ": " + p + " type `" + S + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[S] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ee.name = "Invariant Violation", ee;
              }
              x = t[S](c, S, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (A) {
              x = A;
            }
            x && !(x instanceof Error) && (Pe(C), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, S, typeof x), Pe(null)), x instanceof Error && !(x.message in Se) && (Se[x.message] = !0, Pe(C), g("Failed %s type: %s", p, x.message), Pe(null));
          }
      }
    }
    var X = Array.isArray;
    function E(t) {
      return X(t);
    }
    function z(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function ae(t) {
      try {
        return de(t), !1;
      } catch {
        return !0;
      }
    }
    function de(t) {
      return "" + t;
    }
    function U(t) {
      if (ae(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", z(t)), de(t);
    }
    var J = _.ReactCurrentOwner, ve = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, we, Re;
    function rn(t) {
      if (ce.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function bn(t) {
      if (ce.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function an(t, c) {
      typeof t.ref == "string" && J.current;
    }
    function hn(t, c) {
      {
        var p = function() {
          we || (we = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function En(t, c) {
      {
        var p = function() {
          Re || (Re = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var _n = function(t, c, p, y, C, T, S) {
      var x = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: S,
        // Record the component responsible for creating this element.
        _owner: T
      };
      return x._store = {}, Object.defineProperty(x._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(x, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(x, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: C
      }), Object.freeze && (Object.freeze(x.props), Object.freeze(x)), x;
    };
    function Fn(t, c, p, y, C) {
      {
        var T, S = {}, x = null, ee = null;
        p !== void 0 && (U(p), x = "" + p), bn(c) && (U(c.key), x = "" + c.key), rn(c) && (ee = c.ref, an(c));
        for (T in c)
          ce.call(c, T) && !ve.hasOwnProperty(T) && (S[T] = c[T]);
        if (t && t.defaultProps) {
          var A = t.defaultProps;
          for (T in A)
            S[T] === void 0 && (S[T] = A[T]);
        }
        if (x || ee) {
          var M = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          x && hn(S, M), ee && En(S, M);
        }
        return _n(t, x, ee, C, y, J.current, S);
      }
    }
    var Ze = _.ReactCurrentOwner, gn = _.ReactDebugCurrentFrame;
    function Le(t) {
      if (t) {
        var c = t._owner, p = se(t.type, t._source, c ? c.type : null);
        gn.setExtraStackFrame(p);
      } else
        gn.setExtraStackFrame(null);
    }
    var dn;
    dn = !1;
    function un(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function Nn() {
      {
        if (Ze.current) {
          var t = P(Ze.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Bn(t) {
      return "";
    }
    var Sn = {};
    function An(t) {
      {
        var c = Nn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function vn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = An(c);
        if (Sn[p])
          return;
        Sn[p] = !0;
        var y = "";
        t && t._owner && t._owner !== Ze.current && (y = " It was passed a child from " + P(t._owner.type) + "."), Le(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Le(null);
      }
    }
    function xn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (E(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            un(y) && vn(y, c);
          }
        else if (un(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var C = j(t);
          if (typeof C == "function" && C !== t.entries)
            for (var T = C.call(t), S; !(S = T.next()).done; )
              un(S.value) && vn(S.value, c);
        }
      }
    }
    function Ln(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var y = P(c);
          kn(p, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !dn) {
          dn = !0;
          var C = P(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", C || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var y = c[p];
          if (y !== "children" && y !== "key") {
            Le(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Le(null);
            break;
          }
        }
        t.ref !== null && (Le(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Le(null));
      }
    }
    var Cn = {};
    function wn(t, c, p, y, C, T) {
      {
        var S = ne(t);
        if (!S) {
          var x = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (x += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ee = Bn();
          ee ? x += ee : x += Nn();
          var A;
          t === null ? A = "null" : E(t) ? A = "array" : t !== void 0 && t.$$typeof === n ? (A = "<" + (P(t.type) || "Unknown") + " />", x = " Did you accidentally export a JSX literal instead of a component?") : A = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", A, x);
        }
        var M = Fn(t, c, p, C, T);
        if (M == null)
          return M;
        if (S) {
          var ue = c.children;
          if (ue !== void 0)
            if (y)
              if (E(ue)) {
                for (var ze = 0; ze < ue.length; ze++)
                  xn(ue[ze], t);
                Object.freeze && Object.freeze(ue);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              xn(ue, t);
        }
        if (ce.call(c, "key")) {
          var Te = P(t), re = Object.keys(c).filter(function(Gn) {
            return Gn !== "key";
          }), mn = re.length > 0 ? "{key: someKey, " + re.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Cn[Te + mn]) {
            var Dn = re.length > 0 ? "{" + re.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, mn, Te, Dn, Te), Cn[Te + mn] = !0;
          }
        }
        return t === i ? Vn(M) : Ln(M), M;
      }
    }
    function zn(t, c, p) {
      return wn(t, c, p, !0);
    }
    function qn(t, c, p) {
      return wn(t, c, p, !1);
    }
    var Un = qn, Kn = zn;
    Ds.Fragment = i, Ds.jsx = Un, Ds.jsxs = Kn;
  })()), Ds;
}
var ES;
function UB() {
  return ES || (ES = 1, process.env.NODE_ENV === "production" ? Jm.exports = VB() : Jm.exports = zB()), Jm.exports;
}
var K = UB();
const MB = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getAddresses" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Recharge" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getAddresses" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "customer_id" }, value: { kind: "Variable", name: { kind: "Name", value: "customerId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recharge_Addresses" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "addresses" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "payment_method_id" } }, { kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "country_code" } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "customer_id" } }, { kind: "Field", name: { kind: "Name", value: "discounts" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "value" } }, { kind: "Field", name: { kind: "Name", value: "value_type" } }] } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "order_attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "value" } }] } }, { kind: "Field", name: { kind: "Name", value: "order_note" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "presentment_currency" } }, { kind: "Field", name: { kind: "Name", value: "shipping_lines_conserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "price" } }] } }, { kind: "Field", name: { kind: "Name", value: "shipping_lines_override" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "price" } }] } }, { kind: "Field", name: { kind: "Name", value: "updated_at" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }] } }] } }] } }] } }] } }] }, BB = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getChargeById" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "id" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Recharge" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getChargeById" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "id" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recharge_Charge" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "charge" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "scheduled_at" } }, { kind: "Field", name: { kind: "Name", value: "processed_at" } }, { kind: "Field", name: { kind: "Name", value: "total_price" } }, { kind: "Field", name: { kind: "Name", value: "currency" } }, { kind: "Field", name: { kind: "Name", value: "line_items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "variant_title" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "unit_price" } }, { kind: "Field", name: { kind: "Name", value: "total_price" } }] } }] } }] } }] } }] } }] } }] }, qB = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCharges" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "subscriptionId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "status" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "limit" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Recharge" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getCharges" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "customer_id" }, value: { kind: "Variable", name: { kind: "Name", value: "customerId" } } }, { kind: "Argument", name: { kind: "Name", value: "subscription_id" }, value: { kind: "Variable", name: { kind: "Name", value: "subscriptionId" } } }, { kind: "Argument", name: { kind: "Name", value: "status" }, value: { kind: "Variable", name: { kind: "Name", value: "status" } } }, { kind: "Argument", name: { kind: "Name", value: "limit" }, value: { kind: "Variable", name: { kind: "Name", value: "limit" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recharge_Charges" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "charges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "scheduled_at" } }, { kind: "Field", name: { kind: "Name", value: "processed_at" } }, { kind: "Field", name: { kind: "Name", value: "total_price" } }, { kind: "Field", name: { kind: "Name", value: "currency" } }, { kind: "Field", name: { kind: "Name", value: "line_items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "variant_title" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "unit_price" } }, { kind: "Field", name: { kind: "Name", value: "total_price" } }] } }] } }] } }] } }] } }] } }] }, HB = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCustomerDetails" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Recharge" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getStore" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recharge_Store" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "store" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "external_platform" } }, { kind: "Field", name: { kind: "Name", value: "customer_portal_base_url" } }, { kind: "Field", name: { kind: "Name", value: "merchant_portal_base_url" } }, { kind: "Field", name: { kind: "Name", value: "identifier" } }, { kind: "Field", name: { kind: "Name", value: "checkout_platform" } }, { kind: "Field", name: { kind: "Name", value: "external_platform" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "getCustomers" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "email" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recharge_Customers" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "customers" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "updated_at" } }, { kind: "Field", name: { kind: "Name", value: "external_customer_id" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ecommerce" } }] } }, { kind: "Field", name: { kind: "Name", value: "subscriptions_active_count" } }, { kind: "Field", name: { kind: "Name", value: "subscriptions_total_count" } }, { kind: "Field", name: { kind: "Name", value: "has_valid_payment_method" } }, { kind: "Field", name: { kind: "Name", value: "hash" } }] } }] } }] } }] } }] } }] }, WB = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getOrders" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "limit" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "addressId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Recharge" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getOrders" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "customer_id" }, value: { kind: "Variable", name: { kind: "Name", value: "customerId" } } }, { kind: "Argument", name: { kind: "Name", value: "limit" }, value: { kind: "Variable", name: { kind: "Name", value: "limit" } } }, { kind: "Argument", name: { kind: "Name", value: "address_id" }, value: { kind: "Variable", name: { kind: "Name", value: "addressId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recharge_Orders" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orders" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "currency" } }, { kind: "Field", name: { kind: "Name", value: "is_prepaid" } }, { kind: "Field", name: { kind: "Name", value: "note" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "subtotal_price" } }, { kind: "Field", name: { kind: "Name", value: "total_discounts" } }, { kind: "Field", name: { kind: "Name", value: "total_duties" } }, { kind: "Field", name: { kind: "Name", value: "total_line_items_price" } }, { kind: "Field", name: { kind: "Name", value: "total_price" } }, { kind: "Field", name: { kind: "Name", value: "total_refunds" } }, { kind: "Field", name: { kind: "Name", value: "total_tax" } }, { kind: "Field", name: { kind: "Name", value: "total_weight_grams" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "charge" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "external_transaction_id" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "payment_processor" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "billing_address" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "country_code" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "province" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }] } }, { kind: "Field", name: { kind: "Name", value: "shipping_address" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "country_code" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "province" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }] } }] } }] } }] } }] } }] } }] }, KB = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getSubscriptionById" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "id" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Recharge" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getSubscriptionById" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "id" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recharge_Subscription_" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "subscription" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "product_title" } }, { kind: "Field", name: { kind: "Name", value: "variant_title" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "presentment_currency" } }, { kind: "Field", name: { kind: "Name", value: "is_prepaid" } }, { kind: "Field", name: { kind: "Name", value: "next_charge_scheduled_at" } }, { kind: "Field", name: { kind: "Name", value: "order_interval_frequency" } }, { kind: "Field", name: { kind: "Name", value: "order_interval_unit" } }, { kind: "Field", name: { kind: "Name", value: "charge_interval_frequency" } }, { kind: "Field", name: { kind: "Name", value: "cancellation_reason" } }, { kind: "Field", name: { kind: "Name", value: "cancelled_at" } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }] } }] } }] } }] } }] } }] }, GB = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getSubscriptions" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "status" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "limit" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Recharge" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getSubscriptions" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "customer_id" }, value: { kind: "Variable", name: { kind: "Name", value: "customerId" } } }, { kind: "Argument", name: { kind: "Name", value: "status" }, value: { kind: "Variable", name: { kind: "Name", value: "status" } } }, { kind: "Argument", name: { kind: "Name", value: "limit" }, value: { kind: "Variable", name: { kind: "Name", value: "limit" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recharge_Subscriptions" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "product_title" } }, { kind: "Field", name: { kind: "Name", value: "variant_title" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "presentment_currency" } }, { kind: "Field", name: { kind: "Name", value: "is_prepaid" } }, { kind: "Field", name: { kind: "Name", value: "is_skippable" } }, { kind: "Field", name: { kind: "Name", value: "is_swappable" } }, { kind: "Field", name: { kind: "Name", value: "next_charge_scheduled_at" } }, { kind: "Field", name: { kind: "Name", value: "order_interval_frequency" } }, { kind: "Field", name: { kind: "Name", value: "order_interval_unit" } }, { kind: "Field", name: { kind: "Name", value: "charge_interval_frequency" } }, { kind: "Field", name: { kind: "Name", value: "cancellation_reason" } }, { kind: "Field", name: { kind: "Name", value: "cancellation_reason_comments" } }, { kind: "Field", name: { kind: "Name", value: "cancelled_at" } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }] } }] } }] } }] } }] } }] }, YB = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "activateSubscription" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "id" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Recharge" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "activateSubscription" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "id" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "__typename" } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recharge_Subscription_" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "subscription" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "cancelled_at" } }, { kind: "Field", name: { kind: "Name", value: "cancellation_reason" } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recharge_BasicResponse" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, JB = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "cancelSubscription" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "id" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Recharge_SubscriptionCancelInput_Input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Recharge" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "cancelSubscription" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "id" } } }, { kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "__typename" } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recharge_Subscription_" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "subscription" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "cancelled_at" } }, { kind: "Field", name: { kind: "Name", value: "cancellation_reason" } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recharge_BasicResponse" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, QB = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "changeSubscriptionNextChargeDate" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "id" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Recharge_SubscriptionChangeNextChargeDateInput_Input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Recharge" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "changeSubscriptionNextChargeDate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "id" } } }, { kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "__typename" } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recharge_Subscription_" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "subscription" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "next_charge_scheduled_at" } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recharge_BasicResponse" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, XB = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "skipCharge" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "id" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Recharge_ChargeSkipInput_Input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Recharge" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "skipCharge" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "id" } } }, { kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "__typename" } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recharge_Charge" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "charge" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "scheduled_at" } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recharge_BasicResponse" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, ZB = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "unskipCharge" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "id" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Recharge_ChargeSkipInput_Input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Recharge" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "unskipCharge" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "id" } } }, { kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "__typename" } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recharge_Charge" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "charge" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "scheduled_at" } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recharge_BasicResponse" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, eq = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "updateSubscription" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "id" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Recharge_SubscriptionUpdateInput_Input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Recharge" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "updateSubscription" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "id" } } }, { kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "__typename" } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recharge_Subscription_" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "subscription" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "product_title" } }, { kind: "Field", name: { kind: "Name", value: "variant_title" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "next_charge_scheduled_at" } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recharge_BasicResponse" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, nq = {
  "\n  query getAddresses($customerId: String) {\n    Recharge {\n      getAddresses(customer_id: $customerId) {\n        ... on Recharge_Addresses {\n          addresses {\n            id\n            payment_method_id\n            address1\n            address2\n            city\n            company\n            country_code\n            created_at\n            customer_id\n            discounts {\n              id\n              code\n              value\n              value_type\n            }\n            first_name\n            last_name\n            order_attributes {\n              name\n              value\n            }\n            order_note\n            phone\n            presentment_currency\n            shipping_lines_conserved {\n              code\n              title\n              price\n            }\n            shipping_lines_override {\n              code\n              title\n              price\n            }\n            updated_at\n            zip\n          }\n        }\n      }\n    }\n  }\n": MB,
  "\n  query getChargeById($id: Int!) {\n    Recharge {\n      getChargeById(id: $id) {\n        ... on Recharge_Charge {\n          charge {\n            id\n            status\n            scheduled_at\n            processed_at\n            total_price\n            currency\n            line_items {\n              title\n              variant_title\n              quantity\n              unit_price\n              total_price\n            }\n          }\n        }\n      }\n    }\n  }\n": BB,
  "\n  query getCharges(\n    $customerId: String\n    $subscriptionId: String\n    $status: String\n    $limit: String\n  ) {\n    Recharge {\n      getCharges(\n        customer_id: $customerId\n        subscription_id: $subscriptionId\n        status: $status\n        limit: $limit\n      ) {\n        ... on Recharge_Charges {\n          charges {\n            id\n            status\n            scheduled_at\n            processed_at\n            total_price\n            currency\n            line_items {\n              title\n              variant_title\n              quantity\n              unit_price\n              total_price\n            }\n          }\n        }\n      }\n    }\n  }\n": qB,
  "\n  query getCustomerDetails($email: String) {\n    Recharge {\n      getStore {\n        ... on Recharge_Store {\n          store {\n            id\n            name\n            external_platform\n            customer_portal_base_url\n            merchant_portal_base_url\n            identifier\n            checkout_platform\n            external_platform\n          }\n        }\n      }\n      getCustomers(email: $email) {\n        ... on Recharge_Customers {\n          customers {\n            id\n            email\n            phone\n            first_name\n            last_name\n            created_at\n            updated_at\n            external_customer_id {\n              ecommerce\n            }\n            subscriptions_active_count\n            subscriptions_total_count\n            has_valid_payment_method\n            hash\n          }\n        }\n      }\n    }\n  }\n": HB,
  "\n  query getOrders($customerId: String, $limit: String, $addressId: String) {\n    Recharge {\n      getOrders(\n        customer_id: $customerId\n        limit: $limit\n        address_id: $addressId\n      ) {\n        ... on Recharge_Orders {\n          orders {\n            id\n            created_at\n            currency\n            is_prepaid\n            note\n            status\n            subtotal_price\n            total_discounts\n            total_duties\n            total_line_items_price\n            total_price\n            total_refunds\n            total_tax\n            total_weight_grams\n            type\n            charge {\n              external_transaction_id {\n                payment_processor\n              }\n            }\n            billing_address {\n              address1\n              address2\n              city\n              company\n              country_code\n              first_name\n              last_name\n              phone\n              province\n              zip\n            }\n            shipping_address {\n              address1\n              address2\n              city\n              company\n              country_code\n              first_name\n              last_name\n              phone\n              province\n              zip\n            }\n          }\n        }\n      }\n    }\n  }\n": WB,
  "\n  query getSubscriptionById($id: Int!) {\n    Recharge {\n      getSubscriptionById(id: $id) {\n        ... on Recharge_Subscription_ {\n          subscription {\n            id\n            status\n            product_title\n            variant_title\n            quantity\n            price\n            presentment_currency\n            is_prepaid\n            next_charge_scheduled_at\n            order_interval_frequency\n            order_interval_unit\n            charge_interval_frequency\n            cancellation_reason\n            cancelled_at\n            created_at\n          }\n        }\n      }\n    }\n  }\n": KB,
  "\n  query getSubscriptions($customerId: String, $status: String, $limit: String) {\n    Recharge {\n      getSubscriptions(\n        customer_id: $customerId\n        status: $status\n        limit: $limit\n      ) {\n        ... on Recharge_Subscriptions {\n          subscriptions {\n            id\n            status\n            product_title\n            variant_title\n            quantity\n            price\n            presentment_currency\n            is_prepaid\n            is_skippable\n            is_swappable\n            next_charge_scheduled_at\n            order_interval_frequency\n            order_interval_unit\n            charge_interval_frequency\n            cancellation_reason\n            cancellation_reason_comments\n            cancelled_at\n            created_at\n          }\n        }\n      }\n    }\n  }\n": GB,
  "\n  mutation activateSubscription($id: Int!) {\n    Recharge {\n      activateSubscription(id: $id) {\n        __typename\n        ... on Recharge_Subscription_ {\n          subscription {\n            id\n            status\n            cancelled_at\n            cancellation_reason\n          }\n        }\n        ... on Recharge_BasicResponse {\n          message\n        }\n      }\n    }\n  }\n": YB,
  "\n  mutation cancelSubscription(\n    $id: Int!\n    $input: Recharge_SubscriptionCancelInput_Input\n  ) {\n    Recharge {\n      cancelSubscription(id: $id, input: $input) {\n        __typename\n        ... on Recharge_Subscription_ {\n          subscription {\n            id\n            status\n            cancelled_at\n            cancellation_reason\n          }\n        }\n        ... on Recharge_BasicResponse {\n          message\n        }\n      }\n    }\n  }\n": JB,
  "\n  mutation changeSubscriptionNextChargeDate(\n    $id: Int!\n    $input: Recharge_SubscriptionChangeNextChargeDateInput_Input\n  ) {\n    Recharge {\n      changeSubscriptionNextChargeDate(id: $id, input: $input) {\n        __typename\n        ... on Recharge_Subscription_ {\n          subscription {\n            id\n            status\n            next_charge_scheduled_at\n          }\n        }\n        ... on Recharge_BasicResponse {\n          message\n        }\n      }\n    }\n  }\n": QB,
  "\n  mutation skipCharge($id: Int!, $input: Recharge_ChargeSkipInput_Input) {\n    Recharge {\n      skipCharge(id: $id, input: $input) {\n        __typename\n        ... on Recharge_Charge {\n          charge {\n            id\n            status\n            scheduled_at\n          }\n        }\n        ... on Recharge_BasicResponse {\n          message\n        }\n      }\n    }\n  }\n": XB,
  "\n  mutation unskipCharge($id: Int!, $input: Recharge_ChargeSkipInput_Input) {\n    Recharge {\n      unskipCharge(id: $id, input: $input) {\n        __typename\n        ... on Recharge_Charge {\n          charge {\n            id\n            status\n            scheduled_at\n          }\n        }\n        ... on Recharge_BasicResponse {\n          message\n        }\n      }\n    }\n  }\n": ZB,
  "\n  mutation updateSubscription(\n    $id: Int!\n    $input: Recharge_SubscriptionUpdateInput_Input\n  ) {\n    Recharge {\n      updateSubscription(id: $id, input: $input) {\n        __typename\n        ... on Recharge_Subscription_ {\n          subscription {\n            id\n            status\n            product_title\n            variant_title\n            price\n            quantity\n            next_charge_scheduled_at\n          }\n        }\n        ... on Recharge_BasicResponse {\n          message\n        }\n      }\n    }\n  }\n": eq
};
function li(e) {
  return nq[e] ?? {};
}
const tq = li(
  /* GraphQL */
  `
  query getCustomerDetails($email: String) {
    Recharge {
      getStore {
        ... on Recharge_Store {
          store {
            id
            name
            external_platform
            customer_portal_base_url
            merchant_portal_base_url
            identifier
            checkout_platform
            external_platform
          }
        }
      }
      getCustomers(email: $email) {
        ... on Recharge_Customers {
          customers {
            id
            email
            phone
            first_name
            last_name
            created_at
            updated_at
            external_customer_id {
              ecommerce
            }
            subscriptions_active_count
            subscriptions_total_count
            has_valid_payment_method
            hash
          }
        }
      }
    }
  }
`
), rq = li(
  /* GraphQL */
  `
  query getAddresses($customerId: String) {
    Recharge {
      getAddresses(customer_id: $customerId) {
        ... on Recharge_Addresses {
          addresses {
            id
            payment_method_id
            address1
            address2
            city
            company
            country_code
            created_at
            customer_id
            discounts {
              id
              code
              value
              value_type
            }
            first_name
            last_name
            order_attributes {
              name
              value
            }
            order_note
            phone
            presentment_currency
            shipping_lines_conserved {
              code
              title
              price
            }
            shipping_lines_override {
              code
              title
              price
            }
            updated_at
            zip
          }
        }
      }
    }
  }
`
), iq = li(
  /* GraphQL */
  `
  query getOrders($customerId: String, $limit: String, $addressId: String) {
    Recharge {
      getOrders(
        customer_id: $customerId
        limit: $limit
        address_id: $addressId
      ) {
        ... on Recharge_Orders {
          orders {
            id
            created_at
            currency
            is_prepaid
            note
            status
            subtotal_price
            total_discounts
            total_duties
            total_line_items_price
            total_price
            total_refunds
            total_tax
            total_weight_grams
            type
            charge {
              external_transaction_id {
                payment_processor
              }
            }
            billing_address {
              address1
              address2
              city
              company
              country_code
              first_name
              last_name
              phone
              province
              zip
            }
            shipping_address {
              address1
              address2
              city
              company
              country_code
              first_name
              last_name
              phone
              province
              zip
            }
          }
        }
      }
    }
  }
`
), aq = li(
  /* GraphQL */
  `
  query getSubscriptions($customerId: String, $status: String, $limit: String) {
    Recharge {
      getSubscriptions(
        customer_id: $customerId
        status: $status
        limit: $limit
      ) {
        ... on Recharge_Subscriptions {
          subscriptions {
            id
            status
            product_title
            variant_title
            quantity
            price
            presentment_currency
            is_prepaid
            is_skippable
            is_swappable
            next_charge_scheduled_at
            order_interval_frequency
            order_interval_unit
            charge_interval_frequency
            cancellation_reason
            cancellation_reason_comments
            cancelled_at
            created_at
          }
        }
      }
    }
  }
`
), oq = li(
  /* GraphQL */
  `
  query getCharges(
    $customerId: String
    $subscriptionId: String
    $status: String
    $limit: String
  ) {
    Recharge {
      getCharges(
        customer_id: $customerId
        subscription_id: $subscriptionId
        status: $status
        limit: $limit
      ) {
        ... on Recharge_Charges {
          charges {
            id
            status
            scheduled_at
            processed_at
            total_price
            currency
            line_items {
              title
              variant_title
              quantity
              unit_price
              total_price
            }
          }
        }
      }
    }
  }
`
), sq = li(
  /* GraphQL */
  `
  mutation cancelSubscription(
    $id: Int!
    $input: Recharge_SubscriptionCancelInput_Input
  ) {
    Recharge {
      cancelSubscription(id: $id, input: $input) {
        __typename
        ... on Recharge_Subscription_ {
          subscription {
            id
            status
            cancelled_at
            cancellation_reason
          }
        }
        ... on Recharge_BasicResponse {
          message
        }
      }
    }
  }
`
), lq = li(
  /* GraphQL */
  `
  mutation activateSubscription($id: Int!) {
    Recharge {
      activateSubscription(id: $id) {
        __typename
        ... on Recharge_Subscription_ {
          subscription {
            id
            status
            cancelled_at
            cancellation_reason
          }
        }
        ... on Recharge_BasicResponse {
          message
        }
      }
    }
  }
`
), cq = li(
  /* GraphQL */
  `
  mutation updateSubscription(
    $id: Int!
    $input: Recharge_SubscriptionUpdateInput_Input
  ) {
    Recharge {
      updateSubscription(id: $id, input: $input) {
        __typename
        ... on Recharge_Subscription_ {
          subscription {
            id
            status
            product_title
            variant_title
            price
            quantity
            next_charge_scheduled_at
          }
        }
        ... on Recharge_BasicResponse {
          message
        }
      }
    }
  }
`
), dq = li(
  /* GraphQL */
  `
  mutation skipCharge($id: Int!, $input: Recharge_ChargeSkipInput_Input) {
    Recharge {
      skipCharge(id: $id, input: $input) {
        __typename
        ... on Recharge_Charge {
          charge {
            id
            status
            scheduled_at
          }
        }
        ... on Recharge_BasicResponse {
          message
        }
      }
    }
  }
`
);
function by(e = !1, n) {
  const [r, i] = me(e);
  return Xe(() => {
    const a = r ? window.setTimeout(() => i(!1), 2e3) : void 0;
    return () => window.clearTimeout(a);
  }, [n, r]), { isCopied: r, copy: (a) => {
    navigator.clipboard.writeText(a), i(!0);
  } };
}
const cc = ({
  mutation: e,
  isSuccessful: n,
  successText: r,
  failureText: i,
  trackingAction: a,
  setIsMutationLoading: o,
  setIsOpen: s,
  refetchSubscriptions: l
}) => {
  const { track: d } = jn(), { useMutation: m, showNotification: u } = fn(), f = () => {
    o(!1), u({
      title: "Something went wrong",
      text: i,
      icon: "exclamation-triangle-filled",
      severity: "warning"
    }), s(!1);
  }, [h, v] = m(e, {
    onError: f,
    onCompleted: async (w) => {
      if (!n(w)) {
        f();
        return;
      }
      await l().catch(() => {
      }), o(!1), u({
        title: "Success",
        text: r,
        icon: "check-circle-filled",
        severity: "success"
      }), d(a), s(!1);
    }
  });
  return [(w) => h(w).catch(() => {
  }), v];
}, Y1 = (e) => `${e.charAt(0).toUpperCase()}${e.slice(1).toLowerCase()}`, dc = "DD MMM YYYY @ HH:mm", uq = "_list_18ybb_1", mq = "_listItem_18ybb_4", pq = "_copyIcon_18ybb_12", fq = "_fullWidth_18ybb_17", Vt = {
  list: uq,
  listItem: mq,
  copyIcon: pq,
  fullWidth: fq
}, _y = ({
  address: e,
  icon: n,
  title: r,
  isLoading: i = !1,
  hasMultipleAddresses: a = !1
}) => {
  const { isCopied: o, copy: s } = by(), l = 14, {
    first_name: d,
    last_name: m,
    address1: u,
    address2: f,
    city: h,
    zip: v,
    country_code: w
  } = e ?? {}, N = `${d} ${m}`.trim() || void 0, j = `${h} ${v}`.trim() || void 0, _ = [N, u, f, j, w].filter(
    Boolean
  );
  return /* @__PURE__ */ K.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
    /* @__PURE__ */ K.jsxs(b, { gap: "200", children: [
      /* @__PURE__ */ K.jsx(fe, { size: l, name: n }),
      i ? /* @__PURE__ */ K.jsx(sn, { size: l }) : /* @__PURE__ */ K.jsxs(b, { gap: "200", flexDirection: "column", children: [
        r && /* @__PURE__ */ K.jsx(F.Paragraph, { variant: "3", children: r }),
        /* @__PURE__ */ K.jsx(F.Paragraph, { variant: "4", children: _.map((g, O) => /* @__PURE__ */ K.jsx(ct, { children: g }, O)) })
      ] })
    ] }),
    !i && /* @__PURE__ */ K.jsxs(b, { gap: "100", children: [
      a && /* @__PURE__ */ K.jsx(Ge, { content: "The customer has multiple addresses, showing only the first here.", children: /* @__PURE__ */ K.jsx(
        fe,
        {
          size: l,
          name: "exclamation",
          className: Vt.copyIcon
        }
      ) }),
      /* @__PURE__ */ K.jsx(Ge, { content: `Copy ${r ? r.toLowerCase() : "address"}`, children: /* @__PURE__ */ K.jsx(
        fe,
        {
          size: l,
          name: o ? "done" : "copy",
          onClick: () => s(_.join(", ")),
          className: Vt.copyIcon
        }
      ) })
    ] })
  ] });
}, hq = "_wrapper_1nher_1", yq = {
  wrapper: hq
}, gq = ({
  customer: e,
  store: n
}) => {
  const { track: r } = jn(), { isCopied: i, copy: a } = by(), { isCopied: o, copy: s } = by(), { useQuery: l } = fn(), d = e?.id, {
    loading: m,
    error: u,
    data: f
  } = l(rq, {
    skip: !d,
    variables: {
      customerId: d?.toString()
    }
  }), h = f?.Recharge?.getAddresses, v = !m && h?.addresses?.[0] ? h.addresses[0] : void 0, w = (h?.addresses?.length ?? 0) > 1;
  if (Xe(() => {
    v && r("recharge:profile:received");
  }, [v, r]), u)
    return /* @__PURE__ */ K.jsx($n, { error: u });
  if (!e)
    return null;
  const {
    id: N,
    phone: j,
    email: _,
    first_name: g,
    last_name: O,
    created_at: R,
    has_valid_payment_method: $
  } = e, I = 14, L = n ? `https://${n.identifier}.admin.rechargeapps.com/merchant/customers/${N}` : null, G = `${g || ""} ${O || ""}`.trim() || "A customer has no name";
  return /* @__PURE__ */ K.jsx(b, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ K.jsxs(b, { className: yq.wrapper, gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ K.jsx(F.Heading, { variant: "heading-2", children: G }),
    R && /* @__PURE__ */ K.jsxs(b, { gap: "200", justifyContent: "space-between", margin: "0 0 200", children: [
      /* @__PURE__ */ K.jsx(F.Paragraph, { variant: "4", children: "Member since" }),
      /* @__PURE__ */ K.jsx(F.Paragraph, { variant: "4", children: Wn(R).format(dc) })
    ] }),
    _ && /* @__PURE__ */ K.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ K.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ K.jsx(fe, { size: I, name: "mail" }),
        /* @__PURE__ */ K.jsx(F.ExternalLink, { href: `mailto:${_}`, children: _ })
      ] }),
      /* @__PURE__ */ K.jsx(Ge, { content: "Copy email", children: /* @__PURE__ */ K.jsx(
        fe,
        {
          size: I,
          name: i ? "done" : "copy",
          onClick: () => a(_),
          className: Vt.copyIcon
        }
      ) })
    ] }),
    j && /* @__PURE__ */ K.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ K.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ K.jsx(fe, { size: I, name: "phone" }),
        /* @__PURE__ */ K.jsx(F.Paragraph, { variant: "4", children: j })
      ] }),
      /* @__PURE__ */ K.jsx(Ge, { content: "Copy phone number", children: /* @__PURE__ */ K.jsx(
        fe,
        {
          size: I,
          name: o ? "done" : "copy",
          onClick: () => s(j),
          className: Vt.copyIcon
        }
      ) })
    ] }),
    /* @__PURE__ */ K.jsx(
      _y,
      {
        address: v,
        icon: "home",
        isLoading: m,
        hasMultipleAddresses: w
      }
    ),
    /* @__PURE__ */ K.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ K.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ K.jsx(fe, { size: I, name: "credit-card" }),
        /* @__PURE__ */ K.jsx(F.Paragraph, { variant: "4", children: "Has valid payment method" })
      ] }),
      /* @__PURE__ */ K.jsx(
        fe,
        {
          size: I,
          name: $ ? "check-circle" : "close-circle-filled",
          color: $ ? "green.500" : "red.500"
        }
      )
    ] }),
    L && /* @__PURE__ */ K.jsxs(b, { alignItems: "center", gap: "200", children: [
      /* @__PURE__ */ K.jsx(fe, { size: I, name: "external-link" }),
      /* @__PURE__ */ K.jsx(
        F.ExternalLink,
        {
          href: L,
          target: "_blank",
          rel: "noreferrer",
          onClick: () => r("recharge:external:customer:overview:opened"),
          children: "View customer in Recharge"
        }
      )
    ] })
  ] }) });
}, vq = "_order_1dlaa_1", kq = "_orderIsOpen_1dlaa_9", bq = "_orderHeader_1dlaa_12", _q = "_note_1dlaa_16", Os = {
  order: vq,
  orderIsOpen: kq,
  orderHeader: bq,
  note: _q
}, xq = ({
  order: e,
  isOpenByDefault: n,
  store: r
}) => {
  const { track: i } = jn(), [a, o] = me(n), {
    id: s,
    status: l,
    charge: d,
    currency: m,
    note: u,
    created_at: f,
    billing_address: h,
    shipping_address: v,
    total_price: w,
    is_prepaid: N
  } = e, j = 14, _ = r ? `https://${r.identifier}.admin.rechargeapps.com/merchant/orders/${s}` : null, g = d?.external_transaction_id?.payment_processor || void 0;
  return /* @__PURE__ */ K.jsxs(
    b,
    {
      className: ut(Os.order, {
        [Os.orderIsOpen]: a
      }),
      gap: "200",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ K.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: Os.orderHeader,
            onClick: () => o(!a),
            children: [
              /* @__PURE__ */ K.jsxs(b, { gap: "100", flexDirection: "column", children: [
                f && /* @__PURE__ */ K.jsx(b, { alignItems: "center", children: /* @__PURE__ */ K.jsx(F.Paragraph, { variant: "4", children: Wn(f).format(dc) }) }),
                /* @__PURE__ */ K.jsxs(F.Paragraph, { variant: "1", children: [
                  "Order #",
                  s
                ] })
              ] }),
              /* @__PURE__ */ K.jsx(
                Xt,
                {
                  variant: "tertiary",
                  icon: a ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        a && /* @__PURE__ */ K.jsxs(b, { gap: "250", flexDirection: "column", margin: "200 0 0", children: [
          u && /* @__PURE__ */ K.jsx(Ge, { content: "Note", children: /* @__PURE__ */ K.jsx(
            F.Paragraph,
            {
              variant: "4",
              color: "secondary",
              className: Os.note,
              children: u
            }
          ) }),
          l && /* @__PURE__ */ K.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ K.jsx(fe, { size: j, name: "activity" }),
            /* @__PURE__ */ K.jsxs(b, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ K.jsx(F.Paragraph, { variant: "3", children: "Status" }),
              /* @__PURE__ */ K.jsx(F.Paragraph, { variant: "4", children: Y1(l) })
            ] })
          ] }),
          /* @__PURE__ */ K.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ K.jsx(fe, { size: j, name: "credit-card" }),
            /* @__PURE__ */ K.jsxs(b, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ K.jsx(F.Paragraph, { variant: "3", children: "Prepaid" }),
              /* @__PURE__ */ K.jsx(F.Paragraph, { variant: "4", children: N ? "Yes" : "No" })
            ] })
          ] }),
          g && /* @__PURE__ */ K.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ K.jsx(fe, { size: j, name: "cog" }),
            /* @__PURE__ */ K.jsxs(b, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ K.jsx(F.Paragraph, { variant: "3", children: "Payment processor" }),
              /* @__PURE__ */ K.jsx(F.Paragraph, { variant: "4", children: g })
            ] })
          ] }),
          /* @__PURE__ */ K.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ K.jsx(fe, { size: j, name: "chart-bar" }),
            /* @__PURE__ */ K.jsxs(b, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ K.jsx(F.Paragraph, { variant: "3", children: "Order value" }),
              /* @__PURE__ */ K.jsxs(F.Paragraph, { variant: "4", children: [
                w,
                " ",
                m
              ] })
            ] })
          ] }),
          /* @__PURE__ */ K.jsx(
            _y,
            {
              address: h,
              icon: "home",
              title: "Billing address"
            }
          ),
          /* @__PURE__ */ K.jsx(
            _y,
            {
              address: v,
              icon: "map-pin",
              title: "Shipping address"
            }
          ),
          _ && /* @__PURE__ */ K.jsx(
            Et,
            {
              variant: "secondary",
              style: {
                color: "var(--dixa-typography-color-link)",
                padding: "var(--dixa-size-spacer-100)"
              },
              navigate: () => window.open(_, "_blank")?.focus(),
              slotStart: /* @__PURE__ */ K.jsx(fe, { name: "external-link" }),
              onClick: () => i("recharge:external:order:opened"),
              children: "View order in Recharge"
            }
          )
        ] })
      ]
    }
  );
}, Sq = ({
  customerId: e,
  store: n
}) => {
  const { track: r } = jn(), { useQuery: i } = fn(), {
    loading: a,
    error: o,
    data: s
  } = i(iq, {
    skip: !e,
    variables: {
      customerId: e?.toString(),
      limit: "5"
    }
  }), l = s?.Recharge?.getOrders, d = !a && l?.orders && l.orders.length > 0 ? l.orders : [];
  if (!e)
    return null;
  if (o)
    return /* @__PURE__ */ K.jsx($n, { error: o });
  const m = n ? `https://${n.identifier}.admin.rechargeapps.com/merchant/orders/processed?limit=25` : null;
  return /* @__PURE__ */ K.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ K.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ K.jsx(F.Heading, { variant: "heading-3", children: "Customer orders" }),
      !a && /* @__PURE__ */ K.jsx(Pn, { variant: "success", size: "small", children: d.length })
    ] }),
    /* @__PURE__ */ K.jsxs(b, { gap: "200", flexDirection: "column", children: [
      a && /* @__PURE__ */ K.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ K.jsx(sn, {}) }),
      !a && d.length === 0 && /* @__PURE__ */ K.jsx(
        b,
        {
          justifyContent: "center",
          margin: "200 0 300 0",
          "data-testid": "widget-no-orders",
          children: /* @__PURE__ */ K.jsx(F.Paragraph, { color: "tertiary", children: "No orders found" })
        }
      ),
      !a && d.length > 0 && /* @__PURE__ */ K.jsx(b, { gap: "200", flexDirection: "column", children: d.map((u, f) => /* @__PURE__ */ K.jsx(
        xq,
        {
          order: u,
          isOpenByDefault: f === 0,
          store: n
        },
        `${f}-${u.id}`
      )) }),
      m && /* @__PURE__ */ K.jsx(
        Et,
        {
          variant: "secondary",
          style: {
            color: "var(--dixa-typography-color-link)",
            padding: "var(--dixa-size-spacer-100)"
          },
          navigate: () => window.open(m, "_blank")?.focus(),
          slotStart: /* @__PURE__ */ K.jsx(fe, { name: "external-link" }),
          onClick: () => r("recharge:external:orders:list:opened"),
          children: "View all orders in Recharge"
        }
      )
    ] })
  ] });
}, Nq = [
  "Too expensive",
  "Quality issues",
  "Switching product",
  "No longer needed",
  "Delivery issues",
  "Other"
], TS = {
  reason: null,
  comments: "",
  sendEmail: !0
}, jq = ({
  subscriptionId: e,
  productTitle: n,
  isOpen: r,
  setIsOpen: i,
  isMutationLoading: a,
  setIsMutationLoading: o,
  refetchSubscriptions: s
}) => {
  const l = ot({
    defaultValues: TS
  }), [d, { reset: m }] = cc({
    mutation: sq,
    isSuccessful: (h) => h.Recharge?.cancelSubscription?.__typename === "Recharge_Subscription_",
    successText: "The subscription got cancelled.",
    failureText: "Could not cancel the subscription.",
    trackingAction: "recharge:subscription:cancelled",
    setIsMutationLoading: o,
    setIsOpen: i,
    refetchSubscriptions: s
  }), u = pt(
    (h) => {
      h.reason != null && (o(!0), d({
        variables: {
          id: e,
          input: {
            cancellation_reason: h.reason,
            cancellation_reason_comments: h.comments || void 0,
            send_email: h.sendEmail
          }
        }
      }));
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [e]
  ), f = () => {
    i(!1), m(), l.reset(TS);
  };
  return /* @__PURE__ */ K.jsxs(ht, { isOpen: r, onClose: f, children: [
    /* @__PURE__ */ K.jsx(
      yt,
      {
        title: `Cancel subscription ${n}`,
        onClose: f
      }
    ),
    /* @__PURE__ */ K.jsx(gt, { children: /* @__PURE__ */ K.jsxs(et, { children: [
      /* @__PURE__ */ K.jsx(Z, { children: /* @__PURE__ */ K.jsx(
        mr,
        {
          control: l.control,
          label: "Reason",
          name: "reason",
          rules: {
            required: {
              value: !0,
              message: "Please select a reason"
            }
          },
          componentProps: {
            placeholder: "Select a reason",
            equalityFn: (h, v) => h === v,
            getItemTitleByValue: (h) => h ?? ""
          },
          children: Nq.map((h) => /* @__PURE__ */ K.jsx(mt.Item, { value: h, children: /* @__PURE__ */ K.jsx(F.Paragraph, { children: h }) }, h))
        }
      ) }),
      /* @__PURE__ */ K.jsx(Z, { children: /* @__PURE__ */ K.jsx(
        Rn,
        {
          name: "comments",
          label: "Comments (optional)",
          control: l.control
        }
      ) }),
      /* @__PURE__ */ K.jsx(Z, { children: /* @__PURE__ */ K.jsx(qe, { label: "Notify the customer by email", children: /* @__PURE__ */ K.jsx(yn, { control: l.control, name: "sendEmail" }) }) })
    ] }) }),
    /* @__PURE__ */ K.jsx(
      vt,
      {
        confirmProps: {
          disabled: !(l.formState.isValid && l.formState.isDirty),
          isLoading: a,
          loadingIndicator: /* @__PURE__ */ K.jsx(sn, { size: 16 })
        },
        confirmOnClick: l.handleSubmit(u),
        cancelOnClick: f,
        confirmName: "Cancel subscription",
        cancelName: "Back"
      }
    )
  ] });
}, wq = ({
  subscriptionId: e,
  productTitle: n,
  refetchSubscriptions: r
}) => {
  const [i, a] = me(!1), [o, s] = me(!1);
  return /* @__PURE__ */ K.jsxs(K.Fragment, { children: [
    /* @__PURE__ */ K.jsx(
      Ge,
      {
        content: "Cancel this subscription so it no longer creates future orders.",
        wrap: "div",
        wrapProps: { className: Vt.fullWidth },
        children: /* @__PURE__ */ K.jsx(
          Qn,
          {
            variant: "secondary",
            onClick: () => a(!0),
            isLoading: o,
            loadingIndicator: /* @__PURE__ */ K.jsx(sn, { size: 16 }),
            slotStart: /* @__PURE__ */ K.jsx(
              fe,
              {
                size: 14,
                name: "close-circle-filled",
                color: "red.500"
              }
            ),
            className: Vt.fullWidth,
            children: "Cancel"
          }
        )
      }
    ),
    /* @__PURE__ */ K.jsx(
      jq,
      {
        subscriptionId: e,
        productTitle: n,
        isOpen: i,
        setIsOpen: a,
        isMutationLoading: o,
        setIsMutationLoading: s,
        refetchSubscriptions: r
      }
    )
  ] });
}, Cq = ({
  subscriptionId: e,
  productTitle: n,
  isOpen: r,
  setIsOpen: i,
  isMutationLoading: a,
  setIsMutationLoading: o,
  refetchSubscriptions: s
}) => {
  const [l] = cc({
    mutation: lq,
    isSuccessful: (u) => u.Recharge?.activateSubscription?.__typename === "Recharge_Subscription_",
    successText: "The subscription got reactivated.",
    failureText: "Could not reactivate the subscription.",
    trackingAction: "recharge:subscription:reactivated",
    setIsMutationLoading: o,
    setIsOpen: i,
    refetchSubscriptions: s
  }), d = pt(
    () => {
      o(!0), l({
        variables: {
          id: e
        }
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [e]
  ), m = () => i(!1);
  return /* @__PURE__ */ K.jsxs(ht, { isOpen: r, onClose: m, children: [
    /* @__PURE__ */ K.jsx(
      yt,
      {
        title: `Reactivate subscription ${n}`,
        onClose: m
      }
    ),
    /* @__PURE__ */ K.jsx(gt, { children: /* @__PURE__ */ K.jsx(F.Paragraph, { children: "Reactivating resumes this subscription. The customer will be charged again on the regular schedule." }) }),
    /* @__PURE__ */ K.jsx(
      vt,
      {
        confirmProps: {
          isLoading: a,
          loadingIndicator: /* @__PURE__ */ K.jsx(sn, { size: 16 })
        },
        confirmOnClick: d,
        cancelOnClick: m,
        confirmName: "Reactivate subscription",
        cancelName: "Back"
      }
    )
  ] });
}, Fq = ({
  subscriptionId: e,
  productTitle: n,
  refetchSubscriptions: r
}) => {
  const [i, a] = me(!1), [o, s] = me(!1);
  return /* @__PURE__ */ K.jsxs(K.Fragment, { children: [
    /* @__PURE__ */ K.jsx(
      Ge,
      {
        content: "Reactivate this cancelled subscription so its orders start again.",
        wrap: "div",
        wrapProps: { className: Vt.fullWidth },
        children: /* @__PURE__ */ K.jsx(
          Qn,
          {
            variant: "secondary",
            onClick: () => a(!0),
            isLoading: o,
            loadingIndicator: /* @__PURE__ */ K.jsx(sn, { size: 16 }),
            slotStart: /* @__PURE__ */ K.jsx(
              fe,
              {
                size: 14,
                name: "check-circle-filled",
                color: "green.500"
              }
            ),
            className: Vt.fullWidth,
            children: "Reactivate"
          }
        )
      }
    ),
    /* @__PURE__ */ K.jsx(
      Cq,
      {
        subscriptionId: e,
        productTitle: n,
        isOpen: i,
        setIsOpen: a,
        isMutationLoading: o,
        setIsMutationLoading: s,
        refetchSubscriptions: r
      }
    )
  ] });
}, Iq = "QUEUED", $q = ({
  subscriptionId: e,
  productTitle: n,
  nextChargeDate: r,
  isOpen: i,
  setIsOpen: a,
  isMutationLoading: o,
  setIsMutationLoading: s,
  refetchSubscriptions: l
}) => {
  const { executeQuery: d, showNotification: m } = fn(), [u] = cc({
    mutation: dq,
    isSuccessful: (w) => w.Recharge?.skipCharge?.__typename === "Recharge_Charge",
    successText: "The next order was skipped.",
    failureText: "Could not skip the next order.",
    trackingAction: "recharge:subscription:order:skipped",
    setIsMutationLoading: s,
    setIsOpen: a,
    refetchSubscriptions: l
  }), f = (w) => {
    s(!1), m({
      title: "Something went wrong",
      text: w,
      icon: "exclamation-triangle-filled",
      severity: "warning"
    }), a(!1);
  }, h = pt(
    async () => {
      s(!0);
      try {
        const { data: w } = await d(oq, {
          subscriptionId: e.toString(),
          status: Iq,
          limit: "1"
        }), N = w?.Recharge?.getCharges?.charges?.[0]?.id;
        if (!N) {
          f("This subscription has no upcoming order to skip.");
          return;
        }
        u({
          variables: {
            id: N,
            // A subscription is a purchase item, so its id is the purchase item
            // id Recharge's skip endpoint expects.
            input: { purchase_item_ids: [e] }
          }
        });
      } catch {
        f("Could not skip the next order.");
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [e]
  ), v = () => a(!1);
  return /* @__PURE__ */ K.jsxs(ht, { isOpen: i, onClose: v, children: [
    /* @__PURE__ */ K.jsx(
      yt,
      {
        title: `Skip next order ${n}`,
        onClose: v
      }
    ),
    /* @__PURE__ */ K.jsx(gt, { children: /* @__PURE__ */ K.jsx(F.Paragraph, { children: r ? `This skips the upcoming order scheduled for ${Wn(
      r
    ).format(dc)}. The following order proceeds as normal.` : "This skips the next upcoming order. The following order proceeds as normal." }) }),
    /* @__PURE__ */ K.jsx(
      vt,
      {
        confirmProps: {
          isLoading: o,
          loadingIndicator: /* @__PURE__ */ K.jsx(sn, { size: 16 })
        },
        confirmOnClick: h,
        cancelOnClick: v,
        confirmName: "Skip next order",
        cancelName: "Back"
      }
    )
  ] });
}, Eq = ({
  subscriptionId: e,
  productTitle: n,
  nextChargeDate: r,
  disabled: i,
  refetchSubscriptions: a
}) => {
  const [o, s] = me(!1), [l, d] = me(!1);
  return /* @__PURE__ */ K.jsxs(K.Fragment, { children: [
    /* @__PURE__ */ K.jsx(
      Ge,
      {
        content: "Skip this subscription's next order. The following order proceeds as normal.",
        wrap: "div",
        wrapProps: { className: Vt.fullWidth },
        children: /* @__PURE__ */ K.jsx(
          Qn,
          {
            variant: "secondary",
            onClick: () => s(!0),
            disabled: i,
            isLoading: l,
            loadingIndicator: /* @__PURE__ */ K.jsx(sn, { size: 16 }),
            slotStart: /* @__PURE__ */ K.jsx(fe, { size: 14, name: "arrow-right" }),
            className: Vt.fullWidth,
            children: "Skip next"
          }
        )
      }
    ),
    /* @__PURE__ */ K.jsx(
      $q,
      {
        subscriptionId: e,
        productTitle: n,
        nextChargeDate: r,
        isOpen: o,
        setIsOpen: s,
        isMutationLoading: l,
        setIsMutationLoading: d,
        refetchSubscriptions: a
      }
    )
  ] });
}, Tq = "_modal_1op1u_1", Rq = {
  modal: Tq
}, Dq = ({
  subscriptionId: e,
  productTitle: n,
  isPrepaid: r,
  isOpen: i,
  setIsOpen: a,
  isMutationLoading: o,
  setIsMutationLoading: s,
  refetchSubscriptions: l
}) => {
  const d = {
    externalVariantId: "",
    productTitle: "",
    price: ""
  }, m = ot({
    defaultValues: d
  }), [u] = cc({
    mutation: cq,
    isSuccessful: (v) => v.Recharge?.updateSubscription?.__typename === "Recharge_Subscription_",
    successText: "The product was swapped.",
    failureText: "Could not swap the product.",
    trackingAction: "recharge:subscription:product:swapped",
    setIsMutationLoading: s,
    setIsOpen: a,
    refetchSubscriptions: l
  }), f = pt(
    (v) => {
      s(!0), u({
        variables: {
          id: e,
          input: {
            external_variant_id: { ecommerce: v.externalVariantId },
            product_title: v.productTitle || void 0,
            price: v.price ? Number(v.price) : void 0,
            // Prepaid subscriptions can only be swapped when `override` is set;
            // it is irrelevant otherwise, so derive it rather than exposing a
            // switch a user could wrongly turn off.
            override: r
          }
        }
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [e]
  ), h = () => {
    a(!1), m.reset(d);
  };
  return /* @__PURE__ */ K.jsxs(ht, { isOpen: i, onClose: h, className: Rq.modal, children: [
    /* @__PURE__ */ K.jsx(yt, { title: `Swap product ${n}`, onClose: h }),
    /* @__PURE__ */ K.jsx(gt, { children: /* @__PURE__ */ K.jsxs(et, { children: [
      /* @__PURE__ */ K.jsx(Z, { children: /* @__PURE__ */ K.jsx(
        Rn,
        {
          name: "externalVariantId",
          label: "New variant ID",
          control: m.control,
          rules: { required: "A variant ID is required" },
          componentProps: { placeholder: "External variant ID" }
        }
      ) }),
      /* @__PURE__ */ K.jsx(Z, { children: /* @__PURE__ */ K.jsx(
        Rn,
        {
          name: "productTitle",
          label: "Product title (optional)",
          control: m.control
        }
      ) }),
      /* @__PURE__ */ K.jsx(Z, { children: /* @__PURE__ */ K.jsx(
        Rn,
        {
          name: "price",
          label: "Price (optional)",
          control: m.control,
          rules: {
            validate: (v) => !v || !Number.isNaN(Number(v)) && Number(v) >= 0 || "Price must be zero or more"
          }
        }
      ) })
    ] }) }),
    /* @__PURE__ */ K.jsx(
      vt,
      {
        confirmProps: {
          disabled: !(m.formState.isValid && m.formState.isDirty),
          isLoading: o,
          loadingIndicator: /* @__PURE__ */ K.jsx(sn, { size: 16 })
        },
        confirmOnClick: m.handleSubmit(f),
        cancelOnClick: h,
        confirmName: "Swap product",
        cancelName: "Back"
      }
    )
  ] });
}, Oq = ({
  subscriptionId: e,
  productTitle: n,
  isPrepaid: r,
  disabled: i,
  refetchSubscriptions: a
}) => {
  const [o, s] = me(!1), [l, d] = me(!1);
  return /* @__PURE__ */ K.jsxs(K.Fragment, { children: [
    /* @__PURE__ */ K.jsx(
      Ge,
      {
        content: "Replace the product or variant on this subscription. Future orders will ship the new item instead.",
        wrap: "div",
        wrapProps: { className: Vt.fullWidth },
        children: /* @__PURE__ */ K.jsx(
          Qn,
          {
            variant: "secondary",
            onClick: () => s(!0),
            disabled: i,
            isLoading: l,
            loadingIndicator: /* @__PURE__ */ K.jsx(sn, { size: 16 }),
            slotStart: /* @__PURE__ */ K.jsx(fe, { size: 14, name: "exchange" }),
            className: Vt.fullWidth,
            children: "Swap"
          }
        )
      }
    ),
    /* @__PURE__ */ K.jsx(
      Dq,
      {
        subscriptionId: e,
        productTitle: n,
        isPrepaid: r,
        isOpen: o,
        setIsOpen: s,
        isMutationLoading: l,
        setIsMutationLoading: d,
        refetchSubscriptions: a
      }
    )
  ] });
}, Pq = "_subscription_1xxl7_1", Aq = "_subscriptionIsOpen_1xxl7_9", Lq = "_subscriptionHeader_1xxl7_12", Qm = {
  subscription: Pq,
  subscriptionIsOpen: Aq,
  subscriptionHeader: Lq
}, Vq = "CANCELLED", zq = ({
  subscription: e,
  isOpenByDefault: n,
  canCancel: r,
  canReactivate: i,
  canSkip: a,
  canSwap: o,
  store: s,
  refetchSubscriptions: l
}) => {
  const { track: d } = jn(), [m, u] = me(n), {
    id: f,
    status: h,
    product_title: v,
    variant_title: w,
    price: N,
    presentment_currency: j,
    is_prepaid: _,
    is_skippable: g,
    is_swappable: O,
    next_charge_scheduled_at: R,
    order_interval_frequency: $,
    order_interval_unit: I,
    cancellation_reason: L,
    cancellation_reason_comments: G,
    cancelled_at: Q
  } = e, ne = 14, q = h?.toUpperCase() === Vq || !!Q, Y = s && f ? `https://${s.identifier}.admin.rechargeapps.com/merchant/subscriptions/${f}/details` : null, P = $ && I ? `Every ${$} ${I}` : null, B = q ? i : r, ie = a || o, je = B || Y !== null;
  return /* @__PURE__ */ K.jsxs(
    b,
    {
      className: ut(Qm.subscription, {
        [Qm.subscriptionIsOpen]: m
      }),
      gap: "200",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ K.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: Qm.subscriptionHeader,
            onClick: () => u(!m),
            children: [
              /* @__PURE__ */ K.jsxs(b, { gap: "100", flexDirection: "column", children: [
                /* @__PURE__ */ K.jsxs(b, { gap: "200", alignItems: "center", children: [
                  /* @__PURE__ */ K.jsxs(F.Paragraph, { variant: "1", children: [
                    "Subscription #",
                    f
                  ] }),
                  q && /* @__PURE__ */ K.jsx(Pn, { variant: "error", size: "small", children: "Cancelled" })
                ] }),
                v && /* @__PURE__ */ K.jsx(F.Paragraph, { variant: "4", color: "secondary", children: v })
              ] }),
              /* @__PURE__ */ K.jsx(
                Xt,
                {
                  variant: "tertiary",
                  icon: m ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        m && /* @__PURE__ */ K.jsxs(b, { gap: "250", flexDirection: "column", margin: "200 0 0", children: [
          h && /* @__PURE__ */ K.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ K.jsx(fe, { size: ne, name: "activity" }),
            /* @__PURE__ */ K.jsxs(b, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ K.jsx(F.Paragraph, { variant: "3", children: "Status" }),
              /* @__PURE__ */ K.jsx(F.Paragraph, { variant: "4", children: Y1(h) })
            ] })
          ] }),
          w && /* @__PURE__ */ K.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ K.jsx(fe, { size: ne, name: "tag" }),
            /* @__PURE__ */ K.jsxs(b, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ K.jsx(F.Paragraph, { variant: "3", children: "Variant" }),
              /* @__PURE__ */ K.jsx(F.Paragraph, { variant: "4", children: w })
            ] })
          ] }),
          /* @__PURE__ */ K.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ K.jsx(fe, { size: ne, name: "chart-bar" }),
            /* @__PURE__ */ K.jsxs(b, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ K.jsx(F.Paragraph, { variant: "3", children: "Price" }),
              /* @__PURE__ */ K.jsxs(F.Paragraph, { variant: "4", children: [
                N,
                " ",
                j
              ] })
            ] })
          ] }),
          P && /* @__PURE__ */ K.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ K.jsx(fe, { size: ne, name: "sync" }),
            /* @__PURE__ */ K.jsxs(b, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ K.jsx(F.Paragraph, { variant: "3", children: "Frequency" }),
              /* @__PURE__ */ K.jsx(F.Paragraph, { variant: "4", children: P })
            ] })
          ] }),
          !q && R && /* @__PURE__ */ K.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ K.jsx(fe, { size: ne, name: "calendar" }),
            /* @__PURE__ */ K.jsxs(b, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ K.jsx(F.Paragraph, { variant: "3", children: "Next charge" }),
              /* @__PURE__ */ K.jsx(F.Paragraph, { variant: "4", children: Wn(R).format(dc) })
            ] })
          ] }),
          /* @__PURE__ */ K.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ K.jsx(fe, { size: ne, name: "credit-card" }),
            /* @__PURE__ */ K.jsxs(b, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ K.jsx(F.Paragraph, { variant: "3", children: "Prepaid" }),
              /* @__PURE__ */ K.jsx(F.Paragraph, { variant: "4", children: _ ? "Yes" : "No" })
            ] })
          ] }),
          q && L && /* @__PURE__ */ K.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ K.jsx(fe, { size: ne, name: "info" }),
            /* @__PURE__ */ K.jsxs(b, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ K.jsx(F.Paragraph, { variant: "3", children: L }),
              G && /* @__PURE__ */ K.jsx(F.Paragraph, { variant: "4", color: "secondary", children: /* @__PURE__ */ K.jsx("i", { children: G }) })
            ] })
          ] }),
          f && ie && /* @__PURE__ */ K.jsxs(b, { flexDirection: "row", gap: "200", children: [
            a && /* @__PURE__ */ K.jsx(
              b,
              {
                flexDirection: "column",
                style: { flex: 1, minWidth: 0 },
                children: /* @__PURE__ */ K.jsx(
                  Eq,
                  {
                    subscriptionId: f,
                    productTitle: v ?? `#${f}`,
                    nextChargeDate: R,
                    disabled: q || !g,
                    refetchSubscriptions: l
                  }
                )
              }
            ),
            o && /* @__PURE__ */ K.jsx(
              b,
              {
                flexDirection: "column",
                style: { flex: 1, minWidth: 0 },
                children: /* @__PURE__ */ K.jsx(
                  Oq,
                  {
                    subscriptionId: f,
                    productTitle: v ?? `#${f}`,
                    isPrepaid: !!_,
                    disabled: q || !O,
                    refetchSubscriptions: l
                  }
                )
              }
            )
          ] }),
          f && je && /* @__PURE__ */ K.jsxs(b, { flexDirection: "row", gap: "200", children: [
            B && /* @__PURE__ */ K.jsx(
              b,
              {
                flexDirection: "column",
                style: { flex: 1, minWidth: 0 },
                children: q ? /* @__PURE__ */ K.jsx(
                  Fq,
                  {
                    subscriptionId: f,
                    productTitle: v ?? `#${f}`,
                    refetchSubscriptions: l
                  }
                ) : /* @__PURE__ */ K.jsx(
                  wq,
                  {
                    subscriptionId: f,
                    productTitle: v ?? `#${f}`,
                    refetchSubscriptions: l
                  }
                )
              }
            ),
            Y && /* @__PURE__ */ K.jsx(
              b,
              {
                flexDirection: "column",
                style: { flex: 1, minWidth: 0 },
                children: /* @__PURE__ */ K.jsx(
                  Ge,
                  {
                    content: "Open this subscription in the Recharge merchant portal.",
                    wrap: "div",
                    wrapProps: { className: Vt.fullWidth },
                    children: /* @__PURE__ */ K.jsx(
                      Qn,
                      {
                        variant: "secondary",
                        onClick: () => {
                          window.open(Y, "_blank")?.focus(), d("recharge:external:subscription:opened");
                        },
                        slotStart: /* @__PURE__ */ K.jsx(fe, { name: "external-link" }),
                        className: Vt.fullWidth,
                        children: "Open"
                      }
                    )
                  }
                )
              }
            )
          ] })
        ] })
      ]
    }
  );
}, Uq = ({
  customerId: e,
  canCancel: n,
  canReactivate: r,
  canSkip: i,
  canSwap: a,
  store: o
}) => {
  const { track: s } = jn(), { useQuery: l } = fn(), {
    loading: d,
    error: m,
    data: u,
    refetch: f
  } = l(aq, {
    skip: !e,
    variables: {
      customerId: e?.toString(),
      limit: "10"
    }
  }), h = u?.Recharge?.getSubscriptions, v = !d && h?.subscriptions && h.subscriptions.length > 0 ? h.subscriptions : [];
  if (!e)
    return null;
  if (m)
    return /* @__PURE__ */ K.jsx($n, { error: m });
  const w = o ? `https://${o.identifier}.admin.rechargeapps.com/merchant/subscriptions` : null;
  return /* @__PURE__ */ K.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ K.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ K.jsx(F.Heading, { variant: "heading-3", children: "Subscriptions" }),
      !d && /* @__PURE__ */ K.jsx(Pn, { variant: "success", size: "small", children: v.length })
    ] }),
    /* @__PURE__ */ K.jsxs(b, { gap: "200", flexDirection: "column", children: [
      d && /* @__PURE__ */ K.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ K.jsx(sn, {}) }),
      !d && v.length === 0 && /* @__PURE__ */ K.jsx(
        b,
        {
          justifyContent: "center",
          margin: "200 0 300 0",
          "data-testid": "widget-no-subscriptions",
          children: /* @__PURE__ */ K.jsx(F.Paragraph, { color: "tertiary", children: "No subscriptions found" })
        }
      ),
      !d && v.length > 0 && /* @__PURE__ */ K.jsx(b, { gap: "200", flexDirection: "column", children: v.map((N, j) => /* @__PURE__ */ K.jsx(
        zq,
        {
          subscription: N,
          isOpenByDefault: j === 0,
          canCancel: n,
          canReactivate: r,
          canSkip: i,
          canSwap: a,
          store: o,
          refetchSubscriptions: f
        },
        `${j}-${N.id}`
      )) }),
      w && /* @__PURE__ */ K.jsx(
        Et,
        {
          variant: "secondary",
          style: {
            color: "var(--dixa-typography-color-link)",
            padding: "var(--dixa-size-spacer-100)"
          },
          navigate: () => window.open(w, "_blank")?.focus(),
          slotStart: /* @__PURE__ */ K.jsx(fe, { name: "external-link" }),
          onClick: () => s("recharge:external:subscriptions:list:opened"),
          children: "View all subscriptions in Recharge"
        }
      )
    ] })
  ] });
}, Mq = ({
  customer: e
}) => {
  if (!e)
    return null;
  const {
    subscriptions_active_count: n,
    subscriptions_total_count: r
  } = e, i = r ?? 0, a = n ?? 0;
  return /* @__PURE__ */ K.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ K.jsx(F.Heading, { variant: "heading-3", children: "Subscriptions overview" }),
    /* @__PURE__ */ K.jsxs(Je, { className: Vt.list, children: [
      /* @__PURE__ */ K.jsx(Je.Text, { variant: "dense", className: Vt.listItem, children: /* @__PURE__ */ K.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ K.jsx(F.Paragraph, { variant: "4", children: "Total subscriptions" }),
        /* @__PURE__ */ K.jsx(F.Paragraph, { variant: "4", children: i })
      ] }) }),
      /* @__PURE__ */ K.jsx(Je.Text, { variant: "dense", className: Vt.listItem, children: /* @__PURE__ */ K.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ K.jsx(F.Paragraph, { variant: "4", children: "Active subscriptions" }),
        /* @__PURE__ */ K.jsx(F.Paragraph, { variant: "4", children: a })
      ] }) })
    ] })
  ] });
}, Bq = ({
  conversationContext: e,
  settings: n
}) => {
  const { useQuery: r } = fn(), i = e?.customer?.email, a = n.displayCustomerDetails ?? !1, o = n.displaysubscriptionOverview ?? !1, s = n.displaySubscriptions ?? !1, l = n.enableCancelSubscription ?? !1, d = n.enableReactivateSubscription ?? !1, m = n.enableSkipOrder ?? !1, u = n.enableSwapProduct ?? !1, f = n.displayOrders ?? !1, h = !a && !o && !s && !f, {
    loading: v,
    error: w,
    data: N
  } = r(tq, {
    skip: !i,
    variables: {
      email: i
    }
  }), j = !v && N ? N?.Recharge?.getCustomers?.customers?.[0] : void 0, _ = !v && N ? N?.Recharge?.getStore?.store ?? void 0 : void 0;
  if (w) {
    const g = w.graphQLErrors;
    return Ml({ errors: g }) ? /* @__PURE__ */ K.jsx(
      F.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        "data-testid": "widget-downstream-api-forbidden-error",
        children: "The token used for the integration does not have the necessary access rights. Please contact your administrator."
      }
    ) : Bl({ errors: g }) ? /* @__PURE__ */ K.jsx(
      F.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        "data-testid": "widget-downstream-api-authorization-error",
        children: "The integration could not authorize against Recharge. Please contact your administrator."
      }
    ) : /* @__PURE__ */ K.jsx($n, { error: w });
  }
  return v ? /* @__PURE__ */ K.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ K.jsx(sn, {}) }) : j ? h ? /* @__PURE__ */ K.jsx(
    F.Paragraph,
    {
      margin: "200 0 300 0",
      color: "secondary",
      align: "center",
      "data-testid": "widget-no-features",
      children: "All features toggles in the settings are disabled."
    }
  ) : /* @__PURE__ */ K.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300 0",
      "data-testid": "widget-wrapper",
      children: [
        a && /* @__PURE__ */ K.jsx(gq, { customer: j, store: _ }),
        o && /* @__PURE__ */ K.jsx(Mq, { customer: j }),
        s && /* @__PURE__ */ K.jsx(
          Uq,
          {
            customerId: j.id,
            canCancel: l,
            canReactivate: d,
            canSkip: m,
            canSwap: u,
            store: _
          }
        ),
        f && /* @__PURE__ */ K.jsx(Sq, { customerId: j.id, store: _ })
      ]
    }
  ) : /* @__PURE__ */ K.jsx(
    F.Paragraph,
    {
      margin: "200 0 300 0",
      color: "secondary",
      align: "center",
      "data-testid": "widget-customer-not-found",
      children: "No data found for this customer in Recharge."
    }
  );
}, Ko = [
  {
    key: "rechargeAccessToken",
    label: "API token",
    type: "string",
    secret: !0,
    defaultValue: ""
  },
  {
    key: "displayCustomerDetails",
    label: "Displays details of a customer",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "displaysubscriptionOverview",
    label: "Displays the subscription overview",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "displaySubscriptions",
    label: "Displays the list of subscriptions",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "enableCancelSubscription",
    label: "Allows agents to cancel a subscription",
    type: "boolean",
    secret: !1,
    defaultValue: !1
  },
  {
    key: "enableReactivateSubscription",
    label: "Allows agents to reactivate a cancelled subscription",
    type: "boolean",
    secret: !1,
    defaultValue: !1
  },
  {
    key: "enableSkipOrder",
    label: "Allows agents to skip the next order of a subscription",
    type: "boolean",
    secret: !1,
    defaultValue: !1
  },
  {
    key: "enableSwapProduct",
    label: "Allows agents to swap the product of a subscription",
    type: "boolean",
    secret: !1,
    defaultValue: !1
  },
  {
    key: "displayOrders",
    label: "Displays the last 5 orders",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  }
], qq = [
  "enableCancelSubscription",
  "enableReactivateSubscription",
  "enableSkipOrder",
  "enableSwapProduct"
], ii = ar(Ko), J1 = {
  enabled: !1,
  name: "",
  rechargeAccessToken: "",
  ...Jo([], Ko)
}, Hq = {
  ...J1,
  ...qq.reduce(
    (e, n) => ({ ...e, [n]: !0 }),
    {}
  )
}, Wq = ({
  integrationId: e,
  handleRedirect: n,
  showNotification: r,
  automationCouplingState: i,
  renderConditionsEditor: a
}) => {
  const o = !e, s = ot({
    mode: "onChange",
    defaultValues: o ? Hq : J1
  }), {
    create: l,
    update: d,
    remove: m,
    isLoading: u,
    error: f,
    misconfigurationCause: h,
    setMisconfigurationCause: v
  } = pr({
    integrationId: e,
    integrationType: "RECHARGE",
    handleRedirect: n,
    showNotification: r
  }), {
    isLoading: w,
    error: N,
    isWidgetUnknown: j,
    refetch: _,
    widgetConfiguration: g
  } = fr({
    integrationId: e,
    fieldDefinitions: Ko,
    form: s,
    onMisconfigured: v
  }), { renderConditions: O, setRenderConditions: R, renderConditionsForSubmit: $ } = hr({
    integrationId: e,
    widgetConfiguration: g,
    renderConditionsEditor: a
  }), I = (G) => gr(G, {
    fieldDefinitions: Ko,
    isCreationMode: o,
    create: l,
    update: d,
    renderConditions: $
  }), L = s.watch("name");
  return /* @__PURE__ */ K.jsxs(
    yr,
    {
      form: s,
      integrationId: e,
      onValidSubmit: I,
      error: N ?? f,
      onRetry: N ? _ : void 0,
      isLoading: u || w,
      isWidgetUnknown: j,
      children: [
        h && /* @__PURE__ */ K.jsx(vr, { cause: h }),
        /* @__PURE__ */ K.jsxs(et, { children: [
          /* @__PURE__ */ K.jsx(Z, { children: /* @__PURE__ */ K.jsx(qe, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ K.jsx(
            yn,
            {
              name: "enabled",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ K.jsx(Z, { span: 3, children: /* @__PURE__ */ K.jsx(
            Rn,
            {
              name: "name",
              label: "Widget name",
              control: s.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ K.jsx(Z, { span: 3 }),
          /* @__PURE__ */ K.jsx(Z, { span: 3, children: /* @__PURE__ */ K.jsx(
            Er,
            {
              name: "rechargeAccessToken",
              label: ii.rechargeAccessToken,
              control: s.control,
              isCreationMode: o,
              rules: { required: "API token is required" },
              componentProps: {
                placeholder: "Insert the Admin API token for Recharge",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ K.jsx(Z, { span: 3 }),
          /* @__PURE__ */ K.jsx(Z, { span: 3, children: /* @__PURE__ */ K.jsx(qe, { label: ii.displayCustomerDetails, children: /* @__PURE__ */ K.jsx(
            yn,
            {
              name: "displayCustomerDetails",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ K.jsx(Z, { span: 3 }),
          /* @__PURE__ */ K.jsx(Z, { span: 3, children: /* @__PURE__ */ K.jsx(qe, { label: ii.displaysubscriptionOverview, children: /* @__PURE__ */ K.jsx(
            yn,
            {
              name: "displaysubscriptionOverview",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ K.jsx(Z, { span: 3 }),
          /* @__PURE__ */ K.jsx(Z, { span: 3, children: /* @__PURE__ */ K.jsx(qe, { label: ii.displaySubscriptions, children: /* @__PURE__ */ K.jsx(
            yn,
            {
              name: "displaySubscriptions",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ K.jsx(Z, { span: 3 }),
          /* @__PURE__ */ K.jsx(Z, { span: 3, children: /* @__PURE__ */ K.jsx(qe, { label: ii.enableCancelSubscription, children: /* @__PURE__ */ K.jsx(
            yn,
            {
              name: "enableCancelSubscription",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ K.jsx(Z, { span: 3 }),
          /* @__PURE__ */ K.jsx(Z, { span: 3, children: /* @__PURE__ */ K.jsx(qe, { label: ii.enableReactivateSubscription, children: /* @__PURE__ */ K.jsx(
            yn,
            {
              name: "enableReactivateSubscription",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ K.jsx(Z, { span: 3 }),
          /* @__PURE__ */ K.jsx(Z, { span: 3, children: /* @__PURE__ */ K.jsx(qe, { label: ii.enableSkipOrder, children: /* @__PURE__ */ K.jsx(
            yn,
            {
              name: "enableSkipOrder",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ K.jsx(Z, { span: 3 }),
          /* @__PURE__ */ K.jsx(Z, { span: 3, children: /* @__PURE__ */ K.jsx(qe, { label: ii.enableSwapProduct, children: /* @__PURE__ */ K.jsx(
            yn,
            {
              name: "enableSwapProduct",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ K.jsx(Z, { span: 3 }),
          /* @__PURE__ */ K.jsx(Z, { span: 3, children: /* @__PURE__ */ K.jsx(qe, { label: ii.displayOrders, children: /* @__PURE__ */ K.jsx(
            yn,
            {
              name: "displayOrders",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ K.jsx(Z, { span: 3 }),
          a && O !== null && /* @__PURE__ */ K.jsx(Z, { children: a({
            value: O,
            onChange: R,
            configurationKey: g?.id
          }) })
        ] }),
        /* @__PURE__ */ K.jsx(
          kr,
          {
            integrationType: "RECHARGE",
            integrationId: e,
            widgetName: L,
            isCreationMode: o,
            isSubmitting: s.formState.isSubmitting,
            automationCouplingState: i,
            onConfirmDelete: () => m()
          }
        )
      ]
    }
  );
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode('@charset "UTF-8";._wrapper_l5y5y_54{gap:var(--dixa-size-spacer-250);margin-bottom:var(--dixa-size-spacer-300)}._inputWrapper_l5y5y_59{background-color:var(--dixa-color-neutral-100);border-radius:var(--dixa-size-border-radius-100);margin:var(--dixa-size-spacer-300) 0;gap:var(--dixa-size-spacer-250);padding:var(--dixa-size-spacer-300)}._inputField_l5y5y_67{text-align:center}._inputSeparator_l5y5y_71{color:var(--dixa-color-neutral-600);text-align:center}._buttonLink_l5y5y_76{color:var(--dixa-typography-color-link)}._noIssuesFound_l5y5y_80{color:var(--dixa-color-neutral-400);font-size:var(--dixa-typography-size-200)}._list_l5y5y_85{padding:0;overflow-y:auto;max-height:230px;background:linear-gradient(var(--dixa-color-neutral-000) 33%,rgba(255,255,255,0)),linear-gradient(rgba(255,255,255,0),var(--dixa-color-neutral-000) 66%) 0 100%,radial-gradient(farthest-side at 50% 0,var(--dixa-color-neutral-200),rgba(0,0,0,0)),radial-gradient(farthest-side at 50% 100%,var(--dixa-color-neutral-200),rgba(0,0,0,0)) 0 100%;background-color:var(--dixa-color-neutral-000);background-repeat:no-repeat;background-attachment:local,local,scroll,scroll;background-size:100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-200),100% var(--dixa-size-spacer-200)}._listItem_l5y5y_95{background-color:transparent;padding:var(--dixa-size-spacer-100);box-shadow:inset 0 calc(-1 * var(--dixa-size-border-100)) 0 var(--dixa-color-neutral-200)}._listItem_l5y5y_95:last-child{box-shadow:none}._listItemHighlighted_l5y5y_103{border-left:var(--dixa-size-spacer-200) solid var(--dixa-color-orange-300)}._listItemEdit_l5y5y_106{cursor:pointer}._fullWidth_l5y5y_110{width:100%}._boxWrapper_l5y5y_114{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300)}._clickableIcon_l5y5y_120{cursor:pointer;color:var(--dixa-typography-color-secondary)}._wrapper_1xucg_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._externalLink_1xucg_7{color:var(--dixa-typography-color-primary);font-size:var(--dixa-typography-size-200)}._list_rxh85_1{padding:0;overflow-y:auto;max-height:230px}._listItem_rxh85_6{cursor:pointer;font-size:var(--dixa-typography-size-100);background-color:transparent;padding:var(--dixa-size-spacer-200) var(--dixa-size-spacer-100);box-shadow:inset 0 calc(-1 * var(--dixa-size-border-100)) 0 var(--dixa-color-neutral-200)}._listItem_rxh85_6:last-child{box-shadow:none}._listItemHighlighted_rxh85_16{border-left:var(--dixa-size-spacer-200) solid var(--dixa-color-orange-300)}._modalBody_1clhs_1{width:400px}._reward_1gmba_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._reward_1gmba_1:hover{border-color:var(--dixa-color-neutral-400)}._clickable_1gmba_10{cursor:pointer}._voucherCode_1gmba_14{font-family:monospace}')), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Xm = { exports: {} }, go = {}, RS;
function Kq() {
  if (RS) return go;
  RS = 1;
  var e = He, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (v = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return go.Fragment = r, go.jsx = s, go.jsxs = s, go;
}
var Ps = {}, DS;
function Gq() {
  return DS || (DS = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = He, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), d = /* @__PURE__ */ Symbol.for("react.forward_ref"), m = /* @__PURE__ */ Symbol.for("react.suspense"), u = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), v = /* @__PURE__ */ Symbol.for("react.offscreen"), w = Symbol.iterator, N = "@@iterator";
    function j(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = w && t[w] || t[N];
      return typeof c == "function" ? c : null;
    }
    var _ = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          p[y - 1] = arguments[y];
        O("error", t, p);
      }
    }
    function O(t, c, p) {
      {
        var y = _.ReactDebugCurrentFrame, C = y.getStackAddendum();
        C !== "" && (c += "%s", p = p.concat([C]));
        var T = p.map(function(S) {
          return String(S);
        });
        T.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, T);
      }
    }
    var R = !1, $ = !1, I = !1, L = !1, G = !1, Q;
    Q = /* @__PURE__ */ Symbol.for("react.module.reference");
    function ne(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || G || t === a || t === m || t === u || L || t === v || R || $ || I || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Q || t.getModuleId !== void 0));
    }
    function q(t, c, p) {
      var y = t.displayName;
      if (y)
        return y;
      var C = c.displayName || c.name || "";
      return C !== "" ? p + "(" + C + ")" : p;
    }
    function Y(t) {
      return t.displayName || "Context";
    }
    function P(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return Y(c) + ".Consumer";
          case s:
            var p = t;
            return Y(p._context) + ".Provider";
          case d:
            return q(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : P(t.type) || "Memo";
          case h: {
            var C = t, T = C._payload, S = C._init;
            try {
              return P(S(T));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var B = Object.assign, ie = 0, je, pe, le, ge, V, be, Oe;
    function H() {
    }
    H.__reactDisabledLog = !0;
    function Ye() {
      {
        if (ie === 0) {
          je = console.log, pe = console.info, le = console.warn, ge = console.error, V = console.group, be = console.groupCollapsed, Oe = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: H,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ie++;
      }
    }
    function ln() {
      {
        if (ie--, ie === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: B({}, t, {
              value: je
            }),
            info: B({}, t, {
              value: pe
            }),
            warn: B({}, t, {
              value: le
            }),
            error: B({}, t, {
              value: ge
            }),
            group: B({}, t, {
              value: V
            }),
            groupCollapsed: B({}, t, {
              value: be
            }),
            groupEnd: B({}, t, {
              value: Oe
            })
          });
        }
        ie < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Ie = _.ReactCurrentDispatcher, Ue;
    function De(t, c, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (C) {
            var y = C.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Be = !1, Ae;
    {
      var Qe = typeof WeakMap == "function" ? WeakMap : Map;
      Ae = new Qe();
    }
    function Ee(t, c) {
      if (!t || Be)
        return "";
      {
        var p = Ae.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Be = !0;
      var C = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var T;
      T = Ie.current, Ie.current = null, Ye();
      try {
        if (c) {
          var S = function() {
            throw Error();
          };
          if (Object.defineProperty(S.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(S, []);
            } catch (re) {
              y = re;
            }
            Reflect.construct(t, [], S);
          } else {
            try {
              S.call();
            } catch (re) {
              y = re;
            }
            t.call(S.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (re) {
            y = re;
          }
          t();
        }
      } catch (re) {
        if (re && y && typeof re.stack == "string") {
          for (var x = re.stack.split(`
`), ee = y.stack.split(`
`), A = x.length - 1, M = ee.length - 1; A >= 1 && M >= 0 && x[A] !== ee[M]; )
            M--;
          for (; A >= 1 && M >= 0; A--, M--)
            if (x[A] !== ee[M]) {
              if (A !== 1 || M !== 1)
                do
                  if (A--, M--, M < 0 || x[A] !== ee[M]) {
                    var ue = `
` + x[A].replace(" at new ", " at ");
                    return t.displayName && ue.includes("<anonymous>") && (ue = ue.replace("<anonymous>", t.displayName)), typeof t == "function" && Ae.set(t, ue), ue;
                  }
                while (A >= 1 && M >= 0);
              break;
            }
        }
      } finally {
        Be = !1, Ie.current = T, ln(), Error.prepareStackTrace = C;
      }
      var ze = t ? t.displayName || t.name : "", Te = ze ? De(ze) : "";
      return typeof t == "function" && Ae.set(t, Te), Te;
    }
    function Me(t, c, p) {
      return Ee(t, !1);
    }
    function en(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function se(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ee(t, en(t));
      if (typeof t == "string")
        return De(t);
      switch (t) {
        case m:
          return De("Suspense");
        case u:
          return De("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Me(t.render);
          case f:
            return se(t.type, c, p);
          case h: {
            var y = t, C = y._payload, T = y._init;
            try {
              return se(T(C), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var ce = Object.prototype.hasOwnProperty, Se = {}, Ve = _.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, p = se(t.type, t._source, c ? c.type : null);
        Ve.setExtraStackFrame(p);
      } else
        Ve.setExtraStackFrame(null);
    }
    function kn(t, c, p, y, C) {
      {
        var T = Function.call.bind(ce);
        for (var S in t)
          if (T(t, S)) {
            var x = void 0;
            try {
              if (typeof t[S] != "function") {
                var ee = Error((y || "React class") + ": " + p + " type `" + S + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[S] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ee.name = "Invariant Violation", ee;
              }
              x = t[S](c, S, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (A) {
              x = A;
            }
            x && !(x instanceof Error) && (Pe(C), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, S, typeof x), Pe(null)), x instanceof Error && !(x.message in Se) && (Se[x.message] = !0, Pe(C), g("Failed %s type: %s", p, x.message), Pe(null));
          }
      }
    }
    var X = Array.isArray;
    function E(t) {
      return X(t);
    }
    function z(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function ae(t) {
      try {
        return de(t), !1;
      } catch {
        return !0;
      }
    }
    function de(t) {
      return "" + t;
    }
    function U(t) {
      if (ae(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", z(t)), de(t);
    }
    var J = _.ReactCurrentOwner, ve = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, we, Re;
    function rn(t) {
      if (ce.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function bn(t) {
      if (ce.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function an(t, c) {
      typeof t.ref == "string" && J.current;
    }
    function hn(t, c) {
      {
        var p = function() {
          we || (we = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function En(t, c) {
      {
        var p = function() {
          Re || (Re = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var _n = function(t, c, p, y, C, T, S) {
      var x = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: S,
        // Record the component responsible for creating this element.
        _owner: T
      };
      return x._store = {}, Object.defineProperty(x._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(x, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(x, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: C
      }), Object.freeze && (Object.freeze(x.props), Object.freeze(x)), x;
    };
    function Fn(t, c, p, y, C) {
      {
        var T, S = {}, x = null, ee = null;
        p !== void 0 && (U(p), x = "" + p), bn(c) && (U(c.key), x = "" + c.key), rn(c) && (ee = c.ref, an(c));
        for (T in c)
          ce.call(c, T) && !ve.hasOwnProperty(T) && (S[T] = c[T]);
        if (t && t.defaultProps) {
          var A = t.defaultProps;
          for (T in A)
            S[T] === void 0 && (S[T] = A[T]);
        }
        if (x || ee) {
          var M = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          x && hn(S, M), ee && En(S, M);
        }
        return _n(t, x, ee, C, y, J.current, S);
      }
    }
    var Ze = _.ReactCurrentOwner, gn = _.ReactDebugCurrentFrame;
    function Le(t) {
      if (t) {
        var c = t._owner, p = se(t.type, t._source, c ? c.type : null);
        gn.setExtraStackFrame(p);
      } else
        gn.setExtraStackFrame(null);
    }
    var dn;
    dn = !1;
    function un(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function Nn() {
      {
        if (Ze.current) {
          var t = P(Ze.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Bn(t) {
      return "";
    }
    var Sn = {};
    function An(t) {
      {
        var c = Nn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function vn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = An(c);
        if (Sn[p])
          return;
        Sn[p] = !0;
        var y = "";
        t && t._owner && t._owner !== Ze.current && (y = " It was passed a child from " + P(t._owner.type) + "."), Le(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Le(null);
      }
    }
    function xn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (E(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            un(y) && vn(y, c);
          }
        else if (un(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var C = j(t);
          if (typeof C == "function" && C !== t.entries)
            for (var T = C.call(t), S; !(S = T.next()).done; )
              un(S.value) && vn(S.value, c);
        }
      }
    }
    function Ln(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var y = P(c);
          kn(p, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !dn) {
          dn = !0;
          var C = P(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", C || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var y = c[p];
          if (y !== "children" && y !== "key") {
            Le(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Le(null);
            break;
          }
        }
        t.ref !== null && (Le(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Le(null));
      }
    }
    var Cn = {};
    function wn(t, c, p, y, C, T) {
      {
        var S = ne(t);
        if (!S) {
          var x = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (x += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ee = Bn();
          ee ? x += ee : x += Nn();
          var A;
          t === null ? A = "null" : E(t) ? A = "array" : t !== void 0 && t.$$typeof === n ? (A = "<" + (P(t.type) || "Unknown") + " />", x = " Did you accidentally export a JSX literal instead of a component?") : A = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", A, x);
        }
        var M = Fn(t, c, p, C, T);
        if (M == null)
          return M;
        if (S) {
          var ue = c.children;
          if (ue !== void 0)
            if (y)
              if (E(ue)) {
                for (var ze = 0; ze < ue.length; ze++)
                  xn(ue[ze], t);
                Object.freeze && Object.freeze(ue);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              xn(ue, t);
        }
        if (ce.call(c, "key")) {
          var Te = P(t), re = Object.keys(c).filter(function(Gn) {
            return Gn !== "key";
          }), mn = re.length > 0 ? "{key: someKey, " + re.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Cn[Te + mn]) {
            var Dn = re.length > 0 ? "{" + re.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, mn, Te, Dn, Te), Cn[Te + mn] = !0;
          }
        }
        return t === i ? Vn(M) : Ln(M), M;
      }
    }
    function zn(t, c, p) {
      return wn(t, c, p, !0);
    }
    function qn(t, c, p) {
      return wn(t, c, p, !1);
    }
    var Un = qn, Kn = zn;
    Ps.Fragment = i, Ps.jsx = Un, Ps.jsxs = Kn;
  })()), Ps;
}
var OS;
function Yq() {
  return OS || (OS = 1, process.env.NODE_ENV === "production" ? Xm.exports = Kq() : Xm.exports = Gq()), Xm.exports;
}
var _e = Yq(), Q1 = /* @__PURE__ */ ((e) => (e.CustomAction = "custom_action", e.FacebookLike = "facebook_like", e.FacebookShare = "facebook_share", e.InstagramFollow = "instagram_follow", e.Manual = "manual", e.ReferralComplete = "referral_complete", e.TiktokFollow = "tiktok_follow", e.TwitterFollow = "twitter_follow", e.TwitterShare = "twitter_share", e.VisitUrl = "visit_url", e))(Q1 || {}), ba = /* @__PURE__ */ ((e) => (e.Excluded = "excluded", e.Guest = "guest", e.Member = "member", e))(ba || {});
const Jq = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "adjustCustomerPoints" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NamedType", name: { kind: "Name", value: "RivoLoyalty_adjust_customer_points_request_Input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "RivoLoyalty" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "adjust_customer_points" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }] }] } }] } }] }, Qq = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCustomer" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "RivoLoyalty" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "return_customer" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "customer_identifier" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }, { kind: "Argument", name: { kind: "Name", value: "fields" }, value: { kind: "StringValue", value: "lifetime_earnings_tally,next_vip_tier", block: !1 } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "accepts_marketing" } }, { kind: "Field", name: { kind: "Name", value: "orders_count" } }, { kind: "Field", name: { kind: "Name", value: "verified_email" } }, { kind: "Field", name: { kind: "Name", value: "total_spent" } }, { kind: "Field", name: { kind: "Name", value: "loyalty_status" } }, { kind: "Field", name: { kind: "Name", value: "points_tally" } }, { kind: "Field", name: { kind: "Name", value: "credits_tally" } }, { kind: "Field", name: { kind: "Name", value: "vip_tier" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "threshold" } }] } }, { kind: "Field", name: { kind: "Name", value: "points_expire_at" } }, { kind: "Field", name: { kind: "Name", value: "next_vip_tier" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "threshold" } }, { kind: "Field", name: { kind: "Name", value: "to_spend_or_earn" } }] } }, { kind: "Field", name: { kind: "Name", value: "lifetime_earnings_tally" } }] } }] } }] } }] } }] } }] }, Xq = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getFavoriteProducts" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "RivoLoyalty" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "list_customer_favorite_products" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "customer_id" }, value: { kind: "Variable", name: { kind: "Name", value: "customerId" } } }, { kind: "Argument", name: { kind: "Name", value: "data_source" }, value: { kind: "EnumValue", value: "shopify" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "product_id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "handle" } }] } }] } }] } }] } }] }, Zq = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getPointsRedemptions" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "RivoLoyalty" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "list_points_redemptions" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filters_LEFT_SQUARE_BRACE_customer_identifier_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "customerId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "points_amount" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "expires_at" } }, { kind: "Field", name: { kind: "Name", value: "used_at" } }, { kind: "Field", name: { kind: "Name", value: "refunded_at" } }, { kind: "Field", name: { kind: "Name", value: "revoked_at" } }] } }] } }] } }] } }] } }] }, e6 = {
  "\n  mutation adjustCustomerPoints(\n    $input: RivoLoyalty_adjust_customer_points_request_Input\n  ) {\n    RivoLoyalty {\n      adjust_customer_points(input: $input)\n    }\n  }\n": Jq,
  '\n  query getCustomer($email: String!) {\n    RivoLoyalty {\n      return_customer(\n        customer_identifier: $email\n        fields: "lifetime_earnings_tally,next_vip_tier"\n      ) {\n        data {\n          attributes {\n            id\n            email\n            first_name\n            last_name\n            accepts_marketing\n            orders_count\n            verified_email\n            total_spent\n            loyalty_status\n            points_tally\n            credits_tally\n            vip_tier {\n              name\n              threshold\n            }\n            points_expire_at\n            next_vip_tier {\n              name\n              threshold\n              to_spend_or_earn\n            }\n            lifetime_earnings_tally\n          }\n        }\n      }\n    }\n  }\n': Qq,
  "\n  query getFavoriteProducts($customerId: String!) {\n    RivoLoyalty {\n      list_customer_favorite_products(\n        customer_id: $customerId\n        data_source: shopify\n      ) {\n        data {\n          product_id\n          title\n          handle\n        }\n      }\n    }\n  }\n": Xq,
  "\n  query getPointsRedemptions($customerId: String!) {\n    RivoLoyalty {\n      list_points_redemptions(\n        filters_LEFT_SQUARE_BRACE_customer_identifier_RIGHT_SQUARE_BRACE_: $customerId\n      ) {\n        data {\n          id\n          attributes {\n            points_amount\n            name\n            code\n            expires_at\n            used_at\n            refunded_at\n            revoked_at\n          }\n        }\n      }\n    }\n  }\n": Zq
};
function uc(e) {
  return e6[e] ?? {};
}
const n6 = uc(
  /* GraphQL */
  `
  query getCustomer($email: String!) {
    RivoLoyalty {
      return_customer(
        customer_identifier: $email
        fields: "lifetime_earnings_tally,next_vip_tier"
      ) {
        data {
          attributes {
            id
            email
            first_name
            last_name
            accepts_marketing
            orders_count
            verified_email
            total_spent
            loyalty_status
            points_tally
            credits_tally
            vip_tier {
              name
              threshold
            }
            points_expire_at
            next_vip_tier {
              name
              threshold
              to_spend_or_earn
            }
            lifetime_earnings_tally
          }
        }
      }
    }
  }
`
), t6 = uc(
  /* GraphQL */
  `
  query getFavoriteProducts($customerId: String!) {
    RivoLoyalty {
      list_customer_favorite_products(
        customer_id: $customerId
        data_source: shopify
      ) {
        data {
          product_id
          title
          handle
        }
      }
    }
  }
`
), r6 = uc(
  /* GraphQL */
  `
  query getPointsRedemptions($customerId: String!) {
    RivoLoyalty {
      list_points_redemptions(
        filters_LEFT_SQUARE_BRACE_customer_identifier_RIGHT_SQUARE_BRACE_: $customerId
      ) {
        data {
          id
          attributes {
            points_amount
            name
            code
            expires_at
            used_at
            refunded_at
            revoked_at
          }
        }
      }
    }
  }
`
), i6 = uc(
  /* GraphQL */
  `
  mutation adjustCustomerPoints(
    $input: RivoLoyalty_adjust_customer_points_request_Input
  ) {
    RivoLoyalty {
      adjust_customer_points(input: $input)
    }
  }
`
), a6 = "_list_l5y5y_85", o6 = "_listItem_l5y5y_95", s6 = "_listItemHighlighted_l5y5y_103", l6 = "_listItemEdit_l5y5y_106", c6 = "_clickableIcon_l5y5y_120", Fr = {
  list: a6,
  listItem: o6,
  listItemHighlighted: s6,
  listItemEdit: l6,
  clickableIcon: c6
}, mc = "rivoLoyaltyShopifyApiHostName", X1 = "https://admin.shopify.com";
function Z1(e) {
  return e.split(".")[0];
}
const d6 = "_wrapper_1xucg_1", PS = {
  wrapper: d6
}, u6 = ({
  customerDetails: e,
  rivoLoyaltyShopifyApiHostName: n
}) => {
  const { track: r } = jn(), { isCopied: i, copy: a } = Qt(), { attributes: o } = e, {
    first_name: s,
    last_name: l,
    email: d,
    verified_email: m
  } = o, u = 14, f = `${s || ""} ${l || ""}`.trim() || "No name found for customer";
  return /* @__PURE__ */ _e.jsx(b, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ _e.jsxs(b, { className: PS.wrapper, gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ _e.jsx(
      b,
      {
        justifyContent: "space-between",
        className: PS.block,
        alignItems: "center",
        children: /* @__PURE__ */ _e.jsx(F.Heading, { variant: "heading-2", children: f })
      }
    ),
    d && /* @__PURE__ */ _e.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
      /* @__PURE__ */ _e.jsxs(b, { alignItems: "center", gap: "200", children: [
        /* @__PURE__ */ _e.jsx(fe, { size: u, name: "mail" }),
        /* @__PURE__ */ _e.jsx(F.ExternalLink, { href: `mailto:${d}`, children: d }),
        /* @__PURE__ */ _e.jsx(
          Ge,
          {
            content: m ? "Verified email" : "Email is not verified",
            children: /* @__PURE__ */ _e.jsx(b, { alignItems: "center", children: /* @__PURE__ */ _e.jsx(
              fe,
              {
                size: u,
                color: m ? "green.500" : "red.500",
                name: m ? "check-circle" : "exclamation"
              }
            ) })
          }
        )
      ] }),
      /* @__PURE__ */ _e.jsx(Ge, { content: "Copy Email", children: /* @__PURE__ */ _e.jsx(
        fe,
        {
          size: u,
          name: i ? "done" : "copy",
          onClick: () => a(d),
          className: Fr.clickableIcon
        }
      ) })
    ] }),
    /* @__PURE__ */ _e.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ _e.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ _e.jsx(fe, { size: u, name: "sign-in" }),
        /* @__PURE__ */ _e.jsx(F.Paragraph, { variant: "2", children: "Marketing consent" })
      ] }),
      /* @__PURE__ */ _e.jsx(
        fe,
        {
          name: o.accepts_marketing ? "check-circle-filled" : "close-circle-filled",
          color: o.accepts_marketing ? "green.500" : "neutral.500"
        }
      )
    ] }),
    /* @__PURE__ */ _e.jsxs(b, { alignItems: "center", gap: "200", children: [
      /* @__PURE__ */ _e.jsx(fe, { size: u, name: "external-link" }),
      /* @__PURE__ */ _e.jsx(
        F.ExternalLink,
        {
          href: m6(n, o.id),
          target: "_blank",
          rel: "noreferrer",
          onClick: () => {
            r("rivoloyalty:customer:clicked", {});
          },
          children: "View customer in Rivo Loyalty"
        }
      )
    ] })
  ] }) });
};
function m6(e, n) {
  const r = Z1(e);
  return `${X1}/store/${r}/apps/rivo-loyalty/customers/${n}`;
}
const p6 = "_list_rxh85_1", f6 = "_listItem_rxh85_6", AS = {
  list: p6,
  listItem: f6
}, h6 = ({
  customerId: e,
  rivoLoyaltyShopifyApiHostName: n
}) => {
  const { useQuery: r } = fn(), {
    loading: i,
    error: a,
    data: o
  } = r(t6, {
    skip: !e,
    variables: {
      customerId: e?.toString()
    }
  }), s = !i && o ? o.RivoLoyalty?.list_customer_favorite_products?.data ?? [] : [], l = 14, d = () => a ? /* @__PURE__ */ _e.jsx($n, { error: a }) : i ? /* @__PURE__ */ _e.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ _e.jsx(sn, {}) }) : s.length === 0 ? /* @__PURE__ */ _e.jsx(F.Paragraph, { variant: "4", color: "secondary", children: "No favorite products found." }) : /* @__PURE__ */ _e.jsx(Je, { className: AS.list, children: s.map((m) => /* @__PURE__ */ _e.jsxs(
    b,
    {
      alignItems: "center",
      gap: "200",
      className: AS.listItem,
      children: [
        /* @__PURE__ */ _e.jsx(fe, { size: l, name: "external-link" }),
        /* @__PURE__ */ _e.jsx(
          F.ExternalLink,
          {
            href: y6(
              n,
              m.product_id
            ),
            target: "_blank",
            rel: "noreferrer",
            children: m.title
          }
        )
      ]
    },
    m.product_id
  )) });
  return /* @__PURE__ */ _e.jsx(_e.Fragment, { children: /* @__PURE__ */ _e.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ _e.jsx(F.Heading, { variant: "heading-3", children: "Favorite products" }),
    d()
  ] }) });
};
function y6(e, n) {
  const r = Z1(e);
  return `${X1}/store/${r}/products/${n}`;
}
const g6 = "_modalBody_1clhs_1", v6 = {
  modalBody: g6
};
function k6(e, n) {
  if (isNaN(e))
    return "Points can not be empty";
  if (e < n.min)
    return `Points cannot be below ${n.min}`;
  if (e > n.max)
    return `Points can not exceed ${n.max}`;
}
function b6(e, n) {
  if (e === n)
    return "Change the value to update the points";
}
const _6 = Q1, As = {
  addPoints: {
    successEventName: "rivoloyalty:points:add:succeeded",
    successEventText: "Added points successfully",
    failEventName: "rivoloyalty:points:add:failed",
    failEventText: "Failed to add points, try again later."
  },
  removePoints: {
    successEventName: "rivoloyalty:points:remove:succeeded",
    successEventText: "Removed points successfully",
    failEventName: "rivoloyalty:points:remove:failed",
    failEventText: "Failed to remove points, try again later."
  }
}, x6 = ({
  customerIdentifier: e,
  isOpen: n,
  points: r,
  onClose: i,
  refetchCustomerData: a
}) => {
  const { useMutation: o, showNotification: s } = fn(), { track: l } = jn(), [d, m] = me(r), [u, f] = me(""), [h, v] = me(!0), [w, N] = me(), j = {
    min: 0,
    max: 1e5
  }, [_, { loading: g }] = o(
    i6,
    {
      onCompleted: () => {
        const ne = d > r ? As.addPoints : As.removePoints;
        s({
          title: "Success",
          text: ne.successEventText,
          icon: "check-circle-filled",
          severity: "success"
        }), l(ne.successEventName), Q();
      }
    }
  ), O = () => {
    m(r), f(""), v(!0), N(void 0);
  };
  Xe(() => {
    n && O();
  }, [n]);
  const R = !!w, $ = k6(d, j), I = b6(r, d), L = () => {
    if (d !== r) {
      const ne = d > r ? As.addPoints : As.removePoints, q = !h;
      _({
        variables: {
          input: {
            // eslint-disable-next-line camelcase
            points_amount: d - r,
            // eslint-disable-next-line camelcase
            ...u && { internal_note: u },
            // eslint-disable-next-line camelcase
            customer_identifier: e?.toString(),
            source: _6.Manual,
            // eslint-disable-next-line camelcase
            skip_email: q
          }
        }
      }).catch(() => {
        l(ne.failEventName), N([ne.failEventText]);
      });
    }
  }, G = () => {
    O(), i();
  }, Q = () => {
    a(), G();
  };
  return /* @__PURE__ */ _e.jsxs(
    ht,
    {
      isOpen: n,
      onClose: G,
      "data-testid": "rivo-loyalty-change-points-modal",
      children: [
        /* @__PURE__ */ _e.jsx(yt, { title: "Change points", onClose: G }),
        /* @__PURE__ */ _e.jsxs(gt, { className: v6.modalBody, children: [
          /* @__PURE__ */ _e.jsxs(et, { children: [
            /* @__PURE__ */ _e.jsx(Z, { span: 6, "data-testid": "rivo-loyalty-points-input", children: /* @__PURE__ */ _e.jsx(
              Kr,
              {
                label: "New points balance",
                type: "number",
                placeholder: "Insert points balance",
                min: j.min,
                max: j.max,
                meta: {
                  error: $,
                  warning: I
                },
                input: {
                  name: "points",
                  value: d.toString(),
                  onChange: (ne) => m(ne?.target.valueAsNumber ?? 0)
                }
              }
            ) }),
            /* @__PURE__ */ _e.jsx(Z, { span: 6, children: /* @__PURE__ */ _e.jsx(
              Kr,
              {
                label: "Internal note",
                placeholder: "Insert an internal note (optional)",
                input: {
                  name: "internalNote",
                  value: u,
                  onChange: (ne) => f(ne?.target.value ?? "")
                }
              }
            ) }),
            /* @__PURE__ */ _e.jsx(Z, { span: 6, children: /* @__PURE__ */ _e.jsx(qe, { label: "Notify the customer by email", children: /* @__PURE__ */ _e.jsx(
              Cw,
              {
                input: {
                  name: "sendEmail",
                  value: "sendEmail",
                  checked: h,
                  onChange: () => v(!h)
                }
              }
            ) }) })
          ] }),
          !g && R && /* @__PURE__ */ _e.jsx(b, { margin: "200 0", flexDirection: "column", children: /* @__PURE__ */ _e.jsx(Je, { children: w?.map((ne, q) => /* @__PURE__ */ _e.jsx(
            Je.Item,
            {
              variant: "dense",
              title: ne,
              contentLeft: /* @__PURE__ */ _e.jsx(
                fe,
                {
                  color: "red.500",
                  size: 16,
                  name: "exclamation-triangle-filled"
                }
              )
            },
            q
          )) }) })
        ] }),
        /* @__PURE__ */ _e.jsx(
          vt,
          {
            confirmName: "Save",
            confirmOnClick: () => L(),
            confirmProps: {
              isLoading: g,
              loadingIndicator: /* @__PURE__ */ _e.jsx(sn, { size: 16 }),
              disabled: !!($ || I)
            },
            cancelOnClick: G
          }
        )
      ]
    }
  );
}, la = ({
  description: e,
  content: n,
  tooltip: r,
  isHighlighted: i = !1
}) => {
  if (n == null)
    return null;
  const a = jw(n);
  return /* @__PURE__ */ _e.jsx(
    Je.Text,
    {
      variant: "dense",
      className: ut(Fr.listItem, {
        [Fr.listItemHighlighted]: i
      }),
      children: /* @__PURE__ */ _e.jsx(Ge, { content: r, children: /* @__PURE__ */ _e.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ _e.jsx(F.Paragraph, { variant: "4", children: e }),
        a ? n : qi(n)
      ] }) })
    }
  );
}, LS = {
  [ba.Guest]: {
    name: "Guest",
    tooltip: "Customers who can participate in your loyalty program without creating a full account. They can earn and redeem points through email verification or one-time codes.",
    badgeColor: "info"
  },
  [ba.Member]: {
    name: "Member",
    tooltip: "Customers who have activated their loyalty membership and have full access to all program features, including account dashboards and advanced features.",
    badgeColor: "success"
  },
  [ba.Excluded]: {
    name: "Excluded",
    tooltip: "Customers who have been excluded from the loyalty program (typically through the “Rivo Excluded” tag or manual exclusion).",
    badgeColor: "warning"
  }
}, S6 = ({
  customer: e,
  allowAdjustLoyaltyPoints: n,
  refetchCustomerData: r
}) => {
  const { attributes: i } = e, a = i.loyalty_status ? LS[i.loyalty_status] : LS[ba.Guest], o = a?.name === ba.Excluded, s = i.lifetime_earnings_tally ?? 0, l = i.total_spent ?? 0, d = Math.trunc(i.points_tally ?? 0), m = i.next_vip_tier, u = i.next_vip_tier?.to_spend_or_earn ?? 0, f = m?.name ?? "None", [h, v] = me(!1), w = 10, N = () => /* @__PURE__ */ _e.jsx(
    Je.Text,
    {
      variant: "dense",
      className: ut(Fr.listItem),
      children: /* @__PURE__ */ _e.jsx(Ge, { content: a.tooltip, children: /* @__PURE__ */ _e.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ _e.jsx(F.Paragraph, { variant: "4", children: "Loyalty status" }),
        /* @__PURE__ */ _e.jsx(Pn, { variant: a.badgeColor, size: "small", children: a.name })
      ] }) })
    }
  ), j = () => o ? N() : /* @__PURE__ */ _e.jsxs(_e.Fragment, { children: [
    /* @__PURE__ */ _e.jsx(
      Je.Text,
      {
        variant: "dense",
        className: ut(
          Fr.listItem,
          Fr.listItemHighlighted,
          {
            [Fr.listItemEdit]: n
          }
        ),
        onClick: () => n ? v(!0) : void 0,
        children: /* @__PURE__ */ _e.jsx(Ge, { content: "The current balance of loyalty points for the customer.", children: /* @__PURE__ */ _e.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
          /* @__PURE__ */ _e.jsx(F.Paragraph, { variant: "4", children: "Points balance" }),
          /* @__PURE__ */ _e.jsxs(
            b,
            {
              alignItems: "center",
              justifyContent: "space-between",
              gap: "100",
              children: [
                n && /* @__PURE__ */ _e.jsx(
                  fe,
                  {
                    name: "pen",
                    size: w,
                    "aria-label": "Edit points"
                  }
                ),
                /* @__PURE__ */ _e.jsx(F.Paragraph, { variant: "4", children: qi(d) })
              ]
            }
          )
        ] }) })
      }
    ),
    u != null && f && /* @__PURE__ */ _e.jsx(
      la,
      {
        description: `Points until ${f} tier`,
        tooltip: `Loyalty points until the customer advances to ${f} tier`,
        content: u.toFixed(2)
      }
    ),
    /* @__PURE__ */ _e.jsx(
      la,
      {
        description: "Points expiry date",
        tooltip: "The timestamp when the customer's loyalty points are set to expire.",
        content: i.points_expire_at ?? "No expiry"
      }
    ),
    /* @__PURE__ */ _e.jsx(
      la,
      {
        description: "Total points earned",
        tooltip: "The total number of loyalty points earned by the customer.",
        content: s?.toFixed(2)
      }
    ),
    /* @__PURE__ */ _e.jsx(
      la,
      {
        description: "Total points spent",
        tooltip: "The total number of loyalty points spent by the customer.",
        content: l.toFixed(2)
      }
    ),
    N(),
    /* @__PURE__ */ _e.jsx(
      la,
      {
        description: "VIP tier",
        tooltip: "The name of the customer's current VIP tier status.",
        content: i.vip_tier?.name ?? "None"
      }
    ),
    /* @__PURE__ */ _e.jsx(
      la,
      {
        description: "Next VIP tier",
        tooltip: "The name of the customer's next VIP tier status.",
        content: f
      }
    )
  ] });
  return /* @__PURE__ */ _e.jsxs(_e.Fragment, { children: [
    /* @__PURE__ */ _e.jsxs(b, { gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ _e.jsx(F.Heading, { variant: "heading-3", children: "Loyalty" }),
      /* @__PURE__ */ _e.jsx(Je, { className: Fr.list, children: j() })
    ] }),
    /* @__PURE__ */ _e.jsx(
      x6,
      {
        customerIdentifier: i.id,
        isOpen: h,
        points: d,
        onClose: () => v(!1),
        refetchCustomerData: r
      }
    )
  ] });
}, N6 = ({
  ordersCount: e
}) => /* @__PURE__ */ _e.jsx(_e.Fragment, { children: /* @__PURE__ */ _e.jsxs(b, { gap: "200", flexDirection: "column", children: [
  /* @__PURE__ */ _e.jsx(F.Heading, { variant: "heading-3", children: "Orders overview" }),
  /* @__PURE__ */ _e.jsx(Je, { className: Fr.list, children: /* @__PURE__ */ _e.jsx(Je.Text, { variant: "dense", className: Fr.listItem, children: /* @__PURE__ */ _e.jsxs(b, { justifyContent: "space-between", children: [
    /* @__PURE__ */ _e.jsx(F.Paragraph, { variant: "4", children: "Total orders" }),
    /* @__PURE__ */ _e.jsx(F.Paragraph, { variant: "4", children: e ?? 0 })
  ] }) }) })
] }) }), j6 = "_reward_1gmba_1", w6 = "_voucherCode_1gmba_14", VS = {
  reward: j6,
  voucherCode: w6
}, C6 = ({
  pointsRedemption: e
}) => {
  const { isCopied: n, copy: r } = Qt(), {
    name: i,
    code: a,
    points_amount: o
  } = e.attributes;
  return /* @__PURE__ */ _e.jsx(b, { gap: "100", flexDirection: "column", children: /* @__PURE__ */ _e.jsxs(b, { gap: "100", flexDirection: "column", className: VS.reward, children: [
    /* @__PURE__ */ _e.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ _e.jsxs(b, { gap: "100", alignItems: "center", children: [
        /* @__PURE__ */ _e.jsx(fe, { name: "star", size: 12, color: "neutral.500" }),
        i
      ] }),
      /* @__PURE__ */ _e.jsxs(Pn, { size: "small", variant: "info", children: [
        o ?? 0,
        " points"
      ] })
    ] }),
    /* @__PURE__ */ _e.jsxs(
      b,
      {
        gap: "100",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        children: [
          /* @__PURE__ */ _e.jsxs(b, { gap: "100", flexDirection: "row", alignItems: "center", children: [
            /* @__PURE__ */ _e.jsx(fe, { size: 14, name: "tag" }),
            /* @__PURE__ */ _e.jsx(b, { children: /* @__PURE__ */ _e.jsx(F.Paragraph, { variant: "4", className: VS.voucherCode, children: a }) })
          ] }),
          /* @__PURE__ */ _e.jsx(Ge, { content: "Copy reward code", children: /* @__PURE__ */ _e.jsx(
            fe,
            {
              size: 14,
              name: n ? "done" : "copy",
              className: Fr.clickableIcon,
              onClick: () => r(a)
            }
          ) })
        ]
      }
    )
  ] }) });
}, F6 = ({
  customer: e
}) => {
  const { useQuery: n } = fn(), {
    loading: r,
    error: i,
    data: a
  } = n(r6, {
    skip: !e,
    variables: {
      customerId: e.attributes.id.toString()
    }
  }), o = (!r && e && a ? a?.RivoLoyalty?.list_points_redemptions?.data ?? [] : []).filter(
    ({ attributes: l }) => I6({
      usedAt: l.used_at,
      revokedAt: l.revoked_at,
      refundedAt: l.refunded_at
    }) === "Issued"
  ), s = () => i ? /* @__PURE__ */ _e.jsx($n, { error: i }) : r ? /* @__PURE__ */ _e.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ _e.jsx(sn, {}) }) : o.length > 0 ? /* @__PURE__ */ _e.jsx(b, { gap: "200", flexDirection: "column", children: o.map((l) => /* @__PURE__ */ _e.jsx(
    C6,
    {
      pointsRedemption: l
    },
    l.id
  )) }) : /* @__PURE__ */ _e.jsx(F.Paragraph, { variant: "4", color: "secondary", children: "No loyalty rewards found." });
  return /* @__PURE__ */ _e.jsx(_e.Fragment, { children: /* @__PURE__ */ _e.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ _e.jsx(F.Heading, { variant: "heading-3", children: "Available rewards" }),
    s()
  ] }) });
};
function I6(e) {
  return e.usedAt ? "Used" : e.revokedAt ? "Revoked" : e.refundedAt ? "Refunded" : "Issued";
}
const $6 = (e) => {
  const { conversationContext: n, settings: r } = e, {
    rivoLoyaltyShowOrders: i,
    rivoLoyaltyShowLoyalty: a,
    rivoLoyaltyAdjustLoyaltyPoints: o,
    rivoLoyaltyShowFavoriteProducts: s,
    rivoLoyaltyShowPointsRedemptions: l
  } = r, d = r[mc].toString(), { useQuery: m } = fn(), { track: u } = jn(), [f, h] = me(!1), v = n?.customer?.email, {
    loading: w,
    error: N,
    data: j,
    refetch: _
  } = m(n6, {
    skip: !v,
    variables: {
      email: v
    }
  }), g = !w && j ? j.RivoLoyalty?.return_customer?.data : void 0;
  Xe(() => {
    !w && g && !f && (u("rivoloyalty:customer:received"), h(!0));
  }, [w, g]);
  const O = () => /* @__PURE__ */ _e.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ _e.jsx(F.Paragraph, { variant: "4", color: "secondary", children: "No customer profile found." }) });
  if (N) {
    const R = N.graphQLErrors;
    return Fa({ errors: R }) ? O() : Ml({ errors: R }) ? /* @__PURE__ */ _e.jsx(
      F.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        variant: "4",
        "data-testid": "widget-downstream-api-forbidden-error",
        children: "The API token used for the integration does not have the necessary access rights. Please contact your administrator."
      }
    ) : Bl({ errors: R }) ? /* @__PURE__ */ _e.jsx(
      F.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        variant: "4",
        "data-testid": "widget-downstream-api-authorization-error",
        children: "The integration could not authorize against Rivo Loyalty. Please contact your administrator."
      }
    ) : /* @__PURE__ */ _e.jsx($n, { error: N });
  }
  return w ? /* @__PURE__ */ _e.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ _e.jsx(sn, {}) }) : !v || !g ? O() : /* @__PURE__ */ _e.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300 0",
      "data-testid": "widget-wrapper",
      children: [
        /* @__PURE__ */ _e.jsx(
          u6,
          {
            customerDetails: g,
            rivoLoyaltyShopifyApiHostName: d
          }
        ),
        i && /* @__PURE__ */ _e.jsx(
          N6,
          {
            ordersCount: g.attributes?.orders_count ?? 0
          }
        ),
        a && /* @__PURE__ */ _e.jsx(
          S6,
          {
            customer: g,
            refetchCustomerData: _,
            allowAdjustLoyaltyPoints: !!o
          }
        ),
        s && /* @__PURE__ */ _e.jsx(
          h6,
          {
            customerId: g.attributes.id,
            rivoLoyaltyShopifyApiHostName: d
          }
        ),
        l && /* @__PURE__ */ _e.jsx(F6, { customer: g })
      ]
    }
  );
};
var ss = (e) => e.type === "checkbox", Vi = (e) => e instanceof Date, Jt = (e) => e == null;
const eF = (e) => typeof e == "object";
var xt = (e) => !Jt(e) && !Array.isArray(e) && eF(e) && !Vi(e), nF = (e) => xt(e) && e.target ? ss(e.target) ? e.target.checked : e.target.value : e, E6 = (e) => e.substring(0, e.search(/\.\d+(\.|$)/)) || e, tF = (e, n) => e.has(E6(n)), T6 = (e) => {
  const n = e.constructor && e.constructor.prototype;
  return xt(n) && n.hasOwnProperty("isPrototypeOf");
}, Rg = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function Pt(e) {
  let n;
  const r = Array.isArray(e), i = typeof FileList < "u" ? e instanceof FileList : !1;
  if (e instanceof Date)
    n = new Date(e);
  else if (e instanceof Set)
    n = new Set(e);
  else if (!(Rg && (e instanceof Blob || i)) && (r || xt(e)))
    if (n = r ? [] : {}, !r && !T6(e))
      n = e;
    else
      for (const a in e)
        e.hasOwnProperty(a) && (n[a] = Pt(e[a]));
  else
    return e;
  return n;
}
var pc = (e) => Array.isArray(e) ? e.filter(Boolean) : [], bt = (e) => e === void 0, tn = (e, n, r) => {
  if (!n || !xt(e))
    return r;
  const i = pc(n.split(/[,[\].]+?/)).reduce((a, o) => Jt(a) ? a : a[o], e);
  return bt(i) || i === e ? bt(e[n]) ? r : e[n] : i;
}, cr = (e) => typeof e == "boolean", Dg = (e) => /^\w*$/.test(e), rF = (e) => pc(e.replace(/["|']|\]/g, "").split(/\.|\[/)), at = (e, n, r) => {
  let i = -1;
  const a = Dg(n) ? [n] : rF(n), o = a.length, s = o - 1;
  for (; ++i < o; ) {
    const l = a[i];
    let d = r;
    if (i !== s) {
      const m = e[l];
      d = xt(m) || Array.isArray(m) ? m : isNaN(+a[i + 1]) ? {} : [];
    }
    if (l === "__proto__" || l === "constructor" || l === "prototype")
      return;
    e[l] = d, e = e[l];
  }
};
const Dl = {
  BLUR: "blur",
  FOCUS_OUT: "focusout",
  CHANGE: "change"
}, Ir = {
  onBlur: "onBlur",
  onChange: "onChange",
  onSubmit: "onSubmit",
  onTouched: "onTouched",
  all: "all"
}, ai = {
  max: "max",
  min: "min",
  maxLength: "maxLength",
  minLength: "minLength",
  pattern: "pattern",
  required: "required",
  validate: "validate"
}, R6 = He.createContext(null), Og = () => He.useContext(R6);
var iF = (e, n, r, i = !0) => {
  const a = {
    defaultValues: n._defaultValues
  };
  for (const o in e)
    Object.defineProperty(a, o, {
      get: () => {
        const s = o;
        return n._proxyFormState[s] !== Ir.all && (n._proxyFormState[s] = !i || Ir.all), r && (r[s] = !0), e[s];
      }
    });
  return a;
};
function D6(e) {
  const n = Og(), { control: r = n.control, disabled: i, name: a, exact: o } = e || {}, [s, l] = He.useState(r._formState), d = He.useRef({
    isDirty: !1,
    isLoading: !1,
    dirtyFields: !1,
    touchedFields: !1,
    validatingFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }), m = He.useRef(a);
  return m.current = a, He.useEffect(() => r._subscribe({
    name: m.current,
    formState: d.current,
    exact: o,
    callback: (u) => {
      !i && l({
        ...r._formState,
        ...u
      });
    }
  }), [r, i, o]), He.useEffect(() => {
    d.current.isValid && r._setValid(!0);
  }, [r]), He.useMemo(() => iF(s, r, d.current, !1), [s, r]);
}
var Hr = (e) => typeof e == "string", aF = (e, n, r, i, a) => Hr(e) ? (i && n.watch.add(e), tn(r, e, a)) : Array.isArray(e) ? e.map((o) => (i && n.watch.add(o), tn(r, o))) : (i && (n.watchAll = !0), r);
function O6(e) {
  const n = Og(), { control: r = n.control, name: i, defaultValue: a, disabled: o, exact: s } = e || {}, l = He.useRef(i), d = He.useRef(a);
  l.current = i, He.useEffect(() => r._subscribe({
    name: l.current,
    formState: {
      values: !0
    },
    exact: s,
    callback: (f) => !o && u(aF(l.current, r._names, f.values || r._formValues, !1, d.current))
  }), [r, o, s]);
  const [m, u] = He.useState(r._getWatch(i, a));
  return He.useEffect(() => r._removeUnmounted()), m;
}
function P6(e) {
  const n = Og(), { name: r, disabled: i, control: a = n.control, shouldUnregister: o } = e, s = tF(a._names.array, r), l = O6({
    control: a,
    name: r,
    defaultValue: tn(a._formValues, r, tn(a._defaultValues, r, e.defaultValue)),
    exact: !0
  }), d = D6({
    control: a,
    name: r,
    exact: !0
  }), m = He.useRef(e), u = He.useRef(a.register(r, {
    ...e.rules,
    value: l,
    ...cr(e.disabled) ? { disabled: e.disabled } : {}
  })), f = He.useMemo(() => Object.defineProperties({}, {
    invalid: {
      enumerable: !0,
      get: () => !!tn(d.errors, r)
    },
    isDirty: {
      enumerable: !0,
      get: () => !!tn(d.dirtyFields, r)
    },
    isTouched: {
      enumerable: !0,
      get: () => !!tn(d.touchedFields, r)
    },
    isValidating: {
      enumerable: !0,
      get: () => !!tn(d.validatingFields, r)
    },
    error: {
      enumerable: !0,
      get: () => tn(d.errors, r)
    }
  }), [d, r]), h = He.useCallback((j) => u.current.onChange({
    target: {
      value: nF(j),
      name: r
    },
    type: Dl.CHANGE
  }), [r]), v = He.useCallback(() => u.current.onBlur({
    target: {
      value: tn(a._formValues, r),
      name: r
    },
    type: Dl.BLUR
  }), [r, a._formValues]), w = He.useCallback((j) => {
    const _ = tn(a._fields, r);
    _ && j && (_._f.ref = {
      focus: () => j.focus(),
      select: () => j.select(),
      setCustomValidity: (g) => j.setCustomValidity(g),
      reportValidity: () => j.reportValidity()
    });
  }, [a._fields, r]), N = He.useMemo(() => ({
    name: r,
    value: l,
    ...cr(i) || d.disabled ? { disabled: d.disabled || i } : {},
    onChange: h,
    onBlur: v,
    ref: w
  }), [r, i, d.disabled, h, v, w, l]);
  return He.useEffect(() => {
    const j = a._options.shouldUnregister || o;
    a.register(r, {
      ...m.current.rules,
      ...cr(m.current.disabled) ? { disabled: m.current.disabled } : {}
    });
    const _ = (g, O) => {
      const R = tn(a._fields, g);
      R && R._f && (R._f.mount = O);
    };
    if (_(r, !0), j) {
      const g = Pt(tn(a._options.defaultValues, r));
      at(a._defaultValues, r, g), bt(tn(a._formValues, r)) && at(a._formValues, r, g);
    }
    return !s && a.register(r), () => {
      (s ? j && !a._state.action : j) ? a.unregister(r) : _(r, !1);
    };
  }, [r, a, s, o]), He.useEffect(() => {
    a._setDisabledField({
      disabled: i,
      name: r
    });
  }, [i, r, a]), He.useMemo(() => ({
    field: N,
    formState: d,
    fieldState: f
  }), [N, d, f]);
}
var A6 = (e, n, r, i, a) => n ? {
  ...r[e],
  types: {
    ...r[e] && r[e].types ? r[e].types : {},
    [i]: a || !0
  }
} : {}, Oo = (e) => Array.isArray(e) ? e : [e], zS = () => {
  let e = [];
  return {
    get observers() {
      return e;
    },
    next: (n) => {
      for (const r of e)
        r.next && r.next(n);
    },
    subscribe: (n) => (e.push(n), {
      unsubscribe: () => {
        e = e.filter((r) => r !== n);
      }
    }),
    unsubscribe: () => {
      e = [];
    }
  };
}, xy = (e) => Jt(e) || !eF(e);
function vi(e, n) {
  if (xy(e) || xy(n))
    return e === n;
  if (Vi(e) && Vi(n))
    return e.getTime() === n.getTime();
  const r = Object.keys(e), i = Object.keys(n);
  if (r.length !== i.length)
    return !1;
  for (const a of r) {
    const o = e[a];
    if (!i.includes(a))
      return !1;
    if (a !== "ref") {
      const s = n[a];
      if (Vi(o) && Vi(s) || xt(o) && xt(s) || Array.isArray(o) && Array.isArray(s) ? !vi(o, s) : o !== s)
        return !1;
    }
  }
  return !0;
}
var Gt = (e) => xt(e) && !Object.keys(e).length, Pg = (e) => e.type === "file", $r = (e) => typeof e == "function", Ol = (e) => {
  if (!Rg)
    return !1;
  const n = e ? e.ownerDocument : 0;
  return e instanceof (n && n.defaultView ? n.defaultView.HTMLElement : HTMLElement);
}, oF = (e) => e.type === "select-multiple", Ag = (e) => e.type === "radio", L6 = (e) => Ag(e) || ss(e), Zm = (e) => Ol(e) && e.isConnected;
function V6(e, n) {
  const r = n.slice(0, -1).length;
  let i = 0;
  for (; i < r; )
    e = bt(e) ? i++ : e[n[i++]];
  return e;
}
function z6(e) {
  for (const n in e)
    if (e.hasOwnProperty(n) && !bt(e[n]))
      return !1;
  return !0;
}
function Ft(e, n) {
  const r = Array.isArray(n) ? n : Dg(n) ? [n] : rF(n), i = r.length === 1 ? e : V6(e, r), a = r.length - 1, o = r[a];
  return i && delete i[o], a !== 0 && (xt(i) && Gt(i) || Array.isArray(i) && z6(i)) && Ft(e, r.slice(0, -1)), e;
}
var sF = (e) => {
  for (const n in e)
    if ($r(e[n]))
      return !0;
  return !1;
};
function Pl(e, n = {}) {
  const r = Array.isArray(e);
  if (xt(e) || r)
    for (const i in e)
      Array.isArray(e[i]) || xt(e[i]) && !sF(e[i]) ? (n[i] = Array.isArray(e[i]) ? [] : {}, Pl(e[i], n[i])) : Jt(e[i]) || (n[i] = !0);
  return n;
}
function lF(e, n, r) {
  const i = Array.isArray(e);
  if (xt(e) || i)
    for (const a in e)
      Array.isArray(e[a]) || xt(e[a]) && !sF(e[a]) ? bt(n) || xy(r[a]) ? r[a] = Array.isArray(e[a]) ? Pl(e[a], []) : { ...Pl(e[a]) } : lF(e[a], Jt(n) ? {} : n[a], r[a]) : r[a] = !vi(e[a], n[a]);
  return r;
}
var vo = (e, n) => lF(e, n, Pl(n));
const US = {
  value: !1,
  isValid: !1
}, MS = { value: !0, isValid: !0 };
var cF = (e) => {
  if (Array.isArray(e)) {
    if (e.length > 1) {
      const n = e.filter((r) => r && r.checked && !r.disabled).map((r) => r.value);
      return { value: n, isValid: !!n.length };
    }
    return e[0].checked && !e[0].disabled ? (
      // @ts-expect-error expected to work in the browser
      e[0].attributes && !bt(e[0].attributes.value) ? bt(e[0].value) || e[0].value === "" ? MS : { value: e[0].value, isValid: !0 } : MS
    ) : US;
  }
  return US;
}, dF = (e, { valueAsNumber: n, valueAsDate: r, setValueAs: i }) => bt(e) ? e : n ? e === "" ? NaN : e && +e : r && Hr(e) ? new Date(e) : i ? i(e) : e;
const BS = {
  isValid: !1,
  value: null
};
var uF = (e) => Array.isArray(e) ? e.reduce((n, r) => r && r.checked && !r.disabled ? {
  isValid: !0,
  value: r.value
} : n, BS) : BS;
function qS(e) {
  const n = e.ref;
  return Pg(n) ? n.files : Ag(n) ? uF(e.refs).value : oF(n) ? [...n.selectedOptions].map(({ value: r }) => r) : ss(n) ? cF(e.refs).value : dF(bt(n.value) ? e.ref.value : n.value, e);
}
var U6 = (e, n, r, i) => {
  const a = {};
  for (const o of e) {
    const s = tn(n, o);
    s && at(a, o, s._f);
  }
  return {
    criteriaMode: r,
    names: [...e],
    fields: a,
    shouldUseNativeValidation: i
  };
}, Al = (e) => e instanceof RegExp, ko = (e) => bt(e) ? e : Al(e) ? e.source : xt(e) ? Al(e.value) ? e.value.source : e.value : e, HS = (e) => ({
  isOnSubmit: !e || e === Ir.onSubmit,
  isOnBlur: e === Ir.onBlur,
  isOnChange: e === Ir.onChange,
  isOnAll: e === Ir.all,
  isOnTouch: e === Ir.onTouched
});
const WS = "AsyncFunction";
var M6 = (e) => !!e && !!e.validate && !!($r(e.validate) && e.validate.constructor.name === WS || xt(e.validate) && Object.values(e.validate).find((n) => n.constructor.name === WS)), B6 = (e) => e.mount && (e.required || e.min || e.max || e.maxLength || e.minLength || e.pattern || e.validate), KS = (e, n, r) => !r && (n.watchAll || n.watch.has(e) || [...n.watch].some((i) => e.startsWith(i) && /^\.\w+/.test(e.slice(i.length))));
const Po = (e, n, r, i) => {
  for (const a of r || Object.keys(e)) {
    const o = tn(e, a);
    if (o) {
      const { _f: s, ...l } = o;
      if (s) {
        if (s.refs && s.refs[0] && n(s.refs[0], a) && !i || s.ref && n(s.ref, s.name) && !i)
          return !0;
        if (Po(l, n))
          break;
      } else if (xt(l) && Po(l, n))
        break;
    }
  }
};
function GS(e, n, r) {
  const i = tn(e, r);
  if (i || Dg(r))
    return {
      error: i,
      name: r
    };
  const a = r.split(".");
  for (; a.length; ) {
    const o = a.join("."), s = tn(n, o), l = tn(e, o);
    if (s && !Array.isArray(s) && r !== o)
      return { name: r };
    if (l && l.type)
      return {
        name: o,
        error: l
      };
    a.pop();
  }
  return {
    name: r
  };
}
var q6 = (e, n, r, i) => {
  r(e);
  const { name: a, ...o } = e;
  return Gt(o) || Object.keys(o).length >= Object.keys(n).length || Object.keys(o).find((s) => n[s] === (!i || Ir.all));
}, H6 = (e, n, r) => !e || !n || e === n || Oo(e).some((i) => i && (r ? i === n : i.startsWith(n) || n.startsWith(i))), W6 = (e, n, r, i, a) => a.isOnAll ? !1 : !r && a.isOnTouch ? !(n || e) : (r ? i.isOnBlur : a.isOnBlur) ? !e : (r ? i.isOnChange : a.isOnChange) ? e : !0, K6 = (e, n) => !pc(tn(e, n)).length && Ft(e, n), G6 = (e, n, r) => {
  const i = Oo(tn(e, r));
  return at(i, "root", n[r]), at(e, r, i), e;
}, sl = (e) => Hr(e);
function YS(e, n, r = "validate") {
  if (sl(e) || Array.isArray(e) && e.every(sl) || cr(e) && !e)
    return {
      type: r,
      message: sl(e) ? e : "",
      ref: n
    };
}
var ca = (e) => xt(e) && !Al(e) ? e : {
  value: e,
  message: ""
}, JS = async (e, n, r, i, a, o) => {
  const { ref: s, refs: l, required: d, maxLength: m, minLength: u, min: f, max: h, pattern: v, validate: w, name: N, valueAsNumber: j, mount: _ } = e._f, g = tn(r, N);
  if (!_ || n.has(N))
    return {};
  const O = l ? l[0] : s, R = (Y) => {
    a && O.reportValidity && (O.setCustomValidity(cr(Y) ? "" : Y || ""), O.reportValidity());
  }, $ = {}, I = Ag(s), L = ss(s), G = I || L, Q = (j || Pg(s)) && bt(s.value) && bt(g) || Ol(s) && s.value === "" || g === "" || Array.isArray(g) && !g.length, ne = A6.bind(null, N, i, $), q = (Y, P, B, ie = ai.maxLength, je = ai.minLength) => {
    const pe = Y ? P : B;
    $[N] = {
      type: Y ? ie : je,
      message: pe,
      ref: s,
      ...ne(Y ? ie : je, pe)
    };
  };
  if (o ? !Array.isArray(g) || !g.length : d && (!G && (Q || Jt(g)) || cr(g) && !g || L && !cF(l).isValid || I && !uF(l).isValid)) {
    const { value: Y, message: P } = sl(d) ? { value: !!d, message: d } : ca(d);
    if (Y && ($[N] = {
      type: ai.required,
      message: P,
      ref: O,
      ...ne(ai.required, P)
    }, !i))
      return R(P), $;
  }
  if (!Q && (!Jt(f) || !Jt(h))) {
    let Y, P;
    const B = ca(h), ie = ca(f);
    if (!Jt(g) && !isNaN(g)) {
      const je = s.valueAsNumber || g && +g;
      Jt(B.value) || (Y = je > B.value), Jt(ie.value) || (P = je < ie.value);
    } else {
      const je = s.valueAsDate || new Date(g), pe = (V) => /* @__PURE__ */ new Date((/* @__PURE__ */ new Date()).toDateString() + " " + V), le = s.type == "time", ge = s.type == "week";
      Hr(B.value) && g && (Y = le ? pe(g) > pe(B.value) : ge ? g > B.value : je > new Date(B.value)), Hr(ie.value) && g && (P = le ? pe(g) < pe(ie.value) : ge ? g < ie.value : je < new Date(ie.value));
    }
    if ((Y || P) && (q(!!Y, B.message, ie.message, ai.max, ai.min), !i))
      return R($[N].message), $;
  }
  if ((m || u) && !Q && (Hr(g) || o && Array.isArray(g))) {
    const Y = ca(m), P = ca(u), B = !Jt(Y.value) && g.length > +Y.value, ie = !Jt(P.value) && g.length < +P.value;
    if ((B || ie) && (q(B, Y.message, P.message), !i))
      return R($[N].message), $;
  }
  if (v && !Q && Hr(g)) {
    const { value: Y, message: P } = ca(v);
    if (Al(Y) && !g.match(Y) && ($[N] = {
      type: ai.pattern,
      message: P,
      ref: s,
      ...ne(ai.pattern, P)
    }, !i))
      return R(P), $;
  }
  if (w) {
    if ($r(w)) {
      const Y = await w(g, r), P = YS(Y, O);
      if (P && ($[N] = {
        ...P,
        ...ne(ai.validate, P.message)
      }, !i))
        return R(P.message), $;
    } else if (xt(w)) {
      let Y = {};
      for (const P in w) {
        if (!Gt(Y) && !i)
          break;
        const B = YS(await w[P](g, r), O, P);
        B && (Y = {
          ...B,
          ...ne(P, B.message)
        }, R(B.message), i && ($[N] = Y));
      }
      if (!Gt(Y) && ($[N] = {
        ref: O,
        ...Y
      }, !i))
        return $;
    }
  }
  return R(!0), $;
};
const Y6 = {
  mode: Ir.onSubmit,
  reValidateMode: Ir.onChange,
  shouldFocusError: !0
};
function J6(e = {}) {
  let n = {
    ...Y6,
    ...e
  }, r = {
    submitCount: 0,
    isDirty: !1,
    isLoading: $r(n.defaultValues),
    isValidating: !1,
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    touchedFields: {},
    dirtyFields: {},
    validatingFields: {},
    errors: n.errors || {},
    disabled: n.disabled || !1
  };
  const i = {};
  let a = xt(n.defaultValues) || xt(n.values) ? Pt(n.values || n.defaultValues) || {} : {}, o = n.shouldUnregister ? {} : Pt(a), s = {
    action: !1,
    mount: !1,
    watch: !1
  }, l = {
    mount: /* @__PURE__ */ new Set(),
    disabled: /* @__PURE__ */ new Set(),
    unMount: /* @__PURE__ */ new Set(),
    array: /* @__PURE__ */ new Set(),
    watch: /* @__PURE__ */ new Set()
  }, d, m = 0;
  const u = {
    isDirty: !1,
    dirtyFields: !1,
    validatingFields: !1,
    touchedFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  };
  let f = {
    ...u
  };
  const h = {
    array: zS(),
    state: zS()
  }, v = HS(n.mode), w = HS(n.reValidateMode), N = n.criteriaMode === Ir.all, j = (X) => (E) => {
    clearTimeout(m), m = setTimeout(X, E);
  }, _ = async (X) => {
    if (!n.disabled && (u.isValid || f.isValid || X)) {
      const E = n.resolver ? Gt((await Q()).errors) : await q(i, !0);
      E !== r.isValid && h.state.next({
        isValid: E
      });
    }
  }, g = (X, E) => {
    !n.disabled && (u.isValidating || u.validatingFields || f.isValidating || f.validatingFields) && ((X || Array.from(l.mount)).forEach((z) => {
      z && (E ? at(r.validatingFields, z, E) : Ft(r.validatingFields, z));
    }), h.state.next({
      validatingFields: r.validatingFields,
      isValidating: !Gt(r.validatingFields)
    }));
  }, O = (X, E = [], z, ae, de = !0, U = !0) => {
    if (ae && z && !n.disabled) {
      if (s.action = !0, U && Array.isArray(tn(i, X))) {
        const J = z(tn(i, X), ae.argA, ae.argB);
        de && at(i, X, J);
      }
      if (U && Array.isArray(tn(r.errors, X))) {
        const J = z(tn(r.errors, X), ae.argA, ae.argB);
        de && at(r.errors, X, J), K6(r.errors, X);
      }
      if ((u.touchedFields || f.touchedFields) && U && Array.isArray(tn(r.touchedFields, X))) {
        const J = z(tn(r.touchedFields, X), ae.argA, ae.argB);
        de && at(r.touchedFields, X, J);
      }
      (u.dirtyFields || f.dirtyFields) && (r.dirtyFields = vo(a, o)), h.state.next({
        name: X,
        isDirty: P(X, E),
        dirtyFields: r.dirtyFields,
        errors: r.errors,
        isValid: r.isValid
      });
    } else
      at(o, X, E);
  }, R = (X, E) => {
    at(r.errors, X, E), h.state.next({
      errors: r.errors
    });
  }, $ = (X) => {
    r.errors = X, h.state.next({
      errors: r.errors,
      isValid: !1
    });
  }, I = (X, E, z, ae) => {
    const de = tn(i, X);
    if (de) {
      const U = tn(o, X, bt(z) ? tn(a, X) : z);
      bt(U) || ae && ae.defaultChecked || E ? at(o, X, E ? U : qS(de._f)) : je(X, U), s.mount && _();
    }
  }, L = (X, E, z, ae, de) => {
    let U = !1, J = !1;
    const ve = {
      name: X
    };
    if (!n.disabled) {
      if (!z || ae) {
        (u.isDirty || f.isDirty) && (J = r.isDirty, r.isDirty = ve.isDirty = P(), U = J !== ve.isDirty);
        const we = vi(tn(a, X), E);
        J = !!tn(r.dirtyFields, X), we ? Ft(r.dirtyFields, X) : at(r.dirtyFields, X, !0), ve.dirtyFields = r.dirtyFields, U = U || (u.dirtyFields || f.dirtyFields) && J !== !we;
      }
      if (z) {
        const we = tn(r.touchedFields, X);
        we || (at(r.touchedFields, X, z), ve.touchedFields = r.touchedFields, U = U || (u.touchedFields || f.touchedFields) && we !== z);
      }
      U && de && h.state.next(ve);
    }
    return U ? ve : {};
  }, G = (X, E, z, ae) => {
    const de = tn(r.errors, X), U = (u.isValid || f.isValid) && cr(E) && r.isValid !== E;
    if (n.delayError && z ? (d = j(() => R(X, z)), d(n.delayError)) : (clearTimeout(m), d = null, z ? at(r.errors, X, z) : Ft(r.errors, X)), (z ? !vi(de, z) : de) || !Gt(ae) || U) {
      const J = {
        ...ae,
        ...U && cr(E) ? { isValid: E } : {},
        errors: r.errors,
        name: X
      };
      r = {
        ...r,
        ...J
      }, h.state.next(J);
    }
  }, Q = async (X) => {
    g(X, !0);
    const E = await n.resolver(o, n.context, U6(X || l.mount, i, n.criteriaMode, n.shouldUseNativeValidation));
    return g(X), E;
  }, ne = async (X) => {
    const { errors: E } = await Q(X);
    if (X)
      for (const z of X) {
        const ae = tn(E, z);
        ae ? at(r.errors, z, ae) : Ft(r.errors, z);
      }
    else
      r.errors = E;
    return E;
  }, q = async (X, E, z = {
    valid: !0
  }) => {
    for (const ae in X) {
      const de = X[ae];
      if (de) {
        const { _f: U, ...J } = de;
        if (U) {
          const ve = l.array.has(U.name), we = de._f && M6(de._f);
          we && u.validatingFields && g([ae], !0);
          const Re = await JS(de, l.disabled, o, N, n.shouldUseNativeValidation && !E, ve);
          if (we && u.validatingFields && g([ae]), Re[U.name] && (z.valid = !1, E))
            break;
          !E && (tn(Re, U.name) ? ve ? G6(r.errors, Re, U.name) : at(r.errors, U.name, Re[U.name]) : Ft(r.errors, U.name));
        }
        !Gt(J) && await q(J, E, z);
      }
    }
    return z.valid;
  }, Y = () => {
    for (const X of l.unMount) {
      const E = tn(i, X);
      E && (E._f.refs ? E._f.refs.every((z) => !Zm(z)) : !Zm(E._f.ref)) && Be(X);
    }
    l.unMount = /* @__PURE__ */ new Set();
  }, P = (X, E) => !n.disabled && (X && E && at(o, X, E), !vi(Oe(), a)), B = (X, E, z) => aF(X, l, {
    ...s.mount ? o : bt(E) ? a : Hr(X) ? { [X]: E } : E
  }, z, E), ie = (X) => pc(tn(s.mount ? o : a, X, n.shouldUnregister ? tn(a, X, []) : [])), je = (X, E, z = {}) => {
    const ae = tn(i, X);
    let de = E;
    if (ae) {
      const U = ae._f;
      U && (!U.disabled && at(o, X, dF(E, U)), de = Ol(U.ref) && Jt(E) ? "" : E, oF(U.ref) ? [...U.ref.options].forEach((J) => J.selected = de.includes(J.value)) : U.refs ? ss(U.ref) ? U.refs.length > 1 ? U.refs.forEach((J) => (!J.defaultChecked || !J.disabled) && (J.checked = Array.isArray(de) ? !!de.find((ve) => ve === J.value) : de === J.value)) : U.refs[0] && (U.refs[0].checked = !!de) : U.refs.forEach((J) => J.checked = J.value === de) : Pg(U.ref) ? U.ref.value = "" : (U.ref.value = de, U.ref.type || h.state.next({
        name: X,
        values: Pt(o)
      })));
    }
    (z.shouldDirty || z.shouldTouch) && L(X, de, z.shouldTouch, z.shouldDirty, !0), z.shouldValidate && be(X);
  }, pe = (X, E, z) => {
    for (const ae in E) {
      const de = E[ae], U = `${X}.${ae}`, J = tn(i, U);
      (l.array.has(X) || xt(de) || J && !J._f) && !Vi(de) ? pe(U, de, z) : je(U, de, z);
    }
  }, le = (X, E, z = {}) => {
    const ae = tn(i, X), de = l.array.has(X), U = Pt(E);
    at(o, X, U), de ? (h.array.next({
      name: X,
      values: Pt(o)
    }), (u.isDirty || u.dirtyFields || f.isDirty || f.dirtyFields) && z.shouldDirty && h.state.next({
      name: X,
      dirtyFields: vo(a, o),
      isDirty: P(X, U)
    })) : ae && !ae._f && !Jt(U) ? pe(X, U, z) : je(X, U, z), KS(X, l) && h.state.next({ ...r }), h.state.next({
      name: s.mount ? X : void 0,
      values: Pt(o)
    });
  }, ge = async (X) => {
    s.mount = !0;
    const E = X.target;
    let z = E.name, ae = !0;
    const de = tn(i, z), U = (J) => {
      ae = Number.isNaN(J) || Vi(J) && isNaN(J.getTime()) || vi(J, tn(o, z, J));
    };
    if (de) {
      let J, ve;
      const we = E.type ? qS(de._f) : nF(X), Re = X.type === Dl.BLUR || X.type === Dl.FOCUS_OUT, rn = !B6(de._f) && !n.resolver && !tn(r.errors, z) && !de._f.deps || W6(Re, tn(r.touchedFields, z), r.isSubmitted, w, v), bn = KS(z, l, Re);
      at(o, z, we), Re ? (de._f.onBlur && de._f.onBlur(X), d && d(0)) : de._f.onChange && de._f.onChange(X);
      const an = L(z, we, Re), hn = !Gt(an) || bn;
      if (!Re && h.state.next({
        name: z,
        type: X.type,
        values: Pt(o)
      }), rn)
        return (u.isValid || f.isValid) && (n.mode === "onBlur" ? Re && _() : Re || _()), hn && h.state.next({ name: z, ...bn ? {} : an });
      if (!Re && bn && h.state.next({ ...r }), n.resolver) {
        const { errors: En } = await Q([z]);
        if (U(we), ae) {
          const _n = GS(r.errors, i, z), Fn = GS(En, i, _n.name || z);
          J = Fn.error, z = Fn.name, ve = Gt(En);
        }
      } else
        g([z], !0), J = (await JS(de, l.disabled, o, N, n.shouldUseNativeValidation))[z], g([z]), U(we), ae && (J ? ve = !1 : (u.isValid || f.isValid) && (ve = await q(i, !0)));
      ae && (de._f.deps && be(de._f.deps), G(z, ve, J, an));
    }
  }, V = (X, E) => {
    if (tn(r.errors, E) && X.focus)
      return X.focus(), 1;
  }, be = async (X, E = {}) => {
    let z, ae;
    const de = Oo(X);
    if (n.resolver) {
      const U = await ne(bt(X) ? X : de);
      z = Gt(U), ae = X ? !de.some((J) => tn(U, J)) : z;
    } else X ? (ae = (await Promise.all(de.map(async (U) => {
      const J = tn(i, U);
      return await q(J && J._f ? { [U]: J } : J);
    }))).every(Boolean), !(!ae && !r.isValid) && _()) : ae = z = await q(i);
    return h.state.next({
      ...!Hr(X) || (u.isValid || f.isValid) && z !== r.isValid ? {} : { name: X },
      ...n.resolver || !X ? { isValid: z } : {},
      errors: r.errors
    }), E.shouldFocus && !ae && Po(i, V, X ? de : l.mount), ae;
  }, Oe = (X) => {
    const E = {
      ...s.mount ? o : a
    };
    return bt(X) ? E : Hr(X) ? tn(E, X) : X.map((z) => tn(E, z));
  }, H = (X, E) => ({
    invalid: !!tn((E || r).errors, X),
    isDirty: !!tn((E || r).dirtyFields, X),
    error: tn((E || r).errors, X),
    isValidating: !!tn(r.validatingFields, X),
    isTouched: !!tn((E || r).touchedFields, X)
  }), Ye = (X) => {
    X && Oo(X).forEach((E) => Ft(r.errors, E)), h.state.next({
      errors: X ? r.errors : {}
    });
  }, ln = (X, E, z) => {
    const ae = (tn(i, X, { _f: {} })._f || {}).ref, de = tn(r.errors, X) || {}, { ref: U, message: J, type: ve, ...we } = de;
    at(r.errors, X, {
      ...we,
      ...E,
      ref: ae
    }), h.state.next({
      name: X,
      errors: r.errors,
      isValid: !1
    }), z && z.shouldFocus && ae && ae.focus && ae.focus();
  }, Ie = (X, E) => $r(X) ? h.state.subscribe({
    next: (z) => X(B(void 0, E), z)
  }) : B(X, E, !0), Ue = (X) => h.state.subscribe({
    next: (E) => {
      H6(X.name, E.name, X.exact) && q6(E, X.formState || u, Pe, X.reRenderRoot) && X.callback({
        values: { ...o },
        ...r,
        ...E
      });
    }
  }).unsubscribe, De = (X) => (s.mount = !0, f = {
    ...f,
    ...X.formState
  }, Ue({
    ...X,
    formState: f
  })), Be = (X, E = {}) => {
    for (const z of X ? Oo(X) : l.mount)
      l.mount.delete(z), l.array.delete(z), E.keepValue || (Ft(i, z), Ft(o, z)), !E.keepError && Ft(r.errors, z), !E.keepDirty && Ft(r.dirtyFields, z), !E.keepTouched && Ft(r.touchedFields, z), !E.keepIsValidating && Ft(r.validatingFields, z), !n.shouldUnregister && !E.keepDefaultValue && Ft(a, z);
    h.state.next({
      values: Pt(o)
    }), h.state.next({
      ...r,
      ...E.keepDirty ? { isDirty: P() } : {}
    }), !E.keepIsValid && _();
  }, Ae = ({ disabled: X, name: E }) => {
    (cr(X) && s.mount || X || l.disabled.has(E)) && (X ? l.disabled.add(E) : l.disabled.delete(E));
  }, Qe = (X, E = {}) => {
    let z = tn(i, X);
    const ae = cr(E.disabled) || cr(n.disabled);
    return at(i, X, {
      ...z || {},
      _f: {
        ...z && z._f ? z._f : { ref: { name: X } },
        name: X,
        mount: !0,
        ...E
      }
    }), l.mount.add(X), z ? Ae({
      disabled: cr(E.disabled) ? E.disabled : n.disabled,
      name: X
    }) : I(X, !0, E.value), {
      ...ae ? { disabled: E.disabled || n.disabled } : {},
      ...n.progressive ? {
        required: !!E.required,
        min: ko(E.min),
        max: ko(E.max),
        minLength: ko(E.minLength),
        maxLength: ko(E.maxLength),
        pattern: ko(E.pattern)
      } : {},
      name: X,
      onChange: ge,
      onBlur: ge,
      ref: (de) => {
        if (de) {
          Qe(X, E), z = tn(i, X);
          const U = bt(de.value) && de.querySelectorAll && de.querySelectorAll("input,select,textarea")[0] || de, J = L6(U), ve = z._f.refs || [];
          if (J ? ve.find((we) => we === U) : U === z._f.ref)
            return;
          at(i, X, {
            _f: {
              ...z._f,
              ...J ? {
                refs: [
                  ...ve.filter(Zm),
                  U,
                  ...Array.isArray(tn(a, X)) ? [{}] : []
                ],
                ref: { type: U.type, name: X }
              } : { ref: U }
            }
          }), I(X, !1, void 0, U);
        } else
          z = tn(i, X, {}), z._f && (z._f.mount = !1), (n.shouldUnregister || E.shouldUnregister) && !(tF(l.array, X) && s.action) && l.unMount.add(X);
      }
    };
  }, Ee = () => n.shouldFocusError && Po(i, V, l.mount), Me = (X) => {
    cr(X) && (h.state.next({ disabled: X }), Po(i, (E, z) => {
      const ae = tn(i, z);
      ae && (E.disabled = ae._f.disabled || X, Array.isArray(ae._f.refs) && ae._f.refs.forEach((de) => {
        de.disabled = ae._f.disabled || X;
      }));
    }, 0, !1));
  }, en = (X, E) => async (z) => {
    let ae;
    z && (z.preventDefault && z.preventDefault(), z.persist && z.persist());
    let de = Pt(o);
    if (h.state.next({
      isSubmitting: !0
    }), n.resolver) {
      const { errors: U, values: J } = await Q();
      r.errors = U, de = J;
    } else
      await q(i);
    if (l.disabled.size)
      for (const U of l.disabled)
        at(de, U, void 0);
    if (Ft(r.errors, "root"), Gt(r.errors)) {
      h.state.next({
        errors: {}
      });
      try {
        await X(de, z);
      } catch (U) {
        ae = U;
      }
    } else
      E && await E({ ...r.errors }, z), Ee(), setTimeout(Ee);
    if (h.state.next({
      isSubmitted: !0,
      isSubmitting: !1,
      isSubmitSuccessful: Gt(r.errors) && !ae,
      submitCount: r.submitCount + 1,
      errors: r.errors
    }), ae)
      throw ae;
  }, se = (X, E = {}) => {
    tn(i, X) && (bt(E.defaultValue) ? le(X, Pt(tn(a, X))) : (le(X, E.defaultValue), at(a, X, Pt(E.defaultValue))), E.keepTouched || Ft(r.touchedFields, X), E.keepDirty || (Ft(r.dirtyFields, X), r.isDirty = E.defaultValue ? P(X, Pt(tn(a, X))) : P()), E.keepError || (Ft(r.errors, X), u.isValid && _()), h.state.next({ ...r }));
  }, ce = (X, E = {}) => {
    const z = X ? Pt(X) : a, ae = Pt(z), de = Gt(X), U = de ? a : ae;
    if (E.keepDefaultValues || (a = z), !E.keepValues) {
      if (E.keepDirtyValues) {
        const J = /* @__PURE__ */ new Set([
          ...l.mount,
          ...Object.keys(vo(a, o))
        ]);
        for (const ve of Array.from(J))
          tn(r.dirtyFields, ve) ? at(U, ve, tn(o, ve)) : le(ve, tn(U, ve));
      } else {
        if (Rg && bt(X))
          for (const J of l.mount) {
            const ve = tn(i, J);
            if (ve && ve._f) {
              const we = Array.isArray(ve._f.refs) ? ve._f.refs[0] : ve._f.ref;
              if (Ol(we)) {
                const Re = we.closest("form");
                if (Re) {
                  Re.reset();
                  break;
                }
              }
            }
          }
        for (const J of l.mount)
          le(J, tn(U, J));
      }
      o = Pt(U), h.array.next({
        values: { ...U }
      }), h.state.next({
        values: { ...U }
      });
    }
    l = {
      mount: E.keepDirtyValues ? l.mount : /* @__PURE__ */ new Set(),
      unMount: /* @__PURE__ */ new Set(),
      array: /* @__PURE__ */ new Set(),
      disabled: /* @__PURE__ */ new Set(),
      watch: /* @__PURE__ */ new Set(),
      watchAll: !1,
      focus: ""
    }, s.mount = !u.isValid || !!E.keepIsValid || !!E.keepDirtyValues, s.watch = !!n.shouldUnregister, h.state.next({
      submitCount: E.keepSubmitCount ? r.submitCount : 0,
      isDirty: de ? !1 : E.keepDirty ? r.isDirty : !!(E.keepDefaultValues && !vi(X, a)),
      isSubmitted: E.keepIsSubmitted ? r.isSubmitted : !1,
      dirtyFields: de ? {} : E.keepDirtyValues ? E.keepDefaultValues && o ? vo(a, o) : r.dirtyFields : E.keepDefaultValues && X ? vo(a, X) : E.keepDirty ? r.dirtyFields : {},
      touchedFields: E.keepTouched ? r.touchedFields : {},
      errors: E.keepErrors ? r.errors : {},
      isSubmitSuccessful: E.keepIsSubmitSuccessful ? r.isSubmitSuccessful : !1,
      isSubmitting: !1
    });
  }, Se = (X, E) => ce($r(X) ? X(o) : X, E), Ve = (X, E = {}) => {
    const z = tn(i, X), ae = z && z._f;
    if (ae) {
      const de = ae.refs ? ae.refs[0] : ae.ref;
      de.focus && (de.focus(), E.shouldSelect && $r(de.select) && de.select());
    }
  }, Pe = (X) => {
    r = {
      ...r,
      ...X
    };
  }, kn = {
    control: {
      register: Qe,
      unregister: Be,
      getFieldState: H,
      handleSubmit: en,
      setError: ln,
      _subscribe: Ue,
      _runSchema: Q,
      _getWatch: B,
      _getDirty: P,
      _setValid: _,
      _setFieldArray: O,
      _setDisabledField: Ae,
      _setErrors: $,
      _getFieldArray: ie,
      _reset: ce,
      _resetDefaultValues: () => $r(n.defaultValues) && n.defaultValues().then((X) => {
        Se(X, n.resetOptions), h.state.next({
          isLoading: !1
        });
      }),
      _removeUnmounted: Y,
      _disableForm: Me,
      _subjects: h,
      _proxyFormState: u,
      get _fields() {
        return i;
      },
      get _formValues() {
        return o;
      },
      get _state() {
        return s;
      },
      set _state(X) {
        s = X;
      },
      get _defaultValues() {
        return a;
      },
      get _names() {
        return l;
      },
      set _names(X) {
        l = X;
      },
      get _formState() {
        return r;
      },
      get _options() {
        return n;
      },
      set _options(X) {
        n = {
          ...n,
          ...X
        };
      }
    },
    subscribe: De,
    trigger: be,
    register: Qe,
    handleSubmit: en,
    watch: Ie,
    setValue: le,
    getValues: Oe,
    reset: Se,
    resetField: se,
    clearErrors: Ye,
    unregister: Be,
    setError: ln,
    setFocus: Ve,
    getFieldState: H
  };
  return {
    ...kn,
    formControl: kn
  };
}
function Q6(e = {}) {
  const n = He.useRef(void 0), r = He.useRef(void 0), [i, a] = He.useState({
    isDirty: !1,
    isValidating: !1,
    isLoading: $r(e.defaultValues),
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    submitCount: 0,
    dirtyFields: {},
    touchedFields: {},
    validatingFields: {},
    errors: e.errors || {},
    disabled: e.disabled || !1,
    defaultValues: $r(e.defaultValues) ? void 0 : e.defaultValues
  });
  n.current || (n.current = {
    ...e.formControl ? e.formControl : J6(e),
    formState: i
  }, e.formControl && e.defaultValues && !$r(e.defaultValues) && e.formControl.reset(e.defaultValues, e.resetOptions));
  const o = n.current.control;
  return o._options = e, He.useLayoutEffect(() => o._subscribe({
    formState: o._proxyFormState,
    callback: () => a({ ...o._formState }),
    reRenderRoot: !0
  }), [o]), He.useEffect(() => o._disableForm(e.disabled), [o, e.disabled]), He.useEffect(() => {
    if (o._proxyFormState.isDirty) {
      const s = o._getDirty();
      s !== i.isDirty && o._subjects.state.next({
        isDirty: s
      });
    }
  }, [o, i.isDirty]), He.useEffect(() => {
    e.values && !vi(e.values, r.current) ? (o._reset(e.values, o._options.resetOptions), r.current = e.values, a((s) => ({ ...s }))) : o._resetDefaultValues();
  }, [e.values, o]), He.useEffect(() => {
    e.errors && !Gt(e.errors) && o._setErrors(e.errors);
  }, [e.errors, o]), He.useEffect(() => {
    o._state.mount || (o._setValid(), o._state.mount = !0), o._state.watch && (o._state.watch = !1, o._subjects.state.next({ ...o._formState })), o._removeUnmounted();
  }), He.useEffect(() => {
    e.shouldUnregister && o._subjects.state.next({
      values: o._getWatch()
    });
  }, [e.shouldUnregister, o]), n.current.formState = iF(i, o), n.current;
}
var Ls = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function mF(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var ep = { exports: {} }, bo = {}, QS;
function X6() {
  if (QS) return bo;
  QS = 1;
  var e = He, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (v = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return bo.Fragment = r, bo.jsx = s, bo.jsxs = s, bo;
}
var Vs = {}, XS;
function Z6() {
  return XS || (XS = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = He, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), d = /* @__PURE__ */ Symbol.for("react.forward_ref"), m = /* @__PURE__ */ Symbol.for("react.suspense"), u = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), v = /* @__PURE__ */ Symbol.for("react.offscreen"), w = Symbol.iterator, N = "@@iterator";
    function j(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = w && t[w] || t[N];
      return typeof c == "function" ? c : null;
    }
    var _ = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          p[y - 1] = arguments[y];
        O("error", t, p);
      }
    }
    function O(t, c, p) {
      {
        var y = _.ReactDebugCurrentFrame, C = y.getStackAddendum();
        C !== "" && (c += "%s", p = p.concat([C]));
        var T = p.map(function(S) {
          return String(S);
        });
        T.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, T);
      }
    }
    var R = !1, $ = !1, I = !1, L = !1, G = !1, Q;
    Q = /* @__PURE__ */ Symbol.for("react.module.reference");
    function ne(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || G || t === a || t === m || t === u || L || t === v || R || $ || I || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Q || t.getModuleId !== void 0));
    }
    function q(t, c, p) {
      var y = t.displayName;
      if (y)
        return y;
      var C = c.displayName || c.name || "";
      return C !== "" ? p + "(" + C + ")" : p;
    }
    function Y(t) {
      return t.displayName || "Context";
    }
    function P(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return Y(c) + ".Consumer";
          case s:
            var p = t;
            return Y(p._context) + ".Provider";
          case d:
            return q(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : P(t.type) || "Memo";
          case h: {
            var C = t, T = C._payload, S = C._init;
            try {
              return P(S(T));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var B = Object.assign, ie = 0, je, pe, le, ge, V, be, Oe;
    function H() {
    }
    H.__reactDisabledLog = !0;
    function Ye() {
      {
        if (ie === 0) {
          je = console.log, pe = console.info, le = console.warn, ge = console.error, V = console.group, be = console.groupCollapsed, Oe = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: H,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ie++;
      }
    }
    function ln() {
      {
        if (ie--, ie === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: B({}, t, {
              value: je
            }),
            info: B({}, t, {
              value: pe
            }),
            warn: B({}, t, {
              value: le
            }),
            error: B({}, t, {
              value: ge
            }),
            group: B({}, t, {
              value: V
            }),
            groupCollapsed: B({}, t, {
              value: be
            }),
            groupEnd: B({}, t, {
              value: Oe
            })
          });
        }
        ie < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Ie = _.ReactCurrentDispatcher, Ue;
    function De(t, c, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (C) {
            var y = C.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Be = !1, Ae;
    {
      var Qe = typeof WeakMap == "function" ? WeakMap : Map;
      Ae = new Qe();
    }
    function Ee(t, c) {
      if (!t || Be)
        return "";
      {
        var p = Ae.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Be = !0;
      var C = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var T;
      T = Ie.current, Ie.current = null, Ye();
      try {
        if (c) {
          var S = function() {
            throw Error();
          };
          if (Object.defineProperty(S.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(S, []);
            } catch (re) {
              y = re;
            }
            Reflect.construct(t, [], S);
          } else {
            try {
              S.call();
            } catch (re) {
              y = re;
            }
            t.call(S.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (re) {
            y = re;
          }
          t();
        }
      } catch (re) {
        if (re && y && typeof re.stack == "string") {
          for (var x = re.stack.split(`
`), ee = y.stack.split(`
`), A = x.length - 1, M = ee.length - 1; A >= 1 && M >= 0 && x[A] !== ee[M]; )
            M--;
          for (; A >= 1 && M >= 0; A--, M--)
            if (x[A] !== ee[M]) {
              if (A !== 1 || M !== 1)
                do
                  if (A--, M--, M < 0 || x[A] !== ee[M]) {
                    var ue = `
` + x[A].replace(" at new ", " at ");
                    return t.displayName && ue.includes("<anonymous>") && (ue = ue.replace("<anonymous>", t.displayName)), typeof t == "function" && Ae.set(t, ue), ue;
                  }
                while (A >= 1 && M >= 0);
              break;
            }
        }
      } finally {
        Be = !1, Ie.current = T, ln(), Error.prepareStackTrace = C;
      }
      var ze = t ? t.displayName || t.name : "", Te = ze ? De(ze) : "";
      return typeof t == "function" && Ae.set(t, Te), Te;
    }
    function Me(t, c, p) {
      return Ee(t, !1);
    }
    function en(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function se(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ee(t, en(t));
      if (typeof t == "string")
        return De(t);
      switch (t) {
        case m:
          return De("Suspense");
        case u:
          return De("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Me(t.render);
          case f:
            return se(t.type, c, p);
          case h: {
            var y = t, C = y._payload, T = y._init;
            try {
              return se(T(C), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var ce = Object.prototype.hasOwnProperty, Se = {}, Ve = _.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, p = se(t.type, t._source, c ? c.type : null);
        Ve.setExtraStackFrame(p);
      } else
        Ve.setExtraStackFrame(null);
    }
    function kn(t, c, p, y, C) {
      {
        var T = Function.call.bind(ce);
        for (var S in t)
          if (T(t, S)) {
            var x = void 0;
            try {
              if (typeof t[S] != "function") {
                var ee = Error((y || "React class") + ": " + p + " type `" + S + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[S] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ee.name = "Invariant Violation", ee;
              }
              x = t[S](c, S, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (A) {
              x = A;
            }
            x && !(x instanceof Error) && (Pe(C), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, S, typeof x), Pe(null)), x instanceof Error && !(x.message in Se) && (Se[x.message] = !0, Pe(C), g("Failed %s type: %s", p, x.message), Pe(null));
          }
      }
    }
    var X = Array.isArray;
    function E(t) {
      return X(t);
    }
    function z(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function ae(t) {
      try {
        return de(t), !1;
      } catch {
        return !0;
      }
    }
    function de(t) {
      return "" + t;
    }
    function U(t) {
      if (ae(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", z(t)), de(t);
    }
    var J = _.ReactCurrentOwner, ve = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, we, Re;
    function rn(t) {
      if (ce.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function bn(t) {
      if (ce.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function an(t, c) {
      typeof t.ref == "string" && J.current;
    }
    function hn(t, c) {
      {
        var p = function() {
          we || (we = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function En(t, c) {
      {
        var p = function() {
          Re || (Re = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var _n = function(t, c, p, y, C, T, S) {
      var x = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: S,
        // Record the component responsible for creating this element.
        _owner: T
      };
      return x._store = {}, Object.defineProperty(x._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(x, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(x, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: C
      }), Object.freeze && (Object.freeze(x.props), Object.freeze(x)), x;
    };
    function Fn(t, c, p, y, C) {
      {
        var T, S = {}, x = null, ee = null;
        p !== void 0 && (U(p), x = "" + p), bn(c) && (U(c.key), x = "" + c.key), rn(c) && (ee = c.ref, an(c));
        for (T in c)
          ce.call(c, T) && !ve.hasOwnProperty(T) && (S[T] = c[T]);
        if (t && t.defaultProps) {
          var A = t.defaultProps;
          for (T in A)
            S[T] === void 0 && (S[T] = A[T]);
        }
        if (x || ee) {
          var M = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          x && hn(S, M), ee && En(S, M);
        }
        return _n(t, x, ee, C, y, J.current, S);
      }
    }
    var Ze = _.ReactCurrentOwner, gn = _.ReactDebugCurrentFrame;
    function Le(t) {
      if (t) {
        var c = t._owner, p = se(t.type, t._source, c ? c.type : null);
        gn.setExtraStackFrame(p);
      } else
        gn.setExtraStackFrame(null);
    }
    var dn;
    dn = !1;
    function un(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function Nn() {
      {
        if (Ze.current) {
          var t = P(Ze.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Bn(t) {
      return "";
    }
    var Sn = {};
    function An(t) {
      {
        var c = Nn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function vn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = An(c);
        if (Sn[p])
          return;
        Sn[p] = !0;
        var y = "";
        t && t._owner && t._owner !== Ze.current && (y = " It was passed a child from " + P(t._owner.type) + "."), Le(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Le(null);
      }
    }
    function xn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (E(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            un(y) && vn(y, c);
          }
        else if (un(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var C = j(t);
          if (typeof C == "function" && C !== t.entries)
            for (var T = C.call(t), S; !(S = T.next()).done; )
              un(S.value) && vn(S.value, c);
        }
      }
    }
    function Ln(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var y = P(c);
          kn(p, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !dn) {
          dn = !0;
          var C = P(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", C || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var y = c[p];
          if (y !== "children" && y !== "key") {
            Le(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Le(null);
            break;
          }
        }
        t.ref !== null && (Le(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Le(null));
      }
    }
    var Cn = {};
    function wn(t, c, p, y, C, T) {
      {
        var S = ne(t);
        if (!S) {
          var x = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (x += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ee = Bn();
          ee ? x += ee : x += Nn();
          var A;
          t === null ? A = "null" : E(t) ? A = "array" : t !== void 0 && t.$$typeof === n ? (A = "<" + (P(t.type) || "Unknown") + " />", x = " Did you accidentally export a JSX literal instead of a component?") : A = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", A, x);
        }
        var M = Fn(t, c, p, C, T);
        if (M == null)
          return M;
        if (S) {
          var ue = c.children;
          if (ue !== void 0)
            if (y)
              if (E(ue)) {
                for (var ze = 0; ze < ue.length; ze++)
                  xn(ue[ze], t);
                Object.freeze && Object.freeze(ue);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              xn(ue, t);
        }
        if (ce.call(c, "key")) {
          var Te = P(t), re = Object.keys(c).filter(function(Gn) {
            return Gn !== "key";
          }), mn = re.length > 0 ? "{key: someKey, " + re.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Cn[Te + mn]) {
            var Dn = re.length > 0 ? "{" + re.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, mn, Te, Dn, Te), Cn[Te + mn] = !0;
          }
        }
        return t === i ? Vn(M) : Ln(M), M;
      }
    }
    function zn(t, c, p) {
      return wn(t, c, p, !0);
    }
    function qn(t, c, p) {
      return wn(t, c, p, !1);
    }
    var Un = qn, Kn = zn;
    Vs.Fragment = i, Vs.jsx = Un, Vs.jsxs = Kn;
  })()), Vs;
}
var ZS;
function eH() {
  return ZS || (ZS = 1, process.env.NODE_ENV === "production" ? ep.exports = X6() : ep.exports = Z6()), ep.exports;
}
var Ao = eH();
function nH(e) {
  return !e || typeof e == "boolean" || typeof e == "string" ? !!e : e.value;
}
var np, e0;
function Ni() {
  if (e0) return np;
  e0 = 1;
  var e = Array.isArray;
  return np = e, np;
}
var tp, n0;
function pF() {
  if (n0) return tp;
  n0 = 1;
  var e = typeof Ls == "object" && Ls && Ls.Object === Object && Ls;
  return tp = e, tp;
}
var rp, t0;
function Qr() {
  if (t0) return rp;
  t0 = 1;
  var e = pF(), n = typeof self == "object" && self && self.Object === Object && self, r = e || n || Function("return this")();
  return rp = r, rp;
}
var ip, r0;
function ls() {
  if (r0) return ip;
  r0 = 1;
  var e = Qr(), n = e.Symbol;
  return ip = n, ip;
}
var ap, i0;
function tH() {
  if (i0) return ap;
  i0 = 1;
  var e = ls(), n = Object.prototype, r = n.hasOwnProperty, i = n.toString, a = e ? e.toStringTag : void 0;
  function o(s) {
    var l = r.call(s, a), d = s[a];
    try {
      s[a] = void 0;
      var m = !0;
    } catch {
    }
    var u = i.call(s);
    return m && (l ? s[a] = d : delete s[a]), u;
  }
  return ap = o, ap;
}
var op, a0;
function rH() {
  if (a0) return op;
  a0 = 1;
  var e = Object.prototype, n = e.toString;
  function r(i) {
    return n.call(i);
  }
  return op = r, op;
}
var sp, o0;
function La() {
  if (o0) return sp;
  o0 = 1;
  var e = ls(), n = tH(), r = rH(), i = "[object Null]", a = "[object Undefined]", o = e ? e.toStringTag : void 0;
  function s(l) {
    return l == null ? l === void 0 ? a : i : o && o in Object(l) ? n(l) : r(l);
  }
  return sp = s, sp;
}
var lp, s0;
function Qi() {
  if (s0) return lp;
  s0 = 1;
  function e(n) {
    return n != null && typeof n == "object";
  }
  return lp = e, lp;
}
var cp, l0;
function Lg() {
  if (l0) return cp;
  l0 = 1;
  var e = La(), n = Qi(), r = "[object Symbol]";
  function i(a) {
    return typeof a == "symbol" || n(a) && e(a) == r;
  }
  return cp = i, cp;
}
var dp, c0;
function iH() {
  if (c0) return dp;
  c0 = 1;
  var e = Ni(), n = Lg(), r = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, i = /^\w*$/;
  function a(o, s) {
    if (e(o))
      return !1;
    var l = typeof o;
    return l == "number" || l == "symbol" || l == "boolean" || o == null || n(o) ? !0 : i.test(o) || !r.test(o) || s != null && o in Object(s);
  }
  return dp = a, dp;
}
var up, d0;
function Va() {
  if (d0) return up;
  d0 = 1;
  function e(n) {
    var r = typeof n;
    return n != null && (r == "object" || r == "function");
  }
  return up = e, up;
}
var mp, u0;
function fF() {
  if (u0) return mp;
  u0 = 1;
  var e = La(), n = Va(), r = "[object AsyncFunction]", i = "[object Function]", a = "[object GeneratorFunction]", o = "[object Proxy]";
  function s(l) {
    if (!n(l))
      return !1;
    var d = e(l);
    return d == i || d == a || d == r || d == o;
  }
  return mp = s, mp;
}
var pp, m0;
function aH() {
  if (m0) return pp;
  m0 = 1;
  var e = Qr(), n = e["__core-js_shared__"];
  return pp = n, pp;
}
var fp, p0;
function oH() {
  if (p0) return fp;
  p0 = 1;
  var e = aH(), n = (function() {
    var i = /[^.]+$/.exec(e && e.keys && e.keys.IE_PROTO || "");
    return i ? "Symbol(src)_1." + i : "";
  })();
  function r(i) {
    return !!n && n in i;
  }
  return fp = r, fp;
}
var hp, f0;
function hF() {
  if (f0) return hp;
  f0 = 1;
  var e = Function.prototype, n = e.toString;
  function r(i) {
    if (i != null) {
      try {
        return n.call(i);
      } catch {
      }
      try {
        return i + "";
      } catch {
      }
    }
    return "";
  }
  return hp = r, hp;
}
var yp, h0;
function sH() {
  if (h0) return yp;
  h0 = 1;
  var e = fF(), n = oH(), r = Va(), i = hF(), a = /[\\^$.*+?()[\]{}|]/g, o = /^\[object .+?Constructor\]$/, s = Function.prototype, l = Object.prototype, d = s.toString, m = l.hasOwnProperty, u = RegExp(
    "^" + d.call(m).replace(a, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  );
  function f(h) {
    if (!r(h) || n(h))
      return !1;
    var v = e(h) ? u : o;
    return v.test(i(h));
  }
  return yp = f, yp;
}
var gp, y0;
function lH() {
  if (y0) return gp;
  y0 = 1;
  function e(n, r) {
    return n?.[r];
  }
  return gp = e, gp;
}
var vp, g0;
function Xi() {
  if (g0) return vp;
  g0 = 1;
  var e = sH(), n = lH();
  function r(i, a) {
    var o = n(i, a);
    return e(o) ? o : void 0;
  }
  return vp = r, vp;
}
var kp, v0;
function fc() {
  if (v0) return kp;
  v0 = 1;
  var e = Xi(), n = e(Object, "create");
  return kp = n, kp;
}
var bp, k0;
function cH() {
  if (k0) return bp;
  k0 = 1;
  var e = fc();
  function n() {
    this.__data__ = e ? e(null) : {}, this.size = 0;
  }
  return bp = n, bp;
}
var _p, b0;
function dH() {
  if (b0) return _p;
  b0 = 1;
  function e(n) {
    var r = this.has(n) && delete this.__data__[n];
    return this.size -= r ? 1 : 0, r;
  }
  return _p = e, _p;
}
var xp, _0;
function uH() {
  if (_0) return xp;
  _0 = 1;
  var e = fc(), n = "__lodash_hash_undefined__", r = Object.prototype, i = r.hasOwnProperty;
  function a(o) {
    var s = this.__data__;
    if (e) {
      var l = s[o];
      return l === n ? void 0 : l;
    }
    return i.call(s, o) ? s[o] : void 0;
  }
  return xp = a, xp;
}
var Sp, x0;
function mH() {
  if (x0) return Sp;
  x0 = 1;
  var e = fc(), n = Object.prototype, r = n.hasOwnProperty;
  function i(a) {
    var o = this.__data__;
    return e ? o[a] !== void 0 : r.call(o, a);
  }
  return Sp = i, Sp;
}
var Np, S0;
function pH() {
  if (S0) return Np;
  S0 = 1;
  var e = fc(), n = "__lodash_hash_undefined__";
  function r(i, a) {
    var o = this.__data__;
    return this.size += this.has(i) ? 0 : 1, o[i] = e && a === void 0 ? n : a, this;
  }
  return Np = r, Np;
}
var jp, N0;
function fH() {
  if (N0) return jp;
  N0 = 1;
  var e = cH(), n = dH(), r = uH(), i = mH(), a = pH();
  function o(s) {
    var l = -1, d = s == null ? 0 : s.length;
    for (this.clear(); ++l < d; ) {
      var m = s[l];
      this.set(m[0], m[1]);
    }
  }
  return o.prototype.clear = e, o.prototype.delete = n, o.prototype.get = r, o.prototype.has = i, o.prototype.set = a, jp = o, jp;
}
var wp, j0;
function hH() {
  if (j0) return wp;
  j0 = 1;
  function e() {
    this.__data__ = [], this.size = 0;
  }
  return wp = e, wp;
}
var Cp, w0;
function yF() {
  if (w0) return Cp;
  w0 = 1;
  function e(n, r) {
    return n === r || n !== n && r !== r;
  }
  return Cp = e, Cp;
}
var Fp, C0;
function hc() {
  if (C0) return Fp;
  C0 = 1;
  var e = yF();
  function n(r, i) {
    for (var a = r.length; a--; )
      if (e(r[a][0], i))
        return a;
    return -1;
  }
  return Fp = n, Fp;
}
var Ip, F0;
function yH() {
  if (F0) return Ip;
  F0 = 1;
  var e = hc(), n = Array.prototype, r = n.splice;
  function i(a) {
    var o = this.__data__, s = e(o, a);
    if (s < 0)
      return !1;
    var l = o.length - 1;
    return s == l ? o.pop() : r.call(o, s, 1), --this.size, !0;
  }
  return Ip = i, Ip;
}
var $p, I0;
function gH() {
  if (I0) return $p;
  I0 = 1;
  var e = hc();
  function n(r) {
    var i = this.__data__, a = e(i, r);
    return a < 0 ? void 0 : i[a][1];
  }
  return $p = n, $p;
}
var Ep, $0;
function vH() {
  if ($0) return Ep;
  $0 = 1;
  var e = hc();
  function n(r) {
    return e(this.__data__, r) > -1;
  }
  return Ep = n, Ep;
}
var Tp, E0;
function kH() {
  if (E0) return Tp;
  E0 = 1;
  var e = hc();
  function n(r, i) {
    var a = this.__data__, o = e(a, r);
    return o < 0 ? (++this.size, a.push([r, i])) : a[o][1] = i, this;
  }
  return Tp = n, Tp;
}
var Rp, T0;
function yc() {
  if (T0) return Rp;
  T0 = 1;
  var e = hH(), n = yH(), r = gH(), i = vH(), a = kH();
  function o(s) {
    var l = -1, d = s == null ? 0 : s.length;
    for (this.clear(); ++l < d; ) {
      var m = s[l];
      this.set(m[0], m[1]);
    }
  }
  return o.prototype.clear = e, o.prototype.delete = n, o.prototype.get = r, o.prototype.has = i, o.prototype.set = a, Rp = o, Rp;
}
var Dp, R0;
function Vg() {
  if (R0) return Dp;
  R0 = 1;
  var e = Xi(), n = Qr(), r = e(n, "Map");
  return Dp = r, Dp;
}
var Op, D0;
function bH() {
  if (D0) return Op;
  D0 = 1;
  var e = fH(), n = yc(), r = Vg();
  function i() {
    this.size = 0, this.__data__ = {
      hash: new e(),
      map: new (r || n)(),
      string: new e()
    };
  }
  return Op = i, Op;
}
var Pp, O0;
function _H() {
  if (O0) return Pp;
  O0 = 1;
  function e(n) {
    var r = typeof n;
    return r == "string" || r == "number" || r == "symbol" || r == "boolean" ? n !== "__proto__" : n === null;
  }
  return Pp = e, Pp;
}
var Ap, P0;
function gc() {
  if (P0) return Ap;
  P0 = 1;
  var e = _H();
  function n(r, i) {
    var a = r.__data__;
    return e(i) ? a[typeof i == "string" ? "string" : "hash"] : a.map;
  }
  return Ap = n, Ap;
}
var Lp, A0;
function xH() {
  if (A0) return Lp;
  A0 = 1;
  var e = gc();
  function n(r) {
    var i = e(this, r).delete(r);
    return this.size -= i ? 1 : 0, i;
  }
  return Lp = n, Lp;
}
var Vp, L0;
function SH() {
  if (L0) return Vp;
  L0 = 1;
  var e = gc();
  function n(r) {
    return e(this, r).get(r);
  }
  return Vp = n, Vp;
}
var zp, V0;
function NH() {
  if (V0) return zp;
  V0 = 1;
  var e = gc();
  function n(r) {
    return e(this, r).has(r);
  }
  return zp = n, zp;
}
var Up, z0;
function jH() {
  if (z0) return Up;
  z0 = 1;
  var e = gc();
  function n(r, i) {
    var a = e(this, r), o = a.size;
    return a.set(r, i), this.size += a.size == o ? 0 : 1, this;
  }
  return Up = n, Up;
}
var Mp, U0;
function gF() {
  if (U0) return Mp;
  U0 = 1;
  var e = bH(), n = xH(), r = SH(), i = NH(), a = jH();
  function o(s) {
    var l = -1, d = s == null ? 0 : s.length;
    for (this.clear(); ++l < d; ) {
      var m = s[l];
      this.set(m[0], m[1]);
    }
  }
  return o.prototype.clear = e, o.prototype.delete = n, o.prototype.get = r, o.prototype.has = i, o.prototype.set = a, Mp = o, Mp;
}
var Bp, M0;
function wH() {
  if (M0) return Bp;
  M0 = 1;
  var e = gF(), n = "Expected a function";
  function r(i, a) {
    if (typeof i != "function" || a != null && typeof a != "function")
      throw new TypeError(n);
    var o = function() {
      var s = arguments, l = a ? a.apply(this, s) : s[0], d = o.cache;
      if (d.has(l))
        return d.get(l);
      var m = i.apply(this, s);
      return o.cache = d.set(l, m) || d, m;
    };
    return o.cache = new (r.Cache || e)(), o;
  }
  return r.Cache = e, Bp = r, Bp;
}
var qp, B0;
function CH() {
  if (B0) return qp;
  B0 = 1;
  var e = wH(), n = 500;
  function r(i) {
    var a = e(i, function(s) {
      return o.size === n && o.clear(), s;
    }), o = a.cache;
    return a;
  }
  return qp = r, qp;
}
var Hp, q0;
function FH() {
  if (q0) return Hp;
  q0 = 1;
  var e = CH(), n = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, r = /\\(\\)?/g, i = e(function(a) {
    var o = [];
    return a.charCodeAt(0) === 46 && o.push(""), a.replace(n, function(s, l, d, m) {
      o.push(d ? m.replace(r, "$1") : l || s);
    }), o;
  });
  return Hp = i, Hp;
}
var Wp, H0;
function vF() {
  if (H0) return Wp;
  H0 = 1;
  function e(n, r) {
    for (var i = -1, a = n == null ? 0 : n.length, o = Array(a); ++i < a; )
      o[i] = r(n[i], i, n);
    return o;
  }
  return Wp = e, Wp;
}
var Kp, W0;
function IH() {
  if (W0) return Kp;
  W0 = 1;
  var e = ls(), n = vF(), r = Ni(), i = Lg(), a = e ? e.prototype : void 0, o = a ? a.toString : void 0;
  function s(l) {
    if (typeof l == "string")
      return l;
    if (r(l))
      return n(l, s) + "";
    if (i(l))
      return o ? o.call(l) : "";
    var d = l + "";
    return d == "0" && 1 / l == -1 / 0 ? "-0" : d;
  }
  return Kp = s, Kp;
}
var Gp, K0;
function $H() {
  if (K0) return Gp;
  K0 = 1;
  var e = IH();
  function n(r) {
    return r == null ? "" : e(r);
  }
  return Gp = n, Gp;
}
var Yp, G0;
function za() {
  if (G0) return Yp;
  G0 = 1;
  var e = Ni(), n = iH(), r = FH(), i = $H();
  function a(o, s) {
    return e(o) ? o : n(o, s) ? [o] : r(i(o));
  }
  return Yp = a, Yp;
}
var Jp, Y0;
function vc() {
  if (Y0) return Jp;
  Y0 = 1;
  var e = Lg();
  function n(r) {
    if (typeof r == "string" || e(r))
      return r;
    var i = r + "";
    return i == "0" && 1 / r == -1 / 0 ? "-0" : i;
  }
  return Jp = n, Jp;
}
var Qp, J0;
function kF() {
  if (J0) return Qp;
  J0 = 1;
  var e = za(), n = vc();
  function r(i, a) {
    a = e(a, i);
    for (var o = 0, s = a.length; i != null && o < s; )
      i = i[n(a[o++])];
    return o && o == s ? i : void 0;
  }
  return Qp = r, Qp;
}
var Xp, Q0;
function bF() {
  if (Q0) return Xp;
  Q0 = 1;
  var e = Xi(), n = (function() {
    try {
      var r = e(Object, "defineProperty");
      return r({}, "", {}), r;
    } catch {
    }
  })();
  return Xp = n, Xp;
}
var Zp, X0;
function _F() {
  if (X0) return Zp;
  X0 = 1;
  var e = bF();
  function n(r, i, a) {
    i == "__proto__" && e ? e(r, i, {
      configurable: !0,
      enumerable: !0,
      value: a,
      writable: !0
    }) : r[i] = a;
  }
  return Zp = n, Zp;
}
var ef, Z0;
function zg() {
  if (Z0) return ef;
  Z0 = 1;
  var e = _F(), n = yF(), r = Object.prototype, i = r.hasOwnProperty;
  function a(o, s, l) {
    var d = o[s];
    (!(i.call(o, s) && n(d, l)) || l === void 0 && !(s in o)) && e(o, s, l);
  }
  return ef = a, ef;
}
var nf, eN;
function Ug() {
  if (eN) return nf;
  eN = 1;
  var e = 9007199254740991, n = /^(?:0|[1-9]\d*)$/;
  function r(i, a) {
    var o = typeof i;
    return a = a ?? e, !!a && (o == "number" || o != "symbol" && n.test(i)) && i > -1 && i % 1 == 0 && i < a;
  }
  return nf = r, nf;
}
var tf, nN;
function EH() {
  if (nN) return tf;
  nN = 1;
  var e = zg(), n = za(), r = Ug(), i = Va(), a = vc();
  function o(s, l, d, m) {
    if (!i(s))
      return s;
    l = n(l, s);
    for (var u = -1, f = l.length, h = f - 1, v = s; v != null && ++u < f; ) {
      var w = a(l[u]), N = d;
      if (w === "__proto__" || w === "constructor" || w === "prototype")
        return s;
      if (u != h) {
        var j = v[w];
        N = m ? m(j, w, v) : void 0, N === void 0 && (N = i(j) ? j : r(l[u + 1]) ? [] : {});
      }
      e(v, w, N), v = v[w];
    }
    return s;
  }
  return tf = o, tf;
}
var rf, tN;
function TH() {
  if (tN) return rf;
  tN = 1;
  var e = kF(), n = EH(), r = za();
  function i(a, o, s) {
    for (var l = -1, d = o.length, m = {}; ++l < d; ) {
      var u = o[l], f = e(a, u);
      s(f, u) && n(m, r(u, a), f);
    }
    return m;
  }
  return rf = i, rf;
}
var af, rN;
function RH() {
  if (rN) return af;
  rN = 1;
  function e(n, r) {
    return n != null && r in Object(n);
  }
  return af = e, af;
}
var of, iN;
function DH() {
  if (iN) return of;
  iN = 1;
  var e = La(), n = Qi(), r = "[object Arguments]";
  function i(a) {
    return n(a) && e(a) == r;
  }
  return of = i, of;
}
var sf, aN;
function Mg() {
  if (aN) return sf;
  aN = 1;
  var e = DH(), n = Qi(), r = Object.prototype, i = r.hasOwnProperty, a = r.propertyIsEnumerable, o = e(/* @__PURE__ */ (function() {
    return arguments;
  })()) ? e : function(s) {
    return n(s) && i.call(s, "callee") && !a.call(s, "callee");
  };
  return sf = o, sf;
}
var lf, oN;
function Bg() {
  if (oN) return lf;
  oN = 1;
  var e = 9007199254740991;
  function n(r) {
    return typeof r == "number" && r > -1 && r % 1 == 0 && r <= e;
  }
  return lf = n, lf;
}
var cf, sN;
function OH() {
  if (sN) return cf;
  sN = 1;
  var e = za(), n = Mg(), r = Ni(), i = Ug(), a = Bg(), o = vc();
  function s(l, d, m) {
    d = e(d, l);
    for (var u = -1, f = d.length, h = !1; ++u < f; ) {
      var v = o(d[u]);
      if (!(h = l != null && m(l, v)))
        break;
      l = l[v];
    }
    return h || ++u != f ? h : (f = l == null ? 0 : l.length, !!f && a(f) && i(v, f) && (r(l) || n(l)));
  }
  return cf = s, cf;
}
var df, lN;
function PH() {
  if (lN) return df;
  lN = 1;
  var e = RH(), n = OH();
  function r(i, a) {
    return i != null && n(i, a, e);
  }
  return df = r, df;
}
var uf, cN;
function AH() {
  if (cN) return uf;
  cN = 1;
  var e = TH(), n = PH();
  function r(i, a) {
    return e(i, a, function(o, s) {
      return n(i, s);
    });
  }
  return uf = r, uf;
}
var mf, dN;
function qg() {
  if (dN) return mf;
  dN = 1;
  function e(n, r) {
    for (var i = -1, a = r.length, o = n.length; ++i < a; )
      n[o + i] = r[i];
    return n;
  }
  return mf = e, mf;
}
var pf, uN;
function LH() {
  if (uN) return pf;
  uN = 1;
  var e = ls(), n = Mg(), r = Ni(), i = e ? e.isConcatSpreadable : void 0;
  function a(o) {
    return r(o) || n(o) || !!(i && o && o[i]);
  }
  return pf = a, pf;
}
var ff, mN;
function VH() {
  if (mN) return ff;
  mN = 1;
  var e = qg(), n = LH();
  function r(i, a, o, s, l) {
    var d = -1, m = i.length;
    for (o || (o = n), l || (l = []); ++d < m; ) {
      var u = i[d];
      a > 0 && o(u) ? a > 1 ? r(u, a - 1, o, s, l) : e(l, u) : s || (l[l.length] = u);
    }
    return l;
  }
  return ff = r, ff;
}
var hf, pN;
function zH() {
  if (pN) return hf;
  pN = 1;
  var e = VH();
  function n(r) {
    var i = r == null ? 0 : r.length;
    return i ? e(r, 1) : [];
  }
  return hf = n, hf;
}
var yf, fN;
function UH() {
  if (fN) return yf;
  fN = 1;
  function e(n, r, i) {
    switch (i.length) {
      case 0:
        return n.call(r);
      case 1:
        return n.call(r, i[0]);
      case 2:
        return n.call(r, i[0], i[1]);
      case 3:
        return n.call(r, i[0], i[1], i[2]);
    }
    return n.apply(r, i);
  }
  return yf = e, yf;
}
var gf, hN;
function MH() {
  if (hN) return gf;
  hN = 1;
  var e = UH(), n = Math.max;
  function r(i, a, o) {
    return a = n(a === void 0 ? i.length - 1 : a, 0), function() {
      for (var s = arguments, l = -1, d = n(s.length - a, 0), m = Array(d); ++l < d; )
        m[l] = s[a + l];
      l = -1;
      for (var u = Array(a + 1); ++l < a; )
        u[l] = s[l];
      return u[a] = o(m), e(i, this, u);
    };
  }
  return gf = r, gf;
}
var vf, yN;
function BH() {
  if (yN) return vf;
  yN = 1;
  function e(n) {
    return function() {
      return n;
    };
  }
  return vf = e, vf;
}
var kf, gN;
function xF() {
  if (gN) return kf;
  gN = 1;
  function e(n) {
    return n;
  }
  return kf = e, kf;
}
var bf, vN;
function qH() {
  if (vN) return bf;
  vN = 1;
  var e = BH(), n = bF(), r = xF(), i = n ? function(a, o) {
    return n(a, "toString", {
      configurable: !0,
      enumerable: !1,
      value: e(o),
      writable: !0
    });
  } : r;
  return bf = i, bf;
}
var _f, kN;
function HH() {
  if (kN) return _f;
  kN = 1;
  var e = 800, n = 16, r = Date.now;
  function i(a) {
    var o = 0, s = 0;
    return function() {
      var l = r(), d = n - (l - s);
      if (s = l, d > 0) {
        if (++o >= e)
          return arguments[0];
      } else
        o = 0;
      return a.apply(void 0, arguments);
    };
  }
  return _f = i, _f;
}
var xf, bN;
function WH() {
  if (bN) return xf;
  bN = 1;
  var e = qH(), n = HH(), r = n(e);
  return xf = r, xf;
}
var Sf, _N;
function SF() {
  if (_N) return Sf;
  _N = 1;
  var e = zH(), n = MH(), r = WH();
  function i(a) {
    return r(n(a, void 0, e), a + "");
  }
  return Sf = i, Sf;
}
var Nf, xN;
function KH() {
  if (xN) return Nf;
  xN = 1;
  var e = AH(), n = SF(), r = n(function(i, a) {
    return i == null ? {} : e(i, a);
  });
  return Nf = r, Nf;
}
var GH = KH();
const NF = /* @__PURE__ */ mF(GH), YH = [
  "control",
  "defaultValue",
  "name",
  "rules",
  "shouldUnregister"
];
function jF(e) {
  const n = NF(e, YH);
  return {
    controller: P6(n),
    controllerProps: n
  };
}
const JH = [
  "className",
  "description",
  "disabled",
  "helpIcon",
  "label",
  "noAlert",
  "noLabel",
  "style"
];
function QH(e) {
  const { controller: n, controllerProps: r } = jF(e), i = {
    ...NF(e, JH),
    required: nH(r.rules?.required),
    meta: {
      touched: n.fieldState.isTouched,
      error: n.fieldState.error?.message,
      success: e.meta?.success,
      warning: e.meta?.warning
    },
    labelFor: r.name,
    noLabel: e.noLabel,
    noAlert: e.noAlert
  };
  return {
    controller: n,
    controllerProps: r,
    fieldWrapperProps: i
  };
}
var jf, SN;
function XH() {
  if (SN) return jf;
  SN = 1;
  var e = yc();
  function n() {
    this.__data__ = new e(), this.size = 0;
  }
  return jf = n, jf;
}
var wf, NN;
function ZH() {
  if (NN) return wf;
  NN = 1;
  function e(n) {
    var r = this.__data__, i = r.delete(n);
    return this.size = r.size, i;
  }
  return wf = e, wf;
}
var Cf, jN;
function eW() {
  if (jN) return Cf;
  jN = 1;
  function e(n) {
    return this.__data__.get(n);
  }
  return Cf = e, Cf;
}
var Ff, wN;
function nW() {
  if (wN) return Ff;
  wN = 1;
  function e(n) {
    return this.__data__.has(n);
  }
  return Ff = e, Ff;
}
var If, CN;
function tW() {
  if (CN) return If;
  CN = 1;
  var e = yc(), n = Vg(), r = gF(), i = 200;
  function a(o, s) {
    var l = this.__data__;
    if (l instanceof e) {
      var d = l.__data__;
      if (!n || d.length < i - 1)
        return d.push([o, s]), this.size = ++l.size, this;
      l = this.__data__ = new r(d);
    }
    return l.set(o, s), this.size = l.size, this;
  }
  return If = a, If;
}
var $f, FN;
function rW() {
  if (FN) return $f;
  FN = 1;
  var e = yc(), n = XH(), r = ZH(), i = eW(), a = nW(), o = tW();
  function s(l) {
    var d = this.__data__ = new e(l);
    this.size = d.size;
  }
  return s.prototype.clear = n, s.prototype.delete = r, s.prototype.get = i, s.prototype.has = a, s.prototype.set = o, $f = s, $f;
}
var Ef, IN;
function iW() {
  if (IN) return Ef;
  IN = 1;
  function e(n, r) {
    for (var i = -1, a = n == null ? 0 : n.length; ++i < a && r(n[i], i, n) !== !1; )
      ;
    return n;
  }
  return Ef = e, Ef;
}
var Tf, $N;
function cs() {
  if ($N) return Tf;
  $N = 1;
  var e = zg(), n = _F();
  function r(i, a, o, s) {
    var l = !o;
    o || (o = {});
    for (var d = -1, m = a.length; ++d < m; ) {
      var u = a[d], f = s ? s(o[u], i[u], u, o, i) : void 0;
      f === void 0 && (f = i[u]), l ? n(o, u, f) : e(o, u, f);
    }
    return o;
  }
  return Tf = r, Tf;
}
var Rf, EN;
function aW() {
  if (EN) return Rf;
  EN = 1;
  function e(n, r) {
    for (var i = -1, a = Array(n); ++i < n; )
      a[i] = r(i);
    return a;
  }
  return Rf = e, Rf;
}
var ll = { exports: {} }, Df, TN;
function oW() {
  if (TN) return Df;
  TN = 1;
  function e() {
    return !1;
  }
  return Df = e, Df;
}
ll.exports;
var RN;
function wF() {
  return RN || (RN = 1, (function(e, n) {
    var r = Qr(), i = oW(), a = n && !n.nodeType && n, o = a && !0 && e && !e.nodeType && e, s = o && o.exports === a, l = s ? r.Buffer : void 0, d = l ? l.isBuffer : void 0, m = d || i;
    e.exports = m;
  })(ll, ll.exports)), ll.exports;
}
var Of, DN;
function sW() {
  if (DN) return Of;
  DN = 1;
  var e = La(), n = Bg(), r = Qi(), i = "[object Arguments]", a = "[object Array]", o = "[object Boolean]", s = "[object Date]", l = "[object Error]", d = "[object Function]", m = "[object Map]", u = "[object Number]", f = "[object Object]", h = "[object RegExp]", v = "[object Set]", w = "[object String]", N = "[object WeakMap]", j = "[object ArrayBuffer]", _ = "[object DataView]", g = "[object Float32Array]", O = "[object Float64Array]", R = "[object Int8Array]", $ = "[object Int16Array]", I = "[object Int32Array]", L = "[object Uint8Array]", G = "[object Uint8ClampedArray]", Q = "[object Uint16Array]", ne = "[object Uint32Array]", q = {};
  q[g] = q[O] = q[R] = q[$] = q[I] = q[L] = q[G] = q[Q] = q[ne] = !0, q[i] = q[a] = q[j] = q[o] = q[_] = q[s] = q[l] = q[d] = q[m] = q[u] = q[f] = q[h] = q[v] = q[w] = q[N] = !1;
  function Y(P) {
    return r(P) && n(P.length) && !!q[e(P)];
  }
  return Of = Y, Of;
}
var Pf, ON;
function Hg() {
  if (ON) return Pf;
  ON = 1;
  function e(n) {
    return function(r) {
      return n(r);
    };
  }
  return Pf = e, Pf;
}
var cl = { exports: {} };
cl.exports;
var PN;
function Wg() {
  return PN || (PN = 1, (function(e, n) {
    var r = pF(), i = n && !n.nodeType && n, a = i && !0 && e && !e.nodeType && e, o = a && a.exports === i, s = o && r.process, l = (function() {
      try {
        var d = a && a.require && a.require("util").types;
        return d || s && s.binding && s.binding("util");
      } catch {
      }
    })();
    e.exports = l;
  })(cl, cl.exports)), cl.exports;
}
var Af, AN;
function lW() {
  if (AN) return Af;
  AN = 1;
  var e = sW(), n = Hg(), r = Wg(), i = r && r.isTypedArray, a = i ? n(i) : e;
  return Af = a, Af;
}
var Lf, LN;
function CF() {
  if (LN) return Lf;
  LN = 1;
  var e = aW(), n = Mg(), r = Ni(), i = wF(), a = Ug(), o = lW(), s = Object.prototype, l = s.hasOwnProperty;
  function d(m, u) {
    var f = r(m), h = !f && n(m), v = !f && !h && i(m), w = !f && !h && !v && o(m), N = f || h || v || w, j = N ? e(m.length, String) : [], _ = j.length;
    for (var g in m)
      (u || l.call(m, g)) && !(N && // Safari 9 has enumerable `arguments.length` in strict mode.
      (g == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      v && (g == "offset" || g == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      w && (g == "buffer" || g == "byteLength" || g == "byteOffset") || // Skip index properties.
      a(g, _))) && j.push(g);
    return j;
  }
  return Lf = d, Lf;
}
var Vf, VN;
function Kg() {
  if (VN) return Vf;
  VN = 1;
  var e = Object.prototype;
  function n(r) {
    var i = r && r.constructor, a = typeof i == "function" && i.prototype || e;
    return r === a;
  }
  return Vf = n, Vf;
}
var zf, zN;
function FF() {
  if (zN) return zf;
  zN = 1;
  function e(n, r) {
    return function(i) {
      return n(r(i));
    };
  }
  return zf = e, zf;
}
var Uf, UN;
function cW() {
  if (UN) return Uf;
  UN = 1;
  var e = FF(), n = e(Object.keys, Object);
  return Uf = n, Uf;
}
var Mf, MN;
function dW() {
  if (MN) return Mf;
  MN = 1;
  var e = Kg(), n = cW(), r = Object.prototype, i = r.hasOwnProperty;
  function a(o) {
    if (!e(o))
      return n(o);
    var s = [];
    for (var l in Object(o))
      i.call(o, l) && l != "constructor" && s.push(l);
    return s;
  }
  return Mf = a, Mf;
}
var Bf, BN;
function IF() {
  if (BN) return Bf;
  BN = 1;
  var e = fF(), n = Bg();
  function r(i) {
    return i != null && n(i.length) && !e(i);
  }
  return Bf = r, Bf;
}
var qf, qN;
function Gg() {
  if (qN) return qf;
  qN = 1;
  var e = CF(), n = dW(), r = IF();
  function i(a) {
    return r(a) ? e(a) : n(a);
  }
  return qf = i, qf;
}
var Hf, HN;
function uW() {
  if (HN) return Hf;
  HN = 1;
  var e = cs(), n = Gg();
  function r(i, a) {
    return i && e(a, n(a), i);
  }
  return Hf = r, Hf;
}
var Wf, WN;
function mW() {
  if (WN) return Wf;
  WN = 1;
  function e(n) {
    var r = [];
    if (n != null)
      for (var i in Object(n))
        r.push(i);
    return r;
  }
  return Wf = e, Wf;
}
var Kf, KN;
function pW() {
  if (KN) return Kf;
  KN = 1;
  var e = Va(), n = Kg(), r = mW(), i = Object.prototype, a = i.hasOwnProperty;
  function o(s) {
    if (!e(s))
      return r(s);
    var l = n(s), d = [];
    for (var m in s)
      m == "constructor" && (l || !a.call(s, m)) || d.push(m);
    return d;
  }
  return Kf = o, Kf;
}
var Gf, GN;
function Yg() {
  if (GN) return Gf;
  GN = 1;
  var e = CF(), n = pW(), r = IF();
  function i(a) {
    return r(a) ? e(a, !0) : n(a);
  }
  return Gf = i, Gf;
}
var Yf, YN;
function fW() {
  if (YN) return Yf;
  YN = 1;
  var e = cs(), n = Yg();
  function r(i, a) {
    return i && e(a, n(a), i);
  }
  return Yf = r, Yf;
}
var dl = { exports: {} };
dl.exports;
var JN;
function hW() {
  return JN || (JN = 1, (function(e, n) {
    var r = Qr(), i = n && !n.nodeType && n, a = i && !0 && e && !e.nodeType && e, o = a && a.exports === i, s = o ? r.Buffer : void 0, l = s ? s.allocUnsafe : void 0;
    function d(m, u) {
      if (u)
        return m.slice();
      var f = m.length, h = l ? l(f) : new m.constructor(f);
      return m.copy(h), h;
    }
    e.exports = d;
  })(dl, dl.exports)), dl.exports;
}
var Jf, QN;
function yW() {
  if (QN) return Jf;
  QN = 1;
  function e(n, r) {
    var i = -1, a = n.length;
    for (r || (r = Array(a)); ++i < a; )
      r[i] = n[i];
    return r;
  }
  return Jf = e, Jf;
}
var Qf, XN;
function gW() {
  if (XN) return Qf;
  XN = 1;
  function e(n, r) {
    for (var i = -1, a = n == null ? 0 : n.length, o = 0, s = []; ++i < a; ) {
      var l = n[i];
      r(l, i, n) && (s[o++] = l);
    }
    return s;
  }
  return Qf = e, Qf;
}
var Xf, ZN;
function $F() {
  if (ZN) return Xf;
  ZN = 1;
  function e() {
    return [];
  }
  return Xf = e, Xf;
}
var Zf, ej;
function Jg() {
  if (ej) return Zf;
  ej = 1;
  var e = gW(), n = $F(), r = Object.prototype, i = r.propertyIsEnumerable, a = Object.getOwnPropertySymbols, o = a ? function(s) {
    return s == null ? [] : (s = Object(s), e(a(s), function(l) {
      return i.call(s, l);
    }));
  } : n;
  return Zf = o, Zf;
}
var eh, nj;
function vW() {
  if (nj) return eh;
  nj = 1;
  var e = cs(), n = Jg();
  function r(i, a) {
    return e(i, n(i), a);
  }
  return eh = r, eh;
}
var nh, tj;
function Qg() {
  if (tj) return nh;
  tj = 1;
  var e = FF(), n = e(Object.getPrototypeOf, Object);
  return nh = n, nh;
}
var th, rj;
function EF() {
  if (rj) return th;
  rj = 1;
  var e = qg(), n = Qg(), r = Jg(), i = $F(), a = Object.getOwnPropertySymbols, o = a ? function(s) {
    for (var l = []; s; )
      e(l, r(s)), s = n(s);
    return l;
  } : i;
  return th = o, th;
}
var rh, ij;
function kW() {
  if (ij) return rh;
  ij = 1;
  var e = cs(), n = EF();
  function r(i, a) {
    return e(i, n(i), a);
  }
  return rh = r, rh;
}
var ih, aj;
function TF() {
  if (aj) return ih;
  aj = 1;
  var e = qg(), n = Ni();
  function r(i, a, o) {
    var s = a(i);
    return n(i) ? s : e(s, o(i));
  }
  return ih = r, ih;
}
var ah, oj;
function bW() {
  if (oj) return ah;
  oj = 1;
  var e = TF(), n = Jg(), r = Gg();
  function i(a) {
    return e(a, r, n);
  }
  return ah = i, ah;
}
var oh, sj;
function RF() {
  if (sj) return oh;
  sj = 1;
  var e = TF(), n = EF(), r = Yg();
  function i(a) {
    return e(a, r, n);
  }
  return oh = i, oh;
}
var sh, lj;
function _W() {
  if (lj) return sh;
  lj = 1;
  var e = Xi(), n = Qr(), r = e(n, "DataView");
  return sh = r, sh;
}
var lh, cj;
function xW() {
  if (cj) return lh;
  cj = 1;
  var e = Xi(), n = Qr(), r = e(n, "Promise");
  return lh = r, lh;
}
var ch, dj;
function SW() {
  if (dj) return ch;
  dj = 1;
  var e = Xi(), n = Qr(), r = e(n, "Set");
  return ch = r, ch;
}
var dh, uj;
function NW() {
  if (uj) return dh;
  uj = 1;
  var e = Xi(), n = Qr(), r = e(n, "WeakMap");
  return dh = r, dh;
}
var uh, mj;
function Xg() {
  if (mj) return uh;
  mj = 1;
  var e = _W(), n = Vg(), r = xW(), i = SW(), a = NW(), o = La(), s = hF(), l = "[object Map]", d = "[object Object]", m = "[object Promise]", u = "[object Set]", f = "[object WeakMap]", h = "[object DataView]", v = s(e), w = s(n), N = s(r), j = s(i), _ = s(a), g = o;
  return (e && g(new e(new ArrayBuffer(1))) != h || n && g(new n()) != l || r && g(r.resolve()) != m || i && g(new i()) != u || a && g(new a()) != f) && (g = function(O) {
    var R = o(O), $ = R == d ? O.constructor : void 0, I = $ ? s($) : "";
    if (I)
      switch (I) {
        case v:
          return h;
        case w:
          return l;
        case N:
          return m;
        case j:
          return u;
        case _:
          return f;
      }
    return R;
  }), uh = g, uh;
}
var mh, pj;
function jW() {
  if (pj) return mh;
  pj = 1;
  var e = Object.prototype, n = e.hasOwnProperty;
  function r(i) {
    var a = i.length, o = new i.constructor(a);
    return a && typeof i[0] == "string" && n.call(i, "index") && (o.index = i.index, o.input = i.input), o;
  }
  return mh = r, mh;
}
var ph, fj;
function wW() {
  if (fj) return ph;
  fj = 1;
  var e = Qr(), n = e.Uint8Array;
  return ph = n, ph;
}
var fh, hj;
function Zg() {
  if (hj) return fh;
  hj = 1;
  var e = wW();
  function n(r) {
    var i = new r.constructor(r.byteLength);
    return new e(i).set(new e(r)), i;
  }
  return fh = n, fh;
}
var hh, yj;
function CW() {
  if (yj) return hh;
  yj = 1;
  var e = Zg();
  function n(r, i) {
    var a = i ? e(r.buffer) : r.buffer;
    return new r.constructor(a, r.byteOffset, r.byteLength);
  }
  return hh = n, hh;
}
var yh, gj;
function FW() {
  if (gj) return yh;
  gj = 1;
  var e = /\w*$/;
  function n(r) {
    var i = new r.constructor(r.source, e.exec(r));
    return i.lastIndex = r.lastIndex, i;
  }
  return yh = n, yh;
}
var gh, vj;
function IW() {
  if (vj) return gh;
  vj = 1;
  var e = ls(), n = e ? e.prototype : void 0, r = n ? n.valueOf : void 0;
  function i(a) {
    return r ? Object(r.call(a)) : {};
  }
  return gh = i, gh;
}
var vh, kj;
function $W() {
  if (kj) return vh;
  kj = 1;
  var e = Zg();
  function n(r, i) {
    var a = i ? e(r.buffer) : r.buffer;
    return new r.constructor(a, r.byteOffset, r.length);
  }
  return vh = n, vh;
}
var kh, bj;
function EW() {
  if (bj) return kh;
  bj = 1;
  var e = Zg(), n = CW(), r = FW(), i = IW(), a = $W(), o = "[object Boolean]", s = "[object Date]", l = "[object Map]", d = "[object Number]", m = "[object RegExp]", u = "[object Set]", f = "[object String]", h = "[object Symbol]", v = "[object ArrayBuffer]", w = "[object DataView]", N = "[object Float32Array]", j = "[object Float64Array]", _ = "[object Int8Array]", g = "[object Int16Array]", O = "[object Int32Array]", R = "[object Uint8Array]", $ = "[object Uint8ClampedArray]", I = "[object Uint16Array]", L = "[object Uint32Array]";
  function G(Q, ne, q) {
    var Y = Q.constructor;
    switch (ne) {
      case v:
        return e(Q);
      case o:
      case s:
        return new Y(+Q);
      case w:
        return n(Q, q);
      case N:
      case j:
      case _:
      case g:
      case O:
      case R:
      case $:
      case I:
      case L:
        return a(Q, q);
      case l:
        return new Y();
      case d:
      case f:
        return new Y(Q);
      case m:
        return r(Q);
      case u:
        return new Y();
      case h:
        return i(Q);
    }
  }
  return kh = G, kh;
}
var bh, _j;
function TW() {
  if (_j) return bh;
  _j = 1;
  var e = Va(), n = Object.create, r = /* @__PURE__ */ (function() {
    function i() {
    }
    return function(a) {
      if (!e(a))
        return {};
      if (n)
        return n(a);
      i.prototype = a;
      var o = new i();
      return i.prototype = void 0, o;
    };
  })();
  return bh = r, bh;
}
var _h, xj;
function RW() {
  if (xj) return _h;
  xj = 1;
  var e = TW(), n = Qg(), r = Kg();
  function i(a) {
    return typeof a.constructor == "function" && !r(a) ? e(n(a)) : {};
  }
  return _h = i, _h;
}
var xh, Sj;
function DW() {
  if (Sj) return xh;
  Sj = 1;
  var e = Xg(), n = Qi(), r = "[object Map]";
  function i(a) {
    return n(a) && e(a) == r;
  }
  return xh = i, xh;
}
var Sh, Nj;
function OW() {
  if (Nj) return Sh;
  Nj = 1;
  var e = DW(), n = Hg(), r = Wg(), i = r && r.isMap, a = i ? n(i) : e;
  return Sh = a, Sh;
}
var Nh, jj;
function PW() {
  if (jj) return Nh;
  jj = 1;
  var e = Xg(), n = Qi(), r = "[object Set]";
  function i(a) {
    return n(a) && e(a) == r;
  }
  return Nh = i, Nh;
}
var jh, wj;
function AW() {
  if (wj) return jh;
  wj = 1;
  var e = PW(), n = Hg(), r = Wg(), i = r && r.isSet, a = i ? n(i) : e;
  return jh = a, jh;
}
var wh, Cj;
function LW() {
  if (Cj) return wh;
  Cj = 1;
  var e = rW(), n = iW(), r = zg(), i = uW(), a = fW(), o = hW(), s = yW(), l = vW(), d = kW(), m = bW(), u = RF(), f = Xg(), h = jW(), v = EW(), w = RW(), N = Ni(), j = wF(), _ = OW(), g = Va(), O = AW(), R = Gg(), $ = Yg(), I = 1, L = 2, G = 4, Q = "[object Arguments]", ne = "[object Array]", q = "[object Boolean]", Y = "[object Date]", P = "[object Error]", B = "[object Function]", ie = "[object GeneratorFunction]", je = "[object Map]", pe = "[object Number]", le = "[object Object]", ge = "[object RegExp]", V = "[object Set]", be = "[object String]", Oe = "[object Symbol]", H = "[object WeakMap]", Ye = "[object ArrayBuffer]", ln = "[object DataView]", Ie = "[object Float32Array]", Ue = "[object Float64Array]", De = "[object Int8Array]", Be = "[object Int16Array]", Ae = "[object Int32Array]", Qe = "[object Uint8Array]", Ee = "[object Uint8ClampedArray]", Me = "[object Uint16Array]", en = "[object Uint32Array]", se = {};
  se[Q] = se[ne] = se[Ye] = se[ln] = se[q] = se[Y] = se[Ie] = se[Ue] = se[De] = se[Be] = se[Ae] = se[je] = se[pe] = se[le] = se[ge] = se[V] = se[be] = se[Oe] = se[Qe] = se[Ee] = se[Me] = se[en] = !0, se[P] = se[B] = se[H] = !1;
  function ce(Se, Ve, Pe, kn, X, E) {
    var z, ae = Ve & I, de = Ve & L, U = Ve & G;
    if (Pe && (z = X ? Pe(Se, kn, X, E) : Pe(Se)), z !== void 0)
      return z;
    if (!g(Se))
      return Se;
    var J = N(Se);
    if (J) {
      if (z = h(Se), !ae)
        return s(Se, z);
    } else {
      var ve = f(Se), we = ve == B || ve == ie;
      if (j(Se))
        return o(Se, ae);
      if (ve == le || ve == Q || we && !X) {
        if (z = de || we ? {} : w(Se), !ae)
          return de ? d(Se, a(z, Se)) : l(Se, i(z, Se));
      } else {
        if (!se[ve])
          return X ? Se : {};
        z = v(Se, ve, ae);
      }
    }
    E || (E = new e());
    var Re = E.get(Se);
    if (Re)
      return Re;
    E.set(Se, z), O(Se) ? Se.forEach(function(an) {
      z.add(ce(an, Ve, Pe, an, Se, E));
    }) : _(Se) && Se.forEach(function(an, hn) {
      z.set(hn, ce(an, Ve, Pe, hn, Se, E));
    });
    var rn = U ? de ? u : m : de ? $ : R, bn = J ? void 0 : rn(Se);
    return n(bn || Se, function(an, hn) {
      bn && (hn = an, an = Se[hn]), r(z, hn, ce(an, Ve, Pe, hn, Se, E));
    }), z;
  }
  return wh = ce, wh;
}
var Ch, Fj;
function VW() {
  if (Fj) return Ch;
  Fj = 1;
  function e(n) {
    var r = n == null ? 0 : n.length;
    return r ? n[r - 1] : void 0;
  }
  return Ch = e, Ch;
}
var Fh, Ij;
function zW() {
  if (Ij) return Fh;
  Ij = 1;
  function e(n, r, i) {
    var a = -1, o = n.length;
    r < 0 && (r = -r > o ? 0 : o + r), i = i > o ? o : i, i < 0 && (i += o), o = r > i ? 0 : i - r >>> 0, r >>>= 0;
    for (var s = Array(o); ++a < o; )
      s[a] = n[a + r];
    return s;
  }
  return Fh = e, Fh;
}
var Ih, $j;
function UW() {
  if ($j) return Ih;
  $j = 1;
  var e = kF(), n = zW();
  function r(i, a) {
    return a.length < 2 ? i : e(i, n(a, 0, -1));
  }
  return Ih = r, Ih;
}
var $h, Ej;
function MW() {
  if (Ej) return $h;
  Ej = 1;
  var e = za(), n = VW(), r = UW(), i = vc(), a = Object.prototype, o = a.hasOwnProperty;
  function s(l, d) {
    d = e(d, l);
    var m = -1, u = d.length;
    if (!u)
      return !0;
    for (; ++m < u; ) {
      var f = i(d[m]);
      if (f === "__proto__" && !o.call(l, "__proto__") || (f === "constructor" || f === "prototype") && m < u - 1)
        return !1;
    }
    var h = r(l, d);
    return h == null || delete h[i(n(d))];
  }
  return $h = s, $h;
}
var Eh, Tj;
function BW() {
  if (Tj) return Eh;
  Tj = 1;
  var e = La(), n = Qg(), r = Qi(), i = "[object Object]", a = Function.prototype, o = Object.prototype, s = a.toString, l = o.hasOwnProperty, d = s.call(Object);
  function m(u) {
    if (!r(u) || e(u) != i)
      return !1;
    var f = n(u);
    if (f === null)
      return !0;
    var h = l.call(f, "constructor") && f.constructor;
    return typeof h == "function" && h instanceof h && s.call(h) == d;
  }
  return Eh = m, Eh;
}
var Th, Rj;
function qW() {
  if (Rj) return Th;
  Rj = 1;
  var e = BW();
  function n(r) {
    return e(r) ? void 0 : r;
  }
  return Th = n, Th;
}
var Rh, Dj;
function HW() {
  if (Dj) return Rh;
  Dj = 1;
  var e = vF(), n = LW(), r = MW(), i = za(), a = cs(), o = qW(), s = SF(), l = RF(), d = 1, m = 2, u = 4, f = s(function(h, v) {
    var w = {};
    if (h == null)
      return w;
    var N = !1;
    v = e(v, function(_) {
      return _ = i(_, h), N || (N = _.length > 1), _;
    }), a(h, l(h), w), N && (w = n(w, d | m | u, o));
    for (var j = v.length; j--; )
      r(w, v[j]);
    return w;
  });
  return Rh = f, Rh;
}
HW();
var WW = xF();
const KW = /* @__PURE__ */ mF(WW), da = ({
  transformValue: e = KW,
  label: n,
  helpIcon: r,
  className: i,
  ...a
}) => {
  const {
    controller: { field: o },
    controllerProps: { name: s }
  } = jF(a);
  return /* @__PURE__ */ Ao.jsxs(b, { gap: "200", alignItems: "center", className: i, children: [
    /* @__PURE__ */ Ao.jsx(
      Vo,
      {
        ...o,
        id: s,
        checked: e(o.value),
        disabled: a.componentProps?.disabled,
        onChange: (l) => {
          a.componentProps?.onChange?.(l), o.onChange(e(l.target.checked));
        }
      }
    ),
    n && /* @__PURE__ */ Ao.jsx(ww, { htmlFor: s, helpIcon: r, children: n })
  ] });
}, Oj = (e) => {
  const { controller: n, controllerProps: r, fieldWrapperProps: i } = QH(e);
  return /* @__PURE__ */ Ao.jsx(qe, { ...i, children: /* @__PURE__ */ Ao.jsx(
    ur,
    {
      ...e.componentProps,
      ...n.field,
      value: e.componentProps?.type === "number" && isNaN(n.field.value) ? "" : n.field.value ?? "",
      onBlur: (a) => {
        e.componentProps?.onBlur?.(a), n.field.onBlur();
      },
      onChange: (a) => {
        e.componentProps?.onChange?.(a), n.field.onChange(
          e.componentProps?.type === "number" ? a.target.valueAsNumber : a
        );
      },
      id: r.name,
      "aria-disabled": i.disabled,
      disabled: i.disabled,
      "aria-required": i.required,
      required: i.required,
      status: qe.getStatus(i.meta)
    }
  ) });
}, Ll = [
  {
    key: "rivoLoyaltyApiKey",
    label: "API key",
    defaultValue: "",
    secret: !0,
    type: "string"
  },
  {
    key: mc,
    label: "Shopify API host name",
    defaultValue: "",
    secret: !1,
    type: "string"
  },
  {
    key: "rivoLoyaltyShowOrders",
    label: "Show orders overview",
    defaultValue: !0,
    secret: !1,
    type: "boolean"
  },
  {
    key: "rivoLoyaltyShowLoyalty",
    label: "Show loyalty",
    defaultValue: !0,
    secret: !1,
    type: "boolean"
  },
  {
    key: "rivoLoyaltyAdjustLoyaltyPoints",
    label: "Allow adjusting loyalty points",
    defaultValue: !0,
    secret: !1,
    type: "boolean"
  },
  {
    key: "rivoLoyaltyShowFavoriteProducts",
    label: "Show favorite products",
    defaultValue: !0,
    secret: !1,
    type: "boolean"
  },
  {
    key: "rivoLoyaltyShowPointsRedemptions",
    label: "Show available rewards",
    defaultValue: !0,
    secret: !1,
    type: "boolean"
  }
], Ei = ar(Ll), Pj = "RIVOLOYALTY", zs = "Rivo Loyalty", GW = {
  enabled: !1,
  name: "",
  rivoLoyaltyApiKey: "",
  [mc]: "",
  rivoLoyaltyShowOrders: !0,
  rivoLoyaltyShowLoyalty: !0,
  rivoLoyaltyAdjustLoyaltyPoints: !0,
  rivoLoyaltyShowFavoriteProducts: !0,
  rivoLoyaltyShowPointsRedemptions: !0
}, YW = ({
  integrationId: e,
  handleRedirect: n,
  showNotification: r,
  automationCouplingState: i,
  renderConditionsEditor: a
}) => {
  const o = !e, s = Q6({
    mode: "onChange",
    defaultValues: GW
  }), {
    create: l,
    update: d,
    remove: m,
    isLoading: u,
    error: f,
    misconfigurationCause: h,
    setMisconfigurationCause: v
  } = pr({
    integrationId: e,
    integrationType: Pj,
    handleRedirect: n,
    showNotification: r
  }), {
    isLoading: w,
    error: N,
    isWidgetUnknown: j,
    refetch: _,
    widgetConfiguration: g
  } = fr({
    integrationId: e,
    fieldDefinitions: Ll,
    form: s,
    onMisconfigured: v
  }), { renderConditions: O, setRenderConditions: R, renderConditionsForSubmit: $ } = hr({
    integrationId: e,
    widgetConfiguration: g,
    renderConditionsEditor: a
  }), I = (G) => gr(G, {
    fieldDefinitions: Ll,
    isCreationMode: o,
    create: l,
    update: d,
    renderConditions: $
  }), L = s.watch("name");
  return /* @__PURE__ */ _e.jsxs(
    yr,
    {
      form: s,
      integrationId: e,
      onValidSubmit: I,
      error: N ?? f,
      onRetry: N ? _ : void 0,
      isLoading: u || w,
      isWidgetUnknown: j,
      children: [
        h && /* @__PURE__ */ _e.jsx(vr, { cause: h }),
        /* @__PURE__ */ _e.jsxs(et, { children: [
          /* @__PURE__ */ _e.jsx(Z, { children: /* @__PURE__ */ _e.jsx(qe, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ _e.jsx(
            da,
            {
              name: "enabled",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ _e.jsx(Z, { span: 3, children: /* @__PURE__ */ _e.jsx(
            Oj,
            {
              name: "name",
              label: "Widget name",
              control: s.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ _e.jsx(Z, { span: 3 }),
          /* @__PURE__ */ _e.jsx(Z, { span: 3, children: /* @__PURE__ */ _e.jsx(
            Oj,
            {
              name: "rivoLoyaltyShopifyApiHostName",
              label: Ei[mc],
              control: s.control,
              rules: {
                required: "Shopify API host name is required",
                validate: (G) => Ul(G) ?? void 0
              },
              componentProps: {
                placeholder: 'Host name of your Shopify shop, e.g. "my-webshop.myshopify.com"',
                prefix: "https://"
              }
            }
          ) }),
          /* @__PURE__ */ _e.jsx(Z, { span: 3 }),
          /* @__PURE__ */ _e.jsx(Z, { span: 3, children: /* @__PURE__ */ _e.jsx(
            Er,
            {
              name: "rivoLoyaltyApiKey",
              label: Ei.rivoLoyaltyApiKey,
              control: s.control,
              isCreationMode: o,
              rules: { required: "API key is required" },
              componentProps: {
                placeholder: "Insert your Rivo API key",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ _e.jsx(Z, { span: 3 }),
          /* @__PURE__ */ _e.jsx(Z, { span: 3, children: /* @__PURE__ */ _e.jsx(qe, { label: Ei.rivoLoyaltyShowOrders, children: /* @__PURE__ */ _e.jsx(
            da,
            {
              name: "rivoLoyaltyShowOrders",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ _e.jsx(Z, { span: 3 }),
          /* @__PURE__ */ _e.jsx(Z, { span: 3, children: /* @__PURE__ */ _e.jsx(qe, { label: Ei.rivoLoyaltyShowLoyalty, children: /* @__PURE__ */ _e.jsx(
            da,
            {
              name: "rivoLoyaltyShowLoyalty",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ _e.jsx(Z, { span: 3 }),
          /* @__PURE__ */ _e.jsx(Z, { span: 3, children: /* @__PURE__ */ _e.jsx(qe, { label: Ei.rivoLoyaltyAdjustLoyaltyPoints, children: /* @__PURE__ */ _e.jsx(
            da,
            {
              name: "rivoLoyaltyAdjustLoyaltyPoints",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ _e.jsx(Z, { span: 3 }),
          /* @__PURE__ */ _e.jsx(Z, { span: 3, children: /* @__PURE__ */ _e.jsx(qe, { label: Ei.rivoLoyaltyShowFavoriteProducts, children: /* @__PURE__ */ _e.jsx(
            da,
            {
              name: "rivoLoyaltyShowFavoriteProducts",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ _e.jsx(Z, { span: 3 }),
          /* @__PURE__ */ _e.jsx(Z, { span: 3, children: /* @__PURE__ */ _e.jsx(qe, { label: Ei.rivoLoyaltyShowPointsRedemptions, children: /* @__PURE__ */ _e.jsx(
            da,
            {
              name: "rivoLoyaltyShowPointsRedemptions",
              control: s.control
            }
          ) }) }),
          a && O !== null && /* @__PURE__ */ _e.jsx(Z, { children: a({
            value: O,
            onChange: R,
            configurationKey: g?.id
          }) })
        ] }),
        /* @__PURE__ */ _e.jsx(
          kr,
          {
            integrationType: Pj,
            integrationId: e,
            widgetName: L,
            isCreationMode: o,
            isSubmitting: s.formState.isSubmitting,
            automationCouplingState: i,
            onConfirmDelete: () => m(),
            confirmDeleteVariant: "danger",
            deleteConfirmationBody: /* @__PURE__ */ _e.jsxs(b, { gap: "400", children: [
              /* @__PURE__ */ _e.jsx(
                fe,
                {
                  size: 24,
                  name: "exclamation-triangle-filled",
                  color: "red.500"
                }
              ),
              /* @__PURE__ */ _e.jsxs(b, { gap: "200", flexDirection: "column", children: [
                /* @__PURE__ */ _e.jsxs(F.Heading, { withMarginBottom: !0, children: [
                  "By deleting the ",
                  zs,
                  " integration, all links between Dixa and ",
                  zs,
                  " are also deleted."
                ] }),
                /* @__PURE__ */ _e.jsxs(F.Paragraph, { children: [
                  "All data in ",
                  zs,
                  " stays untouched."
                ] }),
                /* @__PURE__ */ _e.jsxs(F.Paragraph, { children: [
                  "Are you sure you want to delete the ",
                  zs,
                  " ",
                  'integration "',
                  L,
                  '"?'
                ] })
              ] })
            ] })
          }
        )
      ]
    }
  );
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._banner_d9pot_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);margin-bottom:var(--dixa-size-spacer-400)}._list_d9pot_8{margin:var(--dixa-size-spacer-200) 0;padding-left:var(--dixa-size-spacer-500)}._list_d9pot_8 li{margin-bottom:var(--dixa-size-spacer-200)}._list_d9pot_8 li:last-child{margin-bottom:0}._list_alvh6_1{padding:0}._listItem_alvh6_4{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_alvh6_4:last-child{border-bottom:none}._listItemEdit_alvh6_11{cursor:pointer}._fullWidth_alvh6_15{width:100%}._boxWrapper_alvh6_19{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300)}._modal_1vkwz_1{width:800px}._disabled_1vkwz_5 input{color:var(--dixa-typography-color-tertiary);background-color:var(--dixa-color-neutral-100);pointer-events:none}._wrapper_10fld_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300) var(--dixa-size-spacer-300) var(--dixa-size-spacer-250);background-color:var(--dixa-color-neutral-100)}._copyIcon_10fld_7{cursor:pointer;color:var(--dixa-typography-color-secondary)}._creationModal_pbe64_1{width:800px}._detailsModal_pbe64_5{width:600px}._percentageSuffix_pbe64_9{background-color:var(--dixa-color-neutral-100);padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-250)}._modal_11d6e_1{width:600px}._modalBody_11d6e_4{max-height:500px;overflow-y:auto}._codeContainer_11d6e_9{margin:var(--dixa-size-spacer-200) var(--dixa-size-spacer-100) 0 0;padding:var(--dixa-size-spacer-200);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100)}._modal_1wlra_1{width:800px}._clickableIcon_33mqm_1{cursor:pointer;color:var(--dixa-typography-color-secondary)}._productTableHeader_6h6pl_1>tr>th{height:var(--dixa-size-spacer-300)}._productImage_6h6pl_5{width:50px;height:50px}._copyIcon_1dlzg_1{cursor:pointer;color:var(--dixa-typography-color-secondary)}._modal_1mprq_1{width:900px}._modal_al73g_1{width:600px}._editIcon_1yp2k_1,._copyIcon_1yp2k_2,._icon_cddi1_1{cursor:pointer;color:var(--dixa-typography-color-secondary)}._link_cddi1_6{font-size:var(--dixa-typography-size-200)}._copyIcon_u5m0p_1{cursor:pointer;color:var(--dixa-typography-color-secondary)}._strikethrough_u5m0p_6{text-decoration:line-through}._order_u5m0p_10{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._order_u5m0p_10:hover,._orderIsOpen_u5m0p_18{border-color:var(--dixa-color-neutral-400)}._orderHeader_u5m0p_21{cursor:pointer}._segmentName_1dkhk_1{overflow:hidden;white-space:nowrap}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Dh = { exports: {} }, _o = {}, Aj;
function JW() {
  if (Aj) return _o;
  Aj = 1;
  var e = He, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (v = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return _o.Fragment = r, _o.jsx = s, _o.jsxs = s, _o;
}
var Us = {}, Lj;
function QW() {
  return Lj || (Lj = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = He, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), d = /* @__PURE__ */ Symbol.for("react.forward_ref"), m = /* @__PURE__ */ Symbol.for("react.suspense"), u = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), v = /* @__PURE__ */ Symbol.for("react.offscreen"), w = Symbol.iterator, N = "@@iterator";
    function j(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = w && t[w] || t[N];
      return typeof c == "function" ? c : null;
    }
    var _ = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          p[y - 1] = arguments[y];
        O("error", t, p);
      }
    }
    function O(t, c, p) {
      {
        var y = _.ReactDebugCurrentFrame, C = y.getStackAddendum();
        C !== "" && (c += "%s", p = p.concat([C]));
        var T = p.map(function(S) {
          return String(S);
        });
        T.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, T);
      }
    }
    var R = !1, $ = !1, I = !1, L = !1, G = !1, Q;
    Q = /* @__PURE__ */ Symbol.for("react.module.reference");
    function ne(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || G || t === a || t === m || t === u || L || t === v || R || $ || I || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Q || t.getModuleId !== void 0));
    }
    function q(t, c, p) {
      var y = t.displayName;
      if (y)
        return y;
      var C = c.displayName || c.name || "";
      return C !== "" ? p + "(" + C + ")" : p;
    }
    function Y(t) {
      return t.displayName || "Context";
    }
    function P(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return Y(c) + ".Consumer";
          case s:
            var p = t;
            return Y(p._context) + ".Provider";
          case d:
            return q(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : P(t.type) || "Memo";
          case h: {
            var C = t, T = C._payload, S = C._init;
            try {
              return P(S(T));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var B = Object.assign, ie = 0, je, pe, le, ge, V, be, Oe;
    function H() {
    }
    H.__reactDisabledLog = !0;
    function Ye() {
      {
        if (ie === 0) {
          je = console.log, pe = console.info, le = console.warn, ge = console.error, V = console.group, be = console.groupCollapsed, Oe = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: H,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ie++;
      }
    }
    function ln() {
      {
        if (ie--, ie === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: B({}, t, {
              value: je
            }),
            info: B({}, t, {
              value: pe
            }),
            warn: B({}, t, {
              value: le
            }),
            error: B({}, t, {
              value: ge
            }),
            group: B({}, t, {
              value: V
            }),
            groupCollapsed: B({}, t, {
              value: be
            }),
            groupEnd: B({}, t, {
              value: Oe
            })
          });
        }
        ie < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Ie = _.ReactCurrentDispatcher, Ue;
    function De(t, c, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (C) {
            var y = C.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Be = !1, Ae;
    {
      var Qe = typeof WeakMap == "function" ? WeakMap : Map;
      Ae = new Qe();
    }
    function Ee(t, c) {
      if (!t || Be)
        return "";
      {
        var p = Ae.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Be = !0;
      var C = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var T;
      T = Ie.current, Ie.current = null, Ye();
      try {
        if (c) {
          var S = function() {
            throw Error();
          };
          if (Object.defineProperty(S.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(S, []);
            } catch (re) {
              y = re;
            }
            Reflect.construct(t, [], S);
          } else {
            try {
              S.call();
            } catch (re) {
              y = re;
            }
            t.call(S.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (re) {
            y = re;
          }
          t();
        }
      } catch (re) {
        if (re && y && typeof re.stack == "string") {
          for (var x = re.stack.split(`
`), ee = y.stack.split(`
`), A = x.length - 1, M = ee.length - 1; A >= 1 && M >= 0 && x[A] !== ee[M]; )
            M--;
          for (; A >= 1 && M >= 0; A--, M--)
            if (x[A] !== ee[M]) {
              if (A !== 1 || M !== 1)
                do
                  if (A--, M--, M < 0 || x[A] !== ee[M]) {
                    var ue = `
` + x[A].replace(" at new ", " at ");
                    return t.displayName && ue.includes("<anonymous>") && (ue = ue.replace("<anonymous>", t.displayName)), typeof t == "function" && Ae.set(t, ue), ue;
                  }
                while (A >= 1 && M >= 0);
              break;
            }
        }
      } finally {
        Be = !1, Ie.current = T, ln(), Error.prepareStackTrace = C;
      }
      var ze = t ? t.displayName || t.name : "", Te = ze ? De(ze) : "";
      return typeof t == "function" && Ae.set(t, Te), Te;
    }
    function Me(t, c, p) {
      return Ee(t, !1);
    }
    function en(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function se(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ee(t, en(t));
      if (typeof t == "string")
        return De(t);
      switch (t) {
        case m:
          return De("Suspense");
        case u:
          return De("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Me(t.render);
          case f:
            return se(t.type, c, p);
          case h: {
            var y = t, C = y._payload, T = y._init;
            try {
              return se(T(C), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var ce = Object.prototype.hasOwnProperty, Se = {}, Ve = _.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, p = se(t.type, t._source, c ? c.type : null);
        Ve.setExtraStackFrame(p);
      } else
        Ve.setExtraStackFrame(null);
    }
    function kn(t, c, p, y, C) {
      {
        var T = Function.call.bind(ce);
        for (var S in t)
          if (T(t, S)) {
            var x = void 0;
            try {
              if (typeof t[S] != "function") {
                var ee = Error((y || "React class") + ": " + p + " type `" + S + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[S] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ee.name = "Invariant Violation", ee;
              }
              x = t[S](c, S, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (A) {
              x = A;
            }
            x && !(x instanceof Error) && (Pe(C), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, S, typeof x), Pe(null)), x instanceof Error && !(x.message in Se) && (Se[x.message] = !0, Pe(C), g("Failed %s type: %s", p, x.message), Pe(null));
          }
      }
    }
    var X = Array.isArray;
    function E(t) {
      return X(t);
    }
    function z(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function ae(t) {
      try {
        return de(t), !1;
      } catch {
        return !0;
      }
    }
    function de(t) {
      return "" + t;
    }
    function U(t) {
      if (ae(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", z(t)), de(t);
    }
    var J = _.ReactCurrentOwner, ve = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, we, Re;
    function rn(t) {
      if (ce.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function bn(t) {
      if (ce.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function an(t, c) {
      typeof t.ref == "string" && J.current;
    }
    function hn(t, c) {
      {
        var p = function() {
          we || (we = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function En(t, c) {
      {
        var p = function() {
          Re || (Re = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var _n = function(t, c, p, y, C, T, S) {
      var x = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: S,
        // Record the component responsible for creating this element.
        _owner: T
      };
      return x._store = {}, Object.defineProperty(x._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(x, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(x, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: C
      }), Object.freeze && (Object.freeze(x.props), Object.freeze(x)), x;
    };
    function Fn(t, c, p, y, C) {
      {
        var T, S = {}, x = null, ee = null;
        p !== void 0 && (U(p), x = "" + p), bn(c) && (U(c.key), x = "" + c.key), rn(c) && (ee = c.ref, an(c));
        for (T in c)
          ce.call(c, T) && !ve.hasOwnProperty(T) && (S[T] = c[T]);
        if (t && t.defaultProps) {
          var A = t.defaultProps;
          for (T in A)
            S[T] === void 0 && (S[T] = A[T]);
        }
        if (x || ee) {
          var M = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          x && hn(S, M), ee && En(S, M);
        }
        return _n(t, x, ee, C, y, J.current, S);
      }
    }
    var Ze = _.ReactCurrentOwner, gn = _.ReactDebugCurrentFrame;
    function Le(t) {
      if (t) {
        var c = t._owner, p = se(t.type, t._source, c ? c.type : null);
        gn.setExtraStackFrame(p);
      } else
        gn.setExtraStackFrame(null);
    }
    var dn;
    dn = !1;
    function un(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function Nn() {
      {
        if (Ze.current) {
          var t = P(Ze.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Bn(t) {
      return "";
    }
    var Sn = {};
    function An(t) {
      {
        var c = Nn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function vn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = An(c);
        if (Sn[p])
          return;
        Sn[p] = !0;
        var y = "";
        t && t._owner && t._owner !== Ze.current && (y = " It was passed a child from " + P(t._owner.type) + "."), Le(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Le(null);
      }
    }
    function xn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (E(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            un(y) && vn(y, c);
          }
        else if (un(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var C = j(t);
          if (typeof C == "function" && C !== t.entries)
            for (var T = C.call(t), S; !(S = T.next()).done; )
              un(S.value) && vn(S.value, c);
        }
      }
    }
    function Ln(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var y = P(c);
          kn(p, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !dn) {
          dn = !0;
          var C = P(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", C || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var y = c[p];
          if (y !== "children" && y !== "key") {
            Le(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Le(null);
            break;
          }
        }
        t.ref !== null && (Le(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Le(null));
      }
    }
    var Cn = {};
    function wn(t, c, p, y, C, T) {
      {
        var S = ne(t);
        if (!S) {
          var x = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (x += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ee = Bn();
          ee ? x += ee : x += Nn();
          var A;
          t === null ? A = "null" : E(t) ? A = "array" : t !== void 0 && t.$$typeof === n ? (A = "<" + (P(t.type) || "Unknown") + " />", x = " Did you accidentally export a JSX literal instead of a component?") : A = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", A, x);
        }
        var M = Fn(t, c, p, C, T);
        if (M == null)
          return M;
        if (S) {
          var ue = c.children;
          if (ue !== void 0)
            if (y)
              if (E(ue)) {
                for (var ze = 0; ze < ue.length; ze++)
                  xn(ue[ze], t);
                Object.freeze && Object.freeze(ue);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              xn(ue, t);
        }
        if (ce.call(c, "key")) {
          var Te = P(t), re = Object.keys(c).filter(function(Gn) {
            return Gn !== "key";
          }), mn = re.length > 0 ? "{key: someKey, " + re.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Cn[Te + mn]) {
            var Dn = re.length > 0 ? "{" + re.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, mn, Te, Dn, Te), Cn[Te + mn] = !0;
          }
        }
        return t === i ? Vn(M) : Ln(M), M;
      }
    }
    function zn(t, c, p) {
      return wn(t, c, p, !0);
    }
    function qn(t, c, p) {
      return wn(t, c, p, !1);
    }
    var Un = qn, Kn = zn;
    Us.Fragment = i, Us.jsx = Un, Us.jsxs = Kn;
  })()), Us;
}
var Vj;
function XW() {
  return Vj || (Vj = 1, process.env.NODE_ENV === "production" ? Dh.exports = JW() : Dh.exports = QW()), Dh.exports;
}
var k = XW();
const zj = "__PairingContext__", ZW = () => globalThis[zj] ?? (() => {
  const e = $y({});
  return globalThis[zj] = e, e;
})(), e9 = ZW(), n9 = () => ql(e9), t9 = "_banner_d9pot_1", r9 = "_list_d9pot_8", Uj = {
  banner: t9,
  list: r9
}, Mj = "https://apps.shopify.com/dixa-dashboard", i9 = {
  install: {
    description: "Connect your Shopify store to Dixa with just a few clicks.",
    listHeading: "How it works:",
    listType: "ol",
    listItems: [
      'Click "Install Dixa app in Shopify" below to start the connection',
      "You'll be redirected to the Shopify App Store to install the Dixa app",
      "After installing, the connection is set up automatically",
      "Return to the Settings > Integrations overview to see your newly connected Shopify integration"
    ],
    buttonText: "Install Dixa app in Shopify",
    buttonVariant: "primary"
  },
  migration: {
    description: "This integration uses a legacy connection method. We recommend upgrading to the Dixa Shopify app for a simpler, more reliable connection that doesn't require manual credential management.",
    listHeading: "Benefits of upgrading:",
    listType: "ul",
    listItems: [
      "No need to manage Client ID and Client Secret",
      "Automatic token refresh handled by the app",
      "Easier setup for new stores"
    ],
    buttonText: "Upgrade via Shopify App Store",
    buttonVariant: "primary"
  }
}, Vl = ({
  label: e,
  bannerVariant: n = "install"
}) => {
  const { initiateFromDixa: r } = n9(), [i, a] = me(!1), [o, s] = me(null), l = i9[n], d = async () => {
    if (n === "install" && r) {
      a(!0), s(null);
      try {
        const u = await r();
        window.open(
          u ?? Mj,
          "_blank",
          "noopener,noreferrer"
        );
      } catch {
        s("Failed to start the connection. Please try again.");
      } finally {
        a(!1);
      }
      return;
    }
    window.open(Mj, "_blank", "noopener,noreferrer");
  }, m = l.listType === "ol" ? "ol" : "ul";
  return /* @__PURE__ */ k.jsx(Z, { children: /* @__PURE__ */ k.jsxs(b, { gap: "300", flexDirection: "column", className: Uj.banner, children: [
    /* @__PURE__ */ k.jsx(F.Heading, { variant: "heading-2", children: e }),
    /* @__PURE__ */ k.jsxs(b, { alignItems: "center", gap: "200", children: [
      /* @__PURE__ */ k.jsx(b, { children: /* @__PURE__ */ k.jsx(fe, { size: 30, name: "shopify", color: "green.500" }) }),
      /* @__PURE__ */ k.jsx(F.Paragraph, { children: l.description })
    ] }),
    /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ k.jsx(F.Heading, { variant: "heading-3", children: l.listHeading }),
      /* @__PURE__ */ k.jsx(F.Paragraph, { as: "div", children: /* @__PURE__ */ k.jsx(m, { className: Uj.list, children: l.listItems.map((u, f) => /* @__PURE__ */ k.jsx("li", { children: u }, f)) }) })
    ] }),
    o && /* @__PURE__ */ k.jsx(F.Paragraph, { color: "danger", children: o }),
    /* @__PURE__ */ k.jsx(b, { margin: "200 0 0 0", children: /* @__PURE__ */ k.jsx(
      Qn,
      {
        onClick: d,
        icon: "external-link",
        variant: l.buttonVariant,
        disabled: i,
        children: i ? /* @__PURE__ */ k.jsxs(b, { alignItems: "center", gap: "200", children: [
          /* @__PURE__ */ k.jsx(sn, { size: 16 }),
          "Connecting…"
        ] }) : l.buttonText
      }
    ) })
  ] }) });
}, Go = [
  {
    key: "apiHostName",
    label: "API host name",
    type: "string",
    secret: !1,
    defaultValue: ""
  },
  {
    key: "displayRefundOrder",
    label: "Display the refund order button",
    type: "boolean",
    secret: !1,
    defaultValue: !1
  },
  {
    key: "displayPartialRefundOrder",
    label: "Displays the partial refund order button",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "displayCancelOrder",
    label: "Displays the cancel order button",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "enableEditShippingAddress",
    label: 'Enable the "edit shipping address" button',
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "displayOrdersOverview",
    label: "Displays short orders overview",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "displayEmailMarketingConsent",
    label: "Displays the email and phone marketing consent status of the customer",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "displaySegmentMembership",
    label: "Displays the segment memberships of the customer",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "displayDiscountCodes",
    label: "Displays available discount codes",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "displayDiscountCodeCreation",
    label: "Displays the discount code creation button",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "displayCreateOrder",
    label: "Displays the create order button",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "displayCreateDraftOrder",
    label: "Displays the create draft order button",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "displayDuplicateOrder",
    label: "Displays the duplicate order button",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "apiAccessToken",
    label: "API Access Token",
    type: "string",
    secret: !0,
    defaultValue: ""
  },
  {
    key: "shopifyClientId",
    label: "Client ID",
    type: "string",
    secret: !0,
    defaultValue: ""
  },
  {
    key: "shopifyClientSecret",
    label: "Client Secret",
    type: "string",
    secret: !0,
    defaultValue: ""
  }
], Bj = "SHOPIFY", Ms = ar(Go), a9 = [
  "displayRefundOrder",
  "displayPartialRefundOrder",
  "displayCancelOrder",
  "enableEditShippingAddress",
  "displayOrdersOverview",
  "displayEmailMarketingConsent",
  "displaySegmentMembership",
  "displayDiscountCodes",
  "displayDiscountCodeCreation",
  "displayCreateOrder",
  "displayCreateDraftOrder",
  "displayDuplicateOrder"
], o9 = {
  enabled: !1,
  name: "",
  ...Jo(
    [],
    Go
  )
}, s9 = ({
  integrationId: e,
  handleRedirect: n,
  showNotification: r,
  automationCouplingState: i,
  renderConditionsEditor: a
}) => {
  const o = !e, s = ot({
    mode: "onChange",
    defaultValues: o9
  }), {
    create: l,
    update: d,
    remove: m,
    isLoading: u,
    error: f,
    misconfigurationCause: h,
    setMisconfigurationCause: v
  } = pr({
    integrationId: e,
    integrationType: Bj,
    handleRedirect: n,
    showNotification: r
  }), {
    isLoading: w,
    error: N,
    isWidgetUnknown: j,
    refetch: _,
    widgetConfiguration: g
  } = fr({
    integrationId: e,
    fieldDefinitions: Go,
    form: s,
    onMisconfigured: v
  }), { renderConditions: O, setRenderConditions: R, renderConditionsForSubmit: $ } = hr({
    integrationId: e,
    widgetConfiguration: g,
    renderConditionsEditor: a
  }), I = g?.additionalProperties, L = I?.tokenSource === "marketplace_app", G = !!I?.isUsingOAuth, Q = !L, ne = (Y) => gr(Y, {
    fieldDefinitions: Go,
    isCreationMode: o,
    create: l,
    update: d,
    renderConditions: $
  }), q = s.watch("name");
  return /* @__PURE__ */ k.jsx(
    yr,
    {
      form: s,
      integrationId: e,
      onValidSubmit: ne,
      error: N ?? f,
      onRetry: N ? _ : void 0,
      isLoading: u || w,
      isWidgetUnknown: j,
      children: o ? /* @__PURE__ */ k.jsx(et, { children: /* @__PURE__ */ k.jsx(
        Vl,
        {
          label: "Connect your Shopify store",
          bannerVariant: "install"
        }
      ) }) : /* @__PURE__ */ k.jsxs(k.Fragment, { children: [
        h && /* @__PURE__ */ k.jsx(vr, { cause: h }),
        /* @__PURE__ */ k.jsxs(et, { children: [
          Q && /* @__PURE__ */ k.jsx(
            Vl,
            {
              label: "Upgrade to simplified connection",
              bannerVariant: "migration"
            }
          ),
          /* @__PURE__ */ k.jsx(Z, { children: /* @__PURE__ */ k.jsx(qe, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ k.jsx(
            yn,
            {
              name: "enabled",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ k.jsx(Z, { span: 3, children: /* @__PURE__ */ k.jsx(
            Rn,
            {
              name: "name",
              label: "Widget name",
              control: s.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ k.jsx(Z, { span: 3 }),
          Q && G && /* @__PURE__ */ k.jsxs(k.Fragment, { children: [
            /* @__PURE__ */ k.jsx(Z, { span: 3, children: /* @__PURE__ */ k.jsx(
              Er,
              {
                name: "shopifyClientId",
                label: Ms.shopifyClientId,
                control: s.control,
                isCreationMode: o,
                rules: { required: "Client ID is required" },
                componentProps: {
                  placeholder: "Client ID from Shopify",
                  autoComplete: "off"
                }
              }
            ) }),
            /* @__PURE__ */ k.jsx(Z, { span: 3 }),
            /* @__PURE__ */ k.jsx(Z, { span: 3, children: /* @__PURE__ */ k.jsx(
              Er,
              {
                name: "shopifyClientSecret",
                label: Ms.shopifyClientSecret,
                control: s.control,
                isCreationMode: o,
                rules: { required: "Client Secret is required" },
                componentProps: {
                  placeholder: "Client Secret from Shopify",
                  autoComplete: "off"
                }
              }
            ) }),
            /* @__PURE__ */ k.jsx(Z, { span: 3 })
          ] }),
          Q && !G && /* @__PURE__ */ k.jsxs(k.Fragment, { children: [
            /* @__PURE__ */ k.jsx(Z, { span: 3, children: /* @__PURE__ */ k.jsx(
              Er,
              {
                name: "apiAccessToken",
                label: Ms.apiAccessToken,
                control: s.control,
                isCreationMode: o,
                rules: { required: "API access token is required" },
                componentProps: {
                  placeholder: "API access token from Shopify",
                  autoComplete: "off"
                }
              }
            ) }),
            /* @__PURE__ */ k.jsx(Z, { span: 3 })
          ] }),
          L ? /* @__PURE__ */ k.jsx(Z, { span: 3, children: /* @__PURE__ */ k.jsx(
            Rn,
            {
              name: "apiHostName",
              label: "Connected Shopify store",
              control: s.control,
              componentProps: {
                readOnly: !0,
                autoComplete: "off",
                prefix: "https://"
              }
            }
          ) }) : /* @__PURE__ */ k.jsx(Z, { span: 3, children: /* @__PURE__ */ k.jsx(
            Rn,
            {
              name: "apiHostName",
              label: "API host name",
              control: s.control,
              rules: {
                required: "API host name is required",
                validate: (Y) => Ul(Y) || !0
              },
              componentProps: {
                placeholder: 'Host name of your shop, e.g. "my-webshop.myshopify.com"',
                autoComplete: "off",
                prefix: "https://"
              }
            }
          ) }),
          /* @__PURE__ */ k.jsx(Z, { span: 3 }),
          a9.map((Y) => /* @__PURE__ */ k.jsxs(CI, { children: [
            /* @__PURE__ */ k.jsx(Z, { span: 3, children: /* @__PURE__ */ k.jsx(qe, { label: Ms[Y], children: /* @__PURE__ */ k.jsx(
              yn,
              {
                name: Y,
                control: s.control
              }
            ) }) }),
            /* @__PURE__ */ k.jsx(Z, { span: 3 })
          ] }, Y)),
          a && O !== null && /* @__PURE__ */ k.jsx(Z, { children: a({
            value: O,
            onChange: R,
            configurationKey: g?.id
          }) })
        ] }),
        /* @__PURE__ */ k.jsx(
          kr,
          {
            integrationType: Bj,
            integrationId: e,
            widgetName: q,
            isCreationMode: o,
            isSubmitting: s.formState.isSubmitting,
            automationCouplingState: i,
            onConfirmDelete: () => m()
          }
        )
      ] })
    }
  );
}, l9 = (e) => /* @__PURE__ */ k.jsx(Vl, { ...e, bannerVariant: "install" }), c9 = (e) => /* @__PURE__ */ k.jsx(Vl, { ...e, bannerVariant: "migration" }), d9 = [
  {
    key: "shopifyClientId",
    label: "Client ID",
    placeholder: "Client ID from Shopify",
    required: !0,
    secret: !0,
    type: "input"
  },
  {
    key: "shopifyClientSecret",
    label: "Client Secret",
    placeholder: "Client Secret from Shopify",
    required: !0,
    secret: !0,
    type: "input"
  }
], u9 = [
  {
    key: "apiAccessToken",
    label: "API Access Token",
    placeholder: "API access token from Shopify",
    required: !0,
    secret: !0,
    type: "input"
  }
], m9 = [
  {
    key: "marketplaceInstallBanner",
    label: "Connect your Shopify store",
    secret: !1,
    type: "custom",
    component: l9
  }
], p9 = [
  {
    key: "apiHostName",
    label: "Connected Shopify store",
    placeholder: "",
    required: !1,
    secret: !1,
    type: "input",
    prefix: "https://",
    readOnly: !0
  }
], qj = [
  {
    key: "migrationBanner",
    label: "Upgrade to simplified connection",
    secret: !1,
    type: "custom",
    component: c9,
    additionalProperties: { renderAboveForm: !0 }
  }
], DF = [
  {
    key: "displayRefundOrder",
    label: "Display the refund order button",
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "displayPartialRefundOrder",
    label: "Displays the partial refund order button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayCancelOrder",
    label: "Displays the cancel order button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "enableEditShippingAddress",
    label: 'Enable the "edit shipping address" button',
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayOrdersOverview",
    label: "Displays short orders overview",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    // We keep the key name to the first version which only showed marketing
    // consent for email in order to not change the existing integration setting
    // for customers. The current version shows both email and phone marketing consent.
    key: "displayEmailMarketingConsent",
    label: "Displays the email and phone marketing consent status of the customer",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displaySegmentMembership",
    label: "Displays the segment memberships of the customer",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayDiscountCodes",
    label: "Displays available discount codes",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayDiscountCodeCreation",
    label: "Displays the discount code creation button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayCreateOrder",
    label: "Displays the create order button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayCreateDraftOrder",
    label: "Displays the create draft order button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayDuplicateOrder",
    label: "Displays the duplicate order button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  }
], Hj = [
  {
    key: "apiHostName",
    label: "API host name",
    placeholder: 'Host name of your shop, e.g. "my-webshop.myshopify.com"',
    required: !0,
    secret: !1,
    type: "input",
    prefix: "https://",
    customValidation: (e) => Ul(e)
  },
  ...DF
];
var pa = /* @__PURE__ */ ((e) => (e.Invalid = "INVALID", e.NotSubscribed = "NOT_SUBSCRIBED", e.Pending = "PENDING", e.Subscribed = "SUBSCRIBED", e.Unsubscribed = "UNSUBSCRIBED", e))(pa || {}), Mi = /* @__PURE__ */ ((e) => (e.ConfirmedOptIn = "CONFIRMED_OPT_IN", e.SingleOptIn = "SINGLE_OPT_IN", e.Unknown = "UNKNOWN", e))(Mi || {}), Br = /* @__PURE__ */ ((e) => (e.NotSubscribed = "NOT_SUBSCRIBED", e.Pending = "PENDING", e.Redacted = "REDACTED", e.Subscribed = "SUBSCRIBED", e.Unsubscribed = "UNSUBSCRIBED", e))(Br || {}), OF = /* @__PURE__ */ ((e) => (e.All = "ALL", e))(OF || {}), Sy = /* @__PURE__ */ ((e) => (e.Active = "ACTIVE", e.Expired = "EXPIRED", e.Scheduled = "SCHEDULED", e))(Sy || {}), Pi = /* @__PURE__ */ ((e) => (e.Customer = "CUSTOMER", e.Declined = "DECLINED", e.Fraud = "FRAUD", e.Inventory = "INVENTORY", e.Other = "OTHER", e.Staff = "STAFF", e))(Pi || {}), Bi = /* @__PURE__ */ ((e) => (e.Authorized = "AUTHORIZED", e.Expired = "EXPIRED", e.Paid = "PAID", e.PartiallyPaid = "PARTIALLY_PAID", e.PartiallyRefunded = "PARTIALLY_REFUNDED", e.Pending = "PENDING", e.Refunded = "REFUNDED", e.Voided = "VOIDED", e))(Bi || {}), ul = /* @__PURE__ */ ((e) => (e.Fulfilled = "FULFILLED", e.Partial = "PARTIAL", e.Restocked = "RESTOCKED", e))(ul || {}), PF = /* @__PURE__ */ ((e) => (e.Authorization = "AUTHORIZATION", e.Capture = "CAPTURE", e.Change = "CHANGE", e.EmvAuthorization = "EMV_AUTHORIZATION", e.Refund = "REFUND", e.Sale = "SALE", e.SuggestedRefund = "SUGGESTED_REFUND", e.Void = "VOID", e))(PF || {});
const f9 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "refundCreate" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_RefundInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "refundCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, h9 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "orderUpdate" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orderUpdate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "order" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shippingAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "countryCodeV2" } }, { kind: "Field", name: { kind: "Name", value: "provinceCode" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, y9 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "orderCancel" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "notifyCustomer" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "orderId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "reason" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderCancelReason" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "refundMethod" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderCancelRefundMethodInput" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "restock" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "staffNote" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orderCancel" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "notifyCustomer" }, value: { kind: "Variable", name: { kind: "Name", value: "notifyCustomer" } } }, { kind: "Argument", name: { kind: "Name", value: "orderId" }, value: { kind: "Variable", name: { kind: "Name", value: "orderId" } } }, { kind: "Argument", name: { kind: "Name", value: "reason" }, value: { kind: "Variable", name: { kind: "Name", value: "reason" } } }, { kind: "Argument", name: { kind: "Name", value: "refundMethod" }, value: { kind: "Variable", name: { kind: "Name", value: "refundMethod" } } }, { kind: "Argument", name: { kind: "Name", value: "restock" }, value: { kind: "Variable", name: { kind: "Name", value: "restock" } } }, { kind: "Argument", name: { kind: "Name", value: "staffNote" }, value: { kind: "Variable", name: { kind: "Name", value: "staffNote" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "job" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "done" } }] } }, { kind: "Field", name: { kind: "Name", value: "orderCancelUserErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, g9 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createCustomer" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_CustomerInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "customerCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "Field", name: { kind: "Name", value: "customer" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "defaultEmailAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "emailAddress" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultPhoneNumber" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "phoneNumber" } }, { kind: "Field", name: { kind: "Name", value: "marketingState" } }, { kind: "Field", name: { kind: "Name", value: "marketingOptInLevel" } }] } }, { kind: "Field", name: { kind: "Name", value: "taxExempt" } }, { kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "amountSpent" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }] } }] } }] }, v9 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createOrder" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "order" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderCreateOrderInput" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "options" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderCreateOptionsInput" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orderCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "order" }, value: { kind: "Variable", name: { kind: "Name", value: "order" } } }, { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "order" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "createdAt" } }, { kind: "Field", name: { kind: "Name", value: "displayFulfillmentStatus" } }, { kind: "Field", name: { kind: "Name", value: "displayFinancialStatus" } }, { kind: "Field", name: { kind: "Name", value: "totalPriceSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "shopMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, k9 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createDraftOrder" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DraftOrderInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "draftOrderCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "draftOrder" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "createdAt" } }, { kind: "Field", name: { kind: "Name", value: "tags" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "totalPriceSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "shopMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, b9 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createDiscountCode" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeBasicInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discountCodeBasicCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "basicCodeDiscount" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "codeDiscountNode" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "codeDiscount" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeBasic" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "codes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "1" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "startsAt" } }, { kind: "Field", name: { kind: "Name", value: "endsAt" } }, { kind: "Field", name: { kind: "Name", value: "usageLimit" } }, { kind: "Field", name: { kind: "Name", value: "appliesOncePerCustomer" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, _9 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "orderMarkAsPaid" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderMarkAsPaidInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orderMarkAsPaid" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "order" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }, { kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, x9 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "refundLineItems" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_RefundInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "refundCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "refund" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "totalRefundedSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, S9 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "updateOrder" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orderUpdate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "order" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "tags" } }] } }] } }] } }] } }] }, N9 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "segments" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "first" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "segments" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }] } }] } }] }, j9 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "customerSegmentMembership" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "segmentIds" } }, type: { kind: "NonNullType", type: { kind: "ListType", type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "customerSegmentMembership" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "customerId" }, value: { kind: "Variable", name: { kind: "Name", value: "customerId" } } }, { kind: "Argument", name: { kind: "Name", value: "segmentIds" }, value: { kind: "Variable", name: { kind: "Name", value: "segmentIds" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "memberships" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "segmentId" } }, { kind: "Field", name: { kind: "Name", value: "isMember" } }] } }] } }] } }] } }] }, w9 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "shopifyCustomerData" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shop" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "countriesInShippingZones" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "countryCodes" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "customers" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "1" } }, { kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "displayName" } }, { kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "defaultEmailAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "emailAddress" } }, { kind: "Field", name: { kind: "Name", value: "marketingOptInLevel" } }, { kind: "Field", name: { kind: "Name", value: "marketingState" } }, { kind: "Field", name: { kind: "Name", value: "marketingUpdatedAt" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultPhoneNumber" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "phoneNumber" } }, { kind: "Field", name: { kind: "Name", value: "marketingOptInLevel" } }, { kind: "Field", name: { kind: "Name", value: "marketingState" } }, { kind: "Field", name: { kind: "Name", value: "marketingUpdatedAt" } }] } }, { kind: "Field", name: { kind: "Name", value: "numberOfOrders" } }, { kind: "Field", name: { kind: "Name", value: "tags" } }, { kind: "Field", name: { kind: "Name", value: "verifiedEmail" } }, { kind: "Field", name: { kind: "Name", value: "amountSpent" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "country" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "provinceCode" } }, { kind: "Field", name: { kind: "Name", value: "countryCodeV2" } }] } }] } }] } }] } }] } }] } }] }, C9 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "shopifyCustomerOrders" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orders" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "5" } }, { kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }, { kind: "Argument", name: { kind: "Name", value: "sortKey" }, value: { kind: "EnumValue", value: "CREATED_AT" } }, { kind: "Argument", name: { kind: "Name", value: "reverse" }, value: { kind: "BooleanValue", value: !0 } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "createdAt" } }, { kind: "Field", name: { kind: "Name", value: "displayFulfillmentStatus" } }, { kind: "Field", name: { kind: "Name", value: "displayFinancialStatus" } }, { kind: "Field", name: { kind: "Name", value: "cancelledAt" } }, { kind: "Field", name: { kind: "Name", value: "tags" } }, { kind: "Field", name: { kind: "Name", value: "discountCodes" } }, { kind: "Field", name: { kind: "Name", value: "netPaymentSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "totalRefundedSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "billingAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "country" } }, { kind: "Field", name: { kind: "Name", value: "countryCodeV2" } }, { kind: "Field", name: { kind: "Name", value: "province" } }, { kind: "Field", name: { kind: "Name", value: "provinceCode" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }] } }, { kind: "Field", name: { kind: "Name", value: "shippingAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "country" } }, { kind: "Field", name: { kind: "Name", value: "countryCodeV2" } }, { kind: "Field", name: { kind: "Name", value: "province" } }, { kind: "Field", name: { kind: "Name", value: "provinceCode" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }] } }, { kind: "Field", name: { kind: "Name", value: "suggestedRefund" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "suggestFullRefund" }, value: { kind: "BooleanValue", value: !0 } }, { kind: "Argument", name: { kind: "Name", value: "refundShipping" }, value: { kind: "BooleanValue", value: !0 } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amountSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "subtotalSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "totalTaxSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "shipping" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amountSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "maximumRefundableSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "suggestedTransactions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "accountNumber" } }, { kind: "Field", name: { kind: "Name", value: "gateway" } }, { kind: "Field", name: { kind: "Name", value: "kind" } }, { kind: "Field", name: { kind: "Name", value: "parentTransaction" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }, { kind: "Field", name: { kind: "Name", value: "amountSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "refundLineItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "lineItem" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "shippingLines" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "5" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "source" } }, { kind: "Field", name: { kind: "Name", value: "discountedPriceSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shopMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "fulfillments" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "2" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "trackingInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "url" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "lineItems" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "15" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "variantTitle" } }, { kind: "Field", name: { kind: "Name", value: "sku" } }, { kind: "Field", name: { kind: "Name", value: "image" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "url" } }] } }, { kind: "Field", name: { kind: "Name", value: "product" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }, { kind: "Field", name: { kind: "Name", value: "discountedUnitPriceSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shopMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "refunds" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "totalRefunded" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "refundLineItems" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "250" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "lineItem" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }] } }] } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "currentTotalPriceSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "shopMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "currentTotalDiscountsSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shopMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }] } }] } }] } }] } }] }, F9 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "searchDiscountCodes" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "first" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "after" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discountNodes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }, { kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }, { kind: "Argument", name: { kind: "Name", value: "after" }, value: { kind: "Variable", name: { kind: "Name", value: "after" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pageInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "hasNextPage" } }, { kind: "Field", name: { kind: "Name", value: "endCursor" } }] } }, { kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "discount" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "__typename" } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeApp" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "codes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "100" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeBasic" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "codes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "100" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "customerGets" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "value" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "__typename" } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountPercentage" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "percentage" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountAmount" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeBxgy" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "codes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "100" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeFreeShipping" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "codes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "100" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }] } }] } }] } }] } }] } }] } }] } }] } }] }, I9 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "searchProducts" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "productCount" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "mediaCount" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "products" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "productCount" } } }, { kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "onlineStoreUrl" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "tags" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "totalInventory" } }, { kind: "Field", name: { kind: "Name", value: "priceRangeV2" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "maxVariantPrice" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "minVariantPrice" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "media" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "mediaCount" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "alt" } }, { kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "mediaContentType" } }, { kind: "Field", name: { kind: "Name", value: "preview" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "image" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "altText" } }, { kind: "Field", name: { kind: "Name", value: "url" } }] } }] } }] } }] } }] } }] } }] } }] } }] }, $9 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "shopifySuggestedRefund" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "orderId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "refundLineItems" } }, type: { kind: "ListType", type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_RefundLineItemInput" } } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "refundShipping" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "suggestFullRefund" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "order" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "orderId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "suggestedRefund" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "refundLineItems" }, value: { kind: "Variable", name: { kind: "Name", value: "refundLineItems" } } }, { kind: "Argument", name: { kind: "Name", value: "refundShipping" }, value: { kind: "Variable", name: { kind: "Name", value: "refundShipping" } } }, { kind: "Argument", name: { kind: "Name", value: "suggestFullRefund" }, value: { kind: "Variable", name: { kind: "Name", value: "suggestFullRefund" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amountSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "subtotalSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "totalTaxSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "shipping" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amountSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "maximumRefundableSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "suggestedTransactions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "accountNumber" } }, { kind: "Field", name: { kind: "Name", value: "gateway" } }, { kind: "Field", name: { kind: "Name", value: "kind" } }, { kind: "Field", name: { kind: "Name", value: "parentTransaction" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }, { kind: "Field", name: { kind: "Name", value: "amountSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "refundLineItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "lineItem" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }] } }] } }] } }] } }] } }] } }] }, E9 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "test" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shop" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "description" } }] } }] } }] } }] }, T9 = {
  "\n  mutation refundCreate($input: Shopify_RefundInput!) {\n    Shopify {\n      refundCreate(input: $input) {\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": f9,
  "\n  mutation orderUpdate($input: Shopify_OrderInput!) {\n    Shopify {\n      orderUpdate(input: $input) {\n        order {\n          shippingAddress {\n            firstName\n            lastName\n            company\n            address1\n            address2\n            city\n            countryCodeV2\n            provinceCode\n            zip\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": h9,
  "\n  mutation orderCancel(\n    $notifyCustomer: Boolean\n    $orderId: ID!\n    $reason: Shopify_OrderCancelReason!\n    $refundMethod: Shopify_OrderCancelRefundMethodInput!\n    $restock: Boolean!\n    $staffNote: String!\n  ) {\n    Shopify {\n      orderCancel(\n        notifyCustomer: $notifyCustomer\n        orderId: $orderId\n        reason: $reason\n        refundMethod: $refundMethod\n        restock: $restock\n        staffNote: $staffNote\n      ) {\n        job {\n          id\n          done\n        }\n        orderCancelUserErrors {\n          code\n          field\n          message\n        }\n      }\n    }\n  }\n": y9,
  "\n  mutation createCustomer($input: Shopify_CustomerInput!) {\n    Shopify {\n      customerCreate(input: $input) {\n        userErrors {\n          field\n          message\n        }\n        customer {\n          id\n          defaultEmailAddress {\n            emailAddress\n          }\n          defaultPhoneNumber {\n            phoneNumber\n            marketingState\n            marketingOptInLevel\n          }\n          taxExempt\n          firstName\n          lastName\n          amountSpent {\n            amount\n            currencyCode\n          }\n        }\n      }\n    }\n  }\n": g9,
  "\n  mutation createOrder(\n    $order: Shopify_OrderCreateOrderInput!\n    $options: Shopify_OrderCreateOptionsInput\n  ) {\n    Shopify {\n      orderCreate(order: $order, options: $options) {\n        order {\n          id\n          name\n          createdAt\n          displayFulfillmentStatus\n          displayFinancialStatus\n          totalPriceSet {\n            presentmentMoney {\n              amount\n              currencyCode\n            }\n            shopMoney {\n              amount\n              currencyCode\n            }\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": v9,
  "\n  mutation createDraftOrder($input: Shopify_DraftOrderInput!) {\n    Shopify {\n      draftOrderCreate(input: $input) {\n        draftOrder {\n          id\n          name\n          createdAt\n          tags\n          status\n          totalPriceSet {\n            presentmentMoney {\n              amount\n              currencyCode\n            }\n            shopMoney {\n              amount\n              currencyCode\n            }\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": k9,
  "\n  mutation createDiscountCode($input: Shopify_DiscountCodeBasicInput!) {\n    Shopify {\n      discountCodeBasicCreate(basicCodeDiscount: $input) {\n        codeDiscountNode {\n          id\n          codeDiscount {\n            ... on Shopify_DiscountCodeBasic {\n              codes(first: 1) {\n                nodes {\n                  code\n                }\n              }\n              title\n              status\n              startsAt\n              endsAt\n              usageLimit\n              appliesOncePerCustomer\n            }\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": b9,
  "\n  mutation orderMarkAsPaid($input: Shopify_OrderMarkAsPaidInput!) {\n    Shopify {\n      orderMarkAsPaid(input: $input) {\n        order {\n          id\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": _9,
  "\n  mutation refundLineItems($input: Shopify_RefundInput!) {\n    Shopify {\n      refundCreate(input: $input) {\n        refund {\n          id\n          totalRefundedSet {\n            presentmentMoney {\n              amount\n              currencyCode\n            }\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": x9,
  "\n  mutation updateOrder($input: Shopify_OrderInput!) {\n    Shopify {\n      orderUpdate(input: $input) {\n        order {\n          id\n          tags\n        }\n      }\n    }\n  }\n": S9,
  "\n  query segments($first: Int!) {\n    Shopify {\n      segments(first: $first) {\n        edges {\n          node {\n            id\n            name\n          }\n        }\n      }\n    }\n  }\n": N9,
  "\n  query customerSegmentMembership($customerId: ID!, $segmentIds: [ID!]!) {\n    Shopify {\n      customerSegmentMembership(\n        customerId: $customerId\n        segmentIds: $segmentIds\n      ) {\n        memberships {\n          segmentId\n          isMember\n        }\n      }\n    }\n  }\n": j9,
  "\n  query shopifyCustomerData($query: String!) {\n    Shopify {\n      shop {\n        countriesInShippingZones {\n          countryCodes\n        }\n      }\n\n      customers(first: 1, query: $query) {\n        edges {\n          node {\n            id\n            displayName\n            firstName\n            lastName\n            defaultEmailAddress {\n              emailAddress\n              marketingOptInLevel\n              marketingState\n              marketingUpdatedAt\n            }\n            defaultPhoneNumber {\n              phoneNumber\n              marketingOptInLevel\n              marketingState\n              marketingUpdatedAt\n            }\n            numberOfOrders\n            tags\n            verifiedEmail\n            amountSpent {\n              amount\n              currencyCode\n            }\n            defaultAddress {\n              firstName\n              lastName\n              address1\n              address2\n              city\n              country\n              zip\n              phone\n              provinceCode\n              countryCodeV2\n            }\n          }\n        }\n      }\n    }\n  }\n": w9,
  "\n  query shopifyCustomerOrders($query: String!) {\n    Shopify {\n      orders(first: 5, query: $query, sortKey: CREATED_AT, reverse: true) {\n        edges {\n          node {\n            id\n            name\n            createdAt\n            displayFulfillmentStatus\n            displayFinancialStatus\n            cancelledAt\n            tags\n            discountCodes\n            netPaymentSet {\n              presentmentMoney {\n                amount\n                currencyCode\n              }\n            }\n            totalRefundedSet {\n              presentmentMoney {\n                amount\n                currencyCode\n              }\n            }\n            billingAddress {\n              firstName\n              lastName\n              company\n              address1\n              address2\n              city\n              country\n              countryCodeV2\n              province\n              provinceCode\n              zip\n              phone\n            }\n            shippingAddress {\n              firstName\n              lastName\n              company\n              address1\n              address2\n              city\n              country\n              countryCodeV2\n              province\n              provinceCode\n              zip\n              phone\n            }\n            suggestedRefund(suggestFullRefund: true, refundShipping: true) {\n              amountSet {\n                presentmentMoney {\n                  amount\n                  currencyCode\n                }\n              }\n              subtotalSet {\n                presentmentMoney {\n                  amount\n                  currencyCode\n                }\n              }\n              totalTaxSet {\n                presentmentMoney {\n                  amount\n                  currencyCode\n                }\n              }\n              shipping {\n                amountSet {\n                  presentmentMoney {\n                    amount\n                    currencyCode\n                  }\n                }\n                maximumRefundableSet {\n                  presentmentMoney {\n                    amount\n                    currencyCode\n                  }\n                }\n              }\n              suggestedTransactions {\n                accountNumber\n                gateway\n                kind\n                parentTransaction {\n                  id\n                }\n                amountSet {\n                  presentmentMoney {\n                    amount\n                    currencyCode\n                  }\n                }\n              }\n              refundLineItems {\n                lineItem {\n                  id\n                  quantity\n                }\n              }\n            }\n            shippingLines(first: 5) {\n              edges {\n                node {\n                  title\n                  code\n                  source\n                  discountedPriceSet {\n                    shopMoney {\n                      amount\n                      currencyCode\n                    }\n                  }\n                }\n              }\n            }\n            fulfillments(first: 2) {\n              trackingInfo {\n                company\n                number\n                url\n              }\n            }\n            lineItems(first: 15) {\n              edges {\n                node {\n                  id\n                  title\n                  quantity\n                  variantTitle\n                  sku\n                  image {\n                    url\n                  }\n                  product {\n                    id\n                  }\n                  discountedUnitPriceSet {\n                    shopMoney {\n                      amount\n                      currencyCode\n                    }\n                  }\n                }\n              }\n            }\n            refunds {\n              totalRefunded {\n                amount\n                currencyCode\n              }\n              refundLineItems(first: 250) {\n                edges {\n                  node {\n                    id\n                    quantity\n                    lineItem {\n                      id\n                      title\n                    }\n                  }\n                }\n              }\n            }\n            currentTotalPriceSet {\n              presentmentMoney {\n                amount\n                currencyCode\n              }\n              shopMoney {\n                amount\n                currencyCode\n              }\n            }\n            currentTotalDiscountsSet {\n              shopMoney {\n                amount\n                currencyCode\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": C9,
  "\n  query searchDiscountCodes($query: String, $first: Int, $after: String) {\n    Shopify {\n      discountNodes(query: $query, first: $first, after: $after) {\n        pageInfo {\n          hasNextPage\n          endCursor\n        }\n        nodes {\n          id\n          discount {\n            __typename\n\n            ... on Shopify_DiscountCodeApp {\n              title\n              status\n              codes(first: 100) {\n                nodes {\n                  code\n                }\n              }\n            }\n\n            ... on Shopify_DiscountCodeBasic {\n              title\n              status\n              codes(first: 100) {\n                nodes {\n                  code\n                }\n              }\n              customerGets {\n                value {\n                  __typename\n\n                  ... on Shopify_DiscountPercentage {\n                    percentage\n                  }\n\n                  ... on Shopify_DiscountAmount {\n                    amount {\n                      amount\n                      currencyCode\n                    }\n                  }\n                }\n              }\n            }\n\n            ... on Shopify_DiscountCodeBxgy {\n              title\n              status\n              codes(first: 100) {\n                nodes {\n                  code\n                }\n              }\n            }\n\n            ... on Shopify_DiscountCodeFreeShipping {\n              title\n              status\n              codes(first: 100) {\n                nodes {\n                  code\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": F9,
  "\n  query searchProducts($query: String!, $productCount: Int, $mediaCount: Int) {\n    Shopify {\n      products(first: $productCount, query: $query) {\n        nodes {\n          id\n          title\n          description\n          onlineStoreUrl\n          status\n          tags\n          title\n          totalInventory\n          priceRangeV2 {\n            maxVariantPrice {\n              amount\n              currencyCode\n            }\n            minVariantPrice {\n              amount\n              currencyCode\n            }\n          }\n          media(first: $mediaCount) {\n            nodes {\n              alt\n              id\n              status\n              mediaContentType\n              preview {\n                image {\n                  id\n                  altText\n                  url\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": I9,
  "\n  query shopifySuggestedRefund(\n    $orderId: ID!\n    $refundLineItems: [Shopify_RefundLineItemInput!]\n    $refundShipping: Boolean\n    $suggestFullRefund: Boolean\n  ) {\n    Shopify {\n      order(id: $orderId) {\n        id\n        suggestedRefund(\n          refundLineItems: $refundLineItems\n          refundShipping: $refundShipping\n          suggestFullRefund: $suggestFullRefund\n        ) {\n          amountSet {\n            presentmentMoney {\n              amount\n              currencyCode\n            }\n          }\n          subtotalSet {\n            presentmentMoney {\n              amount\n              currencyCode\n            }\n          }\n          totalTaxSet {\n            presentmentMoney {\n              amount\n              currencyCode\n            }\n          }\n          shipping {\n            amountSet {\n              presentmentMoney {\n                amount\n                currencyCode\n              }\n            }\n            maximumRefundableSet {\n              presentmentMoney {\n                amount\n                currencyCode\n              }\n            }\n          }\n          suggestedTransactions {\n            accountNumber\n            gateway\n            kind\n            parentTransaction {\n              id\n            }\n            amountSet {\n              presentmentMoney {\n                amount\n                currencyCode\n              }\n            }\n          }\n          refundLineItems {\n            lineItem {\n              id\n              quantity\n            }\n          }\n        }\n      }\n    }\n  }\n": $9,
  "\n  query test {\n    Shopify {\n      shop {\n        name\n        email\n        description\n      }\n    }\n  }\n": E9
};
function or(e) {
  return T9[e] ?? {};
}
const R9 = or(
  /* GraphQL */
  `
  query shopifyCustomerData($query: String!) {
    Shopify {
      shop {
        countriesInShippingZones {
          countryCodes
        }
      }

      customers(first: 1, query: $query) {
        edges {
          node {
            id
            displayName
            firstName
            lastName
            defaultEmailAddress {
              emailAddress
              marketingOptInLevel
              marketingState
              marketingUpdatedAt
            }
            defaultPhoneNumber {
              phoneNumber
              marketingOptInLevel
              marketingState
              marketingUpdatedAt
            }
            numberOfOrders
            tags
            verifiedEmail
            amountSpent {
              amount
              currencyCode
            }
            defaultAddress {
              firstName
              lastName
              address1
              address2
              city
              country
              zip
              phone
              provinceCode
              countryCodeV2
            }
          }
        }
      }
    }
  }
`
), D9 = or(
  /* GraphQL */
  `
  query shopifyCustomerOrders($query: String!) {
    Shopify {
      orders(first: 5, query: $query, sortKey: CREATED_AT, reverse: true) {
        edges {
          node {
            id
            name
            createdAt
            displayFulfillmentStatus
            displayFinancialStatus
            cancelledAt
            tags
            discountCodes
            netPaymentSet {
              presentmentMoney {
                amount
                currencyCode
              }
            }
            totalRefundedSet {
              presentmentMoney {
                amount
                currencyCode
              }
            }
            billingAddress {
              firstName
              lastName
              company
              address1
              address2
              city
              country
              countryCodeV2
              province
              provinceCode
              zip
              phone
            }
            shippingAddress {
              firstName
              lastName
              company
              address1
              address2
              city
              country
              countryCodeV2
              province
              provinceCode
              zip
              phone
            }
            suggestedRefund(suggestFullRefund: true, refundShipping: true) {
              amountSet {
                presentmentMoney {
                  amount
                  currencyCode
                }
              }
              subtotalSet {
                presentmentMoney {
                  amount
                  currencyCode
                }
              }
              totalTaxSet {
                presentmentMoney {
                  amount
                  currencyCode
                }
              }
              shipping {
                amountSet {
                  presentmentMoney {
                    amount
                    currencyCode
                  }
                }
                maximumRefundableSet {
                  presentmentMoney {
                    amount
                    currencyCode
                  }
                }
              }
              suggestedTransactions {
                accountNumber
                gateway
                kind
                parentTransaction {
                  id
                }
                amountSet {
                  presentmentMoney {
                    amount
                    currencyCode
                  }
                }
              }
              refundLineItems {
                lineItem {
                  id
                  quantity
                }
              }
            }
            shippingLines(first: 5) {
              edges {
                node {
                  title
                  code
                  source
                  discountedPriceSet {
                    shopMoney {
                      amount
                      currencyCode
                    }
                  }
                }
              }
            }
            fulfillments(first: 2) {
              trackingInfo {
                company
                number
                url
              }
            }
            lineItems(first: 15) {
              edges {
                node {
                  id
                  title
                  quantity
                  variantTitle
                  sku
                  image {
                    url
                  }
                  product {
                    id
                  }
                  discountedUnitPriceSet {
                    shopMoney {
                      amount
                      currencyCode
                    }
                  }
                }
              }
            }
            refunds {
              totalRefunded {
                amount
                currencyCode
              }
              refundLineItems(first: 250) {
                edges {
                  node {
                    id
                    quantity
                    lineItem {
                      id
                      title
                    }
                  }
                }
              }
            }
            currentTotalPriceSet {
              presentmentMoney {
                amount
                currencyCode
              }
              shopMoney {
                amount
                currencyCode
              }
            }
            currentTotalDiscountsSet {
              shopMoney {
                amount
                currencyCode
              }
            }
          }
        }
      }
    }
  }
`
), O9 = or(
  /* GraphQL */
  `
  query shopifySuggestedRefund(
    $orderId: ID!
    $refundLineItems: [Shopify_RefundLineItemInput!]
    $refundShipping: Boolean
    $suggestFullRefund: Boolean
  ) {
    Shopify {
      order(id: $orderId) {
        id
        suggestedRefund(
          refundLineItems: $refundLineItems
          refundShipping: $refundShipping
          suggestFullRefund: $suggestFullRefund
        ) {
          amountSet {
            presentmentMoney {
              amount
              currencyCode
            }
          }
          subtotalSet {
            presentmentMoney {
              amount
              currencyCode
            }
          }
          totalTaxSet {
            presentmentMoney {
              amount
              currencyCode
            }
          }
          shipping {
            amountSet {
              presentmentMoney {
                amount
                currencyCode
              }
            }
            maximumRefundableSet {
              presentmentMoney {
                amount
                currencyCode
              }
            }
          }
          suggestedTransactions {
            accountNumber
            gateway
            kind
            parentTransaction {
              id
            }
            amountSet {
              presentmentMoney {
                amount
                currencyCode
              }
            }
          }
          refundLineItems {
            lineItem {
              id
              quantity
            }
          }
        }
      }
    }
  }
`
), P9 = or(
  /* GraphQL */
  `
  query segments($first: Int!) {
    Shopify {
      segments(first: $first) {
        edges {
          node {
            id
            name
          }
        }
      }
    }
  }
`
), A9 = or(
  /* GraphQL */
  `
  query customerSegmentMembership($customerId: ID!, $segmentIds: [ID!]!) {
    Shopify {
      customerSegmentMembership(
        customerId: $customerId
        segmentIds: $segmentIds
      ) {
        memberships {
          segmentId
          isMember
        }
      }
    }
  }
`
), ev = or(
  /* GraphQL */
  `
  query searchProducts($query: String!, $productCount: Int, $mediaCount: Int) {
    Shopify {
      products(first: $productCount, query: $query) {
        nodes {
          id
          title
          description
          onlineStoreUrl
          status
          tags
          title
          totalInventory
          priceRangeV2 {
            maxVariantPrice {
              amount
              currencyCode
            }
            minVariantPrice {
              amount
              currencyCode
            }
          }
          media(first: $mediaCount) {
            nodes {
              alt
              id
              status
              mediaContentType
              preview {
                image {
                  id
                  altText
                  url
                }
              }
            }
          }
        }
      }
    }
  }
`
), L9 = or(
  /* GraphQL */
  `
  query searchDiscountCodes($query: String, $first: Int, $after: String) {
    Shopify {
      discountNodes(query: $query, first: $first, after: $after) {
        pageInfo {
          hasNextPage
          endCursor
        }
        nodes {
          id
          discount {
            __typename

            ... on Shopify_DiscountCodeApp {
              title
              status
              codes(first: 100) {
                nodes {
                  code
                }
              }
            }

            ... on Shopify_DiscountCodeBasic {
              title
              status
              codes(first: 100) {
                nodes {
                  code
                }
              }
              customerGets {
                value {
                  __typename

                  ... on Shopify_DiscountPercentage {
                    percentage
                  }

                  ... on Shopify_DiscountAmount {
                    amount {
                      amount
                      currencyCode
                    }
                  }
                }
              }
            }

            ... on Shopify_DiscountCodeBxgy {
              title
              status
              codes(first: 100) {
                nodes {
                  code
                }
              }
            }

            ... on Shopify_DiscountCodeFreeShipping {
              title
              status
              codes(first: 100) {
                nodes {
                  code
                }
              }
            }
          }
        }
      }
    }
  }
`
), V9 = or(
  /* GraphQL */
  `
  mutation orderUpdate($input: Shopify_OrderInput!) {
    Shopify {
      orderUpdate(input: $input) {
        order {
          shippingAddress {
            firstName
            lastName
            company
            address1
            address2
            city
            countryCodeV2
            provinceCode
            zip
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`
), z9 = or(
  /* GraphQL */
  `
  mutation refundCreate($input: Shopify_RefundInput!) {
    Shopify {
      refundCreate(input: $input) {
        userErrors {
          field
          message
        }
      }
    }
  }
`
), U9 = or(
  /* GraphQL */
  `
  mutation orderCancel(
    $notifyCustomer: Boolean
    $orderId: ID!
    $reason: Shopify_OrderCancelReason!
    $refundMethod: Shopify_OrderCancelRefundMethodInput!
    $restock: Boolean!
    $staffNote: String!
  ) {
    Shopify {
      orderCancel(
        notifyCustomer: $notifyCustomer
        orderId: $orderId
        reason: $reason
        refundMethod: $refundMethod
        restock: $restock
        staffNote: $staffNote
      ) {
        job {
          id
          done
        }
        orderCancelUserErrors {
          code
          field
          message
        }
      }
    }
  }
`
), M9 = or(
  /* GraphQL */
  `
  mutation updateOrder($input: Shopify_OrderInput!) {
    Shopify {
      orderUpdate(input: $input) {
        order {
          id
          tags
        }
      }
    }
  }
`
), B9 = or(
  /* GraphQL */
  `
  mutation createCustomer($input: Shopify_CustomerInput!) {
    Shopify {
      customerCreate(input: $input) {
        userErrors {
          field
          message
        }
        customer {
          id
          defaultEmailAddress {
            emailAddress
          }
          defaultPhoneNumber {
            phoneNumber
            marketingState
            marketingOptInLevel
          }
          taxExempt
          firstName
          lastName
          amountSpent {
            amount
            currencyCode
          }
        }
      }
    }
  }
`
), q9 = or(
  /* GraphQL */
  `
  mutation createDiscountCode($input: Shopify_DiscountCodeBasicInput!) {
    Shopify {
      discountCodeBasicCreate(basicCodeDiscount: $input) {
        codeDiscountNode {
          id
          codeDiscount {
            ... on Shopify_DiscountCodeBasic {
              codes(first: 1) {
                nodes {
                  code
                }
              }
              title
              status
              startsAt
              endsAt
              usageLimit
              appliesOncePerCustomer
            }
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`
), AF = Kl`
  mutation createOrder(
    $order: Shopify_OrderCreateOrderInput!
    $options: Shopify_OrderCreateOptionsInput
  ) {
    Shopify {
      orderCreate(order: $order, options: $options) {
        order {
          id
          name
          createdAt
          displayFulfillmentStatus
          displayFinancialStatus
          totalPriceSet {
            presentmentMoney {
              amount
              currencyCode
            }
            shopMoney {
              amount
              currencyCode
            }
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`, H9 = Kl`
  mutation createDraftOrder($input: Shopify_DraftOrderInput!) {
    Shopify {
      draftOrderCreate(input: $input) {
        draftOrder {
          id
          name
          createdAt
          tags
          status
          totalPriceSet {
            presentmentMoney {
              amount
              currencyCode
            }
            shopMoney {
              amount
              currencyCode
            }
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`, LF = or(
  /* GraphQL */
  `
  mutation orderMarkAsPaid($input: Shopify_OrderMarkAsPaidInput!) {
    Shopify {
      orderMarkAsPaid(input: $input) {
        order {
          id
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`
), W9 = ({
  conversationContext: e,
  forcePhoneLookup: n
}) => {
  const { useQuery: r } = fn(), i = e.customer?.email, a = e.customer?.phone_number, o = i ? `email:"${i}"` : null, s = a ? `phone:"${a}"` : null, l = n ? s : o ?? s, {
    loading: d,
    error: m,
    data: u,
    refetch: f,
    networkStatus: h
  } = r(R9, {
    skip: !l,
    variables: {
      query: l
    },
    notifyOnNetworkStatusChange: !0
  });
  return {
    isCustomerLoading: d,
    customerError: m,
    customerData: u,
    refetchCustomer: f,
    customerNetworkStatus: h
  };
}, K9 = () => {
  const { useLazyQuery: e } = fn(), [
    n,
    {
      loading: r,
      error: i,
      data: a,
      refetch: o
    }
  ] = e(D9);
  return {
    getCustomerOrders: n,
    isCustomerOrdersLoading: r,
    customerOrdersError: i,
    customerOrders: a,
    refetchCustomerOrders: o
  };
};
function Wr(e = !1, n) {
  const [r, i] = me(e);
  return Xe(() => {
    const a = r ? window.setTimeout(() => i(!1), 2e3) : void 0;
    return () => window.clearTimeout(a);
  }, [n, r]), { isCopied: r, copy: (a) => {
    navigator.clipboard.writeText(a), i(!0);
  } };
}
const VF = (e, n) => (n ?? []).map(({ amountSet: r, gateway: i, parentTransaction: a }) => ({
  amount: String(r?.presentmentMoney?.amount ?? "0.00"),
  gateway: i ?? "",
  kind: PF.Refund,
  orderId: e,
  parentId: a?.id
})), zF = ({
  orderId: e,
  transactions: n,
  refundLineItems: r,
  refundShipping: i,
  note: a,
  notify: o = !0
}) => ({
  orderId: e,
  notify: o,
  note: a,
  refundLineItems: r,
  transactions: n,
  shipping: {
    fullRefund: i
  }
}), G9 = ({
  ordersData: e
}) => {
  const n = (r) => r?.fulfillments?.length > 0 ? r.fulfillments[0].trackingInfo : [];
  return e.map(({ node: r }) => ({
    id: r.id,
    name: r.name,
    createdAt: new Date(r.createdAt),
    cancelledAt: r.cancelledAt ? new Date(r.cancelledAt) : void 0,
    status: `${r.displayFulfillmentStatus?.toLowerCase()}, ${r.displayFinancialStatus?.toLowerCase()}${r.cancelledAt ? ", cancelled" : ""}`,
    displayFinancialStatus: r.displayFinancialStatus,
    currentTotalPriceSet: r.currentTotalPriceSet,
    currentTotalDiscountsSet: r.currentTotalDiscountsSet,
    value: r.netPaymentSet?.presentmentMoney?.amount,
    currencyCode: r.netPaymentSet?.presentmentMoney?.currencyCode,
    shippingAddress: r.shippingAddress,
    billingAddress: r.billingAddress,
    lineItems: r.lineItems?.edges?.map(({ node: i }) => i),
    suggestedRefund: {
      orderId: r.id,
      amount: r.suggestedRefund?.amountSet?.presentmentMoney?.amount,
      subtotal: r.suggestedRefund?.subtotalSet?.presentmentMoney?.amount,
      tax: r.suggestedRefund?.totalTaxSet?.presentmentMoney?.amount,
      currency: r.suggestedRefund?.amountSet?.presentmentMoney?.currencyCode,
      notify: !0,
      refundLineItems: r.suggestedRefund?.refundLineItems.map(
        ({ lineItem: i }) => ({
          lineItemId: i.id,
          quantity: i.quantity
        })
      ),
      transactions: VF(
        r.id,
        r.suggestedRefund?.suggestedTransactions
      ),
      shipping: {
        fullRefund: !0,
        amount: r.suggestedRefund?.shipping?.amountSet?.presentmentMoney?.amount,
        maximumRefundable: r.suggestedRefund?.shipping?.maximumRefundableSet?.presentmentMoney?.amount
      }
    },
    trackingInfos: n(r),
    shippingLines: r.shippingLines?.edges?.map(({ node: i }) => i),
    tags: r.tags,
    discountCodes: r.discountCodes,
    refunds: r.refunds
  }));
}, Wj = [
  {
    value: Bi.Pending,
    label: "Pending",
    description: "The payment is pending"
  },
  {
    value: Bi.Authorized,
    label: "Authorized",
    description: "The payment has been authorized but not captured"
  },
  {
    value: Bi.Paid,
    label: "Paid",
    description: "The payment has been completed"
  }
], Kj = [
  {
    value: ul.Fulfilled,
    label: "Fulfilled",
    description: "Every line item in the order has been fulfilled"
  },
  {
    value: ul.Partial,
    label: "Partial",
    description: "At least one line item in the order has been fulfilled"
  },
  {
    value: ul.Restocked,
    label: "Restocked",
    description: "Every line item in the order has been restocked and the order canceled"
  }
], UF = (e) => e.length === 0 ? "" : e.map((n) => `id:${n.split("/").pop()}`).join(" OR "), fa = (e) => Y9(J9(e)), Y9 = (e) => Object.fromEntries(
  Object.entries(e ?? {}).filter(([, n]) => n != null)
), J9 = (e) => {
  const n = e;
  if (typeof n == "object" && "countryCodeV2" in n) {
    const { countryCodeV2: r, ...i } = n;
    return {
      ...i,
      ...r && { countryCode: r }
    };
  }
  return e;
}, MF = ({
  orderId: e,
  refundShipping: n,
  refundLineItems: r,
  suggestFullRefund: i,
  skip: a
}) => {
  const { useQuery: o } = fn(), {
    data: s,
    previousData: l,
    loading: d,
    error: m
  } = o(O9, {
    skip: a,
    fetchPolicy: "cache-and-network",
    notifyOnNetworkStatusChange: !0,
    variables: {
      orderId: e,
      refundShipping: n,
      refundLineItems: r,
      suggestFullRefund: i
    }
  }), u = a ? void 0 : s?.Shopify?.order?.suggestedRefund ?? l?.Shopify?.order?.suggestedRefund;
  return { suggestedRefund: Zn(() => {
    if (u)
      return {
        amount: String(u.amountSet.presentmentMoney.amount),
        subtotal: String(u.subtotalSet.presentmentMoney.amount),
        tax: String(u.totalTaxSet.presentmentMoney.amount),
        currency: u.amountSet.presentmentMoney.currencyCode,
        shipping: {
          amount: String(
            u.shipping.amountSet.presentmentMoney.amount
          ),
          maximumRefundable: String(
            u.shipping.maximumRefundableSet.presentmentMoney.amount
          )
        },
        transactions: VF(
          e,
          u.suggestedTransactions
        ),
        refundLineItems: u.refundLineItems.map(
          ({ lineItem: f }) => ({
            lineItemId: f.id,
            quantity: f.quantity
          })
        )
      };
  }, [u, e]), isLoading: d, error: m };
}, Q9 = {
  nodes: [],
  hasMoreResults: !1
}, BF = (e) => "codes" in e.discount, Gj = (e) => BF(e) ? e.discount.codes.nodes[0]?.code ?? "" : "", X9 = (e) => [...e].sort(
  (n, r) => Gj(n).localeCompare(Gj(r))
), Z9 = (e) => {
  const n = e?.Shopify?.discountNodes, r = (n?.nodes ?? []).filter(
    BF
  );
  return {
    nodes: X9(r),
    hasMoreResults: !!n?.pageInfo?.hasNextPage
  };
}, e7 = 300, Yj = 2, n7 = 250, qF = ({
  enabled: e = !0
} = {}) => {
  const { useLazyQuery: n, showNotification: r } = fn(), [i, a] = me(""), [o, s] = me([]), [l, d] = me(!1), [m, u] = me(!1), f = Tr(null), h = Tr(0), [v] = n(L9, {
    fetchPolicy: "no-cache"
  }), w = (j) => {
    s(j.nodes), d(j.hasMoreResults);
  }, N = async (j, _) => {
    const g = h.current + 1;
    h.current = g, u(!0);
    try {
      const O = await v({
        variables: { query: j, first: n7 }
      });
      if (g !== h.current)
        return;
      if (O.error)
        throw O.error;
      const R = Z9(O.data);
      _ && (f.current = R), w(R);
    } catch {
      if (g !== h.current)
        return;
      w(Q9), r({
        title: "Something went wrong",
        text: "Could not search for discount codes. Please try again.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    } finally {
      g === h.current && u(!1);
    }
  };
  return xi(
    () => {
      if (!e)
        return;
      const j = i.trim(), _ = j.length === 0;
      if (!(!_ && j.length < Yj)) {
        if (_ && f.current) {
          w(f.current);
          return;
        }
        N(
          _ ? void 0 : j,
          _
        );
      }
    },
    e7,
    [i, e]
  ), {
    discountNodes: o,
    isLoading: m,
    hasMoreResults: l,
    filter: i,
    setFilter: a,
    minSearchCharacters: Yj
  };
}, t7 = "_list_alvh6_1", r7 = "_listItem_alvh6_4", i7 = "_fullWidth_alvh6_15", a7 = "_boxWrapper_alvh6_19", Bt = {
  list: t7,
  listItem: r7,
  fullWidth: i7,
  boxWrapper: a7
}, o7 = "_modal_1vkwz_1", s7 = "_disabled_1vkwz_5", Oh = {
  modal: o7,
  disabled: s7
}, Jj = [
  {
    label: "Single Opt-In",
    description: "After providing their information, the customer receives marketing information without any intermediate steps.",
    value: Mi.SingleOptIn
  },
  {
    label: "Confirmed Opt-In",
    description: "After providing their information, the customer receives a confirmation and is required to perform a intermediate step before receiving marketing information.",
    value: Mi.ConfirmedOptIn
  },
  {
    label: "Unknown",
    description: "The customer receives marketing information but how they were opted in is unknown.",
    value: Mi.Unknown
  }
], Qj = [
  {
    label: "Not Subscribed",
    description: "The customer hasn’t subscribed to SMS marketing.",
    value: Br.NotSubscribed
  },
  {
    label: "Pending",
    description: "The customer is in the process of subscribing to SMS marketing.",
    value: Br.Pending
  },
  {
    label: "Redacted",
    description: "The customer’s personal data is erased. This value is internally-set and read-only.",
    value: Br.Redacted
  },
  {
    label: "Subscribed",
    description: "The customer is subscribed to SMS marketing.",
    value: Br.Subscribed
  },
  {
    label: "Unsubscribed",
    description: "The customer isn’t currently subscribed to SMS marketing but was previously subscribed.",
    value: Br.Unsubscribed
  }
], l7 = ({
  conversationContext: e,
  isOpen: n,
  setIsOpen: r,
  isMutationLoading: i,
  setIsMutationLoading: a,
  refetchCustomer: o
}) => {
  const { track: s } = jn(), { useMutation: l, showNotification: d } = fn(), [m, u] = me(), [f, h] = me(), [v, w] = V_(!0), [N, j] = V_(!0), _ = !!m, g = e.customer?.email, O = e.customer?.phone_number, R = e.customer?.given_name, $ = e.customer?.family_name, I = {
    email: g ?? "",
    phone: O ?? "",
    firstName: R ?? "",
    lastName: $ ?? "",
    smsMarketingState: null,
    smsMarketingOptInLevel: null
  }, L = ot({
    defaultValues: I
  });
  Xe(() => {
    f?.forEach((P) => {
      const B = P?.field?.[0];
      B && (L.setError(B, {
        type: "server",
        message: P.message
      }), L.setFocus(B));
    });
  }, [f, L]);
  const [G, { error: Q, reset: ne }] = l(B9, {
    onError: (P) => {
      u(P.message), a(!1), d({
        title: "Something went wrong",
        text: "The customer creation was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    },
    onCompleted: async (P) => {
      const B = P?.Shopify?.customerCreate?.userErrors || [];
      B.length > 0 ? (h(B), a(!1), d({
        title: "Something went wrong",
        text: "The customer creation was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      })) : (setTimeout(async () => {
        await o(), a(!1);
      }, 3e3), d({
        title: "Success",
        text: "The customer creation was successful.",
        icon: "check-circle-filled",
        severity: "success"
      }), s("shopify:profile:created"), r(!1));
    }
  }), q = pt(
    (P) => {
      a(!0), u(void 0), G({
        variables: {
          input: {
            firstName: P.firstName,
            lastName: P.lastName,
            ...v && { email: P.email },
            ...N && { phone: P.phone },
            ...P.smsMarketingState && {
              smsMarketingConsent: {
                marketingState: P.smsMarketingState,
                marketingOptInLevel: P.smsMarketingOptInLevel
              }
            }
          }
        }
      });
    },
    [G, a, N, v]
  ), Y = () => {
    r(!1), ne(), u(void 0), L.reset(I);
  };
  return /* @__PURE__ */ k.jsxs(ht, { isOpen: n, onClose: Y, className: Oh.modal, children: [
    /* @__PURE__ */ k.jsx(yt, { title: "Create new customer", onClose: Y }),
    /* @__PURE__ */ k.jsx(gt, { children: /* @__PURE__ */ k.jsxs(et, { children: [
      /* @__PURE__ */ k.jsx(Z, { span: 3, children: /* @__PURE__ */ k.jsx(
        Rn,
        {
          label: "First name",
          name: "firstName",
          control: L.control,
          rules: {
            required: "First name is required"
          }
        }
      ) }),
      /* @__PURE__ */ k.jsx(Z, { span: 3, children: /* @__PURE__ */ k.jsx(
        Rn,
        {
          label: "Last name",
          name: "lastName",
          control: L.control,
          rules: {
            required: "Last name is required"
          }
        }
      ) }),
      /* @__PURE__ */ k.jsx(Z, { children: /* @__PURE__ */ k.jsx(
        Rn,
        {
          label: "Email",
          name: "email",
          control: L.control,
          rules: {
            required: v ? "Email is required" : void 0
          },
          componentProps: {
            className: ut({
              [Oh.disabled]: !v
            }),
            prefix: {
              type: "custom",
              value: /* @__PURE__ */ k.jsx(
                Vo,
                {
                  disabled: !N,
                  name: "hasEmail",
                  value: "email",
                  checked: v,
                  onChange: () => w()
                }
              )
            }
          }
        }
      ) }),
      /* @__PURE__ */ k.jsx(Z, { children: /* @__PURE__ */ k.jsx(
        Rn,
        {
          label: "Phone",
          name: "phone",
          control: L.control,
          rules: {
            required: N ? "Phone is required" : void 0
          },
          componentProps: {
            className: ut({
              [Oh.disabled]: !N
            }),
            prefix: {
              type: "custom",
              value: /* @__PURE__ */ k.jsx(
                Vo,
                {
                  disabled: !v,
                  name: "hasPhone",
                  value: "phone",
                  checked: N,
                  onChange: () => j()
                }
              )
            }
          }
        }
      ) }),
      /* @__PURE__ */ k.jsx(Z, { children: /* @__PURE__ */ k.jsx(
        mr,
        {
          control: L.control,
          label: "SMS marketing state",
          name: "smsMarketingState",
          rules: {
            required: {
              value: !0,
              message: "Please select a marketing state"
            }
          },
          componentProps: {
            placeholder: "Select a marketing state",
            equalityFn: (P, B) => P === B,
            getItemTitleByValue: (P) => {
              const B = Qj.find(
                (ie) => ie.value === P
              );
              return /* @__PURE__ */ k.jsxs(
                b,
                {
                  flexDirection: "column",
                  gap: "100",
                  margin: "100 0 200",
                  children: [
                    /* @__PURE__ */ k.jsx(F.Heading, { variant: "heading-3", children: B.label }),
                    /* @__PURE__ */ k.jsx(F.Paragraph, { color: "secondary", children: B.description })
                  ]
                }
              );
            }
          },
          children: Qj.map((P) => /* @__PURE__ */ k.jsx(mt.Item, { value: P.value, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "100", children: [
            /* @__PURE__ */ k.jsx(F.Heading, { variant: "heading-3", children: P.label }),
            /* @__PURE__ */ k.jsx(F.Paragraph, { color: "secondary", children: P.description })
          ] }) }, P.value))
        }
      ) }),
      /* @__PURE__ */ k.jsx(Z, { children: /* @__PURE__ */ k.jsx(
        mr,
        {
          control: L.control,
          label: "SMS marketing opt-in level",
          name: "smsMarketingOptInLevel",
          rules: {
            required: {
              value: !0,
              message: "Please select a marketing opt-in level"
            }
          },
          componentProps: {
            placeholder: "Select a marketing opt-in level",
            equalityFn: (P, B) => P === B,
            getItemTitleByValue: (P) => {
              const B = Jj.find(
                (ie) => ie.value === P
              );
              return /* @__PURE__ */ k.jsxs(
                b,
                {
                  flexDirection: "column",
                  gap: "100",
                  margin: "100 0 200",
                  children: [
                    /* @__PURE__ */ k.jsx(F.Heading, { variant: "heading-3", children: B.label }),
                    /* @__PURE__ */ k.jsx(F.Paragraph, { color: "secondary", children: B.description })
                  ]
                }
              );
            }
          },
          children: Jj.map((P) => /* @__PURE__ */ k.jsx(mt.Item, { value: P.value, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "100", children: [
            /* @__PURE__ */ k.jsx(F.Heading, { variant: "heading-3", children: P.label }),
            /* @__PURE__ */ k.jsx(F.Paragraph, { color: "secondary", children: P.description })
          ] }) }, P.value))
        }
      ) }),
      _ && /* @__PURE__ */ k.jsx(Z, { children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "row", gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ k.jsx(fe, { name: "close-circle-filled", color: "red.500" }),
        /* @__PURE__ */ k.jsx(F.Paragraph, { children: m })
      ] }) })
    ] }) }),
    /* @__PURE__ */ k.jsx(
      vt,
      {
        confirmProps: {
          disabled: !(L.formState.isValid && L.formState.isDirty),
          isLoading: i,
          loadingIndicator: /* @__PURE__ */ k.jsx(sn, { size: 16 })
        },
        confirmOnClick: L.handleSubmit(q),
        cancelOnClick: Y,
        confirmName: Q ? "Close" : "Save",
        cancelName: Q ? void 0 : "Cancel"
      }
    )
  ] });
}, c7 = ({
  conversationContext: e,
  refetchCustomer: n
}) => {
  const [r, i] = me(!1), [a, o] = me(!1);
  return /* @__PURE__ */ k.jsxs(k.Fragment, { children: [
    /* @__PURE__ */ k.jsx(
      Qn,
      {
        variant: "secondary",
        onClick: () => i(!0),
        isLoading: a,
        loadingIndicator: /* @__PURE__ */ k.jsx(sn, { size: 16 }),
        slotStart: /* @__PURE__ */ k.jsx(fe, { size: 14, name: "user-plus", color: "green.500" }),
        className: Bt.fullWidth,
        children: "Create new Shopify profile"
      }
    ),
    /* @__PURE__ */ k.jsx(
      l7,
      {
        isOpen: r,
        setIsOpen: i,
        isMutationLoading: a,
        setIsMutationLoading: o,
        conversationContext: e,
        refetchCustomer: n
      }
    )
  ] });
}, nv = (e) => {
  const n = e?.match(/shopify\/\w+\/(\d+)/);
  return n ? n[1] : null;
}, Ny = "DD MMM YYYY @ HH:mm", d7 = "_wrapper_10fld_1", u7 = "_copyIcon_10fld_7", Bs = {
  wrapper: d7,
  copyIcon: u7
}, m7 = ({
  customer: e,
  shopifyDomain: n,
  refresh: r,
  loading: i,
  networkStatus: a
}) => {
  const { isCopied: o, copy: s } = Wr(), { isCopied: l, copy: d } = Wr(), { track: m } = jn();
  if (!e)
    return null;
  const {
    id: u,
    displayName: f,
    defaultEmailAddress: h,
    defaultPhoneNumber: v,
    tags: w = [],
    verifiedEmail: N
  } = e, j = h?.emailAddress, _ = v?.phoneNumber, g = nv(u), O = `https://${n}/admin/customers/${g ?? ""}`, R = i && a === ir.refetch, $ = 14;
  return /* @__PURE__ */ k.jsxs(b, { gap: "300", flexDirection: "column", children: [
    /* @__PURE__ */ k.jsxs(b, { className: Bs.wrapper, gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ k.jsx(F.Heading, { variant: "heading-3", children: f }),
        R ? /* @__PURE__ */ k.jsx(sn, { size: $ }) : /* @__PURE__ */ k.jsx(Ge, { content: "Reload customer", children: /* @__PURE__ */ k.jsx(
          fe,
          {
            size: $,
            name: "sync",
            onClick: () => {
              m("shopify:refreshed", { shopifyId: u }), r();
            },
            className: Bs.copyIcon
          }
        ) })
      ] }),
      j && /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ k.jsxs(b, { alignItems: "center", gap: "200", children: [
          /* @__PURE__ */ k.jsx(fe, { size: $, name: "mail" }),
          /* @__PURE__ */ k.jsx(F.ExternalLink, { href: `mailto:${j}`, children: j }),
          /* @__PURE__ */ k.jsx(
            Ge,
            {
              content: N ? "Verified email" : "Email is not verified",
              children: /* @__PURE__ */ k.jsx(b, { alignItems: "center", children: /* @__PURE__ */ k.jsx(
                fe,
                {
                  size: $,
                  color: N ? "green.500" : "red.500",
                  name: N ? "check-circle" : "exclamation"
                }
              ) })
            }
          )
        ] }),
        /* @__PURE__ */ k.jsx(Ge, { content: "Copy Email", children: /* @__PURE__ */ k.jsx(
          fe,
          {
            size: $,
            name: o ? "done" : "copy",
            onClick: () => s(j),
            className: Bs.copyIcon
          }
        ) })
      ] }),
      _ && /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ k.jsxs(b, { alignItems: "center", gap: "200", children: [
          /* @__PURE__ */ k.jsx(fe, { size: $, name: "phone" }),
          /* @__PURE__ */ k.jsx(F.ExternalLink, { href: `tel:${_}`, children: _ })
        ] }),
        /* @__PURE__ */ k.jsx(Ge, { content: "Copy phone number", children: /* @__PURE__ */ k.jsx(
          fe,
          {
            size: $,
            name: l ? "done" : "copy",
            onClick: () => d(_),
            className: Bs.copyIcon
          }
        ) })
      ] }),
      /* @__PURE__ */ k.jsxs(b, { alignItems: "center", gap: "200", children: [
        /* @__PURE__ */ k.jsx(fe, { size: $, name: "external-link" }),
        /* @__PURE__ */ k.jsx(
          F.ExternalLink,
          {
            href: O,
            target: "_blank",
            rel: "noreferrer",
            children: "View customer in Shopify"
          }
        )
      ] })
    ] }),
    w.length > 0 && /* @__PURE__ */ k.jsxs(k.Fragment, { children: [
      /* @__PURE__ */ k.jsx(F.Heading, { variant: "heading-3", children: "Tags" }),
      /* @__PURE__ */ k.jsx(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", children: w.map((I) => /* @__PURE__ */ k.jsx(Jn, { children: I }, `${u}-${I}`)) })
    ] })
  ] });
}, p7 = "_creationModal_pbe64_1", f7 = "_detailsModal_pbe64_5", h7 = "_percentageSuffix_pbe64_9", Ph = {
  creationModal: p7,
  detailsModal: f7,
  percentageSuffix: h7
}, y7 = () => {
  const e = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
  return Array.from(
    { length: 12 },
    () => e.charAt(Math.floor(Math.random() * e.length))
  ).join("");
}, g7 = (e) => {
  const n = e.customerGetsOption === "percentage" ? e.customerGets / 100 : e.customerGets, r = (() => {
    switch (e.minimumRequirementOption) {
      case "quantity":
        return "greaterThanOrEqualToQuantity";
      case "subtotal":
        return "greaterThanOrEqualToSubtotal";
      default:
        return null;
    }
  })(), i = e.maximumUsage;
  return {
    code: e.code,
    title: e.title,
    usageLimit: i === "only-once" ? 1 : null,
    appliesOncePerCustomer: i === "once-per-customer",
    customerGets: {
      value: {
        [e.customerGetsOption]: e.customerGetsOption === "discountAmount" ? { amount: n } : n
      },
      items: {
        all: !0
      }
    },
    context: {
      all: OF.All
    },
    ...r && {
      minimumRequirement: {
        [e.minimumRequirementOption]: {
          [r]: e.minimumRequirementOption === "quantity" ? e.minimumRequirementValue?.toString() : e.minimumRequirementValue
        }
      }
    },
    startsAt: (/* @__PURE__ */ new Date()).toISOString()
  };
}, Xj = [
  {
    label: "Percentage",
    description: "The percentage value of the discount.",
    value: "percentage"
  },
  {
    label: "Amount",
    description: "The value of the discount.",
    value: "discountAmount"
  }
], Zj = [
  {
    label: "None",
    description: "No minimum requirements.",
    value: "none"
  },
  {
    label: "Quantity",
    description: "Minimum required quantity of items.",
    value: "quantity"
  },
  {
    label: "Subtotal",
    description: "Minimum required order subtotal.",
    value: "subtotal"
  }
], ew = [
  {
    label: "No limit",
    value: "no-limit",
    description: "The discount code can be used unlimited times."
  },
  {
    label: "Only once",
    value: "only-once",
    description: "The discount code can only be used once."
  },
  {
    label: "Once per customer",
    value: "once-per-customer",
    description: "The discount code can be used once per customer."
  }
], v7 = ({
  codeDiscount: e
}) => {
  const n = e?.codes?.nodes?.[0]?.code, { isCopied: r, copy: i } = Qt(), a = e?.usageLimit ? `${e?.usageLimit} uses remaining` : "No limit";
  return /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "400", children: [
    /* @__PURE__ */ k.jsxs(Je, { children: [
      /* @__PURE__ */ k.jsx(Je.Text, { children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ k.jsx(F.Paragraph, { variant: "1", children: "Title" }),
        /* @__PURE__ */ k.jsx(F.Paragraph, { variant: "2", color: "secondary", children: e?.title })
      ] }) }),
      /* @__PURE__ */ k.jsx(Je.Text, { children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ k.jsx(F.Paragraph, { variant: "1", children: "Status" }),
        /* @__PURE__ */ k.jsxs(b, { gap: "200", alignItems: "center", children: [
          /* @__PURE__ */ k.jsx(
            fe,
            {
              name: e?.status === "ACTIVE" ? "check-circle-filled" : "circle-filled",
              color: e?.status === "ACTIVE" ? "green.500" : "neutral.500"
            }
          ),
          /* @__PURE__ */ k.jsx(F.Paragraph, { variant: "2", color: "secondary", children: e?.status })
        ] })
      ] }) }),
      /* @__PURE__ */ k.jsx(Je.Text, { children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ k.jsx(F.Paragraph, { variant: "1", children: "Usage limit" }),
        /* @__PURE__ */ k.jsx(F.Paragraph, { variant: "2", color: "secondary", children: a })
      ] }) }),
      /* @__PURE__ */ k.jsx(Je.Text, { children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ k.jsx(F.Paragraph, { variant: "1", children: "Applies once per customer" }),
        /* @__PURE__ */ k.jsx(F.Paragraph, { variant: "2", color: "secondary", children: e?.appliesOncePerCustomer ? "Yes" : "No" })
      ] }) }),
      /* @__PURE__ */ k.jsx(Je.Text, { children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ k.jsx(F.Paragraph, { variant: "1", children: "Starts at" }),
        /* @__PURE__ */ k.jsx(F.Paragraph, { variant: "2", color: "secondary", children: Wn(e?.startsAt).format(It) })
      ] }) })
    ] }),
    /* @__PURE__ */ k.jsx(qe, { label: "Discount code", children: /* @__PURE__ */ k.jsx(
      ur,
      {
        readOnly: !0,
        value: n,
        suffix: {
          type: "button",
          button: {
            icon: r ? "done" : "copy",
            onClick: () => {
              i(n);
            }
          }
        }
      }
    ) })
  ] });
}, k7 = "shopify-discount-code-form", nw = {
  title: "",
  code: "",
  customerGets: void 0,
  customerGetsOption: "percentage",
  minimumRequirementOption: "none",
  minimumRequirementValue: void 0,
  maximumUsage: "only-once"
}, b7 = ({
  isOpen: e,
  setIsOpen: n
}) => {
  const { track: r } = jn(), { useMutation: i, showNotification: a } = fn(), [o, s] = me(
    []
  ), [l, d] = me(), m = ot({
    mode: "all",
    defaultValues: nw
  });
  Xe(() => {
    o?.forEach(($) => {
      const I = $?.field?.[1];
      I && m.setError(I, {
        type: "server",
        message: $.message
      });
    });
  }, [o, m]);
  const u = !!l, f = m.watch("minimumRequirementOption"), h = m.watch("customerGetsOption"), v = Zn(() => {
    switch (f) {
      case "quantity":
        return "Minimum quantity";
      case "subtotal":
        return "Minimum subtotal";
      default:
        return "";
    }
  }, [f]), [
    w,
    {
      loading: N,
      error: j,
      reset: _
    }
  ] = i(q9, {
    onError: () => {
      a({
        title: "Something went wrong",
        text: "The discount code creation was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    },
    onCompleted: ($) => {
      const I = $?.Shopify?.discountCodeBasicCreate?.userErrors;
      if (I && I.length > 0)
        s(I);
      else {
        const L = $?.Shopify?.discountCodeBasicCreate?.codeDiscountNode?.codeDiscount;
        L && "codes" in L && d(L), a({
          title: "Success",
          text: "The discount code was created successfully.",
          icon: "check-circle-filled",
          severity: "success"
        }), r("shopify:discount:code:created"), s([]);
      }
    }
  }), g = () => {
    m.setValue("code", y7(), {
      shouldDirty: !0,
      shouldValidate: !0,
      shouldTouch: !0
    });
  }, O = ($) => {
    w({
      variables: {
        input: g7($)
      }
    });
  }, R = () => {
    m.reset(nw), s([]), _(), d(void 0), n(!1);
  };
  return /* @__PURE__ */ k.jsxs(
    ht,
    {
      isOpen: e,
      onClose: R,
      className: ut({
        [Ph.creationModal]: !u,
        [Ph.detailsModal]: u
      }),
      children: [
        /* @__PURE__ */ k.jsx(
          yt,
          {
            title: u ? "Discount code details" : "Create new discount code",
            onClose: R
          }
        ),
        /* @__PURE__ */ k.jsxs(gt, { children: [
          u && /* @__PURE__ */ k.jsx(v7, { codeDiscount: l }),
          !u && /* @__PURE__ */ k.jsxs("form", { noValidate: !0, id: k7, onSubmit: m.handleSubmit(O), children: [
            /* @__PURE__ */ k.jsx(b, { margin: "0 0 400", children: /* @__PURE__ */ k.jsx(
              Ey,
              {
                variant: "info",
                description: /* @__PURE__ */ k.jsx(F.Paragraph, { children: "This code will be eligible for all customers." })
              }
            ) }),
            /* @__PURE__ */ k.jsxs(et, { children: [
              /* @__PURE__ */ k.jsx(Z, { children: /* @__PURE__ */ k.jsx(
                Rn,
                {
                  label: "Title",
                  name: "title",
                  control: m.control,
                  rules: {
                    required: "Please enter a title"
                  },
                  componentProps: {
                    placeholder: "Enter a title"
                  }
                }
              ) }),
              /* @__PURE__ */ k.jsx(Z, { span: 3, children: /* @__PURE__ */ k.jsx(
                mr,
                {
                  control: m.control,
                  label: "Discount type",
                  name: "customerGetsOption",
                  rules: {
                    required: "Please select a discount type"
                  },
                  componentProps: {
                    placeholder: "Select a discount type",
                    equalityFn: ($, I) => $ === I,
                    onChange: () => {
                      m.setValue("customerGets", void 0), m.clearErrors("customerGets");
                    },
                    getItemTitleByValue: ($) => {
                      const I = Xj.find(
                        (L) => L.value === $
                      );
                      return /* @__PURE__ */ k.jsx(b, { margin: "0 0 100", children: /* @__PURE__ */ k.jsx(F.Heading, { variant: "heading-3", children: I?.label }) });
                    }
                  },
                  children: Xj.map(($) => /* @__PURE__ */ k.jsx(mt.Item, { value: $.value, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "100", children: [
                    /* @__PURE__ */ k.jsx(F.Heading, { variant: "heading-3", children: $.label }),
                    /* @__PURE__ */ k.jsx(F.Paragraph, { color: "secondary", children: $.description })
                  ] }) }, $.value))
                }
              ) }),
              /* @__PURE__ */ k.jsx(Z, { span: 3, children: /* @__PURE__ */ k.jsx(
                Rn,
                {
                  label: "Discount value",
                  name: "customerGets",
                  control: m.control,
                  rules: {
                    required: "Please enter a value",
                    validate: ($) => {
                      if ($) {
                        if (h === "percentage" && ($ < 0 || $ > 100))
                          return "Percentage must be between 0 and 100";
                        if (h === "discountAmount" && $ < 0)
                          return "Discount amount must be greater than 0";
                      }
                    }
                  },
                  componentProps: {
                    placeholder: "Enter a value",
                    type: "number",
                    ...h === "percentage" && {
                      suffix: {
                        type: "custom",
                        noWrap: !0,
                        value: /* @__PURE__ */ k.jsx(
                          b,
                          {
                            alignItems: "center",
                            className: Ph.percentageSuffix,
                            children: "%"
                          }
                        )
                      }
                    }
                  }
                }
              ) }),
              /* @__PURE__ */ k.jsx(Z, { children: /* @__PURE__ */ k.jsx(
                Rn,
                {
                  label: "Code",
                  name: "code",
                  control: m.control,
                  rules: {
                    required: "Please enter a code"
                  },
                  componentProps: {
                    placeholder: "Enter a code or click to the right to generate",
                    suffix: {
                      type: "button",
                      button: {
                        icon: "sync",
                        onClick: g
                      }
                    }
                  }
                }
              ) }),
              /* @__PURE__ */ k.jsx(Z, { span: 3, children: /* @__PURE__ */ k.jsx(
                mr,
                {
                  control: m.control,
                  label: "Minimum purchase requirements",
                  name: "minimumRequirementOption",
                  rules: {
                    required: "Please select a minimum requirement option"
                  },
                  componentProps: {
                    placeholder: "Select a minimum purchase requirement",
                    equalityFn: ($, I) => $ === I,
                    onChange: () => {
                      m.setValue("minimumRequirementValue", void 0), m.clearErrors("minimumRequirementValue");
                    },
                    getItemTitleByValue: ($) => {
                      const I = Zj.find(
                        (L) => L.value === $
                      );
                      return /* @__PURE__ */ k.jsx(b, { margin: "0 0 100", children: /* @__PURE__ */ k.jsx(F.Heading, { variant: "heading-3", children: I?.label }) });
                    }
                  },
                  children: Zj.map(($) => /* @__PURE__ */ k.jsx(mt.Item, { value: $.value, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "100", children: [
                    /* @__PURE__ */ k.jsx(F.Heading, { variant: "heading-3", children: $.label }),
                    /* @__PURE__ */ k.jsx(F.Paragraph, { color: "secondary", children: $.description })
                  ] }) }, $.value))
                }
              ) }),
              /* @__PURE__ */ k.jsx(Z, { span: 3, children: /* @__PURE__ */ k.jsx(
                Rn,
                {
                  name: "minimumRequirementValue",
                  label: v,
                  control: m.control,
                  disabled: f === "none",
                  rules: {
                    required: {
                      value: f !== "none",
                      message: "Please enter a value"
                    },
                    validate: ($) => {
                      if ($ && f !== "none" && $ < 0)
                        return `Minimum ${f} must be greater than 0`;
                    }
                  },
                  componentProps: {
                    type: "number",
                    placeholder: "Enter a value"
                  }
                }
              ) }),
              /* @__PURE__ */ k.jsx(Z, { children: /* @__PURE__ */ k.jsx(
                mr,
                {
                  name: "maximumUsage",
                  label: "Maximum usage",
                  control: m.control,
                  componentProps: {
                    placeholder: "Select a maximum usage",
                    equalityFn: ($, I) => $ === I,
                    getItemTitleByValue: ($) => {
                      const I = ew.find(
                        (L) => L.value === $
                      );
                      return /* @__PURE__ */ k.jsx(b, { margin: "0 0 100", children: /* @__PURE__ */ k.jsx(F.Heading, { variant: "heading-3", children: I?.label }) });
                    }
                  },
                  children: ew.map(($) => /* @__PURE__ */ k.jsx(mt.Item, { value: $.value, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "100", children: [
                    /* @__PURE__ */ k.jsx(F.Heading, { variant: "heading-3", children: $.label }),
                    /* @__PURE__ */ k.jsx(F.Paragraph, { color: "secondary", children: $.description })
                  ] }) }, $.value))
                }
              ) })
            ] })
          ] }),
          j && /* @__PURE__ */ k.jsx($n, { error: j })
        ] }),
        /* @__PURE__ */ k.jsx(
          vt,
          {
            confirmProps: {
              disabled: !u && !(m.formState.isValid && m.formState.isDirty),
              isLoading: N,
              loadingIndicator: /* @__PURE__ */ k.jsx(sn, { size: 16 })
            },
            confirmName: u ? "Close" : "Save",
            confirmOnClick: u ? R : m.handleSubmit(O),
            cancelOnClick: u ? void 0 : R
          }
        )
      ]
    }
  );
}, _7 = ({ code: e }) => {
  const { isCopied: n, copy: r } = Wr();
  return /* @__PURE__ */ k.jsxs(
    b,
    {
      justifyContent: "space-between",
      alignItems: "center",
      gap: "200",
      width: "100%",
      children: [
        /* @__PURE__ */ k.jsxs(b, { gap: "200", alignItems: "center", children: [
          /* @__PURE__ */ k.jsx(fe, { size: 12, name: "shopify", color: "green.500" }),
          /* @__PURE__ */ k.jsx(F.Paragraph, { variant: "3", children: e })
        ] }),
        /* @__PURE__ */ k.jsx(
          Xt,
          {
            icon: n ? "done" : "copy",
            onClick: () => r(e),
            variant: "secondary"
          }
        )
      ]
    }
  );
}, x7 = ({
  discountCode: e
}) => {
  const { discount: n } = e;
  if (!("codes" in n))
    return null;
  const r = n?.codes?.nodes ?? [];
  return /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "100", children: [
    /* @__PURE__ */ k.jsx(F.Heading, { variant: "heading-3", children: n.title }),
    /* @__PURE__ */ k.jsx(Je, { children: r.map((i) => /* @__PURE__ */ k.jsx(Je.Item, { className: Bt.listItem, children: /* @__PURE__ */ k.jsx(_7, { code: i.code }) }, i.code)) })
  ] });
}, S7 = "_modal_11d6e_1", N7 = "_modalBody_11d6e_4", j7 = "_codeContainer_11d6e_9", Ah = {
  modal: S7,
  modalBody: N7,
  codeContainer: j7
}, w7 = ({
  isOpen: e,
  setIsOpen: n
}) => {
  const {
    discountNodes: r,
    isLoading: i,
    filter: a,
    setFilter: o,
    minSearchCharacters: s
  } = qF({ enabled: e }), l = r.length === 0, d = () => {
    o(""), n(!1);
  };
  return /* @__PURE__ */ k.jsxs(ht, { isOpen: e, onClose: d, className: Ah.modal, children: [
    /* @__PURE__ */ k.jsx(yt, { title: "Discount codes", onClose: d }),
    /* @__PURE__ */ k.jsxs(gt, { className: Ah.modalBody, children: [
      /* @__PURE__ */ k.jsx(
        ur,
        {
          type: "search",
          icon: "search",
          value: a,
          placeholder: `Search discount codes (min. ${s} characters)`,
          onChange: (m) => {
            o(m.target.value);
          }
        }
      ),
      i && /* @__PURE__ */ k.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ k.jsx(sn, {}) }),
      !i && l && /* @__PURE__ */ k.jsx(
        zo,
        {
          title: "No discount codes found.",
          description: "There are no discount codes to display. You can create a new discount code with the 'Create new' button in our integration."
        }
      ),
      !i && !l && r.map((m) => /* @__PURE__ */ k.jsx("div", { className: Ah.codeContainer, children: /* @__PURE__ */ k.jsx(x7, { discountCode: m }) }, m.id))
    ] }),
    /* @__PURE__ */ k.jsx(vt, { confirmName: "Close", confirmOnClick: d })
  ] });
}, C7 = ({
  displayDiscountCodeCreation: e
}) => {
  const [n, r] = me(!1), [i, a] = me(!1);
  return /* @__PURE__ */ k.jsxs(k.Fragment, { children: [
    /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ k.jsx(F.Heading, { variant: "heading-3", children: "Discount codes" }),
      /* @__PURE__ */ k.jsxs(b, { gap: "100", flexDirection: "row", alignItems: "center", width: "100%", children: [
        /* @__PURE__ */ k.jsx(b, { flex: "1", children: /* @__PURE__ */ k.jsx(
          Qn,
          {
            variant: "secondary",
            icon: "gift",
            onClick: () => a(!0),
            style: { width: "100%" },
            children: "View discount codes"
          }
        ) }),
        e && /* @__PURE__ */ k.jsx(b, { flex: "1", children: /* @__PURE__ */ k.jsx(
          Qn,
          {
            variant: "secondary",
            icon: "plus",
            onClick: () => r(!0),
            style: { width: "100%" },
            children: "Create new"
          }
        ) })
      ] })
    ] }),
    /* @__PURE__ */ k.jsx(
      w7,
      {
        isOpen: i,
        setIsOpen: a
      }
    ),
    /* @__PURE__ */ k.jsx(
      b7,
      {
        isOpen: n,
        setIsOpen: r
      }
    )
  ] });
}, F7 = ({
  customer: e
}) => {
  if (!e)
    return null;
  const { defaultEmailAddress: n, defaultPhoneNumber: r } = e, i = (h) => h ? Sw(h.replaceAll("_", " ")) : "No state available", a = (h) => {
    switch (h) {
      case pa.Invalid:
      case pa.NotSubscribed:
      case Br.NotSubscribed:
        return "red.500";
      case pa.Pending:
      case Br.Pending:
      case pa.Unsubscribed:
      case Br.Unsubscribed:
        return "orange.500";
      case pa.Subscribed:
      case Br.Subscribed:
        return "green.500";
      default:
        return "neutral.500";
    }
  }, o = (h) => {
    switch (h) {
      case Mi.SingleOptIn:
      case Mi.ConfirmedOptIn:
        return "green.500";
      case Mi.Unknown:
      default:
        return "neutral.200";
    }
  }, {
    marketingState: s,
    marketingUpdatedAt: l,
    marketingOptInLevel: d
  } = n ?? {}, {
    marketingState: m,
    marketingUpdatedAt: u,
    marketingOptInLevel: f
  } = r ?? {};
  return /* @__PURE__ */ k.jsxs(b, { gap: "300", flexDirection: "column", children: [
    /* @__PURE__ */ k.jsx(F.Heading, { variant: "heading-3", children: "Marketing consent" }),
    /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "row", children: [
        /* @__PURE__ */ k.jsx(fe, { name: "mail", color: "neutral.500" }),
        /* @__PURE__ */ k.jsx(F.Heading, { variant: "heading-4", children: "Email" })
      ] }),
      l && /* @__PURE__ */ k.jsx(Ge, { content: "Last updated at", children: /* @__PURE__ */ k.jsx(Pn, { size: "small", variant: "info", children: Wn(l).format(Ny) }) }),
      /* @__PURE__ */ k.jsxs(b, { gap: "100", flexDirection: "row", children: [
        /* @__PURE__ */ k.jsx(Ge, { content: "Opt-In state", children: /* @__PURE__ */ k.jsx(Jn, { color: o(d), children: i(d) }) }),
        /* @__PURE__ */ k.jsx(Ge, { content: "Marketing state", children: /* @__PURE__ */ k.jsx(Jn, { color: a(s), children: i(s) }) })
      ] })
    ] }),
    /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
        /* @__PURE__ */ k.jsx(fe, { name: "phone", color: "neutral.500" }),
        /* @__PURE__ */ k.jsx(F.Heading, { variant: "heading-4", children: "Phone" })
      ] }),
      u && /* @__PURE__ */ k.jsx(Ge, { content: "Last updated at", children: /* @__PURE__ */ k.jsx(Pn, { size: "small", variant: "info", children: Wn(u).format(Ny) }) }),
      /* @__PURE__ */ k.jsxs(b, { gap: "100", flexDirection: "row", children: [
        /* @__PURE__ */ k.jsx(Ge, { content: "Opt-In state", children: /* @__PURE__ */ k.jsx(Jn, { color: o(f), children: i(f) }) }),
        /* @__PURE__ */ k.jsx(Ge, { content: "Marketing state", children: /* @__PURE__ */ k.jsx(Jn, { color: a(m), children: i(m) }) })
      ] })
    ] })
  ] });
}, I7 = (e) => {
  const { discount: n } = e;
  switch (n.__typename) {
    case "Shopify_DiscountCodeBasic": {
      if (n.status !== Sy.Active)
        return null;
      const r = n.codes.nodes[0]?.code;
      if (!r)
        return null;
      const { value: i } = n.customerGets;
      return i.__typename === "Shopify_DiscountPercentage" ? {
        code: r,
        kind: "percentage",
        percentage: Number((i.percentage * 100).toFixed(2))
      } : i.__typename === "Shopify_DiscountAmount" ? {
        code: r,
        kind: "fixedAmount",
        amount: String(i.amount.amount),
        currencyCode: i.amount.currencyCode
      } : null;
    }
    case "Shopify_DiscountCodeFreeShipping": {
      if (n.status !== Sy.Active)
        return null;
      const r = n.codes.nodes[0]?.code;
      return r ? { code: r, kind: "freeShipping" } : null;
    }
    default:
      return null;
  }
}, $7 = (e) => {
  const n = e.map(I7).filter(
    (i) => !!i
  ), r = /* @__PURE__ */ new Map();
  return n.forEach((i) => {
    r.has(i.code) || r.set(i.code, i);
  }), Array.from(r.values());
}, HF = (e) => {
  if (e)
    switch (e.kind) {
      case "percentage":
        return {
          itemPercentageDiscountCode: {
            code: e.code,
            percentage: e.percentage
          }
        };
      case "fixedAmount":
        return {
          itemFixedDiscountCode: {
            code: e.code,
            amountSet: {
              shopMoney: {
                amount: e.amount,
                currencyCode: e.currencyCode
              }
            }
          }
        };
      case "freeShipping":
        return { freeShippingDiscountCode: { code: e.code } };
      default:
        return;
    }
}, E7 = (e) => e ? [e.code] : void 0, jy = (e) => {
  switch (e.kind) {
    case "percentage":
      return `${e.percentage}% off`;
    case "fixedAmount":
      return `${e.amount} ${e.currencyCode} off`;
    case "freeShipping":
      return "Free shipping";
    default:
      return "";
  }
}, WF = ({
  enabled: e
}) => {
  const n = Or(), { discountNodes: r, isLoading: i, filter: a, setFilter: o, minSearchCharacters: s } = qF({ enabled: e }), l = Zn(
    () => $7(r),
    [r]
  ), d = a.trim().length > 0;
  if (!i && !d && l.length === 0)
    return null;
  const m = !i && l.length === 0;
  return /* @__PURE__ */ k.jsx(
    mr,
    {
      label: "Discount code",
      control: n.control,
      name: "discountCode",
      componentProps: {
        clearable: !0,
        placeholder: "Search discount codes",
        tabIndex: 0,
        equalityFn: (u, f) => u?.code === f?.code,
        getItemTitleByValue: (u) => u ? /* @__PURE__ */ k.jsxs(F.Paragraph, { children: [
          u.code,
          " · ",
          jy(u)
        ] }) : null,
        filter: {
          value: a,
          placeholder: `Search discount codes (min. ${s} characters)`,
          onChange: (u) => {
            o(u.target.value);
          }
        },
        onToggleDropdown: (u) => {
          !u && a !== "" && o("");
        }
      },
      children: /* @__PURE__ */ k.jsxs(k.Fragment, { children: [
        i && /* @__PURE__ */ k.jsx(mt.Item, { noFixedSelectionStateSpace: !0, children: /* @__PURE__ */ k.jsx(b, { justifyContent: "center", padding: "300", children: /* @__PURE__ */ k.jsx(sn, {}) }) }),
        !i && l.map((u) => /* @__PURE__ */ k.jsx(mt.Item, { value: u, children: /* @__PURE__ */ k.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            gap: "200",
            children: [
              d ? /* @__PURE__ */ k.jsx(
                Fw,
                {
                  text: u.code,
                  highlight: a
                }
              ) : /* @__PURE__ */ k.jsx(F.Paragraph, { variant: "4", children: u.code }),
              /* @__PURE__ */ k.jsx(F.Paragraph, { variant: "5", color: "tertiary", children: jy(u) })
            ]
          }
        ) }, u.code)),
        m && /* @__PURE__ */ k.jsx(mt.Item, { noFixedSelectionStateSpace: !0, children: /* @__PURE__ */ k.jsx(
          zo,
          {
            title: "No discount codes found",
            description: "Try changing your search criteria."
          }
        ) })
      ] })
    }
  );
}, Ti = ({
  control: e,
  name: n,
  label: r,
  placeholder: i,
  required: a = !1,
  apiUserError: o
}) => /* @__PURE__ */ k.jsx(
  jt,
  {
    name: n,
    control: e,
    rules: {
      required: a ? {
        value: !0,
        message: "This field is required"
      } : !1
    },
    render: ({ field: s, fieldState: l }) => /* @__PURE__ */ k.jsx(
      Kr,
      {
        required: a,
        label: r,
        input: s,
        placeholder: i,
        meta: {
          warning: l?.error?.message,
          error: l?.error?.message || o?.[s.name]
        }
      }
    )
  }
), T7 = "_modal_1wlra_1", R7 = {
  modal: T7
};
function tw(e) {
  try {
    return new Intl.DisplayNames(["en"], { type: "region" }).of(
      e.toUpperCase()
    ) ?? e;
  } catch {
    return e;
  }
}
const rw = [
  "AF",
  "AX",
  "AL",
  "DZ",
  "AD",
  "AO",
  "AI",
  "AG",
  "AR",
  "AM",
  "AW",
  "AC",
  "AU",
  "AT",
  "AZ",
  "BS",
  "BH",
  "BD",
  "BB",
  "BY",
  "BE",
  "BZ",
  "BJ",
  "BM",
  "BT",
  "BO",
  "BA",
  "BW",
  "BV",
  "BR",
  "IO",
  "BN",
  "BG",
  "BF",
  "BI",
  "KH",
  "CA",
  "CV",
  "BQ",
  "KY",
  "CF",
  "TD",
  "CL",
  "CN",
  "CX",
  "CC",
  "CO",
  "KM",
  "CG",
  "CD",
  "CK",
  "CR",
  "HR",
  "CU",
  "CW",
  "CY",
  "CZ",
  "CI",
  "DK",
  "DJ",
  "DM",
  "DO",
  "EC",
  "EG",
  "SV",
  "GQ",
  "ER",
  "EE",
  "SZ",
  "ET",
  "FK",
  "FO",
  "FJ",
  "FI",
  "FR",
  "GF",
  "PF",
  "TF",
  "GA",
  "GM",
  "GE",
  "DE",
  "GH",
  "GI",
  "GR",
  "GL",
  "GD",
  "GP",
  "GT",
  "GG",
  "GN",
  "GW",
  "GY",
  "HT",
  "HM",
  "VA",
  "HN",
  "HK",
  "HU",
  "IS",
  "IN",
  "ID",
  "IR",
  "IQ",
  "IE",
  "IM",
  "IL",
  "IT",
  "JM",
  "JP",
  "JE",
  "JO",
  "KZ",
  "KE",
  "KI",
  "KP",
  "XK",
  "KW",
  "KG",
  "LA",
  "LV",
  "LB",
  "LS",
  "LR",
  "LY",
  "LI",
  "LT",
  "LU",
  "MO",
  "MG",
  "MW",
  "MY",
  "MV",
  "ML",
  "MT",
  "MQ",
  "MR",
  "MU",
  "YT",
  "MX",
  "MD",
  "MC",
  "MN",
  "ME",
  "MS",
  "MA",
  "MZ",
  "MM",
  "NA",
  "NR",
  "NP",
  "NL",
  "AN",
  "NC",
  "NZ",
  "NI",
  "NE",
  "NG",
  "NU",
  "NF",
  "MK",
  "NO",
  "OM",
  "PK",
  "PS",
  "PA",
  "PG",
  "PY",
  "PE",
  "PH",
  "PN",
  "PL",
  "PT",
  "QA",
  "CM",
  "RE",
  "RO",
  "RU",
  "RW",
  "BL",
  "SH",
  "KN",
  "LC",
  "MF",
  "PM",
  "WS",
  "SM",
  "ST",
  "SA",
  "SN",
  "RS",
  "SC",
  "SL",
  "SG",
  "SX",
  "SK",
  "SI",
  "SB",
  "SO",
  "ZA",
  "GS",
  "KR",
  "SS",
  "ES",
  "LK",
  "VC",
  "SD",
  "SR",
  "SJ",
  "SE",
  "CH",
  "SY",
  "TW",
  "TJ",
  "TZ",
  "TH",
  "TL",
  "TG",
  "TK",
  "TO",
  "TT",
  "TA",
  "TN",
  "TR",
  "TM",
  "TC",
  "TV",
  "UG",
  "UA",
  "AE",
  "GB",
  "US",
  "UM",
  "UY",
  "UZ",
  "VU",
  "VE",
  "VN",
  "VG",
  "WF",
  "EH",
  "YE",
  "ZM",
  "ZW",
  "ZZ"
], iw = "shopify-shiping-address-form", D7 = ({
  title: e,
  address: n,
  isOpen: r,
  setIsOpen: i,
  orderId: a,
  shopifyId: o,
  shippingCountryCodes: s,
  onChange: l,
  refetchOrders: d
}) => {
  const { useMutation: m, showNotification: u } = fn(), { track: f } = jn(), [h, v] = me(!1), [w, N] = me({}), j = !l, [
    _,
    { error: g, reset: O }
  ] = m(V9, {
    onError: () => {
      v(!1), u({
        title: "Something went wrong",
        text: "The address change was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    },
    onCompleted: (q) => {
      v(!1);
      const Y = q?.Shopify?.orderUpdate?.userErrors;
      if (Y != null && Y.length > 0) {
        const P = Y.reduce(
          (B, ie) => {
            const je = ie.field;
            if (je == null || je.length === 0)
              return B;
            const pe = je[je.length - 1];
            return pe != null && (B[pe] = ie.message), B;
          },
          {}
        );
        N(P);
      } else
        u({
          title: "Success",
          text: "The address change was successful.",
          icon: "check-circle-filled",
          severity: "success"
        }), d(), ne();
    }
  }), R = pt(
    () => ({
      firstName: n?.firstName || "",
      lastName: n?.lastName || "",
      company: n?.company || "",
      address1: n?.address1 || "",
      address2: n?.address2 || "",
      city: n?.city || "",
      countryCodeV2: rw.find(
        (q) => q === n?.countryCodeV2
      ),
      provinceCode: n?.province || "",
      zip: n?.zip || ""
    }),
    [n]
  ), { control: $, handleSubmit: I, formState: L, reset: G } = ot({
    mode: "all",
    defaultValues: R()
  }), Q = I((q) => {
    if (j) {
      if (v(!0), !o || !a) {
        v(!1);
        return;
      }
      f("shopify:order:edit:shipping:address:modal:submitted", {
        shopifyId: o,
        orderId: a
      });
      const { countryCodeV2: Y, ...P } = q, B = {
        ...P,
        countryCode: Y
      };
      _({
        variables: {
          input: {
            id: a,
            shippingAddress: B
          }
        }
      });
    } else
      l(q), ne();
  });
  Xe(() => {
    r && G(R());
  }, [r, n, G, R]);
  const ne = () => {
    G(R()), N({}), O(), i(!1);
  };
  return /* @__PURE__ */ k.jsxs(
    ht,
    {
      isOpen: r,
      onClose: ne,
      className: R7.modal,
      "data-testid": "edit-shipping-address-modal",
      children: [
        /* @__PURE__ */ k.jsx(yt, { title: e, onClose: () => ne() }),
        /* @__PURE__ */ k.jsx(gt, { children: /* @__PURE__ */ k.jsxs("form", { noValidate: !0, id: iw, onSubmit: Q, children: [
          g && /* @__PURE__ */ k.jsx($n, { error: g }),
          /* @__PURE__ */ k.jsxs(et, { children: [
            /* @__PURE__ */ k.jsx(Z, { span: 3, children: /* @__PURE__ */ k.jsx(
              Ti,
              {
                required: !0,
                control: $,
                name: "firstName",
                label: "First name",
                placeholder: "Insert your first name",
                apiUserError: w
              }
            ) }),
            /* @__PURE__ */ k.jsx(Z, { span: 3, children: /* @__PURE__ */ k.jsx(
              Ti,
              {
                required: !0,
                control: $,
                name: "lastName",
                label: "Last name",
                placeholder: "Insert your last name",
                apiUserError: w
              }
            ) }),
            /* @__PURE__ */ k.jsx(Z, { span: 6, children: /* @__PURE__ */ k.jsx(
              Ti,
              {
                control: $,
                name: "company",
                label: "Company",
                placeholder: "Insert your company name"
              }
            ) }),
            /* @__PURE__ */ k.jsx(Z, { span: 6, children: /* @__PURE__ */ k.jsx(
              Ti,
              {
                required: !0,
                control: $,
                name: "address1",
                label: "Address",
                placeholder: "Insert your address",
                apiUserError: w
              }
            ) }),
            /* @__PURE__ */ k.jsx(Z, { span: 6, children: /* @__PURE__ */ k.jsx(
              Ti,
              {
                control: $,
                name: "address2",
                label: "Additional address details",
                placeholder: "Insert more address details"
              }
            ) }),
            /* @__PURE__ */ k.jsx(Z, { span: 3, children: /* @__PURE__ */ k.jsx(
              Ti,
              {
                required: !0,
                control: $,
                name: "zip",
                label: "Zip / postal code",
                placeholder: "Insert your zip / postal code",
                apiUserError: w
              }
            ) }),
            /* @__PURE__ */ k.jsx(Z, { span: 3, children: /* @__PURE__ */ k.jsx(
              Ti,
              {
                required: !0,
                control: $,
                name: "city",
                label: "City",
                placeholder: "Insert your city",
                apiUserError: w
              }
            ) }),
            /* @__PURE__ */ k.jsx(Z, { span: 6, children: /* @__PURE__ */ k.jsx(
              mr,
              {
                name: "countryCodeV2",
                control: $,
                label: "Country",
                rules: {
                  required: {
                    value: !0,
                    message: "Please select a country"
                  }
                },
                componentProps: {
                  placeholder: "Select your country",
                  getItemTitleByValue: (q) => q ? tw(q) : ""
                },
                children: rw.filter((q) => s.includes(q)).map((q) => /* @__PURE__ */ k.jsx(mt.Item, { value: q, children: /* @__PURE__ */ k.jsx(F.Paragraph, { children: tw(q) }) }, q))
              }
            ) })
          ] })
        ] }) }),
        /* @__PURE__ */ k.jsx(
          vt,
          {
            confirmProps: {
              disabled: !(L.isValid && L.isDirty),
              type: "submit",
              form: iw,
              isLoading: h,
              loadingIndicator: /* @__PURE__ */ k.jsx(sn, { size: 16 })
            },
            confirmOnClick: () => {
              g && ne();
            },
            cancelOnClick: () => {
              o && a && !g && f("shopify:order:edit:shipping:address:modal:canceled", {
                shopifyId: o,
                orderId: a
              }), ne();
            },
            confirmName: g ? "Close" : "Save",
            cancelName: g ? void 0 : "Cancel"
          }
        )
      ]
    }
  );
}, O7 = "_clickableIcon_33mqm_1", Lh = {
  clickableIcon: O7
}, aw = ({
  formFieldName: e,
  ...n
}) => {
  const r = Or(), { field: i } = Qy({
    control: r.control,
    name: e
  });
  return /* @__PURE__ */ k.jsx(
    wy,
    {
      enableEditAddress: !0,
      openByDefault: !0,
      onChange: i.onChange,
      ...n
    }
  );
}, wy = ({
  labelText: e,
  address: n,
  orderId: r,
  shopifyId: i,
  shippingCountryCodes: a,
  enableEditAddress: o,
  icon: s = "home",
  onChange: l,
  refetchOrders: d,
  openByDefault: m = !1
}) => {
  const [u, f] = me(!1), [h, v] = me(m), { isCopied: w, copy: N } = Wr(), { track: j } = jn(), _ = 14, g = o && (!!r || !!l), O = [n?.zip || "", n?.city || ""].filter(Boolean).join(" "), R = [n?.firstName || "", n?.lastName || ""].filter(Boolean).join(" "), $ = n?.countryCodeV2 && xI(n.countryCodeV2), I = pt(() => [
    R,
    n?.company,
    n?.address1,
    n?.address2,
    O,
    n?.province,
    $
  ].filter(Boolean).join(`
`), [n, R, O, $]);
  if (!n)
    return null;
  const L = () => {
    i && r && j("shopify:order:edit:shipping:address:modal:opened", {
      shopifyId: i,
      orderId: r
    }), f(!0);
  };
  return /* @__PURE__ */ k.jsxs(k.Fragment, { children: [
    /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "row", children: [
        /* @__PURE__ */ k.jsx(fe, { size: _, name: s, color: "green.500" }),
        /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
          /* @__PURE__ */ k.jsxs(
            b,
            {
              gap: "100",
              flexDirection: "row",
              onClick: () => v(!h),
              className: Lh.clickableIcon,
              alignItems: "center",
              children: [
                /* @__PURE__ */ k.jsx(F.Paragraph, { variant: "3", children: e }),
                /* @__PURE__ */ k.jsx(
                  fe,
                  {
                    size: _,
                    name: h ? "angle-down" : "angle-right"
                  }
                )
              ]
            }
          ),
          h && /* @__PURE__ */ k.jsxs(b, { gap: "100", flexDirection: "column", children: [
            R && /* @__PURE__ */ k.jsx(F.Paragraph, { variant: "4", children: R }),
            n?.company && /* @__PURE__ */ k.jsx(F.Paragraph, { variant: "4", children: n.company }),
            n?.address1 && /* @__PURE__ */ k.jsx(F.Paragraph, { variant: "4", children: n.address1 }),
            n?.address2 && /* @__PURE__ */ k.jsx(F.Paragraph, { variant: "4", children: n.address2 }),
            O && /* @__PURE__ */ k.jsx(F.Paragraph, { variant: "4", children: O }),
            n?.province && /* @__PURE__ */ k.jsx(F.Paragraph, { variant: "4", children: n.province }),
            $ && /* @__PURE__ */ k.jsx(F.Paragraph, { variant: "4", children: $ })
          ] })
        ] })
      ] }),
      /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "row", children: [
        g && /* @__PURE__ */ k.jsx(Ge, { content: `Edit ${e.toLowerCase()}`, children: /* @__PURE__ */ k.jsx(
          fe,
          {
            size: _,
            name: "pen",
            onClick: () => L(),
            className: Lh.clickableIcon
          }
        ) }),
        /* @__PURE__ */ k.jsx(Ge, { content: `Copy ${e.toLowerCase()}`, children: /* @__PURE__ */ k.jsx(
          fe,
          {
            size: _,
            name: w ? "done" : "copy",
            onClick: () => N(I()),
            className: Lh.clickableIcon
          }
        ) })
      ] })
    ] }),
    g && /* @__PURE__ */ k.jsx(
      D7,
      {
        title: `Edit ${e}`,
        address: n,
        isOpen: u,
        setIsOpen: f,
        orderId: r,
        shopifyId: i,
        shippingCountryCodes: a,
        onChange: l,
        refetchOrders: d
      }
    )
  ] });
}, KF = ({
  withAddresses: e = !0,
  selectedProductIds: n
}) => {
  const r = Or(), i = ki({ control: r.control, name: "lineItems" }), a = ki({
    control: r.control,
    name: "billingAddress"
  }), o = ki({
    control: r.control,
    name: "shippingAddress"
  }), s = ki({
    control: r.control,
    name: "discountCode"
  }), l = Zn(() => n ? n.length === 0 ? [] : (i || []).filter(
    (u) => n.includes(u.id)
  ) : i, [i, n]), d = Zn(() => !l || l.length === 0 ? 0 : l.reduce((u, f) => {
    const h = f.priceRangeV2?.minVariantPrice?.amount || 0, v = f.quantity || 0;
    return u + h * v;
  }, 0), [l]), m = l?.[0]?.priceRangeV2?.minVariantPrice?.currencyCode || "";
  return /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "300", children: [
    e && /* @__PURE__ */ k.jsxs(k.Fragment, { children: [
      /* @__PURE__ */ k.jsxs(F.Paragraph, { variant: "3", children: [
        a?.firstName,
        " ",
        a?.lastName
      ] }),
      /* @__PURE__ */ k.jsx(
        aw,
        {
          formFieldName: "billingAddress",
          address: a,
          labelText: "Billing address",
          shippingCountryCodes: [],
          refetchOrders: () => Promise.resolve({})
        }
      ),
      /* @__PURE__ */ k.jsx(
        aw,
        {
          formFieldName: "shippingAddress",
          address: o,
          labelText: "Shipping address",
          shippingCountryCodes: [],
          icon: "map-pin",
          refetchOrders: () => Promise.resolve({})
        }
      )
    ] }),
    /* @__PURE__ */ k.jsx(Wl, {}),
    /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ k.jsx(F.Paragraph, { variant: "3", children: "Subtotal" }),
      /* @__PURE__ */ k.jsx(F.Paragraph, { variant: "3", children: `${d.toFixed(2)} ${m}` })
    ] }),
    s && /* @__PURE__ */ k.jsxs(k.Fragment, { children: [
      /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ k.jsxs(F.Paragraph, { variant: "4", children: [
          "Discount (",
          s.code,
          ")"
        ] }),
        /* @__PURE__ */ k.jsx(F.Paragraph, { variant: "4", children: jy(s) })
      ] }),
      /* @__PURE__ */ k.jsx(F.Paragraph, { color: "tertiary", variant: "5", children: "The discount will be deducted after the order is created." })
    ] }),
    /* @__PURE__ */ k.jsx(F.Paragraph, { color: "tertiary", variant: "5", children: "Tax and shipping will be calculated by Shopify based on customer address and store settings." })
  ] });
}, P7 = "_productTableHeader_6h6pl_1", A7 = "_productImage_6h6pl_5", Lo = {
  productTableHeader: P7,
  productImage: A7
}, tv = (e) => e.media?.nodes?.[0]?.preview?.image?.url || null, L7 = ({
  product: e,
  index: n,
  onRemove: r
}) => {
  const i = Or(), a = e.priceRangeV2.minVariantPrice.amount, o = e.priceRangeV2.minVariantPrice.currencyCode, s = `lineItems.${n}.quantity`, l = i.watch(s), d = tv(e);
  return /* @__PURE__ */ k.jsxs(st.Tr, { children: [
    /* @__PURE__ */ k.jsx(st.Td, { children: /* @__PURE__ */ k.jsxs(b, { gap: "200", alignItems: "center", children: [
      d && /* @__PURE__ */ k.jsx(
        Ia,
        {
          src: d,
          alt: e.title,
          className: Lo.productImage
        }
      ),
      /* @__PURE__ */ k.jsx(F.Paragraph, { variant: "4", children: e.title })
    ] }) }),
    /* @__PURE__ */ k.jsx(st.Td, { children: /* @__PURE__ */ k.jsx(F.Paragraph, { variant: "4", children: e.totalInventory }) }),
    /* @__PURE__ */ k.jsx(st.Td, { children: /* @__PURE__ */ k.jsx(F.Paragraph, { variant: "4", children: `${a} ${o}` }) }),
    /* @__PURE__ */ k.jsx(st.Td, { children: /* @__PURE__ */ k.jsx(
      Rn,
      {
        noLabel: !0,
        noAlert: !0,
        name: s,
        control: i.control,
        componentProps: {
          type: "number",
          min: 1,
          max: e.totalInventory,
          tabIndex: 0
        }
      },
      `${s}-${l}`
    ) }),
    /* @__PURE__ */ k.jsx(st.Td, { children: /* @__PURE__ */ k.jsx(F.Paragraph, { variant: "4", children: `${a * l} ${o}` }) }),
    /* @__PURE__ */ k.jsx(st.Td, { children: /* @__PURE__ */ k.jsx(b, { justifyContent: "flex-end", children: /* @__PURE__ */ k.jsx(Xt, { icon: "trash", variant: "secondary", onClick: r }) }) })
  ] });
}, V7 = 300, xo = 2, z7 = 25, U7 = ({
  onProductSelected: e
}) => {
  const { useLazyQuery: n, showNotification: r } = fn(), [i, a] = me(""), [o, s] = me([]), l = Or(), d = l.watch("selectedProductId"), [m, { loading: u, networkStatus: f }] = n(ev, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onCompleted: (N) => {
      const j = N?.Shopify?.products?.nodes || [];
      s(
        j.filter((_) => !!_).sort((_, g) => _.title.localeCompare(g.title))
      );
    },
    onError: () => {
      s([]), r({
        title: "Something went wrong",
        text: "Could not search for products. Please try again.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    }
  });
  xi(
    () => {
      i.trim().length >= xo && !u && f === ir.ready ? m({
        variables: {
          query: i.trim(),
          productCount: z7,
          mediaCount: 1
        }
      }) : i.trim().length < xo && s([]);
    },
    V7,
    [i]
  ), Xe(() => {
    if (!d) return;
    const N = o.find(
      (j) => j.id === d
    );
    N && e(N), l.setValue("selectedProductId", void 0);
  }, [d, o, l, e]);
  const h = u && f !== ir.ready, v = i.trim().length >= xo, w = !o.length && !h && v;
  return /* @__PURE__ */ k.jsx(
    mr,
    {
      noAlert: !0,
      label: "Product selection",
      control: l.control,
      name: "selectedProductId",
      componentProps: {
        placeholder: `Search products (min. ${xo} characters)`,
        tabIndex: 0,
        getItemTitleByValue: (N) => {
          const j = o.find(
            (_) => _.id === N
          );
          return j ? /* @__PURE__ */ k.jsx(F.Paragraph, { children: j.title }) : null;
        },
        filter: {
          value: i,
          onChange: (N) => {
            a(N.target.value);
          }
        },
        onToggleDropdown: (N) => {
          !N && i !== "" && a("");
        }
      },
      children: /* @__PURE__ */ k.jsxs(k.Fragment, { children: [
        h && /* @__PURE__ */ k.jsx(mt.Item, { noFixedSelectionStateSpace: !0, children: /* @__PURE__ */ k.jsx(b, { justifyContent: "center", padding: "300", children: /* @__PURE__ */ k.jsx(sn, {}) }) }),
        !h && o.map((N) => {
          const j = N.totalInventory <= 0, _ = tv(N);
          return /* @__PURE__ */ k.jsx(
            mt.Item,
            {
              value: N.id,
              isDisabled: j,
              children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
                /* @__PURE__ */ k.jsxs(b, { gap: "200", alignItems: "center", children: [
                  _ && /* @__PURE__ */ k.jsx(
                    Ia,
                    {
                      src: _,
                      alt: N.title,
                      className: Lo.productImage
                    }
                  ),
                  i ? /* @__PURE__ */ k.jsx(
                    Fw,
                    {
                      text: N.title,
                      highlight: i
                    }
                  ) : /* @__PURE__ */ k.jsx(F.Paragraph, { variant: "4", children: N.title })
                ] }),
                /* @__PURE__ */ k.jsx(F.Paragraph, { variant: "5", children: j ? "Out of stock" : `${N.totalInventory} in stock` })
              ] })
            },
            N.id
          );
        }),
        w && /* @__PURE__ */ k.jsx(mt.Item, { noFixedSelectionStateSpace: !0, children: /* @__PURE__ */ k.jsx(
          zo,
          {
            title: "No products found",
            description: "Try changing your search criteria."
          }
        ) }),
        !v && !h && /* @__PURE__ */ k.jsx(mt.Item, { noFixedSelectionStateSpace: !0, children: /* @__PURE__ */ k.jsx(
          zo,
          {
            title: "Search for products",
            description: `Type at least ${xo} characters to search.`
          }
        ) })
      ] })
    }
  );
}, rv = ({
  loading: e = !1,
  selectionMode: n = !1,
  hideDeleteButton: r = !1,
  hideProductSelect: i = !1,
  selectedProductIds: a = [],
  disabledProductIds: o = [],
  maxQuantities: s,
  onToggleSelect: l,
  onToggleSelectAll: d
}) => {
  const m = Or(), u = m.watch("lineItems"), f = !!u?.length, h = n && f ? u.filter(
    (j) => !o.includes(j?.id)
  ) : [], v = h.length > 0 && h.every(
    (j) => a.includes(j?.id)
  ), w = h.some(
    (j) => a.includes(j?.id)
  ) && !v, N = pt(
    (j) => {
      const _ = m.getValues("lineItems"), g = _.findIndex(
        (O) => O?.id === j.id
      );
      if (g > -1) {
        const O = m.getValues(`lineItems.${g}.quantity`) || 0, R = [..._];
        R[g] = {
          ...R[g],
          quantity: O + 1
        }, m.setValue("lineItems", R);
      } else
        m.setValue("lineItems", [
          ..._,
          { ...j, quantity: 1 }
        ]);
    },
    [m]
  );
  return /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
    !i && /* @__PURE__ */ k.jsx(U7, { onProductSelected: N }),
    !f && e && /* @__PURE__ */ k.jsx(
      b,
      {
        margin: "200 0",
        justifyContent: "center",
        padding: "300",
        className: Bt.boxWrapper,
        children: /* @__PURE__ */ k.jsx(sn, {})
      }
    ),
    !f && !e && /* @__PURE__ */ k.jsx(
      b,
      {
        margin: "200 0",
        justifyContent: "center",
        className: Bt.boxWrapper,
        children: /* @__PURE__ */ k.jsx(
          zo,
          {
            title: "No products selected",
            description: "Select a product above for your new order"
          }
        )
      }
    ),
    f && /* @__PURE__ */ k.jsx(b, { margin: "300 0", children: /* @__PURE__ */ k.jsxs(
      st,
      {
        hoverable: !0,
        framed: !1,
        headerWithBackground: !1,
        className: Lo.productTable,
        children: [
          /* @__PURE__ */ k.jsx(st.Thead, { className: Lo.productTableHeader, children: /* @__PURE__ */ k.jsxs(st.Tr, { children: [
            n && /* @__PURE__ */ k.jsx(st.Th, { children: /* @__PURE__ */ k.jsx(
              dv,
              {
                checked: v,
                indeterminate: w,
                onChange: () => d?.(!v)
              }
            ) }),
            /* @__PURE__ */ k.jsx(st.Th, { children: "Product" }),
            /* @__PURE__ */ k.jsx(st.Th, { children: "In stock" }),
            /* @__PURE__ */ k.jsx(st.Th, { children: "Price" }),
            /* @__PURE__ */ k.jsx(st.Th, { children: "Quantity" }),
            /* @__PURE__ */ k.jsx(st.Th, { children: "Total" }),
            !r && /* @__PURE__ */ k.jsx(st.Th, {})
          ] }) }),
          /* @__PURE__ */ k.jsx(st.Tbody, { children: u?.map((j, _) => {
            if (!n)
              return /* @__PURE__ */ k.jsx(
                L7,
                {
                  product: j,
                  index: _,
                  onRemove: () => {
                    const Y = u.filter(
                      (P, B) => B !== _
                    );
                    m.setValue("lineItems", Y);
                  }
                },
                `${j?.id}-${_}`
              );
            const g = j, O = g.priceRangeV2.minVariantPrice.amount, R = g.priceRangeV2.minVariantPrice.currencyCode, $ = `lineItems.${_}.quantity`, I = m.watch($) || 0, L = O * I, G = tv(g), Q = a.includes(g.id), ne = o.includes(g.id), q = s?.[g.id] ?? g.totalInventory;
            return /* @__PURE__ */ k.jsxs(
              st.Tr,
              {
                style: ne ? { opacity: 0.5 } : void 0,
                children: [
                  /* @__PURE__ */ k.jsx(st.Td, { children: /* @__PURE__ */ k.jsx(
                    dv,
                    {
                      checked: Q,
                      disabled: ne,
                      onChange: () => l?.(g.id, !Q)
                    }
                  ) }),
                  /* @__PURE__ */ k.jsx(st.Td, { children: /* @__PURE__ */ k.jsxs(b, { gap: "200", alignItems: "center", children: [
                    G && /* @__PURE__ */ k.jsx(
                      Ia,
                      {
                        src: G,
                        alt: g.title,
                        className: Lo.productImage
                      }
                    ),
                    /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", children: [
                      /* @__PURE__ */ k.jsx(F.Paragraph, { variant: "4", children: g.title }),
                      ne && /* @__PURE__ */ k.jsx(F.Paragraph, { variant: "5", children: "Already refunded" })
                    ] })
                  ] }) }),
                  /* @__PURE__ */ k.jsx(st.Td, { children: /* @__PURE__ */ k.jsx(F.Paragraph, { variant: "4", children: g.totalInventory }) }),
                  /* @__PURE__ */ k.jsx(st.Td, { children: /* @__PURE__ */ k.jsx(F.Paragraph, { variant: "4", children: `${O} ${R}` }) }),
                  /* @__PURE__ */ k.jsx(st.Td, { children: /* @__PURE__ */ k.jsx(
                    Rn,
                    {
                      noLabel: !0,
                      noAlert: !0,
                      disabled: ne || q <= 1,
                      name: $,
                      control: m.control,
                      componentProps: {
                        type: "number",
                        min: 1,
                        max: q,
                        tabIndex: 0
                      }
                    },
                    `${$}-${m.watch($)}`
                  ) }),
                  /* @__PURE__ */ k.jsx(st.Td, { children: /* @__PURE__ */ k.jsx(F.Paragraph, { variant: "4", children: `${L} ${R}` }) }),
                  !r && /* @__PURE__ */ k.jsx(st.Td, { children: /* @__PURE__ */ k.jsx(b, { justifyContent: "flex-end", children: /* @__PURE__ */ k.jsx(
                    Xt,
                    {
                      icon: "trash",
                      variant: "secondary",
                      onClick: () => {
                        const Y = u.filter(
                          (P, B) => B !== _
                        );
                        m.setValue("lineItems", Y), Q && l?.(g.id, !1);
                      }
                    }
                  ) }) })
                ]
              },
              `${g.id}-${_}`
            );
          }) })
        ]
      }
    ) })
  ] });
}, GF = ({
  previousOrderStatus: e
} = {}) => {
  const n = Or();
  return /* @__PURE__ */ k.jsx(
    mr,
    {
      label: "Payment Status",
      name: "financialStatus",
      control: n.control,
      rules: {
        required: {
          value: !0,
          message: "Please select a payment status"
        }
      },
      componentProps: {
        placeholder: "Select payment status",
        tabIndex: 0,
        getItemTitleByValue: (r) => {
          const i = Wj.find(
            (a) => a.value === r
          );
          return i ? /* @__PURE__ */ k.jsxs(
            b,
            {
              flexDirection: "row",
              gap: "200",
              alignItems: "center",
              margin: "0 0 100 0",
              children: [
                /* @__PURE__ */ k.jsx(F.Paragraph, { variant: "4", children: i.label }),
                /* @__PURE__ */ k.jsxs(F.Paragraph, { variant: "5", color: "secondary", children: [
                  "(",
                  i.description,
                  ")"
                ] })
              ]
            }
          ) : null;
        }
      },
      children: Wj.map((r) => {
        const i = e && r.value === e;
        return /* @__PURE__ */ k.jsx(mt.Item, { value: r.value, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "100", children: [
          /* @__PURE__ */ k.jsxs(b, { flexDirection: "row", gap: "200", alignItems: "center", children: [
            /* @__PURE__ */ k.jsx(F.Paragraph, { variant: "4", children: r.label }),
            i && /* @__PURE__ */ k.jsx(F.Paragraph, { variant: "5", color: "secondary", children: "(previous order status)" })
          ] }),
          /* @__PURE__ */ k.jsx(F.Paragraph, { variant: "5", color: "secondary", children: r.description })
        ] }) }, r.value);
      })
    }
  );
}, YF = () => {
  const e = Or();
  return /* @__PURE__ */ k.jsx(
    mr,
    {
      label: "Fulfillment Status",
      helpIcon: {
        text: "Defaults to 'unfulfilled' if nothing is selected"
      },
      name: "fulfillmentStatus",
      control: e.control,
      componentProps: {
        clearable: !0,
        placeholder: "Select fulfillment status",
        tabIndex: 0,
        getItemTitleByValue: (n) => {
          const r = Kj.find(
            (i) => i.value === n
          );
          return r ? /* @__PURE__ */ k.jsxs(b, { gap: "200", alignItems: "center", margin: "0 0 100 0", children: [
            /* @__PURE__ */ k.jsx(F.Paragraph, { variant: "4", children: r.label }),
            /* @__PURE__ */ k.jsxs(F.Paragraph, { variant: "5", color: "secondary", children: [
              "(",
              r.description,
              ")"
            ] })
          ] }) : null;
        }
      },
      children: Kj.map((n) => /* @__PURE__ */ k.jsx(mt.Item, { value: n.value, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "100", children: [
        /* @__PURE__ */ k.jsx(F.Paragraph, { variant: "4", children: n.label }),
        /* @__PURE__ */ k.jsx(F.Paragraph, { variant: "5", color: "secondary", children: n.description })
      ] }) }, n.value))
    }
  );
}, M7 = "_modal_1mprq_1", B7 = {
  modal: M7
}, Vh = "create-shopify-order-form", q7 = ({
  isOpen: e,
  shopifyCustomer: n,
  displayCreateDraftOrder: r,
  setIsOpen: i,
  refetchCustomerOrders: a
}) => {
  const { useMutation: o, showNotification: s } = fn(), { track: l } = jn(), [d, m] = me(!1), [
    u,
    f
  ] = me(!1), h = {
    firstName: n.defaultAddress?.firstName,
    lastName: n.defaultAddress?.lastName,
    address1: n.defaultAddress?.address1,
    address2: n.defaultAddress?.address2,
    city: n.defaultAddress?.city,
    zip: n.defaultAddress?.zip,
    countryCodeV2: n.defaultAddress?.countryCodeV2,
    phone: n.defaultAddress?.phone
  }, v = {
    selectedProductId: void 0,
    lineItems: [],
    customNote: "",
    tags: [],
    billingAddress: h,
    shippingAddress: h,
    financialStatus: Bi.Pending,
    fulfillmentStatus: void 0,
    discountCode: void 0
  }, [w, N] = me([]), j = ot({
    mode: "all",
    defaultValues: v
  }), _ = j.watch("lineItems").length > 0, g = () => {
    j.reset(v), N([]), i(!1);
  };
  Xe(() => {
    w.length > 0 && j.setValue("tags", w, { shouldDirty: !0 });
  }, [w, j]);
  const O = Tr(!1), R = () => {
    a(), m(!1), s({
      title: "Success",
      text: "The order was created successfully.",
      icon: "check-circle-filled",
      severity: "success"
    }), l("shopify:order:create:succeeded"), g();
  }, $ = () => {
    a(), m(!1), s({
      title: "Order created but not marked as paid",
      text: "The order was created but recording the payment failed. You can mark it as paid in Shopify.",
      icon: "exclamation-triangle-filled",
      severity: "warning"
    }), g();
  }, I = () => {
    m(!1), s({
      title: "Something went wrong",
      text: "The order creation was not successful.",
      icon: "exclamation-triangle-filled",
      severity: "warning"
    }), l("shopify:order:create:failed"), g();
  }, [L] = o(LF, {
    onError: $,
    onCompleted: (B) => {
      const ie = B.Shopify?.orderMarkAsPaid?.userErrors;
      if (ie && ie.length > 0) {
        $();
        return;
      }
      R();
    }
  }), [G, { error: Q }] = o(AF, {
    onError: I,
    onCompleted: (B) => {
      const ie = B.Shopify?.orderCreate, je = ie?.order?.id;
      if (ie?.userErrors?.length || !je) {
        I();
        return;
      }
      if (O.current) {
        L({ variables: { input: { id: je } } });
        return;
      }
      R();
    }
  }), [ne, { error: q }] = o(
    H9,
    {
      onError: () => {
        f(!1), s({
          title: "Something went wrong",
          text: "The draft order creation was not successful.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), l("shopify:order:create:draft:failed"), g();
      },
      onCompleted: () => {
        a(), f(!1), s({
          title: "Success",
          text: "The draft order creation was successful.",
          icon: "check-circle-filled",
          severity: "success"
        }), l("shopify:order:create:draft:succeeded"), g();
      }
    }
  ), Y = (B) => {
    const ie = B.lineItems.map((ge) => ({
      productId: ge.id,
      requiresShipping: !0,
      priceSet: {
        shopMoney: {
          amount: ge.priceRangeV2.maxVariantPrice.amount,
          currencyCode: ge.priceRangeV2.maxVariantPrice.currencyCode
        }
      },
      quantity: ge.quantity
    }));
    m(!0);
    const je = fa(B?.billingAddress), pe = fa(
      B?.shippingAddress
    ), le = B.financialStatus === Bi.Paid;
    O.current = le, G({
      variables: {
        order: {
          lineItems: ie,
          customer: {
            toAssociate: {
              id: n?.id
            }
          },
          note: B.customNote,
          tags: B.tags,
          financialStatus: le ? void 0 : B.financialStatus,
          fulfillmentStatus: B.fulfillmentStatus,
          discountCode: HF(B.discountCode),
          shippingAddress: pe,
          billingAddress: je
        }
      }
    });
  }, P = (B) => {
    const ie = B.lineItems.map((le) => ({
      title: le.title,
      requiresShipping: !0,
      originalUnitPriceWithCurrency: {
        amount: le.priceRangeV2.maxVariantPrice.amount,
        currencyCode: le.priceRangeV2.maxVariantPrice.currencyCode
      },
      quantity: le.quantity
    }));
    f(!0);
    const je = fa(B?.billingAddress), pe = fa(
      B?.shippingAddress
    );
    ne({
      variables: {
        input: {
          email: n.defaultEmailAddress?.emailAddress,
          note: B.customNote,
          tags: B.tags,
          lineItems: ie,
          discountCodes: E7(B.discountCode),
          shippingAddress: pe,
          billingAddress: je
        }
      }
    });
  };
  return /* @__PURE__ */ k.jsxs(
    ht,
    {
      isOpen: e,
      onClose: g,
      className: B7.modal,
      allowEscClose: !1,
      children: [
        /* @__PURE__ */ k.jsx(yt, { title: "Create new order", onClose: g }),
        /* @__PURE__ */ k.jsxs(gt, { children: [
          /* @__PURE__ */ k.jsx(Jy, { ...j, children: /* @__PURE__ */ k.jsx("form", { id: Vh, children: /* @__PURE__ */ k.jsxs(et, { children: [
            /* @__PURE__ */ k.jsx(Z, { children: /* @__PURE__ */ k.jsx(rv, {}) }),
            /* @__PURE__ */ k.jsx(Z, { children: /* @__PURE__ */ k.jsx(
              jt,
              {
                name: "tags",
                render: ({ fieldState: { error: B } }) => /* @__PURE__ */ k.jsx(
                  qe,
                  {
                    label: "Tags",
                    meta: {
                      error: B?.message
                    },
                    children: /* @__PURE__ */ k.jsx(
                      "div",
                      {
                        tabIndex: 0,
                        onKeyDown: (ie) => {
                          ie.key === "Enter" && (ie.preventDefault(), ie.stopPropagation());
                        },
                        children: /* @__PURE__ */ k.jsx(
                          Hl,
                          {
                            placeholder: "Type and hit enter to add tags",
                            selectedTags: w,
                            onChange: (ie) => {
                              N(ie);
                            }
                          },
                          `tags-input-${e}`
                        )
                      }
                    )
                  }
                )
              }
            ) }),
            /* @__PURE__ */ k.jsx(Z, { span: 4, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "300", children: [
              /* @__PURE__ */ k.jsx(GF, {}),
              /* @__PURE__ */ k.jsx(YF, {}),
              /* @__PURE__ */ k.jsx(WF, { enabled: e }),
              /* @__PURE__ */ k.jsx(
                Rn,
                {
                  label: "Custom note",
                  name: "customNote",
                  componentProps: {
                    placeholder: "Enter custom note",
                    tabIndex: 0
                  }
                }
              )
            ] }) }),
            /* @__PURE__ */ k.jsx(Z, { span: 2, children: /* @__PURE__ */ k.jsx(qe, { label: "Details", noAlert: !0, children: /* @__PURE__ */ k.jsx(
              b,
              {
                flexDirection: "column",
                gap: "200",
                justifyContent: "end",
                className: Bt.boxWrapper,
                children: /* @__PURE__ */ k.jsx(KF, {})
              }
            ) }) })
          ] }) }) }),
          (Q || q) && /* @__PURE__ */ k.jsx($n, { error: Q || q })
        ] }),
        /* @__PURE__ */ k.jsx(
          vt,
          {
            confirmProps: {
              type: "submit",
              form: Vh,
              disabled: !_ || d,
              isLoading: d,
              loadingIndicator: /* @__PURE__ */ k.jsx(sn, { size: 16 }),
              tabIndex: 0
            },
            confirmName: "Create order",
            confirmOnClick: j.handleSubmit(Y),
            ...r && {
              confirmSecondaryName: "Create draft order",
              confirmSecondaryOnClick: () => {
                j.handleSubmit(P)();
              },
              confirmSecondaryProps: {
                type: "submit",
                form: Vh,
                disabled: !_ || u,
                isLoading: u,
                loadingIndicator: /* @__PURE__ */ k.jsx(sn, { size: 16 }),
                tabIndex: 0
              }
            }
          }
        )
      ]
    }
  );
}, H7 = "_modal_al73g_1", W7 = {
  modal: H7
}, ow = [
  {
    label: "Customer",
    value: Pi.Customer,
    description: "The customer wanted to cancel the order."
  },
  {
    label: "Declined",
    value: Pi.Declined,
    description: "Payment was declined."
  },
  {
    label: "Fraud",
    value: Pi.Fraud,
    description: "The order was fraudulent."
  },
  {
    label: "Inventory",
    value: Pi.Inventory,
    description: "There was insufficient inventory."
  },
  {
    label: "Other",
    value: Pi.Other,
    description: "The order was canceled for an unlisted reason."
  },
  {
    label: "Staff",
    value: Pi.Staff,
    description: "Staff made an error."
  }
], K7 = ({
  orderId: e,
  isOpen: n,
  orderName: r,
  setIsOpen: i,
  isMutationLoading: a,
  setIsMutationLoading: o,
  refetchOrders: s
}) => {
  const { track: l } = jn(), { useMutation: d, showNotification: m } = fn(), [u, f] = me([]), h = u.length > 0, v = {
    orderId: e,
    reason: null,
    refundMethod: {
      originalPaymentMethodsRefund: !0
    },
    restock: !0,
    notifyCustomer: !1,
    staffNote: ""
  }, w = ot({
    defaultValues: v
  }), [N, { error: j, reset: _ }] = d(U9, {
    onError: () => {
      o(!1), m({
        title: "Something went wrong",
        text: "Could not cancel the order.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      }), i(!1);
    },
    onCompleted: async (R) => {
      const $ = R.Shopify?.orderCancel?.orderCancelUserErrors || [];
      if ($.length > 0)
        o(!1), f($), m({
          title: "Something went wrong",
          text: "Could not cancel the order.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        });
      else {
        const I = R.Shopify?.orderCancel?.job?.done;
        setTimeout(async () => {
          await s().finally(() => o(!1));
        }, I ? 0 : 4e3), m({
          title: "Success",
          text: `${I ? "The order got cancelled" : "The order is being cancelled. It might take some time until it is reflected in the order details."}`,
          icon: "check-circle-filled",
          severity: "success"
        }), l("shopify:order:cancelled"), i(!1);
      }
    }
  }), g = pt(
    (R) => {
      R.reason != null && (o(!0), N({
        variables: {
          orderId: R.orderId,
          reason: R.reason,
          refundMethod: R.refundMethod,
          restock: R.restock,
          notifyCustomer: R.notifyCustomer,
          staffNote: R.staffNote ?? ""
        }
      }));
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [e]
  ), O = () => {
    i(!1), _(), f([]), w.reset(v);
  };
  return /* @__PURE__ */ k.jsxs(ht, { isOpen: n, onClose: O, className: W7.modal, children: [
    /* @__PURE__ */ k.jsx(yt, { title: `Cancel order ${r}`, onClose: O }),
    /* @__PURE__ */ k.jsx(gt, { children: /* @__PURE__ */ k.jsxs(et, { children: [
      /* @__PURE__ */ k.jsx(Z, { children: /* @__PURE__ */ k.jsx(
        mr,
        {
          control: w.control,
          label: "Reason",
          name: "reason",
          rules: {
            required: {
              value: !0,
              message: "Please select a reason"
            }
          },
          componentProps: {
            placeholder: "Select a reason",
            equalityFn: (R, $) => R === $,
            getItemTitleByValue: (R) => {
              if (!R)
                return "";
              const $ = ow.find(
                (I) => I.value === R
              );
              return /* @__PURE__ */ k.jsxs(b, { flexDirection: "row", gap: "200", children: [
                /* @__PURE__ */ k.jsx(F.Heading, { variant: "heading-3", children: $.label }),
                /* @__PURE__ */ k.jsx(F.Paragraph, { color: "secondary", children: $.description })
              ] });
            }
          },
          children: ow.map((R) => /* @__PURE__ */ k.jsx(mt.Item, { value: R.value, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "row", gap: "200", children: [
            /* @__PURE__ */ k.jsx(F.Heading, { variant: "heading-3", children: R.label }),
            /* @__PURE__ */ k.jsx(F.Paragraph, { color: "secondary", children: R.description })
          ] }) }, R.value))
        }
      ) }),
      /* @__PURE__ */ k.jsx(Z, { children: /* @__PURE__ */ k.jsx(qe, { label: "Refund order", children: /* @__PURE__ */ k.jsx(
        yn,
        {
          control: w.control,
          name: "refundMethod.originalPaymentMethodsRefund"
        }
      ) }) }),
      /* @__PURE__ */ k.jsx(Z, { children: /* @__PURE__ */ k.jsx(qe, { label: "Restock items", children: /* @__PURE__ */ k.jsx(yn, { control: w.control, name: "restock" }) }) }),
      /* @__PURE__ */ k.jsx(Z, { children: /* @__PURE__ */ k.jsx(qe, { label: "Notify the customer", children: /* @__PURE__ */ k.jsx(yn, { control: w.control, name: "notifyCustomer" }) }) }),
      /* @__PURE__ */ k.jsx(Z, { children: /* @__PURE__ */ k.jsx(
        Rn,
        {
          name: "staffNote",
          label: "Staff note",
          control: w.control
        }
      ) }),
      h && /* @__PURE__ */ k.jsx(Z, { children: /* @__PURE__ */ k.jsx(b, { gap: "200", flexDirection: "column", children: u.map((R) => /* @__PURE__ */ k.jsxs(
        b,
        {
          flexDirection: "row",
          gap: "200",
          alignItems: "center",
          children: [
            /* @__PURE__ */ k.jsx(fe, { name: "close-circle-filled", color: "red.500" }),
            /* @__PURE__ */ k.jsx(F.Heading, { variant: "heading-3", children: R.code }),
            /* @__PURE__ */ k.jsxs(F.Paragraph, { children: [
              "(",
              R.field?.join(","),
              ") ",
              R.message
            ] })
          ]
        },
        R.code
      )) }) })
    ] }) }),
    /* @__PURE__ */ k.jsx(
      vt,
      {
        confirmProps: {
          disabled: !(w.formState.isValid && w.formState.isDirty),
          isLoading: a,
          loadingIndicator: /* @__PURE__ */ k.jsx(sn, { size: 16 })
        },
        confirmOnClick: w.handleSubmit(g),
        cancelOnClick: O,
        confirmName: j ? "Close" : "Cancel order",
        cancelName: j ? void 0 : "Cancel"
      }
    )
  ] });
}, G7 = ({
  orderId: e,
  orderName: n,
  refetchOrders: r,
  disabled: i
}) => {
  const [a, o] = me(!1), [s, l] = me(!1);
  return /* @__PURE__ */ k.jsxs(b, { width: "100%", children: [
    /* @__PURE__ */ k.jsx(
      Qn,
      {
        variant: "secondary",
        onClick: () => o(!0),
        isLoading: s,
        loadingIndicator: /* @__PURE__ */ k.jsx(sn, { size: 16 }),
        disabled: i,
        slotStart: /* @__PURE__ */ k.jsx(
          fe,
          {
            size: 14,
            name: "close-circle-filled",
            color: "red.500"
          }
        ),
        className: Bt.fullWidth,
        children: "Cancel"
      }
    ),
    /* @__PURE__ */ k.jsx(
      K7,
      {
        orderId: e,
        orderName: n,
        isOpen: a,
        setIsOpen: o,
        isMutationLoading: s,
        setIsMutationLoading: l,
        refetchOrders: r
      }
    )
  ] });
}, Y7 = "_modal_1mprq_1", J7 = {
  modal: Y7
}, Q7 = ({
  order: e,
  orderName: n,
  isOpen: r,
  shopifyId: i,
  setIsOpen: a,
  refetchOrders: o
}) => {
  const { useMutation: s, showNotification: l, useQuery: d } = fn(), { track: m } = jn(), [u, f] = me(!1), [h, v] = me(e?.tags || []), w = "duplicate-shopify-order-form", N = (pe) => ({
    firstName: pe?.firstName,
    lastName: pe?.lastName,
    company: pe?.company,
    address1: pe?.address1,
    address2: pe?.address2,
    city: pe?.city,
    provinceCode: pe?.provinceCode,
    zip: pe?.zip,
    countryCode: pe?.countryCodeV2,
    phone: pe?.phone
  }), j = {
    selectedProductId: void 0,
    lineItems: [],
    customNote: "",
    tags: e?.tags || [],
    billingAddress: N(
      e?.billingAddress ?? e?.shippingAddress
    ),
    shippingAddress: N(e?.shippingAddress),
    financialStatus: void 0,
    fulfillmentStatus: void 0,
    discountCode: void 0
  }, _ = ot({
    mode: "all",
    defaultValues: j
  }), g = _.watch("lineItems").length > 0, O = Zn(
    () => (e?.lineItems || []).map((pe) => pe.product?.id).filter((pe) => !!pe),
    [e]
  ), R = Zn(
    () => UF(O),
    [O]
  ), {
    data: $,
    loading: I,
    error: L
  } = d(ev, {
    skip: !R,
    variables: {
      query: R,
      productCount: O.length,
      mediaCount: 1
    }
  });
  Xe(() => {
    L && l({
      title: "Something went wrong",
      text: "Could not load products for this order.",
      icon: "exclamation-triangle-filled",
      severity: "warning"
    });
  }, [L, l]), Xe(() => {
    if (!r || I || !$ || _.getValues("lineItems")?.length)
      return;
    const pe = $?.Shopify?.products?.nodes || [], le = [];
    e?.lineItems?.forEach((ge) => {
      const V = pe.find(
        (be) => be.id === ge.product?.id
      );
      V && le.push({
        ...V,
        quantity: ge.quantity || 1,
        sku: ge.sku,
        discountedUnitPrice: ge.discountedUnitPriceSet?.shopMoney
      });
    }), le.length > 0 && _.setValue("lineItems", le, { shouldDirty: !0 });
  }, [r, $, I, e, _]), Xe(() => {
    (h.length > 0 || (_.getValues("tags") || []).length > 0) && _.setValue("tags", h, { shouldDirty: !0 });
  }, [h, _]);
  const G = Tr(!1), Q = () => {
    o(), f(!1), l({
      title: "Success",
      text: "The order was duplicated successfully.",
      icon: "check-circle-filled",
      severity: "success"
    }), m("shopify:order:duplicate:succeeded"), je();
  }, ne = () => {
    o(), f(!1), l({
      title: "Order duplicated but not marked as paid",
      text: "The order was duplicated but recording the payment failed. You can mark it as paid in Shopify.",
      icon: "exclamation-triangle-filled",
      severity: "warning"
    }), je();
  }, q = () => {
    f(!1), l({
      title: "Something went wrong",
      text: "The order duplication was not successful.",
      icon: "exclamation-triangle-filled",
      severity: "warning"
    }), m("shopify:order:duplicate:failed"), je();
  }, [Y] = s(LF, {
    onError: ne,
    onCompleted: (pe) => {
      const le = pe.Shopify?.orderMarkAsPaid?.userErrors;
      if (le && le.length > 0) {
        ne();
        return;
      }
      Q();
    }
  }), [P, { error: B }] = s(AF, {
    onError: q,
    onCompleted: (pe) => {
      const le = pe.Shopify?.orderCreate, ge = le?.order?.id;
      if (le?.userErrors?.length || !ge) {
        q();
        return;
      }
      if (G.current) {
        Y({ variables: { input: { id: ge } } });
        return;
      }
      Q();
    }
  }), ie = (pe) => {
    const le = pe.lineItems.map((be) => ({
      productId: be.id,
      requiresShipping: !0,
      priceSet: {
        shopMoney: {
          amount: be.discountedUnitPrice?.amount ?? be.priceRangeV2.maxVariantPrice.amount,
          currencyCode: be.discountedUnitPrice?.currencyCode ?? be.priceRangeV2.maxVariantPrice.currencyCode
        }
      },
      quantity: be.quantity,
      sku: be.sku
    })), ge = (e?.shippingLines ?? []).map(
      (be) => ({
        title: be.title,
        code: be.code,
        source: be.source,
        priceSet: {
          shopMoney: {
            amount: be.discountedPriceSet?.shopMoney?.amount ?? "0.00",
            currencyCode: be.discountedPriceSet?.shopMoney?.currencyCode ?? "USD"
          }
        }
      })
    );
    f(!0);
    const V = pe.financialStatus === Bi.Paid;
    G.current = V, P({
      variables: {
        order: {
          customer: {
            toAssociate: {
              id: i
            }
          },
          lineItems: le,
          shippingLines: ge,
          note: pe.customNote,
          tags: pe.tags,
          financialStatus: V ? void 0 : pe.financialStatus,
          fulfillmentStatus: pe.fulfillmentStatus,
          discountCode: HF(pe.discountCode),
          shippingAddress: fa(pe?.shippingAddress),
          billingAddress: fa(pe?.billingAddress)
        }
      }
    });
  }, je = () => {
    _.reset(j), v(e?.tags || []), a(!1);
  };
  return /* @__PURE__ */ k.jsxs(
    ht,
    {
      isOpen: r,
      onClose: je,
      className: J7.modal,
      allowEscClose: !1,
      children: [
        /* @__PURE__ */ k.jsx(yt, { title: `Duplicate order ${n}`, onClose: je }),
        /* @__PURE__ */ k.jsxs(gt, { children: [
          /* @__PURE__ */ k.jsx(Jy, { ..._, children: /* @__PURE__ */ k.jsx("form", { id: w, children: /* @__PURE__ */ k.jsxs(et, { children: [
            /* @__PURE__ */ k.jsx(Z, { children: /* @__PURE__ */ k.jsx(rv, { loading: I }) }),
            /* @__PURE__ */ k.jsx(Z, { children: /* @__PURE__ */ k.jsx(
              jt,
              {
                name: "tags",
                render: ({ fieldState: { error: pe } }) => /* @__PURE__ */ k.jsx(
                  qe,
                  {
                    label: "Tags",
                    meta: {
                      error: pe?.message
                    },
                    children: /* @__PURE__ */ k.jsx(
                      "div",
                      {
                        tabIndex: 0,
                        onKeyDown: (le) => {
                          le.key === "Enter" && (le.preventDefault(), le.stopPropagation());
                        },
                        children: /* @__PURE__ */ k.jsx(
                          Hl,
                          {
                            placeholder: "Type and hit enter to add tags",
                            selectedTags: h,
                            onChange: (le) => {
                              v(le);
                            }
                          },
                          `tags-input-${r}`
                        )
                      }
                    )
                  }
                )
              }
            ) }),
            /* @__PURE__ */ k.jsx(Z, { children: /* @__PURE__ */ k.jsx(WF, { enabled: r }) }),
            /* @__PURE__ */ k.jsx(Z, { span: 4, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "300", children: [
              /* @__PURE__ */ k.jsx(
                GF,
                {
                  previousOrderStatus: e?.displayFinancialStatus
                }
              ),
              /* @__PURE__ */ k.jsx(YF, {}),
              /* @__PURE__ */ k.jsx(
                Rn,
                {
                  label: "Custom note",
                  name: "customNote",
                  componentProps: {
                    placeholder: "Enter custom note",
                    tabIndex: 0
                  }
                }
              )
            ] }) }),
            /* @__PURE__ */ k.jsx(Z, { span: 2, children: /* @__PURE__ */ k.jsx(qe, { label: "Details", noAlert: !0, children: /* @__PURE__ */ k.jsx(
              b,
              {
                flexDirection: "column",
                gap: "200",
                justifyContent: "end",
                className: Bt.boxWrapper,
                children: /* @__PURE__ */ k.jsx(KF, {})
              }
            ) }) })
          ] }) }) }),
          B && /* @__PURE__ */ k.jsx($n, { error: B })
        ] }),
        /* @__PURE__ */ k.jsx(
          vt,
          {
            confirmProps: {
              type: "submit",
              form: w,
              disabled: !g || u || I,
              isLoading: u || I,
              loadingIndicator: /* @__PURE__ */ k.jsx(sn, { size: 16 }),
              tabIndex: 0
            },
            confirmName: "Create order",
            confirmOnClick: _.handleSubmit(ie)
          }
        )
      ]
    }
  );
}, X7 = "_copyIcon_1dlzg_1", Z7 = {
  copyIcon: X7
}, eK = ({
  orderId: e,
  lineItems: n,
  refundedQuantities: r = {}
}) => {
  const { isCopied: i, copy: a } = Wr();
  if (!n || n?.length === 0)
    return null;
  const o = Object.values(r).some(
    (d) => d > 0
  ), s = n.every(
    ({ id: d, quantity: m }) => (r[d] || 0) >= m
  ), l = n.map(
    ({ title: d, quantity: m, variantTitle: u }) => u ? `${m}x ${d} (${u})` : `${m}x ${d}`
  ).join(`
`);
  return /* @__PURE__ */ k.jsxs(b, { gap: "100", flexDirection: "column", children: [
    /* @__PURE__ */ k.jsxs(
      b,
      {
        gap: "250",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        children: [
          /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "row", alignItems: "center", children: [
            /* @__PURE__ */ k.jsx(fe, { size: 14, name: "shopify", color: "green.500" }),
            /* @__PURE__ */ k.jsx(F.Paragraph, { variant: "3", children: "Line items" })
          ] }),
          /* @__PURE__ */ k.jsx(Ge, { content: "Copy line items", children: /* @__PURE__ */ k.jsx(
            fe,
            {
              size: 14,
              name: i ? "done" : "copy",
              onClick: () => a(l),
              className: Z7.copyIcon
            }
          ) })
        ]
      }
    ),
    o && /* @__PURE__ */ k.jsx(
      b,
      {
        gap: "100",
        flexDirection: "row",
        margin: "200 0 0",
        justifyContent: "center",
        children: /* @__PURE__ */ k.jsx(Jn, { color: "red.500", children: s ? "The order has been refunded" : "Order has refunded items" })
      }
    ),
    /* @__PURE__ */ k.jsx(Je, { children: n.map(({ id: d, title: m, quantity: u, variantTitle: f, image: h }) => {
      const v = r[d], w = v > 0, N = v > 1 ? `Refunded (${v} items)` : "Refunded";
      return /* @__PURE__ */ k.jsx(
        Je.Item,
        {
          contentLeft: /* @__PURE__ */ k.jsxs(b, { gap: "200", children: [
            /* @__PURE__ */ k.jsx(F.Paragraph, { children: u }),
            /* @__PURE__ */ k.jsx(F.Paragraph, { children: "×" })
          ] }),
          title: /* @__PURE__ */ k.jsxs(F.Paragraph, { variant: "4", children: [
            m,
            " ",
            f && `(${f})`,
            w && /* @__PURE__ */ k.jsx(F.Paragraph, { variant: "3", color: "red.500", children: N })
          ] }),
          contentRight: h?.url && /* @__PURE__ */ k.jsx(Ia, { src: `${h?.url}&height=48`, alt: m })
        },
        `list-${e}-${d}`
      );
    }) })
  ] });
}, nK = Kl`
  mutation refundLineItems($input: Shopify_RefundInput!) {
    Shopify {
      refundCreate(input: $input) {
        refund {
          id
          totalRefundedSet {
            presentmentMoney {
              amount
              currencyCode
            }
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`, tK = (e) => {
  const n = [];
  return e.refunds.forEach((r) => {
    const i = r.refundLineItems.edges.filter(
      (a) => a.node.id !== null
    );
    i.length > 0 && n.push({
      ...r,
      refundLineItems: {
        ...r.refundLineItems,
        edges: i
      }
    });
  }), n;
}, JF = (e) => {
  const n = {}, r = tK(e);
  return e.lineItems?.forEach((i) => {
    n[i.id] = 0;
  }), r.forEach((i) => {
    i.refundLineItems.edges.forEach((a) => {
      const o = a.node;
      if (o.id !== null) {
        const s = o.lineItem.id;
        n[s] += o.quantity;
      }
    });
  }), n;
}, qs = (e, n) => `${Number(e || 0).toFixed(2)} ${n}`, QF = ({
  refund: e,
  currencyCode: n,
  refundShipping: r,
  onToggleShipping: i,
  isLoading: a = !1
}) => {
  const o = e?.currency || n, s = Number(e?.shipping.maximumRefundable || 0) > 0, l = s && r;
  return /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "300", children: [
    /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ k.jsx(F.Paragraph, { variant: "4", children: "Subtotal" }),
      /* @__PURE__ */ k.jsx(F.Paragraph, { variant: "4", children: qs(e?.subtotal || "0", o) })
    ] }),
    /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ k.jsx(F.Paragraph, { variant: "4", children: "Tax" }),
      /* @__PURE__ */ k.jsx(F.Paragraph, { variant: "4", children: qs(e?.tax || "0", o) })
    ] }),
    /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
      /* @__PURE__ */ k.jsxs(b, { alignItems: "center", gap: "200", children: [
        /* @__PURE__ */ k.jsx(
          Vo,
          {
            name: "refundShipping",
            value: "shipping",
            checked: l,
            disabled: !s || a,
            onChange: () => i(!r)
          }
        ),
        /* @__PURE__ */ k.jsx(F.Paragraph, { variant: "4", subdued: !l, children: "Refund shipping" })
      ] }),
      /* @__PURE__ */ k.jsx(F.Paragraph, { variant: "4", subdued: !l, children: qs(e?.shipping.amount || "0", o) })
    ] }),
    /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ k.jsx(F.Paragraph, { variant: "3", children: "Total refund" }),
      /* @__PURE__ */ k.jsx(F.Paragraph, { variant: "3", children: qs(e?.amount || "0", o) })
    ] })
  ] });
}, rK = "_modal_1mprq_1", iK = {
  modal: rK
}, sw = "partial-refund-shopify-order-form", aK = ({
  order: e,
  orderName: n,
  isOpen: r,
  setIsOpen: i,
  refetchOrders: a
}) => {
  const { useMutation: o, showNotification: s } = fn(), { track: l } = jn(), { useQuery: d } = fn(), [m, u] = me(!1), [f, h] = me([]), [v, w] = me(!1), N = Zn(
    () => e?.refunds ? JF(e) : {},
    [e]
  ), j = Zn(
    () => (e?.lineItems || []).filter((le) => (N[le.id] || 0) >= (le.quantity || 0)).map((le) => le.product?.id).filter((le) => !!le),
    [e, N]
  ), _ = Zn(() => {
    const le = {};
    return (e?.lineItems || []).forEach((ge) => {
      if (ge.product?.id) {
        const V = N[ge.id] || 0, be = Math.max(
          0,
          (ge.quantity || 0) - V
        );
        le[ge.product.id] = be;
      }
    }), le;
  }, [e, N]), g = Zn(
    () => (e?.lineItems || []).map((le) => le.product?.id).filter((le) => !!le),
    [e]
  ), O = Zn(
    () => UF(g),
    [g]
  ), {
    data: R,
    loading: $,
    error: I
  } = d(ev, {
    skip: !O,
    variables: {
      query: O,
      productCount: g.length,
      mediaCount: 1
    }
  });
  Xe(() => {
    I && s({
      title: "Something went wrong",
      text: "Could not load products for this order.",
      icon: "exclamation-triangle-filled",
      severity: "warning"
    });
  }, [I, s]);
  const L = {
    selectedProductId: void 0,
    lineItems: [],
    customNote: ""
  }, G = ot({
    mode: "all",
    defaultValues: L
  }), Q = f.length > 0;
  Xe(() => {
    !Q && v && w(!1);
  }, [Q, v]);
  const ne = ki({
    control: G.control,
    name: "lineItems"
  }), q = Zn(
    () => (ne || []).filter(
      (le) => f.includes(le.id)
    ).map((le) => {
      const ge = e?.lineItems?.find(
        (H) => H.product?.id === le.id
      ), V = N[ge?.id || ""] || 0, be = (ge?.quantity || 0) - V, Oe = Math.max(
        0,
        Math.min(be, le.quantity || 0)
      );
      return ge && Oe > 0 ? { lineItemId: ge.id, quantity: Oe } : void 0;
    }).filter(
      (le) => !!le
    ),
    [ne, f, e, N]
  ), { suggestedRefund: Y, isLoading: P } = MF({
    orderId: e.id,
    refundShipping: v,
    refundLineItems: q,
    skip: !Q
  }), [B, { error: ie }] = o(
    nK,
    {
      onError: () => {
        s({
          title: "Something went wrong",
          text: "The partial refund was not successful.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), l("shopify:order:partial:refund:failed"), pe();
      },
      onCompleted: () => {
        a(), s({
          title: "Success",
          text: "The partial refund was created successfully.",
          icon: "check-circle-filled",
          severity: "success"
        }), l("shopify:order:partial:refund:succeeded"), pe();
      }
    }
  );
  Xe(() => {
    if (!r || $ || !R || G.getValues("lineItems")?.length)
      return;
    const le = R?.Shopify?.products?.nodes || [], ge = [];
    e?.lineItems?.forEach((V) => {
      const be = le.find(
        (Oe) => Oe.id === V.product?.id
      );
      if (be) {
        const Oe = N[V.id] || 0, H = (V.quantity || 1) - Oe;
        ge.push({
          ...be,
          quantity: H > 0 ? H : V.quantity || 1
        });
      }
    }), ge.length > 0 && (G.setValue("lineItems", ge, { shouldDirty: !0 }), h([]));
  }, [
    r,
    R,
    $,
    e,
    G,
    N
  ]);
  const je = (le) => {
    u(!0), B({
      variables: {
        input: zF({
          orderId: e.id,
          transactions: Y?.transactions,
          refundLineItems: q,
          refundShipping: v,
          note: le.customNote || void 0,
          notify: !0
        })
      }
    });
  }, pe = () => {
    G.reset(L), u(!1), i(!1);
  };
  return /* @__PURE__ */ k.jsxs(ht, { isOpen: r, onClose: pe, className: iK.modal, children: [
    /* @__PURE__ */ k.jsx(yt, { title: `Refund order ${n}`, onClose: pe }),
    /* @__PURE__ */ k.jsxs(gt, { children: [
      /* @__PURE__ */ k.jsx(Jy, { ...G, children: /* @__PURE__ */ k.jsx("form", { id: sw, children: /* @__PURE__ */ k.jsxs(et, { children: [
        /* @__PURE__ */ k.jsx(Z, { children: /* @__PURE__ */ k.jsx(
          rv,
          {
            loading: $,
            selectionMode: !0,
            hideDeleteButton: !0,
            hideProductSelect: !0,
            selectedProductIds: f,
            disabledProductIds: j,
            maxQuantities: _,
            onToggleSelect: (le, ge) => {
              h((V) => ge ? Array.from(/* @__PURE__ */ new Set([...V, le])) : V.filter((be) => be !== le));
            },
            onToggleSelectAll: (le) => {
              const ge = (G.getValues("lineItems") || []).map((V) => V.id).filter((V) => !j.includes(V));
              h(le ? ge : []);
            }
          }
        ) }),
        /* @__PURE__ */ k.jsx(Z, { span: 4, children: /* @__PURE__ */ k.jsx(b, { flexDirection: "column", gap: "300", children: /* @__PURE__ */ k.jsx(
          Rn,
          {
            label: "Custom note",
            name: "customNote",
            componentProps: {
              placeholder: "Enter custom note (optional)",
              tabIndex: 0
            }
          }
        ) }) }),
        /* @__PURE__ */ k.jsx(Z, { span: 2, children: /* @__PURE__ */ k.jsx(qe, { label: "Details", noAlert: !0, children: /* @__PURE__ */ k.jsx(
          b,
          {
            flexDirection: "column",
            gap: "200",
            justifyContent: "end",
            className: Bt.boxWrapper,
            children: /* @__PURE__ */ k.jsx(
              QF,
              {
                refund: Y,
                currencyCode: e.currencyCode,
                refundShipping: v,
                onToggleShipping: w,
                isLoading: P
              }
            )
          }
        ) }) })
      ] }) }) }),
      ie && /* @__PURE__ */ k.jsx($n, { error: ie })
    ] }),
    /* @__PURE__ */ k.jsx(
      vt,
      {
        confirmProps: {
          type: "submit",
          form: sw,
          disabled: !Q || m || $ || P || !Y,
          isLoading: m || $,
          loadingIndicator: /* @__PURE__ */ k.jsx(sn, { size: 16 }),
          tabIndex: 0
        },
        confirmName: "Refund selected",
        confirmOnClick: G.handleSubmit(je)
      }
    )
  ] });
}, oK = "_modal_al73g_1", sK = {
  modal: oK
}, lK = ({
  order: e,
  shopifyId: n,
  orderLink: r,
  isOpen: i,
  setIsOpen: a,
  refetchOrders: o
}) => {
  const { useMutation: s, showNotification: l } = fn(), { track: d } = jn(), { id: m, name: u, currencyCode: f } = e, [h, v] = me(!0), [w, N] = me(), { suggestedRefund: j, isLoading: _ } = MF({
    orderId: m,
    suggestFullRefund: !0,
    refundShipping: h,
    skip: !i
  }), [g, { loading: O }] = s(
    z9,
    {
      onError: (I) => N(I),
      onCompleted: (I) => {
        const L = I.Shopify?.refundCreate?.userErrors;
        if (L && L.length > 0) {
          N(
            new Tw({
              graphQLErrors: L.map((G) => ({
                message: G.message
              }))
            })
          );
          return;
        }
        l({
          title: "Order refunded",
          text: `You refunded order ${u}`,
          icon: "check-circle-filled",
          severity: "success"
        }), o(), R();
      }
    }
  ), R = () => {
    v(!0), N(void 0), a(!1);
  }, $ = () => {
    j && (d("shopify:order:refund:confirmed", { shopifyId: n, orderId: m }), g({
      variables: {
        input: zF({
          orderId: m,
          transactions: j.transactions,
          refundLineItems: j.refundLineItems,
          refundShipping: h,
          notify: e.suggestedRefund.notify
        })
      }
    }));
  };
  return /* @__PURE__ */ k.jsxs(ht, { isOpen: i, onClose: R, className: sK.modal, children: [
    /* @__PURE__ */ k.jsx(yt, { title: `Refund order ${u}`, onClose: R }),
    /* @__PURE__ */ k.jsx(gt, { children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "300", children: [
      /* @__PURE__ */ k.jsx(
        QF,
        {
          refund: j,
          currencyCode: f,
          refundShipping: h,
          onToggleShipping: v,
          isLoading: _
        }
      ),
      w && /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", children: [
        /* @__PURE__ */ k.jsx($n, { error: w }),
        /* @__PURE__ */ k.jsx(
          Et,
          {
            variant: "secondary",
            style: {
              color: "var(--dixa-typography-color-link)",
              padding: "var(--dixa-size-spacer-100)"
            },
            navigate: () => window.open(r, "_blank")?.focus(),
            slotStart: /* @__PURE__ */ k.jsx(fe, { name: "external-link" }),
            children: "View order in Shopify"
          }
        )
      ] })
    ] }) }),
    /* @__PURE__ */ k.jsx(
      vt,
      {
        confirmProps: {
          disabled: !j || _ || O,
          isLoading: O || _,
          loadingIndicator: /* @__PURE__ */ k.jsx(sn, { size: 16 }),
          tabIndex: 0
        },
        confirmName: "Confirm order refund",
        confirmOnClick: $
      }
    )
  ] });
}, cK = ({
  order: e,
  shopifyId: n,
  orderLink: r,
  refetchOrders: i
}) => {
  const { showModal: a } = fn(), { track: o } = jn(), { suggestedRefund: s, id: l } = e, [d, m] = me(!1), u = parseFloat(String(s?.amount)), f = !isNaN(u) && u > 0, h = pt(() => {
    o("shopify:order:refund:requested", { shopifyId: n, orderId: l }), f ? m(!0) : a({
      headline: `Refund Order ${e.name}`,
      children: /* @__PURE__ */ k.jsx(F.Paragraph, { children: "No refund can be issued because no payment has been captured for this order. The order's financial status is currently pending." }),
      confirmLabel: "Close",
      confirmVariant: "secondary",
      onConfirm: () => {
      }
    });
  }, [n, l, e.name, f, a, o]);
  return /* @__PURE__ */ k.jsxs(b, { width: "100%", children: [
    /* @__PURE__ */ k.jsx(
      Qn,
      {
        variant: "secondary",
        onClick: h,
        disabled: s?.refundLineItems?.length === 0 || !f,
        slotStart: /* @__PURE__ */ k.jsx(fe, { size: 14, name: "undo" }),
        className: Bt.fullWidth,
        children: "Full refund"
      }
    ),
    /* @__PURE__ */ k.jsx(
      lK,
      {
        order: e,
        shopifyId: n,
        orderLink: r,
        isOpen: d,
        setIsOpen: m,
        refetchOrders: i
      }
    )
  ] });
}, dK = "_modal_al73g_1", uK = {
  modal: dK
}, mK = ({
  orderId: e,
  tags: n,
  isOpen: r,
  setIsOpen: i,
  refetchOrders: a
}) => {
  const { track: o } = jn(), { useMutation: s, showNotification: l } = fn(), [d, m] = me(n), [u, f] = me(!1), h = ot({
    defaultValues: {
      tags: n
    }
  });
  Xe(() => {
    d && h.setValue("tags", d, { shouldDirty: !0 });
  }, [d]);
  const [v, { error: w, reset: N }] = s(M9, {
    onError: () => {
      f(!1), l({
        title: "Something went wrong",
        text: "The tags change was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      }), i(!1);
    },
    onCompleted: async () => {
      await a(), f(!1), l({
        title: "Success",
        text: "The tags change was successful.",
        icon: "check-circle-filled",
        severity: "success"
      }), o("shopify:order:tags:updated"), i(!1);
    }
  }), j = pt(
    (g) => {
      f(!0), v({
        variables: {
          input: {
            id: e,
            tags: g.tags
          }
        }
      }).then((O) => {
        const R = O.data?.Shopify?.orderUpdate?.order?.tags ?? g.tags;
        h.reset({ tags: R });
      });
    },
    [e, h, v]
  ), _ = () => {
    i(!1), N();
  };
  return /* @__PURE__ */ k.jsxs(ht, { isOpen: r, onClose: _, className: uK.modal, children: [
    /* @__PURE__ */ k.jsx(yt, { title: "Manage tags for order", onClose: _ }),
    /* @__PURE__ */ k.jsxs(gt, { children: [
      /* @__PURE__ */ k.jsx(et, { children: /* @__PURE__ */ k.jsx(Z, { children: /* @__PURE__ */ k.jsx(
        jt,
        {
          control: h.control,
          name: "tags",
          render: ({ fieldState: { error: g } }) => /* @__PURE__ */ k.jsx(
            qe,
            {
              label: "Tags",
              meta: {
                error: g?.message
              },
              children: /* @__PURE__ */ k.jsx(
                Hl,
                {
                  placeholder: "Add tags here",
                  selectedTags: n,
                  onChange: (O) => m(O)
                }
              )
            }
          )
        }
      ) }) }),
      w && /* @__PURE__ */ k.jsx($n, { error: w })
    ] }),
    /* @__PURE__ */ k.jsx(
      vt,
      {
        confirmProps: {
          disabled: !(h.formState.isValid && h.formState.isDirty),
          isLoading: u,
          loadingIndicator: /* @__PURE__ */ k.jsx(sn, { size: 16 })
        },
        confirmOnClick: h.handleSubmit(j),
        cancelOnClick: _,
        confirmName: w ? "Close" : "Save",
        cancelName: w ? void 0 : "Cancel"
      }
    )
  ] });
}, pK = "_editIcon_1yp2k_1", fK = "_copyIcon_1yp2k_2", lw = {
  editIcon: pK,
  copyIcon: fK
}, hK = ({
  orderId: e,
  tags: n,
  refetchOrders: r
}) => {
  const [i, a] = me(!1), { isCopied: o, copy: s } = Wr(), l = 14, d = n.length > 0;
  return /* @__PURE__ */ k.jsxs(k.Fragment, { children: [
    /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "row", children: [
        /* @__PURE__ */ k.jsx(fe, { size: l, name: "tag", color: "green.500" }),
        /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
          /* @__PURE__ */ k.jsx(F.Paragraph, { variant: "3", children: "Tags" }),
          /* @__PURE__ */ k.jsxs(b, { gap: "100", flexDirection: "row", flexWrap: "wrap", children: [
            !d && /* @__PURE__ */ k.jsx(F.Paragraph, { variant: "4", color: "tertiary", children: "No tags here yet" }),
            d && n.map((m, u) => /* @__PURE__ */ k.jsx(Pn, { size: "small", variant: "primary", children: m }, u))
          ] })
        ] })
      ] }),
      /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "row", children: [
        /* @__PURE__ */ k.jsx(Ge, { content: "Edit tags", children: /* @__PURE__ */ k.jsx(
          fe,
          {
            size: l,
            name: "pen",
            className: lw.editIcon,
            onClick: () => a(!0)
          }
        ) }),
        d && /* @__PURE__ */ k.jsx(Ge, { content: "Copy tags", children: /* @__PURE__ */ k.jsx(
          fe,
          {
            size: l,
            name: o ? "done" : "copy",
            className: lw.copyIcon,
            onClick: () => s(n.join(", "))
          }
        ) })
      ] })
    ] }),
    /* @__PURE__ */ k.jsx(
      mK,
      {
        orderId: e,
        tags: n,
        isOpen: i,
        setIsOpen: a,
        refetchOrders: r
      }
    )
  ] });
}, yK = "_icon_cddi1_1", gK = "_link_cddi1_6", cw = {
  icon: yK,
  link: gK
}, vK = ({ trackingInfo: e }) => {
  const { isCopied: n, copy: r } = Wr(), { company: i, number: a, url: o } = e;
  return /* @__PURE__ */ k.jsx(
    Je.Item,
    {
      contentLeft: /* @__PURE__ */ k.jsx(F.Paragraph, { variant: "3", children: a }),
      title: /* @__PURE__ */ k.jsx(
        F.ExternalLink,
        {
          href: o,
          target: "_blank",
          rel: "noreferrer",
          className: cw.link,
          children: i
        }
      ),
      contentRight: a && /* @__PURE__ */ k.jsx(Ge, { content: "Copy tracking code", children: /* @__PURE__ */ k.jsx(
        fe,
        {
          size: 14,
          name: n ? "done" : "copy",
          onClick: () => r(a.toString()),
          className: cw.icon
        }
      ) })
    }
  );
}, kK = ({
  trackingInfos: e
}) => !e || e?.length === 0 ? null : /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
  /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "row", children: [
    /* @__PURE__ */ k.jsx(fe, { size: 14, name: "eye", color: "green.500" }),
    /* @__PURE__ */ k.jsx(F.Paragraph, { variant: "3", children: "Tracking" })
  ] }),
  /* @__PURE__ */ k.jsx(Je, { children: e.map((n) => /* @__PURE__ */ k.jsx(vK, { trackingInfo: n }, n.number)) })
] }), bK = "_copyIcon_u5m0p_1", _K = "_strikethrough_u5m0p_6", xK = "_order_u5m0p_10", SK = "_orderIsOpen_u5m0p_18", NK = "_orderHeader_u5m0p_21", Ri = {
  copyIcon: bK,
  strikethrough: _K,
  order: xK,
  orderIsOpen: SK,
  orderHeader: NK
}, jK = ({
  order: e,
  shopifyId: n,
  openByDefault: r,
  customerCountryCodes: i,
  enableEditShippingAddress: a,
  displayRefund: o,
  displayCancel: s,
  shopifyDomain: l,
  displayDuplicateOrder: d,
  displayPartialRefundOrder: m,
  refetchOrders: u
}) => {
  const { track: f } = jn(), { isCopied: h, copy: v } = Wr(), { isCopied: w, copy: N } = Wr(), { isCopied: j, copy: _ } = Wr(), [g, O] = me(!1), [R, $] = me(!1), [I, L] = me(r), {
    id: G,
    name: Q,
    createdAt: ne,
    status: q,
    currentTotalPriceSet: Y,
    currencyCode: P,
    lineItems: B,
    billingAddress: ie,
    shippingAddress: je,
    trackingInfos: pe,
    tags: le,
    discountCodes: ge,
    currentTotalDiscountsSet: V
  } = e, be = !!je, Oe = nv(G), H = `https://${l}/admin/orders/${Oe ?? ""}`, Ye = Y?.shopMoney?.amount ?? 0, ln = q.includes("cancelled"), Ie = (en) => new Intl.NumberFormat(void 0, {
    style: "currency",
    currency: P
  }).format(en), Ue = Number(
    V?.shopMoney?.amount ?? 0
  ), De = Ue > 0, Be = ge?.join(", ") ?? "", Ae = Ie(Number(Ye)), Qe = Ie(
    Number(Ye) + Ue
  ), Ee = e?.refunds ? JF(e) : {}, Me = !!B?.length && B.every((en) => (Ee[en.id] || 0) >= (en.quantity || 0));
  return /* @__PURE__ */ k.jsxs(
    b,
    {
      className: ut(Ri.order, {
        [Ri.orderIsOpen]: I
      }),
      gap: "200",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ k.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: Ri.orderHeader,
            onClick: () => L(!I),
            children: [
              /* @__PURE__ */ k.jsxs(b, { gap: "100", flexDirection: "column", children: [
                ne && /* @__PURE__ */ k.jsx(b, { alignItems: "center", children: /* @__PURE__ */ k.jsx(F.Paragraph, { variant: "4", children: Wn(ne).format(Ny) }) }),
                /* @__PURE__ */ k.jsxs(F.Paragraph, { variant: "1", children: [
                  "Order ",
                  Q
                ] })
              ] }),
              /* @__PURE__ */ k.jsx(
                Xt,
                {
                  variant: "tertiary",
                  icon: I ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        I && /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "column", margin: "200 0 0", children: [
          /* @__PURE__ */ k.jsxs(
            b,
            {
              gap: "250",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "flex-start",
              children: [
                /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "row", alignItems: "flex-start", children: [
                  /* @__PURE__ */ k.jsx(fe, { size: 14, name: "info", color: "green.500" }),
                  /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
                    /* @__PURE__ */ k.jsx(F.Paragraph, { variant: "3", children: "Order number" }),
                    /* @__PURE__ */ k.jsx(F.Paragraph, { variant: "4", children: Q.replace("#", "") })
                  ] })
                ] }),
                /* @__PURE__ */ k.jsx(Ge, { content: "Copy order number", children: /* @__PURE__ */ k.jsx(
                  fe,
                  {
                    size: 14,
                    name: h ? "done" : "copy",
                    onClick: () => v(Q.replace("#", "")),
                    className: Ri.copyIcon
                  }
                ) })
              ]
            }
          ),
          /* @__PURE__ */ k.jsxs(
            b,
            {
              gap: "250",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "flex-start",
              children: [
                /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "row", alignItems: "flex-start", children: [
                  /* @__PURE__ */ k.jsx(fe, { size: 14, name: "activity", color: "green.500" }),
                  /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
                    /* @__PURE__ */ k.jsx(F.Paragraph, { variant: "3", children: "Order status" }),
                    /* @__PURE__ */ k.jsx(F.Paragraph, { variant: "4", children: q })
                  ] })
                ] }),
                /* @__PURE__ */ k.jsx(Ge, { content: "Copy order status", children: /* @__PURE__ */ k.jsx(
                  fe,
                  {
                    size: 14,
                    name: j ? "done" : "copy",
                    onClick: () => _(q),
                    className: Ri.copyIcon
                  }
                ) })
              ]
            }
          ),
          /* @__PURE__ */ k.jsxs(
            b,
            {
              gap: "250",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "flex-start",
              children: [
                /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "row", alignItems: "flex-start", children: [
                  /* @__PURE__ */ k.jsx(fe, { size: 14, name: "chart-bar", color: "green.500" }),
                  /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
                    /* @__PURE__ */ k.jsx(F.Paragraph, { variant: "3", children: "Order value" }),
                    De && /* @__PURE__ */ k.jsx(F.Paragraph, { variant: "4", className: Ri.strikethrough, children: Qe }),
                    /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
                      /* @__PURE__ */ k.jsx(F.Paragraph, { variant: "4", children: Ae }),
                      Be && /* @__PURE__ */ k.jsxs(F.Paragraph, { variant: "4", color: "tertiary", children: [
                        "(",
                        Be,
                        ")"
                      ] })
                    ] })
                  ] })
                ] }),
                /* @__PURE__ */ k.jsx(Ge, { content: "Copy order value", children: /* @__PURE__ */ k.jsx(
                  fe,
                  {
                    size: 14,
                    name: w ? "done" : "copy",
                    onClick: () => N(Ye),
                    className: Ri.copyIcon
                  }
                ) })
              ]
            }
          ),
          /* @__PURE__ */ k.jsx(
            hK,
            {
              orderId: G,
              tags: le,
              refetchOrders: u
            }
          ),
          /* @__PURE__ */ k.jsx(
            wy,
            {
              openByDefault: !be,
              labelText: "Billing address",
              address: ie,
              shippingCountryCodes: i,
              refetchOrders: u
            }
          ),
          /* @__PURE__ */ k.jsx(
            wy,
            {
              openByDefault: be,
              shopifyId: n,
              orderId: G,
              icon: "map-pin",
              labelText: "Shipping address",
              address: je,
              shippingCountryCodes: i,
              enableEditAddress: a,
              refetchOrders: u
            }
          ),
          /* @__PURE__ */ k.jsx(
            eK,
            {
              orderId: G,
              lineItems: B,
              refundedQuantities: Ee
            }
          ),
          /* @__PURE__ */ k.jsx(kK, { trackingInfos: pe }),
          (o || m) && /* @__PURE__ */ k.jsxs(b, { flexDirection: "row", gap: "200", children: [
            o && /* @__PURE__ */ k.jsx(
              cK,
              {
                order: e,
                shopifyId: n,
                refetchOrders: u,
                orderLink: H
              }
            ),
            m && /* @__PURE__ */ k.jsx(b, { width: "100%", children: /* @__PURE__ */ k.jsx(
              Qn,
              {
                variant: "secondary",
                icon: "undo",
                onClick: () => $(!0),
                className: Bt.fullWidth,
                disabled: ln || Me,
                children: "Partial refund"
              }
            ) })
          ] }),
          (d || s) && /* @__PURE__ */ k.jsxs(b, { flexDirection: "row", gap: "200", children: [
            d && /* @__PURE__ */ k.jsx(b, { width: "100%", children: /* @__PURE__ */ k.jsx(
              Qn,
              {
                variant: "secondary",
                icon: "plus",
                onClick: () => O(!0),
                className: Bt.fullWidth,
                children: "Duplicate"
              }
            ) }),
            s && /* @__PURE__ */ k.jsx(
              G7,
              {
                orderId: G,
                orderName: Q,
                disabled: ln,
                refetchOrders: u
              }
            )
          ] }),
          /* @__PURE__ */ k.jsx(
            Et,
            {
              variant: "secondary",
              style: {
                color: "var(--dixa-typography-color-link)",
                padding: "var(--dixa-size-spacer-100)"
              },
              navigate: () => window.open(H, "_blank")?.focus(),
              slotStart: /* @__PURE__ */ k.jsx(fe, { name: "external-link" }),
              onClick: () => f("shopify:view:order:clicked", {
                shopifyId: n,
                orderId: G
              }),
              children: "View order in Shopify"
            }
          )
        ] }),
        g && /* @__PURE__ */ k.jsx(
          Q7,
          {
            order: e,
            shopifyId: n,
            orderName: Q,
            isOpen: g,
            setIsOpen: O,
            refetchOrders: u
          }
        ),
        R && /* @__PURE__ */ k.jsx(
          aK,
          {
            order: e,
            orderName: Q,
            isOpen: R,
            setIsOpen: $,
            refetchOrders: () => {
              u();
            }
          }
        )
      ]
    }
  );
}, wK = ({
  customerCountryCodes: e,
  shopifyDomain: n,
  displayRefund: r,
  displayCancel: i,
  displayCreateOrder: a,
  displayCreateDraftOrder: o,
  displayDuplicateOrder: s,
  displayPartialRefundOrder: l,
  enableEditShippingAddress: d,
  shopifyCustomer: m
}) => {
  const { track: u } = jn(), [f, h] = me([]), [v, w] = me(!1), N = nv(m?.id), j = `https://${n}/admin/orders?customer_id=${N ?? ""}`, {
    getCustomerOrders: _,
    isCustomerOrdersLoading: g,
    customerOrdersError: O,
    customerOrders: R,
    refetchCustomerOrders: $
  } = K9();
  return Xe(() => {
    !g && N && _({
      variables: {
        query: `customer_id:${N}`
      }
    });
  }, [N]), Xe(() => {
    const I = R?.Shopify?.orders?.edges;
    I && h(G9({ ordersData: I }));
  }, [R]), m ? O ? /* @__PURE__ */ k.jsx($n, { error: O }) : /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ k.jsx(F.Heading, { variant: "heading-3", children: "Customer orders" }),
      !g && /* @__PURE__ */ k.jsx(Pn, { variant: "success", size: "small", children: f.length })
    ] }),
    a && /* @__PURE__ */ k.jsx(
      Qn,
      {
        variant: "secondary",
        icon: "plus",
        onClick: () => w(!0),
        children: "Create new order"
      }
    ),
    /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
      g && /* @__PURE__ */ k.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ k.jsx(sn, {}) }),
      !g && f.length === 0 && /* @__PURE__ */ k.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ k.jsx(F.Paragraph, { color: "tertiary", children: "No orders found" }) }),
      !g && f.length > 0 && /* @__PURE__ */ k.jsx(b, { gap: "200", flexDirection: "column", children: f.map((I, L) => /* @__PURE__ */ k.jsx(
        jK,
        {
          order: I,
          openByDefault: L === 0,
          shopifyId: m?.id,
          displayRefund: r,
          displayCancel: i,
          enableEditShippingAddress: d,
          customerCountryCodes: e,
          refetchOrders: $,
          shopifyDomain: n,
          displayDuplicateOrder: s,
          displayPartialRefundOrder: l
        },
        `${L}-${I.id}`
      )) }),
      /* @__PURE__ */ k.jsx(
        Et,
        {
          variant: "secondary",
          style: {
            color: "var(--dixa-typography-color-link)",
            padding: "var(--dixa-size-spacer-100)"
          },
          navigate: () => window.open(j, "_blank")?.focus(),
          slotStart: /* @__PURE__ */ k.jsx(fe, { name: "external-link" }),
          onClick: () => u("shopify:view:all:orders:clicked", {
            shopifyId: m?.id
          }),
          children: "View all orders in Shopify"
        }
      )
    ] }),
    a && /* @__PURE__ */ k.jsx(
      q7,
      {
        isOpen: v,
        setIsOpen: w,
        shopifyCustomer: m,
        refetchCustomerOrders: $,
        displayCreateDraftOrder: o
      }
    )
  ] }) : null;
}, CK = ({
  totalOrders: e,
  amountSpent: n
}) => {
  const r = n?.amount ?? 0, i = n?.currencyCode ?? "", a = `${Number.parseFloat(r).toFixed(
    2
  )} ${i}`;
  return /* @__PURE__ */ k.jsx(k.Fragment, { children: /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ k.jsx(F.Heading, { variant: "heading-3", children: "Orders overview" }),
    /* @__PURE__ */ k.jsxs(Je, { className: Bt.list, children: [
      /* @__PURE__ */ k.jsx(Je.Text, { variant: "dense", className: Bt.listItem, children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ k.jsx(F.Paragraph, { variant: "4", children: "Total orders" }),
        /* @__PURE__ */ k.jsx(F.Paragraph, { variant: "4", children: e })
      ] }) }),
      /* @__PURE__ */ k.jsx(Je.Text, { variant: "dense", className: Bt.listItem, children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ k.jsx(F.Paragraph, { variant: "4", children: "Total revenue" }),
        /* @__PURE__ */ k.jsx(F.Paragraph, { variant: "4", children: a })
      ] }) })
    ] })
  ] }) });
}, FK = "_segmentName_1dkhk_1", IK = {
  segmentName: FK
}, $K = 100, Hs = 10, EK = ({
  shopifyId: e
}) => {
  const { useQuery: n, useLazyQuery: r } = fn(), [i, a] = me([]), [o, s] = me(Hs), [l, d] = me(!1), m = Zn(
    () => i.filter((N) => N.isMember).length,
    [i]
  ), { loading: u, error: f } = n(
    P9,
    {
      skip: !e,
      variables: {
        first: $K
      },
      onCompleted: (N) => {
        const j = N?.Shopify?.segments?.edges;
        if (j && j.length > 0) {
          const _ = j.map(({ node: g }) => ({
            ...g,
            isMember: !1
          })).sort((g, O) => g.name.localeCompare(O.name));
          a(_), h({
            variables: {
              customerId: e,
              segmentIds: _.map((g) => g.id)
            }
          });
        }
      }
    }
  ), [
    h,
    { loading: v, error: w }
  ] = r(A9, {
    onCompleted: (N) => {
      const j = N?.Shopify?.customerSegmentMembership?.memberships;
      if (j && j.length > 0) {
        const _ = i.map((g) => {
          const O = j.find(
            (R) => R.segmentId === g.id
          );
          return {
            ...g,
            ...O?.isMember && { isMember: O.isMember }
          };
        }).sort(
          (g, O) => g.isMember === O.isMember ? 0 : g.isMember ? -1 : 1
        );
        a(_);
      }
    }
  });
  return Xe(() => {
    s(l ? i.length : Hs);
  }, [l]), e ? /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ k.jsx(F.Heading, { variant: "heading-3", children: "Segment membership" }),
      !u && /* @__PURE__ */ k.jsx(Pn, { variant: "success", size: "small", children: m })
    ] }),
    u && /* @__PURE__ */ k.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ k.jsx(sn, {}) }),
    !u && i.length === 0 && /* @__PURE__ */ k.jsx(F.Paragraph, { color: "tertiary", margin: "200 0 300 0", align: "center", children: "No segments found" }),
    f && /* @__PURE__ */ k.jsx($n, { error: f }),
    w && /* @__PURE__ */ k.jsx($n, { error: w }),
    !u && i.length > 0 && /* @__PURE__ */ k.jsxs(Je, { className: Bt.list, children: [
      i.slice(0, o).map(({ id: N, name: j, isMember: _ }) => /* @__PURE__ */ k.jsx(Je.Text, { className: Bt.listItem, children: /* @__PURE__ */ k.jsx(
        Ge,
        {
          content: `${_ ? "Member of" : "Not a member of"} ${j}`,
          children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
            /* @__PURE__ */ k.jsx(F.Paragraph, { variant: "4", className: IK.segmentName, children: j }),
            v && /* @__PURE__ */ k.jsx(sn, { size: 12 }),
            !v && /* @__PURE__ */ k.jsx(b, { children: /* @__PURE__ */ k.jsx(
              fe,
              {
                color: _ ? "green.500" : "neutral.300",
                name: "shopify"
              }
            ) })
          ] })
        }
      ) }, N)),
      i.length > Hs && /* @__PURE__ */ k.jsx(b, { justifyContent: "center", margin: "200 0 0", children: /* @__PURE__ */ k.jsx(
        Qn,
        {
          variant: "secondary",
          onClick: () => d(!l),
          icon: l ? "angle-up" : "angle-down",
          children: l ? "Show less" : `Show ${i.length - Hs} more`
        }
      ) })
    ] })
  ] }) : null;
}, TK = ({
  conversationContext: e,
  settings: n
}) => {
  const [r, i] = me(!1);
  Xe(() => {
    i(!1);
  }, [
    e.customer?.phone_number,
    e.customer?.email
  ]);
  const {
    isCustomerLoading: a,
    customerError: o,
    customerData: s,
    refetchCustomer: l,
    customerNetworkStatus: d
  } = W9({ conversationContext: e, forcePhoneLookup: r }), [m, u] = me(), [f, h] = me(
    []
  ), v = n.apiHostName, w = n.displayRefundOrder ?? !1, N = n.displayCancelOrder ?? !1, j = n.enableEditShippingAddress ?? !1, _ = n.displayEmailMarketingConsent ?? !1, g = n.displayOrdersOverview ?? !1, O = n.displaySegmentMembership ?? !1, R = n.displayDiscountCodeCreation ?? !1, $ = n.displayDiscountCodes ?? !1, I = n.displayCreateOrder ?? !1, L = n.displayDuplicateOrder ?? !1, G = n.displayCreateDraftOrder ?? !1, Q = n.displayPartialRefundOrder ?? !1;
  if (Xe(() => {
    const ne = s?.Shopify?.customers?.edges[0]?.node, q = !!e.customer?.phone_number && !!e.customer?.email;
    ne && !a ? (h(
      s?.Shopify?.shop?.countriesInShippingZones?.countryCodes || []
    ), u(ne)) : !ne && !a && q && !r ? i(!0) : u(void 0);
  }, [s, e]), !a && o)
    return /* @__PURE__ */ k.jsx($n, { error: o, retry: l });
  if (!a && !o && !m) {
    const ne = `https://${v}/admin/customers?search=${e.customer?.name || ""}`;
    return /* @__PURE__ */ k.jsxs(
      b,
      {
        margin: "200 0 300",
        gap: "300",
        flexDirection: "column",
        "data-testid": "widget-customer-not-found",
        children: [
          /* @__PURE__ */ k.jsx(F.Paragraph, { color: "secondary", children: "We cannot find the customer in Shopify." }),
          /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
            /* @__PURE__ */ k.jsx(
              c7,
              {
                refetchCustomer: l,
                conversationContext: e
              }
            ),
            /* @__PURE__ */ k.jsx(
              Et,
              {
                variant: "secondary",
                style: {
                  color: "var(--dixa-typography-color-link)",
                  padding: "var(--dixa-size-spacer-100)"
                },
                navigate: () => window.open(ne, "_blank")?.focus(),
                slotStart: /* @__PURE__ */ k.jsx(fe, { name: "external-link" }),
                children: "Search customers in Shopify"
              }
            )
          ] })
        ]
      }
    );
  }
  return a && d !== ir.refetch ? /* @__PURE__ */ k.jsx(b, { margin: "200 0 300", justifyContent: "center", children: /* @__PURE__ */ k.jsx(sn, {}) }) : /* @__PURE__ */ k.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300",
      "data-testid": "widget-wrapper",
      children: [
        /* @__PURE__ */ k.jsx(
          m7,
          {
            customer: m,
            shopifyDomain: v,
            refresh: l,
            loading: a,
            networkStatus: d
          }
        ),
        g && /* @__PURE__ */ k.jsx(
          CK,
          {
            totalOrders: m?.numberOfOrders,
            amountSpent: m?.amountSpent
          }
        ),
        O && /* @__PURE__ */ k.jsx(EK, { shopifyId: m?.id }),
        _ && /* @__PURE__ */ k.jsx(F7, { customer: m }),
        $ && /* @__PURE__ */ k.jsx(
          C7,
          {
            displayDiscountCodeCreation: R
          }
        ),
        /* @__PURE__ */ k.jsx(
          wK,
          {
            shopifyCustomer: m,
            shopifyDomain: v,
            displayRefund: w,
            displayCancel: N,
            displayCreateOrder: I,
            displayCreateDraftOrder: G,
            enableEditShippingAddress: j,
            customerCountryCodes: f,
            displayDuplicateOrder: L,
            displayPartialRefundOrder: Q
          }
        )
      ]
    }
  );
}, Dt = [];
for (let e = 0; e < 256; ++e)
  Dt.push((e + 256).toString(16).slice(1));
function RK(e, n = 0) {
  return (Dt[e[n + 0]] + Dt[e[n + 1]] + Dt[e[n + 2]] + Dt[e[n + 3]] + "-" + Dt[e[n + 4]] + Dt[e[n + 5]] + "-" + Dt[e[n + 6]] + Dt[e[n + 7]] + "-" + Dt[e[n + 8]] + Dt[e[n + 9]] + "-" + Dt[e[n + 10]] + Dt[e[n + 11]] + Dt[e[n + 12]] + Dt[e[n + 13]] + Dt[e[n + 14]] + Dt[e[n + 15]]).toLowerCase();
}
const DK = new Uint8Array(16);
function OK() {
  return crypto.getRandomValues(DK);
}
function PK(e, n, r) {
  return crypto.randomUUID ? crypto.randomUUID() : AK(e);
}
function AK(e, n, r) {
  e = e || {};
  const i = e.random ?? e.rng?.() ?? OK();
  if (i.length < 16)
    throw new Error("Random bytes length must be >= 16");
  return i[6] = i[6] & 15 | 64, i[8] = i[8] & 63 | 128, RK(i);
}
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode('@charset "UTF-8";._pointer_pn2q5_54{cursor:pointer;color:var(--dixa-typography-color-secondary)}._list_pn2q5_59{padding:0;overflow-y:auto;max-height:230px;background:linear-gradient(var(--dixa-color-neutral-000) 33%,rgba(255,255,255,0)),linear-gradient(rgba(255,255,255,0),var(--dixa-color-neutral-000) 66%) 0 100%,radial-gradient(farthest-side at 50% 0,var(--dixa-color-neutral-200),rgba(0,0,0,0)),radial-gradient(farthest-side at 50% 100%,var(--dixa-color-neutral-200),rgba(0,0,0,0)) 0 100%;background-color:var(--dixa-color-neutral-000);background-repeat:no-repeat;background-attachment:local,local,scroll,scroll;background-size:100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-200),100% var(--dixa-size-spacer-200)}._listItem_pn2q5_69{cursor:pointer;background-color:transparent;padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_pn2q5_69:last-child{border-bottom:none}._modalBody_1clhs_1{width:400px}._wrapper_1ge6c_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._textVariant_1ge6c_7{color:var(--dixa-typography-color-secondary);font-size:var(--dixa-typography-size-300)}._block_1ge6c_12{margin-bottom:var(--dixa-size-spacer-250)}._wrapper_yud4a_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300)}._list_yud4a_7{padding:0}._listItem_yud4a_11{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItemTooltip_yud4a_15{cursor:pointer}._listItemTimestamp_yud4a_18{font-size:var(--dixa-typography-size-200);color:var(--dixa-typography-color-tertiary)}._listItem_yud4a_11:last-child{border-bottom:none}._tagHover_kzbzk_1:hover{cursor:pointer;border-color:var(--dixa-color-neutral-400)}._channelUnsubscribed_kzbzk_6{color:var(--dixa-color-neutral-500)}._list_zu4s7_1{padding:var(--dixa-size-spacer-100)}._listItem_zu4s7_4{padding:var(--dixa-size-spacer-200) var(--dixa-size-spacer-100)}._listSum_zu4s7_7{margin-top:var(--dixa-size-spacer-200);border-top:var(--dixa-size-border-100) solid var(--dixa-color-neutral-400)}._transaction_1kr8d_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._transaction_1kr8d_1:hover,._transactionIsOpen_1kr8d_9{border-color:var(--dixa-color-neutral-400)}._transactionHeader_1kr8d_12{cursor:pointer}._transactionHeaderSubLine_1kr8d_15{font-size:var(--dixa-typography-size-200);color:var(--dixa-typography-color-tertiary)}._transactionHeaderAlignItemRight_1kr8d_19{margin-left:auto;margin-right:var(--dixa-size-spacer-200)}._message_4z55u_54{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._message_4z55u_54:hover,._messageIsOpen_4z55u_62{border-color:var(--dixa-color-neutral-400)}._messageHeader_4z55u_66{cursor:pointer}._messageText_4z55u_70{max-height:150px;overflow:scroll;padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-200);border:1px solid var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);overflow:auto}._messageText_4z55u_70::-webkit-scrollbar{width:7px;height:7px}._messageText_4z55u_70::-webkit-scrollbar-track{background-color:var(--dixa-color-neutral-000)}._messageText_4z55u_70::-webkit-scrollbar-thumb{background-color:var(--dixa-color-neutral-400);border-radius:4px}._messageText_4z55u_70::-webkit-scrollbar-thumb:hover{background-color:var(--dixa-color-neutral-500)}._buttonLink_4z55u_93{color:var(--dixa-typography-color-link)}._order_19t4p_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._order_19t4p_1:hover,._orderIsOpen_19t4p_9{border-color:var(--dixa-color-neutral-400)}._orderHeader_19t4p_12{cursor:pointer}._orderIconColor_19t4p_15{color:var(--dixa-color-green-500)}._delivery_1m9nb_1{word-break:break-all}._deliveryCode_1m9nb_4{font-family:var(--dixa-typography-family-code);color:var(--dixa-typography-color-tertiary)}')), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var zh = { exports: {} }, So = {}, dw;
function LK() {
  if (dw) return So;
  dw = 1;
  var e = He, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (v = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return So.Fragment = r, So.jsx = s, So.jsxs = s, So;
}
var Ws = {}, uw;
function VK() {
  return uw || (uw = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = He, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), d = /* @__PURE__ */ Symbol.for("react.forward_ref"), m = /* @__PURE__ */ Symbol.for("react.suspense"), u = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), v = /* @__PURE__ */ Symbol.for("react.offscreen"), w = Symbol.iterator, N = "@@iterator";
    function j(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = w && t[w] || t[N];
      return typeof c == "function" ? c : null;
    }
    var _ = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          p[y - 1] = arguments[y];
        O("error", t, p);
      }
    }
    function O(t, c, p) {
      {
        var y = _.ReactDebugCurrentFrame, C = y.getStackAddendum();
        C !== "" && (c += "%s", p = p.concat([C]));
        var T = p.map(function(S) {
          return String(S);
        });
        T.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, T);
      }
    }
    var R = !1, $ = !1, I = !1, L = !1, G = !1, Q;
    Q = /* @__PURE__ */ Symbol.for("react.module.reference");
    function ne(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || G || t === a || t === m || t === u || L || t === v || R || $ || I || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Q || t.getModuleId !== void 0));
    }
    function q(t, c, p) {
      var y = t.displayName;
      if (y)
        return y;
      var C = c.displayName || c.name || "";
      return C !== "" ? p + "(" + C + ")" : p;
    }
    function Y(t) {
      return t.displayName || "Context";
    }
    function P(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return Y(c) + ".Consumer";
          case s:
            var p = t;
            return Y(p._context) + ".Provider";
          case d:
            return q(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : P(t.type) || "Memo";
          case h: {
            var C = t, T = C._payload, S = C._init;
            try {
              return P(S(T));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var B = Object.assign, ie = 0, je, pe, le, ge, V, be, Oe;
    function H() {
    }
    H.__reactDisabledLog = !0;
    function Ye() {
      {
        if (ie === 0) {
          je = console.log, pe = console.info, le = console.warn, ge = console.error, V = console.group, be = console.groupCollapsed, Oe = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: H,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ie++;
      }
    }
    function ln() {
      {
        if (ie--, ie === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: B({}, t, {
              value: je
            }),
            info: B({}, t, {
              value: pe
            }),
            warn: B({}, t, {
              value: le
            }),
            error: B({}, t, {
              value: ge
            }),
            group: B({}, t, {
              value: V
            }),
            groupCollapsed: B({}, t, {
              value: be
            }),
            groupEnd: B({}, t, {
              value: Oe
            })
          });
        }
        ie < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Ie = _.ReactCurrentDispatcher, Ue;
    function De(t, c, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (C) {
            var y = C.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Be = !1, Ae;
    {
      var Qe = typeof WeakMap == "function" ? WeakMap : Map;
      Ae = new Qe();
    }
    function Ee(t, c) {
      if (!t || Be)
        return "";
      {
        var p = Ae.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Be = !0;
      var C = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var T;
      T = Ie.current, Ie.current = null, Ye();
      try {
        if (c) {
          var S = function() {
            throw Error();
          };
          if (Object.defineProperty(S.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(S, []);
            } catch (re) {
              y = re;
            }
            Reflect.construct(t, [], S);
          } else {
            try {
              S.call();
            } catch (re) {
              y = re;
            }
            t.call(S.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (re) {
            y = re;
          }
          t();
        }
      } catch (re) {
        if (re && y && typeof re.stack == "string") {
          for (var x = re.stack.split(`
`), ee = y.stack.split(`
`), A = x.length - 1, M = ee.length - 1; A >= 1 && M >= 0 && x[A] !== ee[M]; )
            M--;
          for (; A >= 1 && M >= 0; A--, M--)
            if (x[A] !== ee[M]) {
              if (A !== 1 || M !== 1)
                do
                  if (A--, M--, M < 0 || x[A] !== ee[M]) {
                    var ue = `
` + x[A].replace(" at new ", " at ");
                    return t.displayName && ue.includes("<anonymous>") && (ue = ue.replace("<anonymous>", t.displayName)), typeof t == "function" && Ae.set(t, ue), ue;
                  }
                while (A >= 1 && M >= 0);
              break;
            }
        }
      } finally {
        Be = !1, Ie.current = T, ln(), Error.prepareStackTrace = C;
      }
      var ze = t ? t.displayName || t.name : "", Te = ze ? De(ze) : "";
      return typeof t == "function" && Ae.set(t, Te), Te;
    }
    function Me(t, c, p) {
      return Ee(t, !1);
    }
    function en(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function se(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ee(t, en(t));
      if (typeof t == "string")
        return De(t);
      switch (t) {
        case m:
          return De("Suspense");
        case u:
          return De("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Me(t.render);
          case f:
            return se(t.type, c, p);
          case h: {
            var y = t, C = y._payload, T = y._init;
            try {
              return se(T(C), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var ce = Object.prototype.hasOwnProperty, Se = {}, Ve = _.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, p = se(t.type, t._source, c ? c.type : null);
        Ve.setExtraStackFrame(p);
      } else
        Ve.setExtraStackFrame(null);
    }
    function kn(t, c, p, y, C) {
      {
        var T = Function.call.bind(ce);
        for (var S in t)
          if (T(t, S)) {
            var x = void 0;
            try {
              if (typeof t[S] != "function") {
                var ee = Error((y || "React class") + ": " + p + " type `" + S + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[S] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ee.name = "Invariant Violation", ee;
              }
              x = t[S](c, S, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (A) {
              x = A;
            }
            x && !(x instanceof Error) && (Pe(C), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, S, typeof x), Pe(null)), x instanceof Error && !(x.message in Se) && (Se[x.message] = !0, Pe(C), g("Failed %s type: %s", p, x.message), Pe(null));
          }
      }
    }
    var X = Array.isArray;
    function E(t) {
      return X(t);
    }
    function z(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function ae(t) {
      try {
        return de(t), !1;
      } catch {
        return !0;
      }
    }
    function de(t) {
      return "" + t;
    }
    function U(t) {
      if (ae(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", z(t)), de(t);
    }
    var J = _.ReactCurrentOwner, ve = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, we, Re;
    function rn(t) {
      if (ce.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function bn(t) {
      if (ce.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function an(t, c) {
      typeof t.ref == "string" && J.current;
    }
    function hn(t, c) {
      {
        var p = function() {
          we || (we = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function En(t, c) {
      {
        var p = function() {
          Re || (Re = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var _n = function(t, c, p, y, C, T, S) {
      var x = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: S,
        // Record the component responsible for creating this element.
        _owner: T
      };
      return x._store = {}, Object.defineProperty(x._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(x, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(x, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: C
      }), Object.freeze && (Object.freeze(x.props), Object.freeze(x)), x;
    };
    function Fn(t, c, p, y, C) {
      {
        var T, S = {}, x = null, ee = null;
        p !== void 0 && (U(p), x = "" + p), bn(c) && (U(c.key), x = "" + c.key), rn(c) && (ee = c.ref, an(c));
        for (T in c)
          ce.call(c, T) && !ve.hasOwnProperty(T) && (S[T] = c[T]);
        if (t && t.defaultProps) {
          var A = t.defaultProps;
          for (T in A)
            S[T] === void 0 && (S[T] = A[T]);
        }
        if (x || ee) {
          var M = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          x && hn(S, M), ee && En(S, M);
        }
        return _n(t, x, ee, C, y, J.current, S);
      }
    }
    var Ze = _.ReactCurrentOwner, gn = _.ReactDebugCurrentFrame;
    function Le(t) {
      if (t) {
        var c = t._owner, p = se(t.type, t._source, c ? c.type : null);
        gn.setExtraStackFrame(p);
      } else
        gn.setExtraStackFrame(null);
    }
    var dn;
    dn = !1;
    function un(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function Nn() {
      {
        if (Ze.current) {
          var t = P(Ze.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Bn(t) {
      return "";
    }
    var Sn = {};
    function An(t) {
      {
        var c = Nn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function vn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = An(c);
        if (Sn[p])
          return;
        Sn[p] = !0;
        var y = "";
        t && t._owner && t._owner !== Ze.current && (y = " It was passed a child from " + P(t._owner.type) + "."), Le(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Le(null);
      }
    }
    function xn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (E(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            un(y) && vn(y, c);
          }
        else if (un(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var C = j(t);
          if (typeof C == "function" && C !== t.entries)
            for (var T = C.call(t), S; !(S = T.next()).done; )
              un(S.value) && vn(S.value, c);
        }
      }
    }
    function Ln(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var y = P(c);
          kn(p, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !dn) {
          dn = !0;
          var C = P(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", C || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var y = c[p];
          if (y !== "children" && y !== "key") {
            Le(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Le(null);
            break;
          }
        }
        t.ref !== null && (Le(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Le(null));
      }
    }
    var Cn = {};
    function wn(t, c, p, y, C, T) {
      {
        var S = ne(t);
        if (!S) {
          var x = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (x += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ee = Bn();
          ee ? x += ee : x += Nn();
          var A;
          t === null ? A = "null" : E(t) ? A = "array" : t !== void 0 && t.$$typeof === n ? (A = "<" + (P(t.type) || "Unknown") + " />", x = " Did you accidentally export a JSX literal instead of a component?") : A = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", A, x);
        }
        var M = Fn(t, c, p, C, T);
        if (M == null)
          return M;
        if (S) {
          var ue = c.children;
          if (ue !== void 0)
            if (y)
              if (E(ue)) {
                for (var ze = 0; ze < ue.length; ze++)
                  xn(ue[ze], t);
                Object.freeze && Object.freeze(ue);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              xn(ue, t);
        }
        if (ce.call(c, "key")) {
          var Te = P(t), re = Object.keys(c).filter(function(Gn) {
            return Gn !== "key";
          }), mn = re.length > 0 ? "{key: someKey, " + re.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Cn[Te + mn]) {
            var Dn = re.length > 0 ? "{" + re.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, mn, Te, Dn, Te), Cn[Te + mn] = !0;
          }
        }
        return t === i ? Vn(M) : Ln(M), M;
      }
    }
    function zn(t, c, p) {
      return wn(t, c, p, !0);
    }
    function qn(t, c, p) {
      return wn(t, c, p, !1);
    }
    var Un = qn, Kn = zn;
    Ws.Fragment = i, Ws.jsx = Un, Ws.jsxs = Kn;
  })()), Ws;
}
var mw;
function zK() {
  return mw || (mw = 1, process.env.NODE_ENV === "production" ? zh.exports = LK() : zh.exports = VK()), zh.exports;
}
var D = zK(), XF = /* @__PURE__ */ ((e) => (e.Adjustment = "Adjustment", e.Automation = "Automation", e.BonusBalanceAdjustment = "BonusBalanceAdjustment", e.BonusPromotion = "BonusPromotion", e.BonusPromotionReturn = "BonusPromotionReturn", e.Manual = "Manual", e.PointTransactionCancellation = "PointTransactionCancellation", e.Purchase = "Purchase", e.ReceiptAdjustment = "ReceiptAdjustment", e.Return = "Return", e.RewardVoucher = "RewardVoucher", e.UpdateBalance = "UpdateBalance", e))(XF || {}), Cy = /* @__PURE__ */ ((e) => (e.Addition = "Addition", e.Cancellation = "Cancellation", e.Deduction = "Deduction", e.Expiry = "Expiry", e))(Cy || {});
const UK = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "updatePreferences" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_contactAttributes_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ContactsV_ContactPatch" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }] } }] } }] }, MK = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "updatePoints" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_AddPointTransactionRequestModel_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "PointTransaction_AddPointTransacion" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }] }] } }] } }] }, BK = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getContactById" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ContactsV_GetContactById" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "attributes" } }, { kind: "Field", name: { kind: "Name", value: "meta" } }, { kind: "Field", name: { kind: "Name", value: "preferences" } }, { kind: "Field", name: { kind: "Name", value: "consents" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "value" } }, { kind: "Field", name: { kind: "Name", value: "source" } }, { kind: "Field", name: { kind: "Name", value: "comment" } }] } }] } }] } }] } }] }, qK = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getContactOverviewById" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ContactOverview_GetContactOverviewAsync" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }] }] } }] } }] }, HK = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getContactId" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "mobilePhone" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ContactOverview_GetContactIdAsync" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "email" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }, { kind: "Argument", name: { kind: "Name", value: "mobilePhone" }, value: { kind: "Variable", name: { kind: "Name", value: "mobilePhone" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_ContactOverview_GetContactIdAsync_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_String_container" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "String" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_ApiExceptionMultipleMatchesResponse" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errorCode" } }, { kind: "Field", name: { kind: "Name", value: "message" } }, { kind: "Field", name: { kind: "Name", value: "requestId" } }, { kind: "Field", name: { kind: "Name", value: "messageDetails" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "multipleMatchesFound" } }] } }] } }] } }] } }] } }] } }] }, WK = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getLatestMessagesByContactId" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "count" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ContactMessage_GetSmsMessagesByContactId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "count" }, value: { kind: "Variable", name: { kind: "Name", value: "count" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_ListResultOfApiMessage" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "messageId" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sendDateTime" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "source" } }, { kind: "Field", name: { kind: "Name", value: "isTransactional" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "messageLink" } }, { kind: "Field", name: { kind: "Name", value: "messageText" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "ContactMessage_GetPostalMessagesByContactId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "count" }, value: { kind: "Variable", name: { kind: "Name", value: "count" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_ListResultOfApiMessage" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "messageId" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sendDateTime" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "source" } }, { kind: "Field", name: { kind: "Name", value: "isTransactional" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "messageLink" } }, { kind: "Field", name: { kind: "Name", value: "messageText" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "ContactMessage_GetEmailMessagesByContactId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "count" }, value: { kind: "Variable", name: { kind: "Name", value: "count" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_ListResultOfApiMessage" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "messageId" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sendDateTime" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "source" } }, { kind: "Field", name: { kind: "Name", value: "isTransactional" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "messageLink" } }, { kind: "Field", name: { kind: "Name", value: "messageText" } }] } }] } }] } }] } }] } }] }, KK = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCustomerTransactions" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "offset" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "count" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Transactions_GetTransactionsWithArticlesByContactId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "offset" }, value: { kind: "Variable", name: { kind: "Name", value: "offset" } } }, { kind: "Argument", name: { kind: "Name", value: "count" }, value: { kind: "Variable", name: { kind: "Name", value: "count" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }, { kind: "Field", name: { kind: "Name", value: "totalCount" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "createdDate" } }, { kind: "Field", name: { kind: "Name", value: "transactionNumber" } }, { kind: "Field", name: { kind: "Name", value: "storeName" } }, { kind: "Field", name: { kind: "Name", value: "numberOfItems" } }, { kind: "Field", name: { kind: "Name", value: "netPriceSum" } }, { kind: "Field", name: { kind: "Name", value: "localNetPriceSum" } }, { kind: "Field", name: { kind: "Name", value: "localCurrency" } }, { kind: "Field", name: { kind: "Name", value: "lineItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "article" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "localPrice" } }, { kind: "Field", name: { kind: "Name", value: "type" } }] } }] } }] } }] } }] } }] }, GK = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getOrdersByContactId" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "offset" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "count" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Orders_GetAllByContact" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "offset" }, value: { kind: "Variable", name: { kind: "Name", value: "offset" } } }, { kind: "Argument", name: { kind: "Name", value: "count" }, value: { kind: "Variable", name: { kind: "Name", value: "count" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "totalCount" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orderId" } }, { kind: "Field", name: { kind: "Name", value: "createdAt" } }, { kind: "Field", name: { kind: "Name", value: "lastChangedAt" } }, { kind: "Field", name: { kind: "Name", value: "channel" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "externalStatus" } }, { kind: "Field", name: { kind: "Name", value: "totalPrice" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }, { kind: "Field", name: { kind: "Name", value: "lineItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "totalPrice" } }, { kind: "Field", name: { kind: "Name", value: "article" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sku" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "imageUri" } }, { kind: "Field", name: { kind: "Name", value: "targetUri" } }] } }] } }] } }] } }] } }] } }] } }] }, YK = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getPoints" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "PointAccountV_GetPointAccounts" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_PointAccountModelV3" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "balance" } }] } }] } }] } }] } }] }, JK = {
  "\n  mutation updatePreferences(\n    $contactId: Voyado_UUID!\n    $input: Voyado_contactAttributes_Input!\n  ) {\n    Voyado {\n      ContactsV_ContactPatch(contactId: $contactId, input: $input) {\n        id\n      }\n    }\n  }\n": UK,
  "\n  mutation updatePoints($input: Voyado_AddPointTransactionRequestModel_Input!) {\n    Voyado {\n      PointTransaction_AddPointTransacion(input: $input)\n    }\n  }\n": MK,
  "\n  query getContactById($contactId: Voyado_UUID!) {\n    Voyado {\n      ContactsV_GetContactById(contactId: $contactId) {\n        id\n        attributes\n        meta\n        preferences\n        consents {\n          id\n          date\n          value\n          source\n          comment\n        }\n      }\n    }\n  }\n": BK,
  "\n  query getContactOverviewById($contactId: String!) {\n    Voyado {\n      ContactOverview_GetContactOverviewAsync(contactId: $contactId)\n    }\n  }\n": qK,
  "\n  query getContactId($email: String!, $mobilePhone: String!) {\n    Voyado {\n      ContactOverview_GetContactIdAsync(\n        email: $email\n        mobilePhone: $mobilePhone\n      ) {\n        ... on Voyado_ContactOverview_GetContactIdAsync_response {\n          ... on Voyado_String_container {\n            String\n          }\n          ... on Voyado_ApiExceptionMultipleMatchesResponse {\n            errorCode\n            message\n            requestId\n            messageDetails {\n              multipleMatchesFound\n            }\n          }\n        }\n      }\n    }\n  }\n": HK,
  "\n  query getLatestMessagesByContactId($contactId: Voyado_UUID!, $count: Int) {\n    Voyado {\n      ContactMessage_GetSmsMessagesByContactId(\n        contactId: $contactId\n        count: $count\n      ) {\n        ... on Voyado_ListResultOfApiMessage {\n          count\n          items {\n            messageId\n            name\n            sendDateTime\n            type\n            source\n            isTransactional\n            status\n            messageLink\n            messageText\n          }\n        }\n      }\n      ContactMessage_GetPostalMessagesByContactId(\n        contactId: $contactId\n        count: $count\n      ) {\n        ... on Voyado_ListResultOfApiMessage {\n          count\n          items {\n            messageId\n            name\n            sendDateTime\n            type\n            source\n            isTransactional\n            status\n            messageLink\n            messageText\n          }\n        }\n      }\n      ContactMessage_GetEmailMessagesByContactId(\n        contactId: $contactId\n        count: $count\n      ) {\n        ... on Voyado_ListResultOfApiMessage {\n          count\n          items {\n            messageId\n            name\n            sendDateTime\n            type\n            source\n            isTransactional\n            status\n            messageLink\n            messageText\n          }\n        }\n      }\n    }\n  }\n": WK,
  "\n  query getCustomerTransactions(\n    $contactId: Voyado_UUID!\n    $offset: Int\n    $count: Int\n  ) {\n    Voyado {\n      Transactions_GetTransactionsWithArticlesByContactId(\n        contactId: $contactId\n        offset: $offset\n        count: $count\n      ) {\n        count\n        totalCount\n        items {\n          id\n          createdDate\n          transactionNumber\n          storeName\n          numberOfItems\n          netPriceSum\n          localNetPriceSum\n          localCurrency\n          lineItems {\n            quantity\n            article {\n              name\n            }\n            localPrice\n            type\n          }\n        }\n      }\n    }\n  }\n": KK,
  "\n  query getOrdersByContactId(\n    $contactId: Voyado_UUID!\n    $offset: Int\n    $count: Int\n  ) {\n    Voyado {\n      Orders_GetAllByContact(\n        contactId: $contactId\n        offset: $offset\n        count: $count\n      ) {\n        totalCount\n        items {\n          orderId\n          createdAt\n          lastChangedAt\n          channel\n          status\n          externalStatus\n          totalPrice\n          currencyCode\n          lineItems {\n            items {\n              id\n              quantity\n              totalPrice\n              article {\n                sku\n                name\n                description\n                imageUri\n                targetUri\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": GK,
  "\n  query getPoints($contactId: Voyado_UUID!) {\n    Voyado {\n      PointAccountV_GetPointAccounts(contactId: $contactId) {\n        ... on Voyado_PointAccountModelV3 {\n          id\n          balance\n        }\n      }\n    }\n  }\n": YK
};
function ci(e) {
  return JK[e] ?? {};
}
const QK = ci(
  /* GraphQL */
  `
  query getContactById($contactId: Voyado_UUID!) {
    Voyado {
      ContactsV_GetContactById(contactId: $contactId) {
        id
        attributes
        meta
        preferences
        consents {
          id
          date
          value
          source
          comment
        }
      }
    }
  }
`
), XK = ci(
  /* GraphQL */
  `
  query getContactOverviewById($contactId: String!) {
    Voyado {
      ContactOverview_GetContactOverviewAsync(contactId: $contactId)
    }
  }
`
), ZK = ci(
  /* GraphQL */
  `
  query getContactId($email: String!, $mobilePhone: String!) {
    Voyado {
      ContactOverview_GetContactIdAsync(
        email: $email
        mobilePhone: $mobilePhone
      ) {
        ... on Voyado_ContactOverview_GetContactIdAsync_response {
          ... on Voyado_String_container {
            String
          }
          ... on Voyado_ApiExceptionMultipleMatchesResponse {
            errorCode
            message
            requestId
            messageDetails {
              multipleMatchesFound
            }
          }
        }
      }
    }
  }
`
), eG = ci(
  /* GraphQL */
  `
  query getLatestMessagesByContactId($contactId: Voyado_UUID!, $count: Int) {
    Voyado {
      ContactMessage_GetSmsMessagesByContactId(
        contactId: $contactId
        count: $count
      ) {
        ... on Voyado_ListResultOfApiMessage {
          count
          items {
            messageId
            name
            sendDateTime
            type
            source
            isTransactional
            status
            messageLink
            messageText
          }
        }
      }
      ContactMessage_GetPostalMessagesByContactId(
        contactId: $contactId
        count: $count
      ) {
        ... on Voyado_ListResultOfApiMessage {
          count
          items {
            messageId
            name
            sendDateTime
            type
            source
            isTransactional
            status
            messageLink
            messageText
          }
        }
      }
      ContactMessage_GetEmailMessagesByContactId(
        contactId: $contactId
        count: $count
      ) {
        ... on Voyado_ListResultOfApiMessage {
          count
          items {
            messageId
            name
            sendDateTime
            type
            source
            isTransactional
            status
            messageLink
            messageText
          }
        }
      }
    }
  }
`
), nG = ci(
  /* GraphQL */
  `
  query getCustomerTransactions(
    $contactId: Voyado_UUID!
    $offset: Int
    $count: Int
  ) {
    Voyado {
      Transactions_GetTransactionsWithArticlesByContactId(
        contactId: $contactId
        offset: $offset
        count: $count
      ) {
        count
        totalCount
        items {
          id
          createdDate
          transactionNumber
          storeName
          numberOfItems
          netPriceSum
          localNetPriceSum
          localCurrency
          lineItems {
            quantity
            article {
              name
            }
            localPrice
            type
          }
        }
      }
    }
  }
`
), tG = ci(
  /* GraphQL */
  `
  query getOrdersByContactId(
    $contactId: Voyado_UUID!
    $offset: Int
    $count: Int
  ) {
    Voyado {
      Orders_GetAllByContact(
        contactId: $contactId
        offset: $offset
        count: $count
      ) {
        totalCount
        items {
          orderId
          createdAt
          lastChangedAt
          channel
          status
          externalStatus
          totalPrice
          currencyCode
          lineItems {
            items {
              id
              quantity
              totalPrice
              article {
                sku
                name
                description
                imageUri
                targetUri
              }
            }
          }
        }
      }
    }
  }
`
), rG = ci(
  /* GraphQL */
  `
  query getPoints($contactId: Voyado_UUID!) {
    Voyado {
      PointAccountV_GetPointAccounts(contactId: $contactId) {
        ... on Voyado_PointAccountModelV3 {
          id
          balance
        }
      }
    }
  }
`
), iG = ci(
  /* GraphQL */
  `
  mutation updatePreferences(
    $contactId: Voyado_UUID!
    $input: Voyado_contactAttributes_Input!
  ) {
    Voyado {
      ContactsV_ContactPatch(contactId: $contactId, input: $input) {
        id
      }
    }
  }
`
), aG = ci(
  /* GraphQL */
  `
  mutation updatePoints($input: Voyado_AddPointTransactionRequestModel_Input!) {
    Voyado {
      PointTransaction_AddPointTransacion(input: $input)
    }
  }
`
), oG = ({
  contactId: e
}) => {
  const { useQuery: n } = fn(), { track: r } = jn(), [i, a] = me(), [o, s] = me(), [l, d] = me(), {
    loading: m,
    error: u,
    data: f,
    refetch: h
  } = n(QK, {
    skip: !e,
    variables: { contactId: e }
  });
  return Xe(() => {
    const v = f?.Voyado?.ContactsV_GetContactById;
    !m && v && typeof v == "object" && ("id" in v && r("voyado:profile:received", { hasProfile: !0 }), "attributes" in v && a(v.attributes), "preferences" in v && s(v.preferences), "consents" in v && d(
      v?.consents?.filter(
        (w) => w !== null
      ) || void 0
    )), !m && (!v || typeof v != "object") && r("voyado:profile:received", { hasProfile: !1 });
  }, [f?.Voyado, m]), Zn(
    () => ({
      isLoading: m,
      error: u,
      refetch: h,
      attributes: i,
      preferences: o,
      consents: l
    }),
    [u, i, o, l]
  );
};
function ml(e = !1, n) {
  const [r, i] = me(e);
  return Xe(() => {
    const a = r ? window.setTimeout(() => i(!1), 2e3) : void 0;
    return () => window.clearTimeout(a);
  }, [n, r]), { isCopied: r, copy: (a) => {
    navigator.clipboard.writeText(a), i(!0);
  } };
}
const sG = {
  count: 0,
  items: []
}, lG = ({
  contactId: e
}) => {
  const { useQuery: n } = fn(), { track: r } = jn(), [i, a] = me(sG), {
    loading: o,
    error: s,
    data: l
  } = n(eG, {
    skip: !e,
    variables: { contactId: e, count: 5 }
  });
  return Xe(() => {
    if (!o && (l?.Voyado?.ContactMessage_GetSmsMessagesByContactId || l?.Voyado?.ContactMessage_GetPostalMessagesByContactId || l?.Voyado?.ContactMessage_GetEmailMessagesByContactId)) {
      const d = l?.Voyado?.ContactMessage_GetEmailMessagesByContactId, m = l?.Voyado?.ContactMessage_GetSmsMessagesByContactId, u = l?.Voyado?.ContactMessage_GetPostalMessagesByContactId, f = {
        count: (m?.count ?? 0) + (u?.count ?? 0) + (d?.count ?? 0),
        items: [
          ...m.items ?? [],
          ...d.items ?? [],
          ...u.items ?? []
        ]
      };
      a(f), r("voyado:messages:received", {
        emailsReceived: d.count ?? 0,
        smsReceived: m.count ?? 0,
        postalReceived: u.count ?? 0,
        total: f.count ?? 0
      });
    }
  }, [l?.Voyado, o]), {
    isLoading: o,
    error: s,
    lastMessages: i
  };
}, cG = {
  count: 0,
  totalCount: 0,
  items: []
}, dG = ({
  contactId: e
}) => {
  const { useQuery: n } = fn(), { track: r } = jn(), [i, a] = me(
    cG
  ), {
    loading: o,
    error: s,
    data: l
  } = n(nG, {
    skip: !e,
    variables: { contactId: e, count: 5 }
  });
  return Xe(() => {
    const d = l?.Voyado?.Transactions_GetTransactionsWithArticlesByContactId;
    if (!o && d) {
      a(
        d
      );
      const { count: m } = d;
      m && r("voyado:transactions:received", { count: m });
    }
  }, [l?.Voyado, o]), {
    isLoading: o,
    error: s,
    transactions: i
  };
}, uG = ({
  conversationContext: e
}) => {
  const { useQuery: n } = fn(), [r, i] = me(void 0), [a, o] = me(!1), { customer: s } = e, l = !!s?.email || !!s?.phone_number, {
    loading: d,
    error: m,
    data: u,
    refetch: f
  } = n(ZK, {
    skip: !l,
    variables: {
      email: s?.email ?? "",
      mobilePhone: s?.phone_number ?? ""
    }
  });
  return Xe(() => {
    const h = u?.Voyado?.ContactOverview_GetContactIdAsync;
    h?.__typename === "Voyado_ApiExceptionMultipleMatchesResponse" && h?.messageDetails?.multipleMatchesFound && h?.messageDetails?.multipleMatchesFound.length > 0 && (o(!0), i(void 0)), h?.__typename === "Voyado_String_container" && h?.String && (o(!1), i(h.String));
  }, [u?.Voyado, d]), {
    isLoading: d,
    contactId: r,
    hasMultipleContacts: a,
    error: m,
    refetch: f
  };
}, mG = ({
  contactId: e,
  skip: n
}) => {
  const { useQuery: r } = fn(), [i, a] = me(
    void 0
  ), {
    loading: o,
    error: s,
    data: l,
    refetch: d
  } = r(XK, {
    skip: !e || n,
    variables: { contactId: e }
  });
  return Xe(() => {
    const m = l?.Voyado?.ContactOverview_GetContactOverviewAsync;
    if (!o && m && Object.hasOwn(m, "memberlevel")) {
      const u = m?.memberlevel;
      a({
        levelName: u?.levelName,
        remainingToUpgrade: u?.remainingToUpgrade,
        basedOnRewardPoints: u?.basedOnRewardPoints,
        levelId: u?.levelId,
        latestChange: u?.latestChange,
        expires: u?.expires
      });
    } else
      a(void 0);
  }, [l?.Voyado, o]), Zn(
    () => ({
      isLoading: o,
      error: s,
      memberLevel: i,
      refetch: d
    }),
    [o, s, i, d]
  );
}, pG = "_pointer_pn2q5_54", fG = "_list_pn2q5_59", hG = "_listItem_pn2q5_69", ft = {
  pointer: pG,
  list: fG,
  listItem: hG
}, yG = "_modalBody_1clhs_1", gG = {
  modalBody: yG
}, vG = ({
  isOpen: e,
  onClose: n,
  pointsAccount: r,
  setHasPointsBeenUpdated: i,
  refetchPointsQuery: a
}) => {
  const { useMutation: o, showNotification: s } = fn(), { track: l } = jn(), d = r?.id, m = r?.balance ?? 0, u = {
    balance: m?.toString() ?? "0",
    description: "",
    transactionType: null
  }, { control: f, setValue: h, reset: v } = ot({
    defaultValues: u,
    mode: "onChange"
  }), w = ki({ control: f }), N = parseInt(w?.balance ?? "0", 10), j = m === N, _ = j ? "Change the value to update the points" : "", g = N < 0, O = g ? "Points can not be negative" : "", R = w.description === "", $ = R ? "Description can not be empty" : "";
  Xe(() => {
    N > m ? h(
      "transactionType",
      Cy.Addition
    ) : N < m && h(
      "transactionType",
      Cy.Deduction
    );
  }, [m, N, h]);
  const [I, { loading: L, error: G, reset: Q }] = o(aG, {
    onCompleted: () => {
      s({
        title: "Success",
        text: "Points updated successfully",
        icon: "check-circle-filled",
        severity: "success"
      });
    }
  }), ne = () => {
    if (d) {
      const Y = PK();
      I({
        variables: {
          input: {
            accountId: d,
            transactionId: Y,
            amount: Math.abs(N - m),
            transactionType: w.transactionType,
            description: w.description,
            source: XF.UpdateBalance
          }
        }
      }).then(async (P) => {
        P?.errors ? l("voyado:update:points:failed") : (l("voyado:update:points:succeeded"), i(!0), await a(), q());
      }).catch(() => {
        l("voyado:update:points:failed");
      });
    }
  }, q = () => {
    v(u), Q(), n();
  };
  return /* @__PURE__ */ D.jsxs(
    ht,
    {
      isOpen: e,
      onClose: q,
      "data-testid": "change-points-modal",
      children: [
        /* @__PURE__ */ D.jsx(yt, { title: "Update points balance", onClose: q }),
        /* @__PURE__ */ D.jsxs(gt, { className: gG.modalBody, children: [
          /* @__PURE__ */ D.jsxs(et, { children: [
            /* @__PURE__ */ D.jsx(Z, { span: 6, children: /* @__PURE__ */ D.jsx(
              jt,
              {
                name: "balance",
                control: f,
                render: ({ field: Y }) => /* @__PURE__ */ D.jsx(
                  Kr,
                  {
                    label: "New points balance",
                    type: "number",
                    placeholder: "Insert new points",
                    min: 0,
                    max: 1e5,
                    meta: {
                      warning: _ || O
                    },
                    input: {
                      ...Y,
                      value: Y.value.toString(),
                      onChange: (P) => Y.onChange(P)
                    }
                  }
                )
              }
            ) }),
            /* @__PURE__ */ D.jsx(Z, { span: 6, children: /* @__PURE__ */ D.jsx(
              jt,
              {
                name: "description",
                control: f,
                render: ({ field: Y }) => /* @__PURE__ */ D.jsx(
                  Kr,
                  {
                    required: !0,
                    label: "Description",
                    placeholder: "Insert a description",
                    input: Y,
                    meta: {
                      warning: $
                    }
                  }
                )
              }
            ) })
          ] }),
          G && /* @__PURE__ */ D.jsx($n, { error: G })
        ] }),
        /* @__PURE__ */ D.jsx(
          vt,
          {
            confirmName: "Save",
            confirmOnClick: () => ne(),
            confirmProps: {
              isLoading: L,
              disabled: j || g || R,
              loadingIndicator: /* @__PURE__ */ D.jsx(sn, { size: 16 })
            },
            cancelOnClick: q
          }
        )
      ]
    }
  );
}, kG = "_wrapper_1ge6c_1", bG = "_block_1ge6c_12", pw = {
  wrapper: kG,
  block: bG
}, _G = ({
  contactAttributes: e,
  contactId: n
}) => {
  const { useQuery: r } = fn(), { isCopied: i, copy: a } = ml(), { isCopied: o, copy: s } = ml(), { isCopied: l, copy: d } = ml(), [m, u] = me(!1), [f, h] = me(), [v, w] = me(!1), {
    loading: N,
    data: j,
    refetch: _
  } = r(rG, {
    variables: {
      contactId: n
    },
    skip: !n
  });
  Xe(() => {
    if (j) {
      const ie = j?.Voyado?.PointAccountV_GetPointAccounts;
      ie && ie?.length > 0 && h(ie[0]);
    }
  }, [j]);
  const g = !!f?.id, O = f?.balance ?? 0;
  if (!e)
    return null;
  const {
    firstName: R,
    lastName: $,
    street: I,
    zipCode: L,
    city: G,
    country: Q,
    isRegistrationCompleted: ne,
    email: q,
    mobilePhone: Y
  } = e, P = 14, B = `${R || ""} ${$ || ""}`.trim() || "Anonymous";
  return /* @__PURE__ */ D.jsxs(b, { flexDirection: "column", className: pw.wrapper, children: [
    /* @__PURE__ */ D.jsxs(
      b,
      {
        justifyContent: "space-between",
        className: pw.block,
        alignItems: "center",
        children: [
          /* @__PURE__ */ D.jsx(F.Heading, { variant: "heading-2", children: B }),
          N && /* @__PURE__ */ D.jsx(sn, { size: 12 }),
          g && !N && /* @__PURE__ */ D.jsxs(b, { gap: "100", alignItems: "center", children: [
            /* @__PURE__ */ D.jsxs(Pn, { size: "small", variant: "warning", children: [
              O,
              " points"
            ] }),
            /* @__PURE__ */ D.jsx(Ge, { content: "Update points balance", children: /* @__PURE__ */ D.jsx(
              fe,
              {
                name: "pen",
                size: 12,
                onClick: () => u(!0),
                className: ft.pointer
              }
            ) }),
            v && /* @__PURE__ */ D.jsx(Ge, { content: "It might take a while until the updated points are available. Please refresh the integration by collapsing and expanding the widget in the sidebar.", children: /* @__PURE__ */ D.jsx(
              fe,
              {
                name: "info",
                size: 12,
                className: ft.pointer
              }
            ) })
          ] })
        ]
      }
    ),
    (I || G || L || Q || Y || q) && /* @__PURE__ */ D.jsxs(b, { gap: "200", flexDirection: "column", children: [
      Y && /* @__PURE__ */ D.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
        /* @__PURE__ */ D.jsxs(b, { gap: "200", alignItems: "center", children: [
          /* @__PURE__ */ D.jsx(fe, { size: P, name: "phone" }),
          /* @__PURE__ */ D.jsx(F.Paragraph, { variant: "4", children: Y })
        ] }),
        /* @__PURE__ */ D.jsx(
          fe,
          {
            size: P,
            name: o ? "done" : "copy",
            onClick: () => s(Y),
            className: ft.pointer
          }
        )
      ] }),
      q && /* @__PURE__ */ D.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
        /* @__PURE__ */ D.jsxs(b, { gap: "200", alignItems: "center", children: [
          /* @__PURE__ */ D.jsx(fe, { size: P, name: "mail" }),
          /* @__PURE__ */ D.jsx(F.Paragraph, { variant: "4", children: q })
        ] }),
        /* @__PURE__ */ D.jsx(
          fe,
          {
            size: P,
            name: i ? "done" : "copy",
            onClick: () => a(q),
            className: ft.pointer
          }
        )
      ] }),
      (I || G || L || Q) && /* @__PURE__ */ D.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
        /* @__PURE__ */ D.jsxs(b, { gap: "200", children: [
          /* @__PURE__ */ D.jsx(fe, { size: P, name: "home" }),
          /* @__PURE__ */ D.jsxs(F.Paragraph, { variant: "4", color: "secondary", children: [
            /* @__PURE__ */ D.jsx(ct, { children: I }),
            /* @__PURE__ */ D.jsxs(ct, { children: [
              L,
              " ",
              G
            ] }),
            /* @__PURE__ */ D.jsx(ct, { children: Q })
          ] })
        ] }),
        /* @__PURE__ */ D.jsx(
          fe,
          {
            size: P,
            name: l ? "done" : "copy",
            onClick: () => d(`${I}, ${L} ${G}, ${Q}`),
            className: ft.pointer
          }
        )
      ] }),
      /* @__PURE__ */ D.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
        /* @__PURE__ */ D.jsxs(b, { gap: "200", alignItems: "center", children: [
          /* @__PURE__ */ D.jsx(fe, { size: P, name: "sign-in" }),
          /* @__PURE__ */ D.jsx(F.Paragraph, { variant: "4", children: "Is registration completed" })
        ] }),
        /* @__PURE__ */ D.jsx(
          fe,
          {
            name: ne ? "check-circle-filled" : "close-circle-filled",
            color: ne ? "green.500" : "neutral.500"
          }
        )
      ] })
    ] }),
    g && /* @__PURE__ */ D.jsx(
      vG,
      {
        isOpen: m,
        pointsAccount: f,
        onClose: () => u(!1),
        setHasPointsBeenUpdated: w,
        refetchPointsQuery: _
      }
    )
  ] });
}, xG = "_list_yud4a_7", SG = "_listItem_yud4a_11", NG = "_listItemTooltip_yud4a_15", jG = "_listItemTimestamp_yud4a_18", Ks = {
  list: xG,
  listItem: SG,
  listItemTooltip: NG,
  listItemTimestamp: jG
}, wG = ({
  contactConsents: e
}) => !e || e.length === 0 ? null : /* @__PURE__ */ D.jsxs(b, { gap: "200", flexDirection: "column", children: [
  /* @__PURE__ */ D.jsx(F.Heading, { variant: "heading-3", children: "Consents" }),
  /* @__PURE__ */ D.jsx(Je, { className: Ks.list, children: e.map((n, r) => /* @__PURE__ */ D.jsx(Je.Text, { variant: "dense", className: Ks.listItem, children: /* @__PURE__ */ D.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
    /* @__PURE__ */ D.jsx(Ge, { content: n?.comment, children: /* @__PURE__ */ D.jsxs(
      b,
      {
        gap: "200",
        alignItems: "center",
        className: ut({
          [Ks.listItemTooltip]: n?.comment
        }),
        children: [
          /* @__PURE__ */ D.jsx(F.Paragraph, { variant: "4", children: n.id }),
          /* @__PURE__ */ D.jsx(F.Paragraph, { className: Ks.listItemTimestamp, children: Wn(n.date).format(It) }),
          n?.comment && /* @__PURE__ */ D.jsx(fe, { name: "info", color: "neutral.400" })
        ]
      }
    ) }),
    /* @__PURE__ */ D.jsx(
      fe,
      {
        name: n.value ? "check-circle-filled" : "close-circle-filled",
        color: n.value ? "green.500" : "red.500"
      }
    )
  ] }) }, r)) })
] }), CG = ({
  memberLevel: e
}) => {
  const n = e?.levelName ?? null, r = e?.remainingToUpgrade ?? null, i = e?.basedOnRewardPoints ?? null, a = e?.latestChange ? Wn(e.latestChange).format(It) : null, o = e?.expires ? `${Wn(e.expires).fromNow()} (${Wn(e.expires).format(It)})` : null, s = !n && !a && !r && !i && !o;
  return /* @__PURE__ */ D.jsx(b, { gap: "200", flexDirection: "column", children: /* @__PURE__ */ D.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ D.jsxs(b, { alignItems: "center", gap: "100", children: [
      /* @__PURE__ */ D.jsx(F.Heading, { variant: "heading-3", children: "Member level" }),
      /* @__PURE__ */ D.jsx(Ge, { content: "Voyado updates the member level data in a nightly batch process", children: /* @__PURE__ */ D.jsx(
        fe,
        {
          name: "question",
          size: 14,
          className: ft.pointer
        }
      ) })
    ] }),
    /* @__PURE__ */ D.jsx(b, { flexDirection: "column", children: /* @__PURE__ */ D.jsxs(Je, { className: ft.list, children: [
      s && /* @__PURE__ */ D.jsx(Je.Text, { variant: "dense", className: ft.listItem, children: /* @__PURE__ */ D.jsx(F.Paragraph, { variant: "4", color: "secondary", children: "No member level properties found" }) }),
      n && /* @__PURE__ */ D.jsx(Je.Text, { variant: "dense", className: ft.listItem, children: /* @__PURE__ */ D.jsx(Ge, { content: "", children: /* @__PURE__ */ D.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ D.jsx(F.Paragraph, { variant: "4", children: "Level" }),
        /* @__PURE__ */ D.jsx(Pn, { variant: "info", size: "small", children: e?.levelName ?? "" })
      ] }) }) }),
      i && /* @__PURE__ */ D.jsx(Je.Text, { variant: "dense", className: ft.listItem, children: /* @__PURE__ */ D.jsx(Ge, { content: "Voyado updates the member level data once a day in a nightly job", children: /* @__PURE__ */ D.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ D.jsx(F.Paragraph, { variant: "4", children: "Based on reward points" }),
        /* @__PURE__ */ D.jsx(Pn, { variant: "success", size: "small", children: i })
      ] }) }) }),
      r && /* @__PURE__ */ D.jsx(Je.Text, { variant: "dense", className: ft.listItem, children: /* @__PURE__ */ D.jsx(Ge, { content: "", children: /* @__PURE__ */ D.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ D.jsx(F.Paragraph, { variant: "4", children: "Remaining to upgrade" }),
        /* @__PURE__ */ D.jsx(Pn, { variant: "success", size: "small", children: r })
      ] }) }) }),
      a && /* @__PURE__ */ D.jsx(Je.Text, { variant: "dense", className: ft.listItem, children: /* @__PURE__ */ D.jsx(Ge, { content: "", children: /* @__PURE__ */ D.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ D.jsx(F.Paragraph, { variant: "4", children: "Latest change" }),
        /* @__PURE__ */ D.jsx(F.Paragraph, { variant: "5", color: "secondary", children: a })
      ] }) }) }),
      o && /* @__PURE__ */ D.jsx(Je.Text, { variant: "dense", className: ft.listItem, children: /* @__PURE__ */ D.jsx(Ge, { content: "", children: /* @__PURE__ */ D.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ D.jsx(F.Paragraph, { variant: "4", children: "Expires" }),
        /* @__PURE__ */ D.jsx(F.Paragraph, { variant: "5", color: "secondary", children: o })
      ] }) }) })
    ] }) })
  ] }) });
}, FG = "_tagHover_kzbzk_1", IG = "_channelUnsubscribed_kzbzk_6", fw = {
  tagHover: FG,
  channelUnsubscribed: IG
}, Uh = ({
  isSubscribed: e,
  channelName: n,
  channelIcon: r,
  contactId: i,
  contactPreferences: a,
  refetchContact: o
}) => {
  const { track: s } = jn(), { useMutation: l } = fn(), [d, m] = me(!1), [u, { loading: f }] = l(iG), h = async ({
    newPreference: w,
    isSubscribed: N,
    channelType: j
  }) => {
    m(!0), (await u({
      variables: {
        contactId: i,
        input: {
          preferences: {
            ...a,
            ...w
          }
        }
      }
    }))?.data?.Voyado.ContactsV_ContactPatch?.id ? N ? s("voyado:channel:unsubscribe:succeeded", { channel: j }) : s("voyado:channel:subscribe:succeeded", { channel: j }) : N ? s("voyado:channel:unsubscribe:failed", { channel: j }) : s("voyado:channel:subscribe:failed", { channel: j }), setTimeout(async () => {
      await o().finally(() => m(!1));
    }, 1e3);
  }, v = d || f;
  return /* @__PURE__ */ D.jsx(Ge, { content: e ? "Unsubscribe" : "Subscribe", children: /* @__PURE__ */ D.jsx(
    Jn,
    {
      className: fw.tagHover,
      color: e ? "green.500" : "neutral.200",
      children: /* @__PURE__ */ D.jsxs(
        b,
        {
          "data-testid": `widget-preference-${e ? "subscribed" : "unsubscribed"}`,
          gap: "200",
          alignItems: "center",
          className: ut({
            [fw.channelUnsubscribed]: !e
          }),
          onClick: () => {
            e ? s("voyado:channel:unsubscribe:clicked", {
              channel: n.toUpperCase()
            }) : s("voyado:channel:subscribe:clicked", {
              channel: n.toUpperCase()
            }), h({
              newPreference: { [`accepts${n}`]: !e },
              isSubscribed: e,
              channelType: n.toUpperCase()
            });
          },
          children: [
            v ? /* @__PURE__ */ D.jsx(sn, { size: 16 }) : /* @__PURE__ */ D.jsx(fe, { size: 16, name: r }),
            n
          ]
        }
      )
    }
  ) });
}, $G = ({
  contactPreferences: e,
  contactId: n,
  refetchContact: r
}) => {
  if (!e || !n)
    return null;
  const { acceptsEmail: i, acceptsPostal: a, acceptsSms: o } = e;
  return /* @__PURE__ */ D.jsx(b, { gap: "200", flexDirection: "column", children: /* @__PURE__ */ D.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ D.jsx(F.Heading, { variant: "heading-3", children: "Subscriptions" }),
    /* @__PURE__ */ D.jsxs(b, { gap: "100", flexDirection: "row", children: [
      /* @__PURE__ */ D.jsx(
        Uh,
        {
          channelName: "Email",
          channelIcon: "mail",
          isSubscribed: i,
          contactId: n,
          contactPreferences: e,
          refetchContact: r
        }
      ),
      /* @__PURE__ */ D.jsx(
        Uh,
        {
          channelName: "Sms",
          channelIcon: "sms",
          isSubscribed: o,
          contactId: n,
          contactPreferences: e,
          refetchContact: r
        }
      ),
      /* @__PURE__ */ D.jsx(
        Uh,
        {
          channelName: "Postal",
          channelIcon: "paper-plane",
          isSubscribed: a,
          contactId: n,
          contactPreferences: e,
          refetchContact: r
        }
      )
    ] })
  ] }) });
}, EG = ({
  contactId: e,
  settings: n
}) => {
  const {
    showCustomerAttributes: r,
    showPreferences: i,
    showAudiences: a,
    showConsents: o,
    showMemberLevel: s
  } = n, {
    isLoading: l,
    error: d,
    refetch: m,
    attributes: u,
    preferences: f,
    consents: h
  } = oG({ contactId: e }), {
    isLoading: v,
    error: w,
    memberLevel: N
  } = mG({ contactId: e, skip: !s }), j = v || l, _ = Zn(
    () => h?.filter(
      (g) => g !== null
    ),
    [h]
  );
  return d || w ? Fa({
    errors: d?.graphQLErrors || w?.graphQLErrors || []
  }) ? /* @__PURE__ */ D.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ D.jsx(F.Paragraph, { color: "secondary", children: "No contact informations found" }) }) : /* @__PURE__ */ D.jsx($n, { error: d || w }) : !r && !i && !a && !o && !s ? /* @__PURE__ */ D.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ D.jsx(F.Paragraph, { color: "secondary", children: "All contact related features in the settings are disabled." }) }) : j ? /* @__PURE__ */ D.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ D.jsx(sn, {}) }) : /* @__PURE__ */ D.jsxs(D.Fragment, { children: [
    r && /* @__PURE__ */ D.jsx(
      _G,
      {
        contactAttributes: u,
        contactId: e
      }
    ),
    s && /* @__PURE__ */ D.jsx(CG, { memberLevel: N }),
    i && /* @__PURE__ */ D.jsx(
      $G,
      {
        refetchContact: m,
        contactPreferences: f,
        contactId: e
      }
    ),
    o && /* @__PURE__ */ D.jsx(wG, { contactConsents: _ })
  ] });
}, Fy = (e, n) => `${e ? e.toFixed(2) : "0.00"} ${n}`, TG = "_list_zu4s7_1", RG = "_listItem_zu4s7_4", DG = "_listSum_zu4s7_7", Gs = {
  list: TG,
  listItem: RG,
  listSum: DG
}, OG = ({
  lineItems: e,
  localCurrency: n,
  localNetPriceSum: r
}) => /* @__PURE__ */ D.jsxs(Je, { className: Gs.list, children: [
  e?.map(({ quantity: i, article: a, localPrice: o, type: s }, l) => /* @__PURE__ */ D.jsx(Je.Text, { variant: "dense", className: Gs.listItem, children: /* @__PURE__ */ D.jsx(Ge, { content: s, children: /* @__PURE__ */ D.jsxs(b, { justifyContent: "space-between", gap: "200", children: [
    /* @__PURE__ */ D.jsxs(b, { flex: "0 0 auto", gap: "200", children: [
      /* @__PURE__ */ D.jsx(F.Paragraph, { variant: "4", children: i }),
      /* @__PURE__ */ D.jsx(F.Paragraph, { variant: "4", children: "×" })
    ] }),
    /* @__PURE__ */ D.jsx(b, { flex: "auto", children: /* @__PURE__ */ D.jsx(F.Paragraph, { variant: "4", children: a?.name }) }),
    o && n && /* @__PURE__ */ D.jsx(b, { flex: "0 0 auto", gap: "100", children: /* @__PURE__ */ D.jsx(F.Paragraph, { variant: "4", children: Fy(o, n) }) })
  ] }) }) }, l)),
  /* @__PURE__ */ D.jsx(
    Je.Text,
    {
      variant: "dense",
      className: ut(Gs.listItem, Gs.listSum),
      children: /* @__PURE__ */ D.jsxs(b, { gap: "100", justifyContent: "space-between", children: [
        /* @__PURE__ */ D.jsx(F.Paragraph, { variant: "3", children: "Sum" }),
        /* @__PURE__ */ D.jsx(F.Paragraph, { variant: "3", children: Fy(r, n) })
      ] })
    },
    "theSumOfItAll"
  )
] }), PG = "_transaction_1kr8d_1", AG = "_transactionIsOpen_1kr8d_9", LG = "_transactionHeader_1kr8d_12", VG = "_transactionHeaderSubLine_1kr8d_15", zG = "_transactionHeaderAlignItemRight_1kr8d_19", ua = {
  transaction: PG,
  transactionIsOpen: AG,
  transactionHeader: LG,
  transactionHeaderSubLine: VG,
  transactionHeaderAlignItemRight: zG
}, UG = ({
  transaction: e,
  openByDefault: n
}) => {
  const [r, i] = me(n), {
    transactionNumber: a,
    createdDate: o,
    storeName: s,
    numberOfItems: l,
    storeType: d,
    lineItems: m,
    localCurrency: u,
    localNetPriceSum: f
  } = e, h = u ?? "", v = f ?? 0, w = m?.length ? m : [];
  return /* @__PURE__ */ D.jsxs(
    b,
    {
      className: ut(ua.transaction, {
        [ua.transactionIsOpen]: r
      }),
      gap: "300",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ D.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: ua.transactionHeader,
            onClick: () => i(!r),
            "data-testid": "contact-transaction-header",
            children: [
              /* @__PURE__ */ D.jsxs(b, { style: { flexGrow: 1 }, children: [
                /* @__PURE__ */ D.jsxs(b, { flexDirection: "column", gap: "100", children: [
                  o && /* @__PURE__ */ D.jsx(Pn, { size: "small", variant: "info", children: Wn(o).format(It) }),
                  /* @__PURE__ */ D.jsxs(
                    F.Heading,
                    {
                      variant: "heading-4",
                      className: ua.transactionHeaderSubLine,
                      children: [
                        "ID: ",
                        a
                      ]
                    }
                  )
                ] }),
                /* @__PURE__ */ D.jsxs(
                  b,
                  {
                    flexDirection: "column",
                    gap: "100",
                    className: ua.transactionHeaderAlignItemRight,
                    children: [
                      /* @__PURE__ */ D.jsx(F.Heading, { variant: "heading-4", children: Fy(v, h) }),
                      /* @__PURE__ */ D.jsxs(
                        F.Heading,
                        {
                          variant: "heading-4",
                          className: ua.transactionHeaderSubLine,
                          children: [
                            l,
                            " line ",
                            `${l === 1 ? "item" : "items"}`
                          ]
                        }
                      )
                    ]
                  }
                )
              ] }),
              /* @__PURE__ */ D.jsx(b, { flexDirection: "column", children: /* @__PURE__ */ D.jsx(
                Xt,
                {
                  variant: "tertiary",
                  icon: r ? "angle-up" : "angle-down"
                }
              ) })
            ]
          }
        ),
        r && /* @__PURE__ */ D.jsxs(
          b,
          {
            gap: "300",
            flexDirection: "column",
            "data-testid": "contact-transaction-content",
            children: [
              /* @__PURE__ */ D.jsx(Wl, {}),
              /* @__PURE__ */ D.jsxs(b, { gap: "100", flexDirection: "column", children: [
                s && /* @__PURE__ */ D.jsx(F.Heading, { variant: "heading-2", children: s }),
                d && /* @__PURE__ */ D.jsx(Jn, { children: /* @__PURE__ */ D.jsx(b, { alignItems: "center", children: d }) }),
                /* @__PURE__ */ D.jsx(
                  OG,
                  {
                    lineItems: w,
                    localCurrency: h,
                    localNetPriceSum: v
                  }
                )
              ] })
            ]
          }
        )
      ]
    }
  );
}, MG = ({
  contactId: e
}) => {
  const {
    isLoading: n,
    error: r,
    transactions: i
  } = dG({ contactId: e });
  if (!e)
    return null;
  const { items: a, totalCount: o } = i, s = o ?? 0;
  return r ? /* @__PURE__ */ D.jsx($n, { error: r }) : /* @__PURE__ */ D.jsxs(
    b,
    {
      gap: "200",
      flexDirection: "column",
      "data-testid": "contact-transactions-wrapper",
      children: [
        /* @__PURE__ */ D.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
          /* @__PURE__ */ D.jsx(F.Heading, { variant: "heading-3", children: "Transactions" }),
          !n && s > 0 && /* @__PURE__ */ D.jsx(Pn, { size: "small", variant: "success", children: s })
        ] }),
        n ? /* @__PURE__ */ D.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ D.jsx(sn, {}) }) : /* @__PURE__ */ D.jsxs(D.Fragment, { children: [
          s === 0 && /* @__PURE__ */ D.jsx(b, { justifyContent: "center", padding: "200", children: /* @__PURE__ */ D.jsx(F.Paragraph, { variant: "4", color: "secondary", children: "There are no transactions for this contact" }) }),
          s > 0 && a?.map((l, d) => /* @__PURE__ */ D.jsx(
            UG,
            {
              transaction: l,
              openByDefault: d === 0
            },
            d
          ))
        ] })
      ]
    }
  );
}, BG = "_message_4z55u_54", qG = "_messageIsOpen_4z55u_62", HG = "_messageHeader_4z55u_66", WG = "_messageText_4z55u_70", KG = "_buttonLink_4z55u_93", No = {
  message: BG,
  messageIsOpen: qG,
  messageHeader: HG,
  messageText: WG,
  buttonLink: KG
}, Mh = {
  status: {
    Delivered: "check-circle",
    Waiting: "clock",
    Hardbounce: "close-circle-filled",
    Softbounce: "close"
  },
  type: {
    EmailMessage: "mail",
    SmsMessage: "sms",
    PostalMessage: "paper-plane"
  },
  source: {
    Automation: "chat-bot",
    Manual: "user",
    System: "eye"
  }
}, Bh = (e, n) => n && e in Mh && n in Mh[e] ? Mh[e][n] : null, GG = ({
  message: e,
  openByDefault: n
}) => {
  const [r, i] = me(n), { track: a } = jn();
  if (!e)
    return null;
  const {
    name: o,
    sendDateTime: s,
    type: l,
    source: d,
    isTransactional: m,
    status: u,
    messageLink: f,
    messageText: h
  } = e, v = l ? Bh("type", l) : null, w = d ? Bh("source", d) : null, N = u ? Bh("status", u) : null, j = l?.replace("Message", "");
  return /* @__PURE__ */ D.jsxs(
    b,
    {
      className: ut(No.message, {
        [No.messageIsOpen]: r
      }),
      gap: "300",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ D.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: No.messageHeader,
            onClick: () => i(!r),
            children: [
              /* @__PURE__ */ D.jsxs(b, { gap: "100", flexDirection: "column", children: [
                /* @__PURE__ */ D.jsxs(b, { gap: "200", alignItems: "center", children: [
                  v && /* @__PURE__ */ D.jsxs(D.Fragment, { children: [
                    /* @__PURE__ */ D.jsx(fe, { name: v, size: 16 }),
                    " ",
                    j
                  ] }),
                  s && /* @__PURE__ */ D.jsx(Pn, { size: "small", variant: "info", children: Wn(s).format(It) })
                ] }),
                o
              ] }),
              /* @__PURE__ */ D.jsx(
                Xt,
                {
                  variant: "tertiary",
                  icon: r ? "angle-up" : "angle-down"
                }
              )
            ]
          }
        ),
        r && /* @__PURE__ */ D.jsxs(b, { gap: "300", flexDirection: "column", children: [
          /* @__PURE__ */ D.jsx(Wl, {}),
          /* @__PURE__ */ D.jsxs(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", children: [
            N && /* @__PURE__ */ D.jsx(Jn, { children: /* @__PURE__ */ D.jsxs(b, { alignItems: "center", gap: "200", children: [
              /* @__PURE__ */ D.jsx(fe, { name: N }),
              " ",
              u
            ] }) }),
            w && /* @__PURE__ */ D.jsx(Jn, { children: /* @__PURE__ */ D.jsxs(b, { alignItems: "center", gap: "200", children: [
              /* @__PURE__ */ D.jsx(fe, { name: w }),
              " ",
              d
            ] }) }),
            m && /* @__PURE__ */ D.jsx(Jn, { children: /* @__PURE__ */ D.jsxs(b, { alignItems: "center", gap: "200", children: [
              /* @__PURE__ */ D.jsx(fe, { name: "exchange" }),
              " Transactional"
            ] }) })
          ] }),
          /* @__PURE__ */ D.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ D.jsx(F.Paragraph, { variant: "4", color: "secondary", children: "Message text" }),
            /* @__PURE__ */ D.jsx(F.Paragraph, { variant: "4", className: No.messageText, children: h })
          ] }),
          f && /* @__PURE__ */ D.jsx(
            Et,
            {
              slotEnd: /* @__PURE__ */ D.jsx(fe, { name: "external-link" }),
              variant: "tertiary",
              className: No.buttonLink,
              navigate: () => {
                j && a("voyado:message:external-link:opened", {
                  channel: j.toUpperCase()
                }), window.open(f, "_blank")?.focus();
              },
              children: "Open message in new tab"
            }
          )
        ] })
      ]
    }
  );
}, YG = ({
  contactId: e
}) => {
  const {
    isLoading: n,
    error: r,
    lastMessages: i
  } = lG({ contactId: e });
  if (!e)
    return null;
  if (r)
    return /* @__PURE__ */ D.jsx($n, { error: r });
  const { count: a, items: o } = i, s = (a && a) ?? 0, l = s > 0;
  return /* @__PURE__ */ D.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ D.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ D.jsx(F.Heading, { variant: "heading-3", children: "Last Messages" }),
      !n && l && /* @__PURE__ */ D.jsx(Pn, { variant: "success", size: "small", children: s })
    ] }),
    /* @__PURE__ */ D.jsx(b, { gap: "200", flexDirection: "column", children: n ? /* @__PURE__ */ D.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ D.jsx(sn, {}) }) : /* @__PURE__ */ D.jsxs(D.Fragment, { children: [
      l && o?.map((d, m) => /* @__PURE__ */ D.jsx(
        GG,
        {
          message: d || void 0,
          openByDefault: m === 0
        },
        m
      )),
      !l && /* @__PURE__ */ D.jsx(b, { justifyContent: "center", margin: "200", children: /* @__PURE__ */ D.jsx(F.Paragraph, { variant: "4", color: "secondary", children: "No messages available" }) })
    ] }) })
  ] });
}, kc = ({
  value: e,
  currencyCode: n
}) => `${Number.parseFloat((e ?? 0).toString()).toFixed(2)} ${n ?? ""}`, hw = ({
  labelText: e,
  address: n,
  icon: r = "home"
}) => {
  const { isCopied: i, copy: a } = ml(), o = [n?.title, n?.firstname, n?.lastname].filter(Boolean).join(" "), s = pt(() => [
    o,
    n?.streetAddress,
    n?.streetAddress2,
    n?.postalCode,
    n?.region,
    n?.city,
    n?.country
  ].filter(Boolean).join(`
`), [n, o]);
  if (!n)
    return null;
  const l = 14;
  return /* @__PURE__ */ D.jsxs(b, { justifyContent: "space-between", children: [
    /* @__PURE__ */ D.jsxs(b, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ D.jsx(fe, { size: l, name: r, color: "green.500" }),
      /* @__PURE__ */ D.jsxs(b, { gap: "200", flexDirection: "column", children: [
        /* @__PURE__ */ D.jsx(F.Paragraph, { variant: "3", children: e }),
        /* @__PURE__ */ D.jsxs(b, { gap: "100", flexDirection: "column", children: [
          o && /* @__PURE__ */ D.jsx(F.Paragraph, { variant: "4", children: o }),
          n?.streetAddress && /* @__PURE__ */ D.jsx(F.Paragraph, { variant: "4", children: n.streetAddress }),
          n?.streetAddress2 && /* @__PURE__ */ D.jsx(F.Paragraph, { variant: "4", children: n.streetAddress2 }),
          n?.postalCode && /* @__PURE__ */ D.jsx(F.Paragraph, { variant: "4", children: n?.postalCode }),
          n?.region && /* @__PURE__ */ D.jsx(F.Paragraph, { variant: "4", children: n.region }),
          n?.city && /* @__PURE__ */ D.jsx(F.Paragraph, { variant: "4", children: n.city }),
          n?.country && /* @__PURE__ */ D.jsx(F.Paragraph, { variant: "4", children: n.country })
        ] })
      ] })
    ] }),
    /* @__PURE__ */ D.jsx(Ge, { content: `Copy ${e.toLowerCase()}`, children: /* @__PURE__ */ D.jsx(
      fe,
      {
        size: l,
        name: i ? "done" : "copy",
        onClick: () => a(s()),
        className: ft.pointer
      }
    ) })
  ] });
}, JG = "_order_19t4p_1", QG = "_orderIsOpen_19t4p_9", XG = "_orderHeader_19t4p_12", ZG = "_orderIconColor_19t4p_15", Ur = {
  order: JG,
  orderIsOpen: QG,
  orderHeader: XG,
  orderIconColor: ZG
}, e8 = "_delivery_1m9nb_1", n8 = "_deliveryCode_1m9nb_4", qh = {
  delivery: e8,
  deliveryCode: n8
}, t8 = ({
  delivery: e
}) => {
  const { isCopied: n, copy: r } = Qt();
  if (!e)
    return null;
  const { method: i, trackingNumber: a, trackingUri: o, deliveryDate: s } = e, l = 14;
  return /* @__PURE__ */ D.jsxs(b, { gap: "250", flexDirection: "row", children: [
    /* @__PURE__ */ D.jsx(
      fe,
      {
        size: l,
        name: "eye",
        className: Ur.orderIconColor
      }
    ),
    /* @__PURE__ */ D.jsxs(b, { flexDirection: "column", gap: "200", width: "100%", children: [
      /* @__PURE__ */ D.jsx(F.Paragraph, { variant: "3", children: "Delivery" }),
      /* @__PURE__ */ D.jsx(
        Ge,
        {
          content: /* @__PURE__ */ D.jsxs(F.Paragraph, { variant: "4", color: "inherit", children: [
            "Arrives: ",
            Wn(s).format(It)
          ] }),
          children: /* @__PURE__ */ D.jsxs(b, { gap: "100", flexDirection: "column", children: [
            o ? /* @__PURE__ */ D.jsx(
              F.ExternalLink,
              {
                href: o,
                target: "_blank",
                rel: "noreferrer",
                children: /* @__PURE__ */ D.jsxs(
                  b,
                  {
                    gap: "100",
                    alignItems: "center",
                    className: qh.delivery,
                    children: [
                      /* @__PURE__ */ D.jsx(fe, { name: "external-link", size: l }),
                      i
                    ]
                  }
                )
              }
            ) : i,
            /* @__PURE__ */ D.jsx(
              F.Paragraph,
              {
                variant: "4",
                className: ut(qh.delivery, qh.deliveryCode),
                children: a
              }
            )
          ] })
        }
      )
    ] }),
    a && /* @__PURE__ */ D.jsx(Ge, { content: "Copy tracking code", children: /* @__PURE__ */ D.jsx(
      fe,
      {
        size: l,
        name: n ? "done" : "copy",
        onClick: () => r(a.toString()),
        className: ft.pointer
      }
    ) })
  ] });
}, r8 = ({
  fees: e,
  currencyCode: n
}) => {
  if (!e)
    return null;
  const r = e?.items ?? [];
  return /* @__PURE__ */ D.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ D.jsxs(b, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ D.jsx(
        fe,
        {
          size: 14,
          name: "file-text",
          className: Ur.orderIconColor
        }
      ),
      /* @__PURE__ */ D.jsx(F.Paragraph, { variant: "3", children: "Fees" })
    ] }),
    /* @__PURE__ */ D.jsx(Je, { className: ft.list, children: r?.map((i, a) => /* @__PURE__ */ D.jsx(Je.Item, { className: ft.listItem, children: /* @__PURE__ */ D.jsxs(
      b,
      {
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%",
        children: [
          /* @__PURE__ */ D.jsxs(b, { flexDirection: "column", gap: "100", children: [
            /* @__PURE__ */ D.jsx(F.Paragraph, { variant: "5", children: i?.type }),
            /* @__PURE__ */ D.jsx(F.Paragraph, { variant: "4", children: i?.description })
          ] }),
          /* @__PURE__ */ D.jsx(b, { flexDirection: "column", gap: "100", children: i?.taxes?.items?.map((o, s) => /* @__PURE__ */ D.jsxs(
            b,
            {
              gap: "100",
              flexDirection: "column",
              className: ft.listItemAlignRight,
              children: [
                /* @__PURE__ */ D.jsx(F.Paragraph, { variant: "5", children: `${o?.description} ${o?.percent}%` }),
                /* @__PURE__ */ D.jsx(F.Paragraph, { variant: "4", children: kc({ value: o?.amount, currencyCode: n }) })
              ]
            },
            `tax-${s}`
          )) })
        ]
      }
    ) }, `fees-${a}`)) })
  ] });
}, i8 = ({
  lineItems: e,
  currencyCode: n
}) => {
  if (!e)
    return null;
  const r = e?.items ?? [];
  return /* @__PURE__ */ D.jsxs(b, { gap: "100", flexDirection: "column", children: [
    /* @__PURE__ */ D.jsxs(b, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ D.jsx(
        fe,
        {
          size: 14,
          name: "tag",
          className: Ur.orderIconColor
        }
      ),
      /* @__PURE__ */ D.jsx(F.Paragraph, { variant: "3", children: "Line items" })
    ] }),
    /* @__PURE__ */ D.jsx(Je, { className: ft.list, children: r?.map((i) => /* @__PURE__ */ D.jsx(
      Je.Item,
      {
        className: ft.listItem,
        contentLeft: /* @__PURE__ */ D.jsxs(b, { gap: "200", children: [
          /* @__PURE__ */ D.jsx(F.Paragraph, { variant: "4", children: i?.quantity }),
          /* @__PURE__ */ D.jsx(F.Paragraph, { variant: "4", children: "×" })
        ] }),
        title: /* @__PURE__ */ D.jsx(
          Ge,
          {
            content: /* @__PURE__ */ D.jsx(F.Paragraph, { variant: "3", color: "inherit", children: i?.article?.sku }),
            children: /* @__PURE__ */ D.jsxs(b, { gap: "100", flexDirection: "column", children: [
              /* @__PURE__ */ D.jsx(F.Paragraph, { variant: "4", children: i?.article?.name }),
              /* @__PURE__ */ D.jsx(b, { children: /* @__PURE__ */ D.jsx(Pn, { size: "small", variant: "info", children: kc({
                value: i?.totalPrice,
                currencyCode: n
              }) }) })
            ] })
          }
        ),
        contentRight: i?.article?.imageUri && /* @__PURE__ */ D.jsx(
          Ia,
          {
            src: i?.article?.imageUri,
            alt: i?.article?.name,
            style: { height: "48px" }
          }
        )
      },
      `list-${i?.id}`
    )) })
  ] });
}, a8 = ({
  payments: e,
  currencyCode: n
}) => {
  if (!e)
    return null;
  const r = e?.items ?? [];
  return /* @__PURE__ */ D.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ D.jsxs(b, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ D.jsx(
        fe,
        {
          size: 14,
          name: "credit-card",
          className: Ur.orderIconColor
        }
      ),
      /* @__PURE__ */ D.jsx(F.Paragraph, { variant: "3", children: "Payment methods" })
    ] }),
    /* @__PURE__ */ D.jsx(Je, { className: ft.list, children: r?.map((i, a) => /* @__PURE__ */ D.jsx(
      Je.Item,
      {
        className: ft.listItem,
        children: /* @__PURE__ */ D.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
            children: [
              /* @__PURE__ */ D.jsxs(b, { flexDirection: "column", gap: "100", children: [
                /* @__PURE__ */ D.jsx(F.Paragraph, { variant: "5", children: i?.description }),
                /* @__PURE__ */ D.jsx(F.Paragraph, { variant: "4", children: i?.method })
              ] }),
              /* @__PURE__ */ D.jsxs(
                b,
                {
                  gap: "100",
                  flexDirection: "column",
                  className: ft.listItemAlignRight,
                  children: [
                    /* @__PURE__ */ D.jsx(F.Paragraph, { variant: "5", children: Wn(i?.paidAt).format(It) }),
                    /* @__PURE__ */ D.jsx(F.Paragraph, { variant: "4", children: kc({ value: i?.amount, currencyCode: n }) })
                  ]
                }
              )
            ]
          }
        )
      },
      `payments-${a}`
    )) })
  ] });
}, o8 = ({
  order: e,
  openByDefault: n
}) => {
  const [r, i] = me(n);
  if (!e)
    return null;
  const {
    orderId: a,
    status: o,
    externalStatus: s,
    currencyCode: l,
    channel: d,
    createdAt: m,
    lastChangedAt: u,
    lineItems: f,
    billingAddress: h,
    deliveryAddress: v,
    totalPrice: w
  } = e, N = 14;
  return /* @__PURE__ */ D.jsxs(
    b,
    {
      className: ut(Ur.order, {
        [Ur.orderIsOpen]: r
      }),
      gap: "200",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ D.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: Ur.orderHeader,
            onClick: () => i(!r),
            children: [
              /* @__PURE__ */ D.jsxs(b, { gap: "100", flexDirection: "column", children: [
                m && /* @__PURE__ */ D.jsx(b, { alignItems: "center", children: /* @__PURE__ */ D.jsx(F.Paragraph, { variant: "4", children: Wn(m).format(It) }) }),
                /* @__PURE__ */ D.jsx(F.Paragraph, { variant: "1", children: a })
              ] }),
              /* @__PURE__ */ D.jsx(
                Xt,
                {
                  variant: "tertiary",
                  icon: r ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        r && /* @__PURE__ */ D.jsxs(b, { gap: "250", flexDirection: "column", margin: "200 0 0", children: [
          /* @__PURE__ */ D.jsxs(b, { gap: "250", children: [
            /* @__PURE__ */ D.jsx(
              fe,
              {
                size: N,
                name: "activity",
                className: Ur.orderIconColor
              }
            ),
            /* @__PURE__ */ D.jsxs(b, { flexDirection: "column", gap: "200", children: [
              /* @__PURE__ */ D.jsx(F.Paragraph, { variant: "3", children: "Order status" }),
              /* @__PURE__ */ D.jsxs(b, { gap: "100", alignItems: "center", flexWrap: "wrap", children: [
                o && /* @__PURE__ */ D.jsx(Ge, { content: "Internal status", children: /* @__PURE__ */ D.jsx(Pn, { size: "small", variant: "info", children: /* @__PURE__ */ D.jsx(D.Fragment, { children: o }) }) }),
                s && /* @__PURE__ */ D.jsx(Ge, { content: "External status", children: /* @__PURE__ */ D.jsx(Pn, { size: "small", variant: "info", children: /* @__PURE__ */ D.jsx(D.Fragment, { children: s }) }) }),
                /* @__PURE__ */ D.jsx(Ge, { content: "Last updated at", children: /* @__PURE__ */ D.jsx(F.Paragraph, { as: "span", variant: "5", children: Wn(u).format(It) }) })
              ] })
            ] })
          ] }),
          /* @__PURE__ */ D.jsxs(b, { gap: "250", children: [
            /* @__PURE__ */ D.jsx(
              fe,
              {
                size: N,
                name: "chart-bar",
                className: Ur.orderIconColor
              }
            ),
            /* @__PURE__ */ D.jsxs(b, { flexDirection: "column", gap: "200", children: [
              /* @__PURE__ */ D.jsx(F.Paragraph, { variant: "3", children: "Order value" }),
              /* @__PURE__ */ D.jsx(F.Paragraph, { variant: "4", children: kc({
                value: w,
                currencyCode: l
              }) })
            ] })
          ] }),
          d && /* @__PURE__ */ D.jsxs(b, { gap: "250", children: [
            /* @__PURE__ */ D.jsx(
              fe,
              {
                size: N,
                name: "channels",
                className: Ur.orderIconColor
              }
            ),
            /* @__PURE__ */ D.jsxs(b, { flexDirection: "column", gap: "200", children: [
              /* @__PURE__ */ D.jsx(F.Paragraph, { variant: "3", children: "Channel" }),
              /* @__PURE__ */ D.jsx(F.Paragraph, { variant: "4", children: /* @__PURE__ */ D.jsx(Pn, { size: "small", variant: "info", children: /* @__PURE__ */ D.jsx(D.Fragment, { children: d }) }) })
            ] })
          ] }),
          /* @__PURE__ */ D.jsx(hw, { labelText: "Billing address", address: h }),
          /* @__PURE__ */ D.jsx(
            hw,
            {
              icon: "map-pin",
              labelText: "Delivery address",
              address: v
            }
          ),
          /* @__PURE__ */ D.jsx(t8, { delivery: e.delivery }),
          /* @__PURE__ */ D.jsx(i8, { lineItems: f, currencyCode: l }),
          /* @__PURE__ */ D.jsx(r8, { fees: e.fees, currencyCode: l }),
          /* @__PURE__ */ D.jsx(
            a8,
            {
              payments: e.payments,
              currencyCode: l
            }
          )
        ] })
      ]
    }
  );
}, s8 = ({
  error: e,
  itemCount: n,
  children: r
}) => e ? n === 0 || Fa({
  errors: e.graphQLErrors
}) ? /* @__PURE__ */ D.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ D.jsx(F.Paragraph, { variant: "4", color: "secondary", children: "There are no orders for this contact" }) }) : /* @__PURE__ */ D.jsx($n, { error: e }) : /* @__PURE__ */ D.jsx(D.Fragment, { children: r }), l8 = ({
  contactId: e
}) => {
  const { useQuery: n } = fn(), [r, i] = me([]), { track: a } = jn(), {
    loading: o,
    error: s,
    data: l
  } = n(tG, {
    skip: !e,
    variables: {
      contactId: e
    }
  });
  return Xe(() => {
    if (l?.Voyado) {
      const d = l?.Voyado.Orders_GetAllByContact;
      if (!o && d?.items) {
        i(d.items);
        const { totalCount: m } = d;
        m && a("voyado:orders:received", { count: m });
      }
    }
  }, [l?.Voyado]), e ? /* @__PURE__ */ D.jsxs(b, { gap: "200", flexDirection: "column", margin: "200 0 300 0", children: [
    /* @__PURE__ */ D.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ D.jsx(F.Heading, { variant: "heading-3", children: "Orders" }),
      r.length > 0 && /* @__PURE__ */ D.jsx(Pn, { size: "small", variant: "success", children: r.length })
    ] }),
    o ? /* @__PURE__ */ D.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ D.jsx(sn, {}) }) : /* @__PURE__ */ D.jsx(s8, { error: s, itemCount: r.length, children: r.map((d, m) => /* @__PURE__ */ D.jsx(
      o8,
      {
        order: d,
        openByDefault: m === 0
      },
      m
    )) })
  ] }) : null;
}, c8 = ({
  conversationContext: e,
  settings: n
}) => {
  const { isLoading: r, contactId: i, hasMultipleContacts: a, error: o } = uG({
    conversationContext: e
  }), s = !e?.customer?.email && !e?.customer?.phone_number, l = !!i, {
    showCustomerAttributes: d,
    showPreferences: m,
    showAudiences: u,
    showConsents: f,
    showLastMessages: h,
    showCustomerTransactions: v,
    showOrders: w
  } = n;
  return s ? /* @__PURE__ */ D.jsx(
    b,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      "data-testid": "widget-no-contact-message",
      children: /* @__PURE__ */ D.jsx(F.Paragraph, { variant: "4", color: "secondary", children: "No email nor phone number are available in this conversation to look up a profile." })
    }
  ) : a ? /* @__PURE__ */ D.jsx(
    b,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      "data-testid": "multiple-contacts-found-message",
      children: /* @__PURE__ */ D.jsx(F.Paragraph, { variant: "4", color: "secondary", children: "We found multiple profile IDs that match your email or phone number. To display customer informations, we need a unique profile id. Please make sure that the customers data is normalized." })
    }
  ) : o ? Fa({
    errors: o.graphQLErrors
  }) ? /* @__PURE__ */ D.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ D.jsx(F.Paragraph, { variant: "4", color: "secondary", children: "No profile found" }) }) : /* @__PURE__ */ D.jsx($n, { error: o }) : !d && !m && !u && !f && !h && !v ? /* @__PURE__ */ D.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ D.jsx(F.Paragraph, { variant: "4", color: "secondary", children: "All features toggles in the widget settings are disabled." }) }) : r ? /* @__PURE__ */ D.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ D.jsx(sn, {}) }) : /* @__PURE__ */ D.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300 0",
      "data-testid": "widget-wrapper",
      children: [
        /* @__PURE__ */ D.jsx(EG, { contactId: i, settings: n }),
        h && /* @__PURE__ */ D.jsx(YG, { contactId: i }),
        v && /* @__PURE__ */ D.jsx(MG, { contactId: i }),
        w && /* @__PURE__ */ D.jsx(l8, { contactId: i }),
        !l && /* @__PURE__ */ D.jsx(b, { justifyContent: "center", padding: "200", children: /* @__PURE__ */ D.jsx(F.Paragraph, { variant: "4", color: "secondary", children: "No contact found." }) })
      ]
    }
  );
}, zl = [
  {
    key: "voyadoApiKey",
    label: "API key",
    type: "string",
    secret: !0,
    defaultValue: ""
  },
  {
    key: "apiHostName",
    label: "API URL",
    type: "string",
    secret: !1,
    defaultValue: ""
  },
  {
    key: "showCustomerAttributes",
    label: "Show the customer attributes",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showPreferences",
    label: "Show preferences",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showAudiences",
    label: "Show audiences",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showConsents",
    label: "Show consents",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showLastMessages",
    label: "Show the last 5 messages",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showCustomerTransactions",
    label: "Show customer transactions",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showOrders",
    label: "Show orders by contact",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showMemberLevel",
    label: "Show member level",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  }
], Lr = ar(zl), d8 = {
  enabled: !1,
  name: "",
  voyadoApiKey: "",
  apiHostName: "",
  showCustomerAttributes: !0,
  showPreferences: !0,
  showAudiences: !0,
  showConsents: !0,
  showLastMessages: !0,
  showCustomerTransactions: !0,
  showOrders: !0,
  showMemberLevel: !0
}, u8 = ({
  integrationId: e,
  handleRedirect: n,
  showNotification: r,
  automationCouplingState: i,
  renderConditionsEditor: a
}) => {
  const o = !e, s = ot({
    mode: "onChange",
    defaultValues: d8
  }), {
    create: l,
    update: d,
    remove: m,
    isLoading: u,
    error: f,
    misconfigurationCause: h,
    setMisconfigurationCause: v
  } = pr({
    integrationId: e,
    integrationType: "VOYADO",
    handleRedirect: n,
    showNotification: r
  }), {
    isLoading: w,
    error: N,
    isWidgetUnknown: j,
    refetch: _,
    widgetConfiguration: g
  } = fr({
    integrationId: e,
    fieldDefinitions: zl,
    form: s,
    onMisconfigured: v
  }), { renderConditions: O, setRenderConditions: R, renderConditionsForSubmit: $ } = hr({
    integrationId: e,
    widgetConfiguration: g,
    renderConditionsEditor: a
  }), I = (G) => gr(G, {
    fieldDefinitions: zl,
    isCreationMode: o,
    create: l,
    update: d,
    renderConditions: $
  }), L = s.watch("name");
  return /* @__PURE__ */ D.jsxs(
    yr,
    {
      form: s,
      integrationId: e,
      onValidSubmit: I,
      error: N ?? f,
      onRetry: N ? _ : void 0,
      isLoading: u || w,
      isWidgetUnknown: j,
      children: [
        h && /* @__PURE__ */ D.jsx(vr, { cause: h }),
        /* @__PURE__ */ D.jsxs(et, { children: [
          /* @__PURE__ */ D.jsx(Z, { children: /* @__PURE__ */ D.jsx(qe, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ D.jsx(
            yn,
            {
              name: "enabled",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ D.jsx(Z, { span: 3, children: /* @__PURE__ */ D.jsx(
            Rn,
            {
              name: "name",
              label: "Widget name",
              control: s.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ D.jsx(Z, { span: 3 }),
          /* @__PURE__ */ D.jsx(Z, { span: 3, children: /* @__PURE__ */ D.jsx(
            Er,
            {
              name: "voyadoApiKey",
              label: Lr.voyadoApiKey,
              control: s.control,
              isCreationMode: o,
              rules: { required: "API key is required" },
              componentProps: {
                placeholder: "API key from Voyado",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ D.jsx(Z, { span: 3 }),
          /* @__PURE__ */ D.jsx(Z, { span: 3, children: /* @__PURE__ */ D.jsx(
            Rn,
            {
              name: "apiHostName",
              label: Lr.apiHostName,
              control: s.control,
              rules: { required: "API URL is required" },
              componentProps: {
                placeholder: "The URL of the Voyado API",
                autoComplete: "off",
                prefix: "https://"
              }
            }
          ) }),
          /* @__PURE__ */ D.jsx(Z, { span: 3 }),
          /* @__PURE__ */ D.jsx(Z, { span: 3, children: /* @__PURE__ */ D.jsx(qe, { label: Lr.showCustomerAttributes, children: /* @__PURE__ */ D.jsx(
            yn,
            {
              name: "showCustomerAttributes",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ D.jsx(Z, { span: 3 }),
          /* @__PURE__ */ D.jsx(Z, { span: 3, children: /* @__PURE__ */ D.jsx(qe, { label: Lr.showPreferences, children: /* @__PURE__ */ D.jsx(
            yn,
            {
              name: "showPreferences",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ D.jsx(Z, { span: 3 }),
          /* @__PURE__ */ D.jsx(Z, { span: 3, children: /* @__PURE__ */ D.jsx(qe, { label: Lr.showAudiences, children: /* @__PURE__ */ D.jsx(
            yn,
            {
              name: "showAudiences",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ D.jsx(Z, { span: 3 }),
          /* @__PURE__ */ D.jsx(Z, { span: 3, children: /* @__PURE__ */ D.jsx(qe, { label: Lr.showConsents, children: /* @__PURE__ */ D.jsx(
            yn,
            {
              name: "showConsents",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ D.jsx(Z, { span: 3 }),
          /* @__PURE__ */ D.jsx(Z, { span: 3, children: /* @__PURE__ */ D.jsx(qe, { label: Lr.showLastMessages, children: /* @__PURE__ */ D.jsx(
            yn,
            {
              name: "showLastMessages",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ D.jsx(Z, { span: 3 }),
          /* @__PURE__ */ D.jsx(Z, { span: 3, children: /* @__PURE__ */ D.jsx(qe, { label: Lr.showCustomerTransactions, children: /* @__PURE__ */ D.jsx(
            yn,
            {
              name: "showCustomerTransactions",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ D.jsx(Z, { span: 3 }),
          /* @__PURE__ */ D.jsx(Z, { span: 3, children: /* @__PURE__ */ D.jsx(qe, { label: Lr.showOrders, children: /* @__PURE__ */ D.jsx(
            yn,
            {
              name: "showOrders",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ D.jsx(Z, { span: 3 }),
          /* @__PURE__ */ D.jsx(Z, { span: 3, children: /* @__PURE__ */ D.jsx(qe, { label: Lr.showMemberLevel, children: /* @__PURE__ */ D.jsx(
            yn,
            {
              name: "showMemberLevel",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ D.jsx(Z, { span: 3 }),
          a && O !== null && /* @__PURE__ */ D.jsx(Z, { children: a({
            value: O,
            onChange: R,
            configurationKey: g?.id
          }) })
        ] }),
        /* @__PURE__ */ D.jsx(
          kr,
          {
            integrationType: "VOYADO",
            integrationId: e,
            widgetName: L,
            isCreationMode: o,
            isSubmitting: s.formState.isSubmitting,
            automationCouplingState: i,
            onConfirmDelete: () => m()
          }
        )
      ]
    }
  );
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode('@charset "UTF-8";._copyIcon_1pfts_54{cursor:pointer;color:var(--dixa-typography-color-secondary)}._list_1pfts_59{padding:0;overflow-y:auto;max-height:230px;background:linear-gradient(var(--dixa-color-neutral-000) 33%,rgba(255,255,255,0)),linear-gradient(rgba(255,255,255,0),var(--dixa-color-neutral-000) 66%) 0 100%,radial-gradient(farthest-side at 50% 0,var(--dixa-color-neutral-200),rgba(0,0,0,0)),radial-gradient(farthest-side at 50% 100%,var(--dixa-color-neutral-200),rgba(0,0,0,0)) 0 100%;background-color:var(--dixa-color-neutral-000);background-repeat:no-repeat;background-attachment:local,local,scroll,scroll;background-size:100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-200),100% var(--dixa-size-spacer-200)}._listItem_1pfts_69{cursor:pointer;background-color:transparent;padding:var(--dixa-size-spacer-100);box-shadow:inset 0 calc(-1 * var(--dixa-size-border-100)) 0 var(--dixa-color-neutral-200)}._listItem_1pfts_69:last-child{box-shadow:none}._listItemHighlighted_1pfts_78{border-left:8px solid var(--dixa-color-orange-300)}._wrapper_1xucg_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._externalLink_1xucg_7{color:var(--dixa-typography-color-primary);font-size:var(--dixa-typography-size-200)}._settingsWrapper_1ycvy_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);margin-bottom:var(--dixa-size-spacer-300)}._settingsWrapperHeader_1ycvy_6{cursor:pointer;padding:var(--dixa-size-spacer-300)}._settingsWrapperContent_1ycvy_10{border-top:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);padding:var(--dixa-size-spacer-300);line-height:var(--dixa-typography-line-height-400)}._settingsWrapperContent_1ycvy_10 ol{margin-bottom:0}._settingsWrapperContentCode_1ycvy_18{background-color:var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-100);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);font-family:var(--dixa-typography-family-code);font-size:var(--dixa-typography-size-200)}._settingsWrapperContentCURL_1ycvy_26{overflow:auto;padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-300);font-family:var(--dixa-typography-family-code);color:var(--dixa-typography-color-secondary);background-color:var(--dixa-color-neutral-100);border-radius:var(--dixa-size-border-radius-100);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300)}')), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Hh = { exports: {} }, jo = {}, yw;
function m8() {
  if (yw) return jo;
  yw = 1;
  var e = He, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (v = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return jo.Fragment = r, jo.jsx = s, jo.jsxs = s, jo;
}
var Ys = {}, gw;
function p8() {
  return gw || (gw = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = He, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), d = /* @__PURE__ */ Symbol.for("react.forward_ref"), m = /* @__PURE__ */ Symbol.for("react.suspense"), u = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), v = /* @__PURE__ */ Symbol.for("react.offscreen"), w = Symbol.iterator, N = "@@iterator";
    function j(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = w && t[w] || t[N];
      return typeof c == "function" ? c : null;
    }
    var _ = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          p[y - 1] = arguments[y];
        O("error", t, p);
      }
    }
    function O(t, c, p) {
      {
        var y = _.ReactDebugCurrentFrame, C = y.getStackAddendum();
        C !== "" && (c += "%s", p = p.concat([C]));
        var T = p.map(function(S) {
          return String(S);
        });
        T.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, T);
      }
    }
    var R = !1, $ = !1, I = !1, L = !1, G = !1, Q;
    Q = /* @__PURE__ */ Symbol.for("react.module.reference");
    function ne(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || G || t === a || t === m || t === u || L || t === v || R || $ || I || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Q || t.getModuleId !== void 0));
    }
    function q(t, c, p) {
      var y = t.displayName;
      if (y)
        return y;
      var C = c.displayName || c.name || "";
      return C !== "" ? p + "(" + C + ")" : p;
    }
    function Y(t) {
      return t.displayName || "Context";
    }
    function P(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return Y(c) + ".Consumer";
          case s:
            var p = t;
            return Y(p._context) + ".Provider";
          case d:
            return q(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : P(t.type) || "Memo";
          case h: {
            var C = t, T = C._payload, S = C._init;
            try {
              return P(S(T));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var B = Object.assign, ie = 0, je, pe, le, ge, V, be, Oe;
    function H() {
    }
    H.__reactDisabledLog = !0;
    function Ye() {
      {
        if (ie === 0) {
          je = console.log, pe = console.info, le = console.warn, ge = console.error, V = console.group, be = console.groupCollapsed, Oe = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: H,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ie++;
      }
    }
    function ln() {
      {
        if (ie--, ie === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: B({}, t, {
              value: je
            }),
            info: B({}, t, {
              value: pe
            }),
            warn: B({}, t, {
              value: le
            }),
            error: B({}, t, {
              value: ge
            }),
            group: B({}, t, {
              value: V
            }),
            groupCollapsed: B({}, t, {
              value: be
            }),
            groupEnd: B({}, t, {
              value: Oe
            })
          });
        }
        ie < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Ie = _.ReactCurrentDispatcher, Ue;
    function De(t, c, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (C) {
            var y = C.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Be = !1, Ae;
    {
      var Qe = typeof WeakMap == "function" ? WeakMap : Map;
      Ae = new Qe();
    }
    function Ee(t, c) {
      if (!t || Be)
        return "";
      {
        var p = Ae.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Be = !0;
      var C = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var T;
      T = Ie.current, Ie.current = null, Ye();
      try {
        if (c) {
          var S = function() {
            throw Error();
          };
          if (Object.defineProperty(S.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(S, []);
            } catch (re) {
              y = re;
            }
            Reflect.construct(t, [], S);
          } else {
            try {
              S.call();
            } catch (re) {
              y = re;
            }
            t.call(S.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (re) {
            y = re;
          }
          t();
        }
      } catch (re) {
        if (re && y && typeof re.stack == "string") {
          for (var x = re.stack.split(`
`), ee = y.stack.split(`
`), A = x.length - 1, M = ee.length - 1; A >= 1 && M >= 0 && x[A] !== ee[M]; )
            M--;
          for (; A >= 1 && M >= 0; A--, M--)
            if (x[A] !== ee[M]) {
              if (A !== 1 || M !== 1)
                do
                  if (A--, M--, M < 0 || x[A] !== ee[M]) {
                    var ue = `
` + x[A].replace(" at new ", " at ");
                    return t.displayName && ue.includes("<anonymous>") && (ue = ue.replace("<anonymous>", t.displayName)), typeof t == "function" && Ae.set(t, ue), ue;
                  }
                while (A >= 1 && M >= 0);
              break;
            }
        }
      } finally {
        Be = !1, Ie.current = T, ln(), Error.prepareStackTrace = C;
      }
      var ze = t ? t.displayName || t.name : "", Te = ze ? De(ze) : "";
      return typeof t == "function" && Ae.set(t, Te), Te;
    }
    function Me(t, c, p) {
      return Ee(t, !1);
    }
    function en(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function se(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ee(t, en(t));
      if (typeof t == "string")
        return De(t);
      switch (t) {
        case m:
          return De("Suspense");
        case u:
          return De("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Me(t.render);
          case f:
            return se(t.type, c, p);
          case h: {
            var y = t, C = y._payload, T = y._init;
            try {
              return se(T(C), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var ce = Object.prototype.hasOwnProperty, Se = {}, Ve = _.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, p = se(t.type, t._source, c ? c.type : null);
        Ve.setExtraStackFrame(p);
      } else
        Ve.setExtraStackFrame(null);
    }
    function kn(t, c, p, y, C) {
      {
        var T = Function.call.bind(ce);
        for (var S in t)
          if (T(t, S)) {
            var x = void 0;
            try {
              if (typeof t[S] != "function") {
                var ee = Error((y || "React class") + ": " + p + " type `" + S + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[S] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ee.name = "Invariant Violation", ee;
              }
              x = t[S](c, S, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (A) {
              x = A;
            }
            x && !(x instanceof Error) && (Pe(C), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, S, typeof x), Pe(null)), x instanceof Error && !(x.message in Se) && (Se[x.message] = !0, Pe(C), g("Failed %s type: %s", p, x.message), Pe(null));
          }
      }
    }
    var X = Array.isArray;
    function E(t) {
      return X(t);
    }
    function z(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function ae(t) {
      try {
        return de(t), !1;
      } catch {
        return !0;
      }
    }
    function de(t) {
      return "" + t;
    }
    function U(t) {
      if (ae(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", z(t)), de(t);
    }
    var J = _.ReactCurrentOwner, ve = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, we, Re;
    function rn(t) {
      if (ce.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function bn(t) {
      if (ce.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function an(t, c) {
      typeof t.ref == "string" && J.current;
    }
    function hn(t, c) {
      {
        var p = function() {
          we || (we = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function En(t, c) {
      {
        var p = function() {
          Re || (Re = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var _n = function(t, c, p, y, C, T, S) {
      var x = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: S,
        // Record the component responsible for creating this element.
        _owner: T
      };
      return x._store = {}, Object.defineProperty(x._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(x, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(x, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: C
      }), Object.freeze && (Object.freeze(x.props), Object.freeze(x)), x;
    };
    function Fn(t, c, p, y, C) {
      {
        var T, S = {}, x = null, ee = null;
        p !== void 0 && (U(p), x = "" + p), bn(c) && (U(c.key), x = "" + c.key), rn(c) && (ee = c.ref, an(c));
        for (T in c)
          ce.call(c, T) && !ve.hasOwnProperty(T) && (S[T] = c[T]);
        if (t && t.defaultProps) {
          var A = t.defaultProps;
          for (T in A)
            S[T] === void 0 && (S[T] = A[T]);
        }
        if (x || ee) {
          var M = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          x && hn(S, M), ee && En(S, M);
        }
        return _n(t, x, ee, C, y, J.current, S);
      }
    }
    var Ze = _.ReactCurrentOwner, gn = _.ReactDebugCurrentFrame;
    function Le(t) {
      if (t) {
        var c = t._owner, p = se(t.type, t._source, c ? c.type : null);
        gn.setExtraStackFrame(p);
      } else
        gn.setExtraStackFrame(null);
    }
    var dn;
    dn = !1;
    function un(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function Nn() {
      {
        if (Ze.current) {
          var t = P(Ze.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Bn(t) {
      return "";
    }
    var Sn = {};
    function An(t) {
      {
        var c = Nn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function vn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = An(c);
        if (Sn[p])
          return;
        Sn[p] = !0;
        var y = "";
        t && t._owner && t._owner !== Ze.current && (y = " It was passed a child from " + P(t._owner.type) + "."), Le(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Le(null);
      }
    }
    function xn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (E(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            un(y) && vn(y, c);
          }
        else if (un(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var C = j(t);
          if (typeof C == "function" && C !== t.entries)
            for (var T = C.call(t), S; !(S = T.next()).done; )
              un(S.value) && vn(S.value, c);
        }
      }
    }
    function Ln(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var y = P(c);
          kn(p, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !dn) {
          dn = !0;
          var C = P(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", C || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var y = c[p];
          if (y !== "children" && y !== "key") {
            Le(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Le(null);
            break;
          }
        }
        t.ref !== null && (Le(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Le(null));
      }
    }
    var Cn = {};
    function wn(t, c, p, y, C, T) {
      {
        var S = ne(t);
        if (!S) {
          var x = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (x += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ee = Bn();
          ee ? x += ee : x += Nn();
          var A;
          t === null ? A = "null" : E(t) ? A = "array" : t !== void 0 && t.$$typeof === n ? (A = "<" + (P(t.type) || "Unknown") + " />", x = " Did you accidentally export a JSX literal instead of a component?") : A = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", A, x);
        }
        var M = Fn(t, c, p, C, T);
        if (M == null)
          return M;
        if (S) {
          var ue = c.children;
          if (ue !== void 0)
            if (y)
              if (E(ue)) {
                for (var ze = 0; ze < ue.length; ze++)
                  xn(ue[ze], t);
                Object.freeze && Object.freeze(ue);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              xn(ue, t);
        }
        if (ce.call(c, "key")) {
          var Te = P(t), re = Object.keys(c).filter(function(Gn) {
            return Gn !== "key";
          }), mn = re.length > 0 ? "{key: someKey, " + re.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Cn[Te + mn]) {
            var Dn = re.length > 0 ? "{" + re.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, mn, Te, Dn, Te), Cn[Te + mn] = !0;
          }
        }
        return t === i ? Vn(M) : Ln(M), M;
      }
    }
    function zn(t, c, p) {
      return wn(t, c, p, !0);
    }
    function qn(t, c, p) {
      return wn(t, c, p, !1);
    }
    var Un = qn, Kn = zn;
    Ys.Fragment = i, Ys.jsx = Un, Ys.jsxs = Kn;
  })()), Ys;
}
var vw;
function f8() {
  return vw || (vw = 1, process.env.NODE_ENV === "production" ? Hh.exports = m8() : Hh.exports = p8()), Hh.exports;
}
var Ne = f8();
const h8 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCustomerDetails" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "phone" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "limit" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "externalIds" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "storeId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "expand" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Yotpo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getCustomers" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "email" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }, { kind: "Argument", name: { kind: "Name", value: "phone_number" }, value: { kind: "Variable", name: { kind: "Name", value: "phone" } } }, { kind: "Argument", name: { kind: "Name", value: "limit" }, value: { kind: "Variable", name: { kind: "Name", value: "limit" } } }, { kind: "Argument", name: { kind: "Name", value: "external_ids" }, value: { kind: "Variable", name: { kind: "Name", value: "externalIds" } } }, { kind: "Argument", name: { kind: "Name", value: "store_id" }, value: { kind: "Variable", name: { kind: "Name", value: "storeId" } } }, { kind: "Argument", name: { kind: "Name", value: "expand" }, value: { kind: "Variable", name: { kind: "Name", value: "expand" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Yotpo_getCustomers_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Yotpo_Customers" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "customers" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "external_id" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "phone_number" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "gender" } }, { kind: "Field", name: { kind: "Name", value: "account_created_at" } }, { kind: "Field", name: { kind: "Name", value: "account_updated_at" } }, { kind: "Field", name: { kind: "Name", value: "default_language" } }, { kind: "Field", name: { kind: "Name", value: "dafault_currency" } }, { kind: "Field", name: { kind: "Name", value: "lists" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "since" } }] } }, { kind: "Field", name: { kind: "Name", value: "yotpo_ugc" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "total_reviews" } }, { kind: "Field", name: { kind: "Name", value: "avg_product_rating" } }, { kind: "Field", name: { kind: "Name", value: "avg_site_rating" } }, { kind: "Field", name: { kind: "Name", value: "total_avg_rating" } }, { kind: "Field", name: { kind: "Name", value: "sentiment_avg_product" } }, { kind: "Field", name: { kind: "Name", value: "sentiment_avg_site" } }, { kind: "Field", name: { kind: "Name", value: "total_avg_sentiment" } }, { kind: "Field", name: { kind: "Name", value: "top_topics" } }, { kind: "Field", name: { kind: "Name", value: "last_star_rating" } }, { kind: "Field", name: { kind: "Name", value: "last_review_date" } }, { kind: "Field", name: { kind: "Name", value: "last_sentiment" } }] } }, { kind: "Field", name: { kind: "Name", value: "yotpo_loyalty" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "points_earned" } }, { kind: "Field", name: { kind: "Name", value: "points_balance" } }, { kind: "Field", name: { kind: "Name", value: "last_seen_at" } }, { kind: "Field", name: { kind: "Name", value: "total_redemptions" } }, { kind: "Field", name: { kind: "Name", value: "total_points_redeemed" } }, { kind: "Field", name: { kind: "Name", value: "vip_tier_name" } }, { kind: "Field", name: { kind: "Name", value: "successful_referrals" } }, { kind: "Field", name: { kind: "Name", value: "referrals_made_and_clicked" } }, { kind: "Field", name: { kind: "Name", value: "is_referred_by_other_customer" } }, { kind: "Field", name: { kind: "Name", value: "points_expire_date" } }, { kind: "Field", name: { kind: "Name", value: "credit_balance_amount" } }, { kind: "Field", name: { kind: "Name", value: "credit_balance_customer_currency" } }, { kind: "Field", name: { kind: "Name", value: "is_opt_in" } }, { kind: "Field", name: { kind: "Name", value: "opt_in_date" } }, { kind: "Field", name: { kind: "Name", value: "opt_out_date" } }, { kind: "Field", name: { kind: "Name", value: "has_store_account" } }, { kind: "Field", name: { kind: "Name", value: "referred_by_customer" } }, { kind: "Field", name: { kind: "Name", value: "vip_entry_date" } }, { kind: "Field", name: { kind: "Name", value: "vip_expiration_date" } }, { kind: "Field", name: { kind: "Name", value: "next_points_expire_on" } }, { kind: "Field", name: { kind: "Name", value: "next_points_expire_amount" } }] } }, { kind: "Field", name: { kind: "Name", value: "yotpo_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "active_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "externalProductId" } }, { kind: "Field", name: { kind: "Name", value: "externalVariantId" } }] } }, { kind: "Field", name: { kind: "Name", value: "paused_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "externalProductId" } }, { kind: "Field", name: { kind: "Name", value: "externalVariantId" } }] } }, { kind: "Field", name: { kind: "Name", value: "failed_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "externalProductId" } }, { kind: "Field", name: { kind: "Name", value: "externalVariantId" } }] } }, { kind: "Field", name: { kind: "Name", value: "expired_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "externalProductId" } }, { kind: "Field", name: { kind: "Name", value: "externalVariantId" } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "externalProductId" } }, { kind: "Field", name: { kind: "Name", value: "externalVariantId" } }] } }] } }] } }] } }] } }] } }] } }] } }] }, y8 = {
  "\n  query getCustomerDetails(\n    $email: String\n    $phone: String\n    $limit: Int\n    $externalIds: String\n    $storeId: String!\n    $expand: String\n  ) {\n    Yotpo {\n      getCustomers(\n        email: $email\n        phone_number: $phone\n        limit: $limit\n        external_ids: $externalIds\n        store_id: $storeId\n        expand: $expand\n      ) {\n        ... on Yotpo_getCustomers_response {\n          ... on Yotpo_Customers {\n            customers {\n              external_id\n              email\n              phone_number\n              first_name\n              last_name\n              gender\n              account_created_at\n              account_updated_at\n              default_language\n              dafault_currency\n              lists {\n                id\n                since\n              }\n              yotpo_ugc {\n                total_reviews\n                avg_product_rating\n                avg_site_rating\n                total_avg_rating\n                sentiment_avg_product\n                sentiment_avg_site\n                total_avg_sentiment\n                top_topics\n                last_star_rating\n                last_review_date\n                last_sentiment\n              }\n              yotpo_loyalty {\n                points_earned\n                points_balance\n                last_seen_at\n                total_redemptions\n                total_points_redeemed\n                vip_tier_name\n                successful_referrals\n                referrals_made_and_clicked\n                is_referred_by_other_customer\n                points_expire_date\n                credit_balance_amount\n                credit_balance_customer_currency\n                is_opt_in\n                opt_in_date\n                opt_out_date\n                has_store_account\n                referred_by_customer\n                vip_entry_date\n                vip_expiration_date\n                next_points_expire_on\n                next_points_expire_amount\n              }\n              yotpo_subscriptions {\n                active_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n                paused_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n                failed_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n                expired_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n                canceled_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": h8
};
function g8(e) {
  return y8[e] ?? {};
}
const v8 = g8(
  /* GraphQL */
  `
  query getCustomerDetails(
    $email: String
    $phone: String
    $limit: Int
    $externalIds: String
    $storeId: String!
    $expand: String
  ) {
    Yotpo {
      getCustomers(
        email: $email
        phone_number: $phone
        limit: $limit
        external_ids: $externalIds
        store_id: $storeId
        expand: $expand
      ) {
        ... on Yotpo_getCustomers_response {
          ... on Yotpo_Customers {
            customers {
              external_id
              email
              phone_number
              first_name
              last_name
              gender
              account_created_at
              account_updated_at
              default_language
              dafault_currency
              lists {
                id
                since
              }
              yotpo_ugc {
                total_reviews
                avg_product_rating
                avg_site_rating
                total_avg_rating
                sentiment_avg_product
                sentiment_avg_site
                total_avg_sentiment
                top_topics
                last_star_rating
                last_review_date
                last_sentiment
              }
              yotpo_loyalty {
                points_earned
                points_balance
                last_seen_at
                total_redemptions
                total_points_redeemed
                vip_tier_name
                successful_referrals
                referrals_made_and_clicked
                is_referred_by_other_customer
                points_expire_date
                credit_balance_amount
                credit_balance_customer_currency
                is_opt_in
                opt_in_date
                opt_out_date
                has_store_account
                referred_by_customer
                vip_entry_date
                vip_expiration_date
                next_points_expire_on
                next_points_expire_amount
              }
              yotpo_subscriptions {
                active_subscriptions {
                  externalProductId
                  externalVariantId
                }
                paused_subscriptions {
                  externalProductId
                  externalVariantId
                }
                failed_subscriptions {
                  externalProductId
                  externalVariantId
                }
                expired_subscriptions {
                  externalProductId
                  externalVariantId
                }
                canceled_subscriptions {
                  externalProductId
                  externalVariantId
                }
              }
            }
          }
        }
      }
    }
  }
`
), k8 = "_copyIcon_1pfts_54", b8 = "_list_1pfts_59", _8 = "_listItem_1pfts_69", x8 = "_listItemHighlighted_1pfts_78", Ca = {
  copyIcon: k8,
  list: b8,
  listItem: _8,
  listItemHighlighted: x8
}, S8 = "_wrapper_1xucg_1", N8 = "_externalLink_1xucg_7", Wh = {
  wrapper: S8,
  externalLink: N8
}, j8 = ({
  customerDetails: e
}) => {
  const { isCopied: n, copy: r } = Qt(), { isCopied: i, copy: a } = Qt();
  if (!e)
    return null;
  const {
    first_name: o,
    last_name: s,
    email: l,
    phone_number: d,
    account_created_at: m
  } = e, u = 14, f = `${o || ""} ${s || ""}`.trim() || "A customer has no name";
  return /* @__PURE__ */ Ne.jsx(b, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ Ne.jsxs(b, { className: Wh.wrapper, gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ Ne.jsx(
      b,
      {
        justifyContent: "space-between",
        className: Wh.block,
        alignItems: "center",
        children: /* @__PURE__ */ Ne.jsx(F.Heading, { variant: "heading-2", children: f })
      }
    ),
    m && /* @__PURE__ */ Ne.jsxs(b, { gap: "200", justifyContent: "space-between", margin: "0 0 200", children: [
      /* @__PURE__ */ Ne.jsx(F.Paragraph, { variant: "4", children: "Member since" }),
      /* @__PURE__ */ Ne.jsx(F.Paragraph, { variant: "4", children: Wn(m).format(It) })
    ] }),
    l && /* @__PURE__ */ Ne.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Ne.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ Ne.jsx(fe, { size: u, name: "mail" }),
        /* @__PURE__ */ Ne.jsx("span", { className: Wh.externalLink, children: l })
      ] }),
      /* @__PURE__ */ Ne.jsx(Ge, { content: "Copy email", children: /* @__PURE__ */ Ne.jsx(b, { alignItems: "center", children: /* @__PURE__ */ Ne.jsx(
        fe,
        {
          size: u,
          name: n ? "done" : "copy",
          onClick: () => r(l),
          className: Ca.copyIcon
        }
      ) }) })
    ] }),
    d && /* @__PURE__ */ Ne.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Ne.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ Ne.jsx(fe, { size: u, name: "phone" }),
        /* @__PURE__ */ Ne.jsx(F.Paragraph, { variant: "4", children: d })
      ] }),
      /* @__PURE__ */ Ne.jsx(Ge, { content: "Copy phone number", children: /* @__PURE__ */ Ne.jsx(b, { alignItems: "center", children: /* @__PURE__ */ Ne.jsx(
        fe,
        {
          size: u,
          name: i ? "done" : "copy",
          onClick: () => a(d),
          className: Ca.copyIcon
        }
      ) }) })
    ] })
  ] }) });
}, nt = ({
  description: e,
  content: n,
  tooltip: r,
  isHighlighted: i = !1
}) => {
  if (n == null)
    return null;
  const a = jw(n);
  return /* @__PURE__ */ Ne.jsx(
    Je.Text,
    {
      variant: "dense",
      className: ut(Ca.listItem, {
        [Ca.listItemHighlighted]: i
      }),
      children: /* @__PURE__ */ Ne.jsx(Ge, { content: r, children: /* @__PURE__ */ Ne.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ Ne.jsx(F.Paragraph, { variant: "4", children: e }),
        a ? n : qi(n)
      ] }) })
    }
  );
}, w8 = ({
  loyalty: e
}) => /* @__PURE__ */ Ne.jsxs(b, { gap: "200", flexDirection: "column", children: [
  /* @__PURE__ */ Ne.jsx(F.Heading, { variant: "heading-3", children: "Loyalty" }),
  !e && /* @__PURE__ */ Ne.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ Ne.jsx(F.Paragraph, { variant: "4", color: "secondary", children: "No loyalty data available" }) }),
  e && /* @__PURE__ */ Ne.jsxs(Je, { className: Ca.list, children: [
    /* @__PURE__ */ Ne.jsx(
      nt,
      {
        isHighlighted: !0,
        description: "Successful referrals",
        tooltip: "The total number of successful referrals made by the customer.",
        content: e.successful_referrals
      }
    ),
    /* @__PURE__ */ Ne.jsx(
      nt,
      {
        isHighlighted: !0,
        description: "Referrals made and clicked",
        tooltip: "The total number of referrals made by the customer and clicked on by others.",
        content: e.referrals_made_and_clicked
      }
    ),
    /* @__PURE__ */ Ne.jsx(
      nt,
      {
        description: "Points earned",
        tooltip: "The total number of loyalty points earned by the customer.",
        content: e.points_earned
      }
    ),
    /* @__PURE__ */ Ne.jsx(
      nt,
      {
        description: "Points balance",
        tooltip: "The current balance of loyalty points for the customer.",
        content: e.points_balance
      }
    ),
    /* @__PURE__ */ Ne.jsx(
      nt,
      {
        description: "Last seen",
        tooltip: "The timestamp when the customer was last seen or engaged with the loyalty program.",
        content: e.last_seen_at
      }
    ),
    /* @__PURE__ */ Ne.jsx(
      nt,
      {
        description: "Total redemptions",
        tooltip: "The total number of times the customer has redeemed loyalty points.",
        content: e.total_redemptions
      }
    ),
    /* @__PURE__ */ Ne.jsx(
      nt,
      {
        description: "Total points redeemed",
        tooltip: "The total number of loyalty points redeemed by the customer.",
        content: e.total_points_redeemed
      }
    ),
    /* @__PURE__ */ Ne.jsx(
      nt,
      {
        description: "VIP tier",
        tooltip: "The name of the customer's current VIP tier status.",
        content: e.vip_tier_name
      }
    ),
    /* @__PURE__ */ Ne.jsx(
      nt,
      {
        description: "Referred by other customer",
        tooltip: "Indicates whether the customer was referred by another customer.",
        content: e.is_referred_by_other_customer
      }
    ),
    /* @__PURE__ */ Ne.jsx(
      nt,
      {
        description: "Points expiry date",
        tooltip: "The timestamp when the customer's loyalty points are set to expire.",
        content: e.next_points_expire_on || e.points_expire_date
      }
    ),
    /* @__PURE__ */ Ne.jsx(
      nt,
      {
        description: "Points expiry amount",
        tooltip: "The number of points that are about to expire",
        content: e.next_points_expire_amount
      }
    ),
    /* @__PURE__ */ Ne.jsx(
      nt,
      {
        description: "Credit balance amount",
        tooltip: "The amount of store credit available to the customer in the default currency of the store.",
        content: e.credit_balance_amount
      }
    ),
    /* @__PURE__ */ Ne.jsx(
      nt,
      {
        description: "Credit balance customer currency",
        tooltip: "The store credit amount in the customer's preferred currency.",
        content: e.credit_balance_customer_currency
      }
    ),
    /* @__PURE__ */ Ne.jsx(
      nt,
      {
        description: "Opt in",
        tooltip: "Indicates whether the customer has opted into the loyalty program.",
        content: e.is_opt_in
      }
    ),
    /* @__PURE__ */ Ne.jsx(
      nt,
      {
        description: "Opt in date",
        tooltip: "The timestamp for when the customer opted into the loyalty program.",
        content: e.opt_in_date
      }
    ),
    /* @__PURE__ */ Ne.jsx(
      nt,
      {
        description: "Opt out date",
        tooltip: "The timestamp for when the customer opted out of the loyalty program.",
        content: e.opt_out_date
      }
    ),
    /* @__PURE__ */ Ne.jsx(
      nt,
      {
        description: "Has store account",
        tooltip: "Indicates whether the customer has a store account.",
        content: e.has_store_account
      }
    ),
    /* @__PURE__ */ Ne.jsx(
      nt,
      {
        description: "Referred by customer",
        tooltip: "The email address of the customer who referred this customer to the loyalty program.",
        content: e.referred_by_customer
      }
    ),
    /* @__PURE__ */ Ne.jsx(
      nt,
      {
        description: "VIP entry date",
        tooltip: "The timestamp for when the customer entered the VIP tier.",
        content: e.vip_entry_date
      }
    ),
    /* @__PURE__ */ Ne.jsx(
      nt,
      {
        description: "VIP expiration date",
        tooltip: "The timestamp for when the customer's VIP tier membership is set to expire.",
        content: e.vip_expiration_date
      }
    )
  ] })
] }), C8 = 0.8, F8 = 0.4, kw = (e) => {
  if (e != null)
    return e >= C8 ? /* @__PURE__ */ Ne.jsx(Pn, { variant: "success", size: "small", children: "Positive" }) : e <= F8 ? /* @__PURE__ */ Ne.jsx(Pn, { variant: "error", size: "small", children: "Negative" }) : /* @__PURE__ */ Ne.jsx(Pn, { variant: "warning", size: "small", children: "Neutral" });
}, I8 = ({
  userGeneratedContent: e
}) => /* @__PURE__ */ Ne.jsxs(b, { gap: "200", flexDirection: "column", children: [
  /* @__PURE__ */ Ne.jsx(F.Heading, { variant: "heading-3", children: "User generated content" }),
  !e && /* @__PURE__ */ Ne.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ Ne.jsx(F.Paragraph, { variant: "4", color: "secondary", children: "No user generated content available" }) }),
  e && /* @__PURE__ */ Ne.jsxs(Je, { className: Ca.list, children: [
    /* @__PURE__ */ Ne.jsx(
      nt,
      {
        isHighlighted: !0,
        description: "Total reviews",
        tooltip: "The total number of reviews submitted by the customer.",
        content: e.total_reviews
      }
    ),
    /* @__PURE__ */ Ne.jsx(
      nt,
      {
        isHighlighted: !0,
        description: "Total average rating",
        tooltip: "The total average rating given by the customer (combining products and site/store ratings).",
        content: e.total_avg_rating?.toFixed(2)
      }
    ),
    /* @__PURE__ */ Ne.jsx(
      nt,
      {
        isHighlighted: !0,
        description: "Total average sentiment score",
        tooltip: "The total average sentiment score given by the customer (combining products and site/store scores).",
        content: kw(e.total_avg_sentiment)
      }
    ),
    /* @__PURE__ */ Ne.jsx(
      nt,
      {
        description: "Average product rating",
        tooltip: "The average product rating given by the customer.",
        content: e.avg_product_rating
      }
    ),
    /* @__PURE__ */ Ne.jsx(
      nt,
      {
        description: "Average site rating",
        tooltip: "The average rating of the site/store given by the customer.",
        content: e.avg_site_rating?.toFixed(2)
      }
    ),
    /* @__PURE__ */ Ne.jsx(
      nt,
      {
        description: "Last sentiment",
        tooltip: "The sentiment score of the customer's last review.",
        content: kw(e.last_sentiment)
      }
    ),
    /* @__PURE__ */ Ne.jsx(
      nt,
      {
        description: "Last star rating",
        tooltip: "The star rating of the customer's last review.",
        content: e.last_star_rating
      }
    ),
    /* @__PURE__ */ Ne.jsx(
      nt,
      {
        description: "Last review date",
        tooltip: "The timestamp for when the customer last submitted a review.",
        content: Wn(e.last_review_date).format(
          It
        )
      }
    ),
    /* @__PURE__ */ Ne.jsx(
      nt,
      {
        description: "Topics",
        tooltip: "An list of top topics (themes) mentioned in all of the customer's reviews.",
        content: /* @__PURE__ */ Ne.jsx(
          b,
          {
            gap: "100",
            width: "80%",
            flexWrap: "wrap",
            justifyContent: "flex-end",
            children: e.top_topics?.map((n, r) => /* @__PURE__ */ Ne.jsx(Pn, { variant: "info", size: "small", children: /* @__PURE__ */ Ne.jsx(Ne.Fragment, { children: n }) }, r))
          }
        )
      }
    )
  ] })
] }), $8 = ({
  conversationContext: e,
  settings: n
}) => {
  const { useQuery: r } = fn(), { track: i } = jn(), [a, o] = me(), [s, l] = me(!1), d = e?.customer?.email, m = e?.customer?.phone_number, u = !d && !m, f = n?.yotpoStoreId, h = n?.showCustomerDetails ?? !1, v = n?.showUserGeneratedContent ?? !1, w = n?.displayLoyalty ?? !1, N = n?.displaySubscriptions ?? !1, j = !f, _ = !h && !v && !w && !N, {
    loading: g,
    error: O,
    data: R
  } = r(v8, {
    skip: u || j,
    variables: {
      ...d && { email: d },
      ...!d && m && { phone: m },
      storeId: f,
      expand: "all"
    }
  });
  if (Xe(() => {
    const $ = R?.Yotpo?.getCustomers?.customers?.[0];
    $ ? (o($), l(!1), i("yotpo:customer:received")) : l(!0);
  }, [R?.Yotpo, g]), j)
    return /* @__PURE__ */ Ne.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ Ne.jsx(
      $n,
      {
        error: new Tw({
          graphQLErrors: [
            {
              message: "Integration needs to be re-/authorized in the settings."
            }
          ]
        }),
        hideCopyButton: !0
      }
    ) });
  if (u)
    return /* @__PURE__ */ Ne.jsx(
      b,
      {
        justifyContent: "center",
        margin: "200 0 300 0",
        "data-testid": "widget-no-contact-message",
        children: /* @__PURE__ */ Ne.jsx(F.Paragraph, { variant: "4", color: "secondary", children: "No email nor phone number are available in this conversation to look up a profile." })
      }
    );
  if (_)
    return /* @__PURE__ */ Ne.jsx(
      b,
      {
        justifyContent: "center",
        margin: "200 0 300 0",
        "data-testid": "widget-no-features",
        children: /* @__PURE__ */ Ne.jsx(F.Paragraph, { variant: "4", color: "secondary", children: "All features toggles in the widget settings are disabled." })
      }
    );
  if (g)
    return /* @__PURE__ */ Ne.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ Ne.jsx(sn, {}) });
  if (s)
    return /* @__PURE__ */ Ne.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ Ne.jsx(F.Paragraph, { variant: "4", color: "secondary", children: "No customer profile found." }) });
  if (O) {
    const $ = O.graphQLErrors;
    return Ml({ errors: $ }) ? /* @__PURE__ */ Ne.jsx(
      F.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        variant: "4",
        "data-testid": "widget-downstream-api-forbidden-error",
        children: "The API token used for the integration does not have the necessary access rights. Please contact your administrator."
      }
    ) : Bl({ errors: $ }) ? /* @__PURE__ */ Ne.jsx(
      F.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        variant: "4",
        "data-testid": "widget-downstream-api-authorization-error",
        children: "The integration could not authorize against Yotpo. Please contact your administrator."
      }
    ) : /* @__PURE__ */ Ne.jsx($n, { error: O });
  }
  return /* @__PURE__ */ Ne.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300 0",
      "data-testid": "widget-wrapper",
      children: [
        h && /* @__PURE__ */ Ne.jsx(j8, { customerDetails: a }),
        v && /* @__PURE__ */ Ne.jsx(
          I8,
          {
            userGeneratedContent: a?.yotpo_ugc
          }
        ),
        w && /* @__PURE__ */ Ne.jsx(w8, { loyalty: a?.yotpo_loyalty })
      ]
    }
  );
}, E8 = "_settingsWrapper_1ycvy_1", T8 = "_settingsWrapperHeader_1ycvy_6", R8 = "_settingsWrapperContent_1ycvy_10", D8 = "_settingsWrapperContentCode_1ycvy_18", O8 = "_settingsWrapperContentCURL_1ycvy_26", wo = {
  settingsWrapper: E8,
  settingsWrapperHeader: T8,
  settingsWrapperContent: R8,
  settingsWrapperContentCode: D8,
  settingsWrapperContentCURL: O8
}, ZF = ({
  handleChangeText: e
}) => {
  const [n, r] = me(!1), { isCopied: i, copy: a } = Qt(), { control: o } = ot({
    defaultValues: {
      storeId: "",
      secret: ""
    },
    mode: "onChange"
  }), s = ki({
    control: o
  }), l = s.storeId !== "" && s.secret !== "", d = pt(() => {
    const m = s.storeId, u = s.secret;
    return `curl --request POST \\
  --url https://api.yotpo.com/core/v3/stores/${m || "store_id"}/access_tokens \\
  --header 'Content-Type: application/json' \\
  --header 'accept: application/json'${u ? ` \\
  --data '{"secret":"${u}"}'` : ""}`;
  }, [s.storeId, s.secret]);
  return /* @__PURE__ */ Ne.jsx(Ne.Fragment, { children: /* @__PURE__ */ Ne.jsx(Z, { span: 6, children: /* @__PURE__ */ Ne.jsxs(b, { flexDirection: "column", className: wo.settingsWrapper, children: [
    /* @__PURE__ */ Ne.jsxs(
      b,
      {
        gap: "200",
        alignItems: "center",
        className: wo.settingsWrapperHeader,
        onClick: () => r(!n),
        children: [
          /* @__PURE__ */ Ne.jsx(F.Heading, { variant: "heading-3", children: "How to get the Yotpo access token" }),
          /* @__PURE__ */ Ne.jsx(fe, { name: n ? "angle-down" : "angle-right" })
        ]
      }
    ),
    n && /* @__PURE__ */ Ne.jsxs(
      b,
      {
        flexDirection: "column",
        className: wo.settingsWrapperContent,
        children: [
          /* @__PURE__ */ Ne.jsx(b, { margin: "0 0 400", children: /* @__PURE__ */ Ne.jsx(
            Ey,
            {
              variant: "announcement",
              headline: "In order to get the Yotpo access token, you have to follow the steps below",
              description: /* @__PURE__ */ Ne.jsxs("ol", { children: [
                /* @__PURE__ */ Ne.jsx("li", { children: "Insert the Yotpo store ID and secret below in the input fields" }),
                /* @__PURE__ */ Ne.jsx("li", { children: "Once the fields are filled in, the CURL command will appear below and you can copy and run it in your terminal" }),
                /* @__PURE__ */ Ne.jsxs("li", { children: [
                  "The response should look like this",
                  " ",
                  /* @__PURE__ */ Ne.jsx("span", { className: wo.settingsWrapperContentCode, children: '{ "access_token": "this-is-your-token" }' })
                ] }),
                /* @__PURE__ */ Ne.jsxs("li", { children: [
                  "Copy the token without quotes and paste it in the",
                  " ",
                  /* @__PURE__ */ Ne.jsx("i", { children: "Yotpo access token" }),
                  " input field below"
                ] }),
                /* @__PURE__ */ Ne.jsx("li", { children: "Click the save button" })
              ] })
            }
          ) }),
          /* @__PURE__ */ Ne.jsx(
            jt,
            {
              name: "storeId",
              control: o,
              render: ({ field: m }) => /* @__PURE__ */ Ne.jsx(
                Kr,
                {
                  label: "Yotpo store ID",
                  placeholder: "Please insert the store ID",
                  input: {
                    ...m,
                    onChange: (u) => {
                      m.onChange(u), e({
                        target: {
                          name: "yotpoStoreId",
                          value: u?.target.value ?? ""
                        }
                      });
                    }
                  }
                }
              )
            }
          ),
          /* @__PURE__ */ Ne.jsx(
            jt,
            {
              name: "secret",
              control: o,
              render: ({ field: m }) => /* @__PURE__ */ Ne.jsx(
                Kr,
                {
                  label: "Yotpo secret",
                  placeholder: "Please insert the secret",
                  input: m
                }
              )
            }
          ),
          l && /* @__PURE__ */ Ne.jsxs(Ne.Fragment, { children: [
            /* @__PURE__ */ Ne.jsx(qe, { label: "Generated CURL command", noAlert: !0, children: /* @__PURE__ */ Ne.jsx(
              b,
              {
                as: "pre",
                gap: "200",
                margin: "100 0 250",
                className: wo.settingsWrapperContentCURL,
                children: d()
              }
            ) }),
            /* @__PURE__ */ Ne.jsx(b, { alignContent: "start", children: /* @__PURE__ */ Ne.jsx(
              Ge,
              {
                content: i ? "Copied!" : "Copy CURL command",
                children: /* @__PURE__ */ Ne.jsx(
                  Qn,
                  {
                    variant: "secondary",
                    icon: i ? "check-circle" : "copy",
                    onClick: () => a(d()),
                    children: "Copy CURL"
                  }
                )
              }
            ) })
          ] })
        ]
      }
    )
  ] }) }) });
}, Yo = [
  // The store id is populated by the OAuth flow, not edited in the form. It is
  // kept here so the runtime widget render can resolve it and so it round-trips
  // on update.
  {
    key: "yotpoStoreId",
    label: "Yotpo store ID",
    type: "string",
    secret: !1,
    defaultValue: ""
  },
  // Secret, only written when editing a legacy token-authenticated widget.
  // Excluded from the read path; omitted from the update payload unless the
  // user re-enters it (preserving the stored value).
  {
    key: "yotpoAccessToken",
    label: "Yotpo access token",
    type: "string",
    secret: !0,
    defaultValue: ""
  },
  {
    key: "showCustomerDetails",
    label: "Show customer details",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showUserGeneratedContent",
    label: "Show user generated content",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "displayLoyalty",
    label: "Show loyalty data",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  }
], P8 = [
  /**
   * The store ID will be fetched through the OAuth flow, so there's no real
   * reason to show it
   */
  {
    key: "yotpoStoreId",
    label: "Yotpo store ID",
    placeholder: "",
    readOnly: !0,
    required: !1,
    secret: !1,
    type: "hidden",
    hideOnCreate: !0
  },
  {
    key: "authorizeWithOauth",
    label: "Authorize with OAuth",
    secret: !1,
    type: "custom",
    hideOnCreate: !0,
    component: bi
  }
], A8 = [
  {
    key: "accessTokenComponent",
    label: "Retrieve Yotpo access token",
    secret: !1,
    type: "custom",
    component: ZF
  },
  {
    key: "yotpoStoreId",
    label: "Yotpo store ID",
    placeholder: 'See "How to get the Yotpo access token" above.',
    readOnly: !0,
    required: !0,
    secret: !1,
    type: "input"
  },
  {
    key: "yotpoAccessToken",
    label: "Yotpo access token",
    placeholder: "Insert the Yotpo access token",
    required: !0,
    secret: !0,
    type: "input"
  }
], Co = ar(Yo), Kh = "YOTPO", L8 = {
  enabled: !1,
  name: "",
  ...Jo(
    [],
    Yo
  )
}, V8 = ({
  integrationId: e,
  configuration: n,
  handleRedirect: r,
  showNotification: i,
  automationCouplingState: a,
  renderConditionsEditor: o
}) => {
  const s = !e, l = ot({
    mode: "onChange",
    defaultValues: L8
  }), {
    create: d,
    update: m,
    remove: u,
    isLoading: f,
    error: h,
    misconfigurationCause: v,
    setMisconfigurationCause: w
  } = pr({
    integrationId: e,
    integrationType: Kh,
    handleRedirect: r,
    showNotification: i
  }), {
    isLoading: N,
    error: j,
    isWidgetUnknown: _,
    refetch: g,
    widgetConfiguration: O
  } = fr({
    integrationId: e,
    fieldDefinitions: Yo,
    form: l,
    onMisconfigured: w
  }), { renderConditions: R, setRenderConditions: $, renderConditionsForSubmit: I } = hr({
    integrationId: e,
    widgetConfiguration: O,
    renderConditionsEditor: o
  }), L = s || !!O?.additionalProperties?.isUsingOAuth, G = (ne) => gr(ne, {
    fieldDefinitions: Yo,
    isCreationMode: s,
    create: d,
    update: m,
    renderConditions: I
  }), Q = l.watch("name");
  return /* @__PURE__ */ Ne.jsxs(
    yr,
    {
      form: l,
      integrationId: e,
      onValidSubmit: G,
      error: j ?? h,
      onRetry: j ? g : void 0,
      isLoading: f || N,
      isWidgetUnknown: _,
      children: [
        v && /* @__PURE__ */ Ne.jsx(vr, { cause: v }),
        /* @__PURE__ */ Ne.jsxs(et, { children: [
          /* @__PURE__ */ Ne.jsx(Z, { children: /* @__PURE__ */ Ne.jsx(qe, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ Ne.jsx(
            yn,
            {
              name: "enabled",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ Ne.jsx(Z, { span: 3, children: /* @__PURE__ */ Ne.jsx(
            Rn,
            {
              name: "name",
              label: "Widget name",
              control: l.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ Ne.jsx(Z, { span: 3 }),
          !L && /* @__PURE__ */ Ne.jsxs(Ne.Fragment, { children: [
            /* @__PURE__ */ Ne.jsx(
              ZF,
              {
                handleChangeText: (ne) => l.setValue("yotpoStoreId", ne?.target.value ?? "")
              }
            ),
            /* @__PURE__ */ Ne.jsx(Z, { span: 3, children: /* @__PURE__ */ Ne.jsx(
              Rn,
              {
                name: "yotpoStoreId",
                label: Co.yotpoStoreId,
                control: l.control,
                rules: { required: "Yotpo store ID is required" },
                componentProps: {
                  placeholder: 'See "How to get the Yotpo access token" above.',
                  readOnly: !0,
                  autoComplete: "off"
                }
              }
            ) }),
            /* @__PURE__ */ Ne.jsx(Z, { span: 3 }),
            /* @__PURE__ */ Ne.jsx(Z, { span: 3, children: /* @__PURE__ */ Ne.jsx(
              Er,
              {
                name: "yotpoAccessToken",
                label: Co.yotpoAccessToken,
                control: l.control,
                isCreationMode: s,
                rules: { required: "Yotpo access token is required" },
                componentProps: {
                  placeholder: "Insert the Yotpo access token",
                  autoComplete: "off"
                }
              }
            ) }),
            /* @__PURE__ */ Ne.jsx(Z, { span: 3 })
          ] }),
          /* @__PURE__ */ Ne.jsx(Z, { span: 3, children: /* @__PURE__ */ Ne.jsx(qe, { label: Co.showCustomerDetails, children: /* @__PURE__ */ Ne.jsx(
            yn,
            {
              name: "showCustomerDetails",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ Ne.jsx(Z, { span: 3 }),
          /* @__PURE__ */ Ne.jsx(Z, { span: 3, children: /* @__PURE__ */ Ne.jsx(qe, { label: Co.showUserGeneratedContent, children: /* @__PURE__ */ Ne.jsx(
            yn,
            {
              name: "showUserGeneratedContent",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ Ne.jsx(Z, { span: 3 }),
          /* @__PURE__ */ Ne.jsx(Z, { span: 3, children: /* @__PURE__ */ Ne.jsx(qe, { label: Co.displayLoyalty, children: /* @__PURE__ */ Ne.jsx(
            yn,
            {
              name: "displayLoyalty",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ Ne.jsx(Z, { span: 3 }),
          L && !s && e && /* @__PURE__ */ Ne.jsx(
            bi,
            {
              configuration: n,
              integrationId: e,
              integrationType: Kh,
              label: "Authorize with OAuth"
            }
          ),
          o && R !== null && /* @__PURE__ */ Ne.jsx(Z, { children: o({
            value: R,
            onChange: $,
            configurationKey: O?.id
          }) })
        ] }),
        /* @__PURE__ */ Ne.jsx(
          kr,
          {
            integrationType: Kh,
            integrationId: e,
            widgetName: Q,
            isCreationMode: s,
            isSubmitting: l.formState.isSubmitting,
            automationCouplingState: a,
            onConfirmDelete: () => u()
          }
        )
      ]
    }
  );
}, z8 = ({
  hasShopifyOAuth: e = !1,
  isShopifyMarketplaceApp: n = !1,
  isCreationMode: r = !1
}) => r ? {
  authSettings: m9,
  featureSettings: []
} : n ? {
  authSettings: p9,
  featureSettings: [...DF]
} : e ? {
  authSettings: [
    ...qj,
    ...d9
  ],
  featureSettings: [...Hj]
} : {
  authSettings: [
    ...qj,
    ...u9
  ],
  featureSettings: [...Hj]
}, eI = (e, n) => ({
  hasOAuth: r = !1,
  isCreationMode: i = !1
}) => r || i ? e : n, U8 = eI(
  P8,
  A8
), M8 = eI(
  _V,
  xV
), nI = (e = {
  SHOPIFY: {},
  YOTPO: {},
  KLAVIYO: {}
}) => {
  const { SHOPIFY: n, YOTPO: r, KLAVIYO: i } = e, {
    authSettings: a,
    featureSettings: o
  } = z8(n), s = U8(r), l = M8(i);
  return {
    SHOPIFY: {
      widget: TK,
      icon: "shopify",
      iconColors: {
        contentColor: "rgb(148, 190, 69)",
        backgroundColor: "rgba(148, 190, 69, 0.1)"
      },
      fieldDefinitions: Go,
      WidgetSettings: s9,
      // Kept for backwards compatibility with the older declarative
      // configuration types. The active settings UI is `WidgetSettings`.
      settingsConfiguration: [
        ...a,
        ...o
      ]
    },
    JIRA: {
      widget: G2,
      icon: "jira",
      iconColors: {
        contentColor: "rgb(38, 132, 255)",
        backgroundColor: "rgba(38, 132, 255, 0.075)"
      },
      fieldDefinitions: jl,
      WidgetSettings: Q2
    },
    GITHUB: {
      widget: JP,
      icon: "github",
      iconColors: {
        contentColor: "rgb(87, 96, 106)",
        backgroundColor: "rgba(221, 244, 255, 0.75)"
      },
      fieldDefinitions: xl,
      WidgetSettings: XP
    },
    MIUROS: {
      widget: PB,
      icon: "miuros",
      iconColors: {
        contentColor: "rgb(246, 135, 179)",
        backgroundColor: "rgba(246, 135, 179, 0.15)"
      },
      fieldDefinitions: Rl,
      WidgetSettings: LB
    },
    KLAVIYO: {
      widget: bV,
      icon: "klaviyo",
      iconColors: {
        contentColor: "rgb(0, 0, 0)",
        backgroundColor: "rgba(0, 0, 0, 0.075)"
      },
      fieldDefinitions: ja,
      WidgetSettings: $V,
      // Kept for backwards compatibility with the older declarative
      // configuration types. The active settings UI is `WidgetSettings`.
      settingsConfiguration: [...l]
    },
    LINEAR: {
      widget: n5,
      icon: "linear",
      iconColors: {
        contentColor: "rgb(94, 106, 210)",
        backgroundColor: "rgba(94, 106, 210, 0.15)"
      },
      fieldDefinitions: El,
      WidgetSettings: r5
    },
    VOYADO: {
      widget: c8,
      icon: "voyado",
      iconColors: {
        contentColor: "rgb(0, 0, 0)",
        backgroundColor: "rgba(0, 0, 0, 0.075)"
      },
      fieldDefinitions: zl,
      WidgetSettings: u8
    },
    LOYALTYLION: {
      widget: D5,
      icon: "loyaltylion",
      iconColors: {
        contentColor: "rgb(36, 31, 79)",
        backgroundColor: "rgba(36, 31, 79, 0.075)"
      },
      fieldDefinitions: Tl,
      WidgetSettings: P5
    },
    RECHARGE: {
      widget: Bq,
      icon: "recharge",
      iconColors: {
        contentColor: "rgb(57, 1, 241)",
        backgroundColor: "rgba(57, 1, 241, 0.075)"
      },
      fieldDefinitions: Ko,
      WidgetSettings: Wq
    },
    BRAZE: {
      widget: SO,
      icon: "braze",
      iconColors: {
        contentColor: "rgb(48, 2, 102)",
        backgroundColor: "rgba(48, 2, 102, 0.075)"
      },
      fieldDefinitions: qo,
      WidgetSettings: jO
    },
    YOTPO: {
      widget: $8,
      icon: "yotpo",
      iconColors: {
        contentColor: "rgb(0, 66, 228)",
        backgroundColor: "rgba(0, 66, 228, 0.075)"
      },
      fieldDefinitions: Yo,
      WidgetSettings: V8,
      // Kept for backwards compatibility with the older declarative
      // configuration types. The active settings UI is `WidgetSettings`.
      settingsConfiguration: [...s]
    },
    INGRID: {
      widget: jA,
      icon: "ingrid",
      iconColors: {
        contentColor: "rgb(0, 0, 0)",
        backgroundColor: "rgba(0, 0, 0, 0.075)"
      },
      fieldDefinitions: Sl,
      WidgetSettings: CA
    },
    RIVOLOYALTY: {
      widget: $6,
      icon: "rivoloyalty",
      iconColors: {
        contentColor: "rgb(0, 0, 0)",
        backgroundColor: "rgba(0, 0, 0, 0.075)"
      },
      fieldDefinitions: Ll,
      WidgetSettings: YW
    }
  };
}, B8 = (e, n) => {
  const r = n.find(
    (i) => i.key === e.key
  )?.value;
  return e.type === "boolean" ? SI(r, e.defaultValue) : NI(r, e.defaultValue);
}, q8 = (e, n) => e.map((r) => ({
  key: r.key,
  value: B8(r, n)
})), H8 = ({ fieldDefinitions: e }, n) => q8(
  (e ?? []).filter(({ secret: r }) => !r),
  n
), W8 = (e) => {
  const n = nI();
  return e.map(
    ({
      id: r,
      type: i,
      name: a,
      settings: o,
      misconfigured: s,
      renderConditions: l,
      integrationKey: d
    }) => {
      const u = n[i];
      return {
        id: r,
        type: i,
        name: a,
        settings: H8(u, o),
        misconfigured: s,
        renderConditions: l,
        icon: u.icon,
        iconColors: u.iconColors,
        widget: u.widget,
        integrationKey: d
      };
    }
  );
}, K8 = ({
  widget: e,
  index: n,
  configuration: r,
  conversationContext: i,
  showNotification: a,
  onToggleFn: o,
  isOpenFn: s,
  isMinimized: l,
  isUnmatched: d,
  renderVisibilityToggleElement: m,
  renderDragElement: u,
  renderConditionMatchedIndicator: f
}) => {
  const { track: h } = jn(), v = DT(), w = Tr(null), {
    id: N,
    name: j,
    type: _,
    widget: g,
    settings: O,
    misconfigured: R,
    renderConditions: $,
    icon: I,
    iconColors: L,
    integrationKey: G
  } = Zn(
    () => W8([e])[0],
    [e]
  ), Q = `partner-integration-${_}`, ne = /* @__PURE__ */ Xn.jsx(Ty, { icon: I, color: L }), q = O?.reduce(
    (Y, P) => (Y[P.key] = P.value, Y),
    {}
  );
  return l ? /* @__PURE__ */ Xn.jsx("div", { className: "icon-holder", children: ne }, `partner-icon-${N}`) : /* @__PURE__ */ Xn.jsxs(
    Sr,
    {
      onToggle: () => {
        h(
          s(G) ? "widget:collapse:closed" : "widget:collapse:opened",
          { widgetId: N, widgetType: _.toLowerCase() }
        ), o(G);
      },
      isOpen: s(G),
      className: Q,
      containerRef: w,
      children: [
        /* @__PURE__ */ Xn.jsx(
          Sr.Header,
          {
            className: ut({ [AT.unmatchedHeader]: d }),
            wrap: "normal",
            avatar: ne,
            slotBeforeTitle: u?.(G, n, w),
            slotAfterTitle: /* @__PURE__ */ Xn.jsx(Xn.Fragment, { children: m?.(G) }),
            children: /* @__PURE__ */ Xn.jsxs(b, { alignItems: "center", flexDirection: "row", gap: "200", children: [
              j,
              f?.($ ?? [], N)
            ] })
          }
        ),
        /* @__PURE__ */ Xn.jsx(Sr.Content, { children: R ? /* @__PURE__ */ Xn.jsx($n, { isMisconfigured: !0 }) : /* @__PURE__ */ Xn.jsx(
          Iw.Provider,
          {
            value: {
              onError: (Y, P) => console.warn(
                `Something went wrong with a partner widget of type '${_}' and id '${N}'`,
                Y,
                P
              )
            },
            children: /* @__PURE__ */ Xn.jsx(
              uC,
              {
                integrationId: N,
                type: _,
                configuration: r,
                showNotification: a,
                showModal: v,
                children: FI(g, {
                  conversationContext: i,
                  settings: q
                })
              }
            )
          }
        ) })
      ]
    },
    G
  );
}, wY = ({
  widgets: e,
  configuration: n,
  conversationContext: r,
  showNotification: i,
  onToggleFn: a,
  isOpenFn: o,
  isMinimized: s,
  renderVisibilityToggleElement: l,
  renderDragElement: d,
  renderConditionMatchedIndicator: m,
  widgetAnnotations: u
}) => /* @__PURE__ */ Xn.jsx(OT, { children: e.map((f, h) => /* @__PURE__ */ Xn.jsx(
  K8,
  {
    widget: f,
    index: h,
    configuration: n,
    conversationContext: r,
    showNotification: i,
    onToggleFn: a,
    isOpenFn: o,
    isMinimized: s,
    isUnmatched: u?.get(f.id) === !1,
    renderVisibilityToggleElement: l,
    renderDragElement: d,
    renderConditionMatchedIndicator: m
  },
  f.integrationKey
)) }), CY = ({
  configuration: e,
  integrationId: n,
  type: r,
  handleRedirect: i,
  showNotification: a,
  automationCouplingState: o,
  renderConditionsEditor: s
}) => {
  const l = nI()[r]?.WidgetSettings;
  return /* @__PURE__ */ Xn.jsx(
    Iw.Provider,
    {
      value: {
        onError: (d, m) => console.warn(
          `Something went wrong with the partner widget settings of type ${r} and id ${n}`,
          d,
          m
        )
      },
      children: /* @__PURE__ */ Xn.jsx(
        uC,
        {
          integrationId: n,
          type: r,
          configuration: e,
          showNotification: a,
          children: /* @__PURE__ */ Xn.jsx(Xn.Fragment, { children: l && /* @__PURE__ */ Xn.jsx(
            l,
            {
              configuration: e,
              integrationId: n,
              handleRedirect: i,
              showNotification: a,
              automationCouplingState: o,
              renderConditionsEditor: s
            }
          ) })
        }
      )
    }
  );
}, bw = "__PairingContext__", tI = globalThis[bw] ?? (() => {
  const e = $y({});
  return globalThis[bw] = e, e;
})(), FY = () => ql(tI), IY = ({
  value: e,
  children: n
}) => /* @__PURE__ */ Xn.jsx(tI.Provider, { value: e, children: n }), G8 = Kl`
  query getWidgetConfigurations {
    Management {
      widgetConfigurations {
        id
        type
        enabled
        name
        misconfigured
        renderConditions
        settings {
          key
          value
        }
      }
    }
  }
`;
function $Y(e, { skip: n = !1 } = {}) {
  const [r, i] = me([]), [a, o] = me(!1);
  return Xe(() => {
    if (n) {
      o(!1);
      return;
    }
    let s = !1;
    return o(!0), dC(e).query({
      query: G8
    }).then(({ data: l }) => {
      s || (i(
        (l?.Management?.widgetConfigurations ?? []).filter(
          (d) => d != null
        ).map((d) => ({
          ...d,
          integrationKey: `partner-integration-${d.id}`
        }))
      ), o(!1));
    }).catch(() => {
      s || o(!1);
    }), () => {
      s = !0;
    };
  }, [e, n]), {
    isLoading: a,
    widgets: r
  };
}
var Js = { exports: {} }, _w;
function Y8() {
  if (_w) return Js.exports;
  _w = 1;
  var e = typeof Reflect == "object" ? Reflect : null, n = e && typeof e.apply == "function" ? e.apply : function($, I, L) {
    return Function.prototype.apply.call($, I, L);
  }, r;
  e && typeof e.ownKeys == "function" ? r = e.ownKeys : Object.getOwnPropertySymbols ? r = function($) {
    return Object.getOwnPropertyNames($).concat(Object.getOwnPropertySymbols($));
  } : r = function($) {
    return Object.getOwnPropertyNames($);
  };
  function i(R) {
    console && console.warn && console.warn(R);
  }
  var a = Number.isNaN || function($) {
    return $ !== $;
  };
  function o() {
    o.init.call(this);
  }
  Js.exports = o, Js.exports.once = _, o.EventEmitter = o, o.prototype._events = void 0, o.prototype._eventsCount = 0, o.prototype._maxListeners = void 0;
  var s = 10;
  function l(R) {
    if (typeof R != "function")
      throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof R);
  }
  Object.defineProperty(o, "defaultMaxListeners", {
    enumerable: !0,
    get: function() {
      return s;
    },
    set: function(R) {
      if (typeof R != "number" || R < 0 || a(R))
        throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + R + ".");
      s = R;
    }
  }), o.init = function() {
    (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) && (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
  }, o.prototype.setMaxListeners = function($) {
    if (typeof $ != "number" || $ < 0 || a($))
      throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + $ + ".");
    return this._maxListeners = $, this;
  };
  function d(R) {
    return R._maxListeners === void 0 ? o.defaultMaxListeners : R._maxListeners;
  }
  o.prototype.getMaxListeners = function() {
    return d(this);
  }, o.prototype.emit = function($) {
    for (var I = [], L = 1; L < arguments.length; L++) I.push(arguments[L]);
    var G = $ === "error", Q = this._events;
    if (Q !== void 0)
      G = G && Q.error === void 0;
    else if (!G)
      return !1;
    if (G) {
      var ne;
      if (I.length > 0 && (ne = I[0]), ne instanceof Error)
        throw ne;
      var q = new Error("Unhandled error." + (ne ? " (" + ne.message + ")" : ""));
      throw q.context = ne, q;
    }
    var Y = Q[$];
    if (Y === void 0)
      return !1;
    if (typeof Y == "function")
      n(Y, this, I);
    else
      for (var P = Y.length, B = w(Y, P), L = 0; L < P; ++L)
        n(B[L], this, I);
    return !0;
  };
  function m(R, $, I, L) {
    var G, Q, ne;
    if (l(I), Q = R._events, Q === void 0 ? (Q = R._events = /* @__PURE__ */ Object.create(null), R._eventsCount = 0) : (Q.newListener !== void 0 && (R.emit(
      "newListener",
      $,
      I.listener ? I.listener : I
    ), Q = R._events), ne = Q[$]), ne === void 0)
      ne = Q[$] = I, ++R._eventsCount;
    else if (typeof ne == "function" ? ne = Q[$] = L ? [I, ne] : [ne, I] : L ? ne.unshift(I) : ne.push(I), G = d(R), G > 0 && ne.length > G && !ne.warned) {
      ne.warned = !0;
      var q = new Error("Possible EventEmitter memory leak detected. " + ne.length + " " + String($) + " listeners added. Use emitter.setMaxListeners() to increase limit");
      q.name = "MaxListenersExceededWarning", q.emitter = R, q.type = $, q.count = ne.length, i(q);
    }
    return R;
  }
  o.prototype.addListener = function($, I) {
    return m(this, $, I, !1);
  }, o.prototype.on = o.prototype.addListener, o.prototype.prependListener = function($, I) {
    return m(this, $, I, !0);
  };
  function u() {
    if (!this.fired)
      return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
  }
  function f(R, $, I) {
    var L = { fired: !1, wrapFn: void 0, target: R, type: $, listener: I }, G = u.bind(L);
    return G.listener = I, L.wrapFn = G, G;
  }
  o.prototype.once = function($, I) {
    return l(I), this.on($, f(this, $, I)), this;
  }, o.prototype.prependOnceListener = function($, I) {
    return l(I), this.prependListener($, f(this, $, I)), this;
  }, o.prototype.removeListener = function($, I) {
    var L, G, Q, ne, q;
    if (l(I), G = this._events, G === void 0)
      return this;
    if (L = G[$], L === void 0)
      return this;
    if (L === I || L.listener === I)
      --this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : (delete G[$], G.removeListener && this.emit("removeListener", $, L.listener || I));
    else if (typeof L != "function") {
      for (Q = -1, ne = L.length - 1; ne >= 0; ne--)
        if (L[ne] === I || L[ne].listener === I) {
          q = L[ne].listener, Q = ne;
          break;
        }
      if (Q < 0)
        return this;
      Q === 0 ? L.shift() : N(L, Q), L.length === 1 && (G[$] = L[0]), G.removeListener !== void 0 && this.emit("removeListener", $, q || I);
    }
    return this;
  }, o.prototype.off = o.prototype.removeListener, o.prototype.removeAllListeners = function($) {
    var I, L, G;
    if (L = this._events, L === void 0)
      return this;
    if (L.removeListener === void 0)
      return arguments.length === 0 ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : L[$] !== void 0 && (--this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : delete L[$]), this;
    if (arguments.length === 0) {
      var Q = Object.keys(L), ne;
      for (G = 0; G < Q.length; ++G)
        ne = Q[G], ne !== "removeListener" && this.removeAllListeners(ne);
      return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
    }
    if (I = L[$], typeof I == "function")
      this.removeListener($, I);
    else if (I !== void 0)
      for (G = I.length - 1; G >= 0; G--)
        this.removeListener($, I[G]);
    return this;
  };
  function h(R, $, I) {
    var L = R._events;
    if (L === void 0)
      return [];
    var G = L[$];
    return G === void 0 ? [] : typeof G == "function" ? I ? [G.listener || G] : [G] : I ? j(G) : w(G, G.length);
  }
  o.prototype.listeners = function($) {
    return h(this, $, !0);
  }, o.prototype.rawListeners = function($) {
    return h(this, $, !1);
  }, o.listenerCount = function(R, $) {
    return typeof R.listenerCount == "function" ? R.listenerCount($) : v.call(R, $);
  }, o.prototype.listenerCount = v;
  function v(R) {
    var $ = this._events;
    if ($ !== void 0) {
      var I = $[R];
      if (typeof I == "function")
        return 1;
      if (I !== void 0)
        return I.length;
    }
    return 0;
  }
  o.prototype.eventNames = function() {
    return this._eventsCount > 0 ? r(this._events) : [];
  };
  function w(R, $) {
    for (var I = new Array($), L = 0; L < $; ++L)
      I[L] = R[L];
    return I;
  }
  function N(R, $) {
    for (; $ + 1 < R.length; $++)
      R[$] = R[$ + 1];
    R.pop();
  }
  function j(R) {
    for (var $ = new Array(R.length), I = 0; I < $.length; ++I)
      $[I] = R[I].listener || R[I];
    return $;
  }
  function _(R, $) {
    return new Promise(function(I, L) {
      function G(ne) {
        R.removeListener($, Q), L(ne);
      }
      function Q() {
        typeof R.removeListener == "function" && R.removeListener("error", G), I([].slice.call(arguments));
      }
      O(R, $, Q, { once: !0 }), $ !== "error" && g(R, G, { once: !0 });
    });
  }
  function g(R, $, I) {
    typeof R.on == "function" && O(R, "error", $, I);
  }
  function O(R, $, I, L) {
    if (typeof R.on == "function")
      L.once ? R.once($, I) : R.on($, I);
    else if (typeof R.addEventListener == "function")
      R.addEventListener($, function G(Q) {
        L.once && R.removeEventListener($, G), I(Q);
      });
    else
      throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof R);
  }
  return Js.exports;
}
var J8 = Y8();
function EY() {
  const e = new J8.EventEmitter();
  return e && typeof window < "u" ? window._partner = {
    events: e
  } : console.warn(
    "Initialization of partner-integration events was not successfull."
  ), e;
}
export {
  $T as GraphQLClientProvider,
  tI as PairingContext,
  IY as PairingProvider,
  K8 as PartnerIntegrationCard,
  OT as PartnerIntegrationModalProvider,
  wY as PartnerIntegrations,
  CY as PartnerIntegrationsSettings,
  nI as getWidgetDefinitions,
  EY as initializePartnerEventEmitter,
  FY as usePairing,
  DT as usePartnerIntegrationModal,
  $Y as usePartnerIntegrationWidgetConfigurations
};
